(function () {
    'use strict';

    angular.module('bentham.pages', [
            'ui.router',
            'bentham.pages.login',
            'bentham.pages.dashboard',
            'bentham.pages.cadastrosbasicos',
            'bentham.pages.qualidade',
            'bentham.pages.licitacoes',
            'bentham.pages.contratos',
            'bentham.pages.economico',
            'bentham.pages.financeiro',
            'bentham.pages.configuracoes',
            'bentham.pages.seguranca',
            'bentham.pages.gerencial',
            'bentham.pages.arquivos',
            // 'bentham.pages.maps'
        ])
        .config(routeConfig)
        .factory('authorization', ['$rootScope', '$state', '$transitions', 'AuthService', '$urlRouter', '$window', '$location',
            function ($rootScope, $state, $transitions, AuthService) {
                return {
                    authorize: function () {
                        return AuthService.user()
                            .then(function (data) {
                                var isAuthenticated = AuthService.isAuthenticated();
                                if (!isAuthenticated)
                                    $state.go('login');
                                else
                                    $rootScope.$exibir = true;
                            }).catch(function (err) {
                                $state.go('login');
                            });
                    }
                };
            }
        ])
        .run(function ($transitions) {
            $transitions.onSuccess({}, function (transition) {
                var auth = transition.injector().get('AuthService');
                if (!auth.isAuthenticated())
                    // User isn't authenticated. Redirect to a new Target State console.log("Successful Transition from " + transition.from().name + " to " + transition.to().name);
                    return transition.router.stateService.go('login');
                if (transition.router.stateService.current.roles != undefined && transition.router.stateService.current.roles.length > 0 && !auth.isInAnyRole(transition.router.stateService.current.roles))
                    return transition.router.stateService.go('login');
            });
        });

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, baSidebarServiceProvider) {
        $urlRouterProvider.otherwise('/login'); //Redirecionando para rota em caso de uma rota não seja encontrado

        $stateProvider.state('home', {
            abstract: true,
            params: {
                id: null
            },
            resolve: {
                authorize: ['authorization',
                    function (authorization) {
                        return authorization.authorize();
                    }
                ]
            }
        });
    }

})();
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme', [
        'toastr',
        'chart.js',
        'angular-chartist',
        'angular.morris-chart',
        //'textAngular',
        'bentham.theme.components',
        'bentham.theme.inputs'
    ]);

})();
/**
 * @author Douglas Nunes
 * created on 10.11.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.arquivos', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('arquivos', {
                url: '/arquivos',
                templateUrl: 'app/pages/arquivos/tree.html',
                controller: 'treeCtrl',
                title: 'GED',
                parent: 'home',
                sidebarMeta: {
                    order: 12,
                    icon: 'ion-briefcase',
                },
                roles: ['ROLE_GED_[A-Z]+'],
            });

    }
})();
/**
 * @author Douglas Nunes
 * created on 21.01.2019
 */
(function() {
    'use strict';

    angular.module('bentham.pages.cadastrosbasicos', [
            'bentham.pages.cadastrosbasicos.clientes',
            'bentham.pages.cadastrosbasicos.parceiros',
            'bentham.pages.cadastrosbasicos.fornecedores',
            'bentham.pages.cadastrosbasicos.fonte-recurso',
            'bentham.pages.cadastrosbasicos.cargo',
            'bentham.pages.cadastrosbasicos.funcionarios',
            'bentham.pages.cadastrosbasicos.pessoafisica',
            'bentham.pages.cadastrosbasicos.pessoajuridica',
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('cadastrosbasicos', {
                url: '/cadastros-basicos',
                parent: 'home',
                title: 'Cadastros Básicos',
                sidebarMeta: {
                    icon: 'fa fa-plus',
                    order: 1,
                }
            });
    }
})();
/**
 * @author Renato Alves
 * created on 02.02.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.configuracoes', [
            'bentham.pages.configuracoes.alertadeemail',
            'bentham.pages.configuracoes.bancos',
            'bentham.pages.configuracoes.tipodocumento',
            'bentham.pages.configuracoes.departamento',
            'bentham.pages.configuracoes.tipocontrato',
            'bentham.pages.configuracoes.consultas',
            'bentham.pages.configuracoes.sourcefile',

        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('configuracoes', {
                url: '/configuracoes',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
                title: 'Configurações',
                sidebarMeta: {
                    icon: 'fa fa-cogs',
                    order: 14,
                },
            });
    }

})();
/**
 * @author Douglas Nunes
 * created on 02.12.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.contratos', [
            'bentham.pages.contratos.consorcios',
            'bentham.pages.contratos.contratosexternos',
            'bentham.pages.contratos.revisaocontratoexterno',
            'bentham.pages.contratos.contratosinternos',
            'bentham.pages.contratos.documento-cat',
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('contratos', {
                url: '/contratos',
                parent: 'home',
                title: 'Contratos',
                sidebarMeta: {
                    icon: 'ion-clipboard',
                    order: 4,
                }
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 02.12.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.economico', [
            'bentham.pages.economico.produtos',
            'bentham.pages.economico.medicoes',        
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('economico', {
                url: '/economico',
                parent: 'home',
                title: 'Econômico',
                sidebarMeta: {
                    icon: 'ion-social-usd',
                    order: 4,
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('bentham.pages.dashboard', [
        'bentham.pages.dashboard.indicador',
        'bentham.pages.dashboard.contrato',
        'bentham.pages.dashboard.apresentadas',
        'bentham.pages.dashboard.perspectiva',
        'bentham.pages.dashboard.financeiro',
        'bentham.pages.dashboard.qualidade',
        'bentham.pages.dashboard.atuacao-juridica-perspectiva',
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard', {
                url: '/dashboard',
                parent: 'home',
                title: 'Dashboard',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 0,
                },
                resolve: { authorize: ['authorization', function(authorization) { return authorization.authorize(); } ] },    
            });
    }

})();
/**
 * @author Douglas Nunes
 * created on 14.12.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.financeiro', [
        'bentham.pages.financeiro.centroCusto',
        'bentham.pages.financeiro.contareceber',
        'bentham.pages.economico.planodeconta',
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('financeiro', {
                url: '/financeiro',
                parent: 'home',
                title: 'Financeiro',
                sidebarMeta: {
                    icon: 'ion-social-usd',
                    order: 7,
                }
            });
    }
})();

/**
 * @author Douglas Nunes
 * created on 17.12.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.gerencial.gantt', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('gerencial.gantt', {
                url: '/gantt',
                templateUrl: 'app/pages/gantt/gantt.html',
                title: 'Gantt',
                controller: 'GanttCtrl',
                sidebarMeta: {
                    icon: 'ion-navicon',
                    order: 5,
                },
                roles: ['ROLE_GANTT_[A-Z]+']

            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 06.02.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.gerencial', [
            'bentham.pages.gerencial.perspectivas',
            'bentham.pages.gerencial.planejamento-estrategico',
            'bentham.pages.gerencial.contratosexternos',
            'bentham.pages.gerencial.controle-entrega',
            'bentham.pages.gerencial.contasareceber',
            'bentham.pages.gerencial.orcamento-economico',
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('gerencial', {
                url: '/gerencial',
                parent: 'home',
                title: 'Gerencial',
                sidebarMeta: {
                    icon: 'ion-pie-graph',
                    order: 8,
                }
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 10.12.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.licitacoes', [
            'bentham.pages.licitacoes.perspectivas',
            'bentham.pages.licitacoes.configuracaoperspectivas',
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('licitacoes', {
                url: '/licitacoes',
                parent: 'home',
                title: 'Licitações',
                sidebarMeta: {
                    icon: 'fa fa-gavel',
                    order: 3,
                }
            });
    }
})();
(function() {
    'use strict';

    angular.module('bentham.pages.login', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('login', {
                url: '/login',
                templateUrl: 'app/pages/login/login.html',
                controller: 'loginCtrl',
                title: 'Login'
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 21.01.2019
 */
(function() {
    'use strict';

    angular.module('bentham.pages.qualidade', [
            'bentham.pages.qualidade.riscos',
            'bentham.pages.qualidade.naoconformidades',
            'bentham.pages.qualidade.acoes',
            'bentham.pages.qualidade.unidade-medida',
            'bentham.pages.qualidade.kpi',
            'bentham.pages.qualidade.indicadores',
            'bentham.pages.qualidade.avancos',
            'bentham.pages.qualidade.dashboards',
            'bentham.pages.qualidade.dashboardIndicadores',
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('qualidade', {
                url: '/qualidade',
                parent: 'home',
                title: 'Qualidade',
                sidebarMeta: {
                    icon: 'fa fa-plus',
                    order: 1,
                }
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 21.01.2019
 */
(function() {
    'use strict';

    angular.module('bentham.pages.seguranca', [
            'bentham.pages.seguranca.auditoriasistema',
            'bentham.pages.seguranca.usuarios',
            'bentham.pages.seguranca.perfis',
            'bentham.pages.seguranca.grupoareasistema',
            'bentham.pages.seguranca.areasistema',
            'bentham.pages.seguranca.auditoriaregistro',

        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('seguranca', {
                parent: 'home',
                url: '/seguranca',
                title: 'Segurança',
                sidebarMeta: {
                    icon: 'fa fa-lock',
                    order: 15,
                },
                // resolve: {
                //     authorize: ['authorization',
                //         function(authorization) {
                //             return authorization.authorize();
                //         }
                //     ]
                // }
            })
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme.components', []);

})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function() {
    'use strict';

    angular.module('bentham.theme.inputs', []);

})();
/**
 * @author Douglas Nunes
 * created on 16.11.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.cadastrosbasicos.cargo', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('cadastrosbasicos.cargo', {
                url: '/cargos',
                templateUrl: 'app/pages/cadastrosbasicos/cargo/cargo.html',
                controller: 'CargoCtrl',
                title: 'Cargo',
                sidebarMeta: {
                    order: 1,
                },
                roles: ['ROLE_CARGO_[A-Z]+'],      
            });

    }
})();
/**
 * @author Douglas Nunes
 * created on 10.11.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.cadastrosbasicos.clientes', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('cadastrosbasicos.clientes', {
                url: '/clientes',
                templateUrl: 'app/pages/cadastrosbasicos/clientes/clientes.html',
                controller: 'ClienteCtrl',
                title: 'Clientes',
                sidebarMeta: {
                    order: 8,
                },
                roles: ['ROLE_CLIENTE_[A-Z]+'],
            }).state('cadastrosbasicos.formcliente',{
                url: '/clientes?clienteId',
                templateUrl: 'app/pages/cadastrosbasicos/clientes/formcliente.html',
                controller:'ClienteCtrl',
                title: 'Cliente',
                roles: ['ROLE_CLIENTE_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 16.11.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.cadastrosbasicos.fonte-recurso', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('cadastrosbasicos.fonte-recurso', {
                url: '/fontes',
                templateUrl: 'app/pages/cadastrosbasicos/fonte-recurso/fonte-recurso.html',
                controller: 'FonteRecursoCtrl',
                title: 'Fonte de Recurso',
                sidebarMeta: {
                    order: 2,
                },
                roles: ['ROLE_FONTEDERECURSO_[A-Z]+'],      
            });

    }
})();
/**
 * @author Douglas Nunes
 * created on 20.11.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.cadastrosbasicos.fornecedores', [
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('cadastrosbasicos.fornecedores', {
                url: '/cadastro',
                templateUrl: 'app/pages/cadastrosbasicos/fornecedores/fornecedor.html',
                controller: 'FornecedorCtrl',
                title: 'Fornecedores',
                sidebarMeta: {
                    order: 8,
                },
                roles: ['ROLE_FORNECEDOR_[A-Z]+'],

            })
            .state('cadastrosbasicos.formfornecedores', {
                url: '/formcadastro-fornecedor?fornecedorId',
                templateUrl: 'app/pages/cadastrosbasicos/fornecedores/formfornecedor.html',
                controller: 'FornecedorCtrl',
                title: 'Fornecedor',
                roles: ['ROLE_FORNECEDOR_[A-Z]+'],
            })
            .state('cadastrosbasicos.viewfornecedor', {
                url: '/view-fornecedor?fornecedorId',
                templateUrl: 'app/pages/cadastrosbasicos/fornecedores/viewFornecedor.html',
                controller: 'FornecedorCtrl',
                title: 'Fornecedor',
                roles: ['ROLE_FORNECEDOR_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 23.07.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.cadastrosbasicos.funcionarios', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('cadastrosbasicos.funcionarios', {
                url: '/funcionarios',
                templateUrl: 'app/pages/cadastrosbasicos/funcionarios/funcionario.html',
                controller: "FuncionarioCtrl",
                title: 'Funcionários',
                sidebarMeta: {
                    order: 4,
                },
                roles: ['ROLE_FUNCIONARIO_[A-Z]+'],
            }).state('cadastrosbasicos.funcionario', {
                url: '/funcionarios/form?funcionarioId',
                templateUrl: 'app/pages/cadastrosbasicos/funcionarios/formfuncionario.html',
                controller: "FuncionarioCtrl",
                title: 'Funcionário',
                roles: ['ROLE_FUNCIONARIO_[A-Z]+'],
            }).state('cadastrosbasicos.viewfuncionario', {
                url: '/funcionarios/view?funcionarioId',
                templateUrl: 'app/pages/cadastrosbasicos/funcionarios/viewfuncionario.html',
                controller: "FuncionarioCtrl",
                title: 'Funcionário',
                roles: ['ROLE_FUNCIONARIO_[A-Z]+'],
            });
    }
})();
/**
 * @author Victor Lima
 * created on 02.02.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.cadastrosbasicos.naturezas', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('cadastrosbasicos.naturezas', {
                url: '/naturezas',
                templateUrl: 'app/pages/cadastrosbasicos/naturezas/natureza.html',
                controller: "NaturezaCtrl",
                title: 'Naturezas',
                sidebarMeta: {
                    order: 2,
                }
            }).state('cadastrosbasicos.natureza', {
                url: '/naturezas?naturezaId',
                templateUrl: 'app/pages/cadastrosbasicos/naturezas/formnatureza.html',
                controller: "NaturezaCtrl",
                title: 'Natureza'
            }).state('cadastrosbasicos.viewnatureza', {
                url: '/naturezas?naturezaId',
                templateUrl: 'app/pages/cadastrosbasicos/naturezas/viewnatureza.html',
                controller: "NaturezaCtrl",
                title: 'Natureza'
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 10.12.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.cadastrosbasicos.pessoafisica', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('cadastrosbasicos.pessoafisica', {
                url: '/pessoa-fisica',
                templateUrl: 'app/pages/cadastrosbasicos/pessoa-fisica/pessoa-fisica.html',
                controller: "PessoaFisicaCtrl",
                title: 'Pessoas Físicas',
                sidebarMeta: {
                    order: 3,
                },
                roles: ['ROLE_PESSOA_FISICA_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 10.12.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.cadastrosbasicos.pessoajuridica', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('cadastrosbasicos.pessoajuridica', {
                url: '/pessoa-juridica',
                templateUrl: 'app/pages/cadastrosbasicos/pessoa-juridica/pessoa-juridica.html',
                controller: "PessoaJuridicaCtrl",
                title: 'Pessoas Júridicas',
                sidebarMeta: {
                    order: 5,
                },
                roles: ['ROLE_PESSOA_JURIDICA_[A-Z]+'],
            });
    }
})();
(function() {
    'use strict';

    angular.module('bentham.pages.maps.leaflet', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
        .state('maps.leaflet', {
            url: '/leaflet',
            templateUrl: 'app/pages/components/leaflet/leaflet.html',
            controller: 'LeafletPageCtrl',
            title: 'Leaflet Maps',
            sidebarMeta: {
                order: 100,
            },
        });
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('bentham.pages.maps', ['bentham.pages.maps.leaflet'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('maps', {
                url: '/maps',
                template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
                title: 'Mapas',
                sidebarMeta: {
                    icon: 'fa fa-map',
                    order: 14,
                },
                //})
                // .state('maps.leaflet', {
                //     url: '/leaflet',
                //     //url: '/leaflet',
                //     //templateUrl: 'app/pages/maps/leaflet/leaflet.html',
                //     controller: 'LeafletPageCtrl',
                //     title: 'Leaflet Maps',
                //     sidebarMeta: {
                //         order: 100,
                //     },
                //   })
                //   .state('maps', {
                //     url: '/maps',
                //     //templateUrl: 'app/pages/maps/maps.html',
                //     abstract: true,
                //     title: 'Maps',
                //     sidebarMeta: {
                //       icon: 'ion-ios-location-outline',
                //       order: 500,
                //     },
                //   })
                //   .state('maps.gmap', {
                //     url: '/gmap',
                //     //templateUrl: 'app/pages/maps/google-maps/google-maps.html',
                //     controller: 'GmapPageCtrl',
                //     title: 'Google Maps',
                //     sidebarMeta: {
                //       order: 0,
                //     },
                //   })
                //   .state('maps.bubble', {
                //     url: '/bubble',
                //     //templateUrl: 'app/pages/maps/map-bubbles/map-bubbles.html',
                //     controller: 'MapBubblePageCtrl',
                //     title: 'Bubble Maps',
                //     sidebarMeta: {
                //       order: 200,
                //     },
                //   })
                //   .state('maps.line', {
                //     url: '/line',
                //     //templateUrl: 'app/pages/maps/map-lines/map-lines.html',
                //     controller: 'MapLinesPageCtrl',
                //     title: 'Line Maps',
                //     sidebarMeta: {
                //       order: 300,
                //     },
            });
    }

})();
/**
 * @author Douglas Nunes
 * created on 10.11.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.configuracoes.alertadeemail', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('configuracoes.alertadeemail', {
                url: '/alerta-de-email',
                templateUrl: 'app/pages/configuracoes/alertadeemail/alerta-email.html',
                controller: 'AlertadeEmailCtrl',
                title: 'Alerta De Email',
                sidebarMeta: {
                    order: 0,
                },
                roles: ['ROLE_SERVIDORDEEMAIL_[A-Z]+']
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 28.11.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.configuracoes.bancos', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('configuracoes.bancos', {
                url: '/bancos',
                templateUrl: 'app/pages/configuracoes/bancos/banco.html',
                controller: "BancoCtrl",
                title: 'Bancos',
                sidebarMeta: {
                    order: 2,
                },
                roles: ['ROLE_BANCO_[A-Z]+']
            });
    }

})();
/**
 * @author Douglas Nunes
 * created on 11.11.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.configuracoes.consultas', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('configuracoes.consultas', {
                url: '/consultas',
                templateUrl: 'app/pages/configuracoes/consulta/consulta.html',
                controller: "ConsultaCtrl",
                title: 'Consultas',
                sidebarMeta: {
                    order: 2,
                },
                roles: ['ROLE_CONSULTA_[A-Z]+']
            }).state('configuracoes.formconsultas', {
                url: '/form-consultas?consultaId',
                templateUrl: 'app/pages/configuracoes/consulta/formconsulta.html',
                controller: "ConsultaCtrl",
                title: 'Consulta',
                roles: ['ROLE_CONSULTA_[A-Z]+']
            });
    }

})();
/**
 * @author Douglas Nunes
 * created on 28.11.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.configuracoes.departamento', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('configuracoes.departamento', {
                url: '/departamentos',
                templateUrl: 'app/pages/configuracoes/departamento/departamento.html',
                controller: 'DepartamentoCtrl',
                title: 'Departamentos',
                sidebarMeta: {
                    order: 0,
                },
                roles: ['ROLE_DEPARTAMENTO_[A-Z]+']
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 04.11.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.configuracoes.sourcefile', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('configuracoes.sourcefile', {
                url: '/source-file',
                templateUrl: 'app/pages/configuracoes/source-file/source-file.html',
                controller: "SourceFileCtrl",
                title: 'Source File',
                sidebarMeta: {
                    order: 2,
                },
                roles: ['ROLE_SOURCE_FILE_[A-Z]+']
            });
    }

})();
/**
 * @author Douglas Nunes
 * created on 28.11.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.configuracoes.tipodocumento', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('configuracoes.tipodocumento', {
                url: '/tipo-documento',
                templateUrl: 'app/pages/configuracoes/tipo-documento/tipo-documento.html',
                controller: "TipoDocumentoCtrl",
                title: 'Tipos de Documento',
                sidebarMeta: {
                    order: 2,
                },
                roles: ['ROLE_TIPO_DOCUMENTO_[A-Z]+']
            });
    }

})();
/**
 * @author Renato Alves
 * created on 02.02.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.configuracoes.tipocontrato', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('configuracoes.tipocontrato', {
                url: '/tipo-de-contrato',
                templateUrl: 'app/pages/configuracoes/tipocontrato/tipocontrato.html',
                controller: "TipoContratoCtrl",
                title: 'Tipo de Contrato',
                sidebarMeta: {
                    order: 6,
                },
                roles: ['ROLE_TIPODECONTRATO_[A-Z]+']
            });
    }

})();
/**
 * @author Douglas Nunes
 * created on 29.01.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.contratos.consorcios',
        [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('contratos.consorcios', {
                url: '/consorcios',
                templateUrl: 'app/pages/contratos/consorcios/consorcio.html',
                title: 'Consorcios',
                controller: 'ConsorcioCtrl',
                sidebarMeta: {
                    order: 1,
                },
                roles: ['ROLE_CONSORCIO_[A-Z]+'],
            }).state('contratos.formconsorcio', {
                url: '/formconsorcio?consorcioId',
                templateUrl: 'app/pages/contratos/consorcios/formconsorcio.html',
                title: 'Consorcio',
                controller: 'ConsorcioCtrl',
                roles: ['ROLE_CONSORCIO_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 05.12.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.contratos.contratosexternos', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('contratos.contratosexternos', {
                url: '/contratos-externos',
                templateUrl: 'app/pages/contratos/contratosexternos/contratosexternos.html',
                title: 'Contratos de Clientes',
                controller: 'ContratoExternoCtrl',
                sidebarMeta: {
                    order: 2,
                },
                roles: ['ROLE_CENTRODECUSTO_[A-Z]+'],
            }).state('contratos.formcontratosexternos', {
                url: '/contrato-externo?contratoId',
                templateUrl: 'app/pages/contratos/contratosexternos/formcontratoexterno.html',
                title: 'Contrato de Cliente',
                controller: 'ContratoExternoCtrl',
                roles: ['ROLE_CENTRODECUSTO_[A-Z]+'],
            }).state('contratos.viewcontratosexternos', {
                url: '/view-contratoexterno?contratoId',
                templateUrl: 'app/pages/contratos/contratosexternos/viewcontratoexterno.html',
                title: 'Contrato de Cliente',
                controller: 'ContratoExternoCtrl',
                roles: ['ROLE_CENTRODECUSTO_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 21.12.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.contratos.contratosinternos', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('contratos.contratosinternos', {
                url: '/contratos-internos',
                templateUrl: 'app/pages/contratos/contratosinternos/contratosinternos.html',
                title: 'Contratos de Fornecedores',
                controller: 'ContratoInternoCtrl',
                sidebarMeta: {
                    order: 3,
                },
                roles: ['ROLE_CONTRATOINTERNO_[A-Z]+'],
            }).state('contratos.formcontratointerno', {
                url: '/contrato-interno?contratoId',
                templateUrl: 'app/pages/contratos/contratosinternos/formcontratointerno.html',
                title: 'Contrato Interno',
                controller: 'ContratoInternoCtrl',
                roles: ['ROLE_CONTRATOINTERNO_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 15.10.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.contratos.documento-cat', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('contratos.documento-cat', {
                url: '/documento-cat?contratoId',
                templateUrl: 'app/pages/contratos/documento-cat/documento-cat.html',
                title: "CAT'S / ART'S / RRT'S",
                controller: 'DocumentoCatCtrl',
                sidebarMeta: {
                    order: 6,
                },
                roles: ['ROLE_DOCUMENTO_CAT_[A-Z]+'],
            }).state('contratos.formdocumento-cat', {
                url: '/formdocumento-cat?documentoId&contratoId',
                templateUrl: 'app/pages/contratos/documento-cat/formdocumento-cat.html',
                title: "CAT / ART / RRT",
                controller: 'DocumentoCatCtrl',
                roles: ['ROLE_DOCUMENTO_CAT_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 14.03.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.contratos.indiceDeReajuste', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('contratos.indiceDeReajuste', {
                url: '/indice-de-reajuste',
                templateUrl: 'app/pages/contratos/indice-de-reajuste/indice-de-reajuste.html',
                title: 'Índice de Reajuste',
                controller: 'IndiceDeReajusteCtrl',
                sidebarMeta: {
                    order: 2,
                }
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 18.04.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.economico.medicoes', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('economico.medicoes', {
                url: '/medicoes?contratoExternoId',
                templateUrl: 'app/pages/contratos/medicao/medicoes.html',
                title: 'Medições',
                controller: 'MedicaoCtrl',
                sidebarMeta: {
                    order: 5,
                },
                roles: ['ROLE_MEDICAO_[A-Z]+'],
            }).state('economico.formMedicao', {
                url: '/form-medicao?medicaoId',
                templateUrl: 'app/pages/contratos/medicao/formmedicao.html',
                title: 'Medição',
                controller: 'MedicaoCtrl',
                roles: ['ROLE_MEDICAO_[A-Z]+'],
                
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 17.12.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.economico.produtos', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('economico.produtos', {
                url: '/produtos?centroDeCustoId&contratoExternoId',
                templateUrl: 'app/pages/contratos/produtos/produtos.html',
                title: 'Produtos',
                controller: 'ProdutosCtrl',
                sidebarMeta: {
                    order: 4,
                },
                roles: ['ROLE_PRODUTO_[A-Z]+'],
            }).state('economico.produto', {
                url: '/produto?produtoId&centroDeCustoId&contratoExternoId',
                templateUrl: 'app/pages/contratos/produtos/formproduto.html',
                title: 'Produto',
                controller: 'ProdutoCtrl',                
                roles: ['ROLE_PRODUTO_[A-Z]*C[A-Z]*']
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 05.12.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.contratos.revisaocontratoexterno', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('contratos.revisaocontratoexterno', {
                url: '/revisoes-contrato',
                templateUrl: 'app/pages/contratos/revisaocontrato/revisoescontratos.html',
                title: 'Revisões de Contratos de Clientes',
                controller: 'RevisaoContratoCtrl',
                sidebarMeta: {
                    order: 2,
                },
                roles: ['ROLE_CONTARECEBER_[A-Z]+'],
            });
    }
})();

(function () {
    'use strict';

    angular.module('bentham.pages.dashboard.apresentadas', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.apresentadas', {
                url: '/dashboard-apresentadas',
                templateUrl: 'app/pages/dashboard/apresentadas/apresentadas-dashboard.html',
                title: 'Dashboard Licitações Apresentadas',
                controller: 'ApresentadasDashBoardCtrl',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 0,
                },
                roles: ['ROLE_DASHBOARDPERSPECTIVA_[A-Z]+']
            });
    }

})();

(function () {
    'use strict';

    angular.module('bentham.pages.dashboard.atuacao-juridica-perspectiva', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.atuacao-juridica-perspectiva', {
                url: '/dashboard-atuacao-juridica-perspectiva',
                templateUrl: 'app/pages/dashboard/atuacao-juridica-perspectiva/atuacao-juridica-perspectiva-dashboard.html',
                title: 'Dashboard Atuação Jurídica nas Perspectivas',
                controller: 'AtuacaoJuridicaPerspectivaDashboardCtrl',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 0,
                },
                roles: ['ROLE_DASHBOARDATUACAOJURIDICOPERSPECTIVA_[A-Z]+']
            });
    }

})();

(function () {
    'use strict';

    angular.module('bentham.pages.dashboard.contrato', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.contrato', {
                url: '/dashboard-contrato',
                templateUrl: 'app/pages/dashboard/contrato/contrato-dashboard.html',
                title: 'Dashboard Contratos',
                controller: 'ContratoDashboardCtrl',
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 1,
                },
                roles: ['ROLE_DASHBOARDCONTRATO_[A-Z]+']
            });
    }

})();

(function () {
    'use strict';

    angular.module('bentham.pages.dashboard.financeiro', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.financeiro', {
                url: '/dashboard-financeiro',
                templateUrl: 'app/pages/dashboard/financeiro/financeiro-dashboard.html',
                title: 'Dashboard Econômico Financeiro',
                controller: 'FinanceiroDashboardCtrl',
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 2,
                },
                roles: ['ROLE_DASHBOARDFINANCEIRO_[A-Z]+']
            });
    }

})();

(function () {
    'use strict';

    angular.module('bentham.pages.dashboard.indicador', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.indicador', {
                url: '/dashboard-indicador',
                templateUrl: 'app/pages/dashboard/indicador/dashboard.html',
                title: 'Dashboard de Indicadores',
                controller: 'DashboardChartCtrl',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 3,
                },
                roles: ['ROLE_DASHBOARDQUALIDADE_[A-Z]+']
            });
    }

})();

(function () {
    'use strict';

    angular.module('bentham.pages.dashboard.perspectiva', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.perspectiva', {
                url: '/dashboard-perspectiva',
                templateUrl: 'app/pages/dashboard/perspectiva/perspectiva-dashboard.html',
                title: 'Dashboard Perspectivas',
                controller: 'PerspectivaDashboardCtrl',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 0,
                },
                roles: ['ROLE_DASHBOARDPERSPECTIVA_[A-Z]+']
            });
    }

})();

(function () {
    'use strict';

    angular.module('bentham.pages.dashboard.qualidade', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.qualidade', {
                url: '/dashboard-qualidade',
                templateUrl: 'app/pages/dashboard/qualidade/qualidade-dashboard.html',
                title: 'Dashboard Qualidade',
                controller: 'QualidadeDashboardCtrl',
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 5,
                },
                roles: ['ROLE_DASHBOARDQUALIDADE_[A-Z]+']
            });
    }

})();
/**
 * @author Douglas Nunes
 * created on 14.12.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.financeiro.centroCusto', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('financeiro.centroCusto', {
                url: '/centro-custo',
                templateUrl: 'app/pages/financeiro/centro-custo/centrocusto.html',
                title: 'Centro de Custo',
                controller: 'CentroDeCustoCtrl',
                sidebarMeta: {
                    order: 1,
                },
                roles: ['ROLE_CENTRODECUSTO_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 17.12.2018
 */
(function () {
  'use strict';

  angular.module('bentham.pages.financeiro.contareceber', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('financeiro.contasreceber', {
        url: '/contas-receber?centroDeCustoId&produtoId',
        templateUrl: 'app/pages/financeiro/conta-receber/conta-receber.html',
        title: 'Contas a Receber',
        controller: 'ContaReceberCtrl',
        sidebarMeta: {
          icon: 'ion-pie-graph',
          order: 2
        },
        roles: ['ROLE_CENTRODECUSTO_[A-Z]+'],
      }).state('financeiro.contareceber', {
        url: '/conta-receber?centroDeCustoId&contaReceberId',
        templateUrl: 'app/pages/financeiro/conta-receber/form-conta-receber.html',
        title: 'Contas a Receber',
        controller: 'ContaReceberCtrl',
        roles: ['ROLE_CONTARECEBER_[A-Z]+'],
      });
  }
})();
/**
 * @author Douglas Nunes
 * created on 17.12.2018
 */
(function () {
  'use strict';

  angular.module('bentham.pages.economico.planodeconta', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('economico.planodeconta', {
        url: '/plano-de-contas',
        templateUrl: 'app/pages/financeiro/plano-de-conta/plano-de-conta.html',
        title: 'Orçamentos',
        controller: 'PlanoDeContaCtrl',
        sidebarMeta: {
            icon: 'ion-pie-graph',
            order: 3
        },
        roles: ['ROLE_PLANODECONTA_[A-Z]+'],
      }).state('economico.formplanodeconta', {
        url: '/formplano-de-conta?planoId',
        templateUrl: 'app/pages/financeiro/plano-de-conta/formplano-de-conta.html',
        title: 'Orçamento Econômico',
        controller: 'PlanoDeContaCtrl',                
      }).state('economico.valor-previsto-plano-conta', {
        url: '/valor-previsto?itemPlanoId',
        templateUrl: 'app/pages/financeiro/plano-de-conta/item-plano-de-conta/valor-previsto-plano-de-conta/valor-plano-de-conta.html',
        title: 'Valores',
        controller: 'ValoresPrevistoPlanoDeContaCtrl',                
    });
}
})();
/**
 * @author Douglas Nunes
 * created on 17.12.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.gerencial.controle-entrega', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('gerencial.controle-entrega', {
                url: '/controle-entrega',
                templateUrl: 'app/pages/gerencial/controle-entrega/controle-entrega.html',
                title: 'Controle de Entregas',
                controller: 'ControleEntregaCtrl',
                sidebarMeta: {
                    icon: 'ion-navicon',
                    order: 4,
                },
                roles: ['ROLE_CONTROLE_ENTREGA_[A-Z]+']

            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 06.02.2019
 */
(function() {
    'use strict';

    angular.module('bentham.pages.gerencial.centrodecusto', [
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('gerencial.centrodecusto', {
                url: '/gerencial-centro-custo',
                controller: 'GerencialCentroDeCustoCtrl',
                templateUrl: 'app/pages/gerencial/gerencial-centro-custo/gerencialcentrodecusto.html',
                title: 'Centro de Custo',
                sidebarMeta: {
                    order: 6,
                },
                roles: ['ROLE_GERENCIAL_CENTRODECUSTO_[A-Z]+']
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 15.03.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.gerencial.contasareceber', [
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('gerencial.contasareceber', {
                url: '/gerencial-contas-a-receber',
                title: 'Contas à Receber',
                controller: 'GerencialContaAReceberCtrl',
                templateUrl: 'app/pages/gerencial/gerencial-conta-a-receber/gerencialconta-a-receber.html',
                sidebarMeta: {
                    order: 5,
                },
                roles: ['ROLE_CONTARECEBER_[A-Z]+']
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 06.02.2019
 */
(function() {
    'use strict';

    angular.module('bentham.pages.gerencial.contratosexternos', [
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('gerencial.contratosexternos', {
                url: '/gerencial-contratos',
                controller: 'GerencialContratoExternoCtrl',
                templateUrl: 'app/pages/gerencial/gerencial-contratos-externos/gerencialcontratosexternos.html',
                title: 'Contratos de Clientes',
                sidebarMeta: {
                    order: 3,
                },
                roles: ['ROLE_GERENCIAL_CONTRATOEXTERNO_[A-Z]+']
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 06.02.2019
 */
(function() {
    'use strict';

    angular.module('bentham.pages.gerencial.perspectivas', [            
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('gerencial.perspectivas', {
                url: '/gerencial-perspectivas',
                title: 'Perspectivas',
                controller: 'GerencialPerspectivaCtrl',
                templateUrl: 'app/pages/gerencial/gerencial-perspectivas/gerencialperspectivas.html',
                sidebarMeta: {
                    order: 1,
                },
                roles: ['ROLE_GERENCIAL_PERSPECTIVA_[A-Z]+']
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 17.12.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.gerencial.orcamento-economico', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('gerencial.orcamento-economico', {
                url: '/orcamento-economico?planoDeContaId',
                templateUrl: 'app/pages/gerencial/orcamento-economico/orcamento-economico.html',
                title: 'Orçamento Econômico',
                controller: 'OrcamentoEconomicoCtrl',
                sidebarMeta: {
                    icon: 'ion-navicon',
                    order: 4,
                },
                roles: ['ROLE_PLANODECONTA_[A-Z]+']
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 17.12.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.gerencial.planejamento-estrategico', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('gerencial.planejamento-estrategico', {
                url: '/planejamento-estrategico',
                templateUrl: 'app/pages/gerencial/planejamento-estrategico/planejamento-estrategico.html',
                title: 'Planejamento Estratégico',
                controller: 'PlanejamentoEstrategicoCtrl',
                sidebarMeta: {
                    icon: 'ion-navicon',
                    order: 2,
                },
                roles: ['ROLE_PLANEJAMENTO_ESTRATEGICO_[A-Z]+']
            });
    }
})();
/**
 * @author Victor Lima
 * created on 02.02.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.licitacoes.configuracaoperspectivas', [
        'bentham.pages.licitacoes.configuracaoperspectivas.area',
        'bentham.pages.licitacoes.configuracaoperspectivas.subarea',
        // 'bentham.pages.licitacoes.configuracaoperspectivas.parceiros',
        'bentham.pages.licitacoes.configuracaoperspectivas.regiaodeatuacao',
        // 'bentham.pages.licitacoes.configuracaoperspectivas.resultado',
        'bentham.pages.licitacoes.configuracaoperspectivas.situacaoperspectiva',
        // 'bentham.pages.licitacoes.configuracaoperspectivas.situacaoatual',
        // 'bentham.pages.licitacoes.configuracaoperspectivas.situacaogeral',
        'bentham.pages.licitacoes.configuracaoperspectivas.tipodelicitacao',
        'bentham.pages.licitacoes.configuracaoperspectivas.tipodeperspectiva',
        'bentham.pages.licitacoes.configuracaoperspectivas.tipodeservico',
        // 'bentham.pages.licitacoes.configuracaoperspectivas.finalizacao',
   
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('licitacoes.configuracaoperspectivas', {
                url: '/configuracao-perspectivas',
                title: 'Configuração de Perspectivas',
                sidebarMeta: {
                    order: 1,
                },
                // resolve: {
                //     authorize: ['authorization',
                //         function(authorization) {
                //             return authorization.authorize();
                //         }
                //     ]
                // }
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 23.07.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.licitacoes.perspectivas', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('licitacoes.perspectivas', {
                url: '/perspectivas',
                templateUrl: 'app/pages/licitacoes/perspectivas/perspectivas.html',
                title: 'Perspectivas',
                controller: 'PerspectivaCtrl',
                sidebarMeta: {
                    order: 0,
                },
                roles: ['ROLE_PERSPECTIVA_[A-Z]+'],
            }).state('licitacoes.formperspectivas', {
                url: '/cadastro-de-perspectiva?perspectivaId',
                templateUrl: 'app/pages/licitacoes/perspectivas/formperspectivatabs.html',
                title: 'Perspectiva',
                controller: 'PerspectivaCtrl',
                roles: ['ROLE_PERSPECTIVA_[A-Z]+'],
            }).state('licitacoes.viewperspectivas', {
                url: '/view-de-perspectiva?perspectivaId',
                templateUrl: 'app/pages/licitacoes/perspectivas/formperspectivatabs.html',
                title: 'Perspectiva',
                controller: 'PerspectivaCtrl',
                roles: ['ROLE_PERSPECTIVA_[A-Z]+'],
            }).state('licitacoes.respostaJuridicoPerspectiva', {
                url: '/resposta-juridico?solicitacaoJuridicoId',
                templateUrl: 'app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/resposta-juridico-perspectiva/resposta-juridico-perspectiva.html',
                title: 'Respostas da solicitação ao jurídico',
                controller: 'RespostaJuridicoPerspectivaCtrl',
                roles: ['ROLE_PERSPECTIVA_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 23.07.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.qualidade.acoes', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('qualidade.acoes', {
                url: '/acoes',
                templateUrl: 'app/pages/qualidade/acoes/acao.html',
                controller: "AcaoCtrl",
                title: 'Ações',
                sidebarMeta: {
                    order: 6,
                },
                roles: ['ROLE_ACAO_[A-Z]+'],
            })
            .state('cadastrosbasicos.acao', {
                url: '/acoes/form?acaoId',
                templateUrl: 'app/pages/qualidade/acoes/formacao.html',
                controller: "AcaoCtrl",
                title: 'Ação',
                // roles: ['ROLE_ACAO_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 23.07.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.qualidade.avancos', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            // .state('qualidade.avancos', {
            //     url: '/avancos',
            //     templateUrl: 'app/pages/qualidade/avancos/avanco.html',
            //     controller: "AvancoCtrl",
            //     title: 'Avanços',
            //     sidebarMeta: {
            //         order: 6,
            //     },
            //     roles: ['ROLE_ACAO_[A-Z]+'],
            // })
            .state('cadastrosbasicos.avanco', {
                url: '/avancos/form?avancoId',
                templateUrl: 'app/pages/qualidade/avancos/formavanco.html',
                controller: "AvancoCtrl",
                title: 'Avanço',
                // roles: ['ROLE_ACAO_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 23.07.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.qualidade.dashboardIndicadores', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            // .state('qualidade.dashboardIndicadores', {
            //     url: '/dashboardIndicadores',
            //     templateUrl: 'app/pages/qualidade/dashboardIndicadores/dashboardIndicador.html',
            //     controller: "DashboardIndicadorCtrl",
            //     title: 'Avanços',
            //     sidebarMeta: {
            //         order: 6,
            //     },
            //     roles: ['ROLE_DASHBOARD_INDICADOR_[A-Z]+'],
            // })
            .state('cadastrosbasicos.dashboardIndicador', {
                url: '/dashboardIndicadores/form?dashboardIndicadorId',
                templateUrl: 'app/pages/qualidade/dashboardIndicadores/formdashboardIndicador.html',
                controller: "DashboardIndicadorCtrl",
                title: 'Dashboard Indicador',
                // roles: ['ROLE_DASHBOARD_INDICADOR_[A-Z]+'],
            });
    }
})();
(function () {
    'use strict';

    angular.module('bentham.pages.qualidade.dashboards', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('qualidade.dashboards', {
                url: '/dashboards',
                templateUrl: 'app/pages/qualidade/dashboards/dashboard.html',
                controller: "DashboardCtrl",
                title: 'Dashboards',
                sidebarMeta: {
                    order: 10,
                },
                roles: ['ROLE_INDICADOR_[A-Z]+'],
            }).state('cadastrosbasicos.dashboard', {
                url: '/dashboards/form?dashboardId',
                templateUrl: 'app/pages/qualidade/dashboards/formdashboard.html',
                controller: "DashboardCtrl",
                title: 'Dashboard',
                roles: ['ROLE_INDICADOR_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 23.07.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.qualidade.indicadores', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('qualidade.indicadores', {
                url: '/indicadores',
                templateUrl: 'app/pages/qualidade/indicadores/indicador.html',
                controller: "IndicadorCtrl",
                title: 'Indicadores',
                sidebarMeta: {
                    order: 10,
                },
                roles: ['ROLE_INDICADOR_[A-Z]+'],
            }).state('cadastrosbasicos.indicador', {
                url: '/indicadores/form?indicadorId',
                templateUrl: 'app/pages/qualidade/indicadores/formindicador.html',
                controller: "IndicadorCtrl",
                title: 'Indicador',
                roles: ['ROLE_INDICADOR_[A-Z]+'],
            });
    }
})();
(function() {
    'use strict';

    angular.module('bentham.pages.qualidade.kpi', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('qualidade.kpi', {
                url: '/kpis',
                templateUrl: 'app/pages/qualidade/kpi/kpi.html',
                controller: 'KpiCtrl',
                title: 'Kpi',
                sidebarMeta: {
                    order: 4,
                },
                roles: ['ROLE_KPI_[A-Z]+'],      
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 23.07.2019
 */
 (function () {
    'use strict';

    angular.module('bentham.pages.qualidade.naoconformidades', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('qualidade.naoconformidades', {
                url: '/naoconformidades',
                templateUrl: 'app/pages/qualidade/nao-conformidade/naoconformidade.html',
                controller: "NaoConformidadeCtrl",
                title: 'Não Conformidades',
                sidebarMeta: {
                    order: 10,
                },
                roles: ['ROLE_RISCO_[A-Z]+'],
            }).state('cadastrosbasicos.naoconformidade', {
                url: '/naoconformidades/form?naoConformidadeId',
                templateUrl: 'app/pages/qualidade/nao-conformidade/formnaoconformidade.html',
                controller: "NaoConformidadeCtrl",
                title: 'Não Conformidade',
                roles: ['ROLE_RISCO_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 23.07.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.qualidade.riscos', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('qualidade.riscos', {
                url: '/riscos',
                templateUrl: 'app/pages/qualidade/riscos/risco.html',
                controller: "RiscoCtrl",
                title: 'Riscos e Oportunidades',
                sidebarMeta: {
                    order: 10,
                },
                roles: ['ROLE_RISCO_[A-Z]+'],
            }).state('cadastrosbasicos.risco', {
                url: '/riscos/form?riscoId',
                templateUrl: 'app/pages/qualidade/riscos/formrisco.html',
                controller: "RiscoCtrl",
                title: 'Risco/Oportunidade',
                roles: ['ROLE_RISCO_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 16.11.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.qualidade.unidade-medida', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('qualidade.unidade-medida', {
                url: '/unidades-medida',
                templateUrl: 'app/pages/qualidade/unidade-medida/unidade-medida.html',
                controller: 'UnidadeMedidaCtrl',
                title: 'Unidade de Medida',
                sidebarMeta: {
                    order: 5,
                },
                roles: ['ROLE_UNIDADE_MEDIDA_[A-Z]+'],      
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 06.06.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.seguranca.areasistema', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('seguranca.areasistema', {
                url: '/areas-sistema',
                templateUrl: 'app/pages/seguranca/area-sistema/area-sistema.html',
                controller: 'AreaSistemaCtrl',
                title: 'Areas Sistema',
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 2,
                },
                roles: ['ROLE_AREASISTEMA_[A-Z]+']
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 05.11.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.seguranca.auditoriaregistro', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('seguranca.auditoriaregistro', {
                url: '/auditoria-registro',
                templateUrl: 'app/pages/seguranca/auditoria-registro/auditoria-registro.html',
                controller: 'AuditoriaRegistroCtrl',
                title: 'Auditoria Registro',
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 2,
                },
                roles: ['ROLE_AUDITORIAREGISTRO_[A-Z]+']
            }).state('seguranca.viewauditoriaregistro', {
                url: '/view-auditoria-registro/?entityName&&entityId',
                templateUrl: 'app/pages/seguranca/auditoria-registro/view-auditoria-registro.html',
                controller: 'AuditoriaRegistroCtrl',
                title: 'Auditoria Registro',
                roles: ['ROLE_AUDITORIAREGISTRO_[A-Z]+']
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 06.06.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.seguranca.auditoriasistema', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('seguranca.auditoriasistema', {
                url: '/auditoria-sistema',
                templateUrl: 'app/pages/seguranca/auditoria-sistema/auditoria-sistema.html',
                controller: 'AuditoriaSistemaCtrl',
                title: 'Auditoria Sistema',
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 2,
                },
                roles: ['ROLE_AUDITORIASISTEMA_[A-Z]+']
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 06.06.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.seguranca.grupoareasistema', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('seguranca.grupoareasistema', {
                url: '/grupo-areas-sistema',
                templateUrl: 'app/pages/seguranca/grupo-area-sistema/grupo-area-sistema.html',
                controller: 'GrupoAreaSistemaCtrl',
                title: 'Grupo Areas Sistema',
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 2,
                },
                roles: ['ROLE_GRUPOAREASISTEMA_[A-Z]+']
            });
    }
})();
/**
 * @author Arthur Nunes
 * created on 03.06.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.seguranca.perfis', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('seguranca.perfis', {
                url: '/perfis',
                templateUrl: 'app/pages/seguranca/perfil/perfil.html',
                controller: 'PerfilCtrl',
                title: 'Perfis',
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 2,
                },
                roles: ['ROLE_PERFIL_[A-Z]+']
            }).state('seguranca.formperfil', {
                url: '/perfil?perfilId',
                templateUrl: 'app/pages/seguranca/perfil/formperfil.html',
                controller: 'PerfilCtrl',
                title: 'Perfil',
                roles: ['ROLE_PERFIL_[A-Z]+']
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 21.01.2019
 */
(function () {
    'use strict';

    angular.module('bentham.pages.seguranca.usuarios', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('seguranca.usuarios', {
                url: '/seguranca/usuarios',
                templateUrl: 'app/pages/seguranca/usuario/usuario.html',
                controller: 'UsuarioCtrl',
                title: 'Usuários',
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 1,
                },
                roles: ['ROLE_USUARIO_[A-Z]+']
            }).state('seguranca.formusuario', {
                url: '/seguranca/usuario?usuarioId',
                templateUrl: 'app/pages/seguranca/usuario/formusuario.html',
                controller: 'UsuarioCtrl',
                title: 'Usuário',
                roles: ['ROLE_USUARIO_[A-Z]+']
            }).state('seguranca.viewusuario', {
                url: '/seguranca/usuario?usuarioId',
                templateUrl: 'app/pages/seguranca/usuario/viewusuario.html',
                controller: 'UsuarioCtrl',
                title: 'Usuário',
                roles: ['ROLE_USUARIO_[A-Z]+']
            });

    }
})();
(function () {
    'use strict';

    angular.module('bentham.theme.components', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('pageTop', {
                templateUrl: 'app/theme/components/pageTop/pageTop.html',
                controller: 'loginCtrl',
            }).state('profile', {
                url: '/profile?profileId',
                templateUrl: 'app/pages/seguranca/profile/profile.html',
                controller: 'ProfileCtrl',
                title: 'Profile'                

            });;

      
    }
})();
/**
 * @author Victor Lima
 * created on 02.02.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.licitacoes.configuracaoperspectivas.area', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('licitacoes.configuracaoperspectivas.area', {
                url: '/area',
                templateUrl: 'app/pages/licitacoes/configuracaoperspectivas/area/area.html',
                title: 'Área',
                controller:'AreaCtrl',
                sidebarMeta: {
                    order: 1,
                },
                roles: ['ROLE_AREA_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 28.11.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.cadastrosbasicos.parceiros', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('cadastrosbasicos.parceiros', {
                url: '/parceiros',
                templateUrl: 'app/pages/licitacoes/configuracaoperspectivas/parceiros/parceiros.html',
                controller:'ParceiroCtrl',
                title: 'Parceiros',
                sidebarMeta: {
                    order: 7,
                },
                roles : ['ROLE_PARCEIRO_[A-Z]+'], 
            }).state('cadastrosbasicos.formparceiros', {
                url: '/formparceiros?parceiroId',
                templateUrl: 'app/pages/licitacoes/configuracaoperspectivas/parceiros/formparceiros.html',
                controller:'ParceiroCtrl',
                title: 'Parceiro',
                roles : ['ROLE_PARCEIRO_[A-Z]*C[A-Z]*'] 
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 04.12.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.licitacoes.configuracaoperspectivas.regiaodeatuacao', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('licitacoes.configuracaoperspectivas.regiaodeatuacao', {
                url: '/regiao-de-atuacao',
                templateUrl: 'app/pages/licitacoes/configuracaoperspectivas/regiaodeatuacao/regiaodeatuacao.html',
                title: 'Região de Atuação',
                controller: 'RegiaoCtrl',
                sidebarMeta: {
                    order: 2,
                },
                roles: ['ROLE_REGIAOATUACAO_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 04.12.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.licitacoes.configuracaoperspectivas.situacaoperspectiva', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('licitacoes.configuracaoperspectivas.situacaoperspectiva', {
                url: '/situacao-perspectiva',
                templateUrl: 'app/pages/licitacoes/configuracaoperspectivas/situacao-perspectiva/situacaoperspectiva.html',
                title: 'Situações de Perspectiva',
                controller: 'SituacaoPerspectivaCtrl',
                sidebarMeta: {
                    order: 6,
                },
                roles: ['ROLE_SITUACAO_[A-Z]+'],
            });
    }
})();
/**
 * @author Arthur Bezerra Nunes
 * created on 23.09.2020
 */
(function() {
    'use strict';

    angular.module('bentham.pages.licitacoes.configuracaoperspectivas.subarea', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('licitacoes.configuracaoperspectivas.subarea', {
                url: '/subarea',
                templateUrl: 'app/pages/licitacoes/configuracaoperspectivas/subarea/subarea.html',
                title: 'Sub Área',
                controller:'SubAreaCtrl',
                sidebarMeta: {
                    order: 1,
                },
                roles: ['ROLE_SUBAREA_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 04.12.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.licitacoes.configuracaoperspectivas.tipodelicitacao', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('licitacoes.configuracaoperspectivas.tipodelicitacao', {
                url: '/tipo-de-licitacao',
                templateUrl: 'app/pages/licitacoes/configuracaoperspectivas/tipodelicitacao/tipodelicitacao.html',
                title: 'Tipo de Licitação',
                controller:'TipoLicitacaoCtrl',                
                sidebarMeta: {
                    order: 5,
                },
                roles: ['ROLE_TIPOLICITACAO_[A-Z]+'],
              
            });
    }
})();
/**
 * @author Douglas Nuhes
 * created on 04.12.2018
 */
(function () {
    'use strict';

    angular.module('bentham.pages.licitacoes.configuracaoperspectivas.tipodeperspectiva', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('licitacoes.configuracaoperspectivas.tipodeperspectiva', {
                url: '/tipo-de-perspectiva',
                templateUrl: 'app/pages/licitacoes/configuracaoperspectivas/tipodeperspectiva/tipoperspectiva.html',
                controller: "TipoPerspetivaCtrl",
                title: 'Tipo de Perspectiva',
                sidebarMeta: {
                    order: 0,
                },roles: ['ROLE_TIPOPERSPECTIVA_[A-Z]+'],
            });
    }
})();
/**
 * @author Douglas Nunes
 * created on 04.12.2018
 */
(function() {
    'use strict';

    angular.module('bentham.pages.licitacoes.configuracaoperspectivas.tipodeservico', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('licitacoes.configuracaoperspectivas.tipodeservico', {
                url: '/tipo-de-servico',
                templateUrl: 'app/pages/licitacoes/configuracaoperspectivas/tipodeservico/tipodeservico.html',
                controller: 'TipoServicoCtrl',
                title: 'Tipo de Serviço',
                sidebarMeta: {
                    order: 3,
                },
                roles: ['ROLE_TIPOSERVICO_[A-Z]+'],
            });
    }
})();
"use strict";
//Before your main app module is declared, declare a momentjs module
angular
  .module("momentjs", [])
  //And on the momentjs module, declare the moment service that we want    // available as an injectable
  .factory("moment", function ($window) {
    if ($window.moment) {
      //Delete moment from window so it's not globally accessible. We can still get at it through _thirdParty however, more on why later
      $window._thirdParty = $window._thirdParty || {};
      $window._thirdParty.moment = $window.moment;
      try {
        delete $window.moment;
      } catch (e) {
        $window.moment = undefined;
        /*<IE8 doesn't do delete of window vars, make undefined if delete error*/
      }
    }
    var moment = $window._thirdParty.moment;
    return moment;
  });

angular
  .module("bentham", [
    "angular-progress-button-styles",
    "angular-jwt",
    "angularFileUpload",
    "angularMoment",
    "ui.bootstrap",
    "ui.sortable",
    "ui.router",
    "ui.select",
    "ui.mask",
    "ui.utils.masks",
    "ui.slimscroll",
    // 'ui-leaflet',
    "ngResource",
    "ngAnimate",
    "ngSanitize",
    "ngCpfCnpj",
    "ngCookies",
    "ngTouch",
    "ngJsTree",
    "toastr",
    "smart-table",
    "xeditable",
    "base64",
    "momentjs",
    "duScroll",
    "nemLogging",
    "gantt",
    "gantt.sortable",
    "gantt.movable",
    "gantt.drawtask",
    "gantt.tooltips",
    "gantt.bounds",
    "gantt.progress",
    "gantt.table",
    "gantt.tree",
    "gantt.groups",
    "gantt.resizeSensor",
    "gantt.overlap",
    "gantt.dependencies",
    "bentham.theme",
    "bentham.pages",
    "chart.js",
  ])
  .constant("prefixRoute", "https://corporativo.bentham.com.br:8443/corporativo/");
angular.module('bentham').service('GenericController', function (GenericService, $q, $timeout, toastr) {
    this.service = {};
    this.tableState = { page: 0, sort : {predicate: 'id', sortOrder : 'ASC'}, pagination : {start: 0, number : 25 }};
    this.itemsByPage = 25;
    this.itemsByPageOptions = [5, 10, 15, 25, 50, 100, 500, 1000];
    var self = this;

    this.save = function (entity) {
        var deferred = $q.defer();
        var self = this;
        if (entity.id)
            this.service.update(entity)
                .then(function success(data) { /*console.log("update"); console.log(data);*/ deferred.resolve(data); toastr.success(data.message);  self.clear();})
                .catch(function (error) { deferred.reject(error); /*console.log(error);*/ toastr.error(error.message); });
        else
            this.service.save(entity)
                .then(function (data) { /*console.log("salva"); console.log(data);*/ deferred.resolve(data); toastr.success(data.message);  self.clear();})
                .catch(function (error) { deferred.reject(error); /*console.log(error);*/ toastr.error(error.message); });
        return deferred.promise;
    };

    this.remove = function (entity) {
        var deferred = $q.defer();
        var self = this;
        this.service.delete(entity)
            .then(function (data) { deferred.resolve(data); toastr.success(data.message); self.clear();})
            .catch(function (error) { deferred.reject(error); toastr.error(error.message); self.clear();});
        return deferred.promise;
    };

    this.busca = function () {
        var deferred = $q.defer();
        var self = this;
        this.service.busca()
            .then(function (data) { deferred.resolve(data); /*console.log(self.entities);*/ })
            .catch(function (error) { deferred.reject(error); toastr.error(error.message); });
        return deferred.promise;
    }

    this.find = function (id) {
        var deferred = $q.defer();
        var self = this;
        if (id)
            this.service.find(id)
                .then(function (data) { deferred.resolve(data); /*console.log(data);*/  })
                .catch(function (error) { deferred.reject(error); toastr.error(error.message); });
        else
            deferred.reject("Id Nulo!");
        return deferred.promise;
    }

    this.initTableState = function (tableState, predicate, order) {
        tableState.page = tableState.pagination.start / tableState.pagination.number;
        predicate = predicate ? predicate : 'id';
        tableState.sort.predicate = tableState.sort.predicate ? tableState.sort.predicate : predicate;
        tableState.sort.sortOrder = order != undefined ? order : 'ASC';
        if(tableState.sort.reverse != undefined)
            tableState.sort.sortOrder = tableState.sort.reverse ? 'DESC' : 'ASC';
        self.tableState = tableState;
        return self.tableState;
    }

    this.updateTableState = function (result) {
        self.tableState.pagination.start = result.number * result.size;//set the number of pages so the pagination can update
        self.tableState.pagination.number = result.size;//set the number of pages so the pagination can update
        self.tableState.pagination.numberOfPages = result.totalPages;//set the number of pages so the pagination can update
        return self.tableState;
    }

    this.getPage = function (tableState) {
        self.initTableState(tableState);
        self.service.getPage(tableState.search.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                self.updateTableState(result)
                tableState.table = result.content;
                tableState.pagination = {
                    start: result.number * result.size,
                    number: result.size,
                    numberOfPages: result.totalPages
                };
                deferred.resolve(tableState);
            }).catch(function (error) {
                deferred.reject(error); toastr.error(error.message);
            });
    }

    this.activate = function () { }

    this.clear = function () { }

});


angular.module('bentham').directive('permission', ['AuthService', function(AuthService) {
    return {
        restrict: 'A',
        scope: {
            permission: '='
        },
        link: function(scope, elem, attrs) {
            scope.$watch(AuthService.isAuthenticated, function() {
                if (AuthService.userHasPermission(scope.permission)) {
                    elem.show();
                } else {
                    elem.hide();
                    //elem.addClass("disablediv");;
                }
            });
        }
    };
}]);
// angular.module('bentham').factory('Chart', function ($resource, prefixRoute) {
//     return $resource(prefixRoute + 'contratos-externos/:id', { id: '@id', }, {
//     });
// });

angular.module('bentham').factory('ChartService', function () {
    var self = this;
    // Object.setPrototypeOf(self, GenericService);

    function fillColors(colors, bar) {
        if(bar.color !=null && !colors.includes(fillColor(bar.color)))
            colors.push(fillColor(bar.color));
    }

    function fillColor(color) {
        switch (color) {
            case 'btn-info':
                return "#33ccff"
            case 'btn-success':
                return '#4dff4d'
            case 'btn-warning':
                return '#F0F100'
            case 'btn-danger':
                return "#ff0000"
            default:
                return color
          }
    }

    self.convertBarChart = function (graphic, type) {
        var data = [];
        var series = []
        var colors = ['#4dff4d','#33ccff', '#ffff4d', '#ff0000']
        graphic.bars.forEach(function (bar) { series.push(bar.name); data.push([bar.value]); });
       return {
            name: graphic.name,
            type: graphic.type,
            data: data,
            labels: [graphic.name],
            series: series,
            colors: colors,
            options: {
                responsive: true,
                legend: { display: true },
                tooltips: {
                    mode: 'nearest',
                    callbacks: {
                        beginAtZero: true,
                        label: (type != 'currency') ? function (tooltipItem, data) { return tooltipItem.yLabel; } :
                            function (tooltipItem, data) { return tooltipItem.yLabel.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}); } 
                    }
                },
                plugins: { labels: false },
                scales: {
                    yAxes: [{
                        id: 'A',
                        type: 'linear',
                        display: true,
                        position: 'left',
                        min: 0,
                        ticks: {
                            beginAtZero: true,
                            callback: (type != 'currency') ? function (value) { return value; } :
                                function (value) { return value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}); } 
                        }
                    }, ],
                }
            }

        }
    };

    self.convertPieChart = function (graphic, type) {
        var data = [];
        var labels = []
        graphic.pies.forEach(function (pie) { labels.push(pie.name); data.push(pie.value); });
        var colors = ['#33ccff', '#4dff4d'];
        return {
            name: graphic.name,
            type: graphic.type,
            data: data,
            labels: labels,
            colors: colors,
            options: {
                tooltips: {
                    mode: 'nearest',
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                            if(type == 'currency')
                                value = value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}); 
                            return data.labels[tooltipItem.index] + ':' + value;
                        }
                    }
                },
                legend: { display: true },
                responsive: true,
                plugins: {
                    labels: [{
                            // showZero: true,
                            fontSize: 12,
                            position: 'outside',
                            textMargin: 15,
                            showActualPercentages: true,
                        },
                        {
                            fontColor: "#fff",
                            render: function (args) {
                                if(type == 'currency')
                                    return args.value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}); 
                                else
                                    return args.value; 
                            }
                        }
                    ]

                }
            }
        };
    };

    // colors definition
    // Orcamento  = rgb(77, 255, 77), #4dff4d
    // Entregue =  rgb(51, 204, 255), #33ccff
    // Deficit = rgb(255, 255, 77),#ffff4d
    // Executado = rgb(255, 0, 0), #ff0000
    // Saldo = rgb(255,165,0) ,#ffa500


    self.convertMultiChart = function (graphic, type) {
        var labels = [];
        var colors = [];
        var data = [];
        var datasetOverride = [];
        var yAxes = [];
        graphic.charts.forEach(function (chart) {
            if (chart.bars != null && chart.bars != undefined) {
                var dataBar = [];
                labels = [];
                yAxes.push({
                            id: 'A',
                            type: 'linear',
                            display: true,
                            position: 'left',
                            min: 0,
                            ticks: {
                                beginAtZero: true,
                                callback: (type != 'currency') ? function (value) { return  chart.measurement ? value  + " " + chart.measurement : value; } :
                                function (value) { return value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}); } 
                            }
                        });
                
                datasetOverride.push({label: chart.name, borderWidth : 1, type: chart.type.toLowerCase(), yAxisID: 'A'});
                chart.bars.forEach(function (bar) { labels.push(bar.name); dataBar.push(bar.value); fillColors(colors, bar) });
                data.push(dataBar);
            } else {
                var dataPoint = [];
                yAxes.push( {
                            id: 'B',
                            type: 'linear',
                            display: true,
                            position: 'right',
                            min: 0,
                            ticks: {
                                beginAtZero: true,
                                callback: (type != 'currency') ? function (value) { return chart.measurement ? value  + " " + chart.measurement : value; } :
                                function (value) { return value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}); } 
                            }
                        });
                datasetOverride.push({fill: false, label: chart.name, borderWidth : 1, type: chart.type.toLowerCase(), hoverBackgroundColor: "rgba(255,99,132,0.4)", hoverBorderColor: "rgba(255,99,132,1)", yAxisID: 'B'});
                chart.points.forEach(function (point) { dataPoint.push(point.value); });
                data.push(dataPoint);
            }
        });
        return {
            name: graphic.name,
            type: graphic.type,
            data: data,
            labels: labels,
            colors: colors.length > 0 ? colors : ['#4dff4d','#4dff4d', '#33ccff', '#33ccff', '#F0F100', '#F0F100', '#DF4C00', '#DF4C00', '#ff0000', '#ff0000'], 
            //['#2BA65A','#2BA65A','#4dff4d','#4dff4d', '#33ccff', '#33ccff', '#F0F100', '#F0F100', '#DF4C00', '#DF4C00', '#ff0000', '#ff0000'],
            // colors: [ '#0300BD', '#0300BD', '#33ccff', '#33ccff', '#DF4C00', '#DF4C00', '#EB8500', '#EB8500', '#4dff4d','#4dff4d' ],
            datasetOverride: datasetOverride,
            borderWidth : 2,
            backgroundColor: 1,
            options: {
                responsive: true,
                legend: { display: true },
                plugins: { labels: false },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            if(type == 'currency')
                                return tooltipItem.yLabel.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
                            else
                                return tooltipItem.yLabel; 
                        }
                    }
                },
                scales: { yAxes : yAxes }
            }
        }
    };

    return function () { return self; };
});
angular.module('bentham').service('GenericService', function ($rootScope, $state, $resource, $q, $injector, $timeout, AuthService) {
    this.resource = {};

    this.catchMessage = function (error) {
        if (error.data && error.data.errors)
            for (var i = 0; i < error.data.errors.length; i++)
                error.data.message += " " + error.data.errors[i].message + "!";
        if (error.status == 500 && error.data.message == null)
            error.data.message = "Erro Interno!";
        if (!error.data)
            error = { data: error}
        return error.data;
    }

    this.process = function (fn) {
        if (!AuthService.isAuthenticated()) {
            return AuthService.obtainAccessToken({ grant_type: 'refresh_token' })
                .then(function () {
                    if (!AuthService.isAuthenticated())
                        $state.go('/login');
                    return fn();
                });
        } else
            return fn();
    }

    this.messageMessage = function (error) { return messageMessage(error); }


    this.messageModelState = function (error) {
        return messageModelState(error);
    }

    this.converte = function (data) { /*console.log(data);*/ return data };

    this.valida = function (data) {
        var deferred = $q.defer();
        deferred.resolve(data);
        return deferred.promise
    };

    this.converteData = function (data) {
        if (typeof data == 'string') {
            var parts = data.match(/(\d+)/g);
            data = new Date(parts[0], parts[1] - 1, parts[2]);
        } else 
            data = moment(data).format("YYYY-MM-DD").concat(' 23:59:5.500');
        return data;
    };

    this.find = function (id) {
        var deferred = $q.defer();
        var self = this;
        var fn = function () {
            if (id) {
                self.resource.get({ id: id },  //Carrega o Objeto 
                    function (data) {
                        data = self.converte(data);  /*console.log(data);*/
                        deferred.resolve(data);
                    },
                    function (error) {
                        error = self.catchMessage(error);
                        deferred.reject(new Error("Erro! " + error.message));
                    }
                );
            } else {
                deferred.resolve(new Error("Erro! Paramêntro nulo"));
            }
            return deferred.promise;
        }
        return self.process(fn);
    }

    this.update = function (entity) {
        delete entity.message;
        var self = this;
        if (entity.id) { //verifica se é um entity já cadastrada
            var deferred = $q.defer();
            var fn = function () {
                self.valida(entity)
                    .then(function (entidade) {
                        if (entidade)
                            self.resource.update({ id: entidade.id }, entidade, //Atualiza
                                function success(data) {
                                    data.message = "Atualizado com sucesso";
                                    if (!data.id)
                                        self.find(entidade.id).then(function (da) { data = da });
                                    data = self.converte(data);
                                    deferred.resolve(data);
                                },
                                function (error) {
                                    error = self.catchMessage(error);
                                    deferred.reject(new Error("Erro! " + error.message));
                                });
                    })
                    .catch(function (error) { deferred.reject(error); });
                return deferred.promise;
            }
            return self.process(fn);
        } else
            return self.save(entity);

    }

    this.save = function (entity) {
        delete entity.message;
        var self = this;
        if (entity.id) //verifica se é um entity já cadastrada
            return self.update(entity);
        else {
            var deferred = $q.defer();
            var fn = function () {
                self.valida(entity)
                    .then(function (entidade) {
                        if (entidade)
                            entidade.$save()
                                .then(function (data) {
                                    data.message = "Salvo com sucesso";
                                    data = self.converte(data);
                                    deferred.resolve(data);
                                })
                                .catch(function (error) {
                                    error = self.catchMessage(error);
                                    deferred.reject(new Error("Erro! " + error.message));
                                });
                    })
                    .catch(function (error) {
                        deferred.reject(error);
                    });
                return deferred.promise;
            }
            return self.process(fn);
        }
    };

    this.delete = function (entity) {
        var self = this;
        var deferred = $q.defer();
        var fn = function () {
            self.resource.delete({ id: entity.id },
                function (data) {
                    data.message = "Excluído com sucesso";
                    deferred.resolve(data);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                }
            );
            return deferred.promise;
        }

        return self.process(fn);
    }

    this.deleteById = function (id) {
        var self = this;
        var deferred = $q.defer();
        var fn = function () {
            self.resource.delete({ id: id },
                function (data) {
                    data.message = "Excluído com sucesso";
                    deferred.resolve(data);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                }
            );
            return deferred.promise;
        }

        return self.process(fn);
    }

    this.busca = function () {
        var self = this;
        var deferred = $q.defer();
        var fn = function () {
            self.resource.pageable({ page: page, size: size, sort: sortField + ',' + sortOrder, search: search },
                function (data) {
                    for (var i = 0; i < data.content.length; i++)
                        data.content[i] = self.converte(data.content[i]);
                    deferred.resolve(data);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }

        return self.process(fn);
    }

    this.getPage = function (page, size, sortField, sortOrder, search) {
        var deferred = $q.defer();
        var self = this;
        if (search.predicateObject) {
            Object.assign(search, search.predicateObject)
            delete search.predicateObject;
        }
        var fn = function () {
            self.resource.pageable(angular.extend(search, { page: page, size: size, sort: sortField + ',' + sortOrder }),
                function (data) {
                    for (var i = 0; i < data.content.length; i++)
                        data.content[i] = self.converte(data.content[i]);
                    deferred.resolve(data);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }

        return self.process(fn);

    }

    this.list = function (page, size, sortField, sortOrder, search) {
        var deferred = $q.defer();
        var self = this;
        if (search.predicateObject) {
            Object.assign(search, search.predicateObject)
            delete search.predicateObject;
        }
        var fn = function () {
            self.resource.all(angular.extend(search, { page: page, size: size, sort: sortField + ',' + sortOrder }),
                function (data) {
                    for (var i = 0; i < data.length; i++)
                        data[i] = self.converte(data[i]);
                    deferred.resolve(data);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }

        return self.process(fn);

    }

});
angular.module('bentham').factory('Role', ['$resource', function($resource) {
    return $resource('role/:id', { id: '@id', }, {
        update: { method: 'PUT' }
        // ,alterarSenha: { method: 'POST', url: 'usuarios/alterar-senha' }
    });
}]);
function a() {
    return {
        buscarCidadesPorSigla: o,
        buscarNomeEstadoPorSigla: r,
        estados: i()
    }
}

function o(a) {
    var o = i(),
        r = [];
    for (var e in o) o[e].sigla === a && (r = o[e].cidades);
    return r
}

function r(a) {
    var o = i(),
        r = "";
    for (var e in o) o[e].sigla === a && (r = o[e].nome);
    return r
}

function i() {
    return [{
        sigla: "AC",
        nome: "Acre",
        cidades: ["Rio Branco", "Acrelândia", "Assis Brasil", "Brasiléia", "Bujari", "Capixaba", "Cruzeiro do Sul", "Epitaciolândia", "Feijó", "Jordão", "Mâncio Lima", "Manoel Urbano", "Marechal Thaumaturgo", "Plácido de Castro", "Porto Acre", "Porto Walter", "Rodrigues Alves", "Santa Rosa do Purus", "Sena Madureira", "Senador Guiomard", "Tarauacá", "Xapuri"]
    }, {
        sigla: "AL",
        nome: "Alagoas",
        cidades: ["Maceió", "Água Branca", "Anadia", "Arapiraca", "Atalaia", "Barra de Santo Antônio", "Barra de São Miguel", "Batalha", "Belém", "Belo Monte", "Boca da Mata", "Branquinha", "Cacimbinhas", "Cajueiro", "Campestre", "Campo Alegre", "Campo Grande", "Canapi", "Capela", "Carneiros", "Chã Preta", "Coité do Nóia", "Colônia Leopoldina", "Coqueiro Seco", "Coruripe", "Craíbas", "Delmiro Gouveia", "Dois Riachos", "Estrela de Alagoas", "Feira Grande", "Feliz Deserto", "Flexeiras", "Girau do Ponciano", "Ibateguara", "Igaci", "Igreja Nova", "Inhapi", "Jacaré dos Homens", "Jacuípe", "Japaratinga", "Jaramataia", "Jequiá da Praia", "Joaquim Gomes", "Jundiá", "Junqueiro", "Lagoa da Canoa", "Limoeiro de Anadia", "Major Isidoro", "Mar Vermelho", "Maragogi", "Maravilha", "Marechal Deodoro", "Maribondo", "Mata Grande", "Matriz de Camaragibe", "Messias", "Minador do Negrão", "Monteirópolis", "Murici", "Novo Lino", "Olho d'Água das Flores", "Olho d'Água do Casado", "Olho d'Água Grande", "Olivença", "Ouro Branco", "Palestina", "Palmeira dos Índios", "Pão de Açúcar", "Pariconha", "Paripueira", "Passo de Camaragibe", "Paulo Jacinto", "Penedo", "Piaçabuçu", "Pilar", "Pindoba", "Piranhas", "Poço das Trincheiras", "Porto Calvo", "Porto de Pedras", "Porto Real do Colégio", "Quebrangulo", "Rio Largo", "Roteiro", "Santa Luzia do Norte", "Santana do Ipanema", "Santana do Mundaú", "São Brás", "São José da Laje", "São José da Tapera", "São Luís do Quitunde", "São Miguel dos Campos", "São Miguel dos Milagres", "São Sebastião", "Satuba", "Senador Rui Palmeira", "Tanque d'Arca", "Taquarana", "Teotônio Vilela", "Traipu", "União dos Palmares", "Viçosa"]
    }, {
        sigla: "AM",
        nome: "Amazonas",
        cidades: ["Manaus", "Alvarães", "Amaturá", "Anamã", "Anori", "Apuí", "Atalaia do Norte", "Autazes", "Barcelos", "Barreirinha", "Benjamin Constant", "Beruri", "Boa Vista do Ramos", "Boca do Acre", "Borba", "Caapiranga", "Canutama", "Carauari", "Careiro", "Careiro da Várzea", "Coari", "Codajás", "Eirunepé", "Envira", "Fonte Boa", "Guajará", "Humaitá", "Ipixuna", "Iranduba", "Itacoatiara", "Itamarati", "Itapiranga", "Japurá", "Juruá", "Jutaí", "Lábrea", "Manacapuru", "Manaquiri", "Manicoré", "Maraã", "Maués", "Nhamundá", "Nova Olinda do Norte", "Novo Airão", "Novo Aripuanã", "Parintins", "Pauini", "Presidente Figueiredo", "Rio Preto da Eva", "Santa Isabel do Rio Negro", "Santo Antônio do Içá", "São Gabriel da Cachoeira", "São Paulo de Olivença", "São Sebastião do Uatumã", "Silves", "Tabatinga", "Tapauá", "Tefé", "Tonantins", "Uarini", "Urucará", "Urucurituba"]
    }, {
        sigla: "AP",
        nome: "Amapá",
        cidades: ["Macapá", "Amapá", "Calçoene", "Cutias", "Ferreira Gomes", "Itaubal", "Laranjal do Jari", "Mazagão", "Oiapoque", "Pedra Branca do Amapari", "Porto Grande", "Pracuúba", "Santana", "Serra do Navio", "Tartarugalzinho", "Vitória do Jari"]
    }, {
        sigla: "BA",
        nome: "Bahia",
        cidades: ["Salvador", "Abaíra", "Abaré", "Acajutiba", "Adustina", "Água Fria", "Aiquara", "Alagoinhas", "Alcobaça", "Almadina", "Amargosa", "Amélia Rodrigues", "América Dourada", "Anagé", "Andaraí", "Andorinha", "Angical", "Anguera", "Antas", "Antônio Cardoso", "Antônio Gonçalves", "Aporá", "Apuarema", "Araças", "Aracatu", "Araci", "Aramari", "Arataca", "Aratuípe", "Aurelino Leal", "Baianópolis", "Baixa Grande", "Banzaê", "Barra", "Barra da Estiva", "Barra do Choça", "Barra do Mendes", "Barra do Rocha", "Barreiras", "Barro Alto", "Barrocas", "Barro Preto", "Belmonte", "Belo Campo", "Biritinga", "Boa Nova", "Boa Vista do Tupim", "Bom Jesus da Lapa", "Bom Jesus da Serra", "Boninal", "Bonito", "Boquira", "Botuporã", "Brejões", "Brejolândia", "Brotas de Macaúbas", "Brumado", "Buerarema", "Buritirama", "Caatiba", "Cabaceiras do Paraguaçu", "Cachoeira", "Caculé", "Caém", "Caetanos", "Caetité", "Cafarnaum", "Cairu", "Caldeirão Grande", "Camacan", "Camaçari", "Camamu", "Campo Alegre de Lourdes", "Campo Formoso", "Canápolis", "Canarana", "Canavieiras", "Candeal", "Candeias", "Candiba", "Cândido Sales", "Cansanção", "Canudos", "Capela do Alto Alegre", "Capim Grosso", "Caraíbas", "Caravelas", "Cardeal da Silva", "Carinhanha", "Casa Nova", "Castro Alves", "Catolândia", "Catu", "Caturama", "Central", "Chorrochó", "Cícero Dantas", "Cipó", "Coaraci", "Cocos", "Conceição da Feira", "Conceição do Almeida", "Conceição do Coité", "Conceição do Jacuípe", "Conde", "Condeúba", "Contendas do Sincorá", "Coração de Maria", "Cordeiros", "Coribe", "Coronel João Sá", "Correntina", "Cotegipe", "Cravolândia", "Crisópolis", "Cristópolis", "Cruz das Almas", "Curaçá", "Dário Meira", "Dias d'Ávila", "Dom Basílio", "Dom Macedo Costa", "Elísio Medrado", "Encruzilhada", "Entre Rios", "Érico Cardoso", "Esplanada", "Euclides da Cunha", "Eunápolis", "Fátima", "Feira da Mata", "Feira de Santana", "Filadélfia", "Firmino Alves", "Floresta Azul", "Formosa do Rio Preto", "Gandu", "Gavião", "Gentio do Ouro", "Glória", "Gongogi", "Governador Mangabeira", "Guajeru", "Guanambi", "Guaratinga", "Heliópolis", "Iaçu", "Ibiassucê", "Ibicaraí", "Ibicoara", "Ibicuí", "Ibipeba", "Ibipitanga", "Ibiquera", "Ibirapitanga", "Ibirapuã", "Ibirataia", "Ibitiara", "Ibititá", "Ibotirama", "Ichu", "Igaporã", "Igrapiúna", "Iguaí", "Ilhéus", "Inhambupe", "Ipecaetá", "Ipiaú", "Ipirá", "Ipupiara", "Irajuba", "Iramaia", "Iraquara", "Irará", "Irecê", "Itabela", "Itaberaba", "Itabuna", "Itacaré", "Itaeté", "Itagi", "Itagibá", "Itagimirim", "Itaguaçu da Bahia", "Itaju do Colônia", "Itajuípe", "Itamaraju", "Itamari", "Itambé", "Itanagra", "Itanhém", "Itaparica", "Itapé", "Itapebi", "Itapetinga", "Itapicuru", "Itapitanga", "Itaquara", "Itarantim", "Itatim", "Itiruçu", "Itiúba", "Itororó", "Ituaçu", "Ituberá", "Iuiú", "Jaborandi", "Jacaraci", "Jacobina", "Jaguaquara", "Jaguarari", "Jaguaripe", "Jandaíra", "Jequié", "Jeremoabo", "Jiquiriçá", "Jitaúna", "João Dourado", "Juazeiro", "Jucuruçu", "Jussara", "Jussari", "Jussiape", "Lafaiete Coutinho", "Lagoa Real", "Laje", "Lajedão", "Lajedinho", "Lajedo do Tabocal", "Lamarão", "Lapão", "Lauro de Freitas", "Lençóis", "Licínio de Almeida", "Livramento de Nossa Senhora", "Luís Eduardo Magalhães", "Macajuba", "Macarani", "Macaúbas", "Macururé", "Madre de Deus", "Maetinga", "Maiquinique", "Mairi", "Malhada", "Malhada de Pedras", "Manoel Vitorino", "Mansidão", "Maracás", "Maragogipe", "Maraú", "Marcionílio Souza", "Mascote", "Mata de São João", "Matina", "Medeiros Neto", "Miguel Calmon", "Milagres", "Mirangaba", "Mirante", "Monte Santo", "Morpará", "Morro do Chapéu", "Mortugaba", "Mucugê", "Mucuri", "Mulungu do Morro", "Mundo Novo", "Muniz Ferreira", "Muquém de São Francisco", "Muritiba", "Mutuípe", "Nazaré", "Nilo Peçanha", "Nordestina", "Nova Canaã", "Nova Fátima", "Nova Ibiá", "Nova Itarana", "Nova Redenção", "Nova Soure", "Nova Viçosa", "Novo Horizonte", "Novo Triunfo", "Olindina", "Oliveira dos Brejinhos", "Ouriçangas", "Ourolândia", "Palmas de Monte Alto", "Palmeiras", "Paramirim", "Paratinga", "Paripiranga", "Pau Brasil", "Paulo Afonso", "Pé de Serra", "Pedrão", "Pedro Alexandre", "Piatã", "Pilão Arcado", "Pindaí", "Pindobaçu", "Pintadas", "Piraí do Norte", "Piripá", "Piritiba", "Planaltino", "Planalto", "Poções", "Pojuca", "Ponto Novo", "Porto Seguro", "Potiraguá", "Prado", "Presidente Dutra", "Presidente Jânio Quadros", "Presidente Tancredo Neves", "Queimadas", "Quijingue", "Quixabeira", "Rafael Jambeiro", "Remanso", "Retirolândia", "Riachão das Neves", "Riachão do Jacuípe", "Riacho de Santana", "Ribeira do Amparo", "Ribeira do Pombal", "Ribeirão do Largo", "Rio de Contas", "Rio do Antônio", "Rio do Pires", "Rio Real", "Rodelas", "Ruy Barbosa", "Salinas da Margarida", "Santa Bárbara", "Santa Brígida", "Santa Cruz Cabrália", "Santa Cruz da Vitória", "Santa Inês", "Santa Luzia", "Santa Maria da Vitória", "Santa Rita de Cássia", "Santa Teresinha", "Santaluz", "Santana", "Santanópolis", "Santo Amaro", "Santo Antônio de Jesus", "Santo Estêvão", "São Desidério", "São Domingos", "São Felipe", "São Félix", "São Félix do Coribe", "São Francisco do Conde", "São Gabriel", "São Gonçalo dos Campos", "São José da Vitória", "São José do Jacuípe", "São Miguel das Matas", "São Sebastião do Passé", "Sapeaçu", "Sátiro Dias", "Saubara", "Saúde", "Seabra", "Sebastião Laranjeiras", "Senhor do Bonfim", "Sento Sé", "Serra do Ramalho", "Serra Dourada", "Serra Preta", "Serrinha", "Serrolândia", "Simões Filho", "Sítio do Mato", "Sítio do Quinto", "Sobradinho", "Souto Soares", "Tabocas do Brejo Velho", "Tanhaçu", "Tanque Novo", "Tanquinho", "Taperoá", "Tapiramutá", "Teixeira de Freitas", "Teodoro Sampaio", "Teofilândia", "Teolândia", "Terra Nova", "Tremedal", "Tucano", "Uauá", "Ubaíra", "Ubaitaba", "Ubatã", "Uibaí", "Umburanas", "Una", "Urandi", "Uruçuca", "Utinga", "Valença", "Valente", "Várzea da Roça", "Várzea do Poço", "Várzea Nova", "Varzedo", "Vera Cruz", "Vereda", "Vitória da Conquista", "Wagner", "Wanderley", "Wenceslau Guimarães", "Xique-Xique"]
    }, {
        sigla: "CE",
        nome: "Ceará",
        cidades: ["Fortaleza", "Abaiara", "Acarapé", "Acaraú", "Acopiara", "Aiuaba", "Alcântaras", "Altaneira", "Alto Santo", "Amontada", "Antonina do Norte", "Apuiarés", "Aquiraz", "Aracati", "Aracoiaba", "Ararendá", "Araripe", "Aratuba", "Arneiroz", "Assaré", "Aurora", "Baixio", "Banabuiú", "Barbalha", "Barreira", "Barro", "Barroquinha", "Baturité", "Beberibe", "Bela Cruz", "Boa Viagem", "Brejo Santo", "Camocim", "Campos Sales", "Canindé", "Capistrano", "Caridade", "Cariré", "Caririaçu", "Cariús", "Carnaubal", "Cascavel", "Catarina", "Catunda", "Caucaia", "Cedro", "Chaval", "Choró", "Chorozinho", "Coreaú", "Crateús", "Crato", "Croatá", "Cruz", "Deputado Irapuan Pinheiro", "Ererê", "Eusébio", "Farias Brito", "Forquilha", "Fortim", "Frecheirinha", "General Sampaio", "Graça", "Granja", "Granjeiro", "Groaíras", "Guaiúba", "Guaraciaba do Norte", "Guaramiranga", "Hidrolândia", "Horizonte", "Ibaretama", "Ibiapina", "Ibicuitinga", "Icapuí", "Icó", "Iguatu", "Independência", "Ipaporanga", "Ipaumirim", "Ipu", "Ipueiras", "Iracema", "Irauçuba", "Itaiçaba", "Itaitinga", "Itapagé", "Itapipoca", "Itapiúna", "Itarema", "Itatira", "Jaguaretama", "Jaguaribara", "Jaguaribe", "Jaguaruana", "Jardim", "Jati", "Jijoca de Jericoacoara", "Juazeiro do Norte", "Jucás", "Lavras da Mangabeira", "Limoeiro do Norte", "Madalena", "Maracanaú", "Maranguape", "Marco", "Martinópole", "Massapê", "Mauriti", "Meruoca", "Milagres", "Milhã", "Miraíma", "Missão Velha", "Mombaça", "Monsenhor Tabosa", "Morada Nova", "Moraújo", "Morrinhos", "Mucambo", "Mulungu", "Nova Olinda", "Nova Russas", "Novo Oriente", "Ocara", "Orós", "Pacajus", "Pacatuba", "Pacoti", "Pacujá", "Palhano", "Palmácia", "Paracuru", "Paraipaba", "Parambu", "Paramoti", "Pedra Branca", "Penaforte", "Pentecoste", "Pereiro", "Pindoretama", "Piquet Carneiro", "Pires Ferreira", "Poranga", "Porteiras", "Potengi", "Potiretama", "Quiterianópolis", "Quixadá", "Quixelô", "Quixeramobim", "Quixeré", "Redenção", "Reriutaba", "Russas", "Saboeiro", "Salitre", "Santa Quitéria", "Santana do Acaraú", "Santana do Cariri", "São Benedito", "São Gonçalo do Amarante", "São João do Jaguaribe", "São Luís do Curu", "Senador Pompeu", "Senador Sá", "Sobral", "Solonópole", "Tabuleiro do Norte", "Tamboril", "Tarrafas", "Tauá", "Tejuçuoca", "Tianguá", "Trairi", "Tururu", "Ubajara", "Umari", "Umirim", "Uruburetama", "Uruoca", "Varjota", "Várzea Alegre", "Viçosa do Ceará"]
    }, {
        sigla: "DF",
        nome: "Distrito Federal",
        cidades: ["Brasília"]
    }, {
        sigla: "ES",
        nome: "Espírito Santo",
        cidades: ["Vitória", "Afonso Cláudio", "Água Doce do Norte", "Águia Branca", "Alegre", "Alfredo Chaves", "Alto Rio Novo", "Anchieta", "Apiacá", "Aracruz", "Atilio Vivacqua", "Baixo Guandu", "Barra de São Francisco", "Boa Esperança", "Bom Jesus do Norte", "Brejetuba", "Cachoeiro de Itapemirim", "Cariacica", "Castelo", "Colatina", "Conceição da Barra", "Conceição do Castelo", "Divino de São Lourenço", "Domingos Martins", "Dores do Rio Preto", "Ecoporanga", "Fundão", "Governador Lindenberg", "Guaçuí", "Guarapari", "Ibatiba", "Ibiraçu", "Ibitirama", "Iconha", "Irupi", "Itaguaçu", "Itapemirim", "Itarana", "Iúna", "Jaguaré", "Jerônimo Monteiro", "João Neiva", "Laranja da Terra", "Linhares", "Mantenópolis", "Marataizes", "Marechal Floriano", "Marilândia", "Mimoso do Sul", "Montanha", "Mucurici", "Muniz Freire", "Muqui", "Nova Venécia", "Pancas", "Pedro Canário", "Pinheiros", "Piúma", "Ponto Belo", "Presidente Kennedy", "Rio Bananal", "Rio Novo do Sul", "Santa Leopoldina", "Santa Maria de Jetibá", "Santa Teresa", "São Domingos do Norte", "São Gabriel da Palha", "São José do Calçado", "São Mateus", "São Roque do Canaã", "Serra", "Sooretama", "Vargem Alta", "Venda Nova do Imigrante", "Viana", "Vila Pavão", "Vila Valério", "Vila Velha"]
    }, {
        sigla: "GO",
        nome: "Goiás",
        cidades: ["Goiânia", "Abadia de Goiás", "Abadiânia", "Acreúna", "Adelândia", "Água Fria de Goiás", "Água Limpa", "Águas Lindas de Goiás", "Alexânia", "Aloândia", "Alto Horizonte", "Alto Paraíso de Goiás", "Alvorada do Norte", "Amaralina", "Americano do Brasil", "Amorinópolis", "Anápolis", "Anhanguera", "Anicuns", "Aparecida de Goiânia", "Aparecida do Rio Doce", "Aporé", "Araçu", "Aragarças", "Aragoiânia", "Araguapaz", "Arenópolis", "Aruanã", "Aurilândia", "Avelinópolis", "Baliza", "Barro Alto", "Bela Vista de Goiás", "Bom Jardim de Goiás", "Bom Jesus de Goiás", "Bonfinópolis", "Bonópolis", "Brazabrantes", "Britânia", "Buriti Alegre", "Buriti de Goiás", "Buritinópolis", "Cabeceiras", "Cachoeira Alta", "Cachoeira de Goiás", "Cachoeira Dourada", "Caçu", "Caiapônia", "Caldas Novas", "Caldazinha", "Campestre de Goiás", "Campinaçu", "Campinorte", "Campo Alegre de Goiás", "Campo Limpo de Goiás", "Campos Belos", "Campos Verdes", "Carmo do Rio Verde", "Castelândia", "Catalão", "Caturaí", "Cavalcante", "Ceres", "Cezarina", "Chapadão do Céu", "Cidade Ocidental", "Cocalzinho de Goiás", "Colinas do Sul", "Córrego do Ouro", "Corumbá de Goiás", "Corumbaíba", "Cristalina", "Cristianópolis", "Crixás", "Cromínia", "Cumari", "Damianópolis", "Damolândia", "Davinópolis", "Diorama", "Divinópolis de Goiás", "Doverlândia", "Edealina", "Edéia", "Estrela do Norte", "Faina", "Fazenda Nova", "Firminópolis", "Flores de Goiás", "Formosa", "Formoso", "Gameleira de Goiás", "Goianápolis", "Goiandira", "Goianésia", "Goianira", "Goiás", "Goiatuba", "Gouvelândia", "Guapó", "Guaraíta", "Guarani de Goiás", "Guarinos", "Heitoraí", "Hidrolândia", "Hidrolina", "Iaciara", "Inaciolândia", "Indiara", "Inhumas", "Ipameri", "Ipiranga de Goiás", "Iporá", "Israelândia", "Itaberaí", "Itaguari", "Itaguaru", "Itajá", "Itapaci", "Itapirapuã", "Itapuranga", "Itarumã", "Itauçu", "Itumbiara", "Ivolândia", "Jandaia", "Jaraguá", "Jataí", "Jaupaci", "Jesúpolis", "Joviânia", "Jussara", "Lagoa Santa", "Leopoldo de Bulhões", "Luziânia", "Mairipotaba", "Mambaí", "Mara Rosa", "Marzagão", "Matrinchã", "Maurilândia", "Mimoso de Goiás", "Minaçu", "Mineiros", "Moiporá", "Monte Alegre de Goiás", "Montes Claros de Goiás", "Montividiu", "Montividiu do Norte", "Morrinhos", "Morro Agudo de Goiás", "Mossâmedes", "Mozarlândia", "Mundo Novo", "Mutunópolis", "Nazário", "Nerópolis", "Niquelândia", "Nova América", "Nova Aurora", "Nova Crixás", "Nova Glória", "Nova Iguaçu de Goiás", "Nova Roma", "Nova Veneza", "Novo Brasil", "Novo Gama", "Novo Planalto", "Orizona", "Ouro Verde de Goiás", "Ouvidor", "Padre Bernardo", "Palestina de Goiás", "Palmeiras de Goiás", "Palmelo", "Palminópolis", "Panamá", "Paranaiguara", "Paraúna", "Perolândia", "Petrolina de Goiás", "Pilar de Goiás", "Piracanjuba", "Piranhas", "Pirenópolis", "Pires do Rio", "Planaltina", "Pontalina", "Porangatu", "Porteirão", "Portelândia", "Posse", "Professor Jamil", "Quirinópolis", "Rialma", "Rianápolis", "Rio Quente", "Rio Verde", "Rubiataba", "Sanclerlândia", "Santa Bárbara de Goiás", "Santa Cruz de Goiás", "Santa Fé de Goiás", "Santa Helena de Goiás", "Santa Isabel", "Santa Rita do Araguaia", "Santa Rita do Novo Destino", "Santa Rosa de Goiás", "Santa Tereza de Goiás", "Santa Terezinha de Goiás", "Santo Antônio da Barra", "Santo Antônio de Goiás", "Santo Antônio do Descoberto", "São Domingos", "São Francisco de Goiás", "São João d'Aliança", "São João da Paraúna", "São Luís de Montes Belos", "São Luíz do Norte", "São Miguel do Araguaia", "São Miguel do Passa Quatro", "São Patrício", "São Simão", "Senador Canedo", "Serranópolis", "Silvânia", "Simolândia", "Sítio d'Abadia", "Taquaral de Goiás", "Teresina de Goiás", "Terezópolis de Goiás", "Três Ranchos", "Trindade", "Trombas", "Turvânia", "Turvelândia", "Uirapuru", "Uruaçu", "Uruana", "Urutaí", "Valparaíso de Goiás", "Varjão", "Vianópolis", "Vicentinópolis", "Vila Boa", "Vila Propício"]
    }, {
        sigla: "MA",
        nome: "Maranhão",
        cidades: ["São Luís", "Açailândia", "Afonso Cunha", "Água Doce do Maranhão", "Alcântara", "Aldeias Altas", "Altamira do Maranhão", "Alto Alegre do Maranhão", "Alto Alegre do Pindaré", "Alto Parnaíba", "Amapá do Maranhão", "Amarante do Maranhão", "Anajatuba", "Anapurus", "Apicum-Açu", "Araguanã", "Araioses", "Arame", "Arari", "Axixá", "Bacabal", "Bacabeira", "Bacuri", "Bacurituba", "Balsas", "Barão de Grajaú", "Barra do Corda", "Barreirinhas", "Bela Vista do Maranhão", "Belágua", "Benedito Leite", "Bequimão", "Bernardo do Mearim", "Boa Vista do Gurupi", "Bom Jardim", "Bom Jesus das Selvas", "Bom Lugar", "Brejo", "Brejo de Areia", "Buriti", "Buriti Bravo", "Buriticupu", "Buritirana", "Cachoeira Grande", "Cajapió", "Cajari", "Campestre do Maranhão", "Cândido Mendes", "Cantanhede", "Capinzal do Norte", "Carolina", "Carutapera", "Caxias", "Cedral", "Central do Maranhão", "Centro do Guilherme", "Centro Novo do Maranhão", "Chapadinha", "Cidelândia", "Codó", "Coelho Neto", "Colinas", "Conceição do Lago-Açu", "Coroatá", "Cururupu", "Davinópolis", "Dom Pedro", "Duque Bacelar", "Esperantinópolis", "Estreito", "Feira Nova do Maranhão", "Fernando Falcão", "Formosa da Serra Negra", "Fortaleza dos Nogueiras", "Fortuna", "Godofredo Viana", "Gonçalves Dias", "Governador Archer", "Governador Edison Lobão", "Governador Eugênio Barros", "Governador Luiz Rocha", "Governador Newton Bello", "Governador Nunes Freire", "Graça Aranha", "Grajaú", "Guimarães", "Humberto de Campos", "Icatu", "Igarapé do Meio", "Igarapé Grande", "Imperatriz", "Itaipava do Grajaú", "Itapecuru Mirim", "Itinga do Maranhão", "Jatobá", "Jenipapo dos Vieiras", "João Lisboa", "Joselândia", "Junco do Maranhão", "Lago da Pedra", "Lago do Junco", "Lago dos Rodrigues", "Lago Verde", "Lagoa do Mato", "Lagoa Grande do Maranhão", "Lajeado Novo", "Lima Campos", "Loreto", "Luís Domingues", "Magalhães de Almeida", "Maracaçumé", "Marajá do Sena", "Maranhãozinho", "Mata Roma", "Matinha", "Matões", "Matões do Norte", "Milagres do Maranhão", "Mirador", "Miranda do Norte", "Mirinzal", "Monção", "Montes Altos", "Morros", "Nina Rodrigues", "Nova Colinas", "Nova Iorque", "Nova Olinda do Maranhão", "Olho d'Água das Cunhãs", "Olinda Nova do Maranhão", "Paço do Lumiar", "Palmeirândia", "Paraibano", "Parnarama", "Passagem Franca", "Pastos Bons", "Paulino Neves", "Paulo Ramos", "Pedreiras", "Pedro do Rosário", "Penalva", "Peri Mirim", "Peritoró", "Pindaré Mirim", "Pinheiro", "Pio XII", "Pirapemas", "Poção de Pedras", "Porto Franco", "Porto Rico do Maranhão", "Presidente Dutra", "Presidente Juscelino", "Presidente Médici", "Presidente Sarney", "Presidente Vargas", "Primeira Cruz", "Raposa", "Riachão", "Ribamar Fiquene", "Rosário", "Sambaíba", "Santa Filomena do Maranhão", "Santa Helena", "Santa Inês", "Santa Luzia", "Santa Luzia do Paruá", "Santa Quitéria do Maranhão", "Santa Rita", "Santana do Maranhão", "Santo Amaro do Maranhão", "Santo Antônio dos Lopes", "São Benedito do Rio Preto", "São Bento", "São Bernardo", "São Domingos do Azeitão", "São Domingos do Maranhão", "São Félix de Balsas", "São Francisco do Brejão", "São Francisco do Maranhão", "São João Batista", "São João do Carú", "São João do Paraíso", "São João do Soter", "São João dos Patos", "São José de Ribamar", "São José dos Basílios", "São Luís Gonzaga do Maranhão", "São Mateus do Maranhão", "São Pedro da Água Branca", "São Pedro dos Crentes", "São Raimundo das Mangabeiras", "São Raimundo do Doca Bezerra", "São Roberto", "São Vicente Ferrer", "Satubinha", "Senador Alexandre Costa", "Senador La Rocque", "Serrano do Maranhão", "Sítio Novo", "Sucupira do Norte", "Sucupira do Riachão", "Tasso Fragoso", "Timbiras", "Timon", "Trizidela do Vale", "Tufilândia", "Tuntum", "Turiaçu", "Turilândia", "Tutóia", "Urbano Santos", "Vargem Grande", "Viana", "Vila Nova dos Martírios", "Vitória do Mearim", "Vitorino Freire", "Zé Doca"]
    }, {
        sigla: "MG",
        nome: "Minas Gerais",
        cidades: ["Belo Horizonte", "Abadia dos Dourados", "Abaeté", "Abre Campo", "Acaiaca", "Açucena", "Água Boa", "Água Comprida", "Aguanil", "Águas Formosas", "Águas Vermelhas", "Aimorés", "Aiuruoca", "Alagoa", "Albertina", "Além Paraíba", "Alfenas", "Alfredo Vasconcelos", "Almenara", "Alpercata", "Alpinópolis", "Alterosa", "Alto Caparaó", "Alto Jequitibá", "Alto Rio Doce", "Alvarenga", "Alvinópolis", "Alvorada de Minas", "Amparo do Serra", "Andradas", "Andrelândia", "Angelândia", "Antônio Carlos", "Antônio Dias", "Antônio Prado de Minas", "Araçaí", "Aracitaba", "Araçuaí", "Araguari", "Arantina", "Araponga", "Araporã", "Arapuá", "Araújos", "Araxá", "Arceburgo", "Arcos", "Areado", "Argirita", "Aricanduva", "Arinos", "Astolfo Dutra", "Ataléia", "Augusto de Lima", "Baependi", "Baldim", "Bambuí", "Bandeira", "Bandeira do Sul", "Barão de Cocais", "Barão de Monte Alto", "Barbacena", "Barra Longa", "Barroso", "Bela Vista de Minas", "Belmiro Braga", "Belo Oriente", "Belo Vale", "Berilo", "Berizal", "Bertópolis", "Betim", "Bias Fortes", "Bicas", "Biquinhas", "Boa Esperança", "Bocaina de Minas", "Bocaiúva", "Bom Despacho", "Bom Jardim de Minas", "Bom Jesus da Penha", "Bom Jesus do Amparo", "Bom Jesus do Galho", "Bom Repouso", "Bom Sucesso", "Bonfim", "Bonfinópolis de Minas", "Bonito de Minas", "Borda da Mata", "Botelhos", "Botumirim", "Brás Pires", "Brasilândia de Minas", "Brasília de Minas", "Brasópolis", "Braúnas", "Brumadinho", "Bueno Brandão", "Buenópolis", "Bugre", "Buritis", "Buritizeiro", "Cabeceira Grande", "Cabo Verde", "Cachoeira da Prata", "Cachoeira de Minas", "Cachoeira de Pajeú", "Cachoeira Dourada", "Caetanópolis", "Caeté", "Caiana", "Cajuri", "Caldas", "Camacho", "Camanducaia", "Cambuí", "Cambuquira", "Campanário", "Campanha", "Campestre", "Campina Verde", "Campo Azul", "Campo Belo", "Campo do Meio", "Campo Florido", "Campos Altos", "Campos Gerais", "Cana Verde", "Canaã", "Canápolis", "Candeias", "Cantagalo", "Caparaó", "Capela Nova", "Capelinha", "Capetinga", "Capim Branco", "Capinópolis", "Capitão Andrade", "Capitão Enéas", "Capitólio", "Caputira", "Caraí", "Caranaíba", "Carandaí", "Carangola", "Caratinga", "Carbonita", "Careaçu", "Carlos Chagas", "Carmésia", "Carmo da Cachoeira", "Carmo da Mata", "Carmo de Minas", "Carmo do Cajuru", "Carmo do Paranaíba", "Carmo do Rio Claro", "Carmópolis de Minas", "Carneirinho", "Carrancas", "Carvalhópolis", "Carvalhos", "Casa Grande", "Cascalho Rico", "Cássia", "Cataguases", "Catas Altas", "Catas Altas da Noruega", "Catuji", "Catuti", "Caxambu", "Cedro do Abaeté", "Central de Minas", "Centralina", "Chácara", "Chalé", "Chapada do Norte", "Chapada Gaúcha", "Chiador", "Cipotânea", "Claraval", "Claro dos Poções", "Cláudio", "Coimbra", "Coluna", "Comendador Gomes", "Comercinho", "Conceição da Aparecida", "Conceição da Barra de Minas", "Conceição das Alagoas", "Conceição das Pedras", "Conceição de Ipanema", "Conceição do Mato Dentro", "Conceição do Pará", "Conceição do Rio Verde", "Conceição dos Ouros", "Cônego Marinho", "Confins", "Congonhal", "Congonhas", "Congonhas do Norte", "Conquista", "Conselheiro Lafaiete", "Conselheiro Pena", "Consolação", "Contagem", "Coqueiral", "Coração de Jesus", "Cordisburgo", "Cordislândia", "Corinto", "Coroaci", "Coromandel", "Coronel Fabriciano", "Coronel Murta", "Coronel Pacheco", "Coronel Xavier Chaves", "Córrego Danta", "Córrego do Bom Jesus", "Córrego Fundo", "Córrego Novo", "Couto de Magalhães de Minas", "Crisólita", "Cristais", "Cristália", "Cristiano Otoni", "Cristina", "Crucilândia", "Cruzeiro da Fortaleza", "Cruzília", "Cuparaque", "Curral de Dentro", "Curvelo", "Datas", "Delfim Moreira", "Delfinópolis", "Delta", "Descoberto", "Desterro de Entre Rios", "Desterro do Melo", "Diamantina", "Diogo de Vasconcelos", "Dionísio", "Divinésia", "Divino", "Divino das Laranjeiras", "Divinolândia de Minas", "Divinópolis", "Divisa Alegre", "Divisa Nova", "Divisópolis", "Dom Bosco", "Dom Cavati", "Dom Joaquim", "Dom Silvério", "Dom Viçoso", "Dona Euzébia", "Dores de Campos", "Dores de Guanhães", "Dores do Indaiá", "Dores do Turvo", "Doresópolis", "Douradoquara", "Durandé", "Elói Mendes", "Engenheiro Caldas", "Engenheiro Navarro", "Entre Folhas", "Entre Rios de Minas", "Ervália", "Esmeraldas", "Espera Feliz", "Espinosa", "Espírito Santo do Dourado", "Estiva", "Estrela Dalva", "Estrela do Indaiá", "Estrela do Sul", "Eugenópolis", "Ewbank da Câmara", "Extrema", "Fama", "Faria Lemos", "Felício dos Santos", "Felisburgo", "Felixlândia", "Fernandes Tourinho", "Ferros", "Fervedouro", "Florestal", "Formiga", "Formoso", "Fortaleza de Minas", "Fortuna de Minas", "Francisco Badaró", "Francisco Dumont", "Francisco Sá", "Franciscópolis", "Frei Gaspar", "Frei Inocêncio", "Frei Lagonegro", "Fronteira", "Fronteira dos Vales", "Fruta de Leite", "Frutal", "Funilândia", "Galiléia", "Gameleiras", "Glaucilândia", "Goiabeira", "Goianá", "Gonçalves", "Gonzaga", "Gouveia", "Governador Valadares", "Grão Mogol", "Grupiara", "Guanhães", "Guapé", "Guaraciaba", "Guaraciama", "Guaranésia", "Guarani", "Guarará", "Guarda-Mor", "Guaxupé", "Guidoval", "Guimarânia", "Guiricema", "Gurinhatã", "Heliodora", "Iapu", "Ibertioga", "Ibiá", "Ibiaí", "Ibiracatu", "Ibiraci", "Ibirité", "Ibitiúra de Minas", "Ibituruna", "Icaraí de Minas", "Igarapé", "Igaratinga", "Iguatama", "Ijaci", "Ilicínea", "Imbé de Minas", "Inconfidentes", "Indaiabira", "Indianópolis", "Ingaí", "Inhapim", "Inhaúma", "Inimutaba", "Ipaba", "Ipanema", "Ipatinga", "Ipiaçu", "Ipuiúna", "Iraí de Minas", "Itabira", "Itabirinha de Mantena", "Itabirito", "Itacambira", "Itacarambi", "Itaguara", "Itaipé", "Itajubá", "Itamarandiba", "Itamarati de Minas", "Itambacuri", "Itambé do Mato Dentro", "Itamogi", "Itamonte", "Itanhandu", "Itanhomi", "Itaobim", "Itapagipe", "Itapecerica", "Itapeva", "Itatiaiuçu", "Itaú de Minas", "Itaúna", "Itaverava", "Itinga", "Itueta", "Ituiutaba", "Itumirim", "Iturama", "Itutinga", "Jaboticatubas", "Jacinto", "Jacuí", "Jacutinga", "Jaguaraçu", "Jaíba", "Jampruca", "Janaúba", "Januária", "Japaraíba", "Japonvar", "Jeceaba", "Jenipapo de Minas", "Jequeri", "Jequitaí", "Jequitibá", "Jequitinhonha", "Jesuânia", "Joaíma", "Joanésia", "João Monlevade", "João Pinheiro", "Joaquim Felício", "Jordânia", "José Gonçalves de Minas", "José Raydan", "Josenópolis", "Juatuba", "Juiz de Fora", "Juramento", "Juruaia", "Juvenília", "Ladainha", "Lagamar", "Lagoa da Prata", "Lagoa dos Patos", "Lagoa Dourada", "Lagoa Formosa", "Lagoa Grande", "Lagoa Santa", "Lajinha", "Lambari", "Lamim", "Laranjal", "Lassance", "Lavras", "Leandro Ferreira", "Leme do Prado", "Leopoldina", "Liberdade", "Lima Duarte", "Limeira do Oeste", "Lontra", "Luisburgo", "Luislândia", "Luminárias", "Luz", "Machacalis", "Machado", "Madre de Deus de Minas", "Malacacheta", "Mamonas", "Manga", "Manhuaçu", "Manhumirim", "Mantena", "Mar de Espanha", "Maravilhas", "Maria da Fé", "Mariana", "Marilac", "Mário Campos", "Maripá de Minas", "Marliéria", "Marmelópolis", "Martinho Campos", "Martins Soares", "Mata Verde", "Materlândia", "Mateus Leme", "Mathias Lobato", "Matias Barbosa", "Matias Cardoso", "Matipó", "Mato Verde", "Matozinhos", "Matutina", "Medeiros", "Medina", "Mendes Pimentel", "Mercês", "Mesquita", "Minas Novas", "Minduri", "Mirabela", "Miradouro", "Miraí", "Miravânia", "Moeda", "Moema", "Monjolos", "Monsenhor Paulo", "Montalvânia", "Monte Alegre de Minas", "Monte Azul", "Monte Belo", "Monte Carmelo", "Monte Formoso", "Monte Santo de Minas", "Monte Sião", "Montes Claros", "Montezuma", "Morada Nova de Minas", "Morro da Garça", "Morro do Pilar", "Munhoz", "Muriaé", "Mutum", "Muzambinho", "Nacip Raydan", "Nanuque", "Naque", "Natalândia", "Natércia", "Nazareno", "Nepomuceno", "Ninheira", "Nova Belém", "Nova Era", "Nova Lima", "Nova Módica", "Nova Ponte", "Nova Porteirinha", "Nova Resende", "Nova Serrana", "Nova União", "Novo Cruzeiro", "Novo Oriente de Minas", "Novorizonte", "Olaria", "Olhos-d'Água", "Olímpio Noronha", "Oliveira", "Oliveira Fortes", "Onça de Pitangui", "Oratórios", "Orizânia", "Ouro Branco", "Ouro Fino", "Ouro Preto", "Ouro Verde de Minas", "Padre Carvalho", "Padre Paraíso", "Pai Pedro", "Paineiras", "Pains", "Paiva", "Palma", "Palmópolis", "Papagaios", "Pará de Minas", "Paracatu", "Paraguaçu", "Paraisópolis", "Paraopeba", "Passa Quatro", "Passa Tempo", "Passa-Vinte", "Passabém", "Passos", "Patis", "Patos de Minas", "Patrocínio", "Patrocínio do Muriaé", "Paula Cândido", "Paulistas", "Pavão", "Peçanha", "Pedra Azul", "Pedra Bonita", "Pedra do Anta", "Pedra do Indaiá", "Pedra Dourada", "Pedralva", "Pedras de Maria da Cruz", "Pedrinópolis", "Pedro Leopoldo", "Pedro Teixeira", "Pequeri", "Pequi", "Perdigão", "Perdizes", "Perdões", "Periquito", "Pescador", "Piau", "Piedade de Caratinga", "Piedade de Ponte Nova", "Piedade do Rio Grande", "Piedade dos Gerais", "Pimenta", "Pingo-d'Água", "Pintópolis", "Piracema", "Pirajuba", "Piranga", "Piranguçu", "Piranguinho", "Pirapetinga", "Pirapora", "Piraúba", "Pitangui", "Piumhi", "Planura", "Poço Fundo", "Poços de Caldas", "Pocrane", "Pompéu", "Ponte Nova", "Ponto Chique", "Ponto dos Volantes", "Porteirinha", "Porto Firme", "Poté", "Pouso Alegre", "Pouso Alto", "Prados", "Prata", "Pratápolis", "Pratinha", "Presidente Bernardes", "Presidente Juscelino", "Presidente Kubitschek", "Presidente Olegário", "Prudente de Morais", "Quartel Geral", "Queluzito", "Raposos", "Raul Soares", "Recreio", "Reduto", "Resende Costa", "Resplendor", "Ressaquinha", "Riachinho", "Riacho dos Machados", "Ribeirão das Neves", "Ribeirão Vermelho", "Rio Acima", "Rio Casca", "Rio do Prado", "Rio Doce", "Rio Espera", "Rio Manso", "Rio Novo", "Rio Paranaíba", "Rio Pardo de Minas", "Rio Piracicaba", "Rio Pomba", "Rio Preto", "Rio Vermelho", "Ritápolis", "Rochedo de Minas", "Rodeiro", "Romaria", "Rosário da Limeira", "Rubelita", "Rubim", "Sabará", "Sabinópolis", "Sacramento", "Salinas", "Salto da Divisa", "Santa Bárbara", "Santa Bárbara do Leste", "Santa Bárbara do Monte Verde", "Santa Bárbara do Tugúrio", "Santa Cruz de Minas", "Santa Cruz de Salinas", "Santa Cruz do Escalvado", "Santa Efigênia de Minas", "Santa Fé de Minas", "Santa Helena de Minas", "Santa Juliana", "Santa Luzia", "Santa Margarida", "Santa Maria de Itabira", "Santa Maria do Salto", "Santa Maria do Suaçuí", "Santa Rita de Caldas", "Santa Rita de Ibitipoca", "Santa Rita de Jacutinga", "Santa Rita de Minas", "Santa Rita do Itueto", "Santa Rita do Sapucaí", "Santa Rosa da Serra", "Santa Vitória", "Santana da Vargem", "Santana de Cataguases", "Santana de Pirapama", "Santana do Deserto", "Santana do Garambéu", "Santana do Jacaré", "Santana do Manhuaçu", "Santana do Paraíso", "Santana do Riacho", "Santana dos Montes", "Santo Antônio do Amparo", "Santo Antônio do Aventureiro", "Santo Antônio do Grama", "Santo Antônio do Itambé", "Santo Antônio do Jacinto", "Santo Antônio do Monte", "Santo Antônio do Retiro", "Santo Antônio do Rio Abaixo", "Santo Hipólito", "Santos Dumont", "São Bento Abade", "São Brás do Suaçuí", "São Domingos das Dores", "São Domingos do Prata", "São Félix de Minas", "São Francisco", "São Francisco de Paula", "São Francisco de Sales", "São Francisco do Glória", "São Geraldo", "São Geraldo da Piedade", "São Geraldo do Baixio", "São Gonçalo do Abaeté", "São Gonçalo do Pará", "São Gonçalo do Rio Abaixo", "São Gonçalo do Rio Preto", "São Gonçalo do Sapucaí", "São Gotardo", "São João Batista do Glória", "São João da Lagoa", "São João da Mata", "São João da Ponte", "São João das Missões", "São João del Rei", "São João do Manhuaçu", "São João do Manteninha", "São João do Oriente", "São João do Pacuí", "São João do Paraíso", "São João Evangelista", "São João Nepomuceno", "São Joaquim de Bicas", "São José da Barra", "São José da Lapa", "São José da Safira", "São José da Varginha", "São José do Alegre", "São José do Divino", "São José do Goiabal", "São José do Jacuri", "São José do Mantimento", "São Lourenço", "São Miguel do Anta", "São Pedro da União", "São Pedro do Suaçuí", "São Pedro dos Ferros", "São Romão", "São Roque de Minas", "São Sebastião da Bela Vista", "São Sebastião da Vargem Alegre", "São Sebastião do Anta", "São Sebastião do Maranhão", "São Sebastião do Oeste", "São Sebastião do Paraíso", "São Sebastião do Rio Preto", "São Sebastião do Rio Verde", "São Thomé das Letras", "São Tiago", "São Tomás de Aquino", "São Vicente de Minas", "Sapucaí-Mirim", "Sardoá", "Sarzedo", "Sem-Peixe", "Senador Amaral", "Senador Cortes", "Senador Firmino", "Senador José Bento", "Senador Modestino Gonçalves", "Senhora de Oliveira", "Senhora do Porto", "Senhora dos Remédios", "Sericita", "Seritinga", "Serra Azul de Minas", "Serra da Saudade", "Serra do Salitre", "Serra dos Aimorés", "Serrania", "Serranópolis de Minas", "Serranos", "Serro", "Sete Lagoas", "Setubinha", "Silveirânia", "Silvianópolis", "Simão Pereira", "Simonésia", "Sobrália", "Soledade de Minas", "Tabuleiro", "Taiobeiras", "Taparuba", "Tapira", "Tapiraí", "Taquaraçu de Minas", "Tarumirim", "Teixeiras", "Teófilo Otoni", "Timóteo", "Tiradentes", "Tiros", "Tocantins", "Tocos do Moji", "Toledo", "Tombos", "Três Corações", "Três Marias", "Três Pontas", "Tumiritinga", "Tupaciguara", "Turmalina", "Turvolândia", "Ubá", "Ubaí", "Ubaporanga", "Uberaba", "Uberlândia", "Umburatiba", "Unaí", "União de Minas", "Uruana de Minas", "Urucânia", "Urucuia", "Vargem Alegre", "Vargem Bonita", "Vargem Grande do Rio Pardo", "Varginha", "Varjão de Minas", "Várzea da Palma", "Varzelândia", "Vazante", "Verdelândia", "Veredinha", "Veríssimo", "Vermelho Novo", "Vespasiano", "Viçosa", "Vieiras", "Virgem da Lapa", "Virgínia", "Virginópolis", "Virgolândia", "Visconde do Rio Branco", "Volta Grande", "Wenceslau Braz"]
    }, {
        sigla: "MS",
        nome: "Mato Grosso do Sul",
        cidades: ["Campo Grande", "Água Clara", "Alcinópolis", "Amambaí", "Anastácio", "Anaurilândia", "Angélica", "Antônio João", "Aparecida do Taboado", "Aquidauana", "Aral Moreira", "Bandeirantes", "Bataguassu", "Bataiporã", "Bela Vista", "Bodoquena", "Bonito", "Brasilândia", "Caarapó", "Camapuã", "Caracol", "Cassilândia", "Chapadão do Sul", "Corguinho", "Coronel Sapucaia", "Corumbá", "Costa Rica", "Coxim", "Deodápolis", "Dois Irmãos do Buriti", "Douradina", "Dourados", "Eldorado", "Fátima do Sul", "Figueirão", "Glória de Dourados", "Guia Lopes da Laguna", "Iguatemi", "Inocência", "Itaporã", "Itaquiraí", "Ivinhema", "Japorã", "Jaraguari", "Jardim", "Jateí", "Juti", "Ladário", "Laguna Carapã", "Maracaju", "Miranda", "Mundo Novo", "Naviraí", "Nioaque", "Nova Alvorada do Sul", "Nova Andradina", "Novo Horizonte do Sul", "Paranaíba", "Paranhos", "Paraíso das Águas", "Pedro Gomes", "Ponta Porã", "Porto Murtinho", "Ribas do Rio Pardo", "Rio Brilhante", "Rio Negro", "Rio Verde de Mato Grosso", "Rochedo", "Santa Rita do Pardo", "São Gabriel do Oeste", "Selvíria", "Sete Quedas", "Sidrolândia", "Sonora", "Tacuru", "Taquarussu", "Terenos", "Três Lagoas", "Vicentina"]
    }, {
        sigla: "MT",
        nome: "Mato Grosso",
        cidades: ["Cuiabá", "Acorizal", "Água Boa", "Alta Floresta", "Alto Araguaia", "Alto Boa Vista", "Alto Garças", "Alto Paraguai", "Alto Taquari", "Apiacás", "Araguaiana", "Araguainha", "Araputanga", "Arenápolis", "Aripuanã", "Barão de Melgaço", "Barra do Bugres", "Barra do Garças", "Bom Jesus do Araguaia", "Brasnorte", "Cáceres", "Campinápolis", "Campo Novo do Parecis", "Campo Verde", "Campos de Júlio", "Canabrava do Norte", "Canarana", "Carlinda", "Castanheira", "Chapada dos Guimarães", "Cláudia", "Cocalinho", "Colíder", "Colniza", "Comodoro", "Confresa", "Conquista d'Oeste", "Cotriguaçu", "Curvelândia", "Denise", "Diamantino", "Dom Aquino", "Feliz Natal", "Figueirópolis d'Oeste", "Gaúcha do Norte", "General Carneiro", "Glória d'Oeste", "Guarantã do Norte", "Guiratinga", "Indiavaí", "Ipiranga do Norte", "Itanhangá", "Itaúba", "Itiquira", "Jaciara", "Jangada", "Jauru", "Juara", "Juína", "Juruena", "Juscimeira", "Lambari d'Oeste", "Lucas do Rio Verde", "Luciára", "Marcelândia", "Matupá", "Mirassol d'Oeste", "Nobres", "Nortelândia", "Nossa Senhora do Livramento", "Nova Bandeirantes", "Nova Brasilândia", "Nova Canaã do Norte", "Nova Guarita", "Nova Lacerda", "Nova Marilândia", "Nova Maringá", "Nova Monte Verde", "Nova Mutum", "Nova Nazaré", "Nova Olímpia", "Nova Santa Helena", "Nova Ubiratã", "Nova Xavantina", "Novo Horizonte do Norte", "Novo Mundo", "Novo Santo Antônio", "Novo São Joaquim", "Paranaíta", "Paranatinga", "Pedra Preta", "Peixoto de Azevedo", "Planalto da Serra", "Poconé", "Pontal do Araguaia", "Ponte Branca", "Pontes e Lacerda", "Porto Alegre do Norte", "Porto dos Gaúchos", "Porto Esperidião", "Porto Estrela", "Poxoréo", "Primavera do Leste", "Querência", "Reserva do Cabaçal", "Ribeirão Cascalheira", "Ribeirãozinho", "Rio Branco", "Rondolândia", "Rondonópolis", "Rosário Oeste", "Salto do Céu", "Santa Carmem", "Santa Cruz do Xingu", "Santa Rita do Trivelato", "Santa Terezinha", "Santo Afonso", "Santo Antônio do Leste", "Santo Antônio do Leverger", "São Félix do Araguaia", "São José do Povo", "São José do Rio Claro", "São José do Xingu", "São José dos Quatro Marcos", "São Pedro da Cipa", "Sapezal", "Serra Nova Dourada", "Sinop", "Sorriso", "Tabaporã", "Tangará da Serra", "Tapurah", "Terra Nova do Norte", "Tesouro", "Torixoréu", "União do Sul", "Vale de São Domingos", "Várzea Grande", "Vera", "Vila Bela da Santíssima Trindade", "Vila Rica"]
    }, {
        sigla: "PA",
        nome: "Pará",
        cidades: ["Belém", "Abaetetuba", "Abel Figueiredo", "Acará", "Afuá", "Água Azul do Norte", "Alenquer", "Almeirim", "Altamira", "Anajás", "Ananindeua", "Anapu", "Augusto Corrêa", "Aurora do Pará", "Aveiro", "Bagre", "Baião", "Bannach", "Barcarena", "Belterra", "Benevides", "Bom Jesus do Tocantins", "Bonito", "Bragança", "Brasil Novo", "Brejo Grande do Araguaia", "Breu Branco", "Breves", "Bujaru", "Cachoeira do Arari", "Cachoeira do Piriá", "Cametá", "Canaã dos Carajás", "Capanema", "Capitão Poço", "Castanhal", "Chaves", "Colares", "Conceição do Araguaia", "Concórdia do Pará", "Cumaru do Norte", "Curionópolis", "Curralinho", "Curuá", "Curuçá", "Dom Eliseu", "Eldorado dos Carajás", "Faro", "Floresta do Araguaia", "Garrafão do Norte", "Goianésia do Pará", "Gurupá", "Igarapé-Açu", "Igarapé-Miri", "Inhangapi", "Ipixuna do Pará", "Irituia", "Itaituba", "Itupiranga", "Jacareacanga", "Jacundá", "Juruti", "Limoeiro do Ajuru", "Mãe do Rio", "Magalhães Barata", "Marabá", "Maracanã", "Marapanim", "Marituba", "Medicilândia", "Melgaço", "Mocajuba", "Moju", "Mojuí dos Campos", "Monte Alegre", "Muaná", "Nova Esperança do Piriá", "Nova Ipixuna", "Nova Timboteua", "Novo Progresso", "Novo Repartimento", "Óbidos", "Oeiras do Pará", "Oriximiná", "Ourém", "Ourilândia do Norte", "Pacajá", "Palestina do Pará", "Paragominas", "Parauapebas", "Pau d'Arco", "Peixe-Boi", "Piçarra", "Placas", "Ponta de Pedras", "Portel", "Porto de Moz", "Prainha", "Primavera", "Quatipuru", "Redenção", "Rio Maria", "Rondon do Pará", "Rurópolis", "Salinópolis", "Salvaterra", "Santa Bárbara do Pará", "Santa Cruz do Arari", "Santa Isabel do Pará", "Santa Luzia do Pará", "Santa Maria das Barreiras", "Santa Maria do Pará", "Santana do Araguaia", "Santarém", "Santarém Novo", "Santo Antônio do Tauá", "São Caetano de Odivelas", "São Domingos do Araguaia", "São Domingos do Capim", "São Félix do Xingu", "São Francisco do Pará", "São Geraldo do Araguaia", "São João da Ponta", "São João de Pirabas", "São João do Araguaia", "São Miguel do Guamá", "São Sebastião da Boa Vista", "Sapucaia", "Senador José Porfírio", "Soure", "Tailândia", "Terra Alta", "Terra Santa", "Tomé-Açu", "Tracuateua", "Trairão", "Tucumã", "Tucuruí", "Ulianópolis", "Uruará", "Vigia", "Viseu", "Vitória do Xingu", "Xinguara"]
    }, {
        sigla: "PB",
        nome: "Paraíba",
        cidades: ["João Pessoa", "Água Branca", "Aguiar", "Alagoa Grande", "Alagoa Nova", "Alagoinha", "Alcantil", "Algodão de Jandaíra", "Alhandra", "Amparo", "Aparecida", "Araçagi", "Arara", "Araruna", "Areia", "Areia de Baraúnas", "Areial", "Aroeiras", "Assunção", "Baía da Traição", "Bananeiras", "Baraúna", "Barra de Santa Rosa", "Barra de Santana", "Barra de São Miguel", "Bayeux", "Belém", "Belém do Brejo do Cruz", "Bernardino Batista", "Boa Ventura", "Boa Vista", "Bom Jesus", "Bom Sucesso", "Bonito de Santa Fé", "Boqueirão", "Borborema", "Brejo do Cruz", "Brejo dos Santos", "Caaporã", "Cabaceiras", "Cabedelo", "Cachoeira dos Índios", "Cacimba de Areia", "Cacimba de Dentro", "Cacimbas", "Caiçara", "Cajazeiras", "Cajazeirinhas", "Caldas Brandão", "Camalaú", "Campina Grande", "Capim", "Caraúbas", "Carrapateira", "Casserengue", "Catingueira", "Catolé do Rocha", "Caturité", "Conceição", "Condado", "Conde", "Congo", "Coremas", "Coxixola", "Cruz do Espírito Santo", "Cubati", "Cuité", "Cuité de Mamanguape", "Cuitegi", "Curral de Cima", "Curral Velho", "Damião", "Desterro", "Diamante", "Dona Inês", "Duas Estradas", "Emas", "Esperança", "Fagundes", "Frei Martinho", "Gado Bravo", "Guarabira", "Gurinhém", "Gurjão", "Ibiara", "Igaracy", "Imaculada", "Ingá", "Itabaiana", "Itaporanga", "Itapororoca", "Itatuba", "Jacaraú", "Jericó", "Joca Claudino", "Juarez Távora", "Juazeirinho", "Junco do Seridó", "Juripiranga", "Juru", "Lagoa", "Lagoa de Dentro", "Lagoa Seca", "Lastro", "Livramento", "Logradouro", "Lucena", "Mãe d'Água", "Malta", "Mamanguape", "Manaíra", "Marcação", "Mari", "Marizópolis", "Massaranduba", "Mataraca", "Matinhas", "Mato Grosso", "Maturéia", "Mogeiro", "Montadas", "Monte Horebe", "Monteiro", "Mulungu", "Natuba", "Nazarezinho", "Nova Floresta", "Nova Olinda", "Nova Palmeira", "Olho d'Água", "Olivedos", "Ouro Velho", "Parari", "Passagem", "Patos", "Paulista", "Pedra Branca", "Pedra Lavrada", "Pedras de Fogo", "Pedro Régis", "Piancó", "Picuí", "Pilar", "Pilões", "Pilõezinhos", "Pirpirituba", "Pitimbu", "Pocinhos", "Poço Dantas", "Poço de José de Moura", "Pombal", "Prata", "Princesa Isabel", "Puxinanã", "Queimadas", "Quixabá", "Remígio", "Riachão", "Riachão do Bacamarte", "Riachão do Poço", "Riacho de Santo Antônio", "Riacho dos Cavalos", "Rio Tinto", "Salgadinho", "Salgado de São Félix", "Santa Cecília", "Santa Cruz", "Santa Helena", "Santa Inês", "Santa Luzia", "Santa Rita", "Santa Teresinha", "Santana de Mangueira", "Santana dos Garrotes", "Santo André", "São Bentinho", "São Bento", "São Domingos", "São Domingos do Cariri", "São Francisco", "São João do Cariri", "São João do Rio do Peixe", "São João do Tigre", "São José da Lagoa Tapada", "São José de Caiana", "São José de Espinharas", "São José de Piranhas", "São José de Princesa", "São José do Bonfim", "São José do Brejo do Cruz", "São José do Sabugi", "São José dos Cordeiros", "São José dos Ramos", "São Mamede", "São Miguel de Taipu", "São Sebastião de Lagoa de Roça", "São Sebastião do Umbuzeiro", "Sapé", "Seridó", "Serra Branca", "Serra da Raiz", "Serra Grande", "Serra Redonda", "Serraria", "Sertãozinho", "Sobrado", "Solânea", "Soledade", "Sossêgo", "Sousa", "Sumé", "Tacima", "Taperoá", "Tavares", "Teixeira", "Tenório", "Triunfo", "Uiraúna", "Umbuzeiro", "Várzea", "Vieirópolis", "Vista Serrana", "Zabelê"]
    }, {
        sigla: "PE",
        nome: "Pernambuco",
        cidades: ["Recife", "Abreu e Lima", "Afogados da Ingazeira", "Afrânio", "Agrestina", "Água Preta", "Águas Belas", "Alagoinha", "Aliança", "Altinho", "Amaraji", "Angelim", "Araçoiaba", "Araripina", "Arcoverde", "Barra de Guabiraba", "Barreiros", "Belém de Maria", "Belém de São Francisco", "Belo Jardim", "Betânia", "Bezerros", "Bodocó", "Bom Conselho", "Bom Jardim", "Bonito", "Brejão", "Brejinho", "Brejo da Madre de Deus", "Buenos Aires", "Buíque", "Cabo de Santo Agostinho", "Cabrobó", "Cachoeirinha", "Caetés", "Calçado", "Calumbi", "Camaragibe", "Camocim de São Félix", "Camutanga", "Canhotinho", "Capoeiras", "Carnaíba", "Carnaubeira da Penha", "Carpina", "Caruaru", "Casinhas", "Catende", "Cedro", "Chã de Alegria", "Chã Grande", "Condado", "Correntes", "Cortês", "Cumaru", "Cupira", "Custódia", "Dormentes", "Escada", "Exu", "Feira Nova", "Fernando de Noronha", "Ferreiros", "Flores", "Floresta", "Frei Miguelinho", "Gameleira", "Garanhuns", "Glória do Goitá", "Goiana", "Granito", "Gravatá", "Iati", "Ibimirim", "Ibirajuba", "Igarassu", "Iguaraci", "Inajá", "Ingazeira", "Ipojuca", "Ipubi", "Itacuruba", "Itaíba", "Itamaracá", "Itambé", "Itapetim", "Itapissuma", "Itaquitinga", "Jaboatão dos Guararapes", "Jaqueira", "Jataúba", "Jatobá", "João Alfredo", "Joaquim Nabuco", "Jucati", "Jupi", "Jurema", "Lagoa do Carro", "Lagoa do Itaenga", "Lagoa do Ouro", "Lagoa dos Gatos", "Lagoa Grande", "Lajedo", "Limoeiro", "Macaparana", "Machados", "Manari", "Maraial", "Mirandiba", "Moreilândia", "Moreno", "Nazaré da Mata", "Olinda", "Orobó", "Orocó", "Ouricuri", "Palmares", "Palmeirina", "Panelas", "Paranatama", "Parnamirim", "Passira", "Paudalho", "Paulista", "Pedra", "Pesqueira", "Petrolândia", "Petrolina", "Poção", "Pombos", "Primavera", "Quipapá", "Quixaba", "Riacho das Almas", "Ribeirão", "Rio Formoso", "Sairé", "Salgadinho", "Salgueiro", "Saloá", "Sanharó", "Santa Cruz", "Santa Cruz da Baixa Verde", "Santa Cruz do Capibaribe", "Santa Filomena", "Santa Maria da Boa Vista", "Santa Maria do Cambucá", "Santa Terezinha", "São Benedito do Sul", "São Bento do Una", "São Caitano", "São João", "São Joaquim do Monte", "São José da Coroa Grande", "São José do Belmonte", "São José do Egito", "São Lourenço da Mata", "São Vicente Ferrer", "Serra Talhada", "Serrita", "Sertânia", "Sirinhaém", "Solidão", "Surubim", "Tabira", "Tacaimbó", "Tacaratu", "Tamandaré", "Taquaritinga do Norte", "Terezinha", "Terra Nova", "Timbaúba", "Toritama", "Tracunhaém", "Trindade", "Triunfo", "Tupanatinga", "Tuparetama", "Venturosa", "Verdejante", "Vertente do Lério", "Vertentes", "Vicência", "Vitória de Santo Antão", "Xexéu"]
    }, {
        sigla: "PI",
        nome: "Piauí",
        cidades: ["Teresina", "Acauã", "Agricolândia", "Água Branca", "Alagoinha do Piauí", "Alegrete do Piauí", "Alto Longá", "Altos", "Alvorada do Gurguéia", "Amarante", "Angical do Piauí", "Anísio de Abreu", "Antônio Almeida", "Aroazes", "Aroeiras do Itaim", "Arraial", "Assunção do Piauí", "Avelino Lopes", "Baixa Grande do Ribeiro", "Barra d'Alcântara", "Barras", "Barreiras do Piauí", "Barro Duro", "Batalha", "Bela Vista do Piauí", "Belém do Piauí", "Beneditinos", "Bertolínia", "Betânia do Piauí", "Boa Hora", "Bocaina", "Bom Jesus", "Bom Princípio do Piauí", "Bonfim do Piauí", "Boqueirão do Piauí", "Brasileira", "Brejo do Piauí", "Buriti dos Lopes", "Buriti dos Montes", "Cabeceiras do Piauí", "Cajazeiras do Piauí", "Cajueiro da Praia", "Caldeirão Grande do Piauí", "Campinas do Piauí", "Campo Alegre do Fidalgo", "Campo Grande do Piauí", "Campo Largo do Piauí", "Campo Maior", "Canavieira", "Canto do Buriti", "Capitão de Campos", "Capitão Gervásio Oliveira", "Caracol", "Caraúbas do Piauí", "Caridade do Piauí", "Castelo do Piauí", "Caxingó", "Cocal", "Cocal de Telha", "Cocal dos Alves", "Coivaras", "Colônia do Gurguéia", "Colônia do Piauí", "Conceição do Canindé", "Coronel José Dias", "Corrente", "Cristalândia do Piauí", "Cristino Castro", "Curimatá", "Currais", "Curral Novo do Piauí", "Curralinhos", "Demerval Lobão", "Dirceu Arcoverde", "Dom Expedito Lopes", "Dom Inocêncio", "Domingos Mourão", "Elesbão Veloso", "Eliseu Martins", "Esperantina", "Fartura do Piauí", "Flores do Piauí", "Floresta do Piauí", "Floriano", "Francinópolis", "Francisco Ayres", "Francisco Macedo", "Francisco Santos", "Fronteiras", "Geminiano", "Gilbués", "Guadalupe", "Guaribas", "Hugo Napoleão", "Ilha Grande", "Inhuma", "Ipiranga do Piauí", "Isaías Coelho", "Itainópolis", "Itaueira", "Jacobina do Piauí", "Jaicós", "Jardim do Mulato", "Jatobá do Piauí", "Jerumenha", "João Costa", "Joaquim Pires", "Joca Marques", "José de Freitas", "Juazeiro do Piauí", "Júlio Borges", "Jurema", "Lagoa Alegre", "Lagoa de São Francisco", "Lagoa do Barro do Piauí", "Lagoa do Piauí", "Lagoa do Sítio", "Lagoinha do Piauí", "Landri Sales", "Luís Correia", "Luzilândia", "Madeiro", "Manoel Emídio", "Marcolândia", "Marcos Parente", "Massapê do Piauí", "Matias Olímpio", "Miguel Alves", "Miguel Leão", "Milton Brandão", "Monsenhor Gil", "Monsenhor Hipólito", "Monte Alegre do Piauí", "Morro Cabeça no Tempo", "Morro do Chapéu do Piauí", "Murici dos Portelas", "Nazaré do Piauí", "Nazária", "Nossa Senhora de Nazaré", "Nossa Senhora dos Remédios", "Nova Santa Rita", "Novo Oriente do Piauí", "Novo Santo Antônio", "Oeiras", "Olho d'Água do Piauí", "Padre Marcos", "Paes Landim", "Pajeú do Piauí", "Palmeira do Piauí", "Palmeirais", "Paquetá", "Parnaguá", "Parnaíba", "Passagem Franca do Piauí", "Patos do Piauí", "Pau d'Arco do Piauí", "Paulistana", "Pavussu", "Pedro II", "Pedro Laurentino", "Picos", "Pimenteiras", "Pio IX", "Piracuruca", "Piripiri", "Porto", "Porto Alegre do Piauí", "Prata do Piauí", "Queimada Nova", "Redenção do Gurguéia", "Regeneração", "Riacho Frio", "Ribeira do Piauí", "Ribeiro Gonçalves", "Rio Grande do Piauí", "Santa Cruz do Piauí", "Santa Cruz dos Milagres", "Santa Filomena", "Santa Luz", "Santa Rosa do Piauí", "Santana do Piauí", "Santo Antônio de Lisboa", "Santo Antônio dos Milagres", "Santo Inácio do Piauí", "São Braz do Piauí", "São Félix do Piauí", "São Francisco de Assis do Piauí", "São Francisco do Piauí", "São Gonçalo do Gurguéia", "São Gonçalo do Piauí", "São João da Canabrava", "São João da Fronteira", "São João da Serra", "São João da Varjota", "São João do Arraial", "São João do Piauí", "São José do Divino", "São José do Peixe", "São José do Piauí", "São Julião", "São Lourenço do Piauí", "São Luis do Piauí", "São Miguel da Baixa Grande", "São Miguel do Fidalgo", "São Miguel do Tapuio", "São Pedro do Piauí", "São Raimundo Nonato", "Sebastião Barros", "Sebastião Leal", "Sigefredo Pacheco", "Simões", "Simplício Mendes", "Socorro do Piauí", "Sussuapara", "Tamboril do Piauí", "Tanque do Piauí", "União", "Uruçuí", "Valença do Piauí", "Várzea Branca", "Várzea Grande", "Vera Mendes", "Vila Nova do Piauí", "Wall Ferraz"]
    }, {
        sigla: "PR",
        nome: "Paraná",
        cidades: ["Curitiba", "Abatiá", "Adrianópolis", "Agudos do Sul", "Almirante Tamandaré", "Altamira do Paraná", "Alto Paraíso", "Alto Paraná", "Alto Piquiri", "Altônia", "Alvorada do Sul", "Amaporã", "Ampére", "Anahy", "Andirá", "Ângulo", "Antonina", "Antônio Olinto", "Apucarana", "Arapongas", "Arapoti", "Arapuã", "Araruna", "Araucária", "Ariranha do Ivaí", "Assaí", "Assis Chateaubriand", "Astorga", "Atalaia", "Balsa Nova", "Bandeirantes", "Barbosa Ferraz", "Barra do Jacaré", "Barracão", "Bela Vista da Caroba", "Bela Vista do Paraíso", "Bituruna", "Boa Esperança", "Boa Esperança do Iguaçu", "Boa Ventura de São Roque", "Boa Vista da Aparecida", "Bocaiúva do Sul", "Bom Jesus do Sul", "Bom Sucesso", "Bom Sucesso do Sul", "Borrazópolis", "Braganey", "Brasilândia do Sul", "Cafeara", "Cafelândia", "Cafezal do Sul", "Califórnia", "Cambará", "Cambé", "Cambira", "Campina da Lagoa", "Campina do Simão", "Campina Grande do Sul", "Campo Bonito", "Campo do Tenente", "Campo Largo", "Campo Magro", "Campo Mourão", "Cândido de Abreu", "Candói", "Cantagalo", "Capanema", "Capitão Leônidas Marques", "Carambeí", "Carlópolis", "Cascavel", "Castro", "Catanduvas", "Centenário do Sul", "Cerro Azul", "Céu Azul", "Chopinzinho", "Cianorte", "Cidade Gaúcha", "Clevelândia", "Colombo", "Colorado", "Congonhinhas", "Conselheiro Mairinck", "Contenda", "Corbélia", "Cornélio Procópio", "Coronel Domingos Soares", "Coronel Vivida", "Corumbataí do Sul", "Cruz Machado", "Cruzeiro do Iguaçu", "Cruzeiro do Oeste", "Cruzeiro do Sul", "Cruzmaltina", "Curiúva", "Diamante d'Oeste", "Diamante do Norte", "Diamante do Sul", "Dois Vizinhos", "Douradina", "Doutor Camargo", "Doutor Ulysses", "Enéas Marques", "Engenheiro Beltrão", "Entre Rios do Oeste", "Esperança Nova", "Espigão Alto do Iguaçu", "Farol", "Faxinal", "Fazenda Rio Grande", "Fênix", "Fernandes Pinheiro", "Figueira", "Flor da Serra do Sul", "Floraí", "Floresta", "Florestópolis", "Flórida", "Formosa do Oeste", "Foz do Iguaçu", "Foz do Jordão", "Francisco Alves", "Francisco Beltrão", "General Carneiro", "Godoy Moreira", "Goioerê", "Goioxim", "Grandes Rios", "Guaíra", "Guairaçá", "Guamiranga", "Guapirama", "Guaporema", "Guaraci", "Guaraniaçu", "Guarapuava", "Guaraqueçaba", "Guaratuba", "Honório Serpa", "Ibaiti", "Ibema", "Ibiporã", "Icaraíma", "Iguaraçu", "Iguatu", "Imbaú", "Imbituva", "Inácio Martins", "Inajá", "Indianópolis", "Ipiranga", "Iporã", "Iracema do Oeste", "Irati", "Iretama", "Itaguajé", "Itaipulândia", "Itambaracá", "Itambé", "Itapejara d'Oeste", "Itaperuçu", "Itaúna do Sul", "Ivaí", "Ivaiporã", "Ivaté", "Ivatuba", "Jaboti", "Jacarezinho", "Jaguapitã", "Jaguariaíva", "Jandaia do Sul", "Janiópolis", "Japira", "Japurá", "Jardim Alegre", "Jardim Olinda", "Jataizinho", "Jesuítas", "Joaquim Távora", "Jundiaí do Sul", "Juranda", "Jussara", "Kaloré", "Lapa", "Laranjal", "Laranjeiras do Sul", "Leópolis", "Lidianópolis", "Lindoeste", "Loanda", "Lobato", "Londrina", "Luiziana", "Lunardelli", "Lupionópolis", "Mallet", "Mamborê", "Mandaguaçu", "Mandaguari", "Mandirituba", "Manfrinópolis", "Mangueirinha", "Manoel Ribas", "Marechal Cândido Rondon", "Maria Helena", "Marialva", "Marilândia do Sul", "Marilena", "Mariluz", "Maringá", "Mariópolis", "Maripá", "Marmeleiro", "Marquinho", "Marumbi", "Matelândia", "Matinhos", "Mato Rico", "Mauá da Serra", "Medianeira", "Mercedes", "Mirador", "Miraselva", "Missal", "Moreira Sales", "Morretes", "Munhoz de Melo", "Nossa Senhora das Graças", "Nova Aliança do Ivaí", "Nova América da Colina", "Nova Aurora", "Nova Cantu", "Nova Esperança", "Nova Esperança do Sudoeste", "Nova Fátima", "Nova Laranjeiras", "Nova Londrina", "Nova Olímpia", "Nova Prata do Iguaçu", "Nova Santa Bárbara", "Nova Santa Rosa", "Nova Tebas", "Novo Itacolomi", "Ortigueira", "Ourizona", "Ouro Verde do Oeste", "Paiçandu", "Palmas", "Palmeira", "Palmital", "Palotina", "Paraíso do Norte", "Paranacity", "Paranaguá", "Paranapoema", "Paranavaí", "Pato Bragado", "Pato Branco", "Paula Freitas", "Paulo Frontin", "Peabiru", "Perobal", "Pérola", "Pérola d'Oeste", "Piên", "Pinhais", "Pinhal de São Bento", "Pinhalão", "Pinhão", "Piraí do Sul", "Piraquara", "Pitanga", "Pitangueiras", "Planaltina do Paraná", "Planalto", "Ponta Grossa", "Pontal do Paraná", "Porecatu", "Porto Amazonas", "Porto Barreiro", "Porto Rico", "Porto Vitória", "Prado Ferreira", "Pranchita", "Presidente Castelo Branco", "Primeiro de Maio", "Prudentópolis", "Quarto Centenário", "Quatiguá", "Quatro Barras", "Quatro Pontes", "Quedas do Iguaçu", "Querência do Norte", "Quinta do Sol", "Quitandinha", "Ramilândia", "Rancho Alegre", "Rancho Alegre d'Oeste", "Realeza", "Rebouças", "Renascença", "Reserva", "Reserva do Iguaçu", "Ribeirão Claro", "Ribeirão do Pinhal", "Rio Azul", "Rio Bom", "Rio Bonito do Iguaçu", "Rio Branco do Ivaí", "Rio Branco do Sul", "Rio Negro", "Rolândia", "Roncador", "Rondon", "Rosário do Ivaí", "Sabáudia", "Salgado Filho", "Salto do Itararé", "Salto do Lontra", "Santa Amélia", "Santa Cecília do Pavão", "Santa Cruz de Monte Castelo", "Santa Fé", "Santa Helena", "Santa Inês", "Santa Isabel do Ivaí", "Santa Izabel do Oeste", "Santa Lúcia", "Santa Maria do Oeste", "Santa Mariana", "Santa Mônica", "Santa Tereza do Oeste", "Santa Terezinha de Itaipu", "Santana do Itararé", "Santo Antônio da Platina", "Santo Antônio do Caiuá", "Santo Antônio do Paraíso", "Santo Antônio do Sudoeste", "Santo Inácio", "São Carlos do Ivaí", "São Jerônimo da Serra", "São João", "São João do Caiuá", "São João do Ivaí", "São João do Triunfo", "São Jorge d'Oeste", "São Jorge do Ivaí", "São Jorge do Patrocínio", "São José da Boa Vista", "São José das Palmeiras", "São José dos Pinhais", "São Manoel do Paraná", "São Mateus do Sul", "São Miguel do Iguaçu", "São Pedro do Iguaçu", "São Pedro do Ivaí", "São Pedro do Paraná", "São Sebastião da Amoreira", "São Tomé", "Sapopema", "Sarandi", "Saudade do Iguaçu", "Sengés", "Serranópolis do Iguaçu", "Sertaneja", "Sertanópolis", "Siqueira Campos", "Sulina", "Tamarana", "Tamboara", "Tapejara", "Tapira", "Teixeira Soares", "Telêmaco Borba", "Terra Boa", "Terra Rica", "Terra Roxa", "Tibagi", "Tijucas do Sul", "Toledo", "Tomazina", "Três Barras do Paraná", "Tunas do Paraná", "Tuneiras do Oeste", "Tupãssi", "Turvo", "Ubiratã", "Umuarama", "União da Vitória", "Uniflor", "Uraí", "Ventania", "Vera Cruz do Oeste", "Verê", "Vila Alta", "Virmond", "Vitorino", "Wenceslau Braz", "Xambrê"]
    }, {
        sigla: "RJ",
        nome: "Rio de Janeiro",
        cidades: ["Rio de Janeiro", "Angra dos Reis", "Aperibé", "Araruama", "Areal", "Armação dos Búzios", "Arraial do Cabo", "Barra do Piraí", "Barra Mansa", "Belford Roxo", "Bom Jardim", "Bom Jesus do Itabapoana", "Cabo Frio", "Cachoeiras de Macacu", "Cambuci", "Campos dos Goytacazes", "Cantagalo", "Carapebus", "Cardoso Moreira", "Carmo", "Casimiro de Abreu", "Comendador Levy Gasparian", "Conceição de Macabu", "Cordeiro", "Duas Barras", "Duque de Caxias", "Engenheiro Paulo de Frontin", "Guapimirim", "Iguaba Grande", "Itaboraí", "Itaguaí", "Italva", "Itaocara", "Itaperuna", "Itatiaia", "Japeri", "Laje do Muriaé", "Macaé", "Macuco", "Magé", "Mangaratiba", "Maricá", "Mendes", "Mesquita", "Miguel Pereira", "Miracema", "Natividade", "Nilópolis", "Niterói", "Nova Friburgo", "Nova Iguaçu", "Paracambi", "Paraíba do Sul", "Parati", "Paty do Alferes", "Petrópolis", "Pinheiral", "Piraí", "Porciúncula", "Porto Real", "Quatis", "Queimados", "Quissamã", "Resende", "Rio Bonito", "Rio Claro", "Rio das Flores", "Rio das Ostras", "Santa Maria Madalena", "Santo Antônio de Pádua", "São Fidélis", "São Francisco de Itabapoana", "São Gonçalo", "São João da Barra", "São João de Meriti", "São José de Ubá", "São José do Vale do Rio Preto", "São Pedro da Aldeia", "São Sebastião do Alto", "Sapucaia", "Saquarema", "Seropédica", "Silva Jardim", "Sumidouro", "Tanguá", "Teresópolis", "Trajano de Moraes", "Três Rios", "Valença", "Varre-Sai", "Vassouras", "Volta Redonda"]
    }, {
        sigla: "RN",
        nome: "Rio Grande do Norte",
        cidades: ["Natal", "Acari", "Açu", "Afonso Bezerra", "Água Nova", "Alexandria", "Almino Afonso", "Alto do Rodrigues", "Angicos", "Antônio Martins", "Apodi", "Areia Branca", "Arês", "Augusto Severo", "Baía Formosa", "Baraúna", "Barcelona", "Bento Fernandes", "Bodó", "Bom Jesus", "Brejinho", "Caiçara do Norte", "Caiçara do Rio do Vento", "Caicó", "Campo Redondo", "Campo Grande", "Canguaretama", "Caraúbas", "Carnaúba dos Dantas", "Carnaubais", "Ceará-Mirim", "Cerro Corá", "Coronel Ezequiel", "Coronel João Pessoa", "Cruzeta", "Currais Novos", "Doutor Severiano", "Encanto", "Equador", "Espírito Santo", "Extremoz", "Felipe Guerra", "Fernando Pedroza", "Florânia", "Francisco Dantas", "Frutuoso Gomes", "Galinhos", "Goianinha", "Governador Dix-Sept Rosado", "Grossos", "Guamaré", "Ielmo Marinho", "Ipanguaçu", "Ipueira", "Itajá", "Itaú", "Jaçanã", "Jandaíra", "Janduís", "Januário Cicco", "Japi", "Jardim de Angicos", "Jardim de Piranhas", "Jardim do Seridó", "João Câmara", "João Dias", "José da Penha", "Jucurutu", "Jundiá", "Lagoa d'Anta", "Lagoa de Pedras", "Lagoa de Velhos", "Lagoa Nova", "Lagoa Salgada", "Lajes", "Lajes Pintadas", "Lucrécia", "Luís Gomes", "Macaíba", "Macau", "Major Sales", "Marcelino Vieira", "Martins", "Maxaranguape", "Messias Targino", "Montanhas", "Monte Alegre", "Monte das Gameleiras", "Mossoró", "Nísia Floresta", "Nova Cruz", "Olho-d'Água do Borges", "Ouro Branco", "Paraná", "Paraú", "Parazinho", "Parelhas", "Parnamirim", "Passa e Fica", "Passagem", "Patu", "Pau dos Ferros", "Pedra Grande", "Pedra Preta", "Pedro Avelino", "Pedro Velho", "Pendências", "Pilões", "Poço Branco", "Portalegre", "Porto do Mangue", "Presidente Juscelino", "Pureza", "Rafael Fernandes", "Rafael Godeiro", "Riacho da Cruz", "Riacho de Santana", "Riachuelo", "Rio do Fogo", "Rodolfo Fernandes", "Ruy Barbosa", "Santa Cruz", "Santa Maria", "Santana do Matos", "Santana do Seridó", "Santo Antônio", "São Bento do Norte", "São Bento do Trairí", "São Fernando", "São Francisco do Oeste", "São Gonçalo do Amarante", "São João do Sabugi", "São José de Mipibu", "São José do Campestre", "São José do Seridó", "São Miguel", "São Miguel do Gostoso", "São Paulo do Potengi", "São Pedro", "São Rafael", "São Tomé", "São Vicente", "Senador Elói de Souza", "Senador Georgino Avelino", "Serra de São Bento", "Serra do Mel", "Serra Negra do Norte", "Serrinha", "Serrinha dos Pintos", "Severiano Melo", "Sítio Novo", "Taboleiro Grande", "Taipu", "Tangará", "Tenente Ananias", "Tenente Laurentino Cruz", "Tibau", "Tibau do Sul", "Timbaúba dos Batistas", "Touros", "Triunfo Potiguar", "Umarizal", "Upanema", "Várzea", "Venha-Ver", "Vera Cruz", "Viçosa", "Vila Flor"]
    }, {
        sigla: "RO",
        nome: "Rondônia",
        cidades: ["Porto Velho", "Alta Floresta d'Oeste", "Alto Alegre dos Parecis", "Alto Paraíso", "Alvorada d'Oeste", "Ariquemes", "Buritis", "Cabixi", "Cacaulândia", "Cacoal", "Campo Novo de Rondônia", "Candeias do Jamari", "Castanheiras", "Cerejeiras", "Chupinguaia", "Colorado do Oeste", "Corumbiara", "Costa Marques", "Cujubim", "Espigão d'Oeste", "Governador Jorge Teixeira", "Guajará-Mirim", "Itapuã do Oeste", "Jaru", "Ji-Paraná", "Machadinho d'Oeste", "Ministro Andreazza", "Mirante da Serra", "Monte Negro", "Nova Brasilândia d'Oeste", "Nova Mamoré", "Nova União", "Novo Horizonte do Oeste", "Ouro Preto do Oeste", "Parecis", "Pimenta Bueno", "Pimenteiras do Oeste", "Presidente Médici", "Primavera de Rondônia", "Rio Crespo", "Rolim de Moura", "Santa Luzia d'Oeste", "São Felipe d'Oeste", "São Francisco do Guaporé", "São Miguel do Guaporé", "Seringueiras", "Teixeirópolis", "Theobroma", "Urupá", "Vale do Anari", "Vale do Paraíso", "Vilhena"]
    }, {
        sigla: "RR",
        nome: "Roraima",
        cidades: ["Boa Vista", "Alto Alegre", "Amajari", "Bonfim", "Cantá", "Caracaraí", "Caroebe", "Iracema", "Mucajaí", "Normandia", "Pacaraima", "Rorainópolis", "São João da Baliza", "São Luiz", "Uiramutã"]
    }, {
        sigla: "RS",
        nome: "Rio Grande do Sul",
        cidades: ["Porto Alegre", "Aceguá", "Água Santa", "Agudo", "Ajuricaba", "Alecrim", "Alegrete", "Alegria", "Almirante Tamandaré do Sul", "Alpestre", "Alto Alegre", "Alto Feliz", "Alvorada", "Amaral Ferrador", "Ametista do Sul", "André da Rocha", "Anta Gorda", "Antônio Prado", "Arambaré", "Araricá", "Aratiba", "Arroio do Meio", "Arroio do Padre", "Arroio do Sal", "Arroio do Tigre", "Arroio dos Ratos", "Arroio Grande", "Arvorezinha", "Augusto Pestana", "Áurea", "Bagé", "Balneário Pinhal", "Barão", "Barão de Cotegipe", "Barão do Triunfo", "Barra do Guarita", "Barra do Quaraí", "Barra do Ribeiro", "Barra do Rio Azul", "Barra Funda", "Barracão", "Barros Cassal", "Benjamin Constant do Sul", "Bento Gonçalves", "Boa Vista das Missões", "Boa Vista do Buricá", "Boa Vista do Cadeado", "Boa Vista do Incra", "Boa Vista do Sul", "Bom Jesus", "Bom Princípio", "Bom Progresso", "Bom Retiro do Sul", "Boqueirão do Leão", "Bossoroca", "Bozano", "Braga", "Brochier", "Butiá", "Caçapava do Sul", "Cacequi", "Cachoeira do Sul", "Cachoeirinha", "Cacique Doble", "Caibaté", "Caiçara", "Camaquã", "Camargo", "Cambará do Sul", "Campestre da Serra", "Campina das Missões", "Campinas do Sul", "Campo Bom", "Campo Novo", "Campos Borges", "Candelária", "Cândido Godói", "Candiota", "Canela", "Canguçu", "Canoas", "Canudos do Vale", "Capão Bonito do Sul", "Capão da Canoa", "Capão do Cipó", "Capão do Leão", "Capela de Santana", "Capitão", "Capivari do Sul", "Caraá", "Carazinho", "Carlos Barbosa", "Carlos Gomes", "Casca", "Caseiros", "Catuípe", "Caxias do Sul", "Centenário", "Cerrito", "Cerro Branco", "Cerro Grande", "Cerro Grande do Sul", "Cerro Largo", "Chapada", "Charqueadas", "Charrua", "Chiapetta", "Chuí", "Chuvisca", "Cidreira", "Ciríaco", "Colinas", "Colorado", "Condor", "Constantina", "Coqueiro Baixo", "Coqueiros do Sul", "Coronel Barros", "Coronel Bicaco", "Coronel Pilar", "Cotiporã", "Coxilha", "Crissiumal", "Cristal", "Cristal do Sul", "Cruz Alta", "Cruzaltense", "Cruzeiro do Sul", "David Canabarro", "Derrubadas", "Dezesseis de Novembro", "Dilermando de Aguiar", "Dois Irmãos", "Dois Irmãos das Missões", "Dois Lajeados", "Dom Feliciano", "Dom Pedrito", "Dom Pedro de Alcântara", "Dona Francisca", "Doutor Maurício Cardoso", "Doutor Ricardo", "Eldorado do Sul", "Encantado", "Encruzilhada do Sul", "Engenho Velho", "Entre Rios do Sul", "Entre-Ijuís", "Erebango", "Erechim", "Ernestina", "Erval Grande", "Erval Seco", "Esmeralda", "Esperança do Sul", "Espumoso", "Estação", "Estância Velha", "Esteio", "Estrela", "Estrela Velha", "Eugênio de Castro", "Fagundes Varela", "Farroupilha", "Faxinal do Soturno", "Faxinalzinho", "Fazenda Vilanova", "Feliz", "Flores da Cunha", "Floriano Peixoto", "Fontoura Xavier", "Formigueiro", "Forquetinha", "Fortaleza dos Valos", "Frederico Westphalen", "Garibaldi", "Garruchos", "Gaurama", "General Câmara", "Gentil", "Getúlio Vargas", "Giruá", "Glorinha", "Gramado", "Gramado dos Loureiros", "Gramado Xavier", "Gravataí", "Guabiju", "Guaíba", "Guaporé", "Guarani das Missões", "Harmonia", "Herval", "Herveiras", "Horizontina", "Hulha Negra", "Humaitá", "Ibarama", "Ibiaçá", "Ibiraiaras", "Ibirapuitã", "Ibirubá", "Igrejinha", "Ijuí", "Ilópolis", "Imbé", "Imigrante", "Independência", "Inhacorá", "Ipê", "Ipiranga do Sul", "Iraí", "Itaara", "Itacurubi", "Itapuca", "Itaqui", "Itati", "Itatiba do Sul", "Ivorá", "Ivoti", "Jaboticaba", "Jacuizinho", "Jacutinga", "Jaguarão", "Jaguari", "Jaquirana", "Jari", "Jóia", "Júlio de Castilhos", "Lagoa Bonita do Sul", "Lagoa dos Três Cantos", "Lagoa Vermelha", "Lagoão", "Lajeado", "Lajeado do Bugre", "Lavras do Sul", "Liberato Salzano", "Lindolfo Collor", "Linha Nova", "Maçambara", "Machadinho", "Mampituba", "Manoel Viana", "Maquiné", "Maratá", "Marau", "Marcelino Ramos", "Mariana Pimentel", "Mariano Moro", "Marques de Souza", "Mata", "Mato Castelhano", "Mato Leitão", "Mato Queimado", "Maximiliano de Almeida", "Minas do Leão", "Miraguaí", "Montauri", "Monte Alegre dos Campos", "Monte Belo do Sul", "Montenegro", "Mormaço", "Morrinhos do Sul", "Morro Redondo", "Morro Reuter", "Mostardas", "Muçum", "Muitos Capões", "Muliterno", "Não-Me-Toque", "Nicolau Vergueiro", "Nonoai", "Nova Alvorada", "Nova Araçá", "Nova Bassano", "Nova Boa Vista", "Nova Bréscia", "Nova Candelária", "Nova Esperança do Sul", "Nova Hartz", "Nova Pádua", "Nova Palma", "Nova Petrópolis", "Nova Prata", "Nova Ramada", "Nova Roma do Sul", "Nova Santa Rita", "Novo Barreiro", "Novo Cabrais", "Novo Hamburgo", "Novo Machado", "Novo Tiradentes", "Novo Xingu", "Osório", "Paim Filho", "Palmares do Sul", "Palmeira das Missões", "Palmitinho", "Panambi", "Pântano Grande", "Paraí", "Paraíso do Sul", "Pareci Novo", "Parobé", "Passa Sete", "Passo do Sobrado", "Passo Fundo", "Paulo Bento", "Paverama", "Pedras Altas", "Pedro Osório", "Pejuçara", "Pelotas", "Picada Café", "Pinhal", "Pinhal da Serra", "Pinhal Grande", "Pinheirinho do Vale", "Pinheiro Machado", "Pinto Bandeira", "Pirapó", "Piratini", "Planalto", "Poço das Antas", "Pontão", "Ponte Preta", "Portão", "Porto Lucena", "Porto Mauá", "Porto Vera Cruz", "Porto Xavier", "Pouso Novo", "Presidente Lucena", "Progresso", "Protásio Alves", "Putinga", "Quaraí", "Quatro Irmãos", "Quevedos", "Quinze de Novembro", "Redentora", "Relvado", "Restinga Seca", "Rio dos Índios", "Rio Grande", "Rio Pardo", "Riozinho", "Roca Sales", "Rodeio Bonito", "Rolador", "Rolante", "Ronda Alta", "Rondinha", "Roque Gonzales", "Rosário do Sul", "Sagrada Família", "Saldanha Marinho", "Salto do Jacuí", "Salvador das Missões", "Salvador do Sul", "Sananduva", "Santa Bárbara do Sul", "Santa Cecília do Sul", "Santa Clara do Sul", "Santa Cruz do Sul", "Santa Margarida do Sul", "Santa Maria", "Santa Maria do Herval", "Santa Rosa", "Santa Tereza", "Santa Vitória do Palmar", "Santana da Boa Vista", "Santana do Livramento", "Santiago", "Santo Ângelo", "Santo Antônio da Patrulha", "Santo Antônio das Missões", "Santo Antônio do Palma", "Santo Antônio do Planalto", "Santo Augusto", "Santo Cristo", "Santo Expedito do Sul", "São Borja", "São Domingos do Sul", "São Francisco de Assis", "São Francisco de Paula", "São Gabriel", "São Jerônimo", "São João da Urtiga", "São João do Polêsine", "São Jorge", "São José das Missões", "São José do Herval", "São José do Hortêncio", "São José do Inhacorá", "São José do Norte", "São José do Ouro", "São José do Sul", "São José dos Ausentes", "São Leopoldo", "São Lourenço do Sul", "São Luiz Gonzaga", "São Marcos", "São Martinho", "São Martinho da Serra", "São Miguel das Missões", "São Nicolau", "São Paulo das Missões", "São Pedro da Serra", "São Pedro das Missões", "São Pedro do Butiá", "São Pedro do Sul", "São Sebastião do Caí", "São Sepé", "São Valentim", "São Valentim do Sul", "São Valério do Sul", "São Vendelino", "São Vicente do Sul", "Sapiranga", "Sapucaia do Sul", "Sarandi", "Seberi", "Sede Nova", "Segredo", "Selbach", "Senador Salgado Filho", "Sentinela do Sul", "Serafina Corrêa", "Sério", "Sertão", "Sertão Santana", "Sete de Setembro", "Severiano de Almeida", "Silveira Martins", "Sinimbu", "Sobradinho", "Soledade", "Tabaí", "Tapejara", "Tapera", "Tapes", "Taquara", "Taquari", "Taquaruçu do Sul", "Tavares", "Tenente Portela", "Terra de Areia", "Teutônia", "Tio Hugo", "Tiradentes do Sul", "Toropi", "Torres", "Tramandaí", "Travesseiro", "Três Arroios", "Três Cachoeiras", "Três Coroas", "Três de Maio", "Três Forquilhas", "Três Palmeiras", "Três Passos", "Trindade do Sul", "Triunfo", "Tucunduva", "Tunas", "Tupanci do Sul", "Tupanciretã", "Tupandi", "Tuparendi", "Turuçu", "Ubiretama", "União da Serra", "Unistalda", "Uruguaiana", "Vacaria", "Vale do Sol", "Vale Real", "Vale Verde", "Vanini", "Venâncio Aires", "Vera Cruz", "Veranópolis", "Vespasiano Correa", "Viadutos", "Viamão", "Vicente Dutra", "Victor Graeff", "Vila Flores", "Vila Lângaro", "Vila Maria", "Vila Nova do Sul", "Vista Alegre", "Vista Alegre do Prata", "Vista Gaúcha", "Vitória das Missões", "Westfália", "Xangri-lá"]
    }, {
        sigla: "SC",
        nome: "Santa Catarina",
        cidades: ["Florianópolis", "Abdon Batista", "Abelardo Luz", "Agrolândia", "Agronômica", "Água Doce", "Águas de Chapecó", "Águas Frias", "Águas Mornas", "Alfredo Wagner", "Alto Bela Vista", "Anchieta", "Angelina", "Anita Garibaldi", "Anitápolis", "Antônio Carlos", "Apiúna", "Arabutã", "Araquari", "Araranguá", "Armazém", "Arroio Trinta", "Arvoredo", "Ascurra", "Atalanta", "Aurora", "Balneáreo Piçarras", "Balneário Arroio do Silva", "Balneário Barra do Sul", "Balneário Camboriú", "Balneário Gaivota", "Balneário Rincão", "Bandeirante", "Barra Bonita", "Barra Velha", "Bela Vista do Toldo", "Belmonte", "Benedito Novo", "Biguaçu", "Blumenau", "Bocaina do Sul", "Bom Jardim da Serra", "Bom Jesus", "Bom Jesus do Oeste", "Bom Retiro", "Bombinhas", "Botuverá", "Braço do Norte", "Braço do Trombudo", "Brunópolis", "Brusque", "Caçador", "Caibi", "Calmon", "Camboriú", "Campo Alegre", "Campo Belo do Sul", "Campo Erê", "Campos Novos", "Canelinha", "Canoinhas", "Capão Alto", "Capinzal", "Capivari de Baixo", "Catanduvas", "Caxambu do Sul", "Celso Ramos", "Cerro Negro", "Chapadão do Lageado", "Chapecó", "Cocal do Sul", "Concórdia", "Cordilheira Alta", "Coronel Freitas", "Coronel Martins", "Correia Pinto", "Corupá", "Criciúma", "Cunha Porã", "Cunhataí", "Curitibanos", "Descanso", "Dionísio Cerqueira", "Dona Emma", "Doutor Pedrinho", "Entre Rios", "Ermo", "Erval Velho", "Faxinal dos Guedes", "Flor do Sertão", "Formosa do Sul", "Forquilhinha", "Fraiburgo", "Frei Rogério", "Galvão", "Garopaba", "Garuva", "Gaspar", "Governador Celso Ramos", "Grão Pará", "Gravatal", "Guabiruba", "Guaraciaba", "Guaramirim", "Guarujá do Sul", "Guatambú", "Herval d'Oeste", "Ibiam", "Ibicaré", "Ibirama", "Içara", "Ilhota", "Imaruí", "Imbituba", "Imbuia", "Indaial", "Iomerê", "Ipira", "Iporã do Oeste", "Ipuaçu", "Ipumirim", "Iraceminha", "Irani", "Irati", "Irineópolis", "Itá", "Itaiópolis", "Itajaí", "Itapema", "Itapiranga", "Itapoá", "Ituporanga", "Jaborá", "Jacinto Machado", "Jaguaruna", "Jaraguá do Sul", "Jardinópolis", "Joaçaba", "Joinville", "José Boiteux", "Jupiá", "Lacerdópolis", "Lages", "Laguna", "Lajeado Grande", "Laurentino", "Lauro Muller", "Lebon Régis", "Leoberto Leal", "Lindóia do Sul", "Lontras", "Luiz Alves", "Luzerna", "Macieira", "Mafra", "Major Gercino", "Major Vieira", "Maracajá", "Maravilha", "Marema", "Massaranduba", "Matos Costa", "Meleiro", "Mirim Doce", "Modelo", "Mondaí", "Monte Carlo", "Monte Castelo", "Morro da Fumaça", "Morro Grande", "Navegantes", "Nova Erechim", "Nova Itaberaba", "Nova Trento", "Nova Veneza", "Novo Horizonte", "Orleans", "Otacílio Costa", "Ouro", "Ouro Verde", "Paial", "Painel", "Palhoça", "Palma Sola", "Palmeira", "Palmitos", "Papanduva", "Paraíso", "Passo de Torres", "Passos Maia", "Paulo Lopes", "Pedras Grandes", "Penha", "Peritiba", "Pescaria Brava", "Petrolândia", "Pinhalzinho", "Pinheiro Preto", "Piratuba", "Planalto Alegre", "Pomerode", "Ponte Alta", "Ponte Alta do Norte", "Ponte Serrada", "Porto Belo", "Porto União", "Pouso Redondo", "Praia Grande", "Presidente Castello Branco", "Presidente Getúlio", "Presidente Nereu", "Princesa", "Quilombo", "Rancho Queimado", "Rio das Antas", "Rio do Campo", "Rio do Oeste", "Rio do Sul", "Rio dos Cedros", "Rio Fortuna", "Rio Negrinho", "Rio Rufino", "Riqueza", "Rodeio", "Romelândia", "Salete", "Saltinho", "Salto Veloso", "Sangão", "Santa Cecília", "Santa Helena", "Santa Rosa de Lima", "Santa Rosa do Sul", "Santa Terezinha", "Santa Terezinha do Progresso", "Santiago do Sul", "Santo Amaro da Imperatriz", "São Bento do Sul", "São Bernardino", "São Bonifácio", "São Carlos", "São Cristovão do Sul", "São Domingos", "São Francisco do Sul", "São João Batista", "São João do Itaperiú", "São João do Oeste", "São João do Sul", "São Joaquim", "São José", "São José do Cedro", "São José do Cerrito", "São Lourenço do Oeste", "São Ludgero", "São Martinho", "São Miguel da Boa Vista", "São Miguel do Oeste", "São Pedro de Alcântara", "Saudades", "Schroeder", "Seara", "Serra Alta", "Siderópolis", "Sombrio", "Sul Brasil", "Taió", "Tangará", "Tigrinhos", "Tijucas", "Timbé do Sul", "Timbó", "Timbó Grande", "Três Barras", "Treviso", "Treze de Maio", "Treze Tílias", "Trombudo Central", "Tubarão", "Tunápolis", "Turvo", "União do Oeste", "Urubici", "Urupema", "Urussanga", "Vargeão", "Vargem", "Vargem Bonita", "Vidal Ramos", "Videira", "Vitor Meireles", "Witmarsum", "Xanxerê", "Xavantina", "Xaxim", "Zortéa"]
    }, {
        sigla: "SP",
        nome: "São Paulo",
        cidades: ["São Paulo", "Adamantina", "Adolfo", "Aguaí", "Águas da Prata", "Águas de Lindóia", "Águas de Santa Bárbara", "Águas de São Pedro", "Agudos", "Alambari", "Alfredo Marcondes", "Altair", "Altinópolis", "Alto Alegre", "Alumínio", "Álvares Florence", "Álvares Machado", "Álvaro de Carvalho", "Alvinlândia", "Americana", "Américo Brasiliense", "Américo de Campos", "Amparo", "Analândia", "Andradina", "Angatuba", "Anhembi", "Anhumas", "Aparecida", "Aparecida d'Oeste", "Apiaí", "Araçariguama", "Araçatuba", "Araçoiaba da Serra", "Aramina", "Arandu", "Arapeí", "Araraquara", "Araras", "Arco-Íris", "Arealva", "Areias", "Areiópolis", "Ariranha", "Artur Nogueira", "Arujá", "Aspásia", "Assis", "Atibaia", "Auriflama", "Avaí", "Avanhandava", "Avaré", "Bady Bassitt", "Balbinos", "Bálsamo", "Bananal", "Barão de Antonina", "Barbosa", "Bariri", "Barra Bonita", "Barra do Chapéu", "Barra do Turvo", "Barretos", "Barrinha", "Barueri", "Bastos", "Batatais", "Bauru", "Bebedouro", "Bento de Abreu", "Bernardino de Campos", "Bertioga", "Bilac", "Birigui", "Biritiba-Mirim", "Boa Esperança do Sul", "Bocaina", "Bofete", "Boituva", "Bom Jesus dos Perdões", "Bom Sucesso de Itararé", "Borá", "Boracéia", "Borborema", "Borebi", "Botucatu", "Bragança Paulista", "Braúna", "Brejo Alegre", "Brodowski", "Brotas", "Buri", "Buritama", "Buritizal", "Cabrália Paulista", "Cabreúva", "Caçapava", "Cachoeira Paulista", "Caconde", "Cafelândia", "Caiabu", "Caieiras", "Caiuá", "Cajamar", "Cajati", "Cajobi", "Cajuru", "Campina do Monte Alegre", "Campinas", "Campo Limpo Paulista", "Campos do Jordão", "Campos Novos Paulista", "Cananéia", "Canas", "Cândido Mota", "Cândido Rodrigues", "Canitar", "Capão Bonito", "Capela do Alto", "Capivari", "Caraguatatuba", "Carapicuíba", "Cardoso", "Casa Branca", "Cássia dos Coqueiros", "Castilho", "Catanduva", "Catiguá", "Cedral", "Cerqueira César", "Cerquilho", "Cesário Lange", "Charqueada", "Chavantes", "Clementina", "Colina", "Colômbia", "Conchal", "Conchas", "Cordeirópolis", "Coroados", "Coronel Macedo", "Corumbataí", "Cosmópolis", "Cosmorama", "Cotia", "Cravinhos", "Cristais Paulista", "Cruzália", "Cruzeiro", "Cubatão", "Cunha", "Descalvado", "Diadema", "Dirce Reis", "Divinolândia", "Dobrada", "Dois Córregos", "Dolcinópolis", "Dourado", "Dracena", "Duartina", "Dumont", "Echaporã", "Eldorado", "Elias Fausto", "Elisiário", "Embaúba", "Embu das Artes", "Embu-Guaçu", "Emilianópolis", "Engenheiro Coelho", "Espírito Santo do Pinhal", "Espírito Santo do Turvo", "Estiva Gerbi", "Estrela d'Oeste", "Estrela do Norte", "Euclides da Cunha Paulista", "Fartura", "Fernando Prestes", "Fernandópolis", "Fernão", "Ferraz de Vasconcelos", "Flora Rica", "Floreal", "Florínia", "Flórida Paulista", "Franca", "Francisco Morato", "Franco da Rocha", "Gabriel Monteiro", "Gália", "Garça", "Gastão Vidigal", "Gavião Peixoto", "General Salgado", "Getulina", "Glicério", "Guaiçara", "Guaimbê", "Guaíra", "Guapiaçu", "Guapiara", "Guará", "Guaraçaí", "Guaraci", "Guarani d'Oeste", "Guarantã", "Guararapes", "Guararema", "Guaratinguetá", "Guareí", "Guariba", "Guarujá", "Guarulhos", "Guatapará", "Guzolândia", "Herculândia", "Holambra", "Hortolândia", "Iacanga", "Iacri", "Iaras", "Ibaté", "Ibirá", "Ibirarema", "Ibitinga", "Ibiúna", "Icém", "Iepê", "Igaraçu do Tietê", "Igarapava", "Igaratá", "Iguape", "Ilha Comprida", "Ilha Solteira", "Ilhabela", "Indaiatuba", "Indiana", "Indiaporã", "Inúbia Paulista", "Ipaussu", "Iperó", "Ipeúna", "Ipiguá", "Iporanga", "Ipuã", "Iracemápolis", "Irapuã", "Irapuru", "Itaberá", "Itaí", "Itajobi", "Itaju", "Itanhaém", "Itaóca", "Itapecerica da Serra", "Itapetininga", "Itapeva", "Itapevi", "Itapira", "Itapirapuã Paulista", "Itápolis", "Itaporanga", "Itapuí", "Itapura", "Itaquaquecetuba", "Itararé", "Itariri", "Itatiba", "Itatinga", "Itirapina", "Itirapuã", "Itobi", "Itu", "Itupeva", "Ituverava", "Jaborandi", "Jaboticabal", "Jacareí", "Jaci", "Jacupiranga", "Jaguariúna", "Jales", "Jambeiro", "Jandira", "Jardinópolis", "Jarinu", "Jaú", "Jeriquara", "Joanópolis", "João Ramalho", "José Bonifácio", "Júlio Mesquita", "Jumirim", "Jundiaí", "Junqueirópolis", "Juquiá", "Juquitiba", "Lagoinha", "Laranjal Paulista", "Lavínia", "Lavrinhas", "Leme", "Lençóis Paulista", "Limeira", "Lindóia", "Lins", "Lorena", "Lourdes", "Louveira", "Lucélia", "Lucianópolis", "Luís Antônio", "Luiziânia", "Lupércio", "Lutécia", "Macatuba", "Macaubal", "Macedônia", "Magda", "Mairinque", "Mairiporã", "Manduri", "Marabá Paulista", "Maracaí", "Marapoama", "Mariápolis", "Marília", "Marinópolis", "Martinópolis", "Matão", "Mauá", "Mendonça", "Meridiano", "Mesópolis", "Miguelópolis", "Mineiros do Tietê", "Mira Estrela", "Miracatu", "Mirandópolis", "Mirante do Paranapanema", "Mirassol", "Mirassolândia", "Mococa", "Mogi das Cruzes", "Mogi-Guaçu", "Mogi-Mirim", "Mombuca", "Monções", "Mongaguá", "Monte Alegre do Sul", "Monte Alto", "Monte Aprazível", "Monte Azul Paulista", "Monte Castelo", "Monte Mor", "Monteiro Lobato", "Morro Agudo", "Morungaba", "Motuca", "Murutinga do Sul", "Nantes", "Narandiba", "Natividade da Serra", "Nazaré Paulista", "Neves Paulista", "Nhandeara", "Nipoã", "Nova Aliança", "Nova Campina", "Nova Canaã Paulista", "Nova Castilho", "Nova Europa", "Nova Granada", "Nova Guataporanga", "Nova Independência", "Nova Luzitânia", "Nova Odessa", "Novais", "Novo Horizonte", "Nuporanga", "Ocauçu", "Óleo", "Olímpia", "Onda Verde", "Oriente", "Orindiúva", "Orlândia", "Osasco", "Oscar Bressane", "Osvaldo Cruz", "Ourinhos", "Ouro Verde", "Ouroeste", "Pacaembu", "Palestina", "Palmares Paulista", "Palmeira d'Oeste", "Palmital", "Panorama", "Paraguaçu Paulista", "Paraibuna", "Paraíso", "Paranapanema", "Paranapuã", "Parapuã", "Pardinho", "Pariquera-Açu", "Parisi", "Patrocínio Paulista", "Paulicéia", "Paulínia", "Paulistânia", "Paulo de Faria", "Pederneiras", "Pedra Bela", "Pedranópolis", "Pedregulho", "Pedreira", "Pedrinhas Paulista", "Pedro de Toledo", "Penápolis", "Pereira Barreto", "Pereiras", "Peruíbe", "Piacatu", "Piedade", "Pilar do Sul", "Pindamonhangaba", "Pindorama", "Pinhalzinho", "Piquerobi", "Piquete", "Piracaia", "Piracicaba", "Piraju", "Pirajuí", "Pirangi", "Pirapora do Bom Jesus", "Pirapozinho", "Pirassununga", "Piratininga", "Pitangueiras", "Planalto", "Platina", "Poá", "Poloni", "Pompéia", "Pongaí", "Pontal", "Pontalinda", "Pontes Gestal", "Populina", "Porangaba", "Porto Feliz", "Porto Ferreira", "Potim", "Potirendaba", "Pracinha", "Pradópolis", "Praia Grande", "Pratânia", "Presidente Alves", "Presidente Bernardes", "Presidente Epitácio", "Presidente Prudente", "Presidente Venceslau", "Promissão", "Quadra", "Quatá", "Queiroz", "Queluz", "Quintana", "Rafard", "Rancharia", "Redenção da Serra", "Regente Feijó", "Reginópolis", "Registro", "Restinga", "Ribeira", "Ribeirão Bonito", "Ribeirão Branco", "Ribeirão Corrente", "Ribeirão do Sul", "Ribeirão dos Índios", "Ribeirão Grande", "Ribeirão Pires", "Ribeirão Preto", "Rifaina", "Rincão", "Rinópolis", "Rio Claro", "Rio das Pedras", "Rio Grande da Serra", "Riolândia", "Riversul", "Rosana", "Roseira", "Rubiácea", "Rubinéia", "Sabino", "Sagres", "Sales", "Sales Oliveira", "Salesópolis", "Salmourão", "Saltinho", "Salto", "Salto de Pirapora", "Salto Grande", "Sandovalina", "Santa Adélia", "Santa Albertina", "Santa Bárbara d'Oeste", "Santa Branca", "Santa Clara d'Oeste", "Santa Cruz da Conceição", "Santa Cruz da Esperança", "Santa Cruz das Palmeiras", "Santa Cruz do Rio Pardo", "Santa Ernestina", "Santa Fé do Sul", "Santa Gertrudes", "Santa Isabel", "Santa Lúcia", "Santa Maria da Serra", "Santa Mercedes", "Santa Rita d'Oeste", "Santa Rita do Passa Quatro", "Santa Rosa de Viterbo", "Santa Salete", "Santana da Ponte Pensa", "Santana de Parnaíba", "Santo Anastácio", "Santo André", "Santo Antônio da Alegria", "Santo Antônio de Posse", "Santo Antônio do Aracanguá", "Santo Antônio do Jardim", "Santo Antônio do Pinhal", "Santo Expedito", "Santópolis do Aguapeí", "Santos", "São Bento do Sapucaí", "São Bernardo do Campo", "São Caetano do Sul", "São Carlos", "São Francisco", "São João da Boa Vista", "São João das Duas Pontes", "São João de Iracema", "São João do Pau d'Alho", "São Joaquim da Barra", "São José da Bela Vista", "São José do Barreiro", "São José do Rio Pardo", "São José do Rio Preto", "São José dos Campos", "São Lourenço da Serra", "São Luís do Paraitinga", "São Manuel", "São Miguel Arcanjo", "São Pedro", "São Pedro do Turvo", "São Roque", "São Sebastião", "São Sebastião da Grama", "São Simão", "São Vicente", "Sarapuí", "Sarutaiá", "Sebastianópolis do Sul", "Serra Azul", "Serra Negra", "Serrana", "Sertãozinho", "Sete Barras", "Severínia", "Silveiras", "Socorro", "Sorocaba", "Sud Mennucci", "Sumaré", "Suzanápolis", "Suzano", "Tabapuã", "Tabatinga", "Taboão da Serra", "Taciba", "Taguaí", "Taiaçu", "Taiúva", "Tambaú", "Tanabi", "Tapiraí", "Tapiratiba", "Taquaral", "Taquaritinga", "Taquarituba", "Taquarivaí", "Tarabai", "Tarumã", "Tatuí", "Taubaté", "Tejupá", "Teodoro Sampaio", "Terra Roxa", "Tietê", "Timburi", "Torre de Pedra", "Torrinha", "Trabiju", "Tremembé", "Três Fronteiras", "Tuiuti", "Tupã", "Tupi Paulista", "Turiúba", "Turmalina", "Ubarana", "Ubatuba", "Ubirajara", "Uchoa", "União Paulista", "Urânia", "Uru", "Urupês", "Valentim Gentil", "Valinhos", "Valparaíso", "Vargem", "Vargem Grande do Sul", "Vargem Grande Paulista", "Várzea Paulista", "Vera Cruz", "Vinhedo", "Viradouro", "Vista Alegre do Alto", "Vitória Brasil", "Votorantim", "Votuporanga", "Zacarias"]
    }, {
        sigla: "SE",
        nome: "Sergipe",
        cidades: ["Aracaju", "Amparo de São Francisco", "Aquidabã", "Arauá", "Areia Branca", "Barra dos Coqueiros", "Boquim", "Brejo Grande", "Campo do Brito", "Canhoba", "Canindé de São Francisco", "Capela", "Carira", "Carmópolis", "Cedro de São João", "Cristinápolis", "Cumbe", "Divina Pastora", "Estância", "Feira Nova", "Frei Paulo", "Gararu", "General Maynard", "Gracho Cardoso", "Ilha das Flores", "Indiaroba", "Itabaiana", "Itabaianinha", "Itabi", "Itaporanga d'Ajuda", "Japaratuba", "Japoatã", "Lagarto", "Laranjeiras", "Macambira", "Malhada dos Bois", "Malhador", "Maruim", "Moita Bonita", "Monte Alegre de Sergipe", "Muribeca", "Neópolis", "Nossa Senhora Aparecida", "Nossa Senhora da Glória", "Nossa Senhora das Dores", "Nossa Senhora de Lourdes", "Nossa Senhora do Socorro", "Pacatuba", "Pedra Mole", "Pedrinhas", "Pinhão", "Pirambu", "Poço Redondo", "Poço Verde", "Porto da Folha", "Propriá", "Riachão do Dantas", "Riachuelo", "Ribeirópolis", "Rosário do Catete", "Salgado", "Santa Luzia do Itanhy", "Santa Rosa de Lima", "Santana do São Francisco", "Santo Amaro das Brotas", "São Cristóvão", "São Domingos", "São Francisco", "São Miguel do Aleixo", "Simão Dias", "Siriri", "Telha", "Tobias Barreto", "Tomar do Geru", "Umbaúba"]
    }, {
        sigla: "TO",
        nome: "Tocantins",
        cidades: ["Palmas", "Abreulândia", "Aguiarnópolis", "Aliança do Tocantins", "Almas", "Alvorada", "Ananás", "Angico", "Aparecida do Rio Negro", "Aragominas", "Araguacema", "Araguaçu", "Araguaína", "Araguanã", "Araguatins", "Arapoema", "Arraias", "Augustinópolis", "Aurora do Tocantins", "Axixá do Tocantins", "Babaçulândia", "Bandeirantes do Tocantins", "Barra do Ouro", "Barrolândia", "Bernardo Sayão", "Bom Jesus do Tocantins", "Brasilândia do Tocantins", "Brejinho de Nazaré", "Buriti do Tocantins", "Cachoeirinha", "Campos Lindos", "Cariri do Tocantins", "Carmolândia", "Carrasco Bonito", "Caseara", "Centenário", "Chapada da Natividade", "Chapada de Areia", "Colinas do Tocantins", "Colméia", "Combinado", "Conceição do Tocantins", "Couto de Magalhães", "Cristalândia", "Crixás do Tocantins", "Darcinópolis", "Dianópolis", "Divinópolis do Tocantins", "Dois Irmãos do Tocantins", "Dueré", "Esperantina", "Fátima", "Figueirópolis", "Filadélfia", "Formoso do Araguaia", "Fortaleza do Tabocão", "Goianorte", "Goiatins", "Guaraí", "Gurupi", "Ipueiras", "Itacajá", "Itaguatins", "Itapiratins", "Itaporã do Tocantins", "Jaú do Tocantins", "Juarina", "Lagoa da Confusão", "Lagoa do Tocantins", "Lajeado", "Lavandeira", "Lizarda", "Luzinópolis", "Marianópolis do Tocantins", "Mateiros", "Maurilândia do Tocantins", "Miracema do Tocantins", "Miranorte", "Monte do Carmo", "Monte Santo do Tocantins", "Muricilândia", "Natividade", "Nazaré", "Nova Olinda", "Nova Rosalândia", "Novo Acordo", "Novo Alegre", "Novo Jardim", "Oliveira de Fátima", "Palmeirante", "Palmeiras do Tocantins", "Palmeirópolis", "Paraíso do Tocantins", "Paranã", "Pau d'Arco", "Pedro Afonso", "Peixe", "Pequizeiro", "Pindorama do Tocantins", "Piraquê", "Pium", "Ponte Alta do Bom Jesus", "Ponte Alta do Tocantins", "Porto Alegre do Tocantins", "Porto Nacional", "Praia Norte", "Presidente Kennedy", "Pugmil", "Recursolândia", "Riachinho", "Rio da Conceição", "Rio dos Bois", "Rio Sono", "Sampaio", "Sandolândia", "Santa Fé do Araguaia", "Santa Maria do Tocantins", "Santa Rita do Tocantins", "Santa Rosa do Tocantins", "Santa Tereza do Tocantins", "Santa Terezinha do Tocantins", "São Bento do Tocantins", "São Félix do Tocantins", "São Miguel do Tocantins", "São Salvador do Tocantins", "São Sebastião do Tocantins", "São Valério da Natividade", "Silvanópolis", "Sítio Novo do Tocantins", "Sucupira", "Taguatinga", "Taipas do Tocantins", "Talismã", "Tocantínia", "Tocantinópolis", "Tupirama", "Tupiratins", "Wanderlândia", "Xambioá"]
    }]
}

function e() {
    var a = r;
    return function(o, r) {
        o += "";
        var i = r ? o.concat(" - ") : "";
        return i.concat(a(o))
    }
}
angular.module("bentham").factory("brCidadesEstados", a).filter("descricaoEstado", e);
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function() {
    'use strict';

    angular.module('bentham.theme')
        .config(config);

    /** @ngInject */
    function config(baConfigProvider, colorHelper, $provide) {
        $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
        //baConfigProvider.changeTheme({blur: true});
        //
        //baConfigProvider.changeColors({
        //  default: 'rgba(#000000, 0.2)',
        //  defaultText: '#ffffff',
        //  dashboard: {
        //    white: '#ffffff',
        //  },
        //});
    }

    /** @ngInject */
    function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
        return function(uiViewElement) {
            if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
                $anchorScroll();
            } else {
                $delegate(uiViewElement);
            }
        };
    }
})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function() {
    'use strict';

    var basic = {
        default: '#ffffff',
        defaultText: '#666666',
        border: '#dddddd',
        borderDark: '#aaaaaa',
    };

    // main functional color scheme
    var colorScheme = {
        primary: '#209e91',
        info: '#2dacd1',
        success: '#90b900',
        warning: '#dfb81c',
        danger: '#e85656',
    };

    // dashboard colors for charts
    var dashboardColors = {
        blueStone: '#005562',
        surfieGreen: '#0e8174',
        silverTree: '#6eba8c',
        gossip: '#b9f2a1',
        white: '#10c4b5',
    };

    angular.module('bentham.theme')
        .provider('baConfig', configProvider);

    /** @ngInject */
    function configProvider(colorHelper) {
        var conf = {
            theme: {
                blur: false,
            },
            colors: {
                default: basic.default,
                defaultText: basic.defaultText,
                border: basic.border,
                borderDark: basic.borderDark,

                primary: colorScheme.primary,
                info: colorScheme.info,
                success: colorScheme.success,
                warning: colorScheme.warning,
                danger: colorScheme.danger,

                primaryLight: colorHelper.tint(colorScheme.primary, 30),
                infoLight: colorHelper.tint(colorScheme.info, 30),
                successLight: colorHelper.tint(colorScheme.success, 30),
                warningLight: colorHelper.tint(colorScheme.warning, 30),
                dangerLight: colorHelper.tint(colorScheme.danger, 30),

                primaryDark: colorHelper.shade(colorScheme.primary, 15),
                infoDark: colorHelper.shade(colorScheme.info, 15),
                successDark: colorHelper.shade(colorScheme.success, 15),
                warningDark: colorHelper.shade(colorScheme.warning, 15),
                dangerDark: colorHelper.shade(colorScheme.danger, 15),

                dashboard: {
                    blueStone: dashboardColors.blueStone,
                    surfieGreen: dashboardColors.surfieGreen,
                    silverTree: dashboardColors.silverTree,
                    gossip: dashboardColors.gossip,
                    white: dashboardColors.white,
                },
            }
        };

        conf.changeTheme = function(theme) {
            angular.merge(conf.theme, theme)
        };

        conf.changeColors = function(colors) {
            angular.merge(conf.colors, colors)
        };

        conf.$get = function() {
            delete conf.$get;
            return conf;
        };
        return conf;
    }
})();
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function() {
    'use strict';

    var IMAGES_ROOT = 'assets/img/';

    angular.module('bentham.theme')
        .constant('layoutSizes', {
            resWidthCollapseSidebar: 1200,
            resWidthHideSidebar: 500
        })
        .constant('layoutPaths', {
            images: {
                root: IMAGES_ROOT,
                profile: IMAGES_ROOT + 'app/profile/',
                amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
                amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
            }
        })
        .constant('colorHelper', {
            tint: function(color, weight) {
                return mix('#ffffff', color, weight);
            },
            shade: function(color, weight) {
                return mix('#000000', color, weight);
            },
        });

    function shade(color, weight) {
        return mix('#000000', color, weight);
    }

    function tint(color, weight) {
        return mix('#ffffff', color, weight);
    }

    //SASS mix function
    function mix(color1, color2, weight) {
        // convert a decimal value to hex
        function d2h(d) {
            return d.toString(16);
        }
        // convert a hex value to decimal
        function h2d(h) {
            return parseInt(h, 16);
        }

        var result = "#";
        for (var i = 1; i < 7; i += 2) {
            var color1Part = h2d(color1.substr(i, 2));
            var color2Part = h2d(color2.substr(i, 2));
            var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
            result += ('0' + resultPart).slice(-2);
        }
        return result;
    }
})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .run(themeRun);

    /** @ngInject */
    function themeRun($timeout, $location, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
        var whatToWait = [
            preloader.loadAmCharts(),
            $timeout(30)
        ];

        var theme = themeLayoutSettings;
        if (theme.blur) {
            if (theme.mobile) {
                whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
            } else {
                whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
                whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
            }
        }

        $q.all(whatToWait).then(function() {
            $rootScope.$pageFinishedLoading = true;
            $rootScope.$exibir = $location.url() != '/login';
        });

        $timeout(function() {
            if (!$rootScope.$pageFinishedLoading) {
                $rootScope.$pageFinishedLoading = true;
            }
        }, 10);

        $rootScope.$baSidebarService = baSidebarService;
    }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function() {
    'use strict';

    angular.module('bentham.theme')
        .service('themeLayoutSettings', themeLayoutSettings);

    /** @ngInject */
    function themeLayoutSettings(baConfig) {
        var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
        var mobileClass = isMobile ? 'mobile' : '';
        var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
        angular.element(document.body).addClass(mobileClass).addClass(blurClass);

        return {
            blur: baConfig.theme.blur,
            mobile: isMobile,
        }
    }

})();
/**
 * Código não usado
 * 
 */

angular.module('bentham.pages.cadastrosbasicos').controller('ArquivoCtrl',function($scope, $rootScope, $upload, Arquivo) {
    $rootScope.arquivoCtrl = $scope;

    $scope.show = function(type, id, formats, limit, multiplo) {
      var target = type+"@"+id;

      if(formats) {
        $scope.formats=formats.split(",");
        $scope.extensoes=formats;
      } else {
        $scope.formats=formats;
      }

      $scope.limit=limit;
      $scope.multiplo=multiplo;
      $scope.target = target;
  
      // $scope.arquivos = Arquivo.todosArquivosPerspectiva({target: target}, function(quant){
      //   $scope.quantidade = quant.length;
      //   $scope.modal.open();
      // });
    }
    
    $scope.testeObjeto = function(objeto){
        if(objeto){
            if(objeto.indexOf('Contrato') > -1){
                return 'Contrato';
              }else if(objeto.indexOf('OS') > -1){
                return 'Ordem de Serviço';
              }else if(objeto.indexOf('PropostaFinanceira') > -1){
                return 'Proposta Financeira';
              }else if(objeto.indexOf('PropostaTecnica') > -1){
                return 'Proposta Técnica';
              }else if(objeto.indexOf('ExtratoDiarioOficial') > -1){
                return 'Extrato Diário Oficial';
              }else if(objeto.indexOf('Edital') > -1){
                  return 'Edital';
              }  
        }
  };
  
    $scope.up=function(file) {
      $upload.upload({
        url: 'arquivos/'+$scope.target+'/commit',
        method: 'POST',
        file: file
      }).success(function(){
        $scope.arquivos = [];
        // Arquivo.todosArquivosPerspectiva({target: $scope.target}, function(quant) { $scope.quantidade=quant.length; });
      });
    }
  
    $scope.onFileSelect = function($files) {
      var tamanho=$scope.arquivos.length+$files.length;
  
      if($scope.formats && $scope.limit) {
        if(tamanho<=$scope.limit) {
          angular.forEach($files, function(file, index){
            var fileName=file.name.split(".");
  
            for(var i=0;i<=$scope.formats.length;i++) {
              if(fileName[1]==$scope.formats[i]) {
                $scope.up(file);
              }else {
                $rootScope.asideScope.addError({defaultMessage: "Só é permitido o upload de arquivos com extensão("+$scope.extensoes+")"});
              }
            }
          });
        }else {
          $rootScope.asideScope.addError({defaultMessage: "Não é permitido o upload de mais de "+$scope.limit+" arquivos"});
        }
      }else if($scope.formats && !$scope.limit) {
        angular.forEach($files, function(file, index){
          var fileName=file.name.split(".");
  
          for(var i=0;i<=$scope.formats.length;i++) {
            if(fileName[1]==$scope.formats[i]) {
              $scope.up(file);
            }else {
              $rootScope.asideScope.addError({defaultMessage: "Só é permitido o upload de arquivos com extensão("+$scope.extensoes+")"});
            }
          }
        });
      }else if(!$scope.formats && $scope.limit) {
        if(tamanho<=$scope.limit) {
          angular.forEach($files, function(file, index) { $scope.up(file); });
        }else {
          $rootScope.asideScope.addError({defaultMessage: "Não é permitido o upload de mais de "+$scope.limit+" arquivos"});
        }
      }else {
        angular.forEach($files, function(file, index){ $scope.up(file); });
      }
    }
  
    $scope.deletar = function(arquivo) {
      Arquivo.delete(arquivo, function(quant) {
        $scope.arquivos = [];
        // Arquivo.todosArquivosPerspectiva({target: $scope.target},function(quant) { $scope.quantidade=quant.length; });
      })
    }
  });
angular.module('bentham').factory('Arquivo', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'arquivos/:id', {
    id: '@id',
  }, {
    save: {
      methods: 'POST',
    },
    update: {
      method: 'PUT'
    },
    delete: {
      method: 'DELETE',
      url: prefixRoute + "arquivos/:id",
    },
    catchFile: downloadFileResource({
      method: 'GET',
      url: prefixRoute + "arquivos/catchFile/:id",
    }),
    catchAlfrescoFiles: {
      method: 'GET',
      url: prefixRoute + "arquivos/catch-alfresco-files",
      isArray: true,
    },
    catchList2TreeView: {
      method: 'GET',
      url: prefixRoute + "arquivos/catch-folder-files",
      isArray: true,
    },
    catchChildren: {
      method: 'GET',
      url: prefixRoute + "arquivos/catch-children",
      isArray: true,
    },
    clean: {
      method: 'GET',
      url: prefixRoute + "arquivos/clean",
    },
    sync: {
      method: 'GET',
      url: prefixRoute + "arquivos/sync",
    },
    metadata: {
      method: 'GET',
      url: prefixRoute + "arquivos/metadata",
    },
    all: {
      method: 'GET',
      url: prefixRoute + "arquivos/",
      isArray: true,
    },
    pageable: {
      method: 'GET',
      url: prefixRoute + 'arquivos/pageable',
      params: {
        'sort': '@sort',
        'number': '@number',
        'size': '@size'
      }
    },
  });
});


angular.module('bentham').factory('ArquivoService', function (GenericService, Arquivo, $q, prefixRoute, $http) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new Arquivo();
  Object.setPrototypeOf(self.resource, Arquivo);

  self.delete = function (arquivo) {
    var deferred = $q.defer();
    var fn = function () {
      self.resource.delete({
          id: arquivo.id
        }, function success(data) {
          deferred.resolve(data);
        },
        function (error) {
          error = self.catchMessage(error);
          deferred.reject(new Error("Erro! " + error.message));
        });
      return deferred.promise;
    }
    return self.process(fn);
  }

  self.catchFile = function (arquivo) {
    var deferred = $q.defer();
    var fn = function () {
      self.resource.catchFile({
          id: arquivo.id
        }, function success(data) {
          deferred.resolve(data);
        },
        function (error) {
          error = self.catchMessage(error);
          deferred.reject(new Error("Erro! " + error.message));
        });
      return deferred.promise;
    }
    return self.process(fn);
  }

  self.catchList2TreeView = function () {
    var deferred = $q.defer();
    var fn = function () {
      self.resource.catchList2TreeView(function success(data) {
          deferred.resolve(data);
        },
        function (error) {
          error = self.catchMessage(error);
          deferred.reject(new Error("Erro! " + error));
        });
      return deferred.promise;
    }
    return self.process(fn);
  }

  self.catchAlfrescoFiles = function () {
    var deferred = $q.defer();
    var fn = function () {
      self.resource.catchAlfrescoFiles(function success(data) {
          deferred.resolve(data);
        },
        function (error) {
          error = self.catchMessage(error);
          deferred.reject(new Error("Erro! " + error));
        });
      return deferred.promise;
    }
    return self.process(fn);
  }


  self.catchChildren = function (id) {
    var deferred = $q.defer();
    var fn = function () {
      self.resource.catchChildren({
          id: id
        }, function success(data) {
          deferred.resolve(data);
        },
        function (error) {
          error = self.catchMessage(error);
          deferred.reject(new Error("Erro! " + error));
        });
      return deferred.promise;
    }
    return self.process(fn);
  }

  self.all= function () {
    var deferred = $q.defer();
    var fn = function () {
      self.resource.all(function success(data) {
          deferred.resolve(data);
        },
        function (error) {
          error = self.catchMessage(error);
          deferred.reject(new Error("Erro! " + error.message));
        });
      return deferred.promise;
    }
    return self.process(fn);
  }

  self.upload = function ($files, target) {
    var deferred = $q.defer();
    if ($files[0].size <= 10485760) {
      var fd = new FormData();
      fd.append("file", $files[0]);
      $http.post(prefixRoute + 'arquivos/' + "?target=" + target, fd, {
        withCredentials: true,
        headers: {
          'Content-Type': undefined
        },
        transformRequest: angular.identity
      }).then(function (response) {
        deferred.resolve(response.data.entity);
      }).catch(function (error) {
        error.message = 'O arquivo excede o tamanho máximo de 10MB';
        deferred.reject(new Error("Erro! " + error.message));
      });
    }
    return deferred.promise;
  }

  return function () {
    return self;
  };
});
angular.module('bentham.pages.arquivos').controller('treeCtrl', function ($scope, ArquivoService, GenericController, DocumentoService, toastr) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  self.service = new ArquivoService();
  self.documentoService = new DocumentoService();

  $scope.itemsByPage = 50;
  $scope.itemsByPageOptions = self.itemsByPageOptions;
  // $scope.isLoading = true;

  $scope.fonte = "bentham";
  $scope.visao = "grid";

  $scope.filtro = {};
  $scope.arquivos = [];

  $scope.basicConfig = {
    core: {
      multiple: false,
      check_callback: true,
      worker: true
    },
    'types': {
      'Folder': {
        'icon': 'ion-ios-folder'
      },
      'default': {
        'icon': 'ion-document-text'
      }
    },
    'plugins': ['types'],
    'version': 1
  };

  // self.service.catchAlfrescoFiles().then(function (datas) {
  //   $scope.alfrescoDocs = datas;
  //   $scope.isLoading = false;
  // });
  // $scope.catchChildren = function (obj) {
  //   var get = function (id) {
  //     self.service.catchChildren(id).then(function (result) {
  //       angular.forEach(result, function (r) {
  //         $scope.alfrescoDocs.push(r);
  //       })
  //       $scope.isLoading = false;
  //     });
  //   }

  //   if (obj == null) {
  //     $('#jstree').on("changed.jstree", function (e, data) {
  //       if (data.node.original.type != "Document") {
  //         $scope.isLoading = true;
  //         get(data.selected[0]);
  //       }
  //     });
  //   } else {
  //     $scope.isLoading = true;
  //     get(obj.id);
  //   }
  // };

  // self.service.catchList2TreeView().then(function (datas) {
  //   $scope.benthamDocs = datas;
  //   $scope.isLoading = false;
  // });

  $scope.clean = function () {
    self.service.resource.clean();
  };

  $scope.sync = function () {
    self.service.resource.sync();
  };

  $scope.metadata = function () {
    self.service.resource.metadata();
  };

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "name");
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.arquivos = result.content;
        self.updateTableState(result);
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.loadDocumentos = function (tableState) {
    self.initTableState(tableState, "name");
    self.documentoService.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.arquivos = result.content;
        self.updateTableState(result);
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.search = function (fil) {
    var filtro = angular.copy(fil);
    filtro.tipoDocumentoId = (filtro.tipoDocumento != null ? filtro.tipoDocumento.id : null)
    filtro.tipoDocumento = null;
    self.tableState.search = filtro;
    if (filtro.tipoDocumentoId != null)
      $scope.loadDocumentos(self.tableState);
    else
      $scope.load(self.tableState);
  };

    $scope.download = function (arquivo) {
        self.documentoService.catchFile(arquivo).then(function success(data) {
            downloadFile(new Blob([data.response]), arquivo.name, data.response.type);
        }).catch(function (error) {
            toastr.error(error.message);
        });
    };


});
angular.module('bentham.pages').controller('ModalController', function ($scope, $uibModalInstance, entity, self, title) {
    $scope.entity = angular.copy(entity); //SERVE PARA O MODAL AO SELECIONAR ITEM CADASTRÁVEL PARA EXCLUIR
    $scope.title = title;

    $scope.remove = function (entity) {
        self.remove(entity)
            .then(function success(data) {
                $uibModalInstance.close();
                $scope.refresh();
            })
            .catch(function (error) { $uibModalInstance.close(); });
    }

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.save = function (entity) {
        self.save(entity)
            .then(function success(data) {
                $uibModalInstance.close();
                $scope.refresh();
            });
    }

    $scope.clear = function () {
        self.clear();
        $uibModalInstance.dismiss('cancel');
    };

    $scope.confirm = function (entity) {
        self.confirm(entity)
            .then(function success(data) {
                $uibModalInstance.close();
                $scope.refresh();
            });
        $uibModalInstance.close();
    };

    $scope.print = function (formato) {
        self.print(formato)
            .then(function success(data) {
                $uibModalInstance.close();
                $uibModalInstance.dismiss('cancel');
            });
    };

});
/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('bentham.pages')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();
angular.module('bentham').
  directive('accordion', function() {
    return {
      restrict: 'E',
      transclude: true,
      scope:{
        id: '@'
      },
      controller: function($scope, $element) {
        $($element).find('.collapse').collapse({toggle: false});
      },
      template: '<div class="panel-group accordion" role="tablist" aria-multiselectable="true" ng-transclude/>',
      replace: true
    };
  }
);

angular.module('bentham').
  directive('accordionTab', function() {
    return {
      restrict: 'E',
      transclude: true,
      scope:{
        id: '@',
        title: '@',
        subtitle: '@'
      },
      controller: function($scope, $element) {

        $scope.isOpen = false;
        $scope.hasSubtitle = $scope.subtitle != undefined;

        this.open = function(){
          $scope.isOpen = true;
        }

        this.close = function(){
          $scope.isOpen = false;
        }

        var toggle = function(){
          $scope.isOpen = !$scope.isOpen;
        }

        $scope.selecionarTab = function(id){
          toggle();
          $('#' + id + '-collapse').collapse('toggle');
        }

      },
      template: '<div class="panel panel-default">' +
        '<div class="panel-heading" role="tab">' +
          '<h4 class="panel-title" style="cursor: pointer;" ng-click=selecionarTab(id)>' +
            "<a role='button' class='link-collapse' data-toggle='collapse' aria-expanded='false' aria-controls='{{id}}-collapse'>" +
            '{{title}}' +
            '</a>&nbsp;' +
            '<span class="badge" ng-show="hasSubtitle">{{subtitle}}</span>' +
            '<i class="indicator glyphicon glyphicon-chevron-up pull-right" ng-show="isOpen"></i>' +
            '<i class="indicator glyphicon glyphicon-chevron-down pull-right" ng-show="!isOpen"></i>' +
          '</h4>' +
        '</div>' +
        '<div id="{{id}}-collapse" class="panel-collapse collapse" role="tabpanel">' +
          '<div class="panel-body" ng-transclude>' +
          '</div>' +
        '</div>' +
      '</div>',
      replace: true
    };
  }
);

angular.module('bentham').
  directive('accordionShow', function() {
    return {
      require: '^accordionTab',
      restrict: 'A',
      link: function($scope, $element, attrs, accordionTabCtrl) {
        accordionTabCtrl.open();
        $($element).find('.collapse').addClass('in');
      }
    };
  }
);

angular.module('bentham')
  .directive('anexarArquivo', function ($compile,$rootScope) {
    return {
      restrict: 'E',
        scope: {
          type: '@',
          target: '='
        },
        template:'<a class="file {{classe}}" ng-click="show()" title="anexar arquivo">{{title}} <i class="file-manager" ng-show="showIcone"/></a>',
        transclude: true,
        link: function ($scope, $element, $attr) {
          if ($attr.showicone) {
            $scope.showIcone = true;
          }else if ($attr.botao){
            $scope.classe = $attr.botao;
            $scope.title = "Adicionar Arquivo";
          }else {
            $scope.title = "Anexar Arquivo";
          }

          $scope.show = function() {
            $rootScope.arquivoCtrl.show($scope.type, $scope.target, $attr.formats, $attr.limit, $attr.multiplo);
          };
        }
    };
});

/**
 * Checklist-model
 * AngularJS directive for list of checkboxes
 * https://github.com/vitalets/checklist-model
 * License: MIT http://opensource.org/licenses/MIT
 */

angular.module('checklist-model', [])
.directive('checklistModel', ['$parse', '$compile', function($parse, $compile) {
  // contains
  function contains(arr, item, comparator) {
    if (angular.isArray(arr)) {
      for (var i = arr.length; i--;) {
        if (comparator(arr[i], item)) {
          return true;
        }
      }
    }
    return false;
  }

  // add
  function add(arr, item, comparator) {
    arr = angular.isArray(arr) ? arr : [];
      if(!contains(arr, item, comparator)) {
          arr.push(item);
      }
    return arr;
  }  

  // remove
  function remove(arr, item, comparator) {
    if (angular.isArray(arr)) {
      for (var i = arr.length; i--;) {
        if (comparator(arr[i], item)) {
          arr.splice(i, 1);
          break;
        }
      }
    }
    return arr;
  }

  // http://stackoverflow.com/a/19228302/1458162
  function postLinkFn(scope, elem, attrs) {
     // exclude recursion, but still keep the model
    var checklistModel = attrs.checklistModel;
    attrs.$set("checklistModel", null);
    // compile with `ng-model` pointing to `checked`
    $compile(elem)(scope);
    attrs.$set("checklistModel", checklistModel);

    // getter / setter for original model
    var getter = $parse(checklistModel);
    var setter = getter.assign;
    var checklistChange = $parse(attrs.checklistChange);
    var checklistBeforeChange = $parse(attrs.checklistBeforeChange);

    // value added to list
    var value = attrs.checklistValue ? $parse(attrs.checklistValue)(scope.$parent) : attrs.value;


    var comparator = angular.equals;

    if (attrs.hasOwnProperty('checklistComparator')){
      if (attrs.checklistComparator[0] == '.') {
        var comparatorExpression = attrs.checklistComparator.substring(1);
        comparator = function (a, b) {
          return a[comparatorExpression] === b[comparatorExpression];
        };
        
      } else {
        comparator = $parse(attrs.checklistComparator)(scope.$parent);
      }
    }

    // watch UI checked change
    scope.$watch(attrs.ngModel, function(newValue, oldValue) {
      if (newValue === oldValue) { 
        return;
      } 

      if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
        scope[attrs.ngModel] = contains(getter(scope.$parent), value, comparator);
        return;
      }

      setValueInChecklistModel(value, newValue);

      if (checklistChange) {
        checklistChange(scope);
      }
    });

    function setValueInChecklistModel(value, checked) {
      var current = getter(scope.$parent);
      if (angular.isFunction(setter)) {
        if (checked === true) {
          setter(scope.$parent, add(current, value, comparator));
        } else {
          setter(scope.$parent, remove(current, value, comparator));
        }
      }
      
    }

    // declare one function to be used for both $watch functions
    function setChecked(newArr, oldArr) {
      if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
        setValueInChecklistModel(value, scope[attrs.ngModel]);
        return;
      }
      scope[attrs.ngModel] = contains(newArr, value, comparator);
    }

    // watch original model change
    // use the faster $watchCollection method if it's available
    if (angular.isFunction(scope.$parent.$watchCollection)) {
        scope.$parent.$watchCollection(checklistModel, setChecked);
    } else {
        scope.$parent.$watch(checklistModel, setChecked, true);
    }
  }

  return {
    restrict: 'A',
    priority: 1000,
    terminal: true,
    scope: true,
    compile: function(tElement, tAttrs) {
      if ((tElement[0].tagName !== 'INPUT' || tAttrs.type !== 'checkbox') && (tElement[0].tagName !== 'MD-CHECKBOX') && (!tAttrs.btnCheckbox)) {
        throw 'checklist-model should be applied to `input[type="checkbox"]` or `md-checkbox`.';
      }

      if (!tAttrs.checklistValue && !tAttrs.value) {
        throw 'You should provide `value` or `checklist-value`.';
      }

      // by default ngModel is 'checked', so we set it if not specified
      if (!tAttrs.ngModel) {
        // local scope var storing individual checkbox model
        tAttrs.$set("ngModel", "checked");
      }

      return postLinkFn;
    }
  };
}]);

angular.module('bentham')
  .directive('chosen',function($timeout){
      var NG_OPTIONS_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w\d]*)|(?:\(\s*([\$\w][\$\w\d]*)\s*,\s*([\$\w][\$\w\d]*)\s*\)))\s+in\s+(.*)$/;

      var linker = function(scope,element,attrs) {

          var trigger = function(e) {
            // Notify of change!
            element.trigger('liszt:updated');
            element.trigger("chosen:updated");
            //console.warn("change!", e);
          };
          $(element)[0].addEventListener("DOMSubtreeModified", trigger, false);
          $(element)[0].addEventListener("DOMAttrModified", trigger, false);

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel,trigger);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, trigger);
          }

          element.chosen({
            inherit_select_classes:true,
            disable_search_threshold: 6,
            width: '100%'
          });
      };

      return {
          restrict:'AC',
          link: linker
      };
  });

angular.module('bentham').
directive('selectCidade', ['$parse', '$rootScope', 'brCidadesEstados', function($parse, $rootScope, brCidadesEstados) {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      ngModel: '=',
      watchTo: '='
    },
    link: function ($scope, elem, $attrs) {
      $scope.$watch('watchTo', function(estado){
        if (estado === undefined) {
          $scope.$_cidades = [];
        }else if(estado && estado.sigla){
          $scope.$_cidades = brCidadesEstados.buscarCidadesPorSigla(estado.sigla);
        }else{
          $scope.$_cidades = brCidadesEstados.buscarCidadesPorSigla(estado);
        }
        $scope.$_cidades_label = $attrs.noSelectionLabel || "Selecione uma Cidade";
      });
    },
    template:'<select class="form-control" ng-options="cidade as cidade for cidade in $_cidades track by cidade">'+
        '<option value="">{{$_cidades_label}}</option></select>',
    replace: true
  };
}]);
angular.module('bentham')
  .directive('confirm', function ($compile,$rootScope) {
    return {
    restrict: 'A',
      priority: 1,
      terminal: true,
      link: function (scope, element, attr) {
        var msg = attr.confirm || "Are you sure?";

        var template = angular.element("<div>"+msg+"</div>");
        var compiled = $compile(template);
        compiled(scope);
        var clickAction = attr.ngClick;

        element.bind('click',function () {
          compiled(scope);
        var cloned = compiled(scope);
        $rootScope.confirm_msg = cloned.text();
        $rootScope.confirm_fn = function() {
          scope.$eval(clickAction);
          $rootScope.confirm_modal.close();
        };
        $rootScope.$apply('confirm_msg');
        $rootScope.confirm_modal.open();
        });
      }
    };
  });
angular.module('bentham')
  .factory('cotacaoWS',function($resource){
	  return $resource('banco-central',{},
		{obterCotacao:{
		      method: 'GET',
		      url: 'banco-central/cotacao',
		      transformResponse: function(data) {
		          return {cotacao: data};
		      }
		    }
			  
		  });
  })
  .directive('cotacao',['cotacaoWS',function(cotacaoWS){
	    var linker = function(scope,element,attrs,modelCtrl) {

	    	var applyCotacao = function(cotacao) {
	    		scope.$eval(attrs.cotacao +'='+cotacao);
	    	};

	    	var cotacao = function(modelValue, oldValue) {
	    		scope.old = oldValue || scope.old;
	    		if (modelValue && modelCtrl.$valid) {

						if(scope.old || !scope.$eval(attrs.cotacao)) {
							cotacaoWS.obterCotacao({data:element.val()},function(data){
		    				applyCotacao(parseFloat(data.cotacao));
		    			},function(){
		    				applyCotacao(0.0000);
		    			});
	    			}

	    		}
	    	};

	    	scope.$watch(attrs.ngModel,cotacao);
	    };

	    return {
	        restrict:'A',
	        link: linker,
	        transclusion: false,
	        replace: false,
	        priority: 1,
	        require: 'ngModel'
	    };
	}]);

/**
 * Função para encapsular o resource do download de um arquivo
 */
function download(data, strFileName, strMimeType) { var self = window, u = "application/octet-stream", m = strMimeType || u, x = data, D = document, a = D.createElement("a"), z = function (a) { return String(a); }, B = self.Blob || self.MozBlob || self.WebKitBlob || z, BB = self.MSBlobBuilder || self.WebKitBlobBuilder || self.BlobBuilder, fn = strFileName || "download", blob, b, ua, fr; if (String(this) === "true") { x = [x, m]; m = x[0]; x = x[1]; } if (String(x).match(/^data\:[\w+\-]+\/[\w+\-]+[,;]/)) { return navigator.msSaveBlob ? navigator.msSaveBlob(d2b(x), fn) : saver(x); } try { blob = x instanceof B ? x : new B([x], { type: m }); } catch (y) { if (BB) { b = new BB(); b.append([x]); blob = b.getBlob(m); } } function d2b(u) { var p = u.split(/[:;,]/), t = p[1], dec = p[2] == "base64" ? atob : decodeURIComponent, bin = dec(p.pop()), mx = bin.length, i = 0, uia = new Uint8Array(mx); for (i; i < mx; ++i)uia[i] = bin.charCodeAt(i); return new B([uia], { type: t }); } function saver(url, winMode) { if ('download' in a) { a.href = url; a.setAttribute("download", fn); a.innerHTML = "downloading..."; D.body.appendChild(a); setTimeout(function () { a.click(); D.body.removeChild(a); if (winMode === true) { setTimeout(function () { self.URL.revokeObjectURL(a.href); }, 250); } }, 66); return true; } var f = D.createElement("iframe"); D.body.appendChild(f); if (!winMode) { url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, u); } f.src = url; setTimeout(function () { D.body.removeChild(f); }, 333); } if (navigator.msSaveBlob) { return navigator.msSaveBlob(blob, fn); } if (self.URL) { saver(self.URL.createObjectURL(blob), true); } else { if (typeof blob === "string" || blob.constructor === z) { try { return saver("data:" + m + ";base64," + self.btoa(blob)); } catch (y) { return saver("data:" + m + "," + encodeURIComponent(blob)); } } fr = new FileReader(); fr.onload = function (e) { saver(this.result); }; fr.readAsDataURL(blob); } return true; }

function downloadFileResource(config) {
  var objResource = {};
  objResource.method = config.method || 'POST';
  objResource.responseType = config.responseType || 'arraybuffer';
  objResource.cache = config.cache || true;
  objResource.transformResponse = config.transformResponse || function (data, headersGetter) {
    var response = {};
    var contentType = headersGetter()['content-type'];
    if (contentType === 'application/json;charset=UTF-8') {
      response = String.fromCharCode.apply(null, new Uint8Array(data));
      response = angular.fromJson(response);
    } else if (data) {
      response.response = new Blob([data], { type: contentType.split(';')[0] });
    }
    return response;
  };
  objResource.url = config.url;

  return objResource;
}

/**
 * Função para realizar o download de um arquivo
 */
function downloadFile(blob, fileName, dataType) {
  var parts = dataType.split('.');
  if(dataType.split('/')[1] == 'pdf' && parts[parts.length-1] != 'pdf')
    download(blob, fileName + ".pdf", dataType);
  else if(dataType == "application/json")
    download(blob, fileName);
  else if(dataType.split('/')[1] == 'xls' && parts[parts.length-1] != 'xls')
    download(blob, fileName + ".xls", dataType);
  else if(dataType == "application/xml" || dataType == "application/vnd.ms-excel")
    download(blob, fileName + ".xls", dataType);
  else if(dataType == "csv")
    download(blob, fileName + ".csv", dataType);
  else
    download(blob, fileName, dataType);
  
}

angular.module('bentham').directive('dynamicCtrl', ['$compile', '$parse',function($compile, $parse) {
  return {
    restrict: 'A',
    terminal: true,
    priority: 100000,
    link: function(scope, elem) {
      var name = $parse(elem.attr('dynamic-ctrl'))(scope);
      elem.removeAttr('dynamic-ctrl');
      elem.attr('ng-controller', name);
      $compile(elem)(scope);
    }
  };
}]);
angular.module('bentham')
  .factory('enderecoWS',function($resource){
    var rest = $resource(
      'https://viacep.com.br/ws/:cep/json/',
      {
        'cep': ''
      }
    );
    return rest;
  })
  .directive('endereco',['enderecoWS',function(enderecoWS){
      var linker = function(scope,element,attrs,modelCtrl) {

        var applyEndereco = function(enderecoEncontrato) {
          scope.$eval(attrs.endereco +'.logradouro='+ JSON.stringify(enderecoEncontrato.logradouro));
          scope.$eval(attrs.endereco +'.bairro='+ JSON.stringify(enderecoEncontrato.bairro));
          scope.$eval(attrs.endereco +'.cidade='+ JSON.stringify(enderecoEncontrato.localidade));
          scope.$eval(attrs.endereco +'.estado='+ JSON.stringify(enderecoEncontrato.uf));
        };

        var buscaEndereco = function(modelValue, oldValue) {
          if (modelValue && modelCtrl.$valid) {
            modelValue = modelValue.replace(/[^0-9]/g,"");
            enderecoWS.get({cep:modelValue},function(data){
              applyEndereco(data);
            });
          }
        };

        element.bind('blur', function (e) {
          buscaEndereco(e.target.value);
        });
      };

      return {
          restrict:'A',
          link: linker,
          transclusion: false,
          replace: false,
          priority: 1,
          require: 'ngModel'
      };
  }]);

angular.module('bentham').
  directive('selectEstado', ['$parse', '$rootScope', 'brCidadesEstados', function ($parse, $rootScope, brCidadesEstados) {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        ngModel: '=',
        watchTo: '='
      },
      link: function ($scope, elem, $attrs) {
        $scope.$_estados = brCidadesEstados.estados;
        $scope.$_estados_label = $attrs.noSelectionLabel || "Selecione um Estado";
      },
      template: '<select class="form-control" ng-options="estado.sigla as estado.sigla for estado in $_estados">' +
        '<option value="">{{$_estados_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham.pages').directive('compile', function ($compile) {
  return {
    scope: {
      compile: '=',
      entity: '=',
      entityname: '=',
      totalizador: '='
    },
    link: function ($scope, $element, $attrs) {

      $scope.$watch('compile', function (value) {
        // when the 'compile' expression changes
        // assign it into the current DOM
        $element.html(value);

        //we create a new scope to isolate events

        for (var i in $scope.$parent.$parent.$parent.$parent) {
          if (i.charAt(0) != '$' && i != 'this') {
            $scope[i] = $scope.$parent.$parent.$parent.$parent[i];
          }
        }

        $scope[$scope.entityname] = $scope.entity;
        if ($scope.totalizador) {
          $scope[$scope.totalizador] = $scope.totalizador;
        }

        $compile($element.contents())($scope);
      });

    }
  };
}).directive('grid', function ($parse) {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        entitiesList: '=entities',
        entityname: '@',
        pagesize: '@',
        paginationmethod: '@'
      },
      controller: function ($scope, $element, $attrs, $rootScope, $compile, $timeout) {
        var columns = $scope.columns = [];
        var elementColumns = $scope.elementColumns = [];
        var columnsFooter = $scope.columnsFooter = [];
        var elementColumnsFooter = $scope.elementColumnsFooter = [];
        $scope.entityname = $attrs.entityname;
        $scope.paginationmethod = $attrs.paginationmethod;
        $scope.totalizermethod = $attrs.totalizermethod;
        $scope.rangePages = [];
        $scope.recordsPerPage = $attrs.pagesize ? $attrs.pagesize : 10;
        $scope.gridId = $attrs.id;

        var atualizaEntities = function (list) {
          if (Array.isArray(list)) {
            $scope.entities = { totalRecords: list.length, number: 0, content: list };
            updateTotalizer(list);
          } else if (list === undefined || list === null) {
            $scope.entities = { totalRecords: 0, number: 0, content: [] };
            $scope.loadPage(0, true);
          } else {
            if (list && list.$promise) {
              list.$promise.then(function () {
                $scope.entities.content = list.content;
                $scope.entities.totalElements = list.totalElements;
                $scope.entities.number = list.number + 1;
                updateTotalizer(list.content);
              });
            }

          }
        };

        var updateTotalizer = function (itens) {
          if ($scope.totalizermethod) {
            $scope.totalizador = $scope.$parent[$scope.totalizermethod](itens);
          }
        };

        this.addcolumn = function (column, elementColumn) {
          columns.push(column);
          elementColumns.push(elementColumn);
        };

        this.addcolumnFooter = function (column, elementColumn) {
          columnsFooter.push(column);
          elementColumnsFooter.push(elementColumn);
        };

        $scope.render = function (column, model) {
          //$scope.sticky();
          return elementColumns[columns.indexOf(column)];
        };

        $scope.renderFooter = function (column, totalizador) {
          column.totalizador = totalizador;
          return elementColumnsFooter[columnsFooter.indexOf(column)];
        };

        var updateRange = function () {
          if ($scope.entities === null) {
            $scope.loadPage(1);
            return;
          }
          $scope.rangePages.length = 0;
          $scope.pageSize = Math.ceil(($scope.entities.totalElements || 1) / $scope.recordsPerPage);
          if (isNaN($scope.pageSize) || $scope.pageSize === 0) {
            $scope.pageSize = 1;
          }

          var startAt = $scope.entities.number - 5;
          if (startAt < 1) {
            startAt = 1;
          }

          var finishAt = startAt + 10;
          if (finishAt > $scope.pageSize) {
            finishAt = $scope.pageSize;
          }
          for (var i = startAt; i <= finishAt; i++) {
            $scope.rangePages.push(i);
          }
        };

        $scope.sticky = function () {
          // if ($($element).find('.table').attr('sticky-enable') === "true") {
          //   $(window).resize();
          // }
          // if ($attrs.sticky === "sticky" && $('.sticky-thead').length === 0) {
          //   $($element).find('.table').attr('sticky-enable', true).sticky();
          //   $timeout(function () {
          //     $(window).resize();
          //   }, 0);
          // }
        };

        $scope.loadPage = function (page, force) {
          if ((!$scope.entities || page != $scope.entities.number || force) && $scope.$parent[$scope.paginationmethod]) {
            var numberOfpages = $scope.getNumberOfpages();
            var newPage = page;
            if (numberOfpages !== 0 && newPage > numberOfpages) {
              newPage = numberOfpages;
            }
            $scope.$parent[$scope.paginationmethod](newPage - 1, $scope.recordsPerPage);
            $($element).find("tbody tr").each(function (i) {
              $(this).css({
                'transition-delay': 1.318 * i,
                'transition-duration': "#{0.3}s"
              });
            });
            $scope.sticky();
          }
        };

        $scope.previusPage = function () {
          if ($scope.entities.number > 1) {
            $scope.loadPage($scope.entities.number);
          }
        };

        $scope.nextPage = function () {
          if ($scope.entities.number < $scope.pageSize) {
            $scope.loadPage($scope.entities.number);
          }
        };

        $scope.lastPage = function () {
          var lastPage = $scope.getNumberOfpages();
          $scope.loadPage(lastPage);
        };

        $scope.getNumberOfpages = function () {
          if (!$scope.entities) {
            return 0;
          } else {
            return Math.ceil(($scope.entities.totalElements || 1) / $scope.recordsPerPage);
          }
        };

        $scope.$watch('entitiesList', atualizaEntities);
        $scope.$watch('entitiesList.content', updateRange);

        atualizaEntities($scope.entitiesList);
        updateRange();

      },
      templateUrl: 'app/pages/components/grid.html',
      replace: true
    };
  }).
  directive('gridcolumn', function () {
    return {
      require: '^grid',
      restrict: 'E',
      transclude: true,
      scope: { title: '@', style: '@', 'class': '@', type: '@', width: '@', weight: '@' },
      link: function (scope, element, attrs, tabsCtrl) {
        tabsCtrl.addcolumn(scope, element.html());
      },
      template: '<div ng-transclude></div>',
      replace: true
    };
  }).
  directive('gridcolumnfooter', function () {
    return {
      require: '^grid',
      restrict: 'E',
      transclude: true,
      scope: { title: '@', style: '@', 'class': '@', type: '@', width: '@', weight: '@', colspan: '@' },
      link: function (scope, element, attrs, tabsCtrl) {
        tabsCtrl.addcolumnFooter(scope, element.html());
      },
      template: '<div ng-transclude></div>',
      replace: true
    };
  });
angular.module('bentham.pages').directive('gridConsultas', ['Consulta', '$rootScope', function (Consulta, $rootScope) {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      ngModel: '=',
      searchMethod: '@'
    },
    controller: function ($scope, $element, $attrs) {
      $scope.tag = $attrs.tag;
      $rootScope.consultaCtrl.tag = $scope.tag;
      $scope.filter = {};
      $scope.searchMethod = $attrs.searchMethod;
      $rootScope.consultaCtrl.consultas = Consulta.obterPorTag({ tag: $scope.tag });
      $scope.consultaCtrl = $rootScope.consultaCtrl;
      $scope.consultaSelecionada = $rootScope.consultaSelecionada;

      $scope.deletarConsulta = $rootScope.consultaCtrl.deletar;

      $scope.showConsulta = function (consulta) {
        $rootScope.consultaCtrl.showModal(consulta, $scope);
      };

      $scope.selecionarConsulta = function (consulta) {
        $rootScope.consultaCtrl.selecionarConsulta(consulta, $scope);
      };

      $scope.showModalConsulta = function () {
        var consulta = $scope.filter.consulta;
        $rootScope.consultaCtrl.showModal($scope.tag);
      };

    },
    templateUrl: 'app/pages/components/gridconsulta.html',
    replace: true
  };
}]);
angular.module('bentham').directive('htmlBind', [ function () {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      element.html(attrs.htmlBind);
    }
  };
}]);
angular.module('bentham').
directive('consultaLabel', [function() {
    return {
      restrict: 'E',

      link: function(scope, element, attrs){},
      template: '<legend class="column"> Resultado {{labelConsulta | limitTo: 150}}{{labelConsulta.length > 150 ? "..." : "" }} </legend>'
    };
}]);
Number.prototype.formatMoney = function(c, d, t){
var n = this,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };

 //left padding with zero if the length is smaller than parameter size
 String.prototype.adjustLength = function(size){
  var stringAdjusted = this,
    length = this.length;

  if (length < size) {
    var diferenca = size - length;
    for (var i=0; i < diferenca; i++) {
      stringAdjusted = '0' + stringAdjusted;
    }
  }

  if (length > size) {
    stringAdjusted = stringAdjusted.substring(length - size);
  }

  return stringAdjusted;
 }
 /**
  * <input mask="myDate" ng-model="date" />
  * {{date | mask:'brDate'}}
  *
  * angular.module('bentham').inject.get('MaskService').formats['myDate'] = {
  *    format: function(value){
  *     return value; //go to input
  *    },
  *    parse: function(input) {
  *     return input; //go to ngModel
  *    }
  * }
  */

 angular.module('bentham')
  .factory('MaskService',function() {
    var currency = {
      format: function(ngModel,simbolo,precisao,thousandSymbol,digitSymbol) {
          var valor = ngModel||0;
          valor = parseFloat(valor);
          var precisao = precisao || 2;
          var output = "";
          if (simbolo) {
            output = simbolo+" "+output;
          }
          output += valor.formatMoney(precisao,digitSymbol,thousandSymbol);
          return output;
        },
        parse: function(valor,simbolo,precisao,max) {
          var precisao = precisao||2;
          max = max||19;
          precisao=parseInt(precisao);
          max=parseInt(max);
          max = max - precisao;
          var valor = valor || "0.00";
          var isNegative = valor.indexOf('-') != -1;
          valor = valor.replace(/[^0-9]/g,"")
          if(isNegative) {
            valor = '-'+valor
          }
          if (valor.length <= precisao) {
            var diferenca = precisao+1-valor.length;
            for (var i=0; i<=diferenca; i++) {
              valor = "0"+valor;
            }
          }
          var parteInteira = valor.substring(0,valor.length-precisao);
          if(parteInteira.length > max){
            parteInteira = parteInteira.substring(0, max);
          }
          var parteDecimal = valor.substring(valor.length-precisao);
          valor = parseFloat(parteInteira+'.'+parteDecimal);
          return valor;
        }
    }
    var formats = {
      'brDate': {
        type:'string',
        format: function(valor) {
        if (valor === null || valor === undefined || valor=="") {
          valor = "0000-00-00";
        } else if(valor && valor.length > 10){
          valor = valor.substr(0,10)
        }
        var valor = valor.replace(/[^0-9]/g,"");

        valor = valor.adjustLength(8);

        return [valor.substr(6,2),valor.substr(4,2),valor.substr(0,4)].join('/');
        },
        parse: function(valor) {
          if (valor==undefined || valor=="") {
          valor = "00/00/0000";
        }
        var valor = valor.replace(/[^0-9]/g,"");

        valor = valor.adjustLength(8);

        return [valor.substr(4,4),valor.substr(2,2),valor.substr(0,2)].join('-');
        },
        validate: function(valor) {
          //The date is valid only if it is in 'dd/MM/yyyy' or 'dd-MM-yyyy' format and the year is between 1900 and 2099
          var brDateRegex = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-](19|20)\d{2}$/g;
          return brDateRegex.test(valor);
        }
      },
      'brTimestamp': {
        type:'string',
        format: function(valor) {
        if (valor==undefined || valor=="") {
          valor = "0000-00-00 00:00:00";
        }
        var valor = valor.replace(/[^0-9]/g,"");

        valor = valor.adjustLength(15);

        return [valor.substr(7,2),valor.substr(5,2),valor.substr(1,4)].join('/') + ' ' + [valor.substr(9,2),valor.substr(11,2),valor.substr(13,2)].join(':');
        },
        parse: function(valor) {
          if (valor==undefined || valor==""){
          valor = "00/00/0000 00:00:00";
        }
        var valor = valor.replace(/[^0-9]/g,"");

        valor = valor.adjustLength(15);

        return [valor.substr(5,4),valor.substr(3,2),valor.substr(1,2)].join('-') + ' ' + [valor.substr(9,2),valor.substr(11,2),valor.substr(13,2)].join(':');
        },
        validate: function(valor) {
          var brDateHourRegex = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-](19|20)\d{2}[\s](2[0-3]|1[0-9]|0[0-9]|[^0-9][0-9]):([0-5][0-9]|[0-9]):([0-5][0-9]|[0-9])$/g;
          return brDateHourRegex.test(valor);
        }
      },
      'inteiro': {
        type: 'number',
        format: function(valor,max,maxNumber){

          if(valor){
                  valor = valor.toString().replace(/[^0-9]/g,"");
                  if(max){
                    if(valor.length > max){
                      valor = valor.substr(0, max)
                    }
                  }
                  if(maxNumber){
                    if(parseInt(valor) > parseInt(maxNumber)){
                      valor = maxNumber;
                    }
                  }
                  return valor;
          } else{
            return "";
            }
        },
        parse: function(valor,max, maxNumber) {
          if(valor){
          valor = valor.toString().replace(/[^0-9]/g,"");
                if(max){
                  if(valor.length > max){
                    valor = valor.substr(0, max)
                  }
                }
                if(maxNumber){
                  if(parseInt(valor) > parseInt(maxNumber)){
                    valor = maxNumber;
                  }
                }
                return valor;
        } else{
          return "";
        }

        },
        validate: function(valor){
          var realRegex = new RegExp(/[0-9]/g);
          var regexValid = realRegex.test(valor.toString());
          return regexValid;
        }
      },
      'real': {
        type: 'number',
        format: function(ngModel,simbolo,precisao) {
          simbolo=simbolo===true||simbolo=='true'?'R$':undefined;
          return currency.format(ngModel,simbolo,precisao,'.',',');
        },
        parse: function(valor,simbolo,precisao) {
          return currency.parse(valor,simbolo,precisao, 12);
        },
        validate: function(valor, simbolo, precisao, min, max){
          simbolo=simbolo===true||simbolo=='true'?'R\\$ ':'';
          precisao = precisao || 2;
          var realRegex = "";

          if(precisao == "0") {
            realRegex = new RegExp('^('+simbolo+'[-]?((\\d{1,3})(\\.\\d{3})*)|(\\d+))$','g');
          } else {
            realRegex = new RegExp('^('+simbolo+'[-]?((\\d{1,3})(\\.\\d{3})*)|(\\d+))(,\\d{'+precisao+'})$','g');
          }
          //if (min===undefined)  min = "0.01";
          var valorNumerico = currency.parse(valor,simbolo,precisao);
          var minInvalid = min!=undefined && Number(min) > valorNumerico;
          var maxInvalid = max!=undefined && Number(max) < valorNumerico;
          var regexValid = realRegex.test(valor);
          return regexValid && !minInvalid && !maxInvalid;
        }
      },
      'dolar': {
        type: 'number',
        format: function(ngModel,simbolo,precisao) {
          simbolo=simbolo===true||simbolo=='true'?'US$':undefined;
          return currency.format(ngModel,simbolo,precisao,',','.');
        },
        parse: function(valor,simbolo,precisao) {
          return currency.parse(valor,simbolo,precisao);
        },
        validate: function(valor, simbolo, precisao, min, max){
          simbolo=simbolo===true||simbolo=='true'?'US\\$ ':'';
          precisao = precisao || 2;
          var dolarRegex = new RegExp('^('+simbolo+'[-]?((\\d{1,3})(,\\d{3})*)|(\\d+))(\\.\\d{'+precisao+'})$','g');
          if (min==undefined) {
            min = "0.01"
          }
          var valorNumerico = currency.parse(valor,simbolo,precisao);
          var minInvalid = min!=undefined && Number(min) > valorNumerico;
          var maxInvalid = max!=undefined && Number(max) < valorNumerico;
          var regexValid = dolarRegex.test(valor);
          return regexValid && !minInvalid && !maxInvalid;
        }
      },
      'cpf': {
        type: 'string',
        format: function(valor) {
          var cpf;
          if (valor == undefined) {
            cpf = "";
          } else {
            cpf = valor.toString();
          }

          cpf = cpf.replace(/[^0-9]/g,"");
          cpf = cpf.adjustLength(11);

          return [[cpf.substring(0,3),cpf.substring(3,6),cpf.substring(6,9)].join('.'),cpf.substring(9,11)].join('-');
        },
        parse: function(valor) {

          if (valor==undefined || valor=="") {
            valor = "000.000.000-00";
          }

          var valor = valor.replace(/[^0-9]/g,"");
          valor = valor.adjustLength(11);

          return valor;
        },
        validate: function(valor) {
          var cpfRegex = /^\d{3}.\d{3}.\d{3}-\d{2}$/g;
          return cpfRegex.test(valor) && validarCpf(valor);
        }
      },
      'cnpj': {
        type: 'string',
        format: function(valor) {
          if(valor){
            valor = valor.toString();
            valor = valor.replace(/[^0-9]/g,"");
          }

          var cnpj;
          if (valor == undefined) {
            cnpj = "";
          } else {
            cnpj = valor.toString();
          }

          cnpj = cnpj.adjustLength(14);

          return [[[cnpj.substring(0,2),cnpj.substring(2,5),cnpj.substring(5,8)]
              .join('.'),cnpj.substring(8,12)].join('/'),cnpj.substring(12,14)].join('-');
        },
        parse: function(valor) {
          if (valor==undefined || valor=="") {
            valor = "00.000.000/0000-00";
          }
          var valor = valor.replace(/[^0-9]/g,"");

          return parseInt(valor);
        },
        validate: function(valor) {
          var cnpjRegex = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/g;
          return cnpjRegex.test(valor) && validarCnpj(valor);
        }
      },
      'email':{
        type: 'string',
        format: function(valor){
          return valor;
        },
        parse: function(valor){
          return valor;
        },
        validate: function(valor){
          var emailRegex = /^[\w\.\-]+@[a-zA-Z_-]+?\.[a-zA-Z\.]+[^.*]$/;
          if(valor){
            return emailRegex.test(valor.trim());
          }else{
            return false;
          }
        }
      },
      'cep':{
        type: 'string',
        format: function(valor){
          if(valor){
            valor = valor.toString();
            valor = valor.replace(/[^0-9]/g,"");
          }

          var cep;
          if (valor === undefined) {
            cep = "";
          }else if(valor === null){
            cep = "";
          } else {
            cep = valor.toString();
          }

          cep = cep.adjustLength(8);

          return [[[cep.substring(0,2),cep.substring(2,5)]
              .join('.'),cep.substring(5,8)].join('-')];
        },
        parse: function(valor){
          valor = valor.toString();
          valor = valor.replace(/[^0-9]/g,"");
          return valor;
        },
        validate: function(valor){
          if(valor){
            return valor !== "00000000";
          }else{
            return false;
          }
        }
      },
      'mes': {
        type: 'string',
        format: function(valor){
          if(valor == undefined)
            return "00/0000";

          valor = valor.replace(/[^0-9]/g,"");
          valor = valor.adjustLength(6);
          return [valor.substring(0,2),valor.substring(2,6)].join("/");
        },
        parse: function(valor){
          if(valor == undefined || valor == "")
            return "00/0000";

          if(valor.length == 8){
            valor = valor.replace(/[^0-9]/g,"");
            valor = valor.substring(1,7);
            valor = [valor.substring(0,2),valor.substring(2,6)].join("/");
          }

          return valor;
        },
        validate: function(valor){
          var mesRegex = /^\d{2}\/\d{4}$/g;
          var mes = valor.substring(0,2);
          mes = parseInt(mes);

          return mesRegex.test(valor) && (mes > 0 && mes <= 12);
        }
      },
      'mesAno': {
        type:'string',
        format: function(valor) {
        if (valor === null || valor === undefined || valor==="") {
          valor = "0000-00-00";
        } else if(valor && valor.length > 8){
          valor = valor.substr(0,8);
        }
        var valor = valor.replace(/[^0-9]/g,"");

        valor = valor.adjustLength(6);

        return [valor.substr(4,2),valor.substr(0,4)].join('/');
        },
        parse: function(valor) {
          if (valor===undefined || valor=="") {
          valor = "00/0000";
        }
        var valor = valor.replace(/[^0-9]/g,"");

        valor = valor.adjustLength(6);

        return [valor.substr(2,4),valor.substr(0,2)].join('-');
        },
        validate: function(valor) {
          //The date is valid only if it is in 'MM/yyyy' or 'MM-yyyy' format and the year is between 1900 and 2099
          var brDateRegex = /^(0?[1-9]|1[012])[\/\-](19|20)\d{2}$/g;
          return brDateRegex.test(valor);
        }
      }
    };

    var validarCpf = function(cpf) {
      cpf = cpf.replace(/[^\d]+/g,'');
      if(cpf == '') return false;
      // Elimina CPFs invalidos conhecidos
      if (cpf.length != 11 ||
          cpf == "00000000000" ||
          cpf == "11111111111" ||
          cpf == "22222222222" ||
          cpf == "33333333333" ||
          cpf == "44444444444" ||
          cpf == "55555555555" ||
          cpf == "66666666666" ||
          cpf == "77777777777" ||
          cpf == "88888888888" ||
          cpf == "99999999999")
              return false;
      // Valida 1o digito
      add = 0;
      for (i=0; i < 9; i ++)
          add += parseInt(cpf.charAt(i)) * (10 - i);
          rev = 11 - (add % 11);
          if (rev == 10 || rev == 11)
              rev = 0;
          if (rev != parseInt(cpf.charAt(9)))
              return false;
      // Valida 2o digito
      add = 0;
      for (i = 0; i < 10; i ++)
          add += parseInt(cpf.charAt(i)) * (11 - i);
      rev = 11 - (add % 11);
      if (rev == 10 || rev == 11)
          rev = 0;
      if (rev != parseInt(cpf.charAt(10)))
          return false;
      return true;
    };

    var validarCnpj = function validarCNPJ(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g,'');

      if(cnpj == '') return false;

      if (cnpj.length != 14)
          return false;

      // Elimina CNPJs invalidos conhecidos
      if (cnpj == "00000000000000" ||
          cnpj == "11111111111111" ||
          cnpj == "22222222222222" ||
          cnpj == "33333333333333" ||
          cnpj == "44444444444444" ||
          cnpj == "55555555555555" ||
          cnpj == "66666666666666" ||
          cnpj == "77777777777777" ||
          cnpj == "88888888888888" ||
          cnpj == "99999999999999")
          return false;

      // Valida DVs
      tamanho = cnpj.length - 2
      numeros = cnpj.substring(0,tamanho);
      digitos = cnpj.substring(tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
              pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0))
          return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0,tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
              pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1))
            return false;

      return true;
    }

    return {
      formats: formats
    }
  })
  .directive('mask', ['MaskService',function (MaskService) {
    return {
    restrict: 'A',
      require: 'ngModel',
      scope:{
        ngRequired: '='
      }, link: function (scope, element, attr, modelCtrl) {

        var maskAttrs, maskName, mask;

        var formatter =  function (modelValue) {
          var attrs = [modelValue].concat(maskAttrs);
          var valorFormatado = mask.format.apply(mask,attrs);
          if(element.attr('required')) {
            var valid = mask.validate.apply(mask, [valorFormatado].concat(maskAttrs));
            modelCtrl.$setValidity(attr.ngModel, valid);
          }

          return valorFormatado;
        };

        var getOnlyNumber = function(value){
          var numsStr = value.replace(/[^0-9]/g,'');
          return parseInt(numsStr);
        };

        var parser = function (viewValue) {
          var attrs = [viewValue].concat(maskAttrs);
          var valor = mask.parse.apply(mask,attrs);
          var valorFormatado = formatter(valor);
          if(valorFormatado != modelCtrl.$viewValue){
            element.val(valorFormatado);
          }

          var valid = mask.validate.apply(mask, [valorFormatado].concat(maskAttrs));
          if(viewValue!==""){
            if(element.attr('required')) {
              modelCtrl.$setValidity(attr.ngModel, valid);
            }else if(getOnlyNumber(viewValue) > 0){
              modelCtrl.$setValidity(attr.ngModel, valid);
            }else{
              modelCtrl.$setValidity(attr.ngModel, true);
              modelCtrl.$setPristine();
            }
          }

          return valid ? valor : undefined;
        };

        attr.$observe('mask', function(value){

          modelCtrl.$parsers.splice(modelCtrl.$parsers.indexOf(parser),1);
          modelCtrl.$formatters.splice(modelCtrl.$formatters.indexOf(formatter),1);

          if(value !== undefined && value != ''){
            maskAttrs = attr.mask.split(':');
            maskName = maskAttrs.shift();
            mask = MaskService.formats[maskName];

            parser(element.val());

            modelCtrl.$parsers.unshift(parser);
            modelCtrl.$formatters.push(formatter);
          } else {
            element.val('');
          }

        });

      }
    };
  }]);


angular.module('bentham')
  .filter('mask', ['MaskService', function(MaskService) {
    return function() {
      var arguments = $.makeArray(arguments);
      var input = arguments.shift();
      var maskName = arguments.shift();

      var mask = MaskService.formats[maskName];

      if (mask) {
         arguments.unshift(input);
       return mask.format.apply(this,arguments);
      } else {
         return input;
      }
      };
    }]);

angular.module('bentham').
  directive('modalBentham', function() {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        title: '@',
        bindTo: '=',
        onModalHidden: '&',
        class: '@',
        style: '@'
      },
      controller: function($scope, $element) {

        $scope.bindTo = {
            open: function() {
              $($element).find('.modal').modal({
                keyboard: true,
                show:true,
                backdrop: true
              });
              $scope.isClosed = false;
            },
            close: function(callback) {
              $($element).find('.modal').modal('hide');
              if(callback){
                callback();
                $scope.isClosed = true;
              }
            },
            onHidden: function(callback){
              $scope.$on('modal:close', callback);
            },
            isClosed: function(){
              return $scope.isClosed;
            }
        };

        $scope.isClosed = true;

        if ($scope.onModalHidden) {
            $scope.bindTo.onHidden($scope.onModalHidden);
        }
        $($element).find('.modal').on('hidden.bs.modal', function(){
            $("html").removeClass('modal-open');
            $scope.$emit('modal:close');
            $scope.isClosed = true;
        });

        $($element).find('.modal').on('shown.bs.modal', function(){
            $("html").addClass('modal-open');
            $scope.isClosed = false;
        });

      },
      templateUrl: 'app/pages/component/modal.html',
      replace: true
    };
  }).
  directive('modalContent', function() {
    return {
      restrict: 'E',
      transclude: true,
      template:
        '<div class="modal-body"><section ng-transclude></section></div>',
      replace: true
    };
  }).
  directive('modalFooter', function() {
    return {
      restrict: 'E',
      transclude: true,
      template:
        '<div class="modal-footer" ng-transclude></div>',
      replace: true
    };
  });

angular.module('bentham').
	directive('permitido',['Security', function(Security){
		return{
			link: function(scope, element, attr){
				Security.permitido(attr.permitido,function(data){
					if(!data.permitido){
						element.hide();
					}
				});
			}

		};
	}]);
angular.module('bentham').directive('filtroconsulta', ['$rootScope', function($rootScope) {
  return {
    restrict: 'C',
    link: function($scope, $element, $attrs, filterCtrl) {
      $rootScope.filtersName = $rootScope.filtersName || [];
      var filtro  = {name: $element.attr("name"), scope: $scope};
      var isDuplicate = $rootScope.filtersName.some(function(item, index, array) {
        return (item.name == filtro.name);
      });
      if (!isDuplicate) {
        $rootScope.filtersName.push(filtro);
      }
    }
  };
}]);

angular.module('bentham')
.directive('dynamicPlaceholder',
  function() {
    return {
        restrict: 'A',
        link: function ($scope, element, attrs) {
            attrs.$observe('dynamicPlaceholder', function(value) {
                element.attr('placeholder', value);
            });
        }
    };
});
angular.module('bentham').
  directive('required', ['$parse', '$rootScope', function ($parse, $rootScope) {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        var label = $(document).find('label').filter(function () { return $(this).attr('for') == $(elem).attr('name'); })[0];
        $(label).append('&nbsp; <i style="font-size:7px;" class="fa fa-asterisk fa-xs"></i>');
        // var input = $(document).find('input').filter(function () { return $(this).attr('required') });
        // $(input).addClass('');
      }
    };
  }]);

angular.module('bentham').
directive('stringLimiter', [function() {
    return {
      restrict: 'E',
      scope:{
        maxlength: '=',
        text: '@',
        limiter: '@'
      },
      link: function(scope, element, attrs){},
      template: '{{text | limitTo: maxlength}}{{text.length > maxlength ? limiter : "" }}'
    };
}]);
angular.module('bentham').
  directive('tabs', function() {
    return {
      restrict: 'E',
      transclude: true,
      controller: function($scope, $element) {
        var panes = $scope.$_panes = [];

        $scope.select = function(pane) {
          if(!pane.selected && pane.onShow){
            pane.onShow();
          }
          angular.forEach(panes, function(pane) {
            pane.selected = false;
          });
          pane.selected = true;
          $($element).children(".tab-content").children('.tab-pane').removeClass('active');
          $($element).find('[title="'+pane.title+'"]').addClass('active');
        }

        this.addPane = function(pane) {
          if (panes.length == 0) $scope.select(pane);
          if (!Array.contains(panes,pane,'title')) {
            Array.add(panes,pane);
          }
        }

        this.removePane = function(pane) {
          Array.remove(panes,pane);
        }
      },
      template:
        '<div class="tabbable">' +
          '<ul class="nav nav-tabs">' +
            '<li ng-repeat="pane in $_panes" ng-class="{active:pane.selected}">'+
              '<a href="" ng-click="select(pane)">{{pane.title}}</a>' +
            '</li>' +
          '</ul>' +
          '<div class="tab-content" ng-transclude></div>' +
        '</div>',
      replace: true
    };
  }).
  directive('pane', function() {
    return {
      require: '^tabs',
      restrict: 'E',
      transclude: true,
      scope: {
        onShow: '&',
        tabShow: '='
      },
      link: function(scope, element, attrs, tabsCtrl) {
        var pane  = {title: attrs.title, onShow: scope.onShow}
  	  	scope.$watch('tabShow',function(show){
      		if (show==undefined || show) {
      			tabsCtrl.addPane(pane);
      		} else {
      			tabsCtrl.removePane(pane);
      		}
      	});
      },
      template:
        '<div class="tab-pane" ng-transclude >' +
        '</div>',
      replace: true
    };
  })

angular.module('bentham')
  .directive('uppercaseOnly', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ctrl) {
        element.on('keypress', function(e) {
          var char = e.char || String.fromCharCode(e.charCode);
        });

        function parser(value) {
          if (ctrl.$isEmpty(value)) {
            return value;
          }
          var formatedValue = value.toUpperCase();
          if (ctrl.$viewValue !== formatedValue) {
            ctrl.$setViewValue(formatedValue);
            ctrl.$render();
          }
          return formatedValue;
        }

        function formatter(value) {
          if (ctrl.$isEmpty(value)) {
            return value;
          }
          return value.toUpperCase();
        }

        ctrl.$formatters.push(formatter);
        ctrl.$parsers.push(parser);
      }
    };
  });
angular.module('bentham').
directive('uppercaseOnly', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ctrl) {
        element.on('keypress', function(e) {
          var char = e.char || String.fromCharCode(e.charCode);
        });

        function parser(value) {
          if (ctrl.$isEmpty(value)) {
            return value;
          }
          var formatedValue = value.toUpperCase();
          if (ctrl.$viewValue !== formatedValue) {
            ctrl.$setViewValue(formatedValue);
            ctrl.$render();
          }
          return formatedValue;
        }

        function formatter(value) {
          if (ctrl.$isEmpty(value)) {
            return value;
          }
          return value.toUpperCase();
        }

        ctrl.$formatters.push(formatter);
        ctrl.$parsers.push(parser);
      }
    };
  });
/**
 * @author Renato Alves
 * created on 01.02.2018
 */
(function () {
    'use strict';
  
    angular.module('bentham.pages.configuracoes')
      .controller('ModalsPageCtrl', ModalsPageCtrl);
  
    /** @ngInject */
    function ModalsPageCtrl($scope, $uibModal, baProgressModal) {
      $scope.open = function (page, size) {
        $uibModal.open({
          animation: true,
          templateUrl: page,
          size: size,
          resolve: {
            items: function () {
              return $scope.items;
            }
          }
        });
      };
      $scope.openProgressDialog = baProgressModal.open;
    }
  
  
  })();
  
angular.module("bentham").factory('Enum',function($resource, prefixRoute){
    return $resource(prefixRoute + 'enum',
      {},
      {
        all: {
          method:'GET',
          url: prefixRoute + 'enum',
          isArray: true
        },
        getEnumPorTipoNome: {
          method:'GET',
          url: prefixRoute + 'enum/value'
        }
      }
    );
  });
angular.module('bentham').factory('Reajuste', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'reajustes/:id', { id: '@id', }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'reajustes/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'reajustes',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'reajustes/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        }
    });
});

angular.module('bentham').factory('ReajusteoService', function (Reajuste, GenericService, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Reajuste();
    Object.setPrototypeOf(self.resource, Reajuste);
    return function () { return self; };
});
angular.module('bentham').factory('FormaDePagamento', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'formas-de-pagamento/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'formas-de-pagamento/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'formas-de-pagamento',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'formas-de-pagamento/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }
  
            },
        });
  });
  
  angular.module('bentham').factory('FormaDePagamentoService', function (GenericService, FormaDePagamento, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new FormaDePagamento();
    Object.setPrototypeOf(self.resource, FormaDePagamento);
    return function () { return self; };
  });
angular.module('bentham').controller('GanttCtrl', function ($scope, $timeout, $log, GanttObjectModel, ganttDebounce) {
    var self = this;
    var objectModel;
    var dataToRemove;
    var today = new Date();

    $scope.loading = true;
    $scope.filtro = {};
    $scope.data = []; //Json dos dados na estrutura do gantt
    moment.locale('pt-br');

    $scope.$watch("rows",function(newValue,oldValue){
		if(newValue.length > 0)
            $scope.load(newValue);
	});

    $scope.load = function(rows){
        $scope.loading = true;
        $scope.data = []; 
        $scope.data = $scope.data.concat(rows);
        dataToRemove = $scope.data;
        $scope.timespans = function () {
            return [{
                from: new Date(new Date().getFullYear() - 1, new Date().getMonth() + 1, 21, 8, 0, 0),
                to: new Date(new Date().getFullYear() + 1, new Date().getMonth() + 1, 25, 15, 0, 0),
                name: 'Sprint 1 Timespan'
            }];
        }
        $scope.loading = false;
    };

    // Remove data action
    $scope.remove = function () {
        $scope.api.data.remove(dataToRemove);
    };

    $scope.activate = function(columns, start, end){
        $scope.headersFormats = { 
            'year': 'YYYY', 
            'quarter': '[Q]Q YYYY', 
            month: 'MM/YYYY', 
            week: 'w', 
            day: 'D', 
            hour: 'H', 
            minute:'H:mm',
            second:'H:mm:ss',
            millisecond:'H:mm:ss:SSS'
        };
        $scope.scalas = [
            { label: 'Semana', value: 'week'},
            { label: '2 Semanas', value: '2 weeks'},
            { label: 'Meses', value: 'month' },
            { label: '4 Meses', value: 'quarter' },
            { label: 'Semestre', value: '6 months' },
            { label: 'Ano', value: 'year' }
        ];
        $scope.sortMode = [
            { label: 'Desabilitado', value: undefined }, 
            { label: 'Nome', value: 'model.name' },
            { label: 'Inicio', value: 'from' }, 
            { label: 'Fim', value: 'to' }
        ];
        $scope.timeFramesNonWorkingMode = [
            { label: 'Visualizar', value: 'visible' },
            { label: 'Ocultar', value: 'hidden' }, 
            { label: 'Cortadas', value: 'cropped' }
        ];

        $scope.options = {
            mode: 'custom', //Modo do gráfico de gantt 
            scale: 'month', //A Escala da faixa de tempo utilizada para mostrar o grafico
            //sortMode: 'from', //Qual a coluna vai ser utilizada para ordenar as atividades (Name, From, To)
            sideMode: 'Table', //Table, TreeTable, Tree
            showSide: true, //Mostre a serio lateral. Certifique-se de que um plugin de sero lateral (por exemplo, arvore ou tabela) a ativado caso contr�rio a se��o lateral n�o � mostrada.
            daily: true, //Preenche as tarefas arredondando suas datas de / ate o inicio / fim do dia.
            maxHeight: false, //Altura máxima do Gantt. Ele ira mostrar uma barra de rolagem vertical se o conte�do n�o caber dentro.
            width: true, //Habilitar largura dinâmica
            zoom: 0.4, //
            columns: columns, //
            treeTableColumns: ['from', 'to'], //
            columnsHeaders: {
                'status': "Status",
                'name': 'Descrição',
                'from': 'Inicio',
                'to': 'Fim',
                'prazo': 'Prazo',
                'centroDeCusto': 'Centro de Custo',
                'tipo': 'Tipo',
                'porcentagemSucesso': 'Suce %',
                'valorEmpresa': 'Valor da Empresa',
                'valorSucesso': 'Valor de Sucesso',
                'cliente': 'Cliente',
                'estado': 'UF',
                'responsavel': 'Responsável',
            }, //
            columnsClasses: {
                'name': 'gantt-column-name',
                'from': 'gantt-column-from',
                'to': 'gantt-column-to'
            }, //
            columnsFormatters: {
                'status': function (name, column, row) { return row.model.status; },
                'name': function (name, column, row) { return row.model.name; /* !== undefined ? row.name.slice(1, 35).concat("...") : 'Etapa'; */ },
                'from': function (from) { return from !== undefined ? from.format('ll') : undefined; },
                'to': function (to) { return to !== undefined ? to.format('ll') : undefined; },
                'prazo': function (name, column, row) { return row.model.prazo; },
                'centroDeCusto': function (name, column, row) { return row.model.centroDeCusto;  },
                'tipo': function (name, column, row) { return row.model.tipo;  },
                'porcentagemSucesso': function (name, column, row) { return row.model.porcentagemSucesso; },
                'valorEmpresa': function (name, column, row) { return row.model.valorEmpresa; },
                'valorSucesso': function (name, column, row) { return row.model.valorSucesso; },
                'cliente': function (name, column, row) { return row.model.cliente; },
                'estado': function (name, column, row) { return row.model.estado; },
                'responsavel': function (name, column, row) { return row.model.responsavel; }
            },
            columnWidth: 50,
            treeHeaderContent: '<i class="fa fa-align-justify"></i> {{getHeader()}}', //
              columnsHeaderContents: {
                'name': '<i class="fa fa-align-justify"></i> {{getHeader()}}',
                'from': '<i class="fa fa-calendar"></i> {{getHeader()}}',
                'to': '<i class="fa fa-calendar"></i> {{getHeader()}}'
            },
            autoExpand: 'both', //'none',
            taskOutOfRange: 'truncate', //
            fromDate: start ? start : new Date(today.getFullYear() + '-01-01T00:00:00'), //Assegura que a renderizaçãoo do gráfico começa nesta data. Isto é util para mostrar o gráfico mesmo sem quaisquer tarefas,  ou tempo vazio antes da primeira tarefa, ou truncar tarefas anteriores.
            toDate: end ? end : new Date(today.getFullYear() + '-12-31T00:00:00'), //undefined,//a mesma funcao acima mas assegura que va pelo menos ate esta data
            rowContent: '<i class="fa fa-align-justify"></i> {{row.name}}', //
            taskContent: '<i class="fa fa-tasks"></i> {{task.content}}', //
            allowSideResizing: true, //
            labelsEnabled: true, //
            currentDate: 'line', //
            draw: false, //
            readOnly: true, //
            groupDisplayMode: 'group', //
            filterTask: '',
            filterRow: '',
            timeFrames: {
                'day': {
                    start: moment('8:00', 'HH:mm'),
                    end: moment('20:00', 'HH:mm'),
                    working: true,
                    default: true
                },
                'noon': {
                    start: moment('12:00', 'HH:mm'),
                    end: moment('13:30', 'HH:mm'),
                    working: false,
                    default: true
                },
                'weekend': {
                    working: false
                },
                'holiday': {
                    working: false,
                    color: 'red',
                    classes: ['gantt-timeframe-holiday']
                }
            },
            //
            dateFrames: {
                'weekend': {
                    evaluator: function (date) {
                        return date.isoWeekday() === 6 || date.isoWeekday() === 7;
                    },
                    targets: ['weekend']
                },
                '11-november': {
                    evaluator: function (date) {
                        return date.month() === 10 && date.date() === 11;
                    },
                    targets: ['holiday']
                }
            },
            timeFramesNonWorkingMode: 'hidden',
            columnMagnet: '15 minutes',
            timeFramesMagnet: true,

            canDraw: function (event) {
                var isLeftMouseButton = event.button === 0 || event.button === 1;
                return $scope.options.draw && !$scope.options.readOnly && isLeftMouseButton;
            },

            drawTaskFactory: function () {
                return {
                    id: utils.randomUuid(), // Unique id of the task.
                    name: 'Tarefa nova', // Name shown on top of each task.
                    color: '#EEF231' // Color of the task in HEX format (Optional).
                };
            },

            api: function (api) {
                $scope.api = api;
                api.core.on.ready($scope, function () {
                    api.scroll.on.scroll($scope, logScrollEvent);
                    api.core.on.ready($scope, logReadyEvent);

                    api.data.on.remove($scope, addEventName('data.on.remove', logDataEvent));
                    api.data.on.load($scope, addEventName('data.on.load', logDataEvent));
                    api.data.on.clear($scope, addEventName('data.on.clear', logDataEvent));

                    api.tasks.on.add($scope, addEventName('tasks.on.add', logTaskEvent));
                    api.tasks.on.change($scope, addEventName('tasks.on.change', logTaskEvent));
                    api.tasks.on.rowChange($scope, addEventName('tasks.on.rowChange', logTaskEvent));
                    api.tasks.on.remove($scope, addEventName('tasks.on.remove', logTaskEvent));

                    if (api.tasks.on.moveBegin) {
                        api.tasks.on.moveBegin($scope, addEventName('tasks.on.moveBegin', logTaskEvent));
                        //api.tasks.on.move($scope, addEventName('tasks.on.move', logTaskEvent));
                        api.tasks.on.moveEnd($scope, addEventName('tasks.on.moveEnd', logTaskEvent));

                        api.tasks.on.resizeBegin($scope, addEventName('tasks.on.resizeBegin', logTaskEvent));
                        //api.tasks.on.resize($scope, addEventName('tasks.on.resize', logTaskEvent));
                        api.tasks.on.resizeEnd($scope, addEventName('tasks.on.resizeEnd', logTaskEvent));
                    }

                    api.rows.on.add($scope, addEventName('rows.on.add', logRowEvent));
                    api.rows.on.change($scope, addEventName('rows.on.change', logRowEvent));
                    api.rows.on.move($scope, addEventName('rows.on.move', logRowEvent));
                    api.rows.on.remove($scope, addEventName('rows.on.remove', logRowEvent));

                    api.side.on.resizeBegin($scope, addEventName('labels.on.resizeBegin', logLabelsEvent));
                    //api.side.on.resize($scope, addEventName('labels.on.resize', logLabelsEvent));
                    api.side.on.resizeEnd($scope, addEventName('labels.on.resizeEnd', logLabelsEvent));

                    api.timespans.on.add($scope, addEventName('timespans.on.add', logTimespanEvent));
                    api.columns.on.generate($scope, logColumnsGenerateEvent);

                    api.rows.on.filter($scope, logRowsFilterEvent);
                    api.tasks.on.filter($scope, logTasksFilterEvent);
                    //Aparecer um icone para deletar
                    api.data.on.change($scope, function (newData) {
                        //if (dataToRemove === undefined) {
                        //    dataToRemove = [
                        //        { 'id': newData.data[2].id },  //Remove Kickoff row
                        //        {
                        //            'id': newData.data[0].id, 'tasks': [
                        //            { 'id': newData.data[0].tasks[0].id },
                        //            { 'id': newData.data[0].tasks[3].id }
                        //            ]
                        //        },  //Remove some Milestones
                        //        {
                        //            'id': newData.data[6].id, 'tasks': [
                        //            { 'id': newData.data[6].tasks[0].id }
                        //            ]
                        //        }  //Remove order basket from Sprint 2
                        //    ];
                        //}
                    });

                    // Add some DOM events
                    api.directives.on.new($scope, function (directiveName, directiveScope, element) {
                        if (directiveName === 'ganttTask') {
                            element.bind('click', function (event) {
                                event.stopPropagation();
                                logTaskEvent('task-click', directiveScope.task);
                            });
                            element.bind('mousedown touchstart', function (event) {
                                event.stopPropagation();
                                $scope.live.row = directiveScope.task.row.model;
                                if (directiveScope.task.originalModel !== undefined) {
                                    $scope.live.task = directiveScope.task.originalModel;
                                } else {
                                    $scope.live.task = directiveScope.task.model;
                                }
                                $scope.$digest();
                            });
                        } else if (directiveName === 'ganttRow') {
                            element.bind('click', function (event) {
                                event.stopPropagation();
                                logRowEvent('row-click', directiveScope.row);
                            });
                            element.bind('mousedown touchstart', function (event) {
                                event.stopPropagation();
                                $scope.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });
                        } else if (directiveName === 'ganttRowLabel') {
                            element.bind('click', function () {
                                logRowEvent('row-label-click', directiveScope.row);
                            });
                            element.bind('mousedown touchstart', function () {
                                $scope.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });
                        }
                    });

                    api.tasks.on.rowChange($scope, function (task) {
                        $scope.live.row = task.row.model;
                    });

                    objectModel = new GanttObjectModel(api);
                });
            }
        };
    };

    $scope.handleTaskIconClick = function (taskModel) {
        alert('Icon from ' + taskModel.name + ' task has been clicked.');
    };

    $scope.handleRowIconClick = function (rowModel) {
        alert('Icon from ' + rowModel.name + ' row has been clicked.');
    };

    $scope.expandAll = function () {
        $scope.api.tree.expandAll();
    };

    $scope.collapseAll = function () {
        $scope.api.tree.collapseAll();
    };

    $scope.$watch('options.sideMode', function (newValue, oldValue) {
        if (newValue !== oldValue) {
            $scope.api.side.setWidth(undefined);
            $timeout(function () {
                $scope.api.columns.refresh();
            });
        }
    });

    $scope.canAutoWidth = function (scale) {
        if (scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/)) {
            return false;
        }
        return true;
    };

    $scope.getColumnWidth = function (widthEnabled, scale, zoom) {
        if (!widthEnabled && $scope.canAutoWidth(scale)) {
            return undefined;
        }

        if (scale.match(/.*?week.*?/)) {
            return 150 * zoom;
        }

        if (scale.match(/.*?month.*?/)) {
            return 300 * zoom;
        }

        if (scale.match(/.*?quarter.*?/)) {
            return 500 * zoom;
        }

        if (scale.match(/.*?year.*?/)) {
            return 800 * zoom;
        }

        return 40 * zoom;
    };


    $scope.live = {};

    var debounceValue = 1000;

    var listenTaskJson = ganttDebounce(function (taskJson) {
        if (taskJson !== undefined) {
            var task = angular.fromJson(taskJson);
            objectModel.cleanTask(task);
            var model = $scope.live.task;
            angular.extend(model, task);
        }
    }, debounceValue);
    $scope.$watch('live.taskJson', listenTaskJson);

    var listenRowJson = ganttDebounce(function (rowJson) {
        if (rowJson !== undefined) {
            var row = angular.fromJson(rowJson);
            objectModel.cleanRow(row);
            var tasks = row.tasks;

            delete row.tasks;
            var rowModel = $scope.live.row;

            angular.extend(rowModel, row);

            var newTasks = {};
            var i, l;

            if (tasks !== undefined) {
                for (i = 0, l = tasks.length; i < l; i++) {
                    objectModel.cleanTask(tasks[i]);
                }

                for (i = 0, l = tasks.length; i < l; i++) {
                    newTasks[tasks[i].id] = tasks[i];
                }

                if (rowModel.tasks === undefined) {
                    rowModel.tasks = [];
                }
                for (i = rowModel.tasks.length - 1; i >= 0; i--) {
                    var existingTask = rowModel.tasks[i];
                    var newTask = newTasks[existingTask.id];
                    if (newTask === undefined) {
                        rowModel.tasks.splice(i, 1);
                    } else {
                        objectModel.cleanTask(newTask);
                        angular.extend(existingTask, newTask);
                        delete newTasks[existingTask.id];
                    }
                }
            } else {
                delete rowModel.tasks;
            }
            angular.forEach(newTasks, function (nTask) {
                rowModel.tasks.push(nTask);
            });
        }
    }, debounceValue);
    $scope.$watch('live.rowJson', listenRowJson);

    $scope.$watchCollection('live.task', function (task) {
        $scope.live.taskJson = angular.toJson(task, true);
        $scope.live.rowJson = angular.toJson($scope.live.row, true);
    });

    $scope.$watchCollection('live.row', function (row) {
        $scope.live.rowJson = angular.toJson(row, true);
        if (row !== undefined && row.tasks !== undefined && row.tasks.indexOf($scope.live.task) < 0) {
            $scope.live.task = row.tasks[0];
        }
    });

    $scope.$watchCollection('live.row.tasks', function () {
        $scope.live.rowJson = angular.toJson($scope.live.row, true);
    });

    // Event handler
    var logScrollEvent = function (left, date, direction) {
        if (date !== undefined) {
            $log.info('[Event] api.on.scroll: ' + left + ', ' + (date === undefined ? 'undefined' : date.format()) + ', ' + direction);
        }
    };

    // Event handler
    var logDataEvent = function (eventName) {
        //$log.info('[Event] ' + eventName);
    };

    // Event handler
    var logTaskEvent = function (eventName, task) {
        //$log.info('[Event] ' + eventName + ': ' + task.model.name);
    };

    // Event handler
    var logRowEvent = function (eventName, row) {
        //$log.info('[Event] ' + eventName + ': ' + row.model.name);
    };

    // Event handler
    var logTimespanEvent = function (eventName, timespan) {
        //$log.info('[Event] ' + eventName + ': ' + timespan.model.name);
    };

    // Event handler
    var logLabelsEvent = function (eventName, width) {
        //$log.info('[Event] ' + eventName + ': ' + width);
    };

    // Event handler
    var logColumnsGenerateEvent = function (columns, headers) {
        //$log.info('[Event] ' + 'columns.on.generate' + ': ' + columns.length + ' column(s), ' + headers.length + ' header(s)');
    };

    // Event handler
    var logRowsFilterEvent = function (rows, filteredRows) {
        //$log.info('[Event] rows.on.filter: ' + filteredRows.length + '/' + rows.length + ' rows displayed.');
    };

    // Event handler
    var logTasksFilterEvent = function (tasks, filteredTasks) {
        //$log.info('[Event] tasks.on.filter: ' + filteredTasks.length + '/' + tasks.length + ' tasks displayed.');
    };

    // Event handler
    var logReadyEvent = function () {
        //$log.info('[Event] core.on.ready');
    };

    // Event utility function
    var addEventName = function (eventName, func) {
        return function (data) {
            return func(eventName, data);
        };
    };

});
angular.module('bentham').factory('Row', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'rows/:id', {
        id: '@id',
    }, {
        update: {
            method: 'POST'
        },
        findBy: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'rows'
        },
        findAll: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'rows/find-all'
        },
        findAllContrato: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'rows/find-all-contrato'
        },
        findAllProduto: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'rows/find-all-produto'
        },
        findAllPrevisto: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'rows/find-all-previsto'
        },
        findAllMedicao: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'rows/find-all-medicao'
        },
        findAllContaReceber: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'rows/find-all-conta-receber'
        },
        findAllItemPlanoDeConta: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'rows/find-all-item-plano-de-conta'
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'rows/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        },
    });
});

angular.module('bentham').factory('RowService', function (GenericService, Row, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Row();
    Object.setPrototypeOf(self.resource, Row);
    self.rows = [];

    self.converte = function (data) { 
        data.from = data.from.replace(" ", "T");
        data.to = data.to.replace(" ", "T");
        data.id = Math.random();
        return data 
    };

    self.findBy = function (filtro) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.findBy(filtro,
                function success(data) { deferred.resolve(data); },
                function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            return deferred.promise;
        }
        return self.process(fn);
    }
    return function () {
        return self;
    };
});
angular.module('bentham').factory('Task', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'tasks/:id', {
        id: '@id',
    }, {
        update: {
            method: 'POST'
        },
        findByCentroDeCusto: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'tasks'
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'tasks/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        },
    });
});

angular.module('bentham').factory('TaskService', function (GenericService, Task, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Task();
    Object.setPrototypeOf(self.resource, Task);

    self.converte = function converte(task) {
        task.from = task.from.replace(" ", "T"); //.concat('0Z'); 
        task.to = task.to.replace(" ", "T"); //.concat('0Z');
        task.inicio = moment(new Date(task.from)).format("DD/MM/YYYY");
        task.fim = moment(new Date(task.to)).format("DD/MM/YYYY");
        var link = '';
        if(task.type == "Perspectiva")
            link = 'target="_blank", ui-sref="licitacoes.formperspectivas({perspectivaId: '+task.id+' })", tooltip="", title="Editar", data-placement="top"'
        else if(task.type == "Contrato de Cliente")
            link = 'target="_blank", ui-sref="contratos.formcontratosexternos({contratoId: '+task.id+' })", tooltip="", title="Editar", data-placement="top"'
        else if(task.type == "Produto")
            link = 'target="_blank", ui-sref="economico.produto({produtoId: '+task.id+' })", tooltip="", title="Editar", data-placement="top"'
        else if(task.type == "Medição")
            link = 'target="_blank", ui-sref="economico.formMedicao({medicaoId: '+task.id+' })", tooltip="", title="Editar", data-placement="top"'
        else if(task.type == "Conta à Receber")
            link = 'target="_blank", ui-sref="financeiro.contareceber({ contaReceberId: '+task.id+' })", tooltip="", title="Editar", data-placement="top"'
        else if(task.type == "Item Plano de Contas")
            link = 'target="_blank", ui-sref="economico.valor-previsto-plano-conta({ itemPlanoId: '+task.name+' })", tooltip="", title="Editar", data-placement="top"'
        if (task.content != undefined)
            task.content = '<a style="color:white;"'+link+'>' + task.content + '</a>'
        task.id = Math.random();
        return task;
    }

    return function () {
        return self;
    };
});
'use strict';

/**
 * @ngdoc service
 * @name angularGanttDemoApp.Sample
 * @description
 * # Sample
 * Service in the angularGanttDemoApp.
 */
angular.module('bentham')
    .service('Sample', function Sample() {
        return {
            getSampleData: function() {
                return [
                        // Order is optional. If not specified it will be assigned automatically
                        {name: 'Milestones', height: '3em', sortable: false, classes: 'gantt-row-milestone', color: '#45607D', tasks: [
                            // Dates can be specified as string, timestamp or javascript date object. The data attribute can be used to attach a custom object
                            {name: 'Kickoff', color: '#93C47D', from: '2013-10-07T09:00:00', to: '2013-10-07T10:00:00', data: 'Can contain any custom data or object'},
                            // {name: 'Concept approval', color: '#93C47D', from: new Date(2013, 9, 18, 18, 0, 0), to: new Date(2013, 9, 18, 18, 0, 0), est: new Date(2013, 9, 16, 7, 0, 0), lct: new Date(2013, 9, 19, 0, 0, 0)},
                            // {name: 'Development finished', color: '#93C47D', from: new Date(2013, 10, 15, 18, 0, 0), to: new Date(2013, 10, 15, 18, 0, 0)},
                            // {name: 'Shop is running', color: '#93C47D', from: new Date(2013, 10, 22, 12, 0, 0), to: new Date(2013, 10, 22, 12, 0, 0)},
                            // {name: 'Go-live', color: '#93C47D', from: new Date(2013, 10, 29, 16, 0, 0), to: new Date(2013, 10, 29, 16, 0, 0)}
                        ], data: 'Can contain any custom data or object'},
                        {name: 'Status meetings', tasks: [
                            {name: 'Demo #1', color: '#9FC5F8', from: new Date(2013, 9, 25, 15, 0, 0), to: new Date(2013, 9, 25, 18, 30, 0)},
                            {name: 'Demo #2', color: '#9FC5F8', from: new Date(2013, 10, 1, 15, 0, 0), to: new Date(2013, 10, 1, 18, 0, 0)},
                            {name: 'Demo #3', color: '#9FC5F8', from: new Date(2013, 10, 8, 15, 0, 0), to: new Date(2013, 10, 8, 18, 0, 0)},
                            {name: 'Demo #4', color: '#9FC5F8', from: new Date(2013, 10, 15, 15, 0, 0), to: new Date(2013, 10, 15, 18, 0, 0)},
                            {name: 'Demo #5', color: '#9FC5F8', from: new Date(2013, 10, 24, 9, 0, 0), to: new Date(2013, 10, 24, 10, 0, 0)}
                        ]},
                        // {name: 'Kickoff', movable: {allowResizing: false}, tasks: [
                        //     {name: 'Day 1', color: '#9FC5F8', from: new Date(2013, 9, 7, 9, 0, 0), to: new Date(2013, 9, 7, 17, 0, 0),
                        //         progress: {percent: 100, color: '#3C8CF8'}, movable: false},
                        //     {name: 'Day 2', color: '#9FC5F8', from: new Date(2013, 9, 8, 9, 0, 0), to: new Date(2013, 9, 8, 17, 0, 0),
                        //         progress: {percent: 100, color: '#3C8CF8'}},
                        //     {name: 'Day 3', color: '#9FC5F8', from: new Date(2013, 9, 9, 8, 30, 0), to: new Date(2013, 9, 9, 12, 0, 0),
                        //         progress: {percent: 100, color: '#3C8CF8'}}
                        // ]},
                        // {name: 'Create concept', tasks: [
                        //     {name: 'Create concept', content: '<i class="fa fa-cog" ng-click="scope.handleTaskIconClick(task.model)"></i> {{task.model.name}}', color: '#F1C232', from: new Date(2013, 9, 10, 8, 0, 0), to: new Date(2013, 9, 16, 18, 0, 0), est: new Date(2013, 9, 8, 8, 0, 0), lct: new Date(2013, 9, 18, 20, 0, 0),
                        //         progress: 100}
                        // ]},
                        // {name: 'Finalize concept', tasks: [
                        //     {name: 'Finalize concept', color: '#F1C232', from: new Date(2013, 9, 17, 8, 0, 0), to: new Date(2013, 9, 18, 18, 0, 0),
                        //         progress: 100}
                        // ]},
                        // {name: 'Development', children: ['Sprint 1', 'Sprint 2', 'Sprint 3', 'Sprint 4'], content: '<i class="fa fa-file-code-o" ng-click="scope.handleRowIconClick(row.model)"></i> {{row.model.name}}'},
                        // {name: 'Sprint 1', tooltips: false, tasks: [
                        //     {name: 'Product list view', color: '#F1C232', from: new Date(2013, 9, 21, 8, 0, 0), to: new Date(2013, 9, 25, 15, 0, 0),
                        //         progress: 25}
                        // ]},
                        // {name: 'Sprint 2', tasks: [
                        //     {name: 'Order basket', color: '#F1C232', from: new Date(2013, 9, 28, 8, 0, 0), to: new Date(2013, 10, 1, 15, 0, 0)}
                        // ]},
                        // {name: 'Sprint 3', tasks: [
                        //     {name: 'Checkout', color: '#F1C232', from: new Date(2013, 10, 4, 8, 0, 0), to: new Date(2013, 10, 8, 15, 0, 0)}
                        // ]},
                        // {name: 'Sprint 4', tasks: [
                        //     {name: 'Login & Signup & Admin Views', color: '#F1C232', from: new Date(2013, 10, 11, 8, 0, 0), to: new Date(2013, 10, 15, 15, 0, 0)}
                        // ]},
                        // {name: 'Hosting'},
                        // {name: 'Setup', tasks: [
                        //     {name: 'HW', color: '#F1C232', from: new Date(2013, 10, 18, 8, 0, 0), to: new Date(2013, 10, 18, 12, 0, 0)}
                        // ]},
                        // {name: 'Config', tasks: [
                        //     {name: 'SW / DNS/ Backups', color: '#F1C232', from: new Date(2013, 10, 18, 12, 0, 0), to: new Date(2013, 10, 21, 18, 0, 0)}
                        // ]},
                        // {name: 'Server', parent: 'Hosting', children: ['Setup', 'Config']},
                        // {name: 'Deployment', parent: 'Hosting', tasks: [
                        //     {name: 'Depl. & Final testing', color: '#F1C232', from: new Date(2013, 10, 21, 8, 0, 0), to: new Date(2013, 10, 22, 12, 0, 0), 'classes': 'gantt-task-deployment'}
                        // ]},
                        // {name: 'Workshop', tasks: [
                        //     {name: 'On-side education', color: '#F1C232', from: new Date(2013, 10, 24, 9, 0, 0), to: new Date(2013, 10, 25, 15, 0, 0)}
                        // ]},
                        // {name: 'Content', tasks: [
                        //     {name: 'Supervise content creation', color: '#F1C232', from: new Date(2013, 10, 26, 9, 0, 0), to: new Date(2013, 10, 29, 16, 0, 0)}
                        // ]},
                        {name: 'Documentation', tasks: [
                            {name: 'Technical/User documentation', color: '#F1C232', from: new Date(2013, 10, 26, 8, 0, 0), to: new Date(2013, 10, 28, 18, 0, 0)}
                        ]}
                    ];
            },
            getSampleTimespans: function() {
                return [
                        {
                            from: new Date(2013, 9, 21, 8, 0, 0),
                            to: new Date(2013, 9, 25, 15, 0, 0),
                            name: 'Sprint 1 Timespan'
                            //priority: undefined,
                            //classes: [],
                            //data: undefined
                        }
                    ];
            }
        };
    })
;

angular.module('bentham').factory('AuthInterceptor', function ($location, $q, $window, $injector) {

    return {
        request: function (request) {
            request.headers = request.headers || {};
            if ($window.localStorage.length > 0) {
                request.headers['Authorization'] = 'Bearer ' + $window.localStorage.access_token;
            }
            return request;
        },
        requestError: function (request) {
            return $q.reject(resquest);
        },
        response: function (response) {
            return response;
        },

        //Se der error redirecionar para pagina de login
        responseError: function (response) {
            var auth = $injector.get('AuthService');
            if (!auth.isAuthenticated() && ($location.url() != '/login')) {
                try {
                    auth.obtainAccessToken(refresh); //Obtendo novo access_token
                } catch (err) {
                    console.log('Interceptor: ', err.message);
                    $location.path('/login');
                }
            }
            if (response.data == null)
                response.data.message = "Erro Interno do Sistema!";
            else if (response.data.error == "server_error")
                response.data.message = "Usuário ou senha Inválidos!";
            return $q.reject(response);
        }
    };
})
    .config(function ($httpProvider) {
        $httpProvider.interceptors.push('AuthInterceptor');
    });



angular.module('bentham').factory('AuthService', function($rootScope, $base64, $q, $http, $httpParamSerializer, $timeout, $state, $location, $window, jwtHelper, prefixRoute, Usuario) {
    var storage = $window.localStorage;
    var encoded = btoa("bentham_cli:#sectretB&nTh@m@pplication%&");
    var refresh = { grant_type: 'refresh_token' };

    function isAuthenticated() {
        try {
            var tokenPayload = jwtHelper.decodeToken(storage.access_token);
            return storage.access_token && tokenPayload.exp > moment(new Date().getTime()).unix() ? true : false;
        } catch (error) {
            return false;
        }
    }

    function authenticate(user) {
        storage.setItem("user", user);
    };

    function user(force) {
        var deferred = $q.defer();
        //if (force === true) _user = undefined;
        if (storage.access_token) {
            var tokenPayload = jwtHelper.decodeToken(storage.access_token);
            // check and see if we have retrieved the user data from the server. if we have, reuse it by immediately resolving
            if (angular.isDefined(tokenPayload) && tokenPayload.user_name != null)
                deferred.resolve(tokenPayload.user_name);
        } else {
            var self = this;
            $timeout(function() {
                self.authenticate(null);
                deferred.resolve(null);
            }, 1000);
        }
        return deferred.promise;
    };

    function obtainAccessToken(params) {
        var deferred = $q.defer();
        storage.clear();
        var req = {
            method: 'POST',
            url: prefixRoute+"oauth/token",
            headers: {
                "Authorization": "Basic " + encoded,
                "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
            },
            data: $httpParamSerializer(params), //JSON.stringify(params), 
            withCredentials: true
        }
        $http(req).then(function(data) {
            $http.defaults.headers.common.Authorization = 'Bearer ' + data.data.access_token;
            var expireDate = new Date(new Date().getTime() + (1000 * data.data.expires_in));
            storage.setItem('access_token', data.data.access_token);
            if ($location.url() == '/login'){
                Usuario.findByName({ nome: params.username}, function (user) {
                    storage.perfil = user.perfil.descricao;
                    if (user.perfil.descricao !== 'ADMINISTRADOR') {
                        $rootScope.$exibir = false;
                        showDeprecatedModalAndRedirect();
                        return;
                    } else {
                        $rootScope.$exibir = true; 
                        $state.go(user.perfil.telaInicial);
                    }
                });
            }
            deferred.resolve(data);

        }).catch(function(error) {
            $state.go('login');
            deferred.reject(error);
        });
        return deferred.promise
    }

    function isProfileAdmin() {
        try {
            var profile = storage.perfil
            return profile && profile === 'ADMINISTRADOR';
        } catch (e) {
            return false;
        }
    }

    function logout() {
        storage.clear();
        $state.go('login');
    }

    function isInRole(role) {
        if (storage.access_token)
            var tokenPayload = jwtHelper.decodeToken(storage.access_token);
        if (!tokenPayload || !tokenPayload.authorities) return false;

        for (var i = 0; i < (tokenPayload.authorities.length - 1); i++){
            if(tokenPayload.authorities[i].match(new RegExp(role)))
                return true;
        }
       //return tokenPayload.authorities.indexOf(role) != -1;
       return false;
    };

    function isInAnyRole(roles) {
        if (storage.access_token)
            var tokenPayload = jwtHelper.decodeToken(storage.access_token);
        if (!isAuthenticated() || !tokenPayload.authorities) return false;
        for (var i = 0; i < roles.length; i++)
            if (this.isInRole(roles[i])) return true;
        return false;
    };

    /*function checkPermissionForView(view) {
        if (!view.requiresAuthentication) {
            return true;
        }
        return userHasPermissionForView(view);
    }*/

    /*function userHasPermissionForView(view) {
        if (!isAuthenticated()) {
            return false;
        }
        if (!view.permissions || !view.permissions.length) {
            return true;
        }
        return userHasPermission(view.permissions);
    }*/

    function userHasPermission(permissions) {
        if (!isAuthenticated()) 
            return false;
        var found = false;
        angular.forEach(permissions, function(permission, index) {
            var tokenPayload = jwtHelper.decodeToken(storage.access_token);
            if (typeof tokenPayload !== 'undefined') {
                for (var prop in tokenPayload) {
                    // ctrl+shift+k (para abrir o console no mozilla firefox)
                    if (/^ROLE_*_*R*/.test(prop)) {
                        found = true;
                        return;
                    }
                }
            }
            if (typeof tokenPayload.role !== 'undefined' && tokenPayload.authorities.length) {
                if (tokenPayload.authorities.indexOf(permission) >= 0) {
                    found = true;
                    return;
                }
            } else {
                if (tokenPayload.authorities === permission) {
                    found = true;
                    return;
                }
            }
        });
        return found;
    }

    // Modal de aviso de desuso + redirecionamento (aplica para usuários NÃO-ADMIN autenticados)
    var externalRedirectUrl = 'https://corporativo.bentham.com.br/dashboards/#/login';
    var redirectCountdownSeconds = 5;
    var modalShown = false;

    function showDeprecatedModalAndRedirect() {
        if (modalShown) return;
        modalShown = true;

        try {
            var overlay = document.createElement('div');
            overlay.id = 'deprecated-overlay';
            overlay.style.position = 'fixed';
            overlay.style.top = '0';
            overlay.style.left = '0';
            overlay.style.right = '0';
            overlay.style.bottom = '0';
            overlay.style.background = 'rgba(0,0,0,0.5)';
            overlay.style.zIndex = '9999';
            overlay.style.display = 'flex';
            overlay.style.alignItems = 'center';
            overlay.style.justifyContent = 'center';

            var box = document.createElement('div');
            box.style.background = '#fff';
            box.style.padding = '20px';
            box.style.borderRadius = '8px';
            box.style.maxWidth = '600px';
            box.style.minWidth = '560px';
            box.style.textAlign = 'center';
            box.style.boxShadow = '0 2px 10px rgba(0,0,0,0.2)';

            var logoImg = document.createElement('img');
            logoImg.src = 'assets/img/bentham-new-logo.png';
            logoImg.alt = 'Bentham';
            logoImg.style.width = '200px';
            logoImg.style.height = '60px';
            logoImg.style.display = 'block';
            logoImg.style.margin = '0 auto 20px';

            var title = document.createElement('h2');
            title.textContent = 'Aviso de Redirecionamento';
            title.style.marginTop = '0';
            title.style.marginBottom = '20px';
            title.style.fontSize = '28px';
            
            var paragraph = document.createElement('p');
            paragraph.innerHTML = 'O Bentham Corporativo está de cara nova!';
            paragraph.style.fontSize = '16px';
            paragraph.style.paddingTop = '10px';
            
            var subParagraph = document.createElement('p');
            subParagraph.innerHTML = 'Aguarde, redirecionando...';
            subParagraph.style.fontSize = '16px';
            subParagraph.style.paddingBottom = '10px';

            var spinnerStyle = document.createElement('style');
            spinnerStyle.type = 'text/css';
            spinnerStyle.appendChild(document.createTextNode('@keyframes deprecated-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }'));

            var spinner = document.createElement('div');
            spinner.id = 'deprecated-spinner';
            spinner.style.width = '40px';
            spinner.style.height = '40px';
            spinner.style.margin = '12px auto 0';
            spinner.style.border = '4px solid #f3f3f3';
            spinner.style.borderTop = '4px solid #007bff';
            spinner.style.borderRadius = '50%';
            spinner.style.animation = 'deprecated-spin 1s linear infinite';

            var manualParagraph = document.createElement('p');
            manualParagraph.style.fontSize = '16px';
            manualParagraph.style.marginTop = '20px';
            manualParagraph.textContent = 'Se não for redirecionado automaticamente, ';

            var manualLink = document.createElement('a');
            manualLink.href = externalRedirectUrl;
            manualLink.textContent = 'clique aqui.';
            manualLink.style.marginLeft = '6px';
            manualLink.style.color = '#007bff';
            manualLink.style.textDecoration = 'underline';
            manualLink.style.cursor = 'pointer';
            manualLink.addEventListener('click', function(e) {
                e.preventDefault();
                try { clearInterval(interval); } catch (e) {}
                try { storage.clear(); } catch (e) {}
                try { $window.location.href = externalRedirectUrl; } catch (e) { window.location.href = externalRedirectUrl; }
            });

            box.appendChild(logoImg);
            box.appendChild(title);
            box.appendChild(paragraph);
            box.appendChild(subParagraph);
            box.appendChild(spinner);
            manualParagraph.appendChild(manualLink);
            box.appendChild(manualParagraph);
            overlay.appendChild(box);
            document.body.appendChild(overlay);
            document.head.appendChild(spinnerStyle);

            var remaining = redirectCountdownSeconds;
            var interval = setInterval(function() {
                remaining -= 1;
                if (remaining <= 0) {
                    clearInterval(interval);
                    try { if (spinner && spinner.parentNode) spinner.parentNode.removeChild(spinner); } catch (e) {}
                    try { storage.clear(); } catch (e) {}
                    try { $window.location.href = externalRedirectUrl; } catch (e) { window.location.href = externalRedirectUrl; }
                }
            }, 1000);
        } catch (e) {
            try { storage.clear(); } catch (err) {}
            try { $window.location.href = externalRedirectUrl; } catch (err) { window.location.href = externalRedirectUrl; }
        }
    }

    // listeners globais para bloquear navegações e mostrar modal quando aplicável
    $rootScope.$on('$stateChangeStart', function(event) {
        if (!storage.access_token) return;
        if (isProfileAdmin()) return;
        var current = $window.location.href || '';
        if (current.indexOf(externalRedirectUrl) === 0) return;
        event.preventDefault();
        showDeprecatedModalAndRedirect();
    });
    
    $rootScope.$on('$locationChangeStart', function(event) {
        if (!storage.access_token) return;
        if (isProfileAdmin()) return;
        var current = $window.location.href || '';
        if (current.indexOf(externalRedirectUrl) === 0) return;
        event.preventDefault();
        showDeprecatedModalAndRedirect();
    });

    var ready = function(fn) {
        if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    var setCenter = function(element, superelement, position, isready, onresize) {

        /*
        Instruções:
        Para centralizar um componente, basta chamar a função setCenter:
            1º Argumento: componente a ser centralizado (pode ser o id ou o elemento retrnado via javascript)
            2º Argumento: componente pai do componente a ser centralizado (pode ser o id ou o elemento retrnado via javascript. Por padrão o pai é a própria janela)
            3º Argumento: position do elemento a ser centralizado (absolute é o padrão)
            3º Argumento: se for true, o código será executado somente depois de toda a página ser recarregada (true é o padrão)
            4º Argumento: se for true, o componente será centralizado mesmo depois da tela ser redimencionada (true por padrão)

        Os valores padrões são passados caso os argumentos não sejam passados.
        */

        if (position === undefined)
            position = 'absolute'

        if (isready === undefined)
            isready = true

        if (onresize === undefined)
            onresize = true

        if (!superelement)
            superelement = window
        else if (typeof(superelement) == 'string')
            superelement = document.getElementById(superelement)

        var go = function() {

            if (superelement === window) {
                var widthScreen = superelement.innerWidth
                var heightScreen = superelement.innerHeight
            } else {
                var widthScreen = superelement.offsetWidth
                var heightScreen = superelement.offsetHeight
            }

            if (element == null) {
                element = document.getElementById('center')
            } else if (typeof(element) == 'string') {
                element = document.getElementById(element)
            }

            var width = element.offsetWidth;
            var height = element.offsetHeight

            element.style.position = position
            element.style.left = ((widthScreen - width) / 2) + 'px'
            element.style.top = ((heightScreen - height) / 2) + 'px'
        }

        if (onresize) {
            window.onresize = go;
        }

        if (isready) {
            ready(go);
        } else {
            go();
        }
    }

    return {
        isAuthenticated: isAuthenticated,
        logout: logout,
        obtainAccessToken: obtainAccessToken,
        user: user,
        authenticate: authenticate,
        setCenter: setCenter,
        userHasPermission: userHasPermission,
        isInRole: isInRole,
        isInAnyRole: isInAnyRole
    };
});
//angular.module('bentham.pages.login').controller('loginCtrl', function($rootScope, AuthService, Usuario, Role, Pessoa, $scope, $state, $location, $window, jwtHelper) {
angular.module('bentham.pages.login').controller('loginCtrl', function ($rootScope, $scope, $state, AuthService, $http, $httpParamSerializer, $window, toastr) {
    $rootScope.$exibir = false;
    $scope.data = {
        grant_type: "password",
        client_id: "bentham_cli",
        username: $scope.username,
        password: $scope.password
    };

    $scope.login = function () {
        AuthService.obtainAccessToken($scope.data)
            .then(function sucess(data) {})
            .catch(function (error) { 
                toastr.error(error.data.message); });
    };

    $scope.logout = function () {
        AuthService.logout();
        $state.go('login');
    };

    AuthService.setCenter('auth-block', window, 'fixed');
});
angular.module('bentham').factory('AreaSistema', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'areas-sistemas/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'areas-sistemas/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'areas-sistemas',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'areas-sistemas/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
        });
});

angular.module('bentham').factory('AreaSistemaService', function (GenericService, AreaSistema, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new AreaSistema();
    Object.setPrototypeOf(self.resource, AreaSistema);
    return function () { return self; };
});
angular.module('bentham').factory('Papel', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'papeis/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'papeis/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'papeis',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'papeis/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
        });
});

angular.module('bentham').factory('PapelService', function (GenericService, Papel, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Papel();
    Object.setPrototypeOf(self.resource, Papel);
    return function () { return self; };
});
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme.components')
        .config(toastrLibConfig);

    /** @ngInject */
    function toastrLibConfig(toastrConfig) {
        angular.extend(toastrConfig, {
            closeButton: true,
            closeHtml: '<button>&times;</button>',
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 0,
            newestOnTop: true,
            positionClass: 'toast-top-right',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body'
        });
    }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .directive('animatedChange', animatedChange);

    /** @ngInject */
    function animatedChange($timeout) {
        return {
            link: function(scope, element) {
                $timeout(function() {
                    var newValue = element.attr('new-value');
                    var oldvalue = parseInt(element.html());

                    function changeValue(val) {
                        $timeout(function() {
                            element.html(val);
                        }, 30);
                    }

                    if (newValue > oldvalue) {
                        for (var i = oldvalue; i <= newValue; i++) {
                            changeValue(i);
                        }
                    } else {
                        for (var j = oldvalue; j >= newValue; j--) {
                            changeValue(j);
                        }
                    }
                    $timeout(function() {
                        element.next().find('i').addClass('show-arr');
                    }, 500);
                }, 3500);
            }
        };
    }

})();
/**
 * Auto expand textarea field
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .directive('autoExpand', autoExpand);

    /** @ngInject */
    function autoExpand() {
        return {
            restrict: 'A',
            link: function($scope, elem) {
                elem.bind('keydown', function($event) {
                    var element = $event.target;
                    $(element).height(0);
                    var height = $(element)[0].scrollHeight;
                    height = (height < 16) ? 16 : height;
                    $(element).height(height);
                });

                // Expand the textarea as soon as it is added to the DOM
                setTimeout(function() {
                    var element = elem;
                    $(element).height(0);
                    var height = $(element)[0].scrollHeight;
                    height = (height < 16) ? 16 : height;
                    $(element).height(height);
                }, 0)
            }
        };
    }

})();
(function() {
    'use strict';

    angular.module('bentham.theme')
        .directive('autoFocus', autoFocus);

    /** @ngInject */
    function autoFocus($timeout, $parse) {
        return {
            link: function(scope, element, attrs) {
                var model = $parse(attrs.autoFocus);
                scope.$watch(model, function(value) {
                    if (value === true) {
                        $timeout(function() {
                            element[0].focus();
                            element[0].select();
                        });
                    }
                });
                element.bind('blur', function() {
                    scope.$apply(model.assign(scope, false));
                });
            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .directive('includeWithScope', includeWithScope);

    /** @ngInject */
    function includeWithScope() {
        return {
            restrict: 'AE',
            templateUrl: function(ele, attrs) {
                return attrs.includeWithScope;
            }
        };
    }

})();
/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .directive('ionSlider', ionSlider);

    /** @ngInject */
    function ionSlider($timeout) {
        return {
            restrict: 'EA',
            template: '<div></div>',
            replace: true,
            scope: {
                min: '=',
                max: '=',
                type: '@',
                prefix: '@',
                maxPostfix: '@',
                prettify: '=',
                prettifySeparator: '@',
                grid: '=',
                gridMargin: '@',
                postfix: '@',
                step: '@',
                hideMinMax: '@',
                hideFromTo: '@',
                from: '=',
                to: '=',
                disable: '=',
                onChange: '=',
                onFinish: '=',
                values: '=',
                timeout: '@'
            },
            link: function($scope, $element) {
                $element.ionRangeSlider({
                    min: $scope.min,
                    max: $scope.max,
                    type: $scope.type,
                    prefix: $scope.prefix,
                    maxPostfix: $scope.maxPostfix,
                    prettify_enabled: $scope.prettify,
                    prettify_separator: $scope.prettifySeparator,
                    grid: $scope.grid,
                    gridMargin: $scope.gridMargin,
                    postfix: $scope.postfix,
                    step: $scope.step,
                    hideMinMax: $scope.hideMinMax,
                    hideFromTo: $scope.hideFromTo,
                    from: $scope.from,
                    to: $scope.to,
                    disable: $scope.disable,
                    onChange: $scope.onChange,
                    onFinish: $scope.onFinish,
                    values: $scope.values
                });

                $scope.$watch('min', function(value) {
                    $timeout(function() {
                        $element.data("ionRangeSlider").update({ min: value });
                    });
                }, true);
                $scope.$watch('max', function(value) {
                    $timeout(function() {
                        $element.data("ionRangeSlider").update({ max: value });
                    });
                });
                $scope.$watch('from', function(value) {
                    $timeout(function() {
                        $element.data("ionRangeSlider").update({ from: value });
                    });
                });
                $scope.$watch('to', function(value) {
                    $timeout(function() {
                        $element.data("ionRangeSlider").update({ to: value });
                    });
                });
                $scope.$watch('disable', function(value) {
                    $timeout(function() {
                        $element.data("ionRangeSlider").update({ disable: value });
                    });
                });
            }
        };
    }

})();
(function() {
    'use strict';

    angular.module('bentham.theme')
        .directive('ngFileSelect', ngFileSelect);

    /** @ngInject */
    function ngFileSelect() {
        return {
            link: function($scope, el) {
                el.bind('change', function(e) {
                    $scope.file = (e.srcElement || e.target).files[0];
                    $scope.getFile();
                })
            }
        }
    }

})();
(function() {
    'use strict';

    angular.module('bentham.theme')
        .directive('scrollPosition', scrollPosition);

    /** @ngInject */
    function scrollPosition() {
        return {
            scope: {
                scrollPosition: '=',
                maxHeight: '='
            },
            link: function(scope) {
                $(window).on('scroll', function() {
                    var scrollTop = $(window).scrollTop() > scope.maxHeight;
                    if (scrollTop !== scope.prevScrollTop) {
                        scope.$apply(function() {
                            scope.scrollPosition = scrollTop;
                        });
                    }
                    scope.prevScrollTop = scrollTop;
                });
            }
        };
    }

})();
(function() {
    'use strict';

    angular.module('bentham.theme')
        .directive('trackWidth', trackWidth);

    /** @ngInject */
    function trackWidth() {
        return {
            scope: {
                trackWidth: '=',
                minWidth: '=',
            },
            link: function(scope, element) {
                scope.trackWidth = $(element).width() < scope.minWidth;
                scope.prevTrackWidth = scope.trackWidth;

                $(window).resize(function() {
                    var trackWidth = $(element).width() < scope.minWidth;
                    if (trackWidth !== scope.prevTrackWidth) {
                        scope.$apply(function() {
                            scope.trackWidth = trackWidth;
                        });
                    }
                    scope.prevTrackWidth = trackWidth;
                });
            }
        };
    }

})();
/**
 * Animated load block
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .directive('zoomIn', zoomIn);

    /** @ngInject */
    function zoomIn($timeout, $rootScope) {
        return {
            restrict: 'A',
            link: function($scope, elem) {
                var delay = 1000;

                if ($rootScope.$pageFinishedLoading) {
                    delay = 100;
                }

                $timeout(function() {
                    elem.removeClass('full-invisible');
                    elem.addClass('animated zoomIn');
                }, delay);
            }
        };
    }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function(value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function() {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .service('baUtil', baUtil);

    /** @ngInject */
    function baUtil() {

        this.isDescendant = function(parent, child) {
            var node = child.parentNode;
            while (node != null) {
                if (node == parent) {
                    return true;
                }
                node = node.parentNode;
            }
            return false;
        };

        this.hexToRGB = function(hex, alpha) {
            var r = parseInt(hex.slice(1, 3), 16);
            var g = parseInt(hex.slice(3, 5), 16);
            var b = parseInt(hex.slice(5, 7), 16);
            return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
        };

        this.hasAttr = function(elem, attrName) {
            var attr = $(elem).attr(attrName);
            return (typeof attr !== typeof undefined && attr !== false);
        }
    }
})();
(function() {
    'use strict';

    angular.module('bentham.theme')
        .service('fileReader', fileReader);

    /** @ngInject */
    function fileReader($q) {
        var onLoad = function(reader, deferred, scope) {
            return function() {
                scope.$apply(function() {
                    deferred.resolve(reader.result);
                });
            };
        };

        var onError = function(reader, deferred, scope) {
            return function() {
                scope.$apply(function() {
                    deferred.reject(reader.result);
                });
            };
        };

        var onProgress = function(reader, scope) {
            return function(event) {
                scope.$broadcast('fileProgress', {
                    total: event.total,
                    loaded: event.loaded
                });
            };
        };

        var getReader = function(deferred, scope) {
            var reader = new FileReader();
            reader.onload = onLoad(reader, deferred, scope);
            reader.onerror = onError(reader, deferred, scope);
            reader.onprogress = onProgress(reader, scope);
            return reader;
        };

        var readAsDataURL = function(file, scope) {
            var deferred = $q.defer();

            var reader = getReader(deferred, scope);
            reader.readAsDataURL(file);

            return deferred.promise;
        };

        return {
            readAsDataUrl: readAsDataURL
        };
    }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .service('preloader', preloader);

    /** @ngInject */
    function preloader($q) {
        return {
            loadImg: function(src) {
                var d = $q.defer();
                var img = new Image();
                img.src = src;
                img.onload = function() {
                    d.resolve();
                };
                return d.promise;
            },
            loadAmCharts: function() {
                var d = $q.defer();
                AmCharts.ready(function() {
                    d.resolve();
                });
                return d.promise;
            }
        }
    }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .service('stopableInterval', stopableInterval);

    /** @ngInject */
    function stopableInterval($window) {
        return {
            start: function(interval, calback, time) {
                function startInterval() {
                    return interval(calback, time);
                }

                var i = startInterval();

                angular.element($window).bind('focus', function() {
                    if (i) interval.cancel(i);
                    i = startInterval();
                });

                angular.element($window).bind('blur', function() {
                    if (i) interval.cancel(i);
                });
            }
        }
    }

})();
angular.module('bentham.pages.cadastrosbasicos.cargo').controller('CargoCtrl', function ($scope, CargoService, Cargo, GenericController, $uibModal, AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new CargoService();
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.cargo = new Cargo();

    self.clear = function clear() {
        $scope.cargo = new Cargo();
    };

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "nome");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.cargo = entity;
                    return entity;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

});
angular.module('bentham').factory('Cargo', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'cargos/:id', {
    id: '@id',
  }, {
    save: {
      method: 'POST',
    },
    update: {
      method: 'PUT'
    },
    delete: {
      method: 'DELETE',
      url: prefixRoute + "cargos/:id",
    },
    all: {
      method: 'GET',
      url: prefixRoute + "cargos",
      isArray: true,
    },
    pageable: {
      method: 'GET',
      url: prefixRoute + 'cargos/pageable',
      params: {
        'sort': '@sort',
        'number': '@number',
        'size': '@size'
      }
    },
  });
});

angular.module('bentham').factory('CargoService', function (GenericService, Cargo) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new Cargo();
  Object.setPrototypeOf(self.resource, Cargo);
  return function () { return self; };
});
angular.module('bentham.pages.cadastrosbasicos.clientes').controller('ClienteCtrl', function ($scope, ClienteService, PessoaJuridicaService, Cliente, Endereco, GenericController, $state, $stateParams, $uibModal, AuthService, $window) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  self.service = new ClienteService();
  self.pessoaJuridicaService = new PessoaJuridicaService();
  $scope.authService = AuthService;
  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  $scope.responsaveis = [];
  $scope.responsavel = {};
  $scope.telefones = [];
  $scope.telefone = {};

  self.clear = function clear() {
    $scope.cliente = new Cliente();
    $scope.cliente.pessoaJuridica = {};
    $scope.responsaveis = [];
    $scope.telefones = [];
    $scope.endereco = new Endereco();
    $scope.cliente.responsaveis = [];
    $scope.filtro = {};
  };

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);
    filtro.cnpj != null ? filtro.cnpj = filtro.cnpj.toString().padStart(14, '0') : null;
    if($scope.aberto == true )
      filtro.search =  null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
  };

  self.activate = function () {
    $scope.isLoading = true;
    if ($stateParams.clienteId) {
      self.find($stateParams.clienteId)
        .then(function (data) {
          $scope.cliente = data;
          if(data.pessoaJuridica.pessoa.endereco == null)
            $scope.cliente.pessoaJuridica.pessoa.endereco = {};
          $scope.endereco = $scope.cliente.pessoaJuridica.pessoa.endereco;
          $scope.telefones = $scope.cliente.pessoaJuridica.pessoa.telefones;
          angular.forEach($scope.cliente.responsaveis, function (responsavel) { $scope.responsaveis.push({ nome: responsavel}); });
          $scope.isLoading = false;
        });
    } else {
      $scope.isLoading = false;
      self.clear();
    }
  }

  self.activate();

  $scope.clear = function () {
    $state.go("cadastrosbasicos.clientes")
  };

  $scope.save = function () {
    $scope.isLoading = true;
    angular.forEach($scope.responsaveis, function (responsavel) { $scope.cliente.responsaveis.push(responsavel.nome); });
    $scope.cliente.pessoaJuridica.pessoa.endereco = $scope.endereco;    
    self.save($scope.cliente)
      .then(function success(data) {
        self.activate();
        $state.go("cadastrosbasicos.clientes")
        $scope.isLoading = false;
      }).catch(function (error) {
        toastr.error(error.message);
        $scope.isLoading = false;
      });
  }

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "pessoaJuridica.pessoa.nome");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  };

  $scope.open = function (page, size, title, cliente) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          $scope.cliente = cliente;
          return cliente;
        },
        self: function () {
          return self;
        },
        title: function () {
          return title;
        }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

  $scope.onCnpjBlur = function (cnpj) {
    self.pessoaJuridicaService.byCnpj(cnpj).then(function (data) {
      if (data.id != null && data.id != undefined)
      delete data.pessoa.handler;
      delete data.pessoa.hibernateLazyInitializer;
      $scope.cliente.pessoaJuridica = data;
    });
  };

  $scope.adicionarTelefone = function (telefone) {
    if (telefone != null) 
      $scope.telefones.push(telefone);
    $scope.telefone = {};
  };

  $scope.atualizarMascaraTelefone = function (tipo) {
    $scope.mascara = (tipo.name == 'CELULAR') ? $scope.mascara = "(99)99999-9999": scope.mascara = "(99)9999-9999";
  }
  $scope.deletarTelefone = function (telefone) {
    $scope.telefones.splice($scope.telefones.indexOf(telefone), 1);
  };

  $scope.adicionarResponsavel = function (responsavel) {
    if (responsavel !== null) 
      $scope.responsaveis.push(responsavel);
    $scope.responsavel = {};
  };

  $scope.deletarResponsavel = function (responsavel) {
    $scope.responsaveis.splice($scope.responsaveis.indexOf(responsavel), 1);
  };
});
angular.module('bentham').factory('Cliente', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'clientes/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'clientes/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'clientes',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'clientes/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
        });
});

angular.module('bentham').factory('ClienteService', function (GenericService, Cliente, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Cliente();
    Object.setPrototypeOf(self.resource, Cliente);

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        if(data.pessoaJuridica.cnpj)
            data.pessoaJuridica.cnpj.toString().padStart(14, '0');
        deferred.resolve(data);
        return deferred.promise;
    };
    
    return function () { return self; };
});
angular.module('bentham').factory('ContaBancaria', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'contas/:id', { id: '@id', }, {
        delete: {   
            method: 'DELETE',
            url: prefixRoute + 'contas/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'contas/',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'contas/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        },
    });
});

angular.module('bentham').factory('ContaService', function (GenericService, ContaBancaria, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ContaBancaria();
    Object.setPrototypeOf(self.resource, ContaBancaria);
    return function () { return self; };
});
angular.module('bentham.pages.cadastrosbasicos').controller('ContaCtrl', function ($scope, ContaService, ContaBancaria, GenericController, $state, $stateParams, $uibModal) {

    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new ContaService();

    self.clear = function clear() {
        $scope.conta = new ContaBancaria();
    };

    $scope.open = function (page, size, title, conta) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.conta = conta;
                    return conta;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,  
            controller: 'ModalController'
        });
    };

});
angular.module('bentham').factory('Documento', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'documentos/:id', {
    id: '@id',
  }, {
    all: {
      method: 'GET',
      url: prefixRoute + 'documentos/',
      isArray: true
    },
    update: {
      method: 'PUT'
    },
    delete: {
      method: 'DELETE',
      url: prefixRoute + "documentos/:id",
    },
    catchFile: downloadFileResource({
      method: 'GET',
      url: prefixRoute + "documentos/catchFile/:id",
    }),
    pageable: {
      method: 'GET',
      url: prefixRoute + 'documentos/pageable',
      params: {
        'sort': '@sort',
        'number': '@number',
        'size': '@size'
      }

    },
  });
});


angular.module('bentham').factory('DocumentoService', function (GenericService, Documento, $q, prefixRoute, $http) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new Documento();
  Object.setPrototypeOf(self.resource, Documento);

  self.delete = function (documento) {
    var deferred = $q.defer();
    var fn = function () {
      self.resource.delete({
          id: documento.id
        }, function success(data) {
          deferred.resolve(data);
        },
        function (error) {
          error = self.catchMessage(error);
          deferred.reject(new Error("Erro! " + error.message));
        });
      return deferred.promise;
    }
    return self.process(fn);
  }

  self.all= function () {
    var deferred = $q.defer();
    var fn = function () {
      self.resource.all(function success(data) {
          deferred.resolve(data);
        },
        function (error) {
          error = self.catchMessage(error);
          deferred.reject(new Error("Erro! " + error.message));
        });
      return deferred.promise;
    }
    return self.process(fn);
  }

  self.catchFile = function (documento) {
    var deferred = $q.defer();
    var fn = function () {
      self.resource.catchFile({
          id: documento.id
        }, function success(data) {
          deferred.resolve(data);
        },
        function (error) {
          error = self.catchMessage(error);
          deferred.reject(new Error("Erro! " + error.message));
        });
      return deferred.promise;
    }
    return self.process(fn);
  }

  /*
    Upload generico para estruturar os arquivos dinamicamente
  */

  self.upload = function ($files, tipoAnexo, target) {
    var deferred = $q.defer();
    if ($files[0].size <= 10485760) {
      var fd = new FormData();
      fd.append("file", $files[0]);
      $http.post(prefixRoute + 'documentos/' +
        "?tipoAnexo=" + (tipoAnexo != undefined || tipoAnexo != null ? tipoAnexo : "") +
        "&&target=" + (target != undefined || target != null ? target : ""), 
        fd, {
          withCredentials: true,
          headers: {
            'Content-Type': undefined
          },
          transformRequest: angular.identity
        }).then(function (response) {
        deferred.resolve(response.data.entity);
      }).catch(function (error) {
        deferred.reject(new Error("Erro! " + error.data.message));
      });
    }
    return deferred.promise;
  }

  return function () {
    return self;
  };
});
angular.module('bentham').factory('Endereco', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'enderecos/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'enderecos/:id',
            },
            save: {
                method: 'POST'
            },
            update:{
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'enderecos',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'enderecos/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
        });
});

angular.module('bentham').factory('EnderecoService', function (Endereco, GenericService,$q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Endereco();
    Object.setPrototypeOf(self.resource, Endereco);

    return function () { return self; };
});
angular.module('bentham.pages.cadastrosbasicos.fonte-recurso').controller('FonteRecursoCtrl', function ($scope, FonteDeRecursoService, FonteDeRecurso, GenericController, $stateParams, $uibModal, AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new FonteDeRecursoService();
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.fonte = new FonteDeRecurso();

    self.clear = function clear() {
        $scope.fonte = new FonteDeRecurso();
    };

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "sigla");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    if ($stateParams.fonteId)
                        entity.fonte = { id: $stateParams.fonteId }
                    $scope.fonte = entity;
                    return entity;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

});
angular.module('bentham').factory('FonteDeRecurso', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'fontes/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'fontes/:id',
            },
            save: {
                method: 'POST'
            },
            update:{
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'fontes',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'fontes/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }
            },
        });
});

angular.module('bentham').factory('FonteDeRecursoService', function (FonteDeRecurso, GenericService,$q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new FonteDeRecurso();
    Object.setPrototypeOf(self.resource, FonteDeRecurso);

    return function () { return self; };
});
angular.module('bentham.pages.cadastrosbasicos.fornecedores').controller('FornecedorCtrl', function ($scope, FornecedorService, Fornecedor, Endereco, PessoaFisicaService, GenericController, $state, $stateParams, $uibModal, AuthService, toastr) {

    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new FornecedorService();
    self.pessoaFisicaService = new PessoaFisicaService();
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    $scope.telefones = [];
    $scope.telefone = {};

    $scope.responsaveis = [];
    $scope.responsavel = {};

    $scope.contas = [];
    $scope.conta = {};

    self.clear = function clear() {
        $scope.fornecedor = new Fornecedor();
        $scope.fornecedor.pessoaJuridica = {};
        $scope.responsaveis = [];
        $scope.telefones = [];
        $scope.endereco = new Endereco();
        $scope.fornecedor.responsaveis = [];
        $scope.filtro = {};
    };

    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.fornecedorId) {
            self.find($stateParams.fornecedorId)
                .then(function (data) {
                    $scope.fornecedor = data;
                    $scope.endereco = $scope.fornecedor.pessoaJuridica.pessoa.endereco;
                    $scope.pessoaJuridica = $scope.fornecedor.pessoaJuridica;
                    $scope.isLoading = false;
                });
        } else {
            self.clear();
            $scope.isLoading = false;
        }
    }

    self.activate();


    $scope.open = function (page, size, title, fornecedor) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.fornecedor = fornecedor;
                    return fornecedor;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "pessoaJuridica.pessoa.nome");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };


    $scope.refresh = function () {
        $scope.load(self.tableState);
    };


    $scope.clear = function () {
        $state.go("cadastrosbasicos.fornecedores");
    };

    $scope.save = function () {
        $scope.isLoading = true;
        $scope.fornecedor.pessoaJuridica.pessoa.endereco = $scope.endereco;
        self.save($scope.fornecedor)
            .then(function success(data) {
                self.activate();
                $state.go("cadastrosbasicos.fornecedores");
                $scope.isLoading = false;
            }).catch(function (error) {
                toastr.error(error.message);
                $scope.isLoading = false;
            });
    }

    $scope.adicionarTelefone = function (telefone) {
        if (telefone != null)
            $scope.telefones.push(telefone);
        $scope.telefone = {};
    };

    $scope.atualizarMascaraTelefone = function (tipo) {
        if (tipo.name == 'CELULAR')
            $scope.mascara = "(99)99999-9999";
        else
            $scope.mascara = "(99)9999-9999";
    }

    $scope.deletarTelefone = function (telefone) {
        $scope.telefones.splice($scope.telefones.indexOf(telefone), 1);
    };

    $scope.adicionarContato = function (contato) {
        if (contato != null) {
            conta.endereco = $scope.endereco
            $scope.contatos.push(contato);
        }
        $scope.conta = {};
    };

    $scope.deletarConta = function (conta) {
        $scope.contas.splice($scope.contas.indexOf(conta), 1);
    };

    $scope.adicionarResponsavel = function (responsavel) {
        if (responsavel !== null)
            $scope.responsaveis.push(responsavel);
        $scope.responsavel = {};
    };

    $scope.deletarResponsavel = function (responsavel) {
        $scope.responsaveis.splice($scope.responsaveis.indexOf(responsavel), 1);
    };

    $scope.onCpfBlur = function (cpf) {
        self.pessoaFisicaService.byCpf(cpf).then(function (data) {
          if (data.id != null && data.id != undefined)
            $scope.responsavel = data;
        });
      };
    
});
angular.module('bentham').factory('Fornecedor', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'fornecedores/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'fornecedores/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'fornecedores',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'fornecedores/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
       });
});

angular.module('bentham').factory('FornecedorService', function (GenericService, Fornecedor, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Fornecedor();
    Object.setPrototypeOf(self.resource, Fornecedor);
    return function () { return self; };
});
angular.module('bentham.pages.cadastrosbasicos.funcionarios').controller('FuncionarioCtrl', function ($scope, $state, FuncionarioService, GenericController, $stateParams, Funcionario, $uibModal, AuthService, $window, PessoaFisicaService, toastr) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;
  self.service = new FuncionarioService();
  self.pessoaFisicaService = new PessoaFisicaService();

  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  $scope.telefone = {};
  $scope.telefones = [];

  self.clear = function clear() {
    $scope.funcionario = new Funcionario();
    $scope.telefones = [];
    $scope.endereco = {};
    $scope.filtro = {};
  };

  self.activate = function () {
    $scope.isLoading = true;
    if ($stateParams.funcionarioId) {
      self.find($stateParams.funcionarioId)
        .then(function (data) {
          $scope.funcionario = data;
          if(data.pessoaFisica.pessoa.endereco == null)
            data.pessoaFisica.pessoa.endereco = {};
          if(data.pessoaFisica.pessoa.telefones == null)
            data.pessoaFisica.pessoa.endereco = [];
          $scope.telefones = $scope.funcionario.telefones;
          $scope.endereco = $scope.funcionario.pessoaFisica.pessoa.endereco;
          $scope.isLoading = false;
        })
    } else {
      self.clear();
      $scope.isLoading = false;
    }
  }

  self.activate();

  $scope.clear = function () {
    self.clear();
    self.tableState.search = {};
    $scope.load(self.tableState);
  };

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "pessoaFisica.pessoa.nome");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          $scope.funcionario = entity;
          return entity;
        },
        self: function () {
          return self;
        },
        title: function () {
          return title;
        }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

  $scope.close = function () {
    $state.go("cadastrosbasicos.funcionarios");
  }

  $scope.save = function () {
    $scope.isLoading = true;
    $scope.funcionario.telefones = $scope.telefones;
    $scope.funcionario.pessoaFisica.pessoa.endereco = $scope.endereco;
    self.save($scope.funcionario)
      .then(function () { $state.go("cadastrosbasicos.funcionarios"); $scope.isLoading = false; })
      .catch(function (error) { $scope.isLoading = false; });
  }

  $scope.adicionarTelefone = function (telefone) {
    if (telefone != null) {
      $scope.telefones.push(telefone);
    }
    $scope.telefone = {};

  };

  $scope.deletarTelefone = function (telefone) {
    $scope.telefones.splice($scope.telefones.indexOf(telefone), 1);
  };

  $scope.atualizarMascaraTelefone = function (tipo) {
    if (tipo.name == 'CELULAR') {
      $scope.mascara = "(99)99999-9999";
    } else {
      $scope.mascara = "(99)9999-9999";
    }
  };

  $scope.onCpfBlur = function (cpf) {
    self.pessoaFisicaService.byCpf(cpf).then(function (data) {
      if (data.id != null && data.id != undefined)
        $scope.funcionario.pessoaFisica = data;
    });
  };

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);
    filtro.departamento != null ? filtro.departamentoId = filtro.departamento.id : null;
    filtro.departamento = null;
    if ($scope.aberto == true)
      filtro.search = null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
  };

  $scope.clear = function () {
    self.clear();
  };

});
angular.module('bentham').factory('Funcionario', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'funcionarios/:id', {
    id: '@id',
  }, {
    save: {
      method: 'POST'
    },
    all: {
      method: 'GET',
      isArray: true,
    },
    update: {
      method: 'PUT'
    },
    deletar: {
      method: 'DELETE'
    },
    pageable: {
      method: 'GET',
      url: prefixRoute + 'funcionarios/pageable',
      params: {
        'sort': '@sort',
        'number': '@number',
        'size': '@size'
      }
    }
  });
});

angular.module('bentham').factory('FuncionarioService', function (GenericService, Funcionario, $q) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new Funcionario();
  Object.setPrototypeOf(self.resource, Funcionario);

  self.converte = function (data) {
    return data;
  };

  self.valida = function (entity) {
    var data = angular.copy(entity)
    var deferred = $q.defer();
    if (!entity.pessoaFisica.cpf)
      deferred.reject(new Error("Cpf não foi preenchido corretamente!"));
    if (!entity.pessoaFisica.rg)
      deferred.reject(new Error("Rg não foi preenchido corretamente!"));
    else
      deferred.resolve(data);
    return deferred.promise
  };

  return function () { return self; };
});

angular.module('bentham.pages.cadastrosbasicos.naturezas').controller('NaturezaCtrl', function ($scope, NaturezaService, Natureza, $uibModal, GenericController) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new NaturezaService();
    $scope.natureza = new Natureza();
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.natureza = new Natureza();
    };

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "codigo");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    }

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.natureza = entity;
                    return entity;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.naturezaPai = function(pai){
        $scope.natureza.codigo = pai.codigo+"."
    }

});
angular.module('bentham').factory('Natureza', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'naturezas/:id', {
    id: '@id',
  }, {
      save: {
        method: 'POST'
      },
      all: {
        method: 'GET',
        isArray: true,
      },
      update: {
        method: 'PUT'
      },
      delete: {
        method: 'DELETE'
      },
      pageable: {
        method: 'GET',
        url: prefixRoute + 'naturezas/pageable',
        params: {
          'sort': '@sort',
          'number': '@number',
          'size': '@size'
        }
      },
    });
});

angular.module('bentham').factory('NaturezaService', function (GenericService, Natureza) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new Natureza();
  Object.setPrototypeOf(self.resource, Natureza);
  return function () { return self; };
});

angular.module('bentham.pages.cadastrosbasicos.pessoafisica').controller('PessoaFisicaCtrl', function ($scope, $state, PessoaFisicaService, GenericController, $stateParams, PessoaFisica, $uibModal, AuthService, $window, toastr) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    $scope.authService = AuthService;
    self.service = new PessoaFisicaService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.pessoaFisica = new PessoaFisica();
        $scope.pessoaFisica.pessoa = {};
        $scope.filtro = {};
    };
    self.clear();
    
    $scope.load = function load(tableState) {
        self.initTableState(tableState, "pessoa.nome");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    }

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    if(!entity.pessoa)
                        entity.pessoa = {};
                    if(!entity.pessoa.endereco)
                        entity.pessoa.endereco = {};
                    $scope.pessoaFisica = entity;
                    $scope.endereco = entity.pessoa.endereco;
                    return entity;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.clear = function () {
        $window.history.back();
    }
    
    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        if ($scope.aberto == true)
            filtro.search = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };

    $scope.clear = function () {
        self.clear();
    };

    $scope.onCepBlur = function (cep) {
        self.enderecoService.byCep(cep).then(function (data) {
            if (data.codigoPostal != null && data.codigoPostal != undefined)
                $scope.pessoaFisica.endereco = data;
        });
    };
});
angular.module('bentham').factory('PessoaFisica', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'pessoas-fisicas/:id', {
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'pessoas-fisicas/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'pessoas-fisicas',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'pessoas-fisicas/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        },
        byCpf: {
            method: 'GET',
            url: prefixRoute + 'pessoas-fisicas/byCpf',
        }
    });
});

angular.module('bentham').factory('PessoaFisicaService', function (GenericService, PessoaFisica, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new PessoaFisica();
    Object.setPrototypeOf(self.resource, PessoaFisica);


    self.byCpf = function (cpf) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.byCpf({
                    cpf: cpf
                },
                function (data) {
                    deferred.resolve(data);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }



    return function () {
        return self;
    };
});
angular.module('bentham').factory('Pessoa', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'pessoas/:id', {
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'pessoas/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'pessoas',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'pessoas/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        }
    });
});

angular.module('bentham').factory('PessoaService', function (GenericService, Pessoa, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Pessoa();
    Object.setPrototypeOf(self.resource, Pessoa);
    return function () { return self;};
});
angular.module('bentham.pages.cadastrosbasicos.pessoajuridica').controller('PessoaJuridicaCtrl', function ($scope, $state, PessoaJuridicaService, GenericController, $stateParams, PessoaJuridica, $uibModal, AuthService, $window, toastr) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    $scope.authService = AuthService;
    self.service = new PessoaJuridicaService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.pessoaJuridica = new PessoaJuridica();
        $scope.pessoaJuridica.pessoa = {}
        $scope.filtro = {};
    };
    self.clear();

    // self.activate = function () {
    //     $scope.isLoading = true;
    //     if ($stateParams.pessoaJuridicaId) {
    //         self.find($stateParams.pessoaJuridicaId)
    //             .then(function (data) {
    //                 $scope.pessoaJuridica = data;
    //                 $scope.isLoading = false;
    //             })
    //     } else {
    //         $scope.isLoading = false;
    //     }
    // }
    // self.activate();

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "pessoa.nome");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    }

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    if(entity.pessoa.endereco == null)
                        entity.pessoa.endereco = {};
                    $scope.pessoaJuridica = entity;
                    $scope.endereco = entity.pessoa.endereco;
                    return entity;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.clear = function () {
        $window.history.back();
    }
    
    $scope.save = function () {
        $scope.isLoading = true;
        $scope.pessoaJuridica.telefones = $scope.telefones;
        $scope.pessoaJuridica.endereco = $scope.endereco;
        self.save($scope.pessoaJuridica)
            .then(function () {
                $state.go("cadastrosbasicos.pessoajuridica");
                $scope.isLoading = false;
            }).catch(function (error) {
                $scope.isLoading = false;
            });

    }

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        filtro.cnpj != null ? filtro.cnpj = filtro.cnpj.toString().padStart(14, '0') : null;
        if ($scope.aberto == true)
            filtro.search = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };

    $scope.clear = function () {
        self.clear();
    };

    $scope.onCnpjBlur = function (cnpj) {
        self.service.byCnpj(cnpj).then(function (data) {
            if (data.id != null && data.id != undefined)
            $scope.pessoaJuridica = data;
        });
    };    

    $scope.isCheckCnpjExists = function() {
        if(!$scope.pessoaJuridica.cnpj) return false
        return true
    };
});
angular.module('bentham').factory('PessoaJuridica', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'pessoas-juridicas/:id', {
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'pessoas-juridicas/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'pessoas-juridicas',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'pessoas-juridicas/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        },
        byCnpj: {
            method: 'GET',
            url: prefixRoute + 'pessoas-juridicas/byCnpj',
        }
    });
});

angular.module('bentham').factory('PessoaJuridicaService', function (GenericService, PessoaJuridica, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new PessoaJuridica();
    Object.setPrototypeOf(self.resource, PessoaJuridica);


    self.byCnpj = function (cnpj) {
        var deferred = $q.defer();
        if(cnpj != null)
            cnpj = cnpj.toString().padStart(14, '0');  
        var fn = function () {
            self.resource.byCnpj({ cnpj: cnpj }, 
                function (data) { deferred.resolve(data); },
                function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message));});
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        data.cnpj.toString().padStart(14, '0');
        deferred.resolve(data);
        return deferred.promise;
    };


    return function () {
        return self;
    };
});
angular.module('bentham').factory('PessoaFisica', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'pessoas-fisicas/:id', {
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'pessoas-fisicas/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'pessoas-fisicas',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'pessoas-fisicas/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        },
        byCpf: {
            method: 'GET',
            url: prefixRoute + 'pessoas-fisicas/byCpf',
        }
    });
});

angular.module('bentham').factory('PessoaFisicaService', function (GenericService, PessoaFisica, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new PessoaFisica();
    Object.setPrototypeOf(self.resource, PessoaFisica);


    self.byCpf = function (cpf) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.byCpf({
                    cpf: cpf
                },
                function (data) {
                    deferred.resolve(data);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }



    return function () {
        return self;
    };
});
angular.module('bentham.pages.cadastrosbasicos').controller('ResponsavelCtrl', function ($scope, PessoaFisicaService, GenericController, PessoaFisica, $uibModal, AuthService, $window, toastr) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;
  self.service = new PessoaFisicaService();

  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  self.clear = function clear() {
      $scope.pessoaFisica = new PessoaFisica();
      $scope.pessoaFisica.pessoa = {};
      $scope.filtro = {};
  };
  self.clear();
  
  $scope.load = function load(tableState) {
      self.initTableState(tableState, "pessoa.nome");
      $scope.isLoading = true;
      self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
          .then(function (result) {
              $scope.displayed = result.content;
              self.updateTableState(result)
              $scope.isLoading = false;
          })
          .catch(function (error) {
              toastr.error(error.message);
          });
  };

  $scope.refresh = function () {
      $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
      $uibModal.open({
          animation: true,
          templateUrl: page,
          size: size,
          resolve: {
              entity: function () {
                  if(!entity.pessoa)
                      entity.pessoa = {};
                  if(!entity.pessoa.endereco)
                      entity.pessoa.endereco = {};
                  $scope.pessoaFisica = entity;
                  $scope.endereco = entity.pessoa.endereco;
                  return entity;
              },
              self: function () {
                  return self;
              },
              title: function () {
                  return title;
              }
          },
          scope: $scope,
          controller: 'ModalController'
      });
  };

  $scope.clear = function () {
      $window.history.back();
  }
  
  $scope.search = function () {
      var filtro = angular.copy($scope.filtro);
      if ($scope.aberto == true)
          filtro.search = null;
      self.tableState.search = filtro;
      $scope.load(self.tableState);
  };

  $scope.clear = function () {
      self.clear();
  };

  $scope.onCepBlur = function (cep) {
      self.enderecoService.byCep(cep).then(function (data) {
          if (data.codigoPostal != null && data.codigoPostal != undefined)
              $scope.pessoaFisica.endereco = data;
      });
  };
});
angular.module('bentham').controller('ButtonImportCtrl', function ($scope, $element, prefixRoute, $http, $q) {
    var self = this;
    $scope.prefixRoute = prefixRoute + "imports/";

    $scope.fillRoute = function (filter) {
        var route = "";
        for (var property in filter) {
            if (filter[property] != null && typeof filter[property] == 'object' && filter[property].id)
                route += property + "Id=" + filter[property].id + "&&";
            else if (filter[property] != null && typeof filter[property] == 'object' && filter[property].name)
                route += property + "=" + filter[property].name + "&&";
            else
                route += (filter[property] != null && typeof filter[property] != 'object' ? property + "=" + filter[property] + "&&" : "");
        }
        return route;
    }

    $scope.onFileSelectUploadPlanilha = function ($files, filter) {
        // $http.post(prefixRoute + "imports/" + $element.attr("entity"), { fitler: filter, file: file })
        // .then(function (response) { console.log(response); }).catch(function (error) { console.log(error); });
        var deferred = $q.defer();
        if ($files[0].size <= 10485760) {
            var fd = new FormData();
            fd.append("file", $files[0]);
            $http.post($scope.prefixRoute + $element.attr("entity") + $scope.fillRoute(filter), fd, {
                withCredentials: true,
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            }).then(function (response) {
                deferred.resolve(response.data.entity);
            }).catch(function (error) {
                deferred.reject(new Error("Erro! " + error));
            });
        }
        return deferred.promise;
    };



});
angular.module('bentham').component('buttonImport', {
      template: '<label class="btn btn-info btn-with-icon" type="button"><i class="ion-arrow-up-c"></i>Importar <input class="input_file" type="file" onchange="angular.element(this).scope().onFileSelectUploadPlanilha(this.files, this.filter)" ng-model="files" ng-file-select="onFileSelectUploadPlanilha($files, this.filter)" /></label>',
      bindings: { filter: '=' },
      controller: 'ButtonImportCtrl'
});
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('bentham.pages.maps')
        .controller('LeafletPageCtrl', LeafletPageCtrl);

    /** @ngInject */
    function LeafletPageCtrl($scope, $timeout, $http, leafletData, leafletDrawEvents, $q, fileReader, EnderecoService, Endereco, EstadoService, Estado, MunicipioService, Municipio, $filter, $uibModal, baProgressModal, toastr) {
        var self = this;
        self.service = new EnderecoService();
        self.municipioService = new MunicipioService();
        self.estadoService = new EstadoService();

        function initialize() {
            //L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
            // var map = L.map(document.getElementById('leaflet-map'))
            //     .setView([51.505, -0.09], 13);
            // map.addControl(new L.Control.Search({
            //     url: 'http://200.17.32.22:8080/nominatim/search?format=json&q={s}',
            //     jsonpParam: 'json_callback',
            //     propertyName: 'display_name',
            //     propertyLoc: ['lat', 'lon'],
            //     marker: L.circleMarker([0, 0], {
            //         radius: 30
            //     }),
            //     autoCollapse: true,
            //     autoType: false,
            //     minLength: 2
            // }));

        }

        // $timeout(function () {
        //     initialize();
        // }, 100);
        // leafletData.getGeoJSON().then(function (lObjs) {
        //     window.leafletDataGeoJSON = lObjs;
        // });

        var drawn = new L.FeatureGroup();
        $scope.drawnCount = function () {
            return drawn.getLayers().length;
        }

        angular.extend($scope, {
            center: {
                lat: -4.5611866,
                lng: -37.7690846,
                zoom: 6
            },
            layers: {
                baselayers: {
                    osm: {
                        name: 'OpenStreetMap',
                        url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                        type: 'xyz'
                    }
                },
                overlays: {
                    draw: {
                        name: 'draw',
                        type: 'group',
                        visible: true,
                        layerParams: {
                            showOnSelector: false
                        }
                    }
                }
            },
            defaults: {
                scrollWheelZoom: true
            },
            legend: {
                position: 'bottomleft',
                colors: ['#ff0000', '#28c9ff', '#0000ff', '#ecf386'],
                labels: ['Estados', 'Endereços', 'Obras', 'Estacas']
            },
            // controls: {
            //     fullscreen: {
            //         position: 'topleft'
            //     }
            // },
            drawOptions: {
                position: "topleft",
                draw: {
                    polyline: false,
                    polygon: false,
                    rectangle: false,
                    circle: false,
                    marker: true
                },
                edit: {
                    featureGroup: drawn,
                    remove: true
                }
            }
        });

        var handle = {
            created: function (e, leafletEvent, leafletObject, model, modelName) {
                drawn.addLayer(leafletEvent.layer);
                //console.log(leafletEvent.layer._latlngs[0].lat);
                //$scope.latitude =
            },
            edited: function (arg) { },
            deleted: function (arg) { },
            drawstart: function (arg) { },
            drawstop: function (arg) { },
            editstart: function (arg) { },
            editstop: function (arg) { },
            deletestart: function (arg) { },
            deletestop: function (arg) { }
        };

        var drawEvents = leafletDrawEvents.getAvailableEvents();
        drawEvents.forEach(function (eventName) {
            $scope.$on('leafletDirectiveDraw.' + eventName, function (e, payload) {
                //{leafletEvent, leafletObject, model, modelName} = payload
                var leafletEvent, leafletObject, model, modelName; //destructuring not supported by chrome yet :(
                leafletEvent = payload.leafletEvent, leafletObject = payload.leafletObject, model = payload.model,
                    modelName = payload.modelName;
                handle[eventName.replace('draw:', '')](e, leafletEvent, leafletObject, model, modelName);
            });
        });

        // // Mouse over function, called from the Leaflet Map Events
        // var countryMouseover = function (feature, leafletEvent) {
        //     var layer = leafletEvent.target;
        //     layer.setStyle({
        //         weight: 2,
        //         color: '#666',
        //         fillColor: 'white'
        //     });
        //     layer.bringToFront();
        // };

        // $scope.$on("leafletDirectiveGeoJson.mouseover", function (ev, leafletPayload) {
        //     countryMouseover(leafletPayload.leafletObject.feature, leafletPayload.leafletEvent);
        // });

        // $scope.centerJSON = function (name) {
        //     leafletData.getMap().then(function (map) {
        //         window.leafletMap = map;
        //         var latlngs = [];
        //         for (var i in $scope.geojson[name].data.features[0].geometry.coordinates) {
        //             var coord = $scope.geojson[name].data.features[0].geometry.coordinates[i];
        //             for (var j in coord) {
        //                 var points = coord[j];
        //                 for (var k in points) {
        //                     latlngs.push(L.GeoJSON.coordsToLatLng(points[k]));
        //                 }
        //             }
        //         }
        //         map.fitBounds(latlngs);
        //     });
        // };

        function zoomToFeature(e) {
            map.fitBounds(e.target.getBounds());
        }

        function highlightFeature(e) {
            var layer = e.target;
        
            layer.setStyle({
                weight: 5,
                color: '#666',
                dashArray: '',
                fillOpacity: 0.7
            });
        
            if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
                layer.bringToFront();
            }
        }

        function onEachFeature(feature, layer) {
            layer.on({
                mouseover: highlightFeature,
                mouseout: resetHighlight
            });
        }

        // Get the countries geojson data from a JSON
        self.estadoService.listGeojson()
            .then(function (result, status) {
                $scope.estados = result;
                angular.extend($scope.layers.overlays, {
                    estados: {
                        name: 'Estados',
                        type: 'geoJSONShape',
                        url: '',
                        visible: true,
                        data: result,
                        resetStyleOnMouseout: true,
                        style: {
                            fillColor: "green",
                            weight: 2,
                            opacity: 1,
                            color: 'white',
                            dashArray: '3',
                            fillOpacity: 0.7
                        },
                        //onEachFeature: onEachFeature,
                        layerOptions : {}
                    }
                });
            });

        self.municipioService.listGeojson()
            .then(function (result, status) {
                $scope.municipios = result;
                angular.extend($scope.layers.overlays, {
                    municipios: {
                        data: result,
                        name: 'Municipios',
                        type: 'geoJSON',
                        resetStyleOnMouseout: true,
                        style: {
                            fillColor: "green",
                            weight: 2,
                            opacity: 1,
                            color: 'white',
                            dashArray: '3',
                            fillOpacity: 0.7
                        }
                    }
                });
            });

    }
})();
angular.module('bentham').
directive('selectAreaSistema', ['AreaSistema', function (AreaSistema) {
  return {
    restrict: 'E',
    transclude: true,
    link: function (scope, element, attrs) {
      scope.$_areasSistemas = AreaSistema.all();
      $_area_sistema_order = ''
      scope.$_area_sistema_label = attrs.noSelectionLabel || "Selecione uma Área";
    },
    template: "<select class='form-control' ng-options='area as area.descricao for area in $_areasSistemas orderBy: descricao track by area.id'>" +
      "<option value=''>{{$_area_label}}</option></select>",
    replace: true
  };
}]);
angular.module("bentham").directive("selectArea", [
  "Area",
  function(Area) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_areas = Area.all();
        scope.$_area_label = attrs.noSelectionLabel || "Selecione uma Área";
      },
      template:
        "<select class='form-control' ng-options='area as area.descricao for area in $_areas | orderBy: descricao track by area.id'>" +
        "<option value=''>{{$_area_label}}</option></select>",
      replace: true
    };
  }
]);

angular.module("bentham").directive("selectAreas", [ "Area", function(Area) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_areas = Area.all();
        setTimeout(null, 5000);
        scope.$_area_label = attrs.noSelectionLabel || "Selecione uma Area";
      },
      template:
        '<select multiple="" selectpicker="" class="form-control" ng-options="area as area.descricao for area in $_areas | orderBy: descricao track by area.id">' +
        '<option value="">{{$_area_label}}</option></select>',
      replace: true
    };
  }
]);

angular.module('bentham').
directive('selectBanco', ['Banco',function(Banco) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_bancos = Banco.all();
        scope.$_bancos_label = attrs.noSelectionLabel || "Selecione um Banco";
        scope.$_sort = "nome";
      },
      template:'<select class="form-control" ng-options="banco as banco.nome for banco in $_bancos | orderBy: $_sort track by banco.id">'+
          '<option value="">{{$_bancos_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').
directive('selectCargo', ['Cargo',function(Cargo) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_cargos = Cargo.all();
        scope.$_cargo_label = attrs.noSelectionLabel || "Selecione um Cargo";
      },
      template:'<select class="form-control" ng-options="cargo as cargo.nome for cargo in $_cargos | orderBy: nome track by cargo.nome" >'+
          '<option value="">{{$_cargo_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').
  directive('selectCentroCusto', ['CentroDeCusto', function (CentroDeCusto) {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        resource: '=',
        filter: '=',
      },
      link: function (scope, element, attrs) {
        scope.$watchGroup(['resource', 'filter'], function (newValues) {
          var resource = newValues[0];
          var filter = newValues[1];
          
          scope.$_centro_custo_label = attrs.noSelectionLabel || "Selecione um Centro de Custo";
          if (!resource) {
            scope.$_centro_custos = CentroDeCusto.all();
            return;
          }
          scope.$_centro_custos = CentroDeCusto[resource](filter);
        });
      },
      template: "<select class='form-control' ng-options='centro_custo as centro_custo.nome for centro_custo in $_centro_custos | orderBy: nome track by centro_custo.id'>" +
        '<option value="">{{$_centro_custo_label}}</option></select>',
      replace: true
    };
  }]);

angular.module('bentham').directive('selectCentroDeCustoByUsuario', ['CentroDeCustoView', function (CentroDeCustoView) {
  return {
    restrict: 'E',
    transclude: true,
    link: function (scope, element, attrs) {
      scope.$_centro_de_custo_label = "Selecione um Centro de Custo";
      scope.$_sort = "centroDeCusto.nome";
      scope.$_space = " - ";
      scope.$_centro_de_custos = CentroDeCustoView.findAllByUsuario();
    },
    template: '<select class="form-control" ng-options="centroDeCusto as centroDeCusto.nome for centroDeCusto in $_centro_de_custos | orderBy: $_sort track by centroDeCusto.id">' +
      '<option value="">{{$_centro_de_custo_label}}</option></select>',
    replace: true
  };
}]);
angular.module("bentham").directive("selectCliente", [
  "Cliente",
  function(Cliente) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_clientes = Cliente.all();
        scope.$_space = " - ";
        scope.$_sort = 'pessoaJuridica.nomeFantasia'
        scope.$_cliente_label = attrs.noSelectionLabel || "Selecione um Cliente";
      },
      template:
        '<select class="form-control" ng-options="cliente as cliente.pessoaJuridica.nomeFantasia+$_space+cliente.pessoaJuridica.cnpj+$_space+cliente.pessoaJuridica.pessoa.nome for cliente in $_clientes | orderBy: $_sort track by cliente.id">' +
        '<option value="">{{$_cliente_label}}</option></select>',
      replace: true
    };
  }
]);

angular.module("bentham").directive("selectConsorcio", [
  "Consorcio",
  function(Consorcio) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_consorcios = Consorcio.all();
        scope.$_sort = 'pessoaJuridica.nomeFantasia'
        scope.$_consorcio_label = attrs.noSelectionLabel || "Selecione um Consorcio";
        scope.$_space = " - ";
      },
      template:
        '<select class="form-control" ng-options="consorcio as consorcio.pessoaJuridica.nomeFantasia+$_space+consorcio.pessoaJuridica.cnpj+$_space+consorcio.pessoaJuridica.pessoa.nome for consorcio in $_consorcios | orderBy: $_sort track by consorcio.id">' +
        '<option value="">{{$_consorcio_label}}</option></select>',
      replace: true
    };
  }
]);

angular.module('bentham').
directive('selectConsultaByUsuarioAndPerfil', ['Consulta',function(Consulta) {
  return {
    restrict: 'E',
    transclude: true,
    link: function(scope, $element, attrs) {
      var entidade = $element.attr("entidade");
      scope.$_consultas = Consulta.getByUsuarioOrPerfil({entidade : entidade != null ? entidade : null});
    },
    template:'<select class="form-control" ng-options="consulta as consulta.nome for consulta in $_consultas | orderBy: nome track by consulta.id">'+
        '<option value="">Selecione uma Consulta</option></select>', 
    replace: true
  };
}])
angular.module('bentham').
directive('selectContaBancaria', ['ContaBancaria',function(ContaBancaria) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_contas = ContaBancaria.all();
        scope.$_conta_label = attrs.noSelectionLabel || "Selecione uma Conta Bancária";
        scope.$_sort = "nomeDaConta";        
      },
      template:'<select class="form-control" ng-options="conta as conta.nomeDaConta for conta in $_contas orderBy: $_sort track by conta.id">'+
          '<option value="">{{$_conta_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').directive('selectContratoExterno', ['ContratoExterno', function (ContratoExterno) {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      filtro: '=',
    },
    link: function (scope, element, attrs) {
      scope.$_contrato_label = "Selecione um Contrato";
      scope.$_sort = "centroCusto.nome";
      scope.$_space = " - ";
      scope.$watch('filtro', function (filtro) {
        scope.$_contratos = ContratoExterno.all(filtro);
      });
    },
    template: '<select class="form-control" ng-options="contrato as contrato.centroCusto.nome+$_space+contrato.numeroContrato for contrato in $_contratos | orderBy: $_sort track by contrato.id">' +
      '<option value="" disabled>{{$_contrato_label}}</option></select>',
    replace: true
  };
}]);
angular.module("bentham").directive("selectCriterioJulgamento", [
  "CriterioJulgamento",
  function(CriterioJulgamento) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_criterio_julgamentos = CriterioJulgamento.all();
        scope.$_criterio_julgamento_label = attrs.noSelectionLabel || "Selecione um Critério de Julgamento";
      },
      template:
        "<select class='form-control' ng-options='criterioJulgamento as criterioJulgamento.descricao for criterioJulgamento in $_criterio_julgamentos | orderBy: descricao track by criterioJulgamento.id'>" +
        "<option value=''>{{$_criterio_julgamento_label}}</option></select>",
      replace: true
    };
  }
]);

angular.module("bentham").directive("selectCriteriosJulgamentos", [ "CriterioJulgamento", function(CriterioJulgamento) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_criterio_julgamentos = CriterioJulgamento.all();
        setTimeout(null, 5000);
        scope.$_criterio_julgamento_label = attrs.noSelectionLabel || "Selecione um Criterio de Julgamento";
      },
      template:
        '<select multiple="" selectpicker="" class="form-control" ng-options="criterioJulgamento as criterioJulgamento.descricao for criterioJulgamento in $_criterio_julgamentos | orderBy: descricao track by criterioJulgamento.id">' +
        '<option value="">{{$_criterio_julgamento_label}}</option></select>',
      replace: true
    };
  }
]);

angular.module('bentham').
directive('selectDepartamento', ['Departamento',function(Departamento) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_departamentos = Departamento.all();
        scope.$_departamento_label = attrs.noSelectionLabel || "Selecione um Departamento";
        scope.$_sort = "nome";
      },
      template:'<select class="form-control" ng-options="departamento as departamento.nome for departamento in $_departamentos | orderBy: $_sort track by departamento.id">'+
          '<option value="">{{$_departamento_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').
directive('selectEnum', ['Enum', function (Enum) {
  return {
    restrict: 'E',
    scope: {

    },
    link: function (scope, element, attrs) {
      scope.$_values = Enum.all({
        tipo: attrs.tipo
      });
      scope.$_tipoLabel = attrs.tipoLabel;
      scope.$_sort = "descricao";

      if (scope.$_values.$promise) {
        scope.$_values.$promise.then(function (values) {
          for (var value in values) 
            if (values[value].descricao === undefined) 
              scope.$_values[value].descricao = values[value].name;
        });
      }
    },
    template: '<select class="form-control" ng-options="tipo as tipo.descricao for tipo in $_values | orderBy: $_sort track by tipo.name">' +
      '<option value="">Selecione a opção</option></select>',
    replace: true
  };
}]);
angular.module('bentham').
directive('selectEnums', ['Enum', function (Enum) {
  return {
    restrict: 'E',
    scope: {

    },
    link: function (scope, element, attrs) {
      scope.$_values = Enum.all({
        tipo: attrs.tipo
      });
      scope.$_tipoLabel = attrs.tipoLabel;
      scope.$_sort = "descricao";

      if (scope.$_values.$promise) {
        scope.$_values.$promise.then(function (values) {
          for (var value in values) 
            if (values[value].descricao === undefined) 
              scope.$_values[value].descricao = values[value].name;
        });
      }
    },
    template:
    '<select multiple="" selectpicker="" class="form-control" ng-options="tipo as tipo.descricao for tipo in $_values | orderBy: $_sort track by tipo.name">' +
    '<option value="">Selecione a opção</option></select>',
    replace: true
  };
}]);
angular.module('bentham').
directive('selectFonteRecurso', ['FonteDeRecurso',function(FonteDeRecurso) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_fontes = FonteDeRecurso.all();
        scope.$_fonte_label = attrs.noSelectionLabel || "Selecione uma Fonte de Recurso";
        scope.$_space = " - ";
        scope.$_sort = "sigla";
      },
      template:'<select class="form-control" ng-options="fonte as fonte.sigla+$_space+fonte.nome for fonte in $_fontes | orderBy: $_sort track by fonte.id">'+
          '<option value="">{{$_fonte_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').
directive('selectFormaDePagamento', ['FormaDePagamento',function(FormaDePagamento) {
  return {
    restrict: 'E',
    transclude: true,
    link: function(scope, element, attrs) {
      scope.$_formasDePagamento = FormaDePagamento.all();
      scope.$_formaDePagamento_label = attrs.noSelectionLabel || "Selecione a Forma de Pagamento";
    },
    template:'<select class="form-control" ng-options="formaDePagamento as formaDePagamento.nome for formaDePagamento in $_formasDePagamento track by formaDePagamento.nome">'+
        '<option value="">{{$_formaDePagamento_label}}</option></select>',
    replace: true
  };
}]);
angular.module('bentham').
directive('selectFormatoContaContabil', ['FormatoContaContabil',function(FormatoContaContabil) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs, tabsCtrl) {
        scope.$_formatos = FormatoContaContabil.all();
      },
      template:'<select ng-options="formato as formato.nome for formato in $_formatos track by formato.id"><option value="">Selecione o Formato de Contas</option>'+
          '</select>',
      replace: true
    };
  }])
angular.module("bentham").directive("selectFornecedor", [
  "Fornecedor",
  function(Fornecedor) {
    return {
      restrict: "E",
      transclude: true,
      scope: {
        watchTo: "="
      },
      link: function(scope, element, attrs) {
        scope.$_fornecedores = Fornecedor.all();
        scope.$_fornecedor_label = attrs.noSelectionLabel || "Selecione um Fornecedor";
        scope.$_sort = 'pessoaJuridica.nomeFantasia' 
        scope.$_space = " - ";
      },
      template:
        '<select class="form-control" ng-options="fornecedor as fornecedor.pessoaJuridica.nomeFantasia+$_space+fornecedor.pessoaJuridica.cnpj+$_space+fornecedor.pessoaJuridica.pessoa.nome for fornecedor in $_fornecedores | orderBy: $_sort track by fornecedor.nome">' +
        '<option value="">{{$_fornecedor_label}}</option></select>',
      replace: true
    };
  }
]);

angular.module("bentham").directive("selectFuncionario", [
  "Funcionario",
  function(Funcionario) {
    return {
      restrict: "E",
      transclude: true,
      scope: {
        watchTo: '='
      },
        link: function(scope, element, attrs) {
        scope.$_funcionarios_label = attrs.noSelectionLabel || "Selecione um Funcionario";
        scope.$_sort = "pesoaFisica.pessoa.nome";
        scope.$watch('watchTo', function (departamento) {
          if (departamento != undefined || departamento != null){
            scope.$_funcionarios_label = "Selecione um Responsável";
            scope.$_funcionarios = Funcionario.all( {
              departamentoId: departamento
            });
          }
          else
            scope.$_funcionarios = Funcionario.all();
        });
  
      },
      template:
        '<select  class="form-control" ng-options="funcionario as funcionario.pessoaFisica.pessoa.nome for funcionario in $_funcionarios | orderBy: $_sort track by funcionario.id">' +
        '<option value="">{{$_funcionarios_label}}</option></select>',
      replace: true
    };
  }
]);

angular.module("bentham").directive("selectFuncionarios", [ "Funcionario", function(Funcionario) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_funcionarios = Funcionario.all();
        setTimeout(null, 5000);
        scope.$_funcionario_label = attrs.noSelectionLabel || "Selecione um Funcionario";
        scope.$_sort = 'pessoaFisica.pessoa.nome'
      },
      template:
        '<select multiple="" selectpicker="" class="form-control" ng-options="funcionario as funcionario.pessoaFisica.pessoa.nome for funcionario in $_funcionarios | orderBy: $_sort track by funcionario.id">' +
        '<option value="">{{$_funcionario_label}}</option></select>',
      replace: true
    };
  }
]);

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('bentham')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }
          setTimeout(function(){ elem.selectpicker('refresh'); }, 500);

          if (attrs.ngModel) 
            scope.$watch(attrs.ngModel, refresh);

          if (attrs.ngDisabled) 
            scope.$watch(attrs.ngDisabled, refresh);

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
angular.module('bentham').
directive('selectGrupoAreaSistema', ['GrupoAreaSistema', function (GrupoAreaSistema) {
  return {
    restrict: 'E',
    transclude: true,
    link: function (scope, element, attrs) {
      scope.$_grupoAreasSistemas = GrupoAreaSistema.all();
      scope.$_grupo_area_sistema_label = attrs.noSelectionLabel || "Selecione uma Grupo";
    },
    template: "<select class='form-control' ng-options='grupo as grupo.descricao for grupo in $_grupoAreasSistemas | orderBy: descricao track by grupo.id'>" +
      "<option value=''>{{$_grupo_area_sistema_label}}</option></select>",
    replace: true
  };
}]);
angular.module('bentham').
directive('selectIndicador', ['Indicador',function(Indicador) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_indicadors = Indicador.all();
        scope.$_indicador_label = attrs.noSelectionLabel || "Selecione um Indicador";
      },
      template:'<select class="form-control" ng-options="indicador as indicador.descricao for indicador in $_indicadors | orderBy: descricao track by indicador.descricao" >'+
          '<option value="">{{$_indicador_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').directive('selectIndiceReajuste', ['IndiceDeReajuste', function (IndiceDeReajuste) {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      contratoExterno: '=',
      indicesReajuste: '=',
    },
    link: function (scope, element, attrs) {
      scope.$_indice_label = attrs.noSelectionLabel || "Selecione um Índice";
      scope.$_sort = "inicio";
      scope.$_dataformat = "dd/MM/y";
      scope.$_format = "real";
      scope.$_space = " - ";
      scope.$_percentage = "%";

      scope.$watchGroup(['contratoExterno', 'indicesReajuste'], function (values) {
        var contratoExterno = values[0];
        var indicesReajuste = values[1];
        if (indicesReajuste) {
          scope.$_indices = indicesReajuste;
          return;
        }
        
        if (contratoExterno) {
          scope.$_indices = IndiceDeReajuste.all({
            contratoExternoId: contratoExterno.id
          });
          return;
        }

        scope.$_indices = [];
      });
    },

    template: '<select class="form-control" ng-options="indice as (indice.percentual|mask:$_format) + $_percentage + $_space +(indice.inicio|date:$_dataformat)+ $_space +(indice.fim|date:$_dataformat) for indice in $_indices | orderBy:$_sort track by indice.id" >' +
      '<option value="">{{$_indice_label}}</option></select>',
    replace: true
  };
}]);
angular.module('bentham').
directive('selectKpi', ['Kpi',function(Kpi) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_kpis = Kpi.all();
        scope.$_kpi_label = attrs.noSelectionLabel || "Selecione um Kpi";
      },
      template:'<select class="form-control" ng-options="kpi as kpi.descricao for kpi in $_kpis | orderBy: descricao track by kpi.descricao" >'+
          '<option value="">{{$_kpi_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').
directive('selectLocalOrigemServico', ['LocalOrigemServico',function(LocalOrigemServico) {
  return {
    restrict: 'E',
    transclude: true,
    link: function(scope, element, attrs) {
      scope.$_locais = LocalOrigemServico.all();
      scope.$_local_label = attrs.noSelectionLabel || "Selecione um Local Origem Serviço";
    },
    template:'<select class="form-control" ng-options="local as local.local for local in $_locais track by local.local">'+
        '<option value="">{{$_local_label}}</option></select>',
    replace: true
  };
}]);
angular.module('bentham').directive('selectMedicao', ['Medicao', function (Medicao) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            contratoExterno: '=',
            centroDeCusto: '='
          },
        link: function (scope, element, attrs) {
            scope.$_medicoes = Medicao.all();
            scope.$_medicoes_label = attrs.noSelectionLabel || "Selecione uma Medição";
            scope.$watch('contratoExterno', function (contratoExterno) {
                if (contratoExterno != undefined || contratoExterno != null)
                  scope.$_medicoes = Medicao.all({ contratoExterno: contratoExterno.id });
                // else
                //   scope.$_medicoes = Produto.all();
              });
              scope.$watch('centroDeCusto', function (centroDeCusto) {
                if (centroDeCusto != undefined || centroDeCusto != null)
                  scope.$_medicoes = Medicao.all({ centroDeCusto: centroDeCusto.id });
                // else
                //   scope.$_medicoes = Produto.all();
              });
        
        },
        template: '<select class="form-control" ng-options="medicao as medicao.codigo for medicao in $_medicoes orderBy: $_sort track by medicao.id">' +
            '<option value="">{{$_medicoes_label}}</option></select>',
        replace: true
    };
}]);
// angular.module('bentham').directive('multiSelectUsuario', ['Usuario', function (Usuario) {
//   return {
//     restrict: 'E',
//     transclude: true,
//     link: function (scope, element, attrs) {
//       scope.$_usuarios = Usuario.all();
//     },
//     template: `
//       <ui-select class="form-control" multiple search-enabled="true" append-to-body="true">
//         <ui-select-match placeholder="Selecione Usuários">
//           <p>{{$item.nome}}</p>
//         </ui-select-match>
//         <ui-select-choices repeat="usuario in $_usuarios | filter: $select.search">
//           <p>{{usuario.pessoaFisica.pessoa.nome}}</p>
//         </ui-select-choices>
//       </ui-select>`,
//     replace: true
//   };
// }]);
angular.module('bentham').
directive('selectNatureza', ['Natureza',function(Natureza) {
  return {
    restrict: 'E',
    transclude: true,
    link: function(scope, element, attrs) {
      scope.$_naturezas = Natureza.all();
      scope.$_espaco = " - "; 
      scope.$_natureza_label = attrs.noSelectionLabel || "Selecione uma Natureza";
    },
    template:'<select class="form-control" ng-options="natureza as (natureza.codigo+$_espaco+natureza.descricao) for natureza in $_naturezas track by natureza.id">'+
        '<option value="">Selecione a Natureza</option></select>',
    replace: true
  };
}])
angular.module('bentham').directive('selectOrdemServico', ['OrdemDeServico', function (OrdemDeServico) {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      watchTo: '='
    },
    link: function (scope, element, attrs) {
      scope.$_ordem_servico_label = "Selecione uma Ordem de Serviço";
      scope.$_sort = "data";
      scope.$_space = " - ";
      scope.$watch('watchTo', function (contratoExterno) {
        if (contratoExterno != undefined || contratoExterno != null)
          scope.$_ordem_servicos = OrdemDeServico.all({
            contratoExternoId: contratoExterno.id
          });
        else
          scope.$_ordem_servicos = OrdemDeServico.all();
      });
    },
    template: '<select class="form-control" ng-options="ordemServico as ordemServico.numero for ordemServico in $_ordem_servicos | orderBy: $_sort track by ordemServico.id">' +
      '<option value="">{{$_ordem_servico_label}}</option></select>',
    replace: true
  };
}]);
angular.module('bentham').
directive('selectOrder', [function() {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_orders = ['asc', 'desc'];
        scope.$_orders_label = attrs.noSelectionLabel || "Selecione uma Ordem";
      },
      template:'<select class="form-control" ng-options="order for order in $_orders">'+
          '<option value="">{{$_orders_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').
directive('selectPais', ['Pais',function(Pais) {
  return {
    restrict: 'E',
    transclude: true,
    link: function(scope, element, attrs) {
      scope.$_paises = Pais.all();
    },
    template:'<select class="form-control" ng-options="pais as pais.nome for pais in $_paises | orderBy: nome track by pais.id">'+
        '<option value="">Selecione o País</option></select>',
    replace: true
  };
}])
angular.module("bentham").directive("selectParceiro", [
  "Parceiro",
  function(Parceiro) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_parceiros = Parceiro.all();
        scope.$_parceiro_label =
          attrs.noSelectionLabel || "Selecione um Parceiro";
        scope.$_sort = "pessoaJuridica.nomeFantasia";
        scope.$_space = " - ";
      },
      template:
        '<select class="form-control" ng-options="parceiro as parceiro.pessoaJuridica.nomeFantasia+$_space+parceiro.pessoaJuridica.cnpj+$_space+parceiro.pessoaJuridica.pessoa.nome for parceiro in $_parceiros | orderBy: $_sort track by parceiro.id">' +
        '<option value="">{{$_parceiro_label}}</option></select>',
      replace: true
    };
  }
]);

angular.module('bentham').directive('selectPerfil', ['Perfil', function (Perfil) {
    return {
      restrict: 'E',
      transclude: true,
      link: function (scope, element, attrs) {
        scope.$_perfis = Perfil.all();
        scope.$_perfis_label = attrs.noSelectionLabel || "Selecione um Perfil";
      },
      template: '<select class="form-control" ng-options="perfil as perfil.descricao for perfil in $_perfis | orderBy: descricao track by perfil.id">' +
        '<option value="">{{$_perfis_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').
directive('selectPerspectivasContratosAssinado', ['Perspectiva',function(Perspectiva) {
  return {
    restrict: 'E',
    transclude: true,
    link: function(scope, element, attrs) {
      scope.$_perspectivas = Perspectiva.findAllContratosAssinados();
      scope.$_space = " / ";
      scope.$_hiffen = " -> ";
    },
    template:'<select class="form-control" ng-options="perspectiva as perspectiva.codigo + $_hiffen + perspectiva.numeroEdital + $_space +perspectiva.titulo for perspectiva in $_perspectivas | orderBy: -id track by perspectiva.id">'+
        '<option value="">Selecione o Perspectiva</option></select>', 
    replace: true
  };
}])
angular.module("bentham").directive("selectPessoaFisica", [
  "PessoaFisica",
  function(PessoaFisica) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_pessoas_fisicas = PessoaFisica.all();
        scope.$_pessoa_fisica_label = attrs.noSelectionLabel || "Selecione uma Pessoa Fisica";
        scope.$_sort = "pessoa.nome";
        scope.$_space = " - ";
      },
      template:
        '<select class="form-control" ng-options="pessoaFisica as pessoaFisica.pessoa.nome+$_space+pessoaFisica.cpf for pessoaFisica in $_pessoas_fisicas | orderBy: $_sort track by pessoaFisica.id">' +
        '<option value="">{{$_pessoa_Fisica_label}}</option></select>',
      replace: true
    };
  }
]);

angular.module("bentham").directive("selectPessoaJuridica", [
  "PessoaJuridica",
  function(PessoaJuridica) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_pessoas_juridicas = PessoaJuridica.all();
        scope.$_pessoa_juridica_label = attrs.noSelectionLabel || "Selecione uma Pessoa Juridica";
        scope.$_sort = "nomeFantasia";
        scope.$_space = " - ";
      },
      template:
        '<select class="form-control" ng-options="pessoaJuridica as pessoaJuridica.nomeFantasia+$_space+pessoaJuridica.cnpj+$_space+pessoaJuridica.pessoa.nome for pessoaJuridica in $_pessoas_juridicas | orderBy: $_sort track by pessoaJuridica.id">' +
        '<option value="">{{$_pessoa_juridica_label}}</option></select>',
      replace: true
    };
  }
]);

angular.module("bentham").directive("selectPessoa", [
  "Pessoa",
  function(Pessoa) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_pessoas = Pessoa.all();
        scope.$_pessoa_label = attrs.noSelectionLabel || "Selecione uma Pessoa ";
        scope.$_sort = "nome";
        scope.$_space = " - ";
      },
      template:
        '<select class="form-control" ng-options="pessoa as pessoa.nome for pessoa in $_pessoas | orderBy: $_sort track by pessoa.id">' +
        '<option value="">{{$_pessoa_label}}</option></select>',
      replace: true
    };
  }
]);

angular.module("bentham").directive("selectPessoasFisicas", [ "PessoaFisica", function(PessoaFisica) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_pessoafisicas = PessoaFisica.all();
        setTimeout(null, 5000);
        scope.$_pessoafisica_label = attrs.noSelectionLabel || "Selecione um PessoaFisica";
        scope.$_sort = 'pessoaFisica.pessoa.nome'
      },
      template:
        '<select multiple="" selectpicker="" class="form-control" ng-options="pessoafisica as pessoafisica.pessoa.nome for pessoafisica in $_pessoafisicas | orderBy: $_sort track by pessoafisica.id">' +
        '<option value="">{{$_pessoafisica_label}}</option></select>',
      replace: true
    };
  }
]);

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('bentham')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }
          setTimeout(function(){ elem.selectpicker('refresh'); }, 500);

          if (attrs.ngModel) 
            scope.$watch(attrs.ngModel, refresh);

          if (attrs.ngDisabled) 
            scope.$watch(attrs.ngDisabled, refresh);

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
angular.module('bentham').
directive('selectPlanoDeContas', ['PlanoDeConta',function(PlanoDeConta) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_planos = PlanoDeConta.all();
        scope.$_plano_label = attrs.noSelectionLabel || "Selecione um Plano de Contas";
      },
      template:'<select ng-options="plano as plano.titulo for plano in $_planos track by plano.titulo">'+
          '<option value="">{{$_plano_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').
directive('selectProduto', ['Produto', function (Produto) {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      contratoExterno: '=',
      centroDeCusto: '='
    },
    link: function (scope, element, attrs) {
      scope.$_produto_label = attrs.noSelectionLabel || "Selecione um Produto";
      scope.$_space = " - ";
      scope.$_sort = "-dataContrato";
      scope.$watch('contratoExterno', function (contratoExterno) {
        if (contratoExterno != undefined || contratoExterno != null)
          scope.$_produtos = Produto.all({ contratoExterno: contratoExterno.id });
        // else
        //   scope.$_produtos = Produto.all();
      });
      scope.$watch('centroDeCusto', function (centroDeCusto) {
        if (centroDeCusto != undefined || centroDeCusto != null)
          scope.$_produtos = Produto.all({ centroDeCusto: centroDeCusto.id });
        // else
        //   scope.$_produtos = Produto.all();
      });
    },
    template: '<select class="form-control" ng-options="produto as produto.descricao for produto in $_produtos | orderBy: $_sort track by produto.id">' +
      '<option value="">{{$_produto_label}}</option></select>',
    replace: true
  };
}]);
angular.module('bentham').
  directive('selectRegiao', ['Regiao', function (Regiao) {
    return {
      restrict: 'E',
      transclude: true,
      link: function (scope, element, attrs) {
        scope.$_regioes = Regiao.all();
        scope.$_regiao_label = attrs.noSelectionLabel || "Selecione uma Região";
      },
      template: '<select class="form-control" ng-options="regiao as regiao.descricao for regiao in $_regioes | orderBy: descricao track by regiao.descricao">' +
        '<option value="">{{$_regiao_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').
directive('selectSituacaoPerspectiva', ['SituacaoPerspectiva', function (SituacaoPerspectiva) {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      watchTo: '='
    },
    link: function (scope, element, attrs) {
      scope.$_situacao_label = attrs.noSelectionLabel || "Selecione uma Situacao";
      scope.$_sort = "descricao";
      scope.$_space = " -> ";

      scope.$watch('watchTo', function (tipoLicitacao) {
        if (tipoLicitacao != undefined && tipoLicitacao != null)
          scope.$_situacoes = SituacaoPerspectiva.all({
            tipoLicitacao: tipoLicitacao.id
          });
        else
          scope.$_situacoes = SituacaoPerspectiva.all();
      });
    },
    template: '<select class="form-control" ng-options="situacao as situacao.situacaoPerspectiva.descricao+$_space+situacao.descricao for situacao in $_situacoes|orderBy:$_sort track by situacao.id">' +
      '<option value="">{{$_situacao_label}}</option></select>',
    replace: true
  };
}]);

angular.module('bentham').
directive('selectSituacaoPerspectivaAnterior', ['SituacaoPerspectiva', function (SituacaoPerspectiva) {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      watchTo: '='
    },
    link: function (scope, element, attrs) {
      scope.$_situacao_label = attrs.noSelectionLabel || "Selecione uma Situacao";
      scope.$_sort = "descricao";
      scope.$_space = " ";
      scope.$watch('watchTo', function (object) {
        var tipoLicitacao = object.tipoLicitacao;
        var situacao = object.situacaoPerspectiva;
        situacao = typeof (situacao) == 'undefined' || situacao == null ? null : situacao.id;
        if (situacao != null)
          scope.$_situacoes = [];
        scope.$_situacoes = SituacaoPerspectiva.all({
          tipoLicitacao: tipoLicitacao.id,
          situacaoPerpectiva: situacao
        });
      });
    },
    template: '<select class="form-control" ng-options="situacao as situacao.codigo+$_space+situacao.descricao for situacao in $_situacoes|orderBy:$_sort track by situacao.id">' +
      '<option value="">{{$_situacao_label}}</option></select>',
    replace: true
  };
}]);


angular.module('bentham').
directive('selectSituacaoPerspectivaByCodigo', ['SituacaoPerspectiva', function (SituacaoPerspectiva) {
  return {
    restrict: 'E',
    transclude: true,
    link: function (scope) {
      var sort = function(a, b) {
        if (a[0]<b[0]) 
          return -1;
        if (a[0]>b[0]) 
          return 1;
        return 0;
      }

      scope.$_situacoes = SituacaoPerspectiva.uniqueByCodigo({},
        function (data) { data.sort(sort); },
        function (error) { error = self.catchMessage(error); });
    },
    template: '<select class="form-control">'+'<option value="">Selecione uma Situação</option>'
      +'<option ng-repeat="situacao in $_situacoes" value="{{situacao[0]}}">{{situacao[1]}}</option></select>' ,
    replace: true
  };
}]);

angular.module('bentham').
directive('selectSituacaoPerspectivaByCodigoApresentadas', ['SituacaoPerspectiva', function (SituacaoPerspectiva) {
  return {
    restrict: 'E',
    transclude: true,
    link: function (scope) {
      var sort = function(a, b) {
        if (a[0]<b[0]) 
          return -1;
        if (a[0]>b[0]) 
          return 1;
        return 0;
      }

      var clearNegativItems = function(arr) {
        function startWithNegative(item) {
          var lowerText = item[0].toLowerCase();
          var startsWithNao = lowerText.indexOf("nao") === 0;
          var isOnHold = lowerText === "analise_edital" || lowerText === "elaboracao";

          return startsWithNao || isOnHold;
        };

        for(var i=0; i<arr.length; i++) {
          var item = arr[i];
          
          // if(startWithNegative(item)) {
          //   arr.splice(i, 1)
          //   i--;
          // }

        }

        return arr.filter(startWithNegative);
      }

      scope.$_situacoesClean = SituacaoPerspectiva.uniqueByCodigo({},
        function (data) { 
          return clearNegativItems(data.sort(sort));
        },
        function (error) { error = self.catchMessage(error); });
    },
    template: '<select class="form-control">'+'<option value="">Selecione uma Situação</option>'
      +'<option ng-repeat="situacao in $_situacoesClean" value="{{situacao[0]}}">{{situacao[1]}}</option></select>' ,
    replace: true
  };
}]);
angular.module("bentham").directive("selectSubArea", [
  "SubArea",
  function(SubArea) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_sub_areas = SubArea.all();
        scope.$_sub_area_label = attrs.noSelectionLabel || "Selecione uma Subárea";
      },
      template:
        "<select class='form-control' ng-options='subArea as subArea.descricao for subArea in $_sub_areas | orderBy: descricao track by subArea.id'>" +
        "<option value=''>{{$_sub_area_label}}</option></select>",
      replace: true
    };
  }
]);

angular.module("bentham").directive("selectSubAreas", [ "SubArea", function(SubArea) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_sub_areas = SubArea.all();
        setTimeout(null, 5000);
        scope.$_sub_area_label = attrs.noSelectionLabel || "Selecione uma Sub Area";
      },
      template:
        '<select multiple="" selectpicker="" class="form-control" ng-options="subArea as subArea.descricao for subArea in $_sub_areas | orderBy: descricao track by subArea.id">' +
        '<option value="">{{$_sub_area_label}}</option></select>',
      replace: true
    };
  }
]);

angular.module('bentham').
directive('selectTipoAcaoJuridico', ['Enum', function (Enum) {
  return {
    restrict: 'E',
    scope: {
      options: '='
    },
    link: function (scope, element, attrs) {
      scope.$_values = scope.options;
      scope.$_tipoLabel = attrs.tipoLabel;
      scope.$_sort = "descricao";

      if (scope.options) {
        for (var value in scope.options) 
            if (scope.options[value].descricao === undefined) 
              scope.options[value].descricao = scope.options[value].name;
      }
    },
    template: '<select class="form-control" ng-options="tipo as tipo.descricao for tipo in $_values | orderBy: $_sort track by tipo.name">' +
      '<option value="">Selecione a opção</option></select>',
    replace: true
  };
}]);
angular.module('bentham').
directive('selectTipoDocumento', ['TipoDocumento', function (TipoDocumento) {
  return {
    restrict: 'E',
    transclude: true,
    link: function (scope, element, attrs) {
      scope.$_tipo_label = attrs.noSelectionLabel || "Selecione um Tipo";
      scope.$_tipos = TipoDocumento.all();

    },
    template: '<select class="form-control" ng-options="tipo as tipo.descricao for tipo in $_tipos | orderBy: descricao track by tipo.id">' +
      '<option value="">{{$_tipo_label}}</option></select>',
    replace: true
  };
}]);
angular.module('bentham').
directive('selectInstituicaoOrigemServico', ['InstituicaoOrigemServico',function(InstituicaoOrigemServico) {
  return {
    restrict: 'E',
    transclude: true,
    link: function(scope, element, attrs) {
      scope.$_instituicoes = InstituicaoOrigemServico.all();
      scope.$_instituicao_origem_label = attrs.noSelectionLabel || "Selecione um Tipo de Instituição";
    },
    template:'<select class="form-control" ng-options="instituicao_origem as instituicao_origem.tipoInstituicao for instituicao_origem in $_instituicoes track by instituicao_origem.tipoInstituicao">'+
        '<option value="">{{$_instituicao_origem_label}}</option></select>',
    replace: true
  };
}]);
angular.module('bentham').
directive('selectTipoItemServico', ['TipoItemServico',function(TipoItemServico) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_tipos_item_servico = TipoItemServico.all();
        scope.$_tipo_item_servico_label = attrs.noSelectionLabel || "Selecione uma Tipo de Item de Serviço";
      },
      template:'<select ng-options="tipo as tipo.descricao for tipo in $_tipos_item_servico track by tipo.descricao">'+
          '<option value="">{{$_tipo_item_servico_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').
directive('selectTipoLicitacao', ['TipoLicitacao',function(TipoLicitacao) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_tipoLicitacoes = TipoLicitacao.all();
        scope.$_tipoLicitacao_label = attrs.noSelectionLabel || "Selecione um Tipo de Licitação";
        scope.$_sort = "sigla";
      },
      template:'<select class="form-control" ng-options="tipoLicitacao as tipoLicitacao.sigla for tipoLicitacao in $_tipoLicitacoes | orderBy: $_sort track by tipoLicitacao.id">'+
          '<option value="">{{$_tipoLicitacao_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').
directive('selectTipoPerspectiva', ['TipoPerspectiva',function(TipoPerspectiva) {
  return {
    restrict: 'E',
    transclude: true,
    link: function(scope, element, attrs) {
      scope.$_tipoPerspectivas = TipoPerspectiva.all();
      scope.$_tipoPerspectiva_label = attrs.noSelectionLabel || "Selecione um Tipo de Perspectiva";
    },
    template:'<select class="form-control" ng-options="tipoPerspectiva as tipoPerspectiva.descricao for tipoPerspectiva in $_tipoPerspectivas track by tipoPerspectiva.id">'+
        '<option value="">{{$_tipoPerspectiva_label}}</option></select>',
    replace: true
  };
}]);
angular.module('bentham').directive('selectTipoServicoDespesa',function(TipoServicoDespesa) {
  return {
    restrict: 'E',
    transclude: true,
    link: function(scope, element, attrs) {
      scope.$_tipo_servicos = TipoServicoDespesa.all();
      scope.$_tipo_servico_label = attrs.noSelectionLabel || "Selecione um Tipo de Serviço/Despesa";
      scope.$_sort = "tipoServicoDespesa";
    },
    template:'<select class="form-control" ng-options="tipo_servico as tipo_servico.tipoServicoDespesa for tipo_servico in $_tipo_servicos | orderBy: $_sort track by tipo_servico.id">'+
        '<option value="">{{$_tipo_servico_label}}</option></select>',
    replace: true
  };
});
angular.module("bentham").directive("selectTipoServico", [
  "TipoServico",
  function(TipoServico) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_tipoServicos = TipoServico.all();
        scope.$_tipoServico_label =
          attrs.noSelectionLabel || "Selecione um Tipo de Serviço";
      },
      template:
        '<select class="form-control" ng-options="tipoServico as tipoServico.descricao for tipoServico in $_tipoServicos | orderBy: descricao track by tipoServico.id">' +
        '<option value="">{{$_tipoServico_label}}</option></select>',
      replace: true
    };
  }
]);

angular.module("bentham").directive("selectTipoServicos", [ "TipoServico", function(TipoServico) {
    return {
      restrict: "E",
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_tipo_servicos = TipoServico.all();
        setTimeout(null, 5000);
        scope.$_tipo_servico_label = attrs.noSelectionLabel || "Selecione um Tipo de Serviço";
      },
      template:
        '<select multiple="" selectpicker="" class="form-control" ng-options="tipoServico as tipoServico.descricao for tipoServico in $_tipo_servicos | orderBy: descricao track by tipoServico.id">' +
        '<option value="">{{$_tipo_servico_label}}</option></select>',
      replace: true
    };
  }
]);

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('bentham')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }
          setTimeout(function(){ elem.selectpicker('refresh'); }, 500);

          if (attrs.ngModel) 
            scope.$watch(attrs.ngModel, refresh);

          if (attrs.ngDisabled) 
            scope.$watch(attrs.ngDisabled, refresh);

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
angular.module('bentham').
directive('selectTipoConta', ['TipoConta',function(TipoConta) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_tipos_conta = TipoConta.all();
        scope.$_tipos_conta_label = attrs.noSelectionLabel || "Selecione o Tipo da Conta";
      },
      template:'<select class="form-control"  ng-options="tipoConta as tipoConta.descricao for tipoConta in $_tipos_conta track by tipoConta.descricao">'+
          '<option value="">{{$_tipos_conta_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').
directive('selectUnidadeFederativa', ['UnidadeFederativa',function(UnidadeFederativa) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_ufs = UnidadeFederativa.all();
        scope.$_uf_label = attrs.noSelectionLabel || "Selecione a Unidade Federativa";
      },
      template:'<select ng-options="uf as uf.sigla for uf in $_ufs | orderBy: sigla track by uf.id">'+
          '<option value="">{{$_uf_label}}</option></select>',
      replace: true
    };
  }]);
angular.module('bentham').
directive('selectUnidadeMedida', ['UnidadeMedida',function(UnidadeMedida) {
    return {
      restrict: 'E',
      transclude: true,
      link: function(scope, element, attrs) {
        scope.$_unidadeMedidas = UnidadeMedida.all();
        scope.$_unidadeMedida_label = attrs.noSelectionLabel || "Selecione uma Unidade de Medida";
      },
      template:'<select class="form-control" ng-options="unidadeMedida as unidadeMedida.descricao for unidadeMedida in $_unidadeMedidas | orderBy: descricao track by unidadeMedida.descricao" >'+
          '<option value="">{{$_unidadeMedida_label}}</option></select>',
      replace: true
    };
  }]);
angular.module("bentham").directive("selectUsuario", [ "Usuario", function(Usuario) {
  return {
    restrict: "E",
    transclude: true,
    scope: {
      watchTo: '='
    },
    link: function(scope, element, attrs) {
      scope.$_usuario_label = attrs.noSelectionLabel || "Selecione um Usuário";
      scope.$_sort = 'pessoaFisica.pessoa.nome'
      scope.$watch('watchTo', function (perfil) {
        if(!perfil) {
          scope.$_usuario_label = "Selecione um Responsável";
          scope.$_usuarios = Usuario.all( {perfil: 100903});
        }
        if(perfil.id) {
          scope.$_usuarios = Usuario.all({
            perfil: perfil.id
          });
        }else if(perfil.descricao) {
          scope.$_usuarios = Usuario.findByPerfilDescricaoContainingAndAtivoTrue({
            descricao: perfil.descricao
          });
        }
      });
    },
    template:
      '<select class="form-control" ng-options="usuario as usuario.pessoaFisica.pessoa.nome for usuario in $_usuarios | orderBy: $_sort track by usuario.id">' +
      '<option value="">{{$_usuario_label}}</option></select>',
    replace: true
  };
}]);

angular.module('bentham').controller('ModalPrintCtrl', function ($scope, $element, prefixRoute, $http,  $uibModal,$q) {
    var self = this;
    $scope.prefixRoute = prefixRoute;
    $scope.route = "";
    $scope.title = $element.attr("title");
    $scope.reportTitle = $element.attr("reportTitle");
    $scope.filter = '';

    self.print = function (formato) {
        var deferred = $q.defer();
        if (formato.name == "PDF")
            window.open($scope.prefixRoute + "relatorios/" + $scope.route + "formato=" + formato.name);
        else if (formato.name == "XLS" || formato.name == "CSV")
            $scope.download(($scope.prefixRoute + "relatorios/" + $scope.route + "formato=" + formato.name),formato)
        else
            window.open($scope.prefixRoute + "relatorios/" + $scope.route + "formato=" + formato.name);
        $scope.route = "";
        deferred.resolve();
        return deferred.promise;
    };
    
    $scope.forceFileDownload = function (bytes, formato) {
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob([bytes]));
        link.setAttribute('download', $scope.reportTitle + (formato.name == "XLS" ? ".xls" : ".csv"))
        document.body.appendChild(link)
        link.click()
    };

    $scope.download = function (route, formato) {
        $http({url:route, method: 'GET', responseType: "arraybuffer",}).then(function (response) {
            $scope.forceFileDownload(response.data, formato);
        }).catch(function (error) { toastr.error(error.message); });
    };

    $scope.openModalPrint = function (filter, search) {
        $scope.route = $element.attr("route")
        if(search)
            $scope.route += $scope.fillRoute(search(filter));
        else 
            $scope.route += $scope.fillRoute(filter);

        $uibModal.open({
            animation: true,
            templateUrl: 'app/pages/components/modal-print/modal-print.html',
            size: 'sm',
            resolve: {
                entity: function(){},
                self: function () {
                    return self;
                },
                title: function () {
                    return $scope.reportTitle;
                }
            },
            scope: $scope,
            controller: "ModalController"
        });
    };
    
    $scope.fillRoute = function (filter) {
        var route = "";
        for (var property in filter) {
            if (filter[property] != null && typeof filter[property] == 'object' && filter[property] instanceof Date)
                route += property + "=" + filter[property].toISOString() + "&&";
            if (filter[property] != null && Array.isArray(filter[property]))
                for(i = 0; i < filter[property].length; i++)
                    route += property + "=" + filter[property][i] + "&&";
            if (filter[property] != null && typeof filter[property] == 'object' && filter[property].id)
                route += property + "=" + filter[property].id + "&&";
            else if (filter[property] != null && typeof filter[property] == 'object' && filter[property].name)
                route += property + "=" + filter[property].name + "&&";
            else
                route += (filter[property] != null && typeof filter[property] != 'object' ? property + "=" + filter[property] + "&&" : "");
        }
        return route;
    }
});
angular.module('bentham').component('modalPrint', {
      template: "<a class='btn btn-success' style='color:#fff;' data-toggle='tooltip' title='Emitir' ng-click='openModalPrint($ctrl.filter, $ctrl.search)' type='button'><i class='fa fa-print'></i> {{$ctrl.title}}</a>",
      bindings: {
            filter: '=',
            title: '=',
            search:'='
      },
      controller: 'ModalPrintCtrl'
});
angular.module('bentham.pages.configuracoes.alertadeemail').controller('AlertadeEmailCtrl', function ($scope, ServidorEmailService, ServidorDeEmail, GenericController, $uibModal, AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new ServidorEmailService();
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
  
    self.clear = function clear() {
      $scope.alerta = new ServidorDeEmail();
    };
  
    $scope.load = function load(tableState) {
      self.initTableState(tableState, "emailRemetente");
      $scope.isLoading = true;
      self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
        .then(function (result) {
          $scope.displayed = result.content;
          self.updateTableState(result)
          $scope.isLoading = false;
        })
        .catch(function (error) { toastr.error(error.message); });
    };
  
    $scope.refresh = function () {
      $scope.load(self.tableState);
    };
  
    $scope.open = function (page, size, title, alerta) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          entity: function () {
            $scope.alerta = alerta;
            return alerta;
          },
          self: function () { return self; },
          title: function () { return title; }
        },
        scope: $scope,
        controller: 'ModalController'
      });
    };
  });
angular.module('bentham').factory('ServidorDeEmail', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'servidor-email/:id', {
    id: '@id',
  }, {
      delete: {
        method: 'DELETE',
        url: prefixRoute + 'servidor-email/:id',
      },
      save: {
        method: 'POST'
      },
      update: {
        method: 'PUT'
      },
      all: {
        method: 'GET',
        isArray: true,
        url: prefixRoute + 'servidor-email',
      },
      pageable: {
        method: 'GET',
        url: prefixRoute + 'servidor-email/pageable',
        params: {
          'sort': '@sort',
          'number': '@number',
          'size': '@size'
        }

      },
    });
});

angular.module('bentham').factory('ServidorEmailService', function (GenericService, ServidorDeEmail, $q) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new ServidorDeEmail();
  Object.setPrototypeOf(self.resource, ServidorDeEmail);
  return function () { return self; };
});
angular.module('bentham.pages.configuracoes.bancos').controller('BancoCtrl', function ($scope, $stateParams, BancoService, Banco,$uibModal, GenericController, AuthService) {
 
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;
  self.service = new BancoService();
  $scope.banco = new Banco();
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  self.clear = function clear() {
    $scope.banco = new Banco();
  };

  // $scope.save = function () {
  //   self.save($scope.banco)
  //     .then(function success(data) {
  //       self.activate();
  //       $state.go("configuracoes.bancos")
  //     });
  // }

  self.activate = function () {
    if ($stateParams.bancoId) {
      self.find($stateParams.bancoId)
        .then(function (data) { $scope.banco = data; })
    } else {
      self.clear();
    }
  }

  self.activate();

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "nome");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) { toastr.error(error.message); });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          $scope.banco = entity;
          return entity;
        },
        self: function () { return self; },
        title: function () { return title; }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

});

angular.module('bentham').factory('Banco', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'bancos/:id', {
        id: '@id',
    }, {
            delete: {   
                method: 'DELETE',
                url: prefixRoute + 'bancos/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'bancos/',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'bancos/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
        });
});

angular.module('bentham').factory('BancoService', function (GenericService, Banco, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Banco();
    Object.setPrototypeOf(self.resource, Banco);
    return function () { return self; };
});
angular.module('bentham.pages.configuracoes.departamento').controller('ConsultaCtrl', function ($scope, ConsultaService, Consulta, GenericController, $uibModal, AuthService, Usuario, Perfil, $window, $stateParams, toastr, $state) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  self.service = new ConsultaService();
  $scope.authService = AuthService;
  $scope.itemsByPage = 25;
  $scope._usuarios = Usuario.all();
  $scope._perfis = Perfil.all();

  $scope.itemsByPageOptions = self.itemsByPageOptions;

  self.clear = function clear() {
    $scope.consulta = new Consulta();
    $scope.filtro = {};
  };

  // $scope.clear = function () {
  //   $window.history.back();
  // };

  $scope.clear = function () {
    $scope.filtro = {};
  }

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);
    filtro.entidade != null ? filtro.entidade = filtro.entidade.name : null;
    if ($scope.aberto == true)
      filtro.search = null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
  };


  $scope.save = function () {
    $scope.isLoading = true;
    if ($scope.filtro != null) {
      var campos = [];
      angular.forEach($scope.filtro, function (value, key) {
        var campo = {};
        if (value != null && value != undefined && value != "") {
          if (key.indexOf("show") !== -1) {
            campo.type = 'column'
            campo.valor = value;
          }else if (typeof value == 'object') {
            campo.type = 'object'
            if (value.id)
              campo.valor = value.id;
            else if (value.name)
              campo.valor = value.name;
          } else {
            campo.type = "string"
            campo.valor = value;
          }
          campo.descricao = key;
          campos.push(campo);
        }
      });
      $scope.consulta.campos = campos;
    }
    self.save($scope.consulta)
      .then(function success(data) {
        self.clear();
        self.activate();
        $state.go("configuracoes.consultas")
        $scope.isLoading = false;
      }).catch(function (error) {
        toastr.error(error.message);
        $scope.isLoading = false;
      });
  };


  $scope.load = function load(tableState) {
    self.initTableState(tableState, "");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  };

  $scope.open = function (page, size, title, departamento) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          $scope.departamento = departamento;
          return departamento;
        },
        self: function () {
          return self;
        },
        title: function () {
          return title;
        }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };


  self.activate = function () {
    if ($stateParams.consultaId) {
      self.find($stateParams.consultaId)
        .then(function (data) {
          $scope.consulta = data;
          $scope.filtro = {};
          $scope.OnEntidadeChange($scope.consulta.entidade.name)
          $scope.consulta.campos.forEach(function (campo) {
            if (campo.type == 'object')
              if (campo.valor.match(/\d+/g))
                $scope.filtro[campo.descricao] = {
                  id: campo.valor
                };
              else
                $scope.filtro[campo.descricao] = {
                  name: campo.valor
                };
            else
              $scope.filtro[campo.descricao] = campo.valor;
          });
        })
    } else {
      self.clear();
    }
  }

  self.activate();

  $scope.OnEntidadeChange = function (entidade) {
    $scope.isLoading = true;
    if (entidade != null) {
      for (var i = 0; i <= $scope.entities.length - 1; i++) {
        if ($scope.entities[i].searchForm != null && entidade == $scope.entities[i].entityName) {
          $scope.entitySelected = $scope.entities[i];
          if(entidade=="Perspectiva"){
                $scope.filtro.ordenacao = {
                    class: "br.com.bentham.enums.OrdenacaoPerspectiva",
                    declaringClass: "br.com.bentham.enums.OrdenacaoPerspectiva",
                    descricao: "Data Apresentação",
                    name: "DATA_APRESENTACAO",
                    nome: "dataApresentacao"
                };
                $scope.filtro.visao = 'geral';
            }
          $scope.isLoading = false;
          break;
        }
      }
    }
  };

  $scope.entities = [{
      entityName: "Usuario",
      searchForm: "app/pages/seguranca/usuario/usuarioSearch.html",
      controller: "UsuarioCtrl",
      service: "UsuarioService"
    },
    {
      entityName: "Cliente",
      searchForm: "app/pages/cadastrosbasicos/clientes/clienteSearch.html",
      controller: "ClienteCtrl",
      service: "ClienteService"
    },
    {
      entityName: "Parceiro",
      searchForm: "app/pages/licitacoes/configuracaoperspectivas/parceiros/parceirosSearch.html",
      controller: "ParceiroCtrl",
      service: "ParceiroService"
    },
    {
      entityName: "Perspectiva",
      searchForm: "app/pages/licitacoes/perspectivas/perspectivasSearch.html",
      controller: "PerspectivaCtrl",
      service: "PerspectivaService"
    },
    {
      entityName: "CentroDeCusto",
      searchForm: "app/pages/financeiro/centro-custo/centrocustoSearch.html",
      controller: "CentroDeCustoCtrl",
      service: "CentroDeCustoService"
    },
    {
      entityName: "ContratoExterno",
      searchForm: "app/pages/contratos/contratosexternos/contratosexternosSearch.html",
      controller: "ContratoExternoCtrl",
      service: "ContratoExternoService"
    },
    {
      entityName: "ContratoInterno",
      searchForm: "app/pages/contratos/contratosinternos/contratosInternoSearch.html",
      controller: "ContratoInternoCtrl",
      service: "ContratoInternoService"
    },
    {
      entityName: "Medicao",
      searchForm: "app/pages/contratos/medicao/medicoesSearch.html",
      controller: "MedicaoCtrl",
      service: "MedicaoService"
    },
    {
      entityName: "ContaReceber",
      searchForm: "app/pages/financeiro/conta-receber/contareceberSearch.html",
      controller: "ContaReceberCtrl",
      service: "ContaReceberService"
    },
    {
      entityName: "Produto",
      searchForm: "app/pages/contratos/produtos/produtosSearch.html",
      controller: "ProdutoCtrl",
      service: "ProdutoService"
    },

    // Formulário Genérico Código e Descrição

    {
      entityName: "TipoPerspectiva",
      searchForm: null,
      controller: "TipoPerspectivaCtrl",
      service: "TipoPerspectivaService"
    },
    {
      entityName: "Area",
      searchForm: null,
      controller: "AreaCtrl",
      service: "AreaService"
    },
    {
      entityName: "RegiaoAtuacao",
      searchForm: null,
      controller: "RegiaoAtuacaoCtrl",
      service: "RegiaoAtuacaoService"
    },
    {
      entityName: "TipoServico",
      searchForm: null,
      controller: "TipoServicoCtrl",
      service: "TipoServicoService"
    },
    {
      entityName: "TipoLicitacao",
      searchForm: null,
      controller: "TipoLicitacaoCtrl",
      service: "TipoLicitacaoService"
    },
    {
      entityName: "LocalOrigemServico",
      searchForm: null,
      controller: "LocalOrigemServicoCtrl",
      service: "LocalOrigemServicoService"
    },
    {
      entityName: "TipoServicoDespesa",
      searchForm: null,
      controller: "TipoServicoDespesaCtrl",
      service: "TipoServicoDespesaService"
    },
    {
      entityName: "TipoInstituicaoOrigemServico",
      searchForm: null,
      controller: "TipoInstituicaoOrigemServicoCtrl",
      service: "TipoInstituicaoOrigemServicoService"
    },
    {
      entityName: "TipoCentroDeCusto",
      searchForm: null,
      controller: "TipoCentroDeCustoCtrl",
      service: "TipoCentroDeCustoService"
    },
    {
      entityName: "TipoDeContrato",
      searchForm: null,
      controller: "TipoDeContratoCtrl",
      service: "TipoDeContratoService"
    },
    {
      entityName: "FormaDePagamento",
      searchForm: null,
      controller: "FormaDePagamentoCtrl",
      service: "FormaDePagamentoService"
    },
    {
      entityName: "FonteDeRecurso",
      searchForm: null,
      controller: "FonteDeRecursoCtrl",
      service: "FonteDeRecursoService"
    },
    {
      entityName: "TipoItemServico",
      searchForm: null,
      controller: "TipoItemServicoCtrl",
      service: "TipoItemServicoService"
    },
    {
      entityName: "Pais",
      searchForm: null,
      controller: "PaisCtrl",
      service: "PaisService"
    },

    // Formulário de Documentos

    {
      entityName: "TipoDocumento",
      searchForm: null,
      controller: "TipoDocumentoCtrl",
      service: "TipoDocumentoService"
    },
    {
      entityName: "Documento",
      searchForm: null,
      controller: "DocumentoCtrl",
      service: "DocumentoService"
    },
    {
      entityName: "ContratoExternoDocumento",
      searchForm: null,
      controller: "ContratoExternoDocumentoCtrl",
      service: "ContratoExternoDocumentoService"
    },
    {
      entityName: "PerspectivaDocumento",
      searchForm: null,
      controller: "PerspectivaDocumentoCtrl",
      service: "PerspectivaDocumentoService"
    },
    {
      entityName: "DocumentoCat",
      searchForm: null,
      controller: "DocumentoCatCtrl",
      service: "DocumentoCatService"
    },

    //Pesquisa com a classe principal também

    {
      entityName: "HistoricoPerspectiva",
      searchForm: null,
      controller: "HistoricoPerspectivaCtrl",
      service: "HistoricoPerspectivaService"
    },

    {
      entityName: "SolicitacaoJuridicoPerspectiva",
      searchForm: null,
      controller: "SolicitacaoJuridicoPerspectivaCtrl",
      service: "SolicitacaoJuridicoPerspectivaService"
    },

    {
      entityName: "ProvimentoSolicitacao",
      searchForm: null,
      controller: "ProvimentoSolicitacaoCtrl",
      service: "ProvimentoSolicitacaoService"
    },

    {
      entityName: "RevisaoContrato",
      searchForm: null,
      controller: "RevisaoContratoCtrl",
      service: "RevisaoContratoService"
    },
    {
      entityName: "Prazo",
      searchForm: null,
      controller: "PrazoCtrl",
      service: "PrazoService"
    },
    {
      entityName: "IndiceDeReajuste",
      searchForm: null,
      controller: "IndiceDeReajusteCtrl",
      service: "IndiceDeReajusteService"
    },
    {
      entityName: "DataImportante",
      searchForm: null,
      controller: "DataImportanteCtrl",
      service: "DataImportanteService"
    },
    {
      entityName: "Reajuste",
      searchForm: null,
      controller: "ReajusteCtrl",
      service: "ReajusteService"
    },

    {
      entityName: "ComentarioContaReceber",
      searchForm: null,
      controller: "ComentarioContaReceberCtrl",
      service: "ComentarioContaReceberService"
    },

    {
      entityName: "AnaliseContratual",
      searchForm: null,
      controller: "AnaliseContratualCtrl",
      service: "AnaliseContratualService"
    },
    {
      entityName: "AnaliseOperacional",
      searchForm: null,
      controller: "AnaliseOperacionalCtrl",
      service: "AnaliseOperacionalService"
    },

    //Pessoa Fisica e Pessoa Juridica

    {
      entityName: "ParceiroResponsavel",
      searchForm: null,
      controller: "ParceiroResponsavelCtrl",
      service: "ParceiroResponsavelService"
    },
    {
      entityName: "Funcionario",
      searchForm: null,
      controller: "FuncionarioCtrl",
      service: "FuncionarioService"
    },
    {
      entityName: "PessoaFisica",
      searchForm: null,
      controller: "PessoaFisicaCtrl",
      service: "PessoaFisicaService"
    },

    {
      entityName: "Pessoa",
      searchForm: null,
      controller: "PessoaCtrl",
      service: "PessoaService"
    },

    {
      entityName: "PessoaJuridica",
      searchForm: null,
      controller: "PessoaJuridicaCtrl",
      service: "PessoaJuridicaService"
    },
    {
      entityName: "Consorcio",
      searchForm: null,
      controller: "ConsorcioCtrl",
      service: "ConsorcioService"
    },
    {
      entityName: "ConsorcioParceiro",
      searchForm: null,
      controller: "ConsorcioParceiroCtrl",
      service: "ConsorcioParceiroService"
    },
    {
      entityName: "Fornecedor",
      searchForm: null,
      controller: "FornecedorCtrl",
      service: "FornecedorService"
    },

    {
      entityName: "Departamento",
      searchForm: null,
      controller: "DepartamentoCtrl",
      service: "DepartamentoService"
    },

    //Baldiado

    {
      entityName: "RevisaoValoresPrevistos",
      searchForm: null,
      controller: "RevisaoValoresPrevistosCtrl",
      service: "RevisaoValoresPrevistosService"
    },
    {
      entityName: "ServidorDeEmail",
      searchForm: null,
      controller: "ServidorDeEmailCtrl",
      service: "ServidorDeEmailService"
    },
    {
      entityName: "Contato",
      searchForm: null,
      controller: "ContatoCtrl",
      service: "ContatoService"
    },
    {
      entityName: "ContaBancaria",
      searchForm: null,
      controller: "ContaBancariaCtrl",
      service: "ContaBancariaService"
    },
    {
      entityName: "Banco",
      searchForm: null,
      controller: "BancoCtrl",
      service: "BancoService"
    },
    {
      entityName: "Perfil",
      searchForm: null,
      controller: "PerfilCtrl",
      service: "PerfilService"
    },
    {
      entityName: "GrupoAreaSistema",
      searchForm: null,
      controller: "GrupoAreaSistemaCtrl",
      service: "GrupoAreaSistemaService"
    },
    {
      entityName: "AreaSistema",
      searchForm: null,
      controller: "AreaSistemaCtrl",
      service: "AreaSistemaService"
    },
    {
      entityName: "Papel",
      searchForm: null,
      controller: "PapelCtrl",
      service: "PapelService"
    },
    {
      entityName: "ItemDeServico",
      searchForm: null,
      controller: "ItemDeServicoCtrl",
      service: "ItemDeServicoService"
    },
    {
      entityName: "ItemContratado",
      searchForm: null,
      controller: "ItemContratadoCtrl",
      service: "ItemContratadoService"
    },
  ];

});
angular.module('bentham').factory('Consulta', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'consultas/:id', {
        id: '@id',
    }, {
            delete: {   
                method: 'DELETE',
                url: prefixRoute + 'consultas/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'consultas/',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'consultas/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
            getByUsuarioOrPerfil:{
                method: 'GET',
                isArray: true,
                url: prefixRoute +  "consultas/findBy-usuario-or-perfil"
            }
        });
});

angular.module('bentham').factory('ConsultaService', function (GenericService, Consulta) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Consulta();
    Object.setPrototypeOf(self.resource, Consulta);
    return function () { return self; };
});
angular.module('bentham').factory('Departamento', function($resource, prefixRoute){
    return $resource(prefixRoute  + 'departamentos/:id',{
      id: '@id',
    },{
      pageable: {
        method:'GET',
        url: prefixRoute  + 'departamentos/pageable',
      },
      delete: {
        method: 'DELETE'
      },
      save: {
        method:'POST'
      },
      update: {
        method:'PUT'
      },
      all: {
        method: 'GET',
        isArray: true
      }
    });
  });

  angular.module('bentham').factory('DepartamentoService', function (Departamento, GenericService,$q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Departamento();
    Object.setPrototypeOf(self.resource, Departamento);

    return function () { return self; };
});
angular.module('bentham.pages.configuracoes.departamento').controller('DepartamentoCtrl', function ($scope, DepartamentoService, Departamento, GenericController, $uibModal, AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new DepartamentoService();
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.departamento = new Departamento();
  
    self.clear = function clear() {
      $scope.departamento = new Departamento();
    };
  
    $scope.load = function load(tableState) {
      self.initTableState(tableState, "codigo");
      $scope.isLoading = true;
      self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
        .then(function (result) {
          $scope.displayed = result.content;
          self.updateTableState(result)
          $scope.isLoading = false;
        })
        .catch(function (error) { toastr.error(error.message); });
    };
  
    $scope.refresh = function () {
      $scope.load(self.tableState);
    };
  
    $scope.open = function (page, size, title, departamento) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          entity: function () {
            $scope.departamento = departamento;
            return departamento;
          },
          self: function () { return self; },
          title: function () { return title; }
        },
        scope: $scope,
        controller: 'ModalController'
      });
    };
  });
angular.module('bentham').factory('Enum', function($resource, prefixRoute){
    return $resource(prefixRoute  + 'enum',
      {},
      {
        all: {
          method:'GET',
          url: prefixRoute  + 'enum',
          isArray: true
        },
        getEnumPorTipoNome: {
          method:'GET',
          url: prefixRoute  + 'enum/value'
        }
      }
    );
  });
angular.module("bentham").factory('Pais', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'paises/:id', {
        id: '@id',
    },
        {
            all: {
                method: 'GET',
                url: prefixRoute + 'paises',
                isArray: true
            }
        }
    );
});

angular.module('bentham.pages.configuracoes.sourcefile').controller('SourceFileCtrl', function ($scope, $stateParams, SourceFileService, SourceFile, $uibModal, GenericController, AuthService) {

  var self = this;
  Object.setPrototypeOf(self, GenericController);

  self.service = new SourceFileService();

  $scope.authService = AuthService;
  $scope.itemsByPageOptions = self.itemsByPageOptions;
  $scope.itemsByPage = 25;

  self.clear = function clear() {
    $scope.source = new SourceFile();
  };

  self.activate = function () {
    if ($stateParams.sourceId) {
      self.find($stateParams.sourceId)
        .then(function (data) {
          $scope.source = data;
        })
    } else {
      self.clear();
    }
  }

  self.activate();

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "protocol");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          $scope.source = entity;
          return entity;
        },
        self: function () {
          return self;
        },
        title: function () {
          return title;
        }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };


  $scope.sync = function (source) {
    source.isSynchronized = false
    self.service.syncSource (source.id).then(function (data) {
      source = data;
    }).catch(function (error) {
      toastr.error(error.message);
    });



  }

});
angular.module('bentham').factory('SourceFile', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'sources-files/:id', {
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'sources-files/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'sources-files/',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'sources-files/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        },
        syncSource: {
            method: 'GET',
            url: prefixRoute + 'sources-files//sync-source',
        }
    });
});

angular.module('bentham').factory('SourceFileService', function (GenericService, SourceFile, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new SourceFile();
    Object.setPrototypeOf(self.resource, SourceFile);


    self.syncSource = function (id) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.syncSource({
                    id: id
                },
                function success(data) {
                    deferred.resolve(data);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () {
        return self;
    };
});
angular.module('bentham.pages.configuracoes.tipodocumento').controller('TipoDocumentoCtrl', function ($scope, $stateParams, TipoDocumentoService, TipoDocumento,$uibModal, GenericController, AuthService) {
 
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;
  self.service = new TipoDocumentoService();
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  self.clear = function clear() {
    $scope.tipoDocumento = new TipoDocumento();
    $scope.filtro = {};
  };

  self.activate = function () {
    if ($stateParams.tipoDocumentoId) {
      self.find($stateParams.tipoDocumentoId)
        .then(function (data) { $scope.tipoDocumento = data; })
    } else {
      self.clear();
    }
  }

  self.activate();

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);
    filtro.tipoAnexo != undefined && filtro.tipoAnexo != null ? filtro.tipoAnexo = filtro.tipoAnexo.name : null;
    filtro.predecessor != undefined && filtro.predecessor != null ? filtro.predecessor = filtro.predecessor.id : null;
    if ($scope.aberto == true)
        filtro.search = null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
};


  $scope.load = function load(tableState) {
    self.initTableState(tableState, "descricao");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) { toastr.error(error.message); });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          $scope.tipoDocumento = entity;
          return entity;
        },
        self: function () { return self; },
        title: function () { return title; }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

});

angular.module('bentham').factory('TipoDocumento', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'tipos-documento/:id', {
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'tipos-documento/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'tipos-documento',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'tipos-documento/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        },
        getAllByTipoAnexo: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'tipos-documento/getAll-byTipoAnexo',
        },        
        getByTipoAnexo: {
            method: 'GET',
            url: prefixRoute + 'tipos-documento/getby-tipoAnexo',
        },
        findOne: {
            method: 'GET',
        }
    });
});

angular.module('bentham').factory('TipoDocumentoService', function (GenericService, TipoDocumento, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new TipoDocumento();
    Object.setPrototypeOf(self.resource, TipoDocumento);


    self.getAllByTipoAnexo = function (tipoAnexo) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getAllByTipoAnexo({
                    tipoAnexo: tipoAnexo
                },
                function success(tipoDocumentos) {
                    deferred.resolve(tipoDocumentos);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getByTipoAnexo = function (tipoAnexo) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getByTipoAnexo({
                    tipoAnexo: tipoAnexo
                },
                function success(tipoDocumento) {
                    deferred.resolve(tipoDocumento);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }


    self.findOne = function (id) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.findOne({
                    id: id
                },
                function success(tipoDocumento) {
                    deferred.resolve(tipoDocumento);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () {
        return self;
    };
});
angular.module('bentham').factory('TipoServicoDespesa', function($resource, prefixRoute){
    return $resource(prefixRoute  + 'tipos-servico-despesa/:id',{
      id: '@id',
    },{
      delete: {
        method: 'DELETE',
        url: prefixRoute  + 'tipos-servico-despesa/:id'
      },
      save: {
        method:'POST'
      },
      all: {
        method: 'GET',
        isArray: true,
        url: prefixRoute  + 'tipos-servico-despesa'
      }
    });
  });
angular.module('bentham.pages.configuracoes.tipocontrato').controller('TipoContratoCtrl', function ($scope, TipoContratoService, TipoContrato, GenericController, $uibModal,AuthService) {
  
  var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new TipoContratoService();
    $scope.authService = AuthService;
  
    $scope.itemsByPage = 5;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
  
    self.clear = function clear() {
      $scope.tipocontrato = new TipoContrato();
    };
  
    $scope.load = function load(tableState) {
      self.initTableState(tableState, "codigo");
      $scope.isLoading = true;
      self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
        .then(function (result) {
          $scope.displayed = result.content;
          self.updateTableState(result)
          $scope.isLoading = false;
        })
        .catch(function (error) { toastr.error(error.message); });
    };
  
    $scope.refresh = function () {
      $scope.load(self.tableState);
    };
  
    $scope.open = function (page, size, title, tipocontrato) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          entity: function () {
            $scope.tipocontrato = tipocontrato;
            return tipocontrato;
          },
          self: function () { return self; },
          title: function () { return title; }
        },
        scope: $scope,
        controller: 'ModalController'
      });
    };
  });
angular.module('bentham').factory('TipoContrato', function($resource, prefixRoute){
    return $resource(prefixRoute  + 'tipo-de-contrato/:id',{
      id: '@id',
    },{
      pageable: {
        method:'GET',
        url: prefixRoute  + 'tipo-de-contrato/pageable',
      },
      delete: {
        method: 'DELETE'
      },
      save: {
        method:'POST'
      },
      update: {
        method:'PUT'
      },
      all: {
        method: 'GET',
        isArray: true
      }
    });
  });

  angular.module('bentham').factory('TipoContratoService', function (TipoContrato, GenericService) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new TipoContrato();
    Object.setPrototypeOf(self.resource, TipoContrato);
    return function () { return self; };
});
angular.module('bentham.pages.contratos.consorcios').controller('ConsorcioCtrl', function ($scope, PessoaJuridicaService, ConsorcioService, Consorcio, GenericController, $state, $stateParams, $uibModal, AuthService, $window) {
  var self = this;
  $scope.authService = AuthService;
  Object.setPrototypeOf(self, GenericController);
  self.service = new ConsorcioService();
  self.pessoaJuridicaService = new PessoaJuridicaService();

  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  self.clear = function clear() {
    $scope.consorcio = new Consorcio();
    $scope.filtro = {};
  };

  $scope.clear = function () {
    self.clear();
  };

  self.activate = function () {
    $scope.isLoading = true;
    if ($stateParams.consorcioId) {
      self.find($stateParams.consorcioId)
        .then(function (data) {
          $scope.consorcio = data;
          $scope.isLoading = false;
        });
    } else {
      self.clear();
      $scope.isLoading = false;
    }
  }

  self.activate();

  $scope.clear = function () {
    $state.go("contratos.consorcios")
  };

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);
    filtro.cnpj != null ? filtro.cnpj = filtro.cnpj.toString().padStart(14, '0') : null;
    if($scope.aberto == true )
      filtro.search =  null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
  };

  $scope.save = function () {
    $scope.isLoading = true;
    self.save($scope.consorcio)
      .then(function success(data) {
        $scope.consorcio = data;
        $state.go("contratos.formconsorcio", {consorcioId: data.id})
        $scope.isLoading = false;
      }).catch(function (error) {
        toastr.error(error.message);
        $scope.isLoading = false;
      });
  }

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "pessoaJuridica.pessoa.nome");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  };

  $scope.open = function (page, size, title, consorcio) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          $scope.consorcio = consorcio;
          return consorcio;
        },
        self: function () {
          return self;
        },
        title: function () {
          return title;
        }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

  $scope.onCnpjBlur = function (cnpj) {
    self.pessoaJuridicaService.byCnpj(cnpj).then(function (data) {
      if (data.id != null && data.id != undefined)
      delete data.pessoa.handler;
      delete data.pessoa.hibernateLazyInitializer;
      $scope.consorcio.pessoaJuridica = data;
    });
  };

});
angular.module('bentham').factory('Consorcio', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'consorcios/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'consorcios/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'consorcios',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'consorcios/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }
            },
        });
});

angular.module('bentham').factory('ConsorcioService', function (GenericService, Consorcio, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Consorcio();
    Object.setPrototypeOf(self.resource, Consorcio);
    
    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        data.pessoaJuridica.cnpj.padStart(14, '0');
        deferred.resolve(data);
        return deferred.promise;
    };
    
    return function () { return self; };
});
angular.module('bentham.pages.contratos.contratosexternos').controller('ContratoExternoCtrl', function ($scope, $q, ContratoExternoService, ContratoExterno, PerspectivaService, Perspectiva, GenericController, $state, $stateParams, $uibModal, CentroDeCusto, toastr, DocumentoService, CentroDeCustoService, AuthService, prefixRoute, $window, ContratoExternoViewService) {
    var self = this;
    $scope.prefixRoute = prefixRoute;
    Object.setPrototypeOf(self, GenericController);
    $scope.authService = AuthService;
    self.service = new ContratoExternoService();
    self.serviceView = new ContratoExternoViewService();
    self.perspectivaService = new PerspectivaService();
    self.documentoService = new DocumentoService();

    self.perspectivaTableState = {};
    $scope.itemsByPage = 25;

    $scope.itemsByPagePerspectiva = 5;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.centrosDeCusto = CentroDeCusto.all();

    self.confirm = function (entity) {
        var deferred = $q.defer();
        entity.contratoGerado = true;
        self.perspectivaService.save(entity)
            .then(function success(data) {  $scope.refresh(); $scope.cancel() })
            .catch(function (error) { toastr.error(error.message); });
        return deferred.promise;
    };

    $scope.gerarContrato = function (perspectiva) {
        self.service.gerarContrato(perspectiva)
            .then(function (data) {  $scope.contrato = data; $state.go("contratos.formcontratosexternos", { contratoId: $scope.contrato.id }) })
            .catch(function (error) { toastr.error(error.message); });
    };

    self.clear = function clear() {
        $scope.contrato = new ContratoExterno();
        $scope.perspectiva = new Perspectiva();
        $scope.centroDeCusto = new CentroDeCusto();
        $scope.contrato.arts = [];
        $scope.contrato.atestados = [];
        $scope.contrato.cats = [];
        $scope.contrato.fichas = [];
        $scope.contrato.orcamentosPrevistos = [];
        $scope.filtro = {};
    };

    $scope.clear = function () {
        self.clear();
    };

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        filtro.centroDeCusto != null ? filtro.centroDeCusto = filtro.centroDeCusto.id: null;
        filtro.responsavel != null ? filtro.responsavel = filtro.responsavel.pessoaFisica.id : null;
        filtro.pais != null ? filtro.pais = filtro.pais.id : null;
        filtro.regiao != null ? filtro.regiao = filtro.regiao.name : null;
        filtro.regiaoAtuacao != null ? filtro.regiaoAtuacao = filtro.regiaoAtuacao.id : null;
        filtro.tipoServico != null ? filtro.tipoServico = filtro.tipoServico.id : null;
        filtro.area != null ? filtro.area = filtro.area.id : null;
        filtro.subArea != null ? filtro.subArea = filtro.subArea.id : null;
        filtro.cliente != null ? filtro.cliente = filtro.cliente.id : null;
        filtro.consorcio != null ? filtro.consorcio = filtro.consorcio.id : null;
        filtro.statusContrato != null ? filtro.statusContrato = filtro.statusContrato.name : null;
        if (filtro.dataInicio != null)
            filtro.dataInicio = moment(filtro.dataInicio, "YYYY-MM-DD").format("YYYY-MM-DD");
        if (filtro.dataTermino != null)
            filtro.dataTermino = moment(filtro.dataTermino, "YYYY-MM-DD").format("YYYY-MM-DD");
        if($scope.aberto == true )
           filtro.search = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };

    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.contratoId) {
            self.find($stateParams.contratoId)
                .then(function (data) {  $scope.contrato = data; $scope.isLoading = false; });
        } else {
            self.clear();
            $scope.isLoading = false;
        }

        // if ($stateParams.perspectivaId) {
        //     $scope.isLoading = true;
        //     self.perspectivaService.find($stateParams.perspectivaId)
        //         .then(function (data) { $scope.perspectiva = data; $scope.isLoading = false; });
        // } else {
        //     self.clear();
        //     $scope.isLoading = false;
        // }
    };

    self.activate();

    $scope.activate = function () {
        self.activate();
    };

    $scope.cancel = function () {
        $state.go("contratos.contratosexternos")
    };

    $scope.save = function () {
        $scope.isLoading = true;
        self.save($scope.contrato)
            .then(function success(data) { self.clear(); self.activate(); $state.go("contratos.formcontratosexternos", { contratoId: data.id }); $scope.isLoading = false; })
            .catch(function (error) { $scope.isLoading = false; });
    };

    formatarStatus = function (contrato) {
        if (contrato.statusContrato != null) {
            var name = contrato.statusContrato.name;
            if (name == 'ATIVO')
                contrato.isAtivo = true;
            else if (name == 'POSSIVEL_DE_ENCERRAMENTO')
                contrato.isPossivelEncerramento = true;
            else if (name == 'ENCERRADO')
                contrato.isEncerrado = true;
            else if (name == 'SEM_SALDO_A_MEDIR')
                contrato.isSemSaldoAMedir = true;
        }
    };

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "dataFimExecucao","DESC");
        $scope.isLoading = true;
        self.serviceView.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                $scope.displayed.forEach(function (contrato) { formatarStatus(contrato); });
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
        $scope.loadPerspectiva(self.perspectivaTableState);
    };

    $scope.loadPerspectiva = function load(tableState) {
        if (tableState.pagination == undefined || null)
            tableState.pagination = { number: 10, start: 0 };
        if (tableState.sort == undefined || null)
            tableState.sort = { predicate: "codigo", sortOrder: "ASC" };
        if (tableState.search == undefined || null) 
            tableState.search = {};

        tableState.page = tableState.pagination.start / tableState.pagination.number;
        tableState.sort.predicate = tableState.sort.predicate ? tableState.sort.predicate : 'id';
        tableState.sort.sortOrder = tableState.sort.reverse ? 'DESC' : 'ASC';
        $scope.contratosAGerarLoading = true;
        self.perspectivaService.getContratosAssinados(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                tableState.pagination.start = result.number * result.size; //set the number of pages so the pagination can update
                tableState.pagination.number = result.size; //set the number of pages so the pagination can update
                tableState.pagination.numberOfPages = result.totalPages; //set the number of pages so the pagination can update
                $scope.displayedPerspectiva = result.content;
                $scope.contratosAGerarLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
        $scope.loadPerspectiva(self.perspectivaTableState);
    };

    $scope.open = function (page, size, title, contrato) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {  $scope.contrato = contrato; return contrato; },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    /** Método para as funcionalidade de gerar um novo contrato de um perspectiva e marca a perspetiva como contrato gerado */
    $scope.openPerspectiva = function (page, size, title, perspectiva) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.perspectiva = perspectiva;
                    var contrato = new ContratoExterno();
                    contrato.numeroEdital = perspectiva.numeroEdital;
                    contrato.cliente = perspectiva.cliente;
                    contrato.pais = perspectiva.pais;
                    contrato.regiao = perspectiva.regiao;
                    contrato.estado = perspectiva.estado;
                    contrato.cidade = perspectiva.cidade;
                    contrato.escopoContratual = perspectiva.descricao;
                    contrato.descricaoNarrativa = perspectiva.descricao;
                    contrato.tipoServicos = perspectiva.tipoServicos;
                    contrato.area = perspectiva.area;
                    contrato.subAreas = perspectiva.subAreas;
                    contrato.valorTotalReal = perspectiva.valorTotal;
                    contrato.percentualEmpresa = perspectiva.percentualEmpresa;
                    contrato.valorEmpresaReal = perspectiva.valor;
                    contrato.perspectiva = perspectiva;
                    contrato.prazo = perspectiva.prazo;
                    contrato.vigencia = perspectiva.vigencia;
                    contrato.tipoPrazo = perspectiva.tipoPrazo;
                    $scope.contrato = contrato;
                    return perspectiva;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    checkDatas = function () {
        return ($scope.contrato.folder && $scope.contrato.regiao.name != null) ? true : false;
    }

    /** File Upload Section */

    $scope.download = function (arquivo) {
        self.documentoService.catchFile(arquivo).then(function success(data) {
            downloadFile(new Blob([data.response]), arquivo.name, data.response.type);
        }).catch(function (error) {
            toastr.error(error.message);
        });
    };

    $scope.onFileSelectContrato = function ($files) {
        if (checkDatas() == true)
            self.documentoService.upload($files, "CONTRATO_ASSINADO", $scope.contrato.regiao.descricao + "/" + $scope.contrato.folder)
            .then(function success(data) { $scope.contrato.arquivoContrato = data; toastr.success("Upload feito com sucesso!"); })
            .catch(function (error) { toastr.error(error.message); });
        else
            toastr.warning("Preecha o campo Pasta dos Anexos e Região!!");

    };

    $scope.onFileSelectEdital = function ($files) {
        if (checkDatas() == true)
            self.documentoService.upload($files, "EDITAL", $scope.contrato.regiao.descricao + "/" + $scope.contrato.folder)
            .then(function success(data) {
                $scope.contrato.arquivoEdital = data;
                toastr.success("Upload feito com sucesso!");
            })
            .catch(function (error) { toastr.error(error.message); });
        else
            toastr.warning("Preecha o campo Pasta dos Anexos e Região!!");
    };

    $scope.onFileSelectOrdemServico = function ($files) {
        if (checkDatas() == true)
            self.documentoService.upload($files, "ORDEM_DE_SERVICO", $scope.contrato.regiao.descricao + "/" + $scope.contrato.folder)
            .then(function success(data) {
                $scope.contrato.arquivoOrdemServico = data;
                toastr.success("Upload feito com sucesso!");
            })
            .catch(function (error) { toastr.error(error.message); });
        else
            toastr.warning("Preecha o campo Pasta dos Anexos e Região!!");

    };

    $scope.onFileSelectOrcamentoPrevisto = function ($files) {
        if (checkDatas() == true)
            self.documentoService.upload($files, "ORCAMENTO_PREVISTO", $scope.contrato.regiao.descricao + "/" + $scope.contrato.folder)
            .then(function success(data) {
                $scope.contrato.orcamentoPrevisto = data;
                toastr.success("Upload feito com sucesso!");
            })
            .catch(function (error) {  toastr.error(error.message); });
        else
            toastr.warning("Preecha o campo Pasta dos Anexos e Região!!");
    };

    /** Blur Interaction Form Section */

    $scope.onDataPropostraFinanceiraBlur = function (dataProposta) {
        if (dataProposta != undefined) {
            var data = moment(dataProposta, "YYYY-MM-DD HH:mm:ss");
            $scope.contrato.pedidoReajuste = data.add(1, 'years').format();
        }
    };

    $scope.$watch('contrato.dataFimExecucao', function () {
        if ($scope.contrato.dataFimExecucao != undefined) {
            var data = moment($scope.contrato.dataFimExecucao, "YYYY-MM-DD HH:mm:ss");
            $scope.contrato.pedidoAditivoPrazo = data.subtract(60, 'days').format();
        }
    });

    $scope.onPrazoBlur = function () {
        if ($scope.contrato.tipoPrazo != undefined && $scope.contrato.dataInicioExecucao != undefined) {
            var data = moment($scope.contrato.dataInicioExecucao, "YYYY-MM-DD HH:mm:ss");
            if ($scope.contrato.tipoPrazo.descricao === "DIA")
                $scope.contrato.dataFimExecucao = data.add($scope.contrato.prazo, 'days').format();
            else if ($scope.contrato.tipoPrazo.descricao === "MÊS")
                $scope.contrato.dataFimExecucao = data.add($scope.contrato.prazo, 'months').format();
            else
                $scope.contrato.dataFimExecucao = data.add($scope.contrato.prazo, 'years').format();
        }
        if ($scope.contrato.tipoPrazo != undefined && $scope.contrato.dataInicioVigencia != undefined) {
            var data = moment($scope.contrato.dataInicioVigencia, "YYYY-MM-DD HH:mm:ss");
            if ($scope.contrato.tipoPrazo.descricao === "DIA")
                $scope.contrato.dataFimVigencia = data.add($scope.contrato.vigencia, 'days').format();
            else if ($scope.contrato.tipoPrazo.descricao === "MÊS")
                $scope.contrato.dataFimVigencia = data.add($scope.contrato.vigencia, 'months').format();
            else
                $scope.contrato.dataFimVigencia = data.add($scope.contrato.vigencia, 'years').format();
        }
    };
    
    $scope.onValorTotalBlur = function (valor, percentualEmpresa, valorCotacao) {
        $scope.contrato.valorEmpresaReal = valor * (percentualEmpresa / 100);
        $scope.contrato.valorTotalDolar = valor / valorCotacao;
        $scope.contrato.valorEmpresaDolar = $scope.contrato.valorTotalDolar * (percentualEmpresa / 100);
    };

    $scope.onPercentualEmpresaBlur = function (valor, percentualEmpresa) {
        $scope.contrato.valorEmpresaReal = valor * (percentualEmpresa / 100);
        $scope.contrato.valorEmpresaDolar = $scope.contrato.valorTotalDolar * (percentualEmpresa / 100);
    };

    $scope.onValorCotacaoBlur = function (valor, percentualEmpresa, valorCotacao) {
        $scope.contrato.valorTotalDolar = valor / valorCotacao;
        $scope.contrato.valorEmpresaDolar = $scope.contrato.valorTotalDolar * (percentualEmpresa / 100);
    };

});
angular.module('bentham').factory('ContratoExterno', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'contratos-externos/:id', { id: '@id', }, {
        findByCentroDeCustoId: {
            method: 'GET',
            url: prefixRoute + 'contratos-externos/findByCentroDeCustoId',
        },
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'contratos-externos/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'contratos-externos',
        },
        deleteArquivo: {
            method: 'POST',
            url: prefixRoute + 'contratos-externos/arquivo/delete'
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'contratos-externos/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        },
        gerarContrato: {
            method: 'POST',
            url: prefixRoute + 'contratos-externos/gerar-contrato',
        },
    });
});

angular.module('bentham').factory('ContratoExternoService', function (GenericService, ContratoExterno, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ContratoExterno();
    Object.setPrototypeOf(self.resource, ContratoExterno);

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        data.arts = [];

        if(data.indiceDeReajuste) delete data.indiceDeReajuste;
        if(data.centroCusto) delete data.centroCusto.responsavel;
        if(data.perspectiva) delete data.perspectiva.autor;
        data.prazo = parseInt(data.prazo);
        data.vigencia = parseInt(data.vigencia);

        if (!entity.dataAssinaturaContrato)
            deferred.reject(new Error("Data da Assinatura do Contrato não foi preenchida corretamente!"));
        else if (!entity.dataInicioExecucao)
            deferred.reject(new Error("Data do Inicio de Execução não foi preenchida corretamente!"));
        else if (!entity.dataFimExecucao)
            deferred.reject(new Error("Data do Fim de Execução não foi preenchida corretamente!"));
        else if (!entity.dataInicioVigencia)
            deferred.reject(new Error("Data do Inicio de Vigência não foi preenchida corretamente!"));
        else if (!entity.dataFimVigencia)
            deferred.reject(new Error("Data do Fim de Vigência não foi preenchida corretamente!"));
        else if (!entity.tipoServicos||entity.tipoServicos.length === 0)
            deferred.reject(new Error("Tipo de Serviço não foi preenchida corretamente!"));
        else
            deferred.resolve(data);
        return deferred.promise;
    };

    self.gerarContrato = function (persperctiva) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.gerarContrato({ id: persperctiva.id }, persperctiva,
                function success(contrato) { deferred.resolve(contrato); },
                function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.deletarArquivo = function (arquivo) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.deleteArquivo('', arquivo,
                function success(arquivo) { deferred.resolve(arquivo); },
                function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () { return self; };
});
angular.module('bentham').factory('ContratoExternoView', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'contratos-externos-view/:id', {
        id: '@id',
    }, {
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'contratos-externos-view/',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'contratos-externos-view/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        }
    });
});

angular.module('bentham').factory('ContratoExternoViewService', function (GenericService, ContratoExternoView, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ContratoExternoView();
    Object.setPrototypeOf(self.resource, ContratoExternoView);
    return function () {
        return self;
    };
});
angular.module('bentham.pages.contratos.contratosinternos').controller('ContratoInternoCtrl', function ($scope, ContratoInternoService, ContratoInterno, CentroDeCusto, GenericController, $state, $stateParams, $uibModal, toastr, AuthService, prefixRoute, $window) {
    var self = this;
    $scope.prefixRoute = prefixRoute;
    Object.setPrototypeOf(self, GenericController);
    self.service = new ContratoInternoService();
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.contrato = new ContratoInterno();
        $scope.centroCusto = new CentroDeCusto();
        $scope.filtro = {};
    };


    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        ($scope.filtro.contratada != null) ? filtro.contratada = $scope.filtro.contratada: null;
        ($scope.filtro.cliente != null) ? filtro.cliente = $scope.filtro.cliente.id: null;
        ($scope.filtro.tipoDeContrato != null) ? filtro.tipoDeContrato = $scope.filtro.tipoDeContrato.name: null;
        if ($scope.aberto == true)
            filtro.search = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };

    $scope.clear = function () {
        self.clear();
    };

    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.contratoId) {
            self.find($stateParams.contratoId)
                .then(function (data) { $scope.contrato = data; $scope.isLoading = false; });
        } else {
            self.clear();
            $scope.isLoading = false;
        }
    }

    self.activate();

    $scope.clear = function () {
        $state.go("contratos.contratosinternos")
    };

    $scope.save = function () {
        $scope.isLoading = true;
        self.save($scope.contrato)
            .then(function success(data) {
                self.activate();
                $state.go("contratos.formcontratointerno", { contratoId: data.id });
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); $scope.isLoading = false; });
    }

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "contratada");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, contrato) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () { $scope.contrato = contrato; return contrato;},
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    /** Blur Interaction Form Section */

    $scope.onDataPropostraFinanceiraBlur = function (dataProposta) {
        if (dataProposta != undefined) {
            var data = moment(dataProposta, "YYYY-MM-DD");
            $scope.contrato.pedidoReajuste = data.add(1, 'years').format();
        }
    };
    
    $scope.onPrazoBlur = function () {
        if ($scope.contrato.tipoPrazo != undefined && $scope.contrato.dataInicioExecucao != undefined) {
            var data = moment($scope.contrato.dataInicioExecucao, "YYYY-MM-DD HH:mm:ss");
            if ($scope.contrato.tipoPrazo.descricao === "DIA")
                $scope.contrato.dataFimExecucao = data.add($scope.contrato.prazo, 'days').format();
            else if ($scope.contrato.tipoPrazo.descricao === "MÊS")
                $scope.contrato.dataFimExecucao = data.add($scope.contrato.prazo, 'months').format();
            else
                $scope.contrato.dataFimExecucao = data.add($scope.contrato.prazo, 'years').format();
        }
        if ($scope.contrato.tipoPrazo != undefined && $scope.contrato.dataInicioVigencia != undefined) {
            var data = moment($scope.contrato.dataInicioVigencia, "YYYY-MM-DD HH:mm:ss");
            if ($scope.contrato.tipoPrazo.descricao === "DIA")
                $scope.contrato.dataFimVigencia = data.add($scope.contrato.vigencia, 'days').format();
            else if ($scope.contrato.tipoPrazo.descricao === "MÊS")
                $scope.contrato.dataFimVigencia = data.add($scope.contrato.vigencia, 'months').format();
            else
                $scope.contrato.dataFimVigencia = data.add($scope.contrato.vigencia, 'years').format();
        }
    };
    
    $scope.onValorTotalBlur = function (valor, percentualEmpresa, valorCotacao) {
        $scope.contrato.valorEmpresaReal = valor * (percentualEmpresa / 100);
        $scope.contrato.valorTotalDolar = valor / valorCotacao;
        $scope.contrato.valorEmpresaDolar = $scope.contrato.valorTotalDolar * (percentualEmpresa / 100);
    };

    $scope.onPercentualEmpresaBlur = function (valor, percentualEmpresa) {
        $scope.contrato.valorEmpresaReal = valor * (percentualEmpresa / 100);
        $scope.contrato.valorEmpresaDolar = $scope.contrato.valorTotalDolar * (percentualEmpresa / 100);
    };

    $scope.gerarRelatorio = function (contrato) {
        ContratoInterno.gerarRelatorioContratoInterno(contrato, function (data) {
            window.open(URL.createObjectURL(data.response));
        });
    };
     
    $scope.autoFillFieldsByContract = function (externalContract) {
        if ($scope.contrato.id) return;

        $scope.contrato.centroCusto = externalContract.centroCusto;
        $scope.contrato.pais = externalContract.pais;
        $scope.contrato.regiao = externalContract.regiao;
        $scope.contrato.estado = externalContract.estado;
        $scope.contrato.cidade = externalContract.cidade;
        $scope.contrato.cliente = externalContract.cliente;
    };
     
});
angular.module('bentham').factory('ContratoInterno', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'contratos-internos/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'contratos-internos/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'contratos-internos',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'contratos-internos/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            }
        });
});

angular.module('bentham').factory('ContratoInternoService', function (GenericService, ContratoInterno, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ContratoInterno();
    Object.setPrototypeOf(self.resource, ContratoInterno);

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        if(data.pedidoReajuste) data.pedidoReajuste = moment(data.pedidoReajuste).format('YYYY-MM-DD');
        if(data.indiceDeReajuste) delete data.indiceDeReajuste;
        if(data.centroCusto) delete data.centroCusto.responsavel;
        if(data.cliente) delete data.cliente.pessoaJuridica;

        if (!entity.dataAssinaturaContrato)
            deferred.reject(new Error("Data da Assinatura do Contrato não foi preenchido corretamente!"));
        else
            deferred.resolve(data);
        return deferred.promise;
    };

    return function () { return self; };
});
angular.module('bentham.pages.contratos.documento-cat').controller('DocumentoCatCtrl',
    function ($scope, DocumentoCatService, DocumentoCat, GenericController, $state, $stateParams, $uibModal, toastr, AuthService, prefixRoute, $sce, DocumentoService, $window) {
        var self = this;
        Object.setPrototypeOf(self, GenericController);
        $scope.authService = AuthService;

        self.service = new DocumentoCatService();
        self.documentoService = new DocumentoService();


        $scope.itemsByPage = 25;
        $scope.itemsByPageOptions = self.itemsByPageOptions;

        self.clear = function clear() {
            $scope.cat = new DocumentoCat();
            $scope.cat.tipo = "CAT";
            $scope.filtro = {};
        };

        $scope.clean = function () {
            self.clear();
        }

        $scope.clear = function () {
            self.clear();
        }

        $scope.search = function () {
            var filtro = angular.copy($scope.filtro);
            filtro.cliente != null ? filtro.cliente = filtro.cliente.id : null;
            filtro.contratada != null ? filtro.contratada = filtro.contratada.id : null;
            filtro.tipoServico != null ? filtro.tipoServico = filtro.tipoServico.id : null;
            filtro.area != null ? filtro.area = filtro.area.id : null;
            filtro.subArea != null ? filtro.subArea = filtro.subArea.id : null;
            filtro.pais != null ? filtro.pais = filtro.pais.id : null;
            filtro.contratoExterno != null ? filtro.contratoExterno = filtro.contratoExterno.id : null;
            filtro.profissional != null ? filtro.profissional = filtro.profissional.id : null;
            filtro.tipoDocumento != null ? filtro.tipoDocumento = filtro.tipoDocumento.id : null;

            if (filtro.inicio != null)
                filtro.inicio = moment(filtro.inicio, "YYYY-MM-DD").format("YYYY-MM-DD");
            if (filtro.fim != null)
                filtro.fim = moment(filtro.fim, "YYYY-MM-DD").format("YYYY-MM-DD");

            if ($scope.aberto == true)
                filtro.search = null;
            self.tableState.search = filtro;
            $scope.load(self.tableState);
        };

        self.activate = function () {
            $scope.isLoading = true;
            if ($stateParams.documentoId) {
                self.find($stateParams.documentoId)
                    .then(function (data) {
                        $scope.cat = data;
                        if ($scope.cat.documento != null && $scope.cat.documento.id != null) {
                            $scope.picture = prefixRoute + "arquivos/catchPdfFile/" + $scope.cat.documento.id;
                            $scope.cat.tipo = $scope.cat.documento.tipoDocumento.tipoAnexo.name;
                        }
                        $scope.isLoading = false;
                    });
            } else {
                self.clear();
                $scope.isLoading = false;

            }
        };

        self.activate();


        $scope.clear = function () {
            $state.go("contratos.documento-cat");
        };

        $scope.save = function () {
            $scope.isLoading = true;
            self.save($scope.cat)
                .then(function success(data) {
                    self.clear();
                    self.activate();
                    $state.go("contratos.documento-cat");
                    $scope.isLoading = false;
                }).catch(function (error) {
                    toastr.error(error.message);
                    $scope.isLoading = false;
                });
        };

        $scope.load = function load(tableState) {
            self.initTableState(tableState, "profissional.pessoa.nome");
            $scope.isLoading = true;
            if ($stateParams.contratoId != null)
                tableState.search.contratoExternoId = $stateParams.contratoId;
            self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
                .then(function (result) {
                    $scope.displayed = result.content;
                    self.updateTableState(result)
                    $scope.isLoading = false;
                })
                .catch(function (error) {
                    toastr.error(error.message);
                });
        };

        $scope.refresh = function () {
            $scope.load(self.tableState);
        };

        $scope.open = function (page, size, title, cat) {
            $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                resolve: {
                    entity: function () {
                        $scope.cat = cat;
                        return cat;
                    },
                    self: function () {
                        return self;
                    },
                    title: function () {
                        return title;
                    }
                },
                scope: $scope,
                controller: 'ModalController'
            });
        };


        $scope.onFileSelect = function ($files) {
            if ($scope.cat.contratoExterno && $scope.cat.profissional && $scope.cat.tipo)
                self.documentoService.upload($files, $scope.cat.tipo, $scope.cat.profissional.pessoaFisica.pessoa.nome)
                .then(function success(data) {
                    $scope.cat.documento = data;
                    $scope.picture = prefixRoute + "arquivos/catchPdfFile/" + $scope.cat.documento.id;
                    toastr.success("Upload feito com sucesso!");
                })
                .catch(function (error) {
                    toastr.error(error.message);
                });
            else
                toastr.warning("Preencha todos os campos antes do upload!!");


        };

        $scope.download = function (arquivo) {
            self.documentoService.catchFile(arquivo).then(function success(data) {
                downloadFile(new Blob([data.response]), arquivo.name, data.response.type);
            }).catch(function (error) {
                toastr.error(error.message);
            });
        };

        $scope.trustSrc = function (src) {
            return $sce.trustAsResourceUrl(src);
        }


    });
angular.module('bentham').factory('DocumentoCat', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'documentos-cat/:id', { id: '@id', }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'documentos-cat/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'documentos-cat',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'documentos-cat/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        }
    });
});

angular.module('bentham').factory('DocumentoCatService', function (GenericService, DocumentoCat) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new DocumentoCat();
    Object.setPrototypeOf(self.resource, DocumentoCat);
   

    self.converte = function (data) {
        if (data.inicio != null)
            data.inicio = self.converteData(data.inicio);
        if (data.fim != null)
            data.fim = self.converteData(data.fim);
        return data;
    };

    return function () { return self; };
});
angular.module('bentham.pages.contratos.contratosexternos').controller('IndiceDeReajusteCtrl', function ($scope, IndiceDeReajusteService, IndiceDeReajuste, GenericController, $state, $stateParams, $uibModal, toastr) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new IndiceDeReajusteService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.isLoading = true;

    self.clear = function clear() {
        $scope.indice = new IndiceDeReajuste();
        $scope.indice.contratoExterno = $scope.contrato;
    };

    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.contratoId) {
            self.find($stateParams.contratoId)
                .then(function (data) {
                    $scope.indice = data;
                    $scope.indice.contratoExterno = (data.contratoExterno != null ) ? data.contratoExterno : $scope.contrato;
                    $scope.isLoading = false;
                });
        } else {
            self.clear();
            $scope.isLoading = false;
        }
    }

    self.activate();
   
    $scope.load = function load(tableState) {
        self.initTableState(tableState, "id");
        $scope.isLoading = true;
        if ($stateParams.contratoId)
            tableState.search.contratoExternoId = $stateParams.contratoId;  
        tableState.sort.predicate = "id";      
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, indice) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.indice = indice;
                    return indice;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };
 });

angular.module('bentham').factory('IndiceDeReajuste', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'indices-de-reajuste/:id', {
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'indices-de-reajuste/:id',
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'indices-de-reajuste',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'indices-de-reajuste/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        }
    });
});

angular.module('bentham').factory('IndiceDeReajusteService', function (IndiceDeReajuste, GenericService, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new IndiceDeReajuste();
    Object.setPrototypeOf(self.resource, IndiceDeReajuste);

    self.valida = function (data) {
        var deferred = $q.defer();
        delete data.contratoExterno.reajuste;
        delete data.contratoExterno.indiceDeReajuste;
        delete data.contratoExterno.centroCusto;
        delete data.contratoExterno.perspectiva;
        deferred.resolve(data);
        return deferred.promise
    };

    self.findAllByContratoExterno = function (externalContract) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.all({ contratoExternoId: externalContract.id },
                function success(data) { deferred.resolve(data); },
                function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () { return self; };
});
angular.module('bentham.pages.economico.medicoes').controller('MedicaoCtrl', function ($scope, $rootScope, $q, ContratoExternoService, CentroDeCustoService, MedicaoService, Medicao, ProdutoService, GenericController, $state, $stateParams, $uibModal, toastr, AuthService, MedicaoViewService, ArquivoService, IndiceDeReajusteService, $window) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    $scope.authService = AuthService;

    self.service = new MedicaoService();
    self.serviceView = new MedicaoViewService();
    self.produtoService = new ProdutoService();
    self.indiceDeReajusteService = new IndiceDeReajusteService();
    self.centroDeCustoService = new CentroDeCustoService();
    self.contratoExternoService = new ContratoExternoService();
    self.arquivoService = new ArquivoService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.contratoExterno = {};
    $scope.cosp = 14;
    $scope.cosplan = 13;

    self.clear = function clear() {
        $scope.medicao = new Medicao();
        $scope.medicao.reajuste = {};
        $scope.medicao.statusMedicao = {
            class: "br.com.bentham.enums.StatusMedicao",
            declaringClass: "br.com.bentham.enums.StatusMedicao",
            descricao: "ENTREGUE",
            name: "ENTREGUE",
        };
        $scope.medicao.tipoMedicao = {
            class: "br.com.bentham.enums.TipoMedicao",
            declaringClass: "br.com.bentham.enums.TipoMedicao",
            descricao: "PADRÃO",
            name: "MEDICAO_PRINCIPAL",
        };
        $scope.produtos = [];
        $scope.indicesReajuste = [];
        $scope.filtro = {};
        $scope.filtro.contratoExterno = $rootScope.contrato;
    };
    self.clear();

    $scope.clear = function () {
        self.clear()
    };

    // Request Functions
    self.activate = function () {
        $scope.isLoading = true;
        var find = function () {
            self.find($stateParams.medicaoId)
                .then(function (data) {
                    $scope.medicao = data;
                    if (!$scope.medicao.reajuste || !$scope.medicao.reajuste.valor) {
                        $scope.medicao.reajuste = { valor: 0 };
                    }
                    $scope.isLoading = false;
                });
        }

        if ($stateParams.medicaoId)
            find($stateParams.medicaoId);
        else if ($stateParams.contratoExternoId != null) {
            $scope.cosp = 12;
            $scope.cosplan = 11;
            self.contratoExternoService.find($stateParams.contratoExternoId)
                .then(function (data) {
                    $scope.contratoExterno = data;
                    $scope.centroDeCusto = $scope.contratoExterno.centroCusto;
                    $scope.filtro.centroDeCusto = $scope.centroDeCusto;
                    $scope.filtro.contratoExterno = $scope.contratoExterno;
                    if ($stateParams.medicaoId)
                        find($stateParams.medicaoId);
                    else
                        self.clear();
                });
        } else {
            self.clear();
            $scope.isLoading = false;
        }
    };
    self.activate();

    $scope.search = function () {
        var filtro = {};
        filtro = angular.copy($scope.filtro);
        // filtro.tipoMedicao = ($scope.filtro.tipoMedicao != null) ? $scope.filtro.tipoMedicao.name : null;
        filtro.produto = ($scope.filtro.produto != null) ? $scope.filtro.produto.id : null;
        if ($scope.filtro.inicio != null)
            filtro.inicio = moment($scope.filtro.inicio, "YYYY-MM-DD").format("YYYY-MM-DD");
        if ($scope.filtro.fim != null)
            filtro.fim = moment($scope.filtro.fim, "YYYY-MM-DD").format("YYYY-MM-DD");
        filtro.contratoExterno = ($scope.filtro.contratoExterno != null) ? $scope.filtro.contratoExterno.id : null;
        filtro.produto = ($scope.filtro.produto != null) ? $scope.filtro.produto.id : null;
        if ($scope.aberto == true)
            filtro.search = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };

    $scope.clear = function () {
        $state.go("economico.medicoes");
    };

    $scope.save = function () {
        $scope.isLoading = true;
        self.save($scope.medicao)
            .then(function success(data) { self.activate(); $state.go("economico.formMedicao", { medicaoId: data.id }); $scope.isLoading = false; })
            .catch(function (error) { toastr.error(error.message); $scope.isLoading = false; });
    };

    $scope.load = function load(tableState) {
        if (tableState.sort.predicate == undefined && tableState.sort.sortOrder == undefined)
            self.initTableState(tableState, "inicio", 'DESC');
        else
            self.initTableState(tableState);

        $scope.isLoading = true;
        if ($stateParams.contratoExternoId != null)
            tableState.search.contratoExterno = $stateParams.contratoExternoId;
        if ((!tableState.search.contratoExterno) && $rootScope.contrato)
            tableState.search.contratoExterno = $rootScope.contrato.id;
        self.serviceView.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) { $scope.displayed = result.content; self.updateTableState(result); $scope.isLoading = false; })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.findApprovedProductsByDateAndCostCenter = function (costCenter, dateCompetence) {
        $scope.isLoadingProducts = true;
        var dateCompetenceSplit = dateCompetence.toISOString().split('T')[0];
        self.produtoService.findAllByDataCompetenciaAndStatusAndCentroDeCusto(
            costCenter.id,
            dateCompetenceSplit
        ).then(function (data) {
            $scope.produtos = data;

            if ($scope.medicao.produtos) {
                $scope.medicao.produtos = $scope.medicao.produtos.filter(function (produto) {
                    return $scope.produtos.some(function (p) {
                        return p.id === produto.id;
                    });
                });
            }

            $scope.isLoadingProducts = false;
        });
    };

    $scope.findReadjustmentIndicesByExternalContract = function (externalContract) {
        if (!externalContract) return;

        $scope.isLoadingReadjustmentIndices = true;
        self.indiceDeReajusteService.findAllByContratoExterno(externalContract)
            .then(function (data) {
                $scope.indicesReajuste = data;
                $scope.isLoadingReadjustmentIndices = false;
            });
    };
    //

    // Aux Functions 
    $scope.open = function (page, size, title, medicao) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () { $scope.medicao = medicao; return medicao; },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.onValorMedicaoBlur = function (valor) {
        if (valor == undefined || $scope.medicao.contratoExterno.percentualEmpresa == undefined) {
            $scope.medicao.valorEmpresa = 0;
            return;
        };

        var companyValue = (valor * $scope.medicao.contratoExterno.percentualEmpresa) / 100;
        $scope.medicao.valorEmpresa = companyValue.toFixed(2);
    };

    $scope.onCalculateReadjustmentValue = function (companyValue, ReadjustmentIndex) {
        if (companyValue == undefined || !ReadjustmentIndex || !ReadjustmentIndex.percentual) {
            $scope.medicao.reajuste.valor = 0;
        };

        var percentage = ReadjustmentIndex.percentual;
        var readjustmentValue = (companyValue * percentage) / 100;
        var readjustmentValueCurrent = $scope.medicao.reajuste.valor;
        var readjustmentValueFinal = readjustmentValueCurrent ? readjustmentValueCurrent : readjustmentValue;
        $scope.medicao.reajuste.valor = readjustmentValueFinal;
    };

    $scope.onCompetenciaChange = function (data) {
        if (!data) return;
        var startOfMonth = new Date(data.getFullYear(), data.getMonth(), 1);
        var endOfMonth = new Date(data.getFullYear(), data.getMonth() + 1, 0);
        $scope.medicao.inicio = startOfMonth;
        $scope.medicao.fim = endOfMonth;
    };

    $scope.onCalculateTotalValueProducts = function () {
        if (!$scope.medicao.produtos) return;

        var sumValueProduct = $scope.medicao.produtos.reduce(function (acc, produto) {
            var dataCompetenciaSplit = $scope.medicao.dataCompetencia.toISOString().split('T')[0];

            var productPercentage;
            if (dataCompetenciaSplit === produto.competenciaRealizadaEntrega) {
                productPercentage = produto.porcentagemRealizadaEntrega;
            } else if (dataCompetenciaSplit === produto.competenciaRealizadaAprovacao) {
                productPercentage = produto.porcentagemRealizadaAprovacao;
            }

            var productValue = produto.valorRealizado * (productPercentage / 100);
            var totalValue = produto.valorRealizadoTotal;

            var companyValueAcc = acc.companyValue + productValue;
            var totalValueAcc = acc.totalValue + totalValue;

            return { companyValue: companyValueAcc, totalValue: totalValueAcc };
        }, { companyValue: 0, totalValue: 0 });

        $scope.medicao.valorEmpresa = sumValueProduct.companyValue;
        $scope.medicao.valor = sumValueProduct.totalValue;

        if ($scope.medicao.valorEmpresa == undefined || !$scope.medicao.reajuste.indiceDeReajuste) return;
        $scope.onCalculateReadjustmentValue($scope.medicao.valorEmpresa, $scope.medicao.reajuste.indiceDeReajuste);
    }

    $scope.onReadjustmentIndicesByDate = function (readjustmentIndices, dateSelected) {
        if (!readjustmentIndices.length || !dateSelected) return;

        try {
            var dateSelectedSplit = dateSelected.toISOString().split('-');
            dateSelected = dateSelectedSplit[0] + '-' + dateSelectedSplit[1] + '-01';

            readjustmentIndices.sort(function (a, b) {
                return new Date(b.inicio) - new Date(a.inicio);
            });

            var datesFiltered = readjustmentIndices.filter(function (d) {
                var startDateSplit = d.inicio.split('T')[0].split('-');
                var startDate = startDateSplit[0] + '-' + startDateSplit[1] + '-01';

                var endDateSplit = d.fim.split('T')[0].split('-');
                var endDate = endDateSplit[0] + '-' + endDateSplit[1] + '-01';

                return dateSelected >= startDate && dateSelected <= endDate;
            });

            if (!datesFiltered.length) return;

            return datesFiltered[0];
        } catch (e) {
            console.log('onReadjustmentIndicesByDate error', e);
        }
    };

    //

    // Watchers and Events
    $scope.$on("sendContrato", function (evt, data) {
        if ($rootScope.contrato) {
            $scope.clear();
            $scope.search();
        }
    });

    $scope.$watch('medicao.contratoExterno', function (externalContract) {
        if (!externalContract) return;
        $scope.findReadjustmentIndicesByExternalContract(externalContract);
    });

    $scope.$watchGroup(['medicao.contratoExterno', 'medicao.dataCompetencia'], function (newValues) {
        var externalContract = newValues[0];
        var dateCompetence = newValues[1];

        if (!externalContract || !externalContract.centroCusto || !dateCompetence) return;

        var dateParts = dateCompetence.toISOString().split('-');
        var year = parseInt(dateParts[0], 10);
        var month = parseInt(dateParts[1], 10);
        var day = parseInt(dateParts[2], 10);
        if (year < 2000 || month < 1 || month > 12 || day < 1 || day > 31) return;

        $scope.findApprovedProductsByDateAndCostCenter(externalContract.centroCusto, dateCompetence);
    });

    $scope.$watchGroup(['medicao.contratoExterno', 'medicao.dataCompetencia', 'isLoadingReadjustmentIndices'], function (newValues) {
        $scope.hasReadjustmentInCompetenceDate = false;

        var externalContract = newValues[0];
        var dateCompetence = newValues[1];
        var isLoadingReadjustmentIndices = newValues[2];

        if (!externalContract || !externalContract.centroCusto || !dateCompetence || isLoadingReadjustmentIndices) return;

        var competencyReadjustmentIndex = $scope.onReadjustmentIndicesByDate($scope.indicesReajuste, dateCompetence);
        $scope.medicao.reajuste.indiceDeReajuste = competencyReadjustmentIndex;
        $scope.hasReadjustmentInCompetenceDate = competencyReadjustmentIndex ? true : false;

        if ($scope.medicao.valorEmpresa == undefined || !$scope.hasReadjustmentInCompetenceDate) return;

        $scope.onCalculateReadjustmentValue($scope.medicao.valorEmpresa, $scope.medicao.reajuste.indiceDeReajuste);
    });
    //
});
angular.module('bentham').factory('Medicao', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'medicoes/:id', {
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'medicoes/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'medicoes',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'medicoes/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        },
        adicionarVarios: {
            method: 'POST',
            url: prefixRoute + 'medicoes/adicionar-varios'
        },
    });
});

angular.module('bentham').factory('MedicaoService', function (GenericService, Medicao, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Medicao();
    Object.setPrototypeOf(self.resource, Medicao);

    self.converte = function (data) {
        if (data.inicio != null)
            data.inicio = self.converteData(data.inicio);
        if (data.data != null)
            data.data = self.converteData(data.data);
        if (data.fim != null)
            data.fim = self.converteData(data.fim);
        if (data.dataCompetencia != null)
            data.dataCompetencia = self.converteData(data.dataCompetencia);

        return data;
    };

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        if (data.inicio != null)
            data.inicio = self.converteData(data.inicio);
        if (data.data != null)
            data.data = self.converteData(data.data);
        if (data.fim != null)
            data.fim = self.converteData(data.fim);
        if (data.dataCompetencia != null)
            data.dataCompetencia = self.converteData(data.dataCompetencia);
        
        if (data.contratoExterno) {
            delete data.contratoExterno.centroCusto;
            delete data.contratoExterno.indiceDeReajuste;
            delete data.contratoExterno.parceiros;
            delete data.contratoExterno.consorcio;
            delete data.contratoExterno.perspectiva;
            delete data.contratoExterno.responsavelEmpresa;
            delete data.contratoExterno.responsavelCliente;
        }
        if (data.produto) {
            delete data.produto.contratoExterno;
            delete data.produto.centroDeCusto;
        }
        if(data.reajuste&&data.reajuste.indiceDeReajuste)
            delete data.reajuste.indiceDeReajuste.contratoExterno;       
        if(data.funcionario)
            delete data.funcionario.pessoaFisica;

        deferred.resolve(data);
        return deferred.promise
    };

    self.adicionarVarios = function (entity) {
        var deferred = $q.defer();
        var fn = function () {
            self.valida(entity)
            .then(function (med) {
                self.resource.adicionarVarios('', med,
                    function success(med) { deferred.resolve(med); },
                    function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            })
            .catch(function (error) { deferred.reject(error); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () {
        return self;
    };

});
angular.module('bentham').factory('MedicaoView', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'medicoes-view/:id', {
        id: '@id',
    }, {
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'medicoes-view',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'medicoes-view/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        },
        byContrato: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'medicoes-view/byContrato',
        }
    });
});

angular.module('bentham').factory('MedicaoViewService', function (GenericService, MedicaoView, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new MedicaoView();
    Object.setPrototypeOf(self.resource, MedicaoView);
    
    self.converte = function converte(task) {
        if (task.status.name == 'APROVADA') {
            task.color = 'btn-success';
        }  else if (task.status.name == 'EM_ANALISE') {
            task.color = 'btn-warning';
        } else if (new Date(task.data) >= new Date()) {
            task.color = 'btn-info';
        } else if (new Date(task.data) < new Date()) {
            task.color = 'btn-danger';
        }
        return task;
    }

    return function () {
        return self;
    };
});
angular.module('bentham.pages.economico.medicoes').controller('addVariosMedicaoCtrl', function ($scope, MedicaoService, GenericController, $q, toastr, $uibModal) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new MedicaoService();

    $scope.med = {};
    $scope.med.valores = [];
    $scope.med.valoresEmpresa = [];
    $scope.isValores = false;


    self.save = function (med) {
        var deferred = $q.defer();

        if (med.valoresEmpresa != null) {
            var valoresEmpresa = []
            angular.forEach(med.valores, function (v) { valoresEmpresa.push(v.valorEmpresa); });
            med.valoresEmpresa = valoresEmpresa;
        }

        if (med.valores != null) {
            var valores = []
            angular.forEach(med.valores, function (v) { valores.push(v.valor); });
            med.valores = valores;
        }

        $scope.med = {};
        $scope.med.valores = [];
        $scope.med.valoresEmpresa = [];
        $scope.isValores = false;
        med.contratoExterno != null ? med.contratoExterno = med.contratoExterno.id : null;
        self.service.adicionarVarios(med)
            .then(function (data) { $scope.load(self.tableState); deferred.resolve(data); })
            .catch(function (error) {  deferred.reject(error); toastr.error(error.message); });
        return deferred.promise;
    };
    
    $scope.openAddVarios = function (page, size, title, medicao) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.medicao = medicao;
                    return medicao;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };
    
    $scope.editarValores = function (start, end, dia) {
        if (start && end && dia != null) {
            $scope.isValores = true;
            $scope.med.valor = 0;
            $scope.med.valorEmpresa = 0;
            var i = 1;
            var d1 = moment(start);
            var d2 = moment(end);
            var qtdMes = Math.round(moment.duration(d2.diff(d1)).asMonths()) + 1;
            for (i = 1; i <= qtdMes; i++) {
                var mes = moment(start).format("MM");
                var ano = moment(start).format("YYYY");
                $scope.med.valores.push({ data: dia + "/" + mes + "/" + ano });
                start = moment(start).add(1, "months");
            }
        } else {
            toastr.warning("Verifique os campos: Data Inicial, Data Final e Dia do Inicio!");
        }
    };

    $scope.valorUnico = function () {
        $scope.isValores = false;
        $scope.med.valores = [];
        $scope.med.valoresEmpresa = [];
    };

    $scope.onValorBlur = function (valor) {
        return (valor * $scope.med.contratoExterno.percentualEmpresa) / 100;
    };

});
angular.module("bentham.pages.contratos.contratosexternos").controller("OrdemDeServicoCtrl", function (
    $scope,
    OrdemDeServico,
    OrdemDeServicoService,
    ContratoExternoService,
    GenericController,
    $stateParams,
    $uibModal,
    toastr,
    ArquivoService
  ) {

    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new OrdemDeServicoService();
    self.contratoExternoService = new ContratoExternoService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    $scope.contrato = {};

    self.clear = function clear() {
      $scope.ordemDeServico = new OrdemDeServico();
      $scope.ordemDeServico.contratoExterno = $scope.contratoExterno;
      $scope.isLoading = false;
    };

    $scope.clear = function () {
      self.clear();
    };

    $scope.clear = function () {
    };

    $scope.back = function () {
      self.clear();
    };

    self.activate = function () {
      $scope.isLoading = true;
      var find = function (OrdemDeServicoId) {
        self
          .find(OrdemDeServicoId)
          .then(function (data) {
            $scope.ordemDeServico = data;
            $scope.ordemDeServico.contratoExterno = $scope.contratoExterno;
            $scope.isLoading = false;
          })
          .catch(function (error) { toastr.error(error.message);});
      };
      if ($stateParams.contratoId != null) {
        self.contratoExternoService
          .find($stateParams.contratoId)
          .then(function (data) {
            $scope.contratoExterno = data;
            if ($stateParams.OrdemDeServicoId)
              find($stateParams.OrdemDeServicoId);
            else self.clear();
          });
      }
      if ($stateParams.OrdemDeServicoId) find($stateParams.OrdemDeServicoId);
      else self.clear();
    };

    self.activate();

    $scope.load = function load(tableState) {
      self.initTableState(tableState, "data");
      $scope.isLoading = true;
      if ($stateParams.contratoId)
        tableState.search.contratoExternoId = $stateParams.contratoId;
      self.service
        .getPage(
          tableState.page,
          tableState.pagination.number,
          tableState.sort.predicate,
          tableState.sort.sortOrder,
          tableState.search
        )
        .then(function (result) {
          $scope.displayed = result.content;
          self.updateTableState(result);
          $scope.isLoading = false;
        })
        .catch(function (error) {
          toastr.error(error.message);
        });
    };

    $scope.refresh = function () {
      $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, entity) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          entity: function () {
            $scope.ordemDeServico = entity;
            $scope.ordemDeServico.contratoExterno = $scope.contratoExterno;
            delete $scope.ordemDeServico.contratoExterno.centroDeCusto;
            delete $scope.ordemDeServico.contratoExterno.responsavelCliente;
            delete $scope.ordemDeServico.contratoExterno.responsavelEmpresa;
            delete $scope.ordemDeServico.contratoExterno.perspectiva;
            return entity;
          },
          self: function () {
            return self;
          },
          title: function () {
            return title;
          },
        },
        scope: $scope,
        controller: "ModalController",
      });
    };
  });

angular.module('bentham').factory('OrdemDeServico', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'ordens-de-servicos/:id', { id: '@id', }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'ordens-de-servicos/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'ordens-de-servicos',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'ordens-de-servicos/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        }
    });
});

angular.module('bentham').factory('OrdemDeServicoService', function (OrdemDeServico, GenericService, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new OrdemDeServico();
    Object.setPrototypeOf(self.resource, OrdemDeServico);

    self.converte = function (data) {
        if (data.data != null)
            data.data = self.converteData(data.data);
        return data;
    };

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        if (data.data != null)
            data.data = self.converteData(data.data);
        delete data.contratoExterno.ordemDeReajuste;
        deferred.resolve(data);
        return deferred.promise
    };

    return function () { return self; };
});
angular.module('bentham.pages.economico.produtos').controller('ProdutoCtrl', function ($scope, $state, Produto, ProdutoService, ContratoExternoService, CentroDeCustoService, OrdemDeServicoService, IndiceDeReajusteService, GenericController, $stateParams, toastr, DocumentoService, prefixRoute, $sce, $window) {

    var self = this;
    Object.setPrototypeOf(self, GenericController);

    self.service = new ProdutoService();
    self.contratoExternoService = new ContratoExternoService();
    self.centroDeCustoService = new CentroDeCustoService();
    self.ordemDeServicoService = new OrdemDeServicoService();
    self.documentoService = new DocumentoService();
    self.indiceDeReajusteService = new IndiceDeReajusteService();

    $scope.centroDeCusto = {};
    $scope.contrato = {};
    $scope.indicesReajuste = [];
    //
 
    self.clear = function clear() {
        $scope.produto = new Produto();
        if ($scope.contratoExterno != null) {
            $scope.produto.contratoExterno = $scope.contratoExterno;
            $scope.produto.centroDeCusto = $scope.contratoExterno.centroCusto;
        }
        $scope.produto.reajuste = {};
        $scope.indicesReajuste = [];
        $scope.isLoading = false;
    };

    $scope.clear = function () {
        self.clear();
    }

    // Request Fuctions
    $scope.save = function () {
        ($scope.produto.contratoExterno != null && $scope.produto.contratoExterno.centroCusto != null) ? $scope.produto.centroDeCusto = $scope.produto.contratoExterno.centroCusto: null;
        $scope.isLoading = true;
        $scope.setEqualValuesForNonParcelType();
        self.save($scope.produto)
            .then(function success(data) { self.activate(); $state.go("economico.produto", { produtoId: data.id }); $scope.isLoading = false; })
            .catch(function (error) { toastr.error(error.message); $scope.isLoading = false; });
    }

    self.activate = function () {
        $scope.isLoading = true;
        var find = function (produtoId) {
            self.find(produtoId)
                .then(function (data) {
                    $scope.produto = data;
                    $scope.produto.reajuste = ($scope.produto.reajuste == null) ? {} : $scope.produto.reajuste;
                    if ($scope.produto.cartaMedicao != null && $scope.produto.cartaMedicao.id != null)
                        $scope.picture = prefixRoute + "arquivos/catchPdfFile/" + $scope.produto.cartaMedicao.id;
                    if ($scope.contratoExterno != null) {
                        self.ordemDeServicoService.list(null, null, null, null, { contratoExternoId : $scope.produto.contratoExterno.id } )
                            .then(function (data) { $scope.isLoading = true; $scope.ordensDeServicos = data; $scope.isLoading = false;});
                    }
                        $scope.isLoading = false;
                })
                .catch(function (error) {  toastr.error(error.message); });
        }
        if ($stateParams.contratoExternoId != null) {
            $scope.cosp = 8;
            $scope.cosplan = 7;
            self.contratoExternoService.find($stateParams.contratoExternoId)
                .then(function (data) {
                    $scope.contratoExterno = data;
                    $scope.centroDeCusto = $scope.contratoExterno.centroCusto;
                    self.ordemDeServicoService.list(null, null, null, null, { contratoExternoId : $scope.contratoExterno.id } )
                        .then(function (data) { $scope.ordensDeServicos = data; });
                    if ($stateParams.produtoId)
                        find($stateParams.produtoId);
                    else
                        self.clear();
                });
        } else if ($stateParams.centroDeCustoId != null) {
            $scope.cosp = 8;
            $scope.cosplan = 7;
            self.centroDeCustoService.find($stateParams.centroDeCustoId)
                .then(function (data) {
                    $scope.centroDeCusto = data;
                    if ($stateParams.produtoId)
                        find($stateParams.produtoId);
                    else
                        self.clear();
                });
        }
        if ($stateParams.produtoId)
            find($stateParams.produtoId);
        else
            self.clear();
    };

    self.activate();

    $scope.findReadjustmentIndicesByExternalContract = function (externalContract) {
        if (!externalContract) return;

        $scope.isLoadingReadjustmentIndices = true;
        self.indiceDeReajusteService.findAllByContratoExterno(externalContract)
            .then(function (data) {
                $scope.indicesReajuste = data;
                $scope.isLoadingReadjustmentIndices = false;
            });
    };
    //

    // Form Interation Section and Aux Functions
    $scope.isProductInInstallments = function() {
        if(!$scope.produto) return false;
        return $scope.produto.isPagamentoParcelado;
    };
  
    $scope.isProductTypeHH = function() {
        if(!$scope.produto || !$scope.produto.tipo) return false;
        return $scope.produto.tipo.descricao === 'HH';
    };
  
    $scope.isProductEntregue = function() {
        if(!$scope.produto || !$scope.produto.status) return false;
        return $scope.produto.status.name === 'ENTREGUE';
    };
  
    $scope.isProductAprovado = function() {
        if(!$scope.produto || !$scope.produto.status) return false;
        return $scope.produto.status.name === 'APROVADA';
    };

    $scope.onCalculateReadjustmentValue = function (companyValue, ReadjustmentIndex) {
        if(companyValue == undefined || !ReadjustmentIndex || !ReadjustmentIndex.percentual) {
            $scope.produto.reajuste.valor = 0;
        };

        var percentage = ReadjustmentIndex.percentual;
        var readjustmentValue = (companyValue * percentage) / 100;
        $scope.produto.reajuste.valor = readjustmentValue.toFixed(2);
        
        //   $scope.onCalculateReadjustmentValueTotal($scope.medicao.reajuste.valor);
    };
 
    // $scope.onCalculateReadjustmentValueTotal = function (reajuste) {
        // $scope.valorTotal = reajuste + $scope.produto.valorEmpresa;
    // };
 
    $scope.onCalculatePercentageValue = function (valor) {
        var percentageValue = (valor * $scope.produto.contratoExterno.percentualEmpresa) / 100;
        return percentageValue;
    };

    $scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
    }

    $scope.onCompetenciaChange = function (data) {
      if(!data) return;
      var startOfMonth = new Date(data.getFullYear(), data.getMonth(), 1);
      var endOfMonth = new Date(data.getFullYear(), data.getMonth() + 1, 0);
      $scope.produto.inicio = startOfMonth;
      $scope.produto.fim = endOfMonth;
    };

    $scope.back = function () {
        if($scope.centroDeCusto != null)
            $state.go("economico.produtos", { centroDeCustoId: $scope.centroDeCusto.id })
        else
            $state.go("economico.produtos")
    };

    $scope.setEqualValuesForNonParcelType = function (){
      if($scope.isProductInInstallments()) return;
      $scope.produto.porcentagemPrevistaAprovacao = $scope.produto.porcentagemPrevistaEntrega;
      $scope.produto.porcentagemRealizadaAprovacao = $scope.produto.porcentagemRealizadaEntrega;
      $scope.produto.competenciaPrevistaAprovacao = $scope.produto.dataCompetencia;
      $scope.produto.competenciaRealizadaAprovacao = $scope.produto.competenciaRealizadaEntrega;
    };

    $scope.onReadjustmentIndicesByDate = function (readjustmentIndices, dateSelected) {
        if (!readjustmentIndices.length || !dateSelected) return;

        try {
            var dateSelectedSplit = dateSelected.toISOString().split('-');
            dateSelected = dateSelectedSplit[0] + '-' + dateSelectedSplit[1] + '-01';
    
            readjustmentIndices.sort(function (a, b) {
                return new Date(b.inicio) - new Date(a.inicio);
            });
    
            var datesFiltered = readjustmentIndices.filter(function (d) {
                var startDateSplit = d.inicio.split('T')[0].split('-');
                var startDate = startDateSplit[0] + '-' + startDateSplit[1] + '-01';
    
                var endDateSplit = d.fim.split('T')[0].split('-');
                var endDate = endDateSplit[0] + '-' + endDateSplit[1] + '-01';
    
                return dateSelected >= startDate && dateSelected <= endDate;
            });
    
            if (!datesFiltered.length) return;
    
            return datesFiltered[0];
        } catch (e) {
            console.log('onReadjustmentIndicesByDate error', e);
        }
    };
    //

    // Upload File Section
    $scope.download = function (arquivo) {
        self.documentoService.catchFile(arquivo)
            .then(function success(data) { downloadFile(new Blob([data.response]), arquivo.name, data.response.type); })
            .catch(function (error) {  toastr.error(error.message); });
    };

    $scope.onFileSelectCartaMedicao = function ($files) {
        if ($scope.produto.centroDeCusto && $scope.produto.centroDeCusto.regiao && $scope.produto.centroDeCusto.responsavel != null) {
            self.documentoService.upload($files, "CARTA_DE_MEDICAO",
                    $scope.produto.centroDeCusto.regiao.descricao + "/" + $scope.produto.centroDeCusto.responsavel.pessoaFisica.pessoa.nome + "/" + $scope.produto.centroDeCusto.nome + "/" + $scope.produto.descricao)
                .then(function success(data) {
                    $scope.produto.cartaMedicao = data;
                    $scope.picture = prefixRoute + "arquivos/catchPdfFile/" + $scope.produto.cartaMedicao.id;
                    toastr.success("Upload feito com sucesso!");
                })
                .catch(function (error) {
                    toastr.error(error.message);
                });
        } else
            toastr.warning("Verifique os dados cadastrais do Centro de Custo!! Região e Responsável não cadastrados");
    };
    //

    // Watchers and Events
    $scope.$watch('produto.contratoExterno', function (externalContract) {
        if (!externalContract) return;
        $scope.findReadjustmentIndicesByExternalContract(externalContract);

        $scope.produto.centroDeCusto = externalContract.centroCusto;
        self.ordemDeServicoService.list(null, null, null, null, { contratoExternoId: externalContract.id })
            .then(function (data) { $scope.ordensDeServicos = data; });
    });

    $scope.$watchGroup(['produto.valorEmpresa', 'isLoadingReadjustmentIndices'], function (newValues) {
        var companyValue = newValues[0];
        var isLoadingReadjustmentIndices = newValues[1];

        if(
            companyValue == undefined ||
            !$scope.produto ||
            !$scope.produto.reajuste ||
            !$scope.produto.reajuste.indiceDeReajuste ||
            isLoadingReadjustmentIndices
          ) return;
  
        $scope.onCalculateReadjustmentValue(companyValue, $scope.produto.reajuste.indiceDeReajuste);
    })

    $scope.$watchGroup(['produto.contratoExterno', 'produto.dataCompetencia', 'isLoadingReadjustmentIndices'], function (newValues) {
        $scope.hasReadjustmentInCompetenceDate = false;

        var externalContract = newValues[0];
        var dateCompetence = newValues[1];
        var isLoadingReadjustmentIndices = newValues[2];

        if (!$scope.produto || !externalContract || !externalContract.centroCusto || !dateCompetence || isLoadingReadjustmentIndices) return;

        var competencyReadjustmentIndex = $scope.onReadjustmentIndicesByDate($scope.indicesReajuste, dateCompetence);
        $scope.produto.reajuste.indiceDeReajuste = competencyReadjustmentIndex;
        $scope.hasReadjustmentInCompetenceDate = !!competencyReadjustmentIndex;

        if($scope.produto.valorEmpresa == undefined || !$scope.hasReadjustmentInCompetenceDate) return;

        $scope.onCalculateReadjustmentValue($scope.produto.valorEmpresa, $scope.produto.reajuste.indiceDeReajuste);
    });
  
    $scope.$watch('produto.valor', function(newValue) {
        if(
          !newValue ||
          !$scope.produto.valor
        ) return;
  
        $scope.produto.valorEmpresa = $scope.onCalculatePercentageValue($scope.produto.valor);
    });
    
    $scope.$watch('produto.valorRealizadoTotal', function(newValue) {
        if(
          !newValue ||
          !$scope.produto.valorRealizadoTotal
        ) return;
  
        $scope.produto.valorRealizadoConsorcio = $scope.produto.valorRealizadoTotal;
        $scope.produto.valorRealizado = $scope.onCalculatePercentageValue($scope.produto.valorRealizadoTotal);
    });
    
    $scope.$watch('produto.tipo', function(newValue) {
        if(!newValue) return;
        if($scope.isProductTypeHH()) {
            $scope.produto.isPagamentoParcelado = false;
        }
    });
   
    $scope.$watch('produto.isPagamentoParcelado', function(newValue) {
        if(newValue || !$scope.produto) return;
          
        $scope.produto.porcentagemPrevistaEntrega = 100.00;
        $scope.produto.porcentagemRealizadaEntrega = 100.00;
    });   
    //

});
angular.module('bentham').factory('Produto', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'produtos/:id', {
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'produtos/:id',
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'produtos',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'produtos/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        },
        findByCentroDeCusto: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'produtos/centro-custo'
        },
        findAllByContratoExternoId: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'produtos/findAllByContratoExternoId'
        },
        findAllByDataCompetenciaAndStatusAndCentroDeCusto: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'produtos/produtos-aprovados'
        },
        copiarProduto: {
            method: 'POST',
            url: prefixRoute + 'produtos/copiar-produto',
        },
        gerarConta: {
            method: 'POST',
            url: prefixRoute + 'produtos/gerar-conta-receber',
        },
        adicionarVarios: {
            method: 'POST',
            url: prefixRoute + 'produtos/adicionar-varios'
        },
        mediaUltimosProdutos: {
            method: 'GET',
            url: prefixRoute + 'produtos/media-ultimos-produtos'
        },
        gerarRelatorio: downloadFileResource({
            url: prefixRoute + 'produtos/relatorio',
        }),
        gerarRelatorioControleEntrega: downloadFileResource({
            url: prefixRoute + 'produtos/relatorio-controle-entregas',
        })
    });
});

angular.module('bentham').factory('ProdutoService', function (Produto, GenericService, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Produto();
    Object.setPrototypeOf(self.resource, Produto);

    self.copiarProduto = function (entity) {
        var deferred = $q.defer();
        delete entity.contratoExterno.perspectiva;
        delete entity.contratoExterno.centroDeCusto;
        delete entity.contratoExterno.responsavelEmpresa;
        delete entity.contratoExterno.responsavelCliente;
        var fn = function () {
            self.valida(entity)
            .then(function (produto) {
                if (entity)
                    self.resource.copiarProduto('', produto,
                        function success(produto) {  deferred.resolve(produto); },
                        function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            })
            .catch(function (error) { deferred.reject(error); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.gerarConta = function (entity) {
        var deferred = $q.defer();
        delete produto.contratoExterno.perspectiva;
        delete produto.contratoExterno.centroDeCusto;
        delete produto.contratoExterno.responsavelEmpresa;
        delete produto.contratoExterno.responsavelCliente;
        var fn = function () {
            self.valida(entity)
            .then(function (produto) {
                self.resource.gerarConta('', produto,
                    function success(produto) { deferred.resolve(produto); },
                    function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            })
            .catch(function (error) { deferred.reject(error); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.adicionarVarios = function (entity) {
        var deferred = $q.defer();
        var fn = function () {
            self.valida(entity)
            .then(function (prod) {
                self.resource.adicionarVarios('', prod,
                    function success(prod) { deferred.resolve(prod); },
                    function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            })
            .catch(function (error) { deferred.reject(error); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.mediaUltimosProdutos = function (contratoId) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.mediaUltimosProdutos({ id: contratoId },
                function success(data) { deferred.resolve(data); },
                function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.findByCentroDeCusto = function (centroDeCustoId) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.findByCentroDeCusto({ id: centroDeCustoId },
                function success(data) { deferred.resolve(data); },
                function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.findAllByContratoExternoId = function (contratoExternoId) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.findAllByContratoExternoId({ id: contratoExternoId },
                function success(data) { deferred.resolve(data); },
                function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.findAllByDataCompetenciaAndStatusAndCentroDeCusto = function (centroDeCustoId, dataCompetencia) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.findAllByDataCompetenciaAndStatusAndCentroDeCusto({ centroDeCustoId: centroDeCustoId, dataCompetencia:dataCompetencia },
                function success(data) { deferred.resolve(data); },
                function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.converte = function (data) {
        if (data.inicio != null)
            data.inicio = self.converteData(data.inicio);
        if (data.fim != null)
            data.fim = self.converteData(data.fim);
        if (data.dataCompetencia != null)
            data.dataCompetencia = self.converteData(data.dataCompetencia);
        if (data.dataPrevisto != null)
            data.dataPrevisto = self.converteData(data.dataPrevisto);
        if (data.dataRealizado != null)
            data.dataRealizado = self.converteData(data.dataRealizado);
        if (data.dataContrato != null)
            data.dataContrato = self.converteData(data.dataContrato);
        if (data.competenciaPrevistaAprovacao != null)
            data.competenciaPrevistaAprovacao = self.converteData(data.competenciaPrevistaAprovacao);
        if (data.competenciaRealizadaEntrega != null)
            data.competenciaRealizadaEntrega = self.converteData(data.competenciaRealizadaEntrega);
        if (data.competenciaRealizadaAprovacao != null)
            data.competenciaRealizadaAprovacao = self.converteData(data.competenciaRealizadaAprovacao);
        return data;
    };

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        if (data.inicio != null)
            data.inicio = self.converteData(data.inicio);
        if (data.fim != null)
            data.fim = self.converteData(data.fim);
        if (data.dataCompetencia != null)
            data.dataCompetencia = self.converteData(data.dataCompetencia);
        if (data.dataPrevisto != null)
            data.dataPrevisto = self.converteData(data.dataPrevisto);
        if (data.dataRealizado != null)
            data.dataRealizado = self.converteData(data.dataRealizado);
        if (data.dataContrato != null)
            data.dataContrato = self.converteData(data.dataContrato);
        if (data.competenciaPrevistaAprovacao != null)
            data.competenciaPrevistaAprovacao = self.converteData(data.competenciaPrevistaAprovacao);
        if (data.competenciaRealizadaEntrega != null)
            data.competenciaRealizadaEntrega = self.converteData(data.competenciaRealizadaEntrega);
        if (data.competenciaRealizadaAprovacao != null)
            data.competenciaRealizadaAprovacao = self.converteData(data.competenciaRealizadaAprovacao);
        if (data.centroDeCusto)
            delete data.centroDeCusto.responsavel;
        if (data.ordemDeServico) 
            delete data.ordemDeServico.contratoExterno;
        if (data.contratoExterno) {
            delete data.contratoExterno.perspectiva;
            delete data.contratoExterno.centroDeCusto;
            delete data.contratoExterno.responsavelEmpresa;
            delete data.contratoExterno.responsavelCliente;
            delete data.contratoExterno.indiceDeReajuste;
            delete data.contratoExterno.parceiros;
            delete data.contratoExterno.consorcio;
            delete data.contratoExterno.perspectiva;
            delete data.contratoExterno.responsavelEmpresa;
            delete data.contratoExterno.responsavelCliente;
        }
        if (data.reajuste&&data.reajuste.indiceDeReajuste)
            delete data.reajuste.indiceDeReajuste.contratoExterno;
        deferred.resolve(data);
        return deferred.promise
    };

    return function () {
        return self;
    };
});
angular.module('bentham').factory('ProdutoView', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'produtos-view/:id', {
        id: '@id',
    }, {
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'produtos-view',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'produtos-view/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        },
        byContrato: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'produtos-view/byContrato',
        }
    });
});

angular.module('bentham').factory('ProdutoViewService', function (ProdutoView, GenericService, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ProdutoView();
    Object.setPrototypeOf(self.resource, ProdutoView);

    self.converte = function converte(task) {
        if (task.status.name == 'ENTREGUE' || task.status.name == 'APROVADA') {
            task.color = 'btn-success';
        }  else if (task.status.name == 'EM_ANDAMENTO' || task.status.name == 'EM_ANALISE') {
            task.color = 'btn-warning';
        } else if (new Date(task.dataContrato) >= new Date()) {
            task.color = 'btn-info';
        } else if (new Date(task.dataContrato) < new Date()) {
            task.color = 'btn-danger';
        }
        return task;
    }

    return function () {
        return self;
    };
});
angular.module('bentham.pages.economico.produtos').controller('ProdutosCtrl', function ($scope, $rootScope, $state, Produto, ProdutoService, ProdutoViewService, ContratoExternoService, CentroDeCustoService, OrdemDeServicoService, GenericController, $stateParams, $uibModal, toastr, $q, AuthService) {

    var self = this;
    Object.setPrototypeOf(self, GenericController);
 
    $scope.authService = AuthService;
    self.service = new ProdutoService();
    self.serviceView = new ProdutoViewService();
    self.contratoExternoService = new ContratoExternoService();
    self.centroDeCustoService = new CentroDeCustoService();
    self.ordemDeServicoService = new OrdemDeServicoService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    $scope.cosp = 16;
    $scope.cosplan = 15;

    $scope.centroDeCusto = {};
    $scope.contrato = {};
    $scope.filtro = {};

    $scope.isValores = false;

    $scope.$on("sendContrato", function (evt, data) {
        $scope.isLoading = true;
        $scope.filtro.contratoExterno = data;
        if ($rootScope.contrato) {
            $scope.search();
        }
    });

    self.save = function (prod) {
        var deferred = $q.defer();

        if (prod.centroDeCusto != null)
            prod.centroDeCusto = prod.centroDeCusto.id;
        if (prod.contratoExterno != null)
            prod.contratoExterno = prod.contratoExterno.id;
        if (prod.dataInicial != null)
            prod.dataInicial = moment(prod.dataInicial, "YYYY-MM-DD").format("YYYY-MM-DD");
        if (prod.dataFinal != null)
            prod.dataFinal = moment(prod.dataFinal, "YYYY-MM-DD").format("YYYY-MM-DD");

        if (prod.valores != null) {
            var valoresEmpresa = []
            angular.forEach(prod.valores, function (v) { valoresEmpresa.push(v.valorEmpresa); });
            prod.valoresEmpresa = valoresEmpresa;
        }

        if (prod.valores != null) {
            var valores = []
            angular.forEach(prod.valores, function (v) { valores.push(v.valor); });
            prod.valores = valores;
        }
        $scope.prod = {};
        $scope.prod.valores = [];
        $scope.prod.valoresEmpresa = [];
        $scope.isValores = false;
        self.service.adicionarVarios(prod)
            .then(function (data) { $scope.search(); deferred.resolve(data); })
            .catch(function (error) { deferred.reject(error); toastr.error(error.message); });

        return deferred.promise;
    };

    self.clear = function clear() {
        $scope.produto = new Produto();
        $scope.filtro = { openAdvancedSearch: true };
        $scope.filtro.centroDeCusto = $scope.centroDeCusto;
        if($scope.contratoExterno)
            $scope.filtro.contratoExterno = $scope.contratoExterno;
        else
            $scope.filtro.contratoExterno = $rootScope.contrato;
        if($rootScope.contrato)
            self.ordemDeServicoService.list(null, null, null, null, { contratoExternoId : $rootScope.contrato.id } )
                .then(function (data) { $scope.ordensDeServicos = data; });
        // variavel para varios produtos
        $scope.prod = {};
        $scope.prod.valores = [];
    };

    $scope.clear = function () {
        self.clear();
    }

    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.contratoExternoId != null) {
            $scope.cosp = 15;
            $scope.cosplan = 14;
            self.contratoExternoService.find($stateParams.contratoExternoId)
                .then(function (data) {
                    $scope.contratoExterno = data;
                    $scope.centroDeCusto = $scope.contratoExterno.centroCusto;
                    $scope.filtro.centroDeCusto = $scope.centroDeCusto;
                    $scope.filtro.contratoExterno = $scope.contratoExterno;
                    self.clear();
                });
        } else if ($stateParams.centroDeCustoId != null) {
            $scope.cosp = 15;
            $scope.cosplan = 14;
            self.centroDeCustoService.find($stateParams.centroDeCustoId)
                .then(function (data) {
                    $scope.centroDeCusto = data;
                    $scope.filtro.centroDeCusto = data;
                    self.clear();
                });
        }
    };

    self.activate();

    self.transformToFilterPayload = function (data) {
        var filtro = angular.copy(data);
        filtro.status = data.status ? data.status.name : undefined;
        filtro.tipo = data.tipo ? data.tipo.name : undefined;
        filtro.centroDeCusto = data.centroDeCusto ? data.centroDeCusto.id : undefined;
        filtro.contratoExterno = data.contratoExterno ? data.contratoExterno.id : undefined;
        filtro.ordemDeServico = data.ordemDeServico ? data.ordemDeServico.id : undefined;
        return filtro;
    };

    $scope.search = function () {
        $rootScope.filtro = $scope.filtro
        var filtro = self.transformToFilterPayload($scope.filtro);
        self.tableState.search = filtro;
        if ($scope.filtro.openAdvancedSearch) filtro.search = null;
        $rootScope.filtro.openAdvancedSearch = true;
        $scope.pageable(self.tableState);
    };

    $scope.pageable = function pageable(tableState) {
        if (tableState.sort.predicate  == undefined && tableState.sort.sortOrder == undefined){
          self.initTableState(tableState, "dataContrato", 'DESC');
        } else {
          self.initTableState(tableState);
       }

        $scope.isLoading = true;
        self.serviceView.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) { $scope.displayed = result.content; self.updateTableState(result); $scope.isLoading = false; })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.load = function load(tableState) {
      $scope.isLoading = true;
      $scope.filtro = $rootScope.filtro || {};

      tableState.search = self.transformToFilterPayload($scope.filtro);
      $scope.onContratoChange($scope.filtro.contratoExterno);
      
      if ($stateParams.contratoExternoId)
          tableState.search.contratoExterno = $stateParams.contratoExternoId;
      if ($stateParams.centroDeCustoId)
          tableState.search.centroDeCusto = $stateParams.centroDeCustoId;
      if (!tableState.search.contratoExterno && $rootScope.contrato)
          tableState.search.contratoExterno = $rootScope.contrato.id;

      $scope.pageable(tableState);
    }

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () { $scope.produto = entity; return entity; },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.copiarProduto = function (produto) {
        if (!produto) {
            toastr.error('Erro: Produto não definido!');
            return;
        }
        
        console.log('Produto recebido:', produto);
    
        if (!self || !self.service || !self.service.copiarProduto) {
            toastr.error('Erro: Serviço não disponível!');
            return;
        }
        self.service.copiarProduto(produto)
            .then(function (data) { 
                $scope.produto = data; 
                $state.go('economico.produtos', { produtoId: data.id });
                toastr.success('Produto Copiado com Sucesso!');
                $scope.refresh();
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.onContratoChange = function (contrato) {
        if (contrato != null) {
            self.ordemDeServicoService.list(null, null, null, null, { contratoExternoId : contrato.id } )
              .then(function (data) { $scope.ordensDeServicos = data; });
        }
    };

    $scope.onValorBlur = function (valor) {
        return (valor * $scope.prod.contratoExterno.percentualEmpresa) / 100;
    };

    $scope.editarValores = function (dataInicial, dataFinal) {
        if (dataInicial && dataFinal && $scope.prod.diaDoContrato != null) {
            $scope.isValores = true;
            $scope.prod.valor = 0;
            var i = 1;
            var d1 = moment(dataInicial);
            var d2 = moment(dataFinal);
            var qtdMes = Math.round(moment.duration(d2.diff(d1)).asMonths()) + 1;
            for (i = 1; i <= qtdMes; i++) {
                var mes = moment(dataInicial).format("MM");
                var ano = moment(dataInicial).format("YYYY");
                $scope.prod.valores.push({ data: $scope.prod.diaDoContrato + "/" + mes + "/" + ano });
                dataInicial = moment(dataInicial).add(1, "months");
            }
        } else {
            toastr.warning("Verifique os campos: Data Inicial, Data Final e Dia do Contrato!");
        }
    };

    $scope.valorUnico = function () {
        $scope.isValores = false;
        $scope.prod.valores = []
    };

    $scope.mediaUltimosProdutos = function (contrato) {
        self.service.mediaUltimosProdutos(contrato.id)
            .then(function (data) { $scope.prod = data; $scope.prod.valores = []; })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.gerarConta = function (produto) {
        self.service.gerarConta(produto)
            .then(function (data) { $state.go('financeiro.contareceber', { contaReceberId: data.id }) })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.$watch('filtro.contratoExterno', function(newValue) {
        console.log('new value', newValue)
        if (!newValue || !newValue.dataInicioVigencia || !newValue.dataFimVigencia) return;

        $scope.filtro.dataCompetenciaInicial = new Date(newValue.dataInicioVigencia)
        $scope.filtro.dataCompetenciaFinal = new Date(newValue.dataFimVigencia)
    });
});
angular
  .module("bentham.pages.contratos.contratosexternos")
  .controller("RevisaoContratoCtrl", function (
    $scope,
    RevisaoContrato,
    RevisaoContratoService,
    ContratoExternoService,
    CentroDeCustoService,
    GenericController,
    $stateParams,
    $uibModal,
    toastr,
    ArquivoService
  ) {

    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new RevisaoContratoService();
    self.contratoExternoService = new ContratoExternoService();
    self.centroDeCustoService = new CentroDeCustoService();
    self.arquivoService = new ArquivoService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    $scope.centroDeCusto = {};
    $scope.contrato = {};

    self.clear = function clear() {
      $scope.revisaoContrato = new RevisaoContrato();
      $scope.revisaoContrato.valor = 0
      $scope.revisaoContrato.valorTotal = 0
      $scope.revisaoContrato.prazo = 0
      $scope.revisaoContrato.vigencia = 0
      $scope.revisaoContrato.contratoExterno = $scope.contratoExterno;
      $scope.filtro = {};
      $scope.filtro.centroDeCusto = $scope.centroDeCusto;
      $scope.filtro.contratoExterno = $scope.contratoExterno;
      $scope.filtro.order = 'DESC';
      $scope.isLoading = false;
    };

    $scope.clear = function () {
      self.clear();
    };

    $scope.clearTipoRevisao = function () {
      $scope.revisaoContrato.valor = 0
      $scope.revisaoContrato.valorTotal = 0
      $scope.revisaoContrato.prazo = 0
      $scope.revisaoContrato.vigencia = 0
    };

    $scope.back = function () {
      self.clear();
    };

    self.activate = function () {
      $scope.isLoading = true;
      var find = function (revisaoContratoId) {
        self
          .find(revisaoContratoId)
          .then(function (data) {
            $scope.revisaoContrato = data;
            $scope.revisaoContrato.contratoExterno = $scope.contratoExterno;
            $scope.isLoading = false;
          })
          .catch(function (error) { toastr.error(error.message);});
      };
      if ($stateParams.contratoId != null) {
        self.contratoExternoService
          .find($stateParams.contratoId)
          .then(function (data) {
            $scope.contratoExterno = data;
            $scope.centroDeCusto = $scope.contratoExterno.centroCusto;
            if ($stateParams.revisaoContratoId)
              find($stateParams.revisaoContratoId);
            else self.clear();
          });
      }
      if ($stateParams.revisaoContratoId) find($stateParams.revisaoContratoId);
      else self.clear();
    };

    self.activate();

    $scope.search = function () {
      var filtro = angular.copy($scope.filtro);
      filtro.centroDeCusto = ($scope.filtro.centroDeCusto != null) ? $scope.filtro.centroDeCusto.id : null;
      filtro.contratoExterno = ($scope.filtro.contratoExterno != null) ? $scope.filtro.contratoExterno.id : null;
      if ($scope.aberto == true)
          filtro.search = null;
      self.tableState.search = filtro;
      $scope.load(self.tableState);
    };

    $scope.load = function load(tableState) {
      self.initTableState(tableState, "data", 'DESC');
      $scope.isLoading = true;
      if ($stateParams.contratoId)
        tableState.search.contratoExterno = $stateParams.contratoId;
      self.service
        .getPage(
          tableState.page,
          tableState.pagination.number,
          tableState.sort.predicate,
          tableState.sort.sortOrder,
          tableState.search
        )
        .then(function (result) {
          $scope.displayed = result.content;
          self.updateTableState(result);
          $scope.isLoading = false;
        })
        .catch(function (error) {
          toastr.error(error.message);
        });
    };

    $scope.refresh = function () {
      $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, entity) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          entity: function () {
            $scope.revisaoContrato = entity;
            $scope.revisaoContrato.contratoExterno = $scope.contratoExterno;
            return entity;
          },
          self: function () {
            return self;
          },
          title: function () {
            return title;
          },
        },
        scope: $scope,
        controller: "ModalController",
      });
    };
  });

angular.module('bentham').factory('RevisaoContrato', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'revisoes-contratos/:id', { id: '@id', }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'revisoes-contratos/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'revisoes-contratos',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'revisoes-contratos/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        }
    });
});

angular.module('bentham').factory('RevisaoContratoService', function (RevisaoContrato, GenericService, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new RevisaoContrato();
    Object.setPrototypeOf(self.resource, RevisaoContrato);

    self.converte = function (data) {
        if (data.data != null)
            data.data = self.converteData(data.data);
        delete data.contratoExterno.centroDeCusto;
        delete data.contratoExterno.responsavelCliente;
        delete data.contratoExterno.responsavelEmpresa;
        delete data.contratoExterno.funcionarios;
        delete data.contratoExterno.perspectiva;
        delete data.contratoExterno.indiceDeReajuste;
        return data;
    };

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        if (data.data != null)
            data.data = self.converteData(data.data);
        delete data.contratoExterno.centroDeCusto;
        delete data.contratoExterno.responsavelCliente;
        delete data.contratoExterno.responsavelEmpresa;
        delete data.contratoExterno.funcionarios;
        delete data.contratoExterno.perspectiva;
        delete data.contratoExterno.indiceDeReajuste;
        deferred.resolve(data);
        return deferred.promise
    };

    return function () { return self; };
});
angular
  .module("bentham.pages.contratos.contratosinternos")
  .controller("RevisaoContratoInternoCtrl", function (
    $scope,
    RevisaoContratoInterno,
    RevisaoContratoInternoService,
    ContratoInternoService,
    CentroDeCustoService,
    GenericController,
    $stateParams,
    $uibModal,
    toastr,
    ArquivoService
  ) {

    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new RevisaoContratoInternoService();
    self.contratoInternoService = new ContratoInternoService();
    self.centroDeCustoService = new CentroDeCustoService();
    self.arquivoService = new ArquivoService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    $scope.centroDeCusto = {};
    $scope.contrato = {};

    self.clear = function clear() {
      $scope.revisaoContrato = new RevisaoContratoInterno();
      $scope.revisaoContrato.valor = 0
      $scope.revisaoContrato.valorTotal = 0
      $scope.revisaoContrato.prazo = 0
      $scope.revisaoContrato.vigencia = 0
      $scope.revisaoContrato.contratoInterno = $scope.contratoInterno;
      $scope.isLoading = false;
    };

    $scope.clear = function () {
      self.clear();
    };

    $scope.clear = function () {
      $scope.revisaoContrato.valor = 0
      $scope.revisaoContrato.valorTotal = 0
      $scope.revisaoContrato.prazo = 0
      $scope.revisaoContrato.vigencia = 0
    };

    $scope.back = function () {
      self.clear();
    };

    self.activate = function () {
      $scope.isLoading = true;
      var find = function (revisaoContratoId) {
        self
          .find(revisaoContratoId)
          .then(function (data) {
            $scope.revisaoContrato = data;
            $scope.revisaoContrato.contratoInterno = $scope.contratoInterno;
            $scope.isLoading = false;
          })
          .catch(function (error) { toastr.error(error.message); });
      };
      if ($stateParams.contratoId != null) {
        self.contratoInternoService
          .find($stateParams.contratoId)
          .then(function (data) {
            $scope.contratoInterno = data;
            $scope.centroDeCusto = $scope.contratoInterno.centroCusto;
            if ($stateParams.revisaoContratoId)
              find($stateParams.revisaoContratoId);
            else self.clear();
          });
      }
      if ($stateParams.revisaoContratoId) find($stateParams.revisaoContratoId);
      else self.clear();
    };

    self.activate();

    $scope.load = function load(tableState) {
      self.initTableState(tableState, "data");
      $scope.isLoading = true;
      if ($stateParams.contratoId)
        tableState.search.contratoInternoId = $stateParams.contratoId;
      self.service
        .getPage(
          tableState.page,
          tableState.pagination.number,
          tableState.sort.predicate,
          tableState.sort.sortOrder,
          tableState.search
        )
        .then(function (result) {
          $scope.displayed = result.content;
          self.updateTableState(result);
          $scope.isLoading = false;
        })
        .catch(function (error) {
          toastr.error(error.message);
        });
    };

    $scope.refresh = function () {
      $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, entity) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          entity: function () {
            $scope.revisaoContrato = entity;
            $scope.revisaoContrato.contratoInterno = $scope.contratoInterno;
            delete $scope.revisaoContrato.contratoInterno.centroDeCusto;
            delete $scope.revisaoContrato.contratoInterno.responsavelCliente;
            delete $scope.revisaoContrato.contratoInterno.responsavelEmpresa;
            delete $scope.revisaoContrato.contratoInterno.perspectiva;
            return entity;
          },
          self: function () {
            return self;
          },
          title: function () {
            return title;
          },
        },
        scope: $scope,
        controller: "ModalController",
      });
    };
  });

angular.module('bentham').factory('RevisaoContratoInterno', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'revisoes-contratos-internos/:id', { id: '@id', }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'revisoes-contratos-internos/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'revisoes-contratos-internos',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'revisoes-contratos-internos/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        }
    });
});

angular.module('bentham').factory('RevisaoContratoInternoService', function (RevisaoContratoInterno, GenericService, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new RevisaoContratoInterno();
    Object.setPrototypeOf(self.resource, RevisaoContratoInterno);

    self.converte = function (data) {
        if (data.data != null)
            data.data = self.converteData(data.data);
        delete data.contratoInterno.centroDeCusto;
        delete data.contratoInterno.responsavelCliente;
        delete data.contratoInterno.responsavelEmpresa;
        delete data.contratoInterno.perspectiva;
        delete data.contratoInterno.indiceDeReajuste;
        return data;
    };

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        if (data.data != null)
            data.data = self.converteData(data.data);
        delete data.contratoInterno.centroDeCusto;
        delete data.contratoInterno.responsavelCliente;
        delete data.contratoInterno.responsavelEmpresa;
        delete data.contratoInterno.perspectiva;
        delete data.contratoInterno.indiceDeReajuste;
        deferred.resolve(data);
        return deferred.promise
    };

    return function () { return self; };
});
angular.module('bentham.pages.dashboard').controller('ApresentadasDashBoardCtrl', function ($scope, Perspectiva, TipoLicitacao, PerspectivaDashBoardService, ChartService, GenericController, PerspectivaService, toastr, AuthService) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  self.service = new PerspectivaService();

  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;
  $scope.authService = AuthService;

  self.clear = function clear() {
    $scope.perspectivasUl = new Perspectiva();
    $scope.perspectiva = new Perspectiva();
    $scope.perspectiva.contratoGerado = false;
    $scope.parceiros = [];
    $scope.perspectiva.tiposServicos = [];
    $scope.perspectiva.subAreas = [];
    $scope.isLoading = false;
    $scope.filtro = {subAreas:[], tiposServicos:[], criteriosJulgamentos:[], visao:"quantidade", situacaoPerspectivaCodigo:"APRESENTADA", visao:"quantidade", sort:'dataApresentacao,DESC'}
    //dataInicioApresentacao: new Date(new Date().getFullYear() - 1, new Date().getMonth() + 1, 1, 8, 0, 0), dataFimApresentacao: new Date(new Date().getFullYear() , new Date().getMonth() + 1, 1, 15, 0, 0) };    
  };
  self.clear();

  $scope.clear = function () { self.clear(); }

  var error = function (erro) { console.log(erro); $scope.isLoading = false; };

  var perspectivaChart = function (graphic) {
    var type = 'currency'
    if($scope.filtro.visao=='quantidade') type = 'number';
    $scope.perspectivaChart = self.chartService.convertMultiChart(graphic, type);
    $scope.perspectivaChart.colors = ['#4dff4d','#33ccff', '#ffff4d', '#ff0000'];
    $scope.isLoading = false;
  };

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);

    filtro.autor != null ? filtro.responsavel = filtro.autor.id : null;
    filtro.pais != null ? filtro.pais = filtro.pais.id : null;
    filtro.regiao != null ? filtro.regiao = filtro.regiao.name : null;
    filtro.regiaoAtuacao != null ? filtro.regiaoAtuacao = filtro.regiaoAtuacao.id : null;
    filtro.tipoPerspectiva != null ? filtro.tipoPerspectiva = filtro.tipoPerspectiva.id : null;
    filtro.fonteDeRecurso != null ? filtro.fonteDeRecurso = filtro.fonteDeRecurso.id : null;

    filtro.cliente != null ? filtro.cliente = filtro.cliente.id : null;
    filtro.parceiro != null ? filtro.parceiro = filtro.parceiro.id : null;

    filtro.area != null ? filtro.area = filtro.area.id : null;

    filtro.tipoServico != null ? filtro.tipoServico = filtro.tipoServico.id : null;
    filtro.subArea != null ? filtro.subArea = filtro.subArea.id : null;
    filtro.criterioJulgamento != null ? filtro.criterioJulgamento = filtro.criterioJulgamento.id : null;

    for(var i = 0; i< filtro.tiposServicos.length; i++)
      filtro.tiposServicos[i] = filtro.tiposServicos[i].id;
    for(var i = 0; i< filtro.subAreas.length; i++)
      filtro.subAreas[i] = filtro.subAreas[i].id;
    for(var i = 0; i< filtro.criteriosJulgamentos.length; i++)
      filtro.criteriosJulgamentos[i] = filtro.criteriosJulgamentos[i].id;

    filtro.tipoLicitacao != null ? filtro.tipoLicitacao = filtro.tipoLicitacao.id : null;

    filtro.agrupador != null ? filtro.agrupador = filtro.agrupador.name : null;
    filtro.tempo != null ? filtro.tempo = filtro.tempo.name : null;
    filtro.ordenacao != null ? filtro.ordenacao = filtro.ordenacao.name : null;

    if (filtro.dataInicioApresentacao != null)
      filtro.dataInicioApresentacao = moment(filtro.dataInicioApresentacao, "YYYY-MM-DD").format("YYYY-MM-DD");

    if (filtro.dataFimApresentacao != null)
      filtro.dataFimApresentacao = moment(filtro.dataFimApresentacao, "YYYY-MM-DD").format("YYYY-MM-DD");

    if (filtro.inicioPrevisaoContratacao != null)
      filtro.inicioPrevisaoContratacao = moment(filtro.inicioPrevisaoContratacao, "YYYY-MM-DD").format("YYYY-MM-DD");

    if (filtro.fimPrevisaoContratacao != null)
      filtro.fimPrevisaoContratacao = moment(filtro.fimPrevisaoContratacao, "YYYY-MM-DD").format("YYYY-MM-DD");

    for (var prop in filtro)
      if (!filtro[prop])
        delete filtro[prop];

    self.tableState.search = filtro;
    $scope.buildCharts(filtro);
    $scope.load(self.tableState);
    // $scope.load(filtro);
  };

  $scope.buildCharts = function (filtro) {
    $scope.isLoading = true;
    self.chartService = new ChartService();
    self.perspectivaDashService = new PerspectivaDashBoardService();
    self.perspectivaDashService.getPerspectivaChart(filtro).then(perspectivaChart).catch(error);
    // self.perspectivaDashService.getExecucaoOrcamentariaChart(data.id).then(chartExecucaoOrcamentaria).catch(error);
  };

  $scope.load = function load(tableState) {
    $scope.isLoading = true;
    self.initTableState(tableState, 'dataApresentacao', 'DESC');
    if (!tableState.search.visao)
      $scope.search();
    $scope.perspectivas = [];
    TipoLicitacao.all().$promise.then(function (data) {
      if($scope.perspectivas.length==0){
        data.forEach(function (tipoLicitacao) {
          if($scope.filtro.tipoLicitacao == null || $scope.filtro.tipoLicitacao.id == tipoLicitacao.id){
            var searchPerspectivasSection = Object.assign({}, tableState.search)
            searchPerspectivasSection.tipoLicitacao = tipoLicitacao.id
            Perspectiva.all(searchPerspectivasSection).$promise.then(function (data) {
              $scope.perspectivas.push({
                  sigla: tipoLicitacao.sigla,
                  data: data
              });  
            })
          }
        });
      }
    });
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.perspectivasUl = result.content;
        self.updateTableState(result);
        $scope.isLoading = false;
      })
      .catch(function (error) { toastr.error(error.message);});
  };

  $scope.active = function () {
    $scope.clear();
    $scope.search();
  }
  $scope.active();

  // $scope.refresh = function () {
  //     $scope.load(self.tableState);
  // };

  // $scope.onSituacaoPerspectivaBlur = function (situacao) {
  //     $scope.active(situacao);
  // }

});
angular.module('bentham').factory('ApresentadasDashBoard', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'perspectiva-chart/:id', { id: '@id', }, {
        getPerspectivaChart: {
            method: 'GET',
            url: prefixRoute + 'perspectiva-chart/execucao',
        },
    });
});

angular.module('bentham').factory('ApresentadasDashBoardService', function (GenericService, ApresentadasDashBoard, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ApresentadasDashBoard();
    Object.setPrototypeOf(self.resource, ApresentadasDashBoard);

    self.getPerspectivaChart = function (filtro) {
        var deferred = $q.defer();
        filtro['tiposServicos[]'] = filtro.tiposServicos;
        delete filtro.tiposServicos;
        var fn = function () {
            self.resource.getPerspectivaChart(filtro,
                function success(contrato) { deferred.resolve(contrato); },
                function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () { return self; };
});
angular.module('bentham.pages.dashboard').controller('AtuacaoJuridicaPerspectivaDashboardCtrl', function ($scope, GenericController, SolicitacaoJuridicoPerspectivaService, toastr, AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new SolicitacaoJuridicoPerspectivaService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.authService = AuthService;
    $scope.isLoading = false;

    self.clear = function clear() {
      $scope.isLoading = false;
      self.tableState.sort= { predicate : "dataSolicitacao" };
      $scope.filter = {} 
    };
    self.clear();

    $scope.clear = function () { self.clear(); }

    $scope.search = function () {
        var filter = angular.copy($scope.filter);

        filter.tipoAcaoJuridico ? filter.tipoAcaoJuridico = filter.tipoAcaoJuridico.name : null;
        filter.statusRespostaJuridico ? filter.statusRespostaJuridico = filter.statusRespostaJuridico.name : null;
        filter.dataSolicitacaoInicio ? filter.dataSolicitacaoInicio = moment(filter.dataSolicitacaoInicio, "YYYY-MM-DD").format("YYYY-MM-DD") : null;
        filter.dataSolicitacaoFim ? filter.dataSolicitacaoFim = moment(filter.dataSolicitacaoFim, "YYYY-MM-DD").format("YYYY-MM-DD") : null;
        filter.responsavel ? filter.responsavel = filter.responsavel.id : null;

        // for (var prop in filter) 
        //     if (!filter[prop])
        //         delete filter[prop];

        self.tableState.search = filter;
        $scope.load(self.tableState);
    };

    $scope.load = function load(tableState) {
      $scope.isLoading = true;
      self.initTableState(tableState, 'dataSolicitacao');
      self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
          .then(function (result) {
            $scope.solicitacoesJuridico = result.content;
            self.updateTableState(result);
            $scope.isLoading = false;
          })
          .catch(function (error) { toastr.error(error.message);});
    };

    $scope.active = function () {
      $scope.clear(); 
      $scope.search();            
    }
    $scope.active();
    
});
angular.module('bentham').factory('AtuacaoJuridicaPerspectivaDashBoard', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'atuacao-juridica-perspectiva-chart/:id', { id: '@id', }, {
        getPerspectivaChart: {
            method: 'GET',
            url: prefixRoute + 'atuacao-juridica-perspectiva-chart/execucao',
        },
    });
});

angular.module('bentham').factory('AtuacaoJuridicaPerspectivaDashBoardService', function (GenericService, AtuacaoJuridicaPerspectivaDashBoard, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new AtuacaoJuridicaPerspectivaDashBoard();
    Object.setPrototypeOf(self.resource, AtuacaoJuridicaPerspectivaDashBoard);

    return function () { return self; };
});
angular.module('bentham').factory('ContratoDashBoard', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'contratos-externos/:id', { id: '@id', }, {
        getSChart: {
            method: 'GET',
            url: prefixRoute + 'contrato-charts/curva-s',
        },getAvancoTemporalPieChart: {
            method: 'GET',
            url: prefixRoute + 'contrato-charts/avanco-temporal',
        },getAvancoFisicoPieChart: {
            method: 'GET',
            url: prefixRoute + 'contrato-charts/avanco-fisico',
        },getAvancoFinanceiroPieChart: {
            method: 'GET',
            url: prefixRoute + 'contrato-charts/avanco-financeiro',
        },getExecucaoOrcamentariaChart: {
            method: 'GET',
            url: prefixRoute + 'contrato-charts/execucao-orcamentaria',
        }
    });
});

angular.module('bentham').factory('ContratoDashBoardService', function (GenericService, ContratoDashBoard, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ContratoDashBoard();
    Object.setPrototypeOf(self.resource, ContratoDashBoard);

    self.getSChart = function (id) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getSChart({ id: id },
                function success(contrato) { deferred.resolve(contrato); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getAvancoTemporalPieChart = function (id) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getAvancoTemporalPieChart({ id: id },
                function success(contrato) { deferred.resolve(contrato); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getAvancoFisicoPieChart = function (id) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getAvancoFisicoPieChart({ id: id },
                function success(contrato) { deferred.resolve(contrato); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getAvancoFinanceiroPieChart = function (id) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getAvancoFinanceiroPieChart({ id: id },
                function success(contrato) { deferred.resolve(contrato); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getExecucaoOrcamentariaChart = function (id) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getExecucaoOrcamentariaChart({ id: id },
                function success(contrato) { deferred.resolve(contrato); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () { return self; };
});
angular.module('bentham').controller('ContratoDashboardCtrl', function ($scope, ChartService, ContratoDashBoardService, FinanceiroDashBoardService, GenericController, $rootScope) {
    self = this;
    Object.setPrototypeOf(self, GenericController);
    $scope.contrato = null;

    // var numeral = require('numeral');

    $scope.init = function () {
        if ($rootScope.contrato) {
            $scope.contrato = $rootScope.contrato;
            $scope.buildCharts($rootScope.contrato);
        }
    };

    $scope.$on("sendContrato", function (evt, data) {
        $scope.contrato = data;
        $scope.buildCharts(data);
    });

    var error = function (error) { console.log(error.message); $scope.isLoading = false; };

    var chartExecucaoOrcamentaria = function (graphic) {
        $scope.barOrcamentaria = self.chartService.convertBarChart(graphic, 'currency');
        self.contratoDashService.getAvancoTemporalPieChart($scope.contrato.id).then(chartAvancoTemporal).catch(error);
    };

    var chartAvancoFinanceiro = function (graphic) {
        $scope.pieFinanciero = self.chartService.convertPieChart(graphic, 'currency');
        self.contratoDashService.getSChart($scope.contrato.id).then(chartS).catch(error);
    };

    var chartAvancoTemporal = function (graphic) {
        $scope.pieTemporal = self.chartService.convertPieChart(graphic);
        self.contratoDashService.getAvancoFinanceiroPieChart($scope.contrato.id).then(chartAvancoFinanceiro).catch(error);
    };

    var chartS = function (graphic) {
        $scope.Schart = self.chartService.convertMultiChart(graphic, 'currency');
        $scope.Schart.colors = [ '#4dff4d','#4dff4d', '#33ccff', '#33ccff', '#F0F100', '#F0F100', '#DF4C00', '#DF4C00', '#ff0000', '#ff0000' ],
        $scope.isLoading = false;
    };

    var produtoChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.produtoChart = self.chartService.convertMultiChart(graphic, 'currency');
        $scope.produtoChart.colors = ['#33ccff', '#33ccff', '#DF4C00', '#DF4C00', '#EB8500', '#EB8500', '#4dff4d','#4dff4d' ];
        $scope.loading = false;
    };

    var resultadoEconomicoChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.resultadoEconomicoChart = self.chartService.convertMultiChart(graphic, 'currency');
        $scope.resultadoEconomicoChart.colors = ['#33ccff', '#33ccff', '#DF4C00', '#DF4C00', '#EB8500', '#EB8500', '#4dff4d','#4dff4d' ];
        $scope.loading = false;
    };

    var faturamentoChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.faturamentoChart = self.chartService.convertMultiChart(graphic, 'currency');
        $scope.faturamentoChart.colors = ['#33ccff', '#33ccff', '#DF4C00', '#DF4C00', '#EB8500', '#EB8500', '#4dff4d','#4dff4d' ],
        $scope.loading = false;
    };

    var contaReceberChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.contaReceberChart = self.chartService.convertMultiChart(graphic, 'currency');
        //$scope.loading = false;
    };

    $scope.buildCharts = function (contrato) {
        $scope.isLoading = true;
        $scope.produtoChart = null;
        $scope.resultadoEconomicoChart = null;
        $scope.faturamentoChart = null;
        $scope.contaReceberChart = null;
        var filtro = {};
        filtro.centroDeCusto = contrato.centroCusto.id;
        filtro.inicio = new Date(contrato.dataInicioVigencia)
        filtro.inicio.setMonth(filtro.inicio.getMonth()-1);
        filtro.fim = new Date(contrato.dataFimVigencia);
        filtro.fim.setMonth(filtro.fim.getMonth()+1);

        self.contratoDashService = new ContratoDashBoardService();
        self.financeiroDashService = new FinanceiroDashBoardService();
        self.chartService = new ChartService();
        self.contratoDashService.getExecucaoOrcamentariaChart(contrato.id).then(chartExecucaoOrcamentaria).catch(error);
        self.financeiroDashService.getProdutoChart(filtro).then(produtoChart).catch(error);
        self.financeiroDashService.getFaturamentoChart(filtro).then(faturamentoChart).catch(error);
        self.financeiroDashService.getContaReceberChart(filtro).then(contaReceberChart).catch(error);
        filtro.codigo = '1'
        self.financeiroDashService.getResultadoEconomicoChart(filtro).then(resultadoEconomicoChart).catch(error);
    };
});
angular.module('bentham').factory('FinanceiroDashBoard', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'financeiro-chart/:id', { id: '@id', }, {
        getContratoChart: {
            method: 'GET',
            url: prefixRoute + 'financeiro-chart/contrato',
        },
        getProdutoChart: {
            method: 'GET',
            url: prefixRoute + 'financeiro-chart/produtos',
        },
        getContaReceberChart: {
            method: 'GET',
            url: prefixRoute + 'financeiro-chart/contas-receber',
        },
        getDespesasChart: {
            method: 'GET',
            url: prefixRoute + 'financeiro-chart/despesas',
        },
        getFaturamentoChart: {
            method: 'GET',
            url: prefixRoute + 'financeiro-chart/faturamento',
        },
        getFaturamentoGlobalChart: {
            method: 'GET',
            url: prefixRoute + 'financeiro-chart/faturamento-global',
        },
        getResultadoEconomicoChart: {
            method: 'GET',
            url: prefixRoute + 'financeiro-chart/resultado-economico',
        },
    });
});

angular.module('bentham').factory('FinanceiroDashBoardService', function (GenericService, FinanceiroDashBoard, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new FinanceiroDashBoard();
    Object.setPrototypeOf(self.resource, FinanceiroDashBoard);

    self.getContratoChart = function (filtro) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getContratoChart(filtro,
                function success(contrato) { deferred.resolve(contrato); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getProdutoChart = function (filtro) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getProdutoChart(filtro,
                function success(produto) { deferred.resolve(produto); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getContaReceberChart = function (filtro) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getContaReceberChart(filtro,
                function success(contrato) { deferred.resolve(contrato); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getDespesasChart = function (filtro) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getDespesasChart(filtro,
                function success(contrato) { deferred.resolve(contrato); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getFaturamentoChart = function (filtro) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getFaturamentoChart(filtro,
                function success(contrato) { deferred.resolve(contrato); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getFaturamentoGlobalChart = function (filtro) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getFaturamentoGlobalChart(filtro,
                function success(contrato) { deferred.resolve(contrato); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getResultadoEconomicoChart = function (filtro) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getResultadoEconomicoChart(filtro,
                function success(contrato) { deferred.resolve(contrato); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }


    return function () { return self; };
});
angular.module('bentham').controller('FinanceiroDashboardCtrl', function ($scope, Row, RowService, TaskService, ChartService, FinanceiroDashBoardService, GenericController, $rootScope) {
    self = this;
    Object.setPrototypeOf(self, GenericController);
    self.rowService = new RowService();
    self.taskService = new TaskService();
    self.chartService = new ChartService();
    $scope.loading = true;
    $scope.rows = []; 
    $scope.columns = ['status', 'name', 'responsavel', /*'prazo', 'valorEmpresa' */];

    $scope.init = function () {
        if ($rootScope.contrato) {
            $scope.clear(); 
            $scope.filtro.centroDeCusto = $rootScope.contrato.centroDeCusto;
            $scope.search();
        }
    };

    $scope.$on("sendContrato", function (evt, data) {
        $scope.loading = true;
        $scope.clear(); 
        if(data)
            $scope.filtro.centroDeCusto = data.centroDeCusto;
        $scope.search();            
        $scope.loading = false;
    });
    
    var converte = function(data){
        self.rowService = new RowService();
        self.taskService = new TaskService();
        data.forEach(function (row) {
            row = self.rowService.converte(row);
            row.tasks.forEach(function (task) { task = self.taskService.converte(task); });
        });
        $scope.rows = data;
        $scope.loading = false;
    };

    var error = function (erro) { console.log(erro); $scope.loading = false; };

    var contratoChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.contratoChart = self.chartService.convertMultiChart(graphic, 'currency');
        $scope.contratoChart.colors = ['#4dff4d','#33ccff', '#ffff4d', '#ff0000'];
        $scope.loading = false;
    };

    var produtoChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.produtoChart = self.chartService.convertMultiChart(graphic, 'currency');
        $scope.produtoChart.colors = ['#33ccff', '#33ccff', '#DF4C00', '#DF4C00', '#EB8500', '#EB8500', '#4dff4d','#4dff4d' ];
        $scope.loading = false;
    };

    var resultadoEconomicoChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.resultadoEconomicoChart = self.chartService.convertMultiChart(graphic, 'currency');
        $scope.resultadoEconomicoChart.colors = ['#33ccff', '#33ccff', '#DF4C00', '#DF4C00', '#EB8500', '#EB8500', '#4dff4d','#4dff4d' ];
        $scope.loading = false;
    };

    var faturamentoChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.faturamentoChart = self.chartService.convertMultiChart(graphic, 'currency');
        $scope.faturamentoChart.colors = ['#33ccff', '#33ccff', '#DF4C00', '#DF4C00', '#EB8500', '#EB8500', '#4dff4d','#4dff4d' ],
        $scope.loading = false;
    };

    var faturamentoGlobalChart = function (graphic) {
        self.chartService = new ChartService();
        graphic.labels = "";
        $scope.faturamentoGlobalChart = self.chartService.convertBarChart(graphic, 'currency');
        $scope.loading = false;
    };

    var contaReceberChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.contaReceberChart = self.chartService.convertMultiChart(graphic, 'currency');
        $scope.loading = false;
    };

    var despesasChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.despesasChart = self.chartService.convertMultiChart(graphic, 'currency');
        $scope.despesasChart.colors = ['#33ccff', '#33ccff', '#DF4C00', '#DF4C00', '#EB8500', '#EB8500', '#4dff4d','#4dff4d' ];
        $scope.loading = false;
    };


    $scope.clear = function () {
        $scope.filtro = { tipo: 'contaReceber', inicio: new Date(new Date().getFullYear() - 1, new Date().getMonth() + 1, 1, 8, 0, 0), fim: new Date(new Date().getFullYear() , new Date().getMonth() + 1, 1, 15, 0, 0), visao: "valor"};
    }

    // Reload data action
    $scope.load = function (filtro) {
        $scope.loading = true;
        $scope.tipo = filtro.tipo;
        filtro.tipo = null;
        if($scope.tipo == 'contrato')
            Row.findAll(filtro,converte, error);
        else if($scope.tipo == 'produto')
            Row.findAllProduto(filtro,converte, error);
        else if($scope.tipo == 'economico'){
            if(filtro.tipoContaReceber=='PADRAO')
                filtro.codigo = '1.1'
            else if(filtro.tipoContaReceber=='REAJUSTE')
                filtro.codigo = '1.2'
            else
                filtro.codigo = '1'
            Row.findAllPrevisto(filtro,converte, error);
        }else if($scope.tipo == 'medicao')
            Row.findAllMedicao(filtro,converte, error);
        else if($scope.tipo == 'contaReceber')
            Row.findAllContaReceber(filtro,converte, error);
        $scope.loading = false;
    };

    $scope.buildCharts = function (filtro) {
        $scope.loading = true;
        self.financeiroDashService = new FinanceiroDashBoardService();
        $scope.contratoChart = null;
        $scope.produtoChart = null;
        $scope.resultadoEconomicoChart = null;
        $scope.faturamentoChart = null;
        $scope.contaReceberChart = null;
        if($scope.tipo == 'contrato')
            self.financeiroDashService.getContratoChart(filtro).then(contratoChart).catch(error);
        if($scope.tipo == 'produto')
            self.financeiroDashService.getProdutoChart(filtro).then(produtoChart).catch(error);
        if($scope.tipo == 'economico')
            self.financeiroDashService.getResultadoEconomicoChart(filtro).then(resultadoEconomicoChart).catch(error);
        if($scope.tipo == 'contaReceber')
            self.financeiroDashService.getFaturamentoChart(filtro).then(faturamentoChart).catch(error);
        // if($scope.tipo == 'economico' || $scope.tipo == 'medicao' || $scope.tipo == 'produto' || $scope.tipo == 'contaReceber')
        self.financeiroDashService.getDespesasChart(filtro).then(despesasChart).catch(error);
        self.financeiroDashService.getContaReceberChart(filtro).then(contaReceberChart).catch(error);
        // self.financeiroDashService.getFaturamentoGlobalChart(filtro).then(faturamentoGlobalChart).catch(error);
    };

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        $scope.filtro.agrupador != null && $scope.filtro.agrupador != undefined ? filtro.agrupador = filtro.agrupador.name : null;
        $scope.filtro.ordenacao != null && $scope.filtro.ordenacao != undefined ? filtro.ordenacao = filtro.ordenacao.name : null;
        $scope.filtro.regiao != null && $scope.filtro.regiao != undefined ? filtro.regiao = filtro.regiao.name : null;
        $scope.filtro.responsavel != null && $scope.filtro.responsavel != undefined ? filtro.responsavel = filtro.responsavel.id : null;
        $scope.filtro.centroDeCusto != null && $scope.filtro.centroDeCusto != undefined ? filtro.centroDeCusto = filtro.centroDeCusto.id : null;
        filtro.tipoContaReceber != null && filtro.tipoContaReceber != undefined ? filtro.tipoContaReceber = filtro.tipoContaReceber.name : null;
        filtro.agrupador != null ? filtro.agrupador = filtro.agrupador.name : null;
        filtro.tempo != null ? filtro.tempo = filtro.tempo.name : null;
        filtro.ordenacao != null ? filtro.ordenacao = filtro.ordenacao.name : null;
        if ($scope.filtro.inicio != null)
            filtro.inicio = moment($scope.filtro.inicio, "YYYY-MM-DD").format("YYYY-MM-DD");
        if ($scope.filtro.fim != null)
            filtro.fim = moment($scope.filtro.fim, "YYYY-MM-DD").format("YYYY-MM-DD");
        if ($scope.aberto == true)
            filtro.search = null;
            $scope.load(filtro);
            $scope.buildCharts(filtro);
    };
});
angular.module('bentham.pages.dashboard.indicador').controller('DashboardChartCtrl', function ($scope, ChartService, DashboardService, Dashboard, GenericController, $rootScope, $stateParams) {
    self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new DashboardService();
    self.chartService = new ChartService();
    $scope.contrato = null;

    var error = function (error) { console.log(error.message); $scope.isLoading = false; };

    self.clear = function clear() {
        $scope.dashboard = new Dashboard();
        $scope.filtro = {};
    };

    self.activate = function () {
        $scope.isLoading = true;
        $scope.charts = []
        var chartService = new ChartService();
        self.service.getCharts()
            .then(function(charts){
                angular.forEach(charts, function(value, key){
                    $scope.charts.push(chartService.convertMultiChart(value, 'number'));
                });
                $scope.isLoading = false;
            }).catch(error);
        if ($stateParams.dashboardId) {
        self.find($stateParams.dashboardId)
            .then(function (data) {
            $scope.dashboard = data;
            $scope.isLoading = false;
            })
        } else {
            self.clear();
            $scope.isLoading = false;
        }
    }

    self.activate();

    $scope.clear = function () {
        self.clear();
    };

    $scope.load = function load() {

    };

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
            entity: function () {
            $scope.dashboard = entity;
            return entity;
            },
            self: function () {
            return self;
            },
            title: function () {
            return title;
            }
        },
        scope: $scope,
        controller: 'ModalController'
        });
    };

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        filtro.departamento != null ? filtro.departamento = filtro.departamento.id : null;
        filtro.contratoExterno != null ? filtro.contratoExterno = filtro.contratoExterno.id : null;
        if ($scope.aberto == true)
        filtro.search = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };

    $scope.clear = function () {
        self.clear();
    };
    
});
angular.module('bentham.pages.dashboard').controller('PerspectivaDashboardCtrl', function ($scope, Perspectiva, TipoLicitacao, PerspectivaDashBoardService, ChartService, GenericController, PerspectivaService, toastr, AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new PerspectivaService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.authService = AuthService;

    self.clear = function clear() {
        $scope.perspectivasUl = new Perspectiva();
        $scope.perspectiva = new Perspectiva();
        $scope.perspectiva.contratoGerado = false;
        $scope.parceiros = [];
        $scope.perspectiva.tiposServicos = [];
        $scope.perspectiva.subAreas = [];
        $scope.isLoading = false;
        $scope.filtro = {subAreas:[], tiposServicos:[], criteriosJulgamentos:[], visao: "quantidade", situacaoPerspectivaCodigo : "ELABORACAO", visao: "quantidade"} 
        //dataInicioApresentacao: new Date(new Date().getFullYear() - 1, new Date().getMonth() + 1, 1, 8, 0, 0), dataFimApresentacao: new Date(new Date().getFullYear() , new Date().getMonth() + 1, 1, 15, 0, 0) };    
    };
    self.clear();

    $scope.clear = function () { self.clear(); }

    var error = function (erro) { console.log(erro); $scope.isLoading = false; };

    var perspectivaChart = function (graphic) {
        var type = 'currency'
        if($scope.filtro.visao=='quantidade') type = 'number';
        $scope.perspectivaChart = self.chartService.convertMultiChart(graphic, type);
        $scope.perspectivaChart.colors = ['#4dff4d','#33ccff', '#ffff4d', '#ff0000'];
        $scope.isLoading = false;
    };

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);

        filtro.autor != null ? filtro.responsavel = filtro.autor.id : null;
        filtro.pais != null ? filtro.pais = filtro.pais.id : null;
        filtro.regiao != null ? filtro.regiao = filtro.regiao.name : null;
        filtro.regiaoAtuacao != null ? filtro.regiaoAtuacao = filtro.regiaoAtuacao.id : null;
        filtro.tipoPerspectiva != null ? filtro.tipoPerspectiva = filtro.tipoPerspectiva.id : null;
        filtro.fonteDeRecurso != null ? filtro.fonteDeRecurso = filtro.fonteDeRecurso.id : null;

        filtro.cliente != null ? filtro.cliente = filtro.cliente.id : null;
        filtro.parceiro != null ? filtro.parceiro = filtro.parceiro.id : null;

        filtro.area != null ? filtro.area = filtro.area.id : null;
        
        filtro.tipoServico != null ? filtro.tipoServico = filtro.tipoServico.id : null;
        filtro.subArea != null ? filtro.subArea = filtro.subArea.id : null;
        filtro.criterioJulgamento != null ? filtro.criterioJulgamento = filtro.criterioJulgamento.id : null;

        for(var i = 0; i< filtro.tiposServicos.length; i++)
            filtro.tiposServicos[i] = filtro.tiposServicos[i].id;
        for(var i = 0; i< filtro.subAreas.length; i++)
            filtro.subAreas[i] = filtro.subAreas[i].id;
        for(var i = 0; i< filtro.criteriosJulgamentos.length; i++)
            filtro.criteriosJulgamentos[i] = filtro.criteriosJulgamentos[i].id;

        filtro.tipoLicitacao != null ? filtro.tipoLicitacao = filtro.tipoLicitacao.id : null;

        filtro.agrupador != null ? filtro.agrupador = filtro.agrupador.name : null;
        filtro.tempo != null ? filtro.tempo = filtro.tempo.name : null;
        filtro.ordenacao != null ? filtro.ordenacao = filtro.ordenacao.name : null;

        if (filtro.dataInicioApresentacao != null)
            filtro.dataInicioApresentacao = moment(filtro.dataInicioApresentacao, "YYYY-MM-DD").format("YYYY-MM-DD");

        if (filtro.dataFimApresentacao != null)
            filtro.dataFimApresentacao = moment(filtro.dataFimApresentacao, "YYYY-MM-DD").format("YYYY-MM-DD");

        if (filtro.inicioPrevisaoContratacao != null)
            filtro.inicioPrevisaoContratacao = moment(filtro.inicioPrevisaoContratacao, "YYYY-MM-DD").format("YYYY-MM-DD");

        if (filtro.fimPrevisaoContratacao != null)
            filtro.fimPrevisaoContratacao = moment(filtro.fimPrevisaoContratacao, "YYYY-MM-DD").format("YYYY-MM-DD");

        for (var prop in filtro) 
            if (!filtro[prop])
                delete filtro[prop];

        self.tableState.search = filtro;
        $scope.buildCharts(filtro);
        $scope.load(self.tableState);
        // $scope.load(filtro);
    };

    $scope.buildCharts = function (filtro) {
        $scope.isLoading = true;
        self.chartService = new ChartService();
        self.perspectivaDashService = new PerspectivaDashBoardService();
        self.perspectivaDashService.getPerspectivaChart(filtro).then(perspectivaChart).catch(error);
        // self.perspectivaDashService.getExecucaoOrcamentariaChart(data.id).then(chartExecucaoOrcamentaria).catch(error);
    };

    $scope.load = function load(tableState) {
        $scope.isLoading = true;
        self.initTableState(tableState, 'codigo', 'DESC');
        if(!tableState.search.visao)
            $scope.search();
        $scope.perspectivas = [];
        TipoLicitacao.all().$promise.then(function (data) {
            if($scope.perspectivas.length==0)
                data.forEach(function (tipoLicitacao) {
                    if($scope.filtro.tipoLicitacao == null || $scope.filtro.tipoLicitacao.id == tipoLicitacao.id){
                      var searchPerspectivasSection = Object.assign({}, tableState.search)
                      searchPerspectivasSection.tipoLicitacao = tipoLicitacao.id
                      Perspectiva.all(searchPerspectivasSection).$promise.then(function (data) {
                        $scope.perspectivas.push({
                            sigla: tipoLicitacao.sigla,
                            data: data
                        });  
                      })
                    }
                });
        });
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) { $scope.perspectivasUl = result.content; self.updateTableState(result); $scope.isLoading = false; })
            .catch(function (error) { toastr.error(error.message);});
    };

    $scope.active = function () {
        $scope.clear(); 
        $scope.search();            
    }
    $scope.active();

    // $scope.refresh = function () {
    //     $scope.load(self.tableState);
    // };

    // $scope.onSituacaoPerspectivaBlur = function (situacao) {
    //     $scope.active(situacao);
    // }
    
});
angular.module('bentham').factory('PerspectivaDashBoard', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'perspectiva-chart/:id', { id: '@id', }, {
        getPerspectivaChart: {
            method: 'GET',
            url: prefixRoute + 'perspectiva-chart/execucao',
        },
    });
});

angular.module('bentham').factory('PerspectivaDashBoardService', function (GenericService, PerspectivaDashBoard, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new PerspectivaDashBoard();
    Object.setPrototypeOf(self.resource, PerspectivaDashBoard);

    self.getPerspectivaChart = function (filtro) {
        var deferred = $q.defer();
        filtro['tiposServicos[]'] = filtro.tiposServicos;
        delete filtro.tiposServicos;
        var fn = function () {
            self.resource.getPerspectivaChart(filtro,
                function success(contrato) { deferred.resolve(contrato); },
                function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () { return self; };
});
angular.module('bentham').factory('QualidadeDashBoard', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'financeiro-chart/:id', { id: '@id', }, {
        getAcaoChart: {
            method: 'GET',
            url: prefixRoute + 'financeiro-chart/acoes',
        },
        getNaoConformidadeChart: {
            method: 'GET',
            url: prefixRoute + 'financeiro-chart/nao-conformidades',
        },
    });
});

angular.module('bentham').factory('QualidadeDashBoardService', function (GenericService, QualidadeDashBoard, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new QualidadeDashBoard();
    Object.setPrototypeOf(self.resource, QualidadeDashBoard);

    self.getNaoConformidadeChart = function (filtro) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getNaoConformidadeChart(filtro,
                function success(data) { deferred.resolve(data); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getAcaoChart = function (filtro) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.getAcaoChart(filtro,
                function success(data) { deferred.resolve(data); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () { return self; };
});
angular.module('bentham').controller('QualidadeDashboardCtrl', function ($scope, Row, RowService, TaskService, ChartService, QualidadeDashBoardService, GenericController, $rootScope) {
    self = this;
    Object.setPrototypeOf(self, GenericController);
    self.rowService = new RowService();
    self.taskService = new TaskService();
    self.chartService = new ChartService();
    $scope.loading = true;
    $scope.rows = []; 
    $scope.columns = ['status', 'name', 'responsavel', /*'prazo', 'valorEmpresa' */];

    $scope.init = function () {
        if ($rootScope.contrato) {
            $scope.clear(); 
            $scope.filtro.centroDeCusto = $rootScope.contrato.centroDeCusto;
            $scope.search();
        }
    };

    $scope.$on("sendContrato", function (evt, data) {
        $scope.loading = true;
        $scope.clear(); 
        if(data)
            $scope.filtro.centroDeCusto = data.centroDeCusto;
        $scope.search();            
        $scope.loading = false;
    });
    
    var converte = function(data){
        self.rowService = new RowService();
        self.taskService = new TaskService();
        data.forEach(function (row) {
            row = self.rowService.converte(row);
            row.tasks.forEach(function (task) { task = self.taskService.converte(task); });
        });
        $scope.rows = data;
        $scope.loading = false;
    };

    var error = function (erro) { console.log(erro); $scope.loading = false; };

    var naoConformidadeChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.naoConformidadeChart = self.chartService.convertMultiChart(graphic, 'number');
        // $scope.naoConformidadeChart.colors = ['#4dff4d','#33ccff', '#ffff4d', '#ff0000'];
        //$scope.loading = false;
    };

    var acaoChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.acaoChart = self.chartService.convertMultiChart(graphic, 'number');
        // $scope.acaoChart.colors = ['#4dff4d','#33ccff', '#ffff4d', '#ff0000'];
        $scope.loading = false;
    };

    $scope.clear = function () {
        $scope.filtro = {};// tipo: 'acao', inicio: new Date(new Date().getFullYear() - 1, new Date().getMonth() + 1, 1, 8, 0, 0), fim: new Date(new Date().getFullYear() , new Date().getMonth() + 1, 1, 15, 0, 0), visao: "quantidade"};
    }

    // Reload data action
    $scope.load = function (filtro) {
        $scope.loading = true;
        $scope.tipo = filtro.tipo;
        filtro.tipo = null;
        if($scope.tipo == 'acao')
            Row.findAllAcao(filtro,converte, error);
        else if($scope.tipo == 'naoConformidade')
            Row.findAllNaoConformidade(filtro,converte, error);
        $scope.loading = false;
    };

    $scope.buildCharts = function (filtro) {
        $scope.loading = true;
        self.qualidadeDashService = new QualidadeDashBoardService();
        $scope.naoConformidadeChart = null;
        $scope.acaoChart = null;
        // if($scope.tipo == 'acao')
            self.qualidadeDashService.getAcaoChart(filtro).then(acaoChart).catch(error);
        // if($scope.tipo == 'naoConformidade')
            self.qualidadeDashService.getNaoConformidadeChart(filtro).then(naoConformidadeChart).catch(error);
    };

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);

        $scope.filtro.agrupador != null && $scope.filtro.agrupador != undefined ? filtro.agrupador = filtro.agrupador.name : null;
        $scope.filtro.ordenacao != null && $scope.filtro.ordenacao != undefined ? filtro.ordenacao = filtro.ordenacao.name : null;
        $scope.filtro.responsavel != null && $scope.filtro.responsavel != undefined ? filtro.responsavel = filtro.responsavel.id : null;

        filtro.departamento != null ? filtro.departamento = filtro.departamento.id : null;
        filtro.contratoExterno != null ? filtro.contratoExterno = filtro.contratoExterno.id : null;
        filtro.agrupador != null ? filtro.agrupador = filtro.agrupador.name : null;
        filtro.tempo != null ? filtro.tempo = filtro.tempo.name : null;
        filtro.ordenacao != null ? filtro.ordenacao = filtro.ordenacao.name : null;
        if ($scope.filtro.inicio != null)
            filtro.inicio = moment($scope.filtro.inicio, "YYYY-MM-DD").format("YYYY-MM-DD");
        if ($scope.filtro.fim != null)
            filtro.fim = moment($scope.filtro.fim, "YYYY-MM-DD").format("YYYY-MM-DD");
        if ($scope.aberto == true)
            filtro.search = null;
        $scope.buildCharts(filtro);
    };
});
angular.module('bentham.pages.financeiro.centroCusto').controller('CentroDeCustoCtrl', function ($scope, CentroDeCustoViewService, CentroDeCustoService, CentroDeCusto, GenericController, $uibModal, toastr, AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new CentroDeCustoService();
    self.serviceView = new CentroDeCustoViewService();
    $scope.authService = AuthService;

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

 
    self.clear = function clear() {
        $scope.filtro = {};
        $scope.centro = new CentroDeCusto();
        $scope.isLoading = false;
    };
    self.clear();

    $scope.clear = function () {
        self.clear();
    };
  
    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        $scope.filtro.tipoCentroCusto != null && $scope.filtro.tipoCentroCusto != undefined ? filtro.tipoCentroCusto = filtro.tipoCentroCusto.name : null;
        $scope.filtro.regiao != null && $scope.filtro.regiao != undefined ? filtro.regiao = filtro.regiao.name : null;
        $scope.filtro.responsavel != null && $scope.filtro.responsavel != undefined ? filtro.responsavel = filtro.responsavel.id : null;
        $scope.filtro.statusContrato != null && $scope.filtro.statusContrato != undefined ? filtro.statusContrato = filtro.statusContrato.name : null;
        if ($scope.aberto == true)
            filtro.search = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "anoDeCriacao","DESC");
        $scope.isLoading = true;
        self.serviceView.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.centro = entity;
                    return entity;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.isDayValid = function (day) {
        if(day == undefined) return false;

        var dayRange = day >= 1 && day <= 31;
        if (dayRange) return true;

        return false;
    };
});
angular.module('bentham').factory('CentroDeCusto', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'centro-de-custo/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'centro-de-custo/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'centro-de-custo/',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'centro-de-custo/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
            findAllByContractStatus: {
              method: 'GET',
              isArray: true,
              url: prefixRoute + 'centro-de-custo/find-all-by-contract-status/',
            },
        });
});

angular.module('bentham').factory('CentroDeCustoService', function (GenericService, CentroDeCusto, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new CentroDeCusto();
    Object.setPrototypeOf(self.resource, CentroDeCusto);
    return function () { return self; };
});
angular.module('bentham').factory('CentroDeCustoView', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'centro-de-custo-view/:id', {
        id: '@id',
    }, {
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'centro-de-custo-view/',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'centro-de-custo-view/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
        });
});

angular.module('bentham').factory('CentroDeCustoViewService', function (GenericService, CentroDeCustoView, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new CentroDeCustoView();
    Object.setPrototypeOf(self.resource, CentroDeCustoView);
    return function () { return self; };
});
angular.module('bentham.pages.financeiro.contareceber').controller('ContaReceberCtrl', function ($scope, DocumentoService, ContaReceberService, ContaReceber, toastr, GenericController, $state, $stateParams, $uibModal, CentroDeCustoService, MedicaoService, AuthService, $rootScope) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;

  self.service = new ContaReceberService();
  self.documentoService = new DocumentoService();
  self.medicaoService = new MedicaoService();
  self.centroDeCustoService = new CentroDeCustoService();

  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  $scope.cosp = 14;
  $scope.cosplan = 13;
  $scope.centroDeCusto = {};
  $scope.medicoes = [];
  $scope.medicao = {};

  self.clear = function clear() {
    $scope.contaReceber = new ContaReceber();
    $scope.centroDeCusto.id != null ? $scope.contaReceber.centroDeCusto = $scope.centroDeCusto: null;
    $scope.contaReceber.anexos = [];
    $scope.formato = false;
    $scope.filtro = {};
    // if($scope.contratoExterno)
    //     $scope.filtro.contratoExterno = $scope.contratoExterno;
    // else
    //     $scope.filtro.contratoExterno = $rootScope.contrato;
    // $scope.filtro.centroDeCusto =  $scope.filtro.contratoExterno ? $scope.filtro.contratoExterno.centroCusto : null;
    $scope.isLoading = false;
  };

  $scope.back = function () {
    if ($scope.centroDeCusto != null)
      $state.go("financeiro.contasreceber", { centroDeCusto: $scope.centroDeCusto.id })
    else
      $state.go("financeiro.contasreceber")
  };

  self.activate = function () {
    $scope.isLoading = true;
    var find = function (contaReceberId) {
      self.find(contaReceberId)
        .then(function (data) {
          // if (data.medicao != null)
          //   $scope.medicoes.push(data.medicao);
          $scope.contaReceber = data;
          $scope.isLoading = false;
        });
    }
    if ($stateParams.centroDeCustoId != null) {
      $scope.centroDeCustoId = $stateParams.centroDeCustoId;
      $scope.cosp = 11;
      $scope.cosplan = 10;
      self.centroDeCustoService.find($stateParams.centroDeCustoId)
        .then(function (data) {
          $scope.centroDeCusto = data;
          if ($stateParams.contaReceberId) {
            find($stateParams.contaReceberId)
            self.medicaoService.list(null, null, null, null, { centroDeCusto : $scope.centroDeCusto.id } )
              .then(function (data) { $scope.medicoes = data; });
          }
          else
            self.clear();
        });
    }
    if ($stateParams.medicaoId != null) {
      $scope.medicaoId = $stateParams.medicaoId;
      self.medicaoService.find($stateParams.prdutoId)
        .then(function (data) {
          $scope.medicao = data;
          if ($stateParams.contaReceberId)
            find($stateParams.contaReceberId)
          else
            self.clear();
        });
    }
    if ($stateParams.contaReceberId)
      find($stateParams.contaReceberId)
    else
      self.clear();
  }

  $scope.clear = function () {
    self.clear();
  }

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);
    filtro.centroDeCusto = filtro.centroDeCusto != null ? filtro.centroDeCusto.id : null;
    filtro.contratoExterno = filtro.contratoExterno != null ? filtro.contratoExterno.id : null;
    filtro.situacao = filtro.situacao != null ? filtro.situacao.name : null;
    filtro.tipoContaReceber = filtro.tipoContaReceber != null ? filtro.tipoContaReceber.name : null;
    filtro.medicao = filtro.medicao != null ? filtro.medicao.id : null;

    if (filtro.inicio != null)
      filtro.inicio = moment(filtro.inicio, "YYYY-MM-DD").format("YYYY-MM-DD");
    if (filtro.fim != null)
      filtro.fim = moment(filtro.fim, "YYYY-MM-DD").format("YYYY-MM-DD");
    if (filtro.dataCompetencia != null)
      filtro.dataCompetencia = moment(filtro.dataCompetencia, "YYYY-MM-DD").format("YYYY-MM-DD");

    if ($scope.aberto == true)
      filtro.search = null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
  };

  self.activate();

  $scope.clear = function () {
    self.clear();
  };

  $scope.save = function () {
    $scope.isLoading = true;
    self.save($scope.contaReceber)
      .then(function success(data) { self.activate(); $state.go("financeiro.contasreceber", { centroDeCustoId: $scope.centroDeCusto.id }); $scope.isLoading = false; })
      .catch(function (error) { toastr.error(error.message); $scope.isLoading = false; });
  }

  $scope.load = function load(tableState) {
    if (tableState.sort.predicate  == undefined && tableState.sort.sortOrder == undefined)
        self.initTableState(tableState, "dataEmissao", 'DESC');
    else
        self.initTableState(tableState);

    $scope.tableIsLoading = true;
    if ($stateParams.centroDeCustoId)
      tableState.search.centroDeCusto = $stateParams.centroDeCustoId;
    if ($stateParams.medicaoId)
      tableState.search.medicao = $stateParams.medicaoId;

    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.tableIsLoading = false;
      })
      .catch(function (error) { toastr.error(error.message); });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  };

  $scope.open = function (page, size, title, contaReceber, content) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          $scope.contaReceber = contaReceber;
          return contaReceber;
        },
        self: function () {  return self; },
        title: function () { return title; },
        content: function () { return content; }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

  $scope.onCentroDeCustoChange = function (centroDeCusto) {
    self.medicaoService.list(null, null, null, null, { centroDeCusto : centroDeCusto } )
      .then(function (data) {
        $scope.medicoes = data;
      });
  };

  $scope.onContratoChange = function (contrato) {
    if (contrato != null) {
        $scope.produto.centroDeCusto = contrato.centroCusto;
        $scope.produto.reajuste.indiceDeReajuste = $scope.produto.contratoExterno.indiceDeReajuste;
        self.medicaoService.list(null, null, null, null, { centroDeCusto : centroDeCusto } )
          .then(function (data) {
            $scope.medicoes = data;
        });
      }
  };

  $scope.onMedicaoBlur = function (medicao) {
    if (!$scope.contaReceber.id) {
      $scope.contaReceber.descricao = medicao.descricao;
      $scope.contaReceber.valor = medicao.valor;
    }
  };

  $scope.onFileSelectRecebimento = function ($files) {
    if ($scope.contaReceber.centroDeCusto && $scope.contaReceber.centroDeCusto.regiao && $scope.contaReceber.centroDeCusto.responsavel != null) {
      self.documentoService.upload($files, "NOTA_FISCAL",
          $scope.contaReceber.centroDeCusto.regiao.descricao + "/" + $scope.contaReceber.centroDeCusto.responsavel.nome + "/" + $scope.contaReceber.centroDeCusto.nome + "/" + $scope.medicao.descricao)
        .then(function success(data) { $scope.contaReceber.comprovanteValorRecebido = data; toastr.success("Upload feito com sucesso!"); })
        .catch(function (error) { toastr.error(error.message); });
    } else
      toastr.warning("Verifique os dados cadastrais do Centro de Custo!! Região e Responsável não cadastrados");
  };

  $scope.onFileSelectValor = function ($files) {
    if ($scope.contaReceber.centroDeCusto && $scope.contaReceber.centroDeCusto.regiao && $scope.contaReceber.centroDeCusto.responsavel != null) {
      self.documentoService.upload($files, "NOTA_DE_RECEBIMENTO",
          $scope.contaReceber.centroDeCusto.regiao.descricao + "/" + $scope.contaReceber.centroDeCusto.responsavel.nome + "/" + $scope.contaReceber.centroDeCusto.nome + "/" + $scope.medicao.descricao)
        .then(function success(data) { $scope.contaReceber.comprovanteValor = data; toastr.success("Upload feito com sucesso!"); })
        .catch(function (error) { toastr.error(error.message); });
    } else
      toastr.warning("Verifique os dados cadastrais do Centro de Custo!! Região e Responsável não cadastrados");
  };

  $scope.download = function (arquivo) {
    self.documentoService.catchFile(arquivo).then(function success(data) { downloadFile(new Blob([data.response]), arquivo.name, data.response.type); })
    .catch(function (error) { toastr.error(error.message); });
  };

});
angular.module('bentham').factory('ContaReceber', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'contas-receber/:id', {
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'contas-receber/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'contas-receber',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'contas-receber/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        },
        deleteArquivo: {
            method: 'POST',
            url: prefixRoute + 'contas-receber/arquivo/delete'
        }
    });
});

angular.module('bentham').factory('ContaReceberService', function (GenericService, ContaReceber, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ContaReceber();
    Object.setPrototypeOf(self.resource, ContaReceber);

    self.converte = function (data) {
        if (data.dataCompetencia != null)
            data.dataCompetencia = self.converteData(data.dataCompetencia);
        if (data.dataEmissao != null)
            data.dataEmissao = self.converteData(data.dataEmissao);
        if (data.dataPrevista != null)
            data.dataPrevista = self.converteData(data.dataPrevista);
        if (data.dataRecebimento != null)
            data.dataRecebimento = self.converteData(data.dataRecebimento);
        if (data.situacao.name == 'RECEBIDO') {
            data.color = 'btn-success';
        }  else if (data.situacao.name == 'ARECEBER') {
            data.color = 'btn-warning';
        } else if (new Date(data.dataEmissao) >= new Date()) {
            data.color = 'btn-danger';
        } else if (new Date(data.dataEmissao) < new Date()) {
            data.color = 'btn-danger';
        }
        return data;
    }

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();

        if (data.dataPrevista != null)
            data.dataPrevista = self.converteData(data.dataPrevista);
        if (data.dataCompetencia != null)
            data.dataCompetencia = self.converteData(data.dataCompetencia);
        if (data.dataEmissao != null)
            data.dataEmissao = self.converteData(data.dataEmissao);
        if (data.dataRecebimento != null)
            data.dataRecebimento = self.converteData(data.dataRecebimento);
        delete data.centroDeCusto.responsavel;
        delete data.medicao.contratoExterno;
        delete data.medicao.produto;

        deferred.resolve(data);
        return deferred.promise
    };

    return function () { return self; };
});





angular.module('bentham.pages.economico.planodeconta').controller('PlanoDeContaCtrl', function ($scope, PlanoDeContaService, PlanoDeConta, GenericController, $state, $stateParams, $uibModal, toastr) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new PlanoDeContaService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.filtro = {};
        $scope.plano = new PlanoDeConta();
    };

    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.planoId) {
            self.find($stateParams.planoId)
                .then(function (data) {
                    $scope.plano = data;
                    $scope.isLoading = false;
                });
        } else {
            $scope.isLoading = false;
            self.clear();
        }
    }

    self.activate();

    $scope.clear = function () {
        self.clear();
    };

    $scope.cancel = function () {
        $state.go("economico.planodeconta")
    };

    $scope.save = function () {
        self.save($scope.plano)
            .then(function success(data) {
                self.activate();
                $state.go("economico.planodeconta")
            });
    }

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "centroDeCusto.anoDeCriacao","DESC");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        $scope.filtro.centroDeCusto != null && $scope.filtro.centroDeCusto != undefined ? filtro.centroDeCusto = filtro.centroDeCusto.id : null;
        $scope.filtro.regiao != null && $scope.filtro.regiao != undefined ? filtro.regiao = filtro.regiao.name : null;
        $scope.filtro.responsavel != null && $scope.filtro.responsavel != undefined ? filtro.responsavel = filtro.responsavel.id : null;
        if ($scope.aberto == true)
            filtro.search = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, plano) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.plano = plano;
                    return plano;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.onContratoChange = function (contrato) {
        if (contrato != null) {
            $scope.filtro.centroDeCusto = contrato.centroCusto;
            $scope.filtro.inicio = new Date(contrato.dataInicioExecucao);
            $scope.filtro.fim = new Date(contrato.dataFimExecucao);
        }
    };

    $scope.onCentroDeCustoChange = function () {
        var periodo = new Date().getFullYear();
        $scope.filtro.inicio = new Date(periodo + "-01-01");
        $scope.filtro.fim = new Date(periodo + "-12-31");
    };

});

angular.module('bentham').factory('PlanoDeConta', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'plano-de-contas/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'plano-de-contas/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'plano-de-contas',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'plano-de-contas/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
            calcular: {
                method: 'POST',
                url: prefixRoute + 'plano-de-contas/calcular',
            },
        });
});

angular.module('bentham').factory('PlanoDeContaService', function (GenericService, PlanoDeConta, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new PlanoDeConta();
    Object.setPrototypeOf(self.resource, PlanoDeConta);

    
    self.calcular = function (entity) {
        var deferred = $q.defer();
        var fn = function () {
            self.valida(entity)
            .then(function (data) {
                if (entity)
                    self.resource.calcular('', data,
                        function success(data) {  deferred.resolve(data); },
                        function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            })
            .catch(function (error) { deferred.reject(error); });
            return deferred.promise;
        }
        return self.process(fn);
    }


    return function () { return self; };
});
angular.module('bentham').controller('ControleEntregaCtrl', function ($scope, $rootScope, $stateParams, CentroDeCusto, Row, RowService, TaskService, OrdemDeServicoService, ProdutoDashBoardService, ChartService) {
    var self = this;
    self.rowService = new RowService();
    self.taskService = new TaskService();
    self.ordemDeServicoService = new OrdemDeServicoService();

    $scope.loading = true;
    $scope.rows = []; //Lista de Linhas do Gantt //Lista de etapas utlizada na tabela de visualização 
    $scope.columns = ['centroDeCusto', 'tipo', 'name', /*'from', 'to'*/];

    $scope.filtro = {visao: "quantidade", periodo: "entrega"} 
    $scope.filtro.contratoExterno = null;
    $scope.centroDeCusto = new CentroDeCusto();

    var erro = function (erro) { console.log(erro); $scope.rows = []; $scope.loading = false; };

    if ($stateParams.centroDeCustoId) {
        $scope.centroDeCusto = $stateParams.centroDeCustoId;
        CentroDeCusto.get({ id: $stateParams.centroDeCustoId },
            function (data) { $scope.centroDeCusto = data; $scope.load(); },
            function (erro) { console.log(erro) }
        );
    } else
        $scope.centroDeCusto = new CentroDeCusto();

    $scope.init = function () {
        if($rootScope.contrato){
            $scope.contrato = $rootScope.contrato;
            $scope.filtro.contratoExterno = $rootScope.contrato;
            self.ordemDeServicoService.list(null, null, null, null, { contratoExternoId : $rootScope.contrato.id } )
                .then(function (data) { $scope.ordensDeServicos = data; });
            $scope.filtro.inicio = new Date($scope.contrato.dataInicioVigencia)
            $scope.filtro.inicio.setMonth($scope.filtro.inicio.getMonth()-1);
            $scope.filtro.fim = new Date($scope.contrato.dataFimVigencia);
            $scope.filtro.fim.setMonth($scope.filtro.fim.getMonth()+1);
            $scope.search();
        }
    };

    $scope.$on("sendContrato", function (evt, data) {
        if($rootScope.contrato){
            $scope.contrato = $rootScope.contrato;
            $scope.filtro.contratoExterno = $rootScope.contrato;
            self.ordemDeServicoService.list(null, null, null, null, { contratoExternoId : $rootScope.contrato.id } )
                .then(function (data) { $scope.ordensDeServicos = data; });
            $scope.filtro.inicio = new Date($scope.contrato.dataInicioVigencia)
            $scope.filtro.inicio.setMonth($scope.filtro.inicio.getMonth()-1);
            $scope.filtro.fim = new Date($scope.contrato.dataFimVigencia);
            $scope.filtro.fim.setMonth($scope.filtro.fim.getMonth()+1);
            $scope.search();
        }
    });

    self.clear = function clear() {
        $scope.tipo = 'contrato';
        $scope.tipoRelatorio = "controleDeEntrega";
        $scope.filtro = {visao: "quantidade", periodo: "entrega"} 
        var periodo = new Date().getFullYear();
        $scope.filtro.inicio = new Date(periodo + "-01-01");
        $scope.filtro.fim = new Date(periodo + "-12-31");
    };
    self.clear();

    var converte = function(data){
        $scope.rows = data; 
        $scope.rows.forEach(function (row) {
            row = self.rowService.converte(row);
            row.tasks.forEach(function (task) { task = self.taskService.converte(task); });
        });
        $scope.timespans = function () {
            return [{
                from: new Date(new Date().getFullYear() - 1, new Date().getMonth() + 1, 21, 8, 0, 0),
                to: new Date(new Date().getFullYear() + 1, new Date().getMonth() + 1, 25, 15, 0, 0),
                name: 'Sprint 1 Timespan'
            }];
        }
        $scope.loading = false;
    };

    var produtoChart = function (graphic) {
        var type = 'currency'
        if($scope.filtro.visao=='quantidade') type = 'number';
        $scope.produtoChart = self.chartService.convertMultiChart(graphic, type);
        // $scope.produtoChart.colors = ['#ff0000', '#ffff4d', '#4dff4d','#33ccff'];
        $scope.isLoading = false;
    };

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        filtro.status = ($scope.filtro.status != null) ? $scope.filtro.status.name : null;
        filtro.tipo = ($scope.filtro.tipo != null) ? $scope.filtro.tipo.name : null;
        filtro.centroDeCusto = ($scope.filtro.centroDeCusto != null) ? $scope.filtro.centroDeCusto.id : null;
        filtro.contratoExterno = ($scope.filtro.contratoExterno != null) ? $scope.filtro.contratoExterno.id : null;
        filtro.ordemDeServico = ($scope.filtro.ordemDeServico != null) ? $scope.filtro.ordemDeServico.id : null;
        filtro.inicio = $scope.filtro.inicio.toISOString();
        filtro.fim = $scope.filtro.fim.toISOString();        
        $scope.buildCharts(filtro);
        $scope.load(filtro);
    };

    $scope.onContratoChange = function (contrato) {
        if (contrato != null) 
            self.ordemDeServicoService.list(null, null, null, null, { contratoExternoId : contrato.id } )
              .then(function (data) { $scope.ordensDeServicos = data; });
              $scope.filtro.inicio = new Date($scope.contrato.dataInicioVigencia)
              $scope.filtro.inicio.setMonth($scope.filtro.inicio.getMonth()-1);
              $scope.filtro.fim = new Date($scope.contrato.dataFimVigencia);
              $scope.filtro.fim.setMonth($scope.filtro.fim.getMonth()+1);
      };

    $scope.clear = function () {
        self.clear();
    };

    $scope.buildCharts = function (filtro) {
        $scope.isLoading = true;
        self.chartService = new ChartService();
        self.produtoDashService = new ProdutoDashBoardService();
        self.produtoDashService.getProdutoChart(filtro).then(produtoChart).catch(erro);
    };

    // Reload data action
    $scope.load = function (filtro) {
        $scope.loading = true;
        Row.findBy(filtro,converte, erro);
    };

    $scope.clear();
});
angular.module('bentham').factory('ProdutoDashBoard', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'produto-chart/:id', { id: '@id', }, {
        getProdutoChart: {
            method: 'GET',
            url: prefixRoute + 'produto-chart/execucao',
        },
    });
});

angular.module('bentham').factory('ProdutoDashBoardService', function (GenericService, ProdutoDashBoard, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ProdutoDashBoard();
    Object.setPrototypeOf(self.resource, ProdutoDashBoard);

    self.getProdutoChart = function (filtro) {
        var deferred = $q.defer();
        filtro['tiposServicos[]'] = filtro.tiposServicos;
        delete filtro.tiposServicos;
        var fn = function () {
            self.resource.getProdutoChart(filtro,
                function success(contrato) { deferred.resolve(contrato); },
                function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () { return self; };
});
angular.module('bentham.pages.gerencial.centrodecusto').controller('GerencialCentroDeCustoCtrl', function ($scope, CentroDeCustoService, CentroDeCusto, prefixRoute, GenericController, $stateParams, $uibModal, toastr,AuthService) {
    var self = this;
    $scope.prefixRoute = prefixRoute;
    Object.setPrototypeOf(self, GenericController);
    self.service = new CentroDeCustoService();
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;


    self.clear = function clear() {
        $scope.centro = new CentroDeCusto();
        $scope.filtro = {};
    };

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        filtro.tipoCentroCusto = ($scope.filtro.tipoCentroCusto != null) ? $scope.filtro.tipoCentroCusto.name : null;
        filtro.responsavel = ($scope.filtro.responsavel != null) ? $scope.filtro.responsavel.id : null;
        filtro.agrupador = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };

    self.activate = function () {
        if ($stateParams.contratoId) {
            self.find($stateParams.contratoId)
                .then(function (data) {
                    $scope.contrato = data;
                });
        } else {
            self.clear();
        }

    };

    self.activate();

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "nome");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

});

angular.module('bentham.pages.gerencial.contasareceber').controller('GerencialContaAReceberCtrl', function ($scope, ContaReceberService, GenericController,  DocumentoService, toastr) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new ContaReceberService();

    self.clear = function clear() {
        $scope.filtro = {};
        $scope.tipoRelatorio = "geral";
        var periodo = new Date().getFullYear();
        $scope.filtro.inicio = new Date(periodo + "-01-01");
        $scope.filtro.fim = new Date(periodo + "-12-31");
    };

    self.copyLinkApi = function copyLinkApi() {
        var filtroBase = $scope.filtro;
        var filtroMapped = {
            formato: "CSV"
        };

        var baseApiUrl = "https://corporativo.bentham.com.br:8443/corporativo/relatorios/contas-receber/?"
        
        Object.keys(filtroBase).forEach(function accessValues(key) {
            var currentItem = filtroBase[key];
            var valueToAccess = currentItem && (currentItem.id || currentItem.name) || currentItem || "";

            filtroMapped[key] = valueToAccess;
        })

        filtroMapped.inicio = moment(filtroMapped.inicio).format("YYYY-MM-DD");
        filtroMapped.fim = moment(filtroMapped.fim).format("YYYY-MM-DD");

        Object.keys(filtroMapped)
        .forEach(function addToUrl(key, i) {
            if(i){
                baseApiUrl += "&"
            }

            baseApiUrl += (
                key
                + "="
                + filtroMapped[key]
            )
        })
        
        navigator.clipboard.writeText(baseApiUrl)
        .then(function sucessCase() {
            toastr.success("Copiado para área de transferência")
        })
        .catch(function errorCase(err) {
            toastr.error(err.message);
        });
    };

    self.clear();

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        $scope.filtro.tipoCentroCusto != null && $scope.filtro.tipoCentroCusto != undefined ? filtro.tipoCentroCusto = filtro.tipoCentroCusto.name : null;
        $scope.filtro.regiao != null && $scope.filtro.regiao != undefined ? filtro.regiao = filtro.regiao.name : null;
        $scope.filtro.responsavel != null && $scope.filtro.responsavel != undefined ? filtro.responsavel = filtro.responsavel.id : null;
        return filtro;
    };

    $scope.clear = function () {
        self.clear();
    };

    $scope.copyLinkApi = function () {
        self.copyLinkApi();
    };
});

angular.module('bentham.pages.gerencial.contratosexternos').controller('GerencialContratoExternoCtrl', function ($scope, ContratoExternoService, ContratoExterno, prefixRoute, GenericController, $stateParams, $uibModal, toastr,AuthService) {
    var self = this;
    $scope.prefixRoute = prefixRoute;
    Object.setPrototypeOf(self, GenericController);
    self.service = new ContratoExternoService();
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.filtro = {};
        $scope.tipoRelatorio = "geral";
        var periodo = new Date().getFullYear();
        $scope.filtro.dataInicio = new Date((periodo-5) + "-01-01");
        $scope.filtro.dataTermino = new Date(periodo + "-12-31");
    };
    self.clear();

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        filtro.centroDeCusto != null ? filtro.centroDeCusto = filtro.centroDeCusto.id: null;
        filtro.responsavel != null ? filtro.responsavel = filtro.responsavel.pessoaFisica.id : null;
        filtro.pais != null ? filtro.pais = filtro.pais.id : null;
        filtro.regiao != null ? filtro.regiao = filtro.regiao.name : null;
        // filtro.regiaoAtuacao != null ? filtro.regiaoAtuacao = filtro.regiaoAtuacao.id : null;
        filtro.tipoServico != null ? filtro.tipoServico = filtro.tipoServico.id : null;
        filtro.area != null ? filtro.area = filtro.area.id : null;
        filtro.subArea != null ? filtro.subArea = filtro.subArea.id : null;
        filtro.cliente != null ? filtro.cliente = filtro.cliente.id : null;
        filtro.statusContrato != null ? filtro.statusContrato = filtro.statusContrato.name : null;
        if (filtro.dataInicio != null)
            filtro.dataInicio = moment(filtro.dataInicio, "YYYY-MM-DD").format("YYYY-MM-DD");
        if (filtro.dataTermino != null)
            filtro.dataTermino = moment(filtro.dataTermino, "YYYY-MM-DD").format("YYYY-MM-DD");
        if($scope.aberto == true )
           filtro.search = null;
        self.tableState.search = filtro;
       $scope.load(self.tableState);
    };

    self.activate();

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "numeroContrato");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

});

angular.module('bentham.pages.gerencial.perspectivas').controller('GerencialPerspectivaCtrl', function ($scope, PerspectivaService, Perspectiva, GenericController, toastr, AuthService, SituacaoPerspectivaService) {

    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new PerspectivaService();
    $scope.authService = AuthService;

    $scope.onChangueCheckbox = function(){
        if($scope.filtro.showAll){
            $scope.filtro.showItem = true;
            $scope.filtro.showTipo = true;
            $scope.filtro.showDescricao = true;
            $scope.filtro.showArea = true;
            $scope.filtro.showGerencia = true;
            $scope.filtro.showEstadoPais = true;
            $scope.filtro.showCliente = true;
            $scope.filtro.showTipoServico = true;
            $scope.filtro.showTipoLicitacao = true;
            $scope.filtro.showParceria = true;
            $scope.filtro.showDataApresentacao = true;
            $scope.filtro.showSituacao = true;
            $scope.filtro.showCriteriosJulgamentos = true;
            $scope.filtro.showPrazoContrato = true;
            $scope.filtro.showValorTotalMil = true;
            $scope.filtro.showPorcentagemEmpresa = true;
            $scope.filtro.showValorEmpresaMil = true;
            $scope.filtro.showPorcentagemCSD = true;
            $scope.filtro.showObservacoes = true;
            $scope.filtro.showValorCSD = true;
        }else if($scope.filtro.showNone){
            $scope.filtro.showItem = false;
            $scope.filtro.showTipo = false;
            $scope.filtro.showDescricao = false;
            $scope.filtro.showArea = false;
            $scope.filtro.showGerencia = false;
            $scope.filtro.showEstadoPais = false;
            $scope.filtro.showCliente = false;
            $scope.filtro.showTipoServico = false;
            $scope.filtro.showTipoLicitacao = false;
            $scope.filtro.showParceria = false;
            $scope.filtro.showDataApresentacao = false;
            $scope.filtro.showSituacao = false;
            $scope.filtro.showCriteriosJulgamentos = false;
            $scope.filtro.showPrazoContrato = false;
            $scope.filtro.showValorTotalMil = false;
            $scope.filtro.showPorcentagemEmpresa = false;
            $scope.filtro.showValorEmpresaMil = false;
            $scope.filtro.showPorcentagemCSD = false;
            $scope.filtro.showObservacoes = false;
            $scope.filtro.showValorCSD = false;
        }
    }

    $scope.clear = function () {
        var periodo = new Date().getFullYear();
        $scope.filtro = {subAreas:[], tiposServicos:[], criteriosJulgamentos:[], situacaoPerspectivaCodigo : "ELABORACAO", visao: "quantidade",  showAll : true , order: 'desc'};
        $scope.filtro.dataInicioApresentacao = new Date(periodo + "-01-01");
        $scope.filtro.dataFimApresentacao = new Date(periodo + "-12-31");
        $scope.filtro.ordenacao = {
            descricao: "Data Apresentação",
            name: "DATA_APRESENTACAO",
            nome: "dataApresentacao"
        };
        $scope.filtro.order = 'desc'
        $scope.filtro.ordenacao != null ? $scope.filtro.sort = $scope.filtro.ordenacao.nome + ',desc': 'dataApresentacao,desc';
        $scope.visao = "geral";
        $scope.filtro.visao = 'geral';
        $scope.onChangueCheckbox();
    };
    $scope.clear();

    $scope.loadConsulta = function (consulta) {
        //$scope.filtro.search = consulta.nome;
        consulta.campos.forEach(function (campo) {
            if (campo.type == 'object')
                if (campo.valor.match(/\d+/g))
                    $scope.filtro[campo.descricao] = { id: campo.valor };
                else
                    $scope.filtro[campo.descricao] = { name: campo.valor };
            else
                $scope.filtro[campo.descricao] = campo.valor;
        });
    }

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);

        filtro.parceiro != null ? filtro.parceiro = filtro.parceiro.id : null;
        filtro.cliente != null ? filtro.cliente = filtro.cliente.id : null;
        filtro.tipoLicitacao != null ? filtro.tipoLicitacao = filtro.tipoLicitacao.id : null;
        filtro.fonteDeRecurso != null ? filtro.fonteDeRecurso = filtro.fonteDeRecurso.id : null;
        filtro.pais != null ? filtro.pais = filtro.pais.id : null;
        filtro.regiao != null ? filtro.regiao = filtro.regiao.name : null;
        filtro.area != null ? filtro.area = filtro.area.id : null;
        filtro.autor != null ? filtro.responsavel = filtro.autor.id : null;
        filtro.regiaoAtuacao != null ? filtro.regiaoAtuacao = filtro.regiaoAtuacao.id : null;

        filtro.criterioJulgamento != null ? filtro.criterioJulgamento = filtro.criterioJulgamento.id : null;
        filtro.tipoPerspectiva != null ? filtro.tipoPerspectiva = filtro.tipoPerspectiva.name : null;
        filtro.tipoServico != null ? filtro.tipoServico = filtro.tipoServico.id : null;

        for(var i = 0; i< filtro.tiposServicos.length; i++)
            filtro.tiposServicos[i] = filtro.tiposServicos[i].id;
        for(var i = 0; i< filtro.subAreas.length; i++)
            filtro.subAreas[i] = filtro.subAreas[i].id;
        for(var i = 0; i< filtro.criteriosJulgamentos.length; i++)
            filtro.criteriosJulgamentos[i] = filtro.criteriosJulgamentos[i].id;
            
        if (filtro.dataInicioApresentacao != null)
            filtro.dataInicioApresentacao = moment(filtro.dataInicioApresentacao, "YYYY-MM-DD").format("YYYY-MM-DD");

        if (filtro.dataFimApresentacao != null)
            filtro.dataFimApresentacao = moment(filtro.dataFimApresentacao, "YYYY-MM-DD").format("YYYY-MM-DD");

        if (filtro.inicioPrevisaoContratacao != null)
            filtro.inicioPrevisaoContratacao = moment(filtro.inicioPrevisaoContratacao, "YYYY-MM-DD").format("YYYY-MM-DD");

        if (filtro.fimPrevisaoContratacao != null)
            filtro.fimPrevisaoContratacao = moment(filtro.fimPrevisaoContratacao, "YYYY-MM-DD").format("YYYY-MM-DD");

        // cleaning
        if ($scope.aberto == true)
            filtro.search = null;

        filtro.ordenacao != null ? filtro.sort = filtro.ordenacao.nome + ','+ filtro.order : null;
        filtro.ordenacao != null ? filtro.ordenacao = filtro.ordenacao.name : null;

        return filtro;
    };

});
angular.module('bentham').controller('OrcamentoEconomicoCtrl', function ($scope, $rootScope, $stateParams, CentroDeCusto, PlanoDeConta, Row, RowService, TaskService, ChartService, FinanceiroDashBoardService) {
    var self = this;
    self.rowService = new RowService();
    self.taskService = new TaskService();
    self.chartService = new ChartService();

    $scope.loading = true;
    $scope.centroDeCusto = new CentroDeCusto();
    $scope.columns = ['centroDeCusto', 'tipo', 'name', 'valor'/*, 'from', 'to'*/];

    var erro = function (erro) { console.log(erro); $scope.rows = []; $scope.loading = false; };

    var error = function (erro) { console.log(erro); $scope.loading = false; };

    if ($stateParams.planoDeContaId) {
        $scope.plano = $stateParams.planoDeContaId;
        PlanoDeConta.get({ id: $stateParams.planoDeContaId },
            function (data) { $scope.plano = data; $scope.filtro.planoDeConta = data; $scope.search(); },
            function (erro) { console.log(erro) }
        );
    } else
        $scope.plano = new PlanoDeConta();

    if ($stateParams.centroDeCustoId) {
        $scope.centroDeCusto = $stateParams.centroDeCustoId;
        CentroDeCusto.get({ id: $stateParams.centroDeCustoId },
            function (data) { $scope.centroDeCusto = data; $scope.search(); },
            function (erro) { console.log(erro) }
        );
    } else
        $scope.centroDeCusto = new CentroDeCusto();
    
    
    $scope.init = function () {
        if($rootScope.contrato){
            self.clear();
            $scope.search();
        }
    };

    $scope.$on("sendContrato", function (evt, data) {
        if($rootScope.contrato){
            $scope.filtro.contratoExterno = $rootScope.contrato;
            $scope.filtro.centroDeCusto = $rootScope.contrato.centroCusto;
            $scope.search();
        }
    });

    self.clear = function clear() {
        $scope.tipo = 'previsao';
        $scope.tipoRelatorio = "planoDeConta";
        $scope.rows = []; //Lista de Linhas do Gantt //Lista de etapas utlizada na tabela de visualização 
        $scope.filtro = {visao: "previsao"} 
        if($rootScope.contrato){
            $scope.filtro.contratoExterno = $rootScope.contrato;
            $scope.filtro.centroDeCusto = $rootScope.contrato.centroCusto;
            $scope.filtro.inicio = new Date($scope.contrato.dataInicioVigencia)
            $scope.filtro.inicio.setMonth($scope.filtro.inicio.getMonth()-1);
            $scope.filtro.fim = new Date($scope.contrato.dataFimVigencia);
            $scope.filtro.fim.setMonth($scope.filtro.fim.getMonth()+1);
      }else{
            var periodo = new Date().getFullYear();
            $scope.filtro.inicio = new Date(periodo + "-01-01");
            $scope.filtro.fim = new Date(periodo + "-12-31");
        }
    };
    self.clear();

    var resultadoEconomicoChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.resultadoEconomicoChart = self.chartService.convertMultiChart(graphic, 'currency');
        $scope.resultadoEconomicoChart.colors = ['#33ccff', '#33ccff', '#DF4C00', '#DF4C00', '#EB8500', '#EB8500', '#4dff4d','#4dff4d' ];
        $scope.loading = false;
    };

    var contaReceberChart = function (graphic) {
        self.chartService = new ChartService();
        $scope.contaReceberChart = self.chartService.convertMultiChart(graphic, 'currency');
        //$scope.loading = false;
    };

    var converte = function(data){
        $scope.rows = data; 
        $scope.rows.forEach(function (row) {
            row = self.rowService.converte(row);
            row.tasks.forEach(function (task) { task = self.taskService.converte(task); });
        });
        $scope.timespans = function () {
            return [{
                from: new Date(new Date().getFullYear() - 1, new Date().getMonth() + 1, 21, 8, 0, 0),
                to: new Date(new Date().getFullYear() + 1, new Date().getMonth() + 1, 25, 15, 0, 0),
                name: 'Sprint 1 Timespan'
            }];
        }
        $scope.loading = false;
    };

    $scope.buildCharts = function (filtro) {
        $scope.loading = true;
        self.financeiroDashService = new FinanceiroDashBoardService();
        self.financeiroDashService.getResultadoEconomicoChart(filtro).then(resultadoEconomicoChart).catch(error);
        self.financeiroDashService.getContaReceberChart(filtro).then(contaReceberChart).catch(error);
    };


    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        filtro.status = ($scope.filtro.status != null) ? $scope.filtro.status.name : null;
        filtro.tipo = ($scope.filtro.tipo != null) ? $scope.filtro.tipo.name : null;
        delete filtro.contratoExterno;
        filtro.centroDeCusto = ($scope.filtro.centroDeCusto != null) ? $scope.filtro.centroDeCusto.id : null;
        filtro.planoDeConta = (filtro.centroDeCusto == null && $scope.filtro.planoDeConta != null) ? $scope.filtro.planoDeConta.id : null;
        filtro.inicio = $scope.filtro.inicio.toISOString();
        filtro.fim = $scope.filtro.fim.toISOString();
        $scope.buildCharts(filtro);
        $scope.load(filtro);
    };

    $scope.clear = function () {
        self.clear();
    };

    // Reload data action
    $scope.load = function (filtro) {
        $scope.loading = true;
        Row.findAllItemPlanoDeConta(filtro,converte, erro);
    };

    $scope.onContratoChange = function (contrato) {
        if (contrato != null) {
            $scope.filtro.centroDeCusto = contrato.centroCusto;
            $scope.filtro.inicio = new Date(contrato.dataInicioVigencia)
            $scope.filtro.inicio.setMonth($scope.filtro.inicio.getMonth()-1);
            $scope.filtro.fim = new Date(contrato.dataFimVigencia);
            $scope.filtro.fim.setMonth($scope.filtro.fim.getMonth()+1);
      }
    };

    $scope.onCentroDeCustoChange = function () {
        var periodo = new Date().getFullYear();
        $scope.filtro.inicio = new Date(periodo + "-01-01");
        $scope.filtro.fim = new Date(periodo + "-12-31");
    };

});
angular.module('bentham').controller('PlanejamentoEstrategicoCtrl', function ($scope, $stateParams, CentroDeCusto, Row, RowService, TaskService) {
    var self = this;
    self.rowService = new RowService();
    self.taskService = new TaskService();

    $scope.centroDeCusto = new CentroDeCusto();

    $scope.loading = true;
    $scope.tipo = 'contrato';
    $scope.rows = []; //Lista de Linhas do Gantt //Lista de etapas utlizada na tabela de visualização 

    $scope.columns = ['status', 'name', 'cliente', 'estado', 'responsavel', 'prazo', 'porcentagemSucesso', 'valorEmpresa', 'valorSucesso', ];

    //Carregamento 
    if ($stateParams.centroDeCustoId) {
        $scope.centroDeCusto = $stateParams.centroDeCustoId;
        CentroDeCusto.get({ id: $stateParams.centroDeCustoId },
            function (data) { $scope.centroDeCusto = data; $scope.load(); },
            function (error) { console.log(error) }
        );
    } else
        $scope.centroDeCusto = new CentroDeCusto();

    //Carregamento

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);        
        filtro.regiao != null && filtro.regiao != undefined ? filtro.regiao = filtro.regiao.name : null;
        filtro.responsavel != null && filtro.responsavel != undefined ? filtro.responsavel = filtro.responsavel.id : null;
        filtro.centroDeCusto != null && filtro.centroDeCusto != undefined ? filtro.centroDeCusto = filtro.centroDeCusto.id : null;
        if (filtro.inicio != null)
            filtro.inicio = moment(filtro.inicio, "YYYY-MM-DD").format("YYYY-MM-DD");
        if (filtro.fim != null)
            filtro.fim = moment(filtro.fim, "YYYY-MM-DD").format("YYYY-MM-DD");
        $scope.load(filtro);
    };

    $scope.clear = function () {
        $scope.filtro = { 
            inicio: new Date(new Date().getFullYear() - 1, new Date().getMonth() + 1, 1, 8, 0, 0), 
            fim: new Date(new Date().getFullYear() , new Date().getMonth() + 1, 1, 15, 0, 0), 
            dataInicioApresentacao: new Date(new Date().getFullYear() - 1, new Date().getMonth() + 1, 1, 8, 0, 0), 
            dataFimApresentacao: new Date(new Date().getFullYear() , new Date().getMonth() + 1, 1, 15, 0, 0) ,
            situacaoPerspectivaCodigo : "ELABORACAO",
        };
    };

    var converte = function(data){
        $scope.rows = data; 
        $scope.rows.forEach(function (row) {
            row = self.rowService.converte(row);
            row.tasks.forEach(function (task) { task = self.taskService.converte(task); });
        });
        $scope.loading = false;
    };

    var erro = function (erro) { console.log(erro); $scope.loading = false; };

    // Reload data action
    $scope.load = function (filtro) {
        $scope.loading = true;

        if($scope.tipo == 'contrato'){
            filtro.subAreas = []
            filtro.tiposServicos = []
            filtro.autor != null ? filtro.responsavel = filtro.autor.id : null;
            filtro.autor != null ? filtro.autor = filtro.autor.id : null;
            filtro.pais != null ? filtro.pais = filtro.pais.id : null;
            filtro.regiaoAtuacao != null ? filtro.regiaoAtuacao = filtro.regiaoAtuacao.id : null;
            filtro.tipoPerspectiva != null ? filtro.tipoPerspectiva = filtro.tipoPerspectiva.id : null;
            filtro.fonteDeRecurso != null ? filtro.fonteDeRecurso = filtro.fonteDeRecurso.id : null;
            filtro.cliente != null ? filtro.cliente = filtro.cliente.id : null;
            filtro.parceiro != null ? filtro.parceiro = filtro.parceiro.id : null;
            filtro.tipoServico != null ? filtro.tipoServico = filtro.tipoServico.id : null;
            filtro.area != null ? filtro.area = filtro.area.id : null;
            filtro.subArea != null ? filtro.subArea = filtro.subArea.id : null;
            filtro.tipoLicitacao != null ? filtro.tipoLicitacao = filtro.tipoLicitacao.id : null;
                
            for(var i = 0; i< filtro.tiposServicos.length; i++)
                filtro.tiposServicos[i] = filtro.tiposServicos[i].id;
            for(var i = 0; i< filtro.subAreas.length; i++)
                filtro.subAreas[i] = filtro.subAreas[i].id;

            if (filtro.dataInicioApresentacao != null)
                filtro.dataInicioApresentacao = moment(filtro.dataInicioApresentacao, "YYYY-MM-DD").format("YYYY-MM-DD");

            if (filtro.dataFimApresentacao != null)
                filtro.dataFimApresentacao = moment(filtro.dataFimApresentacao, "YYYY-MM-DD").format("YYYY-MM-DD");

            if (filtro.inicioPrevisaoContratacao != null)
                filtro.inicioPrevisaoContratacao = moment(filtro.inicioPrevisaoContratacao, "YYYY-MM-DD").format("YYYY-MM-DD");

            if (filtro.fimPrevisaoContratacao != null)
                filtro.fimPrevisaoContratacao = moment(filtro.fimPrevisaoContratacao, "YYYY-MM-DD").format("YYYY-MM-DD");

            for (var prop in filtro) 
                if (!filtro[prop])
                    delete filtro[prop];
            if ($scope.aberto == true)
                filtro.search = null;
                Row.findAll(filtro, converte, erro);
       } else if($scope.tipo == 'produto'){
            filtro.tipo != null && filtro.tipo != undefined ? filtro.tipoContaReceber = filtro.tipo.name : null;
            filtro.tipo = null;
            for (var prop in filtro) 
                if (!filtro[prop])
                    delete filtro[prop];
            if ($scope.aberto == true)
                filtro.search = null;
            Row.findAllProduto(filtro,converte, erro);
        }
       else if($scope.tipo == 'medicao'){
           filtro.tipo != null && filtro.tipo != undefined ? filtro.tipoContaReceber = filtro.tipo.name : null;
           filtro.tipo = null;
            for (var prop in filtro) 
                if (!filtro[prop])
                    delete filtro[prop];
            if ($scope.aberto == true)
                filtro.search = null;
           Row.findAllMedicao(filtro,converte, erro);
        }
       else if($scope.tipo == 'contaReceber'){
            filtro.tipo != null && filtro.tipo != undefined ? filtro.tipoContaReceber = filtro.tipo.name : null;
            filtro.tipo = null;
            for (var prop in filtro) 
                if (!filtro[prop])
                    delete filtro[prop];
            if ($scope.aberto == true)
                filtro.search = null;
            Row.findAllContaReceber(filtro,converte, erro);
        }
    };

    $scope.clear();
    $scope.search();
});
angular.module('bentham.pages.licitacoes.perspectivas').controller('PerspectivaCtrl', function ($scope, DocumentoService, PerspectivaService, TipoServicoService, Perspectiva, TipoServico, GenericController, SituacaoPerspectivaService, $state, $stateParams, $uibModal, toastr, AuthService, $window) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    $scope.authService = AuthService;
    $scope.pessoaJuridica = null;
    $scope.situacao = {};

    self.service = new PerspectivaService();
    self.situacaoPerspectivaService = new SituacaoPerspectivaService();
    self.tipoServicoService = new TipoServicoService();
    self.documentoService = new DocumentoService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.tiposServicos = [];

    $scope.clear = function () {
        $scope.filtro = {subAreas:[], tiposServicos:[], criteriosJulgamentos:[]};
    };

    self.clear = function clear() {
        $scope.perspectiva = new Perspectiva();
        $scope.perspectiva.contratoGerado = false;
        $scope.parceiros = [];
        $scope.perspectiva.tipoServicos = [];
        $scope.perspectiva.subAreas = [];
        $scope.perspectiva.criteriosJulgamentos = [];
        $scope.isLoading = false;
        $scope.filtro = {subAreas:[], tiposServicos:[], criteriosJulgamentos:[]};
    };

    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.perspectivaId) {
            self.find($stateParams.perspectivaId)
                .then(function (data) {
                    $scope.perspectiva = data;
                    $scope.situacao = data.situacaoPerspectiva;
                    $scope.parceiros = $scope.perspectiva.parceiros;
                    $scope.onValorTotalChange();
                    $scope.onSituacaoPerspectivaChange(data.tipoLicitacao, data.situacaoPerspectiva);
                    $scope.isLoading = false;
                });
        } else {
            self.clear();
            $scope.isLoading = false;
        }
    }

    self.activate();

    $scope.open = function (page, size, title, perspectiva) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.perspectiva = perspectiva;
                    return perspectiva;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.load = function load(tableState) {
        $scope.isLoading = true;
        self.initTableState(tableState, 'codigo', 'DESC');
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { 
                toastr.error(error.message);
            });
    };


    $scope.refresh = function () {
        $scope.load(self.tableState);
    };


    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        filtro.pessoaJuridica = $scope.pessoaJuridica != null ? $scope.pessoaJuridica.id : null;

        filtro.autor != null ? filtro.responsavel = filtro.autor.id : null;
        filtro.autor != null ? filtro.autor = filtro.autor.id : null;
        filtro.pais != null ? filtro.pais = filtro.pais.id : null;
        filtro.regiao != null ? filtro.regiao = filtro.regiao.name : null;
        filtro.regiaoAtuacao != null ? filtro.regiaoAtuacao = filtro.regiaoAtuacao.id : null;
        filtro.tipoPerspectiva != null ? filtro.tipoPerspectiva = filtro.tipoPerspectiva.id : null;
        filtro.fonteDeRecurso != null ? filtro.fonteDeRecurso = filtro.fonteDeRecurso.id : null;
        filtro.cliente != null ? filtro.cliente = filtro.cliente.id : null;
        filtro.parceiro != null ? filtro.parceiro = filtro.parceiro.id : null;
        filtro.area != null ? filtro.area = filtro.area.id : null;
        filtro.tipoLicitacao != null ? filtro.tipoLicitacao = filtro.tipoLicitacao.id : null;

        filtro.tipoServico != null ? filtro.tipoServico = filtro.tipoServico.id : null;
        filtro.subArea != null ? filtro.subArea = filtro.subArea.id : null;
        filtro.criterioJulgamento != null ? filtro.criterioJulgamento = filtro.criterioJulgamento.id : null;

        for(var i = 0; i< filtro.tiposServicos.length; i++)
            filtro.tiposServicos[i] = filtro.tiposServicos[i].id;
        for(var i = 0; i< filtro.subAreas.length; i++)
            filtro.subAreas[i] = filtro.subAreas[i].id;
        for(var i = 0; i< filtro.criteriosJulgamentos.length; i++)
            filtro.criteriosJulgamentos[i] = filtro.criteriosJulgamentos[i].id;

        if (filtro.dataInicioApresentacao != null)
            filtro.dataInicioApresentacao = moment(filtro.dataInicioApresentacao, "YYYY-MM-DD").format("YYYY-MM-DD");

        if (filtro.dataFimApresentacao != null)
            filtro.dataFimApresentacao = moment(filtro.dataFimApresentacao, "YYYY-MM-DD").format("YYYY-MM-DD");

        if (filtro.inicioPrevisaoContratacao != null)
            filtro.inicioPrevisaoContratacao = moment(filtro.inicioPrevisaoContratacao, "YYYY-MM-DD").format("YYYY-MM-DD");

        if (filtro.fimPrevisaoContratacao != null)
            filtro.fimPrevisaoContratacao = moment(filtro.fimPrevisaoContratacao, "YYYY-MM-DD").format("YYYY-MM-DD");

        for (var prop in filtro) 
            if (!filtro[prop])
                delete filtro[prop];

        if ($scope.aberto == true)
            filtro.search = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };

    $scope.clear = function () {
        $scope.filtro = {subAreas:[], tiposServicos:[], criteriosJulgamentos:[]};
        $state.go("licitacoes.perspectivas")
    };

    $scope.save = function () {
        $scope.isLoading = true;
        $scope.perspectiva.parceiros = $scope.parceiros;
        self.save($scope.perspectiva)
            .then(function success(data) {
                self.activate();
                $state.go("licitacoes.perspectivas")
                $scope.isLoading = false;
            }).catch(function (error) {
                toastr.error(error.message);
                $scope.isLoading = false;
            });
    }

    $scope.adicionarParceiro = function (parceiro) {
        if (parceiro != null)
            $scope.parceiros.push(parceiro);
        $scope.parceiro = {};
    }

    $scope.deletarParceiro = function (parceiro) {
        $scope.parceiros.splice($scope.parceiros.indexOf(parceiro), 1);
    }

    $scope.onCalculateValorEmpresa = function () {
        var perspectiva = $scope.perspectiva;
        $scope.perspectiva.valor = perspectiva.valorTotal * perspectiva.percentualEmpresa / 100;
    }

    $scope.onValorTotalChange = function () {
        $scope.perspectiva.percentualDesconto = ((($scope.perspectiva.valorEdital - $scope.perspectiva.valorTotal) / $scope.perspectiva.valorEdital) * 100).toFixed(2);
        $scope.onCalculateValorEmpresa();
        $scope.onPercentualSucessoChange();
    }

    $scope.onPercentualEmpresaChange = function (porcentagem) {
        $scope.perspectiva.valor = $scope.perspectiva.valorTotal * porcentagem / 100;
    }

    $scope.onPercentualSucessoChange = function () {
        var perspectiva = $scope.perspectiva;
        $scope.perspectiva.valorSucesso = perspectiva.valorTotal * perspectiva.percentualSucesso / 100;
    }

    $scope.onTipoLicitacaoChange = function (tipoLicitacao) {
        self.situacaoPerspectivaService.byAnterior({
                tipoLicitacao: tipoLicitacao.id,
                situacaoPerpectiva: null
            })
            .then(function (data) {
                $scope.situacoes = data;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    }

    $scope.onSituacaoPerspectivaChange = function (tipoLicitacao, situacao) {
        self.situacaoPerspectivaService.byAnterior({
                tipoLicitacao: tipoLicitacao.id,
                situacaoPerspectiva: !situacao ? null : situacao.id
            })
            .then(function (data) { $scope.situacoes = data;})
            .catch(function (error) { toastr.error(error.message);});
    }

    $scope.uploadEdital = function ($files) {
        if (checkDatas() == true) {
            self.documentoService.upload($files, "EDITAL", $scope.perspectiva.folder)
                .then(function success(data) { $scope.perspectiva.arquivoEdital = data; toastr.success("Upload feito com sucesso!");})
                .catch(function (error) { toastr.error(error.message); });
        } else
            toastr.warning("Preecha o campo Pasta dos Anexos!!");

    };

    checkDatas = function () {
        if ($scope.perspectiva.folder != null)
            return true;
        else
            return false;
    }

    $scope.uploadPropostaFinanceira = function ($files) {
        if (checkDatas() == true) {
            self.documentoService.upload($files, "PROPOSTA_FINANCEIRA", $scope.perspectiva.folder)
                .then(function success(data) { $scope.perspectiva.arquivoPropostaFinanceira = data; toastr.success("Upload feito com sucesso!"); })
                .catch(function (error) { toastr.error(error.message); });
        } else
            toastr.warning("Preecha o campo Pasta dos Anexos!!");

    };

    $scope.uploadProspostaTecnica = function ($files) {
        if (checkDatas() == true) {
            self.documentoService.upload($files, "PROPOSTA_TECNICA", $scope.perspectiva.folder)
                .then(function success(data) {
                    $scope.perspectiva.arquivoPropostaTecnica = data;
                    toastr.success("Upload feito com sucesso!");
                })
                .catch(function (error) {
                    toastr.error(error.message);
                });
        } else
            toastr.warning("Preecha o campo Pasta dos Anexos!!");

    };

    $scope.uploadExtratoDiario = function ($files) {
        if (checkDatas() == true) {
            self.documentoService.upload($files, "EXTRATO_DIARIO_OFICIAL", $scope.perspectiva.folder)
                .then(function success(data) {
                    $scope.perspectiva.arquivoExtratoDiarioOficial = data;
                    toastr.success("Upload feito com sucesso!");
                })
                .catch(function (error) {
                    toastr.error(error.message);
                });
        } else
            toastr.warning("Preecha o campo Pasta dos Anexos!!");

    };

    $scope.download = function (arquivo) {
        self.documentoService.catchFile(arquivo).then(function success(data) {
            downloadFile(new Blob([data.response]), arquivo.name, data.response.type);
        }).catch(function (error) {
            toastr.error(error.message);
        });
    };

    $scope.clonePerspectiva = function (perspectiva, clone) {
        self.service.clone({
            perspectiva: perspectiva.id,
            tipoLicitacao: clone.tipoLicitacao.id,
            situacaoPerspectiva: clone.situacaoPerspectiva.id
        })
        .then(function (data) { console.log(data); $state.go("licitacoes.formperspectivas", { perspectivaId: data.id}) })
        .catch(function (error) { toastr.error(error.message);});
    };

    $scope.fillFiltro = function (consulta) {
        consulta.campos.forEach(function (campo) {
            if (campo.type == 'object')
                if (campo.valor.match(/\d+/g))
                    $scope.filtro[campo.descricao] = { id: campo.valor };
                else
                    $scope.filtro[campo.descricao] = { name: campo.valor };
            else
                $scope.filtro[campo.descricao] = campo.valor;
        });

    };
});
angular.module('bentham').factory('Perspectiva', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'perspectivas/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'perspectivas/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'perspectivas',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'perspectivas/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
            findAllByTipoLicitacao: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'perspectivas/tipolicitacao'
            },
            ultimosRegistros: {
                method: 'GET',
                url: prefixRoute + 'perspectivas/ultimos-registros/pageable'
            },
            contratosAssinados: {
                method: 'GET',
                url: prefixRoute + 'perspectivas/contratos-assinados/pageable'
            },
            findAllContratosAssinados: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'perspectivas/contratos-assinados'
            },
            clone: {
                method: 'POST',
                url: prefixRoute + 'perspectivas/clone'
            }
        });
});

angular.module('bentham').factory('PerspectivaService', function (GenericService, Perspectiva, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Perspectiva();
    Object.setPrototypeOf(self.resource, Perspectiva);

    self.converte = function (data) {
        if (data.dataApresentacao != null)
            data.dataApresentacao = self.converteData(data.dataApresentacao);
        if (data.dataAssinatura != null)
            data.dataAssinatura = self.converteData(data.dataAssinatura);
        if (data.dataOrdemServico != null)
            data.dataOrdemServico = self.converteData(data.dataOrdemServico);
        if (data.dataHistorico != null)
            data.dataHistorico = self.converteData(data.dataHistorico);
        return data;
    };

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        if (data.dataApresentacao != null)
            data.dataApresentacao = self.converteData(data.dataApresentacao);
        if (data.dataAssinatura != null)
            data.dataAssinatura = self.converteData(data.dataAssinatura);
        if (data.dataOrdemServico != null)
            data.dataOrdemServico = self.converteData(data.dataOrdemServico);
        if (data.dataHistorico != null)
            data.dataHistorico = self.converteData(data.dataHistorico);

        deferred.resolve(data);
        return deferred.promise
    };

    self.getPage = function (page, size, sortField, sortOrder, search) {
        var deferred = $q.defer();
         var self = this;
        if (search.predicateObject) {
            Object.assign(search, search.predicateObject)
            delete search.predicateObject;
        }
        var fn = function () {
            self.resource.pageable(angular.extend(search, { page: page, size: size, sort: sortField + ',' + sortOrder}),
                function (data) {
                    for (var i = 0; i < data.content.length; i++)
                        data.content[i] = self.converte(data.content[i]);
                    deferred.resolve(data);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getContratosAssinados = function (page, size, sortField, sortOrder, search) {
        var deferred = $q.defer();
        if (search.predicateObject) {
            Object.assign(search, search.predicateObject)
            delete search.predicateObject;
        }
        var fn = function () {
            self.resource.contratosAssinados(angular.extend(search, { page: page, size: size, sort: sortField + ',' + sortOrder }),
                function (data) {
                    for (var i = 0; i < data.content.length; i++)
                        data.content[i] = self.converte(data.content[i]);
                    deferred.resolve(data);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.getUltimosRegistros = function (page, size, sortField, sortOrder, search) {
        var deferred = $q.defer();
        if (search.predicateObject) {
            Object.assign(search, search.predicateObject)
            delete search.predicateObject;
        }
        var fn = function () {
            self.resource.ultimosRegistros(angular.extend(search, { page: page, size: size, sort: sortField + ',' + sortOrder }),
                function (data) {
                    for (var i = 0; i < data.content.length; i++)
                        data.content[i] = self.converte(data.content[i]);
                    deferred.resolve(data);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.clone = function (perspectiva) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.clone(perspectiva,
                function (data) { deferred.resolve(data); },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () { return self; };
});
angular.module('bentham.pages.qualidade.acoes').controller('AcaoCtrl', function ($scope, $state, AcaoService, GenericController, $stateParams, Acao, $uibModal, AuthService, $window, FuncionarioService, NaoConformidadeService, RiscoService, toastr) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;
  self.service = new AcaoService();
  self.funcionarioService = new FuncionarioService();
  self.naoConformidadeService = new NaoConformidadeService();
  self.riscoService = new RiscoService();

  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;


  self.clear = function clear() {
    $scope.acao = new Acao();
    $scope.filtro = {};
  };

  self.activate = function () {
    $scope.isLoading = true;
    if ($stateParams.acaoId) {
      self.find($stateParams.acaoId)
        .then(function (data) {
          $scope.acao = data;
          $scope.isLoading = false;
        })
    } else {
      self.clear();
      $scope.isLoading = false;
    }
    if ($stateParams.naoConformidadeId != null) {
      self.naoConformidadeService
        .find($stateParams.naoConformidadeId)
        .then(function (data) {
          $scope.naoConformidade = data;
          if ($stateParams.acaoId)
            find($stateParams.acaoId);
          else self.clear();
      });
    }
    if ($stateParams.riscoId != null) {
      self.riscoService
        .find($stateParams.riscoId)
        .then(function (data) {
          $scope.risco = data;
          if ($stateParams.acaoId)
            find($stateParams.acaoId);
          else self.clear();
        });
    }
    // if ($stateParams.acaoId) find($stateParams.acaoId);
    // else self.clear();
}

  self.activate();

  $scope.clear = function () {
    self.clear();
    self.tableState.search = {};
    $scope.load(self.tableState);
  };

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "inicio","DESC");
    $scope.isLoading = true;
    if ($stateParams.naoConformidadeId)
      tableState.search.naoConformidade = $stateParams.naoConformidadeId;
    else if ($stateParams.riscoId)
      tableState.search.risco = $stateParams.riscoId;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () { 
          $scope.acao = entity; 
          if(!!$scope.naoConformidade) $scope.acao.naoConformidade = $scope.naoConformidade;
          if(!!$scope.risco) $scope.acao.risco = $scope.risco;
          return entity; 
        },
        self: function () { return self; },
        title: function () { return title; }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

  $scope.close = function () {
    $window.history.back();
  }

  $scope.save = function () {
    $scope.isLoading = true;
    self.save($scope.acao)
      .then(function (data) { $window.history.back();  $scope.isLoading = false; })
      .catch(function (error) { $scope.isLoading = false;});
  }

  $scope.search = function () {
    $scope.filtro.naoConformidade =  $scope.naoConformidade;
    var filtro = angular.copy($scope.filtro);
    filtro.responsavel != null ? filtro.responsavel = filtro.responsavel.id : null;
    filtro.naoConformidade != null ? filtro.naoConformidade = filtro.naoConformidade.id : null;
    if ($scope.aberto == true)
      filtro.search = null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
  };

  $scope.clear = function () {
    self.clear();
  };

});
angular.module('bentham').factory('Acao', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'acoes/:id', {
    id: '@id',
  }, {
    save: {
      method: 'POST'
    },
    all: {
      method: 'GET',
      isArray: true,
    },
    update: {
      method: 'PUT'
    },
    deletar: {
      method: 'DELETE'
    },
    pageable: {
      method: 'GET',
      url: prefixRoute + 'acoes/pageable',
      params: {
        'sort': '@sort',
        'number': '@number',
        'size': '@size'
      }
    }
  });
});

angular.module('bentham').factory('AcaoService', function (GenericService, Acao, $q) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new Acao();
  Object.setPrototypeOf(self.resource, Acao);

  self.converte = function (data) {
    if (data.inicio != null)
        data.inicio = self.converteData(data.inicio);
    if (data.prazo != null)
        data.prazo = self.converteData(data.prazo);
    if (data.fim != null)
        data.fim = self.converteData(data.fim);
    return data;
  };

  self.valida = function (entity) {
    var data = angular.copy(entity)
    var deferred = $q.defer();

    delete data.responsavel.pessoaFisica;
    delete data.responsavel.cargo;
    delete data.responsavel.telefones;

    deferred.resolve(data);
    return deferred.promise;
  };

  return function () { return self; };
});

angular.module('bentham.pages.qualidade.avancos').controller('AvancoCtrl', function ($scope, AvancoService, IndicadorService, GenericController, $stateParams, Avanco, $uibModal, AuthService, $window, toastr) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;
  self.service = new AvancoService();
  self.indicadorService = new IndicadorService();

  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;


  self.clear = function clear() {
    $scope.avanco = new Avanco();
    $scope.indicador = new Indicador();
    $scope.filtro = {};
  };

  self.activate = function () {
    $scope.isLoading = true;
    if ($stateParams.indicadorId) {
      $scope.avanco = new Avanco();
      self.indicadorService.find($stateParams.indicadorId)
        .then(function (data) {
          $scope.indicador = data;
          $scope.avanco.indicador = $scope.indicador;
          $scope.isLoading = false;
        })
    } else {
      self.clear();
      $scope.isLoading = false;
    }
  }

  $scope.activate = self.activate();
  self.activate();

  $scope.clear = function () {
    self.clear();
    self.tableState.search = {};
    $scope.load(self.tableState);
  };

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "data");
    $scope.isLoading = true;
    if ($stateParams.indicadorId)
        tableState.search.indicador = $stateParams.indicadorId;  
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () { 
          $scope.avanco = entity; 
          $scope.avanco.indicador = $scope.indicador;
          return entity; 
        },
        self: function () { return self; },
        title: function () { return title; }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

  $scope.close = function () {
    $window.history.back();
  }

  $scope.save = function () {
    $scope.isLoading = true;
    self.save($scope.avanco)
      .then(function (data) {  
        $scope.avanco = new Avanco();
        self.indicadorService.find($stateParams.indicadorId)
          .then(function (data) {
            $scope.avanco.indicador = data;
            $scope.isLoading = false;
          })  
       })
      .catch(function (error) { $scope.isLoading = false;});
  }

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);
    if ($scope.aberto == true)
      filtro.search = null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
  };

  $scope.clear = function () {
    self.clear();
  };

});
angular.module('bentham').factory('Avanco', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'avancos/:id', {
    id: '@id',
  }, {
    save: {
      method: 'POST'
    },
    all: {
      method: 'GET',
      isArray: true,
    },
    update: {
      method: 'PUT'
    },
    deletar: {
      method: 'DELETE'
    },
    pageable: {
      method: 'GET',
      url: prefixRoute + 'avancos/pageable',
      params: {
        'sort': '@sort',
        'number': '@number',
        'size': '@size'
      }
    }
  });
});

angular.module('bentham').factory('AvancoService', function (GenericService, Avanco, $q) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new Avanco();
  Object.setPrototypeOf(self.resource, Avanco);

  self.converte = function (data) {
    if (data.data != null)
        data.data = self.converteData(data.data);
    return data;
  };

  return function () { return self; };
});

angular.module('bentham.pages.qualidade.dashboardIndicadores').controller('DashboardIndicadorCtrl', function ($scope, DashboardIndicadorService, DashboardService, GenericController, $stateParams, DashboardIndicador, $uibModal, AuthService, $window, toastr) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;
  self.service = new DashboardIndicadorService();
  self.dashboardService = new DashboardService();

  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;


  self.clear = function clear() {
    $scope.dashboardIndicador = new DashboardIndicador();
    $scope.filtro = {};
  };

  self.activate = function () {
    $scope.isLoading = true;
    if ($stateParams.dashboardId) {
      $scope.dashboardIndicador = new DashboardIndicador();
      self.dashboardService.find($stateParams.dashboardId)
        .then(function (data) {
          $scope.dashboardIndicador.dashboard = data;
          $scope.isLoading = false;
        })
    } else {
      self.clear();
      $scope.isLoading = false;
    }
  }

  self.activate();

  $scope.clear = function () {
    self.clear();
    self.tableState.search = {};
    $scope.load(self.tableState);
  };

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "indicador");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () { $scope.dashboardIndicador = entity; return entity; },
        self: function () { return self; },
        title: function () { return title; }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

  $scope.close = function () {
    $window.history.back();
  }

  $scope.save = function () {
    $scope.isLoading = true;
    self.save($scope.dashboardIndicador)
      .then(function (data) { $window.history.back();  $scope.isLoading = false; })
      .catch(function (error) { $scope.isLoading = false;});
  }

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);
    if ($scope.aberto == true)
      filtro.search = null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
  };

  $scope.clear = function () {
    self.clear();
  };

});
angular.module('bentham').factory('DashboardIndicador', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'dashboardIndicadors/:id', {
    id: '@id',
  }, {
    save: {
      method: 'POST'
    },
    all: {
      method: 'GET',
      isArray: true,
    },
    update: {
      method: 'PUT'
    },
    deletar: {
      method: 'DELETE'
    },
    pageable: {
      method: 'GET',
      url: prefixRoute + 'dashboardIndicadors/pageable',
      params: {
        'sort': '@sort',
        'number': '@number',
        'size': '@size'
      }
    }
  });
});

angular.module('bentham').factory('DashboardIndicadorService', function (GenericService, DashboardIndicador, $q) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new DashboardIndicador();
  Object.setPrototypeOf(self.resource, DashboardIndicador);
  return function () { return self; };
});

angular.module('bentham.pages.qualidade.dashboards').controller('DashboardCtrl', function ($scope, $state, DashboardService, GenericController, $stateParams, Dashboard, $uibModal, AuthService, PessoaFisicaService, toastr) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;
  self.service = new DashboardService();
  self.pessoaFisicaService = new PessoaFisicaService();

  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  self.clear = function clear() {
    $scope.dashboard = new Dashboard();
    $scope.filtro = {};
  };

  self.activate = function () {
    $scope.isLoading = true;
    if ($stateParams.dashboardId) {
      self.find($stateParams.dashboardId)
        .then(function (data) {
          $scope.dashboard = data;
          $scope.isLoading = false;
        })
    } else {
      self.clear();
      $scope.isLoading = false;
    }
  }

  self.activate();

  $scope.clear = function () {
    self.clear();
    self.tableState.search = {};
    $scope.load(self.tableState);
  };

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "nome");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result);
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          $scope.dashboard = entity;
          return entity;
        },
        self: function () {
          return self;
        },
        title: function () {
          return title;
        }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

  $scope.close = function () {
    $state.go("qualidade.dashboards");
  }

  $scope.save = function () {
    $scope.isLoading = true;
    self.save($scope.dashboard)
      .then(function () {
        $state.go("qualidade.dashboards");
        $scope.isLoading = false;
      }).catch(function (error) {
        $scope.isLoading = false;
      });
  }

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);
    filtro.departamento != null ? filtro.departamento = filtro.departamento.id : null;
    filtro.contratoExterno != null ? filtro.contratoExterno = filtro.contratoExterno.id : null;
    if ($scope.aberto == true)
      filtro.search = null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
  };

  $scope.clear = function () {
    self.clear();
  };

});
angular.module('bentham').factory('Dashboard', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'dashboards/:id', {
    id: '@id',
  }, {
    save: {
      method: 'POST'
    },
    all: {
      method: 'GET',
      isArray: true,
    },
    update: {
      method: 'PUT'
    },
    deletar: {
      method: 'DELETE'
    },
    pageable: {
      method: 'GET',
      url: prefixRoute + 'dashboards/pageable',
      params: {
        'sort': '@sort',
        'number': '@number',
        'size': '@size'
      }
    },
    charts: {
      method: 'GET',
      url: prefixRoute + 'dashboards/charts',
      isArray: true,
    },
  });
});

angular.module('bentham').factory('DashboardService', function (GenericService, Dashboard, $q) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new Dashboard();
  Object.setPrototypeOf(self.resource, Dashboard);

  self.getCharts = function (filter) {
    var deferred = $q.defer();
    var fn = function () {
        self.resource.charts(filter,
            function success(data) {
                deferred.resolve(data); 
            }, function (error) {
                error = self.catchMessage(error);
                deferred.reject(new Error("Erro! " + error.message));
            });
        return deferred.promise;
    }
    return self.process(fn);
  }

  return function () { return self; };
});

angular.module('bentham.pages.qualidade.indicadores').controller('IndicadorCtrl', function ($scope, $state, IndicadorService, GenericController, $stateParams, Indicador, $uibModal, AuthService, PessoaFisicaService, toastr) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;
  self.service = new IndicadorService();
  self.pessoaFisicaService = new PessoaFisicaService();

  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  self.clear = function clear() {
    $scope.indicador = new Indicador();
    $scope.filtro = {};
  };

  self.activate = function () {
    $scope.isLoading = true;
    if ($stateParams.indicadorId) {
      self.find($stateParams.indicadorId)
        .then(function (data) {
          $scope.indicador = data;
          $scope.isLoading = false;
        })
    } else {
      self.clear();
      $scope.isLoading = false;
    }
  }

  self.activate();

  $scope.clear = function () {
    self.clear();
    self.tableState.search = {};
    $scope.load(self.tableState);
  };

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "descricao");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          $scope.indicador = entity;
          return entity;
        },
        self: function () {
          return self;
        },
        title: function () {
          return title;
        }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

  $scope.close = function () {
    $state.go("qualidade.indicadores");
  }

  $scope.save = function () {
    $scope.isLoading = true;
    self.save($scope.indicador)
      .then(function () {
        $state.go("qualidade.indicadores");
        $scope.isLoading = false;
      }).catch(function (error) {
        $scope.isLoading = false;
      });
  }

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);
    filtro.departamento != null ? filtro.departamento = filtro.departamento.id : null;
    filtro.contratoExterno != null ? filtro.contratoExterno = filtro.contratoExterno.id : null;
    if ($scope.aberto == true)
      filtro.search = null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
  };

  $scope.clear = function () {
    self.clear();
  };

});
angular.module('bentham').factory('Indicador', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'indicadores/:id', {
    id: '@id',
  }, {
    save: {
      method: 'POST'
    },
    all: {
      method: 'GET',
      isArray: true,
    },
    update: {
      method: 'PUT'
    },
    deletar: {
      method: 'DELETE'
    },
    pageable: {
      method: 'GET',
      url: prefixRoute + 'indicadores/pageable',
      params: {
        'sort': '@sort',
        'number': '@number',
        'size': '@size'
      }
    }
  });
});

angular.module('bentham').factory('IndicadorService', function (GenericService, Indicador, $q) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new Indicador();
  Object.setPrototypeOf(self.resource, Indicador);

  self.converte = function (data) {
    if (data.inicio != null)
        data.inicio = self.converteData(data.inicio);
    if (data.fim != null)
        data.fim = self.converteData(data.fim);
    return data;
  };

  return function () { return self; };
});

angular.module('bentham.pages.qualidade.kpi').controller('KpiCtrl', function ($scope, KpiService, Kpi, GenericController, $stateParams, $uibModal, AuthService, toastr) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new KpiService();
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.kpi = new Kpi();

    self.clear = function clear() {
        $scope.kpi = new Kpi();
    };

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "descricao");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    if ($stateParams.kpiId)
                        entity.kpi = { id: $stateParams.kpiId }
                    $scope.kpi = entity;
                    return entity;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

});
angular.module('bentham').factory('Kpi', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'kpis/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'kpis/:id',
            },
            save: {
                method: 'POST'
            },
            update:{
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'kpis',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'kpis/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }
            },
        });
});

angular.module('bentham').factory('KpiService', function (Kpi, GenericService, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Kpi();
    Object.setPrototypeOf(self.resource, Kpi);
    return function () { return self; };
});
angular.module('bentham.pages.qualidade.naoconformidades').controller('NaoConformidadeCtrl', function ($scope, $state, NaoConformidadeService, GenericController, $stateParams, NaoConformidade, $uibModal, AuthService, $window, PessoaFisicaService, toastr) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;
  self.service = new NaoConformidadeService();
  self.pessoaFisicaService = new PessoaFisicaService();

  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  self.clear = function clear() {
    $scope.naoConformidade = new NaoConformidade();
    $scope.filtro = {};
  };

  self.activate = function () {
    $scope.isLoading = true;
    if ($stateParams.naoConformidadeId) {
      self.find($stateParams.naoConformidadeId)
        .then(function (data) {
          $scope.naoConformidade = data;
          $scope.isLoading = false;
        })
    } else {
      self.clear();
      $scope.isLoading = false;
    }
  }

  self.activate();

  $scope.clear = function () {
    self.clear();
    self.tableState.search = {};
    $scope.load(self.tableState);
  };

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "solicitacao", "DESC");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          $scope.naoConformidade = entity;
          return entity;
        },
        self: function () {
          return self;
        },
        title: function () {
          return title;
        }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

  $scope.close = function () {
    $state.go("qualidade.naoconformidades");
  }

  $scope.save = function () {
    $scope.isLoading = true;
    self.save($scope.naoConformidade)
      .then(function () {
        $state.go("qualidade.naoconformidades");
        $scope.isLoading = false;
      }).catch(function (error) {
        $scope.isLoading = false;
      });
  }

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);
    filtro.departamento != null ? filtro.departamento = filtro.departamento.id : null;
    filtro.contratoExterno != null ? filtro.contratoExterno = filtro.contratoExterno.id : null;
    if ($scope.aberto == true)
      filtro.search = null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
  };

  $scope.clear = function () {
    self.clear();
  };

});
angular.module('bentham').factory('NaoConformidade', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'naoConformidades/:id', {
    id: '@id',
  }, {
    save: {
      method: 'POST'
    },
    all: {
      method: 'GET',
      isArray: true,
    },
    update: {
      method: 'PUT'
    },
    deletar: {
      method: 'DELETE'
    },
    pageable: {
      method: 'GET',
      url: prefixRoute + 'naoConformidades/pageable',
      params: {
        'sort': '@sort',
        'number': '@number',
        'size': '@size'
      }
    }
  });
});

angular.module('bentham').factory('NaoConformidadeService', function (GenericService, NaoConformidade, $q) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new NaoConformidade();
  Object.setPrototypeOf(self.resource, NaoConformidade);

  self.converte = function (data) {
    if (data.solicitacao != null)
        data.solicitacao = self.converteData(data.solicitacao);
    if (data.prazo != null)
        data.prazo = self.converteData(data.prazo);
    if (data.atendimento != null)
        data.atendimento = self.converteData(data.atendimento);
    if (data.fechamento != null)
        data.fechamento = self.converteData(data.fechamento);
    return data;
  };

  return function () { return self; };
});

angular.module('bentham.pages.qualidade.riscos').controller('RiscoCtrl', function ($scope, $state, RiscoService, GenericController, $stateParams, Risco, $uibModal, AuthService, $window, PessoaFisicaService, toastr) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;
  self.service = new RiscoService();
  self.pessoaFisicaService = new PessoaFisicaService();

  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  self.clear = function clear() {
    $scope.risco = new Risco();
    $scope.filtro = {};
  };

  self.activate = function () {
    $scope.isLoading = true;
    if ($stateParams.riscoId) {
      self.find($stateParams.riscoId)
        .then(function (data) {
          $scope.risco = data;
          $scope.isLoading = false;
        })
    } else {
      self.clear();
      $scope.isLoading = false;
    }
  }

  self.activate();

  $scope.clear = function () {
    self.clear();
    self.tableState.search = {};
    $scope.load(self.tableState);
  };

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "codigo");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          $scope.risco = entity;
          return entity;
        },
        self: function () {
          return self;
        },
        title: function () {
          return title;
        }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

  $scope.close = function () {
    $state.go("qualidade.riscos");
  }

  $scope.save = function () {
    $scope.isLoading = true;
    self.save($scope.risco)
      .then(function () {
        $state.go("qualidade.riscos");
        $scope.isLoading = false;
      }).catch(function (error) {
        $scope.isLoading = false;
      });
  }

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);
    filtro.departamento != null ? filtro.departamento = filtro.departamento.id : null;
    filtro.contratoExterno != null ? filtro.contratoExterno = filtro.contratoExterno.id : null;
    if ($scope.aberto == true)
      filtro.search = null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
  };

  $scope.clear = function () {
    self.clear();
  };

});
angular.module('bentham').factory('Risco', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'riscos/:id', {
    id: '@id',
  }, {
    save: {
      method: 'POST'
    },
    all: {
      method: 'GET',
      isArray: true,
    },
    update: {
      method: 'PUT'
    },
    deletar: {
      method: 'DELETE'
    },
    pageable: {
      method: 'GET',
      url: prefixRoute + 'riscos/pageable',
      params: {
        'sort': '@sort',
        'number': '@number',
        'size': '@size'
      }
    }
  });
});

angular.module('bentham').factory('RiscoService', function (GenericService, Risco, $q) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new Risco();
  Object.setPrototypeOf(self.resource, Risco);

  self.converte = function (data) {
    if (data.inicioObservacao != null)
        data.inicioObservacao = self.converteData(data.inicioObservacao);
    if (data.dataPrazo != null)
        data.dataPrazo = self.converteData(data.dataPrazo);
    if (data.mitigacao != null)
        data.mitigacao = self.converteData(data.mitigacao);
    return data;
  };

  self.valida = function (entity) {
    var data = angular.copy(entity)
    var deferred = $q.defer();

    if(data.contratoExterno){
      delete data.contratoExterno.centroCusto;
      delete data.contratoExterno.funcionarios;
      delete data.contratoExterno.perspectiva;
      delete data.contratoExterno.responsavelEmpresa;
      delete data.contratoExterno.responsavelCliente;
    }

    deferred.resolve(data);
    return deferred.promise;
  };

  return function () { return self; };
});

angular.module('bentham.pages.qualidade.unidade-medida').controller('UnidadeMedidaCtrl', function ($scope, UnidadeMedidaService, UnidadeMedida, GenericController, $stateParams, $uibModal, AuthService, toastr) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new UnidadeMedidaService();
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.unidadeMedida = new UnidadeMedida();

    self.clear = function clear() {
        $scope.unidadeMedida = new UnidadeMedida();
    };

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "sigla");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    if ($stateParams.unidadeMedidaId)
                        entity.unidadeMedida = { id: $stateParams.unidadeMedidaId }
                    $scope.unidadeMedida = entity;
                    return entity;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

});
angular.module('bentham').factory('UnidadeMedida', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'unidadesMedida/:id', {
    id: '@id',
  }, {
    save: {
      method: 'POST',
    },
    update: {
      method: 'PUT'
    },
    delete: {
      method: 'DELETE',
      url: prefixRoute + "unidadesMedida/:id",
    },
    all: {
      method: 'GET',
      url: prefixRoute + "unidadesMedida",
      isArray: true,
    },
    pageable: {
      method: 'GET',
      url: prefixRoute + 'unidadesMedida/pageable',
      params: {
        'sort': '@sort',
        'number': '@number',
        'size': '@size'
      }

    },

  });
});


angular.module('bentham').factory('UnidadeMedidaService', function (GenericService, UnidadeMedida) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new UnidadeMedida();
  Object.setPrototypeOf(self.resource, UnidadeMedida);
  return function () { return self; };
});
angular.module('bentham.pages.seguranca.areasistema').controller('AreaSistemaCtrl', function ($scope, AreaSistemaService, AreaSistema, GenericController, $state, $stateParams, $uibModal, toastr,AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new AreaSistemaService();
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.area = new AreaSistema();
    };
    $scope.clear = function(){
        self.clear();
    }

    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.areaId) {
            self.find($stateParams.areaId)
                .then(function (data) {
                    $scope.area = data;
                    $scope.isLoading = false;
                });
        } else {
            self.clear();
            $scope.isLoading = false;
        }
    }
    self.activate();

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                angular.forEach($scope.displayed, function(area){
                    delete area.grupoAreaSistema.areasSistema;
                });
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, area) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.area = area;
                    return area;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };
});
angular.module('bentham').factory('AreaSistema', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'areas-sistemas/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'areas-sistemas/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'areas-sistemas',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'areas-sistemas/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
        });
});

angular.module('bentham').factory('AreaSistemaService', function (GenericService, AreaSistema, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new AreaSistema();
    Object.setPrototypeOf(self.resource, AreaSistema);

    self.valida = function (data) {
        var deferred = $q.defer();
        delete data.grupoAreaSistema.areasSistema;
        delete data.grupoAreaSistema.dataCriacao;
        delete data.grupoAreaSistema.dataModificacao;
        deferred.resolve(data);
        return deferred.promise
    };

    return function () { return self; };
});
angular.module('bentham.pages.seguranca.auditoriasistema').controller('AuditoriaRegistroCtrl', function ($scope, GenericController, $injector, $stateParams, $controller, toastr) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    $scope.clear = function () {
        $scope.filtro = {};
        $scope.controller = null;
        $scope.entitySelected = null;
    };
    $scope.clear();


    $scope.entities = [{
            entityName: "Usuario",
            searchForm: "app/pages/seguranca/usuario/usuarioSearch.html",
            controller: "UsuarioCtrl",
            service: "UsuarioService"
        },
        {
            entityName: "Cliente",
            searchForm: "app/pages/cadastrosbasicos/clientes/clienteSearch.html",
            controller: "ClienteCtrl",
            service: "ClienteService"
        },
        {
            entityName: "Parceiro",
            searchForm: "app/pages/licitacoes/configuracaoperspectivas/parceiros/parceirosSearch.html",
            controller: "ParceiroCtrl",
            service: "ParceiroService"
        },
        {
            entityName: "Perspectiva",
            searchForm: "app/pages/licitacoes/perspectivas/perspectivasSearch.html",
            controller: "PerspectivaCtrl",
            service: "PerspectivaService"
        },
        {
            entityName: "CentroDeCusto",
            searchForm: "app/pages/financeiro/centro-custo/centrocustoSearch.html",
            controller: "CentroDeCustoCtrl",
            service: "CentroDeCustoService"
        },
        {
            entityName: "ContratoExterno",
            searchForm: "app/pages/contratos/contratosexternos/contratosexternosSearch.html",
            controller: "ContratoExternoCtrl",
            service: "ContratoExternoService"
        },
        {
            entityName: "ContratoInterno",
            searchForm: "app/pages/contratos/contratosinternos/contratosInternoSearch.html",
            controller: "ContratoInternoCtrl",
            service: "ContratoInternoService"
        },
        {
            entityName: "Medicao",
            searchForm: "app/pages/contratos/medicao/medicoesSearch.html",
            controller: "MedicaoCtrl",
            service: "MedicaoService"
        },
        {
            entityName: "ContaReceber",
            searchForm: "app/pages/financeiro/conta-receber/contareceberSearch.html",
            controller: "ContaReceberCtrl",
            service: "ContaReceberService"
        },
        {
            entityName: "Produto",
            searchForm: "app/pages/contratos/produtos/produtosSearch.html",
            controller: "ProdutoCtrl",
            service: "ProdutoService"
        },

        // Formulário Genérico Código e Descrição

        {
            entityName: "TipoPerspectiva",
            searchForm: null,
            controller: "TipoPerspectivaCtrl",
            service: "TipoPerspectivaService"
        },
        {
            entityName: "Area",
            searchForm: null,
            controller: "AreaCtrl",
            service: "AreaService"
        },
        {
            entityName: "RegiaoAtuacao",
            searchForm: null,
            controller: "RegiaoAtuacaoCtrl",
            service: "RegiaoAtuacaoService"
        },
        {
            entityName: "TipoServico",
            searchForm: null,
            controller: "TipoServicoCtrl",
            service: "TipoServicoService"
        },
        {
            entityName: "TipoLicitacao",
            searchForm: null,
            controller: "TipoLicitacaoCtrl",
            service: "TipoLicitacaoService"
        },
        {
            entityName: "LocalOrigemServico",
            searchForm: null,
            controller: "LocalOrigemServicoCtrl",
            service: "LocalOrigemServicoService"
        },
        {
            entityName: "TipoServicoDespesa",
            searchForm: null,
            controller: "TipoServicoDespesaCtrl",
            service: "TipoServicoDespesaService"
        },
        {
            entityName: "TipoInstituicaoOrigemServico",
            searchForm: null,
            controller: "TipoInstituicaoOrigemServicoCtrl",
            service: "TipoInstituicaoOrigemServicoService"
        },
        {
            entityName: "TipoCentroDeCusto",
            searchForm: null,
            controller: "TipoCentroDeCustoCtrl",
            service: "TipoCentroDeCustoService"
        },
        {
            entityName: "TipoDeContrato",
            searchForm: null,
            controller: "TipoDeContratoCtrl",
            service: "TipoDeContratoService"
        },
        {
            entityName: "FormaDePagamento",
            searchForm: null,
            controller: "FormaDePagamentoCtrl",
            service: "FormaDePagamentoService"
        },
        {
            entityName: "FonteDeRecurso",
            searchForm: null,
            controller: "FonteDeRecursoCtrl",
            service: "FonteDeRecursoService"
        },
        {
            entityName: "TipoItemServico",
            searchForm: null,
            controller: "TipoItemServicoCtrl",
            service: "TipoItemServicoService"
        },
        {
            entityName: "Pais",
            searchForm: null,
            controller: "PaisCtrl",
            service: "PaisService"
        },

        // Formulário de Documentos

        {
            entityName: "TipoDocumento",
            searchForm: null,
            controller: "TipoDocumentoCtrl",
            service: "TipoDocumentoService"
        },
        {
            entityName: "Documento",
            searchForm: null,
            controller: "DocumentoCtrl",
            service: "DocumentoService"
        },
        {
            entityName: "ContratoExternoDocumento",
            searchForm: null,
            controller: "ContratoExternoDocumentoCtrl",
            service: "ContratoExternoDocumentoService"
        },
        {
            entityName: "PerspectivaDocumento",
            searchForm: null,
            controller: "PerspectivaDocumentoCtrl",
            service: "PerspectivaDocumentoService"
        },
        {
            entityName: "DocumentoCat",
            searchForm: null,
            controller: "DocumentoCatCtrl",
            service: "DocumentoCatService"
        },

        //Pesquisa com a classe principal também

        {
            entityName: "HistoricoPerspectiva",
            searchForm: null,
            controller: "HistoricoPerspectivaCtrl",
            service: "HistoricoPerspectivaService"
        },

        {
          entityName: "SolicitacaoJuridicoPerspectiva",
          searchForm: null,
          controller: "SolicitacaoJuridicoPerspectivaCtrl",
          service: "SolicitacaoJuridicoPerspectivaService"
        },

        {
          entityName: "RespostaJuridicoPerspectiva",
          searchForm: null,
          controller: "RespostaJuridicoPerspectivaCtrl",
          service: "RespostaJuridicoPerspectivaService"
        },

        {
          entityName: "ProvimentoSolicitacao",
          searchForm: null,
          controller: "ProvimentoSolicitacaoCtrl",
          service: "ProvimentoSolicitacaoService"
        },

        {
            entityName: "RevisaoContrato",
            searchForm: null,
            controller: "RevisaoContratoCtrl",
            service: "RevisaoContratoService"
        },
        {
            entityName: "Prazo",
            searchForm: null,
            controller: "PrazoCtrl",
            service: "PrazoService"
        },
        {
            entityName: "IndiceDeReajuste",
            searchForm: null,
            controller: "IndiceDeReajusteCtrl",
            service: "IndiceDeReajusteService"
        },
        {
            entityName: "DataImportante",
            searchForm: null,
            controller: "DataImportanteCtrl",
            service: "DataImportanteService"
        },
        {
            entityName: "Reajuste",
            searchForm: null,
            controller: "ReajusteCtrl",
            service: "ReajusteService"
        },

        {
            entityName: "ComentarioContaReceber",
            searchForm: null,
            controller: "ComentarioContaReceberCtrl",
            service: "ComentarioContaReceberService"
        },

        {
            entityName: "AnaliseContratual",
            searchForm: null,
            controller: "AnaliseContratualCtrl",
            service: "AnaliseContratualService"
        },
        {
            entityName: "AnaliseOperacional",
            searchForm: null,
            controller: "AnaliseOperacionalCtrl",
            service: "AnaliseOperacionalService"
        },

        //Pessoa Fisica e Pessoa Juridica

        {
            entityName: "ParceiroResponsavel",
            searchForm: null,
            controller: "ParceiroResponsavelCtrl",
            service: "ParceiroResponsavelService"
        },
        {
            entityName: "Funcionario",
            searchForm: null,
            controller: "FuncionarioCtrl",
            service: "FuncionarioService"
        },
        {
            entityName: "PessoaFisica",
            searchForm: null,
            controller: "PessoaFisicaCtrl",
            service: "PessoaFisicaService"
        },

        {
            entityName: "Pessoa",
            searchForm: null,
            controller: "PessoaCtrl",
            service: "PessoaService"
        },

        {
            entityName: "PessoaJuridica",
            searchForm: null,
            controller: "PessoaJuridicaCtrl",
            service: "PessoaJuridicaService"
        },
        {
            entityName: "Consorcio",
            searchForm: null,
            controller: "ConsorcioCtrl",
            service: "ConsorcioService"
        },
        {
            entityName: "ConsorcioParceiro",
            searchForm: null,
            controller: "ConsorcioParceiroCtrl",
            service: "ConsorcioParceiroService"
        },
        {
            entityName: "Fornecedor",
            searchForm: null,
            controller: "FornecedorCtrl",
            service: "FornecedorService"
        },

        {
            entityName: "Departamento",
            searchForm: null,
            controller: "DepartamentoCtrl",
            service: "DepartamentoService"
        },

        //Baldiado

        {
            entityName: "RevisaoValoresPrevistos",
            searchForm: null,
            controller: "RevisaoValoresPrevistosCtrl",
            service: "RevisaoValoresPrevistosService"
        },

        {
            entityName: "ServidorDeEmail",
            searchForm: null,
            controller: "ServidorDeEmailCtrl",
            service: "ServidorDeEmailService"
        },
        {
            entityName: "Contato",
            searchForm: null,
            controller: "ContatoCtrl",
            service: "ContatoService"
        },
        {
            entityName: "ContaBancaria",
            searchForm: null,
            controller: "ContaBancariaCtrl",
            service: "ContaBancariaService"
        },
        {
            entityName: "Banco",
            searchForm: null,
            controller: "BancoCtrl",
            service: "BancoService"
        },

        {
            entityName: "Perfil",
            searchForm: null,
            controller: "PerfilCtrl",
            service: "PerfilService"
        },
        {
            entityName: "GrupoAreaSistema",
            searchForm: null,
            controller: "GrupoAreaSistemaCtrl",
            service: "GrupoAreaSistemaService"
        },
        {
            entityName: "AreaSistema",
            searchForm: null,
            controller: "AreaSistemaCtrl",
            service: "AreaSistemaService"
        },
        {
            entityName: "Papel",
            searchForm: null,
            controller: "PapelCtrl",
            service: "PapelService"
        },


        {
            entityName: "ItemDeServico",
            searchForm: null,
            controller: "ItemDeServicoCtrl",
            service: "ItemDeServicoService"
        },
        {
            entityName: "ItemContratado",
            searchForm: null,
            controller: "ItemContratadoCtrl",
            service: "ItemContratadoService"
        },
        // {entityName: "Finalizacao", searchForm: "app/pages/" , controller: "FinalizacaoCtrl", service: "FinalizacaoService"},
        // {entityName: "RegistroDeOcorrencia", searchForm: "app/pages/" , controller: "RegistroDeOcorrenciaCtrl", service: "RegistroDeOcorrenciaService"},
        // {entityName: "Permissao", searchForm: "app/pages/" , controller: "PermissaoCtrl"},
        // {entityName: "PerfilDeAcesso", searchForm: "app/pages/" , controller: "PerfilDeAcessoCtrl"},
        // {entityName: "Situacao", searchForm: "app/pages/" , controller: "SituacaoCtrl"},
        // {entityName: "SituacaoAtual", searchForm: "app/pages/" , controller: "SituacaoAtualCtrl"},
        // {entityName: "ResultadoMI", searchForm: "app/pages/" , controller: "ResultadoMICtrl"},
        // {entityName: "Endereco", searchForm: "app/pages/" , controller: "EnderecoCtrl"},
        // {entityName: "Telefone", searchForm: "app/pages/" , controller: "TelefoneCtrl"},
        // {entityName: "Arquivo", searchForm: "app/pages/" , controller: "ArquivoCtrl"},
        // {entityName: "CentroDeCustoGeral", searchForm: "app/pages/" , controller: "CentroDeCustoGeralCtrl"},
        // {entityName: "Natureza", searchForm: "app/pages/" , controller: "NaturezaCtrl"},
        // {entityName: "GrupoClausula", searchForm: "app/pages/" , controller: "GrupoClausulaCtrl"},
        // {entityName: "Clausula", searchForm: "app/pages/" , controller: "ClausulaCtrl"},
        // {entityName: "ItemClausula", searchForm: "app/pages/" , controller: "ItemClausulaCtrl"},
        // {entityName: "IndicadorEconomico", searchForm: "app/pages/" , controller: "IndicadorEconomicoCtrl"},
        // {entityName: "ValorPrevisto", searchForm: "app/pages/" , controller: "ValorPrevistoCtrl"},
        // {entityName: "Programa", searchForm: "app/pages/" , controller: "ProgramaCtrl"},
        // {entityName: "NivelItemDeServico", searchForm: "app/pages/" , controller: "NivelItemDeServicoCtrl"},
        // {entityName: "RevisaoItemContratado", searchForm: "app/pages/" , controller: "RevisaoItemContratadoCtrl"},
        // {entityName: "ValorIndicador", searchForm: "app/pages/" , controller: "ValorIndicadorCtrl"},
        // {entityName: "Consulta", searchForm: "app/pages/" , controller: "ConsultaCtrl"},
        // {entityName: "FiltroConsulta", searchForm: "app/pages/" , controller: "FiltroConsultaCtrl"},
        // {entityName: "ItemMedido", searchForm: "app/pages/" , controller: "ItemMedidoCtrl"},
        // {entityName: "ItemFormatoContaContabil", searchForm: "app/pages/" , controller: "ItemFormatoContaContabilCtrl"},
        // {entityName: "DefinicaoPrograma", searchForm: "app/pages/" , controller: "DefinicaoProgramaCtrl"},
        // {entityName: "ItemMedidoContratoInterno", searchForm: "app/pages/" , controller: "ItemMedidoContratoInternoCtrl"},
        // {entityName: "ItemContratadoContratoInterno", searchForm: "app/pages/" , controller: "ItemContratadoContratoInternoCtrl"},
        // {entityName: "PlanoDeConta", searchForm: "app/pages/" , controller: "PlanoDeContaCtrl"},
        // {entityName: "ItemPlanoDeConta", searchForm: "app/pages/" , controller: "ItemPlanoDeContaCtrl"},

    ];

    $scope.getService = function (serviceName) {
        $scope.service = $injector.get(serviceName);
        self.service = new $scope.service();
    };

    $scope.OnEntidadeChange = function (entidade) {
        $scope.isLoading = true;
        $scope.clear();
        if (entidade != null) {           
            for (var i = 0; i <= $scope.entities.length - 1; i++) {
                if ($scope.entities[i].searchForm != null && entidade == $scope.entities[i].entityName) {
                    $scope.entitySelected = $scope.entities[i];
                    $scope.isLoading = false;
                    break;
                }
            }
        }

        if ($scope.entitySelected != null) {
            $scope.getService($scope.entitySelected.service);
            // $scope.controller = $controller($scope.entitySelected.controller, {
            //     $scope: $scope
            // }).constructor;
        }
    };

    $scope.find = function (entityId) {
        self.find(entityId).then(function (data) {
            $scope.formatar(data);
        })
    };

    self.activate = function () {
        if ($stateParams.entityName && $stateParams.entityId) {
            $scope.entityName = $stateParams.entityName;
            $scope.entityId = $stateParams.entityId;
            $scope.OnEntidadeChange($scope.entityName);
            $scope.getService($scope.entitySelected.service);
            $scope.find($stateParams.entityId);
        }
    };

    self.activate();


    $scope.formatar = function (data) {
        $scope.results = [];

        angular.forEach(data, function (value, key) {
            var result = {};
            if (key != "$promise" && key != "$resolved" && key != "version" && key != "dataCriacao" && key != "dataModificacao" )
                result = {
                    key: key,
                    value: value
                }
            if (result.key != null || result.value != null) {
                if (value == null && value == undefined || angular.isArray(value) && value.length == 0) {
                    result.btnColor = "btn-danger"
                    result.status = "Não Preenchido"

                } else {
                    result.btnColor = "btn-success"
                    result.status = "Preenchido"
                }
                $scope.results.push(result);
            }
        });
    }


    $scope.formatarStatus = function (displayed) {
        $scope.displayedFormated = [];
        if (displayed != undefined)
            displayed.forEach(function (data) {
                var contadorNaoConform = 0;
                var contador = 0;

                angular.forEach(data, function (value, key) {
                    if (key != "$promise" && key != "$resolved" && key != "version" && key != "dataCriacao" && key != "dataModificacao" && key != "$$hashKey"){

                        if (value == null && value == undefined || angular.isArray(value) && value.length == 0)
                            contadorNaoConform++;
                        contador++
                    }
                });

                if (contadorNaoConform >= 1) {
                    data.status = "Não Conforme";
                    data.btnColor = "btn-danger";
                } else {
                    data.status = "Conforme";
                    data.btnColor = "btn-success";
                }

                data.percentualPreenchido = ((contador - contadorNaoConform) * 100) / contador;
                data.qtdCamposPreenchidos = contador - contadorNaoConform;
                $scope.displayedFormated.push(data);
            });

    };
});
angular.module('bentham.pages.seguranca.auditoriasistema').controller('AuditoriaSistemaCtrl', function ($scope, AuditoriaSistemaService, $filter, AlteracaoAuditoriaSistemaService, GenericController, Usuario, toastr, prefixRoute) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);

    self.service = new AuditoriaSistemaService();
    self.alteracaoService = new AlteracaoAuditoriaSistemaService();
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.filtro = {};

    // Manipulacao da variavel timeState

    $scope.initTimeState = function (itemsByPage, page, filtro) {
        return timeState = {
            page: page || 0,
            pagination: {
                number: itemsByPage,
                numberOfPages: 1,
                start: itemsByPage,
                totalItemCount: 0,
            },
            search: filtro || {},
            sort: {
                predicate: "revision.timestamp",
                sortOrder: "DESC",
            }
        }
    };

    // Inicializacao da linha do tempo

    $scope.load = function load(itemsByPage, page, filtro) {
        // Iniciando timeState para consulta de dados
        $scope.itemsByPage = itemsByPage || 25;
        timeState = $scope.initTimeState($scope.itemsByPage, page, filtro);

        $scope.isLoading = true;
        // GET de dados
        self.alteracaoService.getPage(timeState.page, timeState.pagination.number, timeState.sort.predicate, timeState.sort.sortOrder, timeState.search).then(function (result) {
                $scope.displayed = result;
                $scope.user = {
                    id: null
                };

                // Limpeza e filtragem de dados recebidos
                $scope.displayed.content.forEach(function (alt) {
                    if (alt.revision.usuario != "new_user") {
                        if ($scope.user.id == null)
                            Usuario.findByName({
                                nome: alt.revision.usuario
                            }).$promise.then(function (user) {
                                $scope.user = user;
                                feedAlt(user);
                            });
                        else if ($scope.user.id != null && $scope.user.login == alt.revision.usuario)
                            feedAlt($scope.user);
                    }

                    // Definição de cores da timeline, o componente timeline possui somente 3 cores: warning, danger e primary; porém o houve uma manipulacao do 
                    // sass do bentham em que alguns componentes primary e warning possui a mesma tonalidade. 
                    if (alt.revisionType == "MOD")
                        alt.typeColor = "warning";

                    if (alt.revisionType == "ADD")
                        alt.typeColor = "";

                    if (alt.revisionType == "DEL")
                        alt.typeColor = "danger";

                    alt.revision.timestamp = new Date(alt.revision.timestamp);

                    // Metodo de alimentacao da varialvel alteracao
                    var feedAlt = function (user) {
                        alt.revision.usuario = user;
                        if (user.imagem != null && user.imagem.id != null)
                            alt.pathImagem = prefixRoute + "arquivos/catchFile/" + user.imagem.id;
                        else
                            alt.pathImagem = $filter('appImage')('app/profile/User.svg');
                    }

                });
                $scope.displayed.page = $scope.getPage($scope.displayed.totalElements, $scope.displayed.number, $scope.displayed.size, $scope.displayed.totalPages);
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.load();

    //  Calculo para paginacao dinamica

    $scope.getPage = function (totalItems, currentPage, pageSize, totalPages) {
        var startPage, endPage;
        if (totalPages <= 10) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        var pages = [];
        startPage = startPage - 1;
        for (startPage; startPage < endPage; startPage++)
            pages.push(startPage);

        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            pages: pages
        };
    }

    // Search

    $scope.search = function (itemsByPage, page) {
        var filtro = angular.copy($scope.filtro);
        filtro.usuario != null ? filtro.usuario = filtro.usuario.login : null;
        filtro.alteracao != null ? filtro.alteracao = filtro.alteracao.name : null;
        filtro.entidade != null ? filtro.entidade = filtro.entidade.name : null;
        $scope.load(itemsByPage, page, filtro)
    };

    $scope.clear = function(){
        $scope.filtro = {};
    }

});
angular.module('bentham').factory('AuditoriaSistema', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'logs-de-auditoria/:id', {
        id: '@id',
    }, {
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'logs-de-auditoria',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'logs-de-auditoria/pageable',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'logs-de-auditoria/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },

        });
});

angular.module('bentham').factory('AuditoriaSistemaService', function (GenericService, AuditoriaSistema, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new AuditoriaSistema();
    Object.setPrototypeOf(self.resource, AuditoriaSistema);

    self.all= function () {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.all(
                function success(logs) {
                    deferred.resolve(logs);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }


    self.pageable = function () {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.pageable(
                function success(logs) {
                    deferred.resolve(logs);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () { return self; };
});
angular.module('bentham.pages.seguranca.grupoareasistema').controller('GrupoAreaSistemaCtrl', function ($scope, GrupoAreaSistemaService, GrupoAreaSistema, GrupoAreaSistema, GenericController, $state, $stateParams, $uibModal, toastr,AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new GrupoAreaSistemaService();
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.grupo = new GrupoAreaSistema();
    };

    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.grupoId) {
            self.find($stateParams.grupoId)
                .then(function (data) {
                    $scope.grupo = data;
                    $scope.isLoading = false;
                });
        } else {
            self.clear();
            $scope.isLoading = false;
        }
    }
    self.activate();

    $scope.clear = function () {
        $state.go("seguranca.grupoareasistema")
    };

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, grupo) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.grupo = grupo;
                    return grupo;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };
});
angular.module('bentham').factory('GrupoAreaSistema', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'grupo-areas-sistemas/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'grupo-areas-sistemas/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'grupo-areas-sistemas',
            },
            byperfil: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'grupo-areas-sistemas/perfil',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'grupo-areas-sistemas/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }
            },
        });
});

angular.module('bentham').factory('GrupoAreaSistemaService', function (GenericService, GrupoAreaSistema, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new GrupoAreaSistema();
    Object.setPrototypeOf(self.resource, GrupoAreaSistema);
    return function () { return self; };
});
angular.module('bentham.pages.seguranca.perfis').controller('PerfilCtrl', function ($scope, PerfilService, Perfil, GrupoAreaSistema, GenericController, $state, $stateParams, $uibModal, toastr, AuthService, $window) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new PerfilService();
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.perfil = new Perfil();
        $scope.perfil.isActive = true;
        $scope.grupos = GrupoAreaSistema.all();
    };

    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.perfilId) {
            self.find($stateParams.perfilId)
                .then(function (data) {
                    $scope.perfil = data;
                    GrupoAreaSistema.byperfil({
                        id: data.id
                    }).$promise.then(function (grupos) {
                        var result = [];

                        angular.forEach(grupos, function (grupo) {
                            angular.forEach(grupo.areasSistema, function (area) {
                                if (area.create && area.delete && area.print && area.read && area.update != null)
                                    area.all = true;
                            });
                            result.push(grupo);
                        });
                        $scope.grupos = result;
                        $scope.isLoading = false;
                    });
                });
        } else {
            self.clear();
            $scope.isLoading = false;
        }
    }

    self.activate();

    $scope.clear = function () {
        $state.go("seguranca.perfis")
    };

    $scope.save = function () {
        $scope.isLoading = true;
        angular.forEach($scope.grupos, function (grupo) {
            angular.forEach(grupo.areasSistema, function (area) {
                area.all = false;
            });
        });
        $scope.perfil.gruposAreaSistema = $scope.grupos;
        self.save($scope.perfil)
            .then(function success(data) {
                self.activate();
                $state.go("seguranca.perfis")
                $scope.isLoading = false;
            }).catch(function (error) {
                toastr.error(error.message);
                $scope.isLoading = false;
            });
    }

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, perfil) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.perfil = perfil;
                    return perfil;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.style = function (active) {
        return {
            'btn-primary': active,
            'btn-default': !active

        }
    };

    $scope.setAll = function (active, area) {
        area.all = active;
        area.create = active;
        area.read = active;
        area.update = active;
        area.delete = active;
        area.print = active;
    };

});
angular.module('bentham').factory('Perfil', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'perfis/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'perfis/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'perfis',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'perfis/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
        });
});

angular.module('bentham').factory('PerfilService', function (GenericService, Perfil, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Perfil();
    Object.setPrototypeOf(self.resource, Perfil);

 
    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();

        data.gruposAreaSistema.forEach(function(grupo){
            grupo.areasSistema.forEach(function(area){
                delete area.grupoAreaSistema;
            });
        });
        
        deferred.resolve(data);
        return deferred.promise
    };

    return function () { return self; };
});
angular.module('bentham.pages.seguranca.usuarios').controller('ProfileCtrl', function ($scope, fileReader, $filter, UsuarioService, Usuario, GenericController, $state, $stateParams, $uibModal, toastr, ArquivoService, prefixRoute) {
    var self = this;
    $scope.prefixRoute = prefixRoute;
    Object.setPrototypeOf(self, GenericController);
    self.service = new UsuarioService();
    self.arquivoService = new ArquivoService();

    $scope.usuario = new Usuario();
    $scope.usuario.pessoaFisica = { pessoa : {imagem : { nome: null }}};
    $scope.picture = $filter('appImage')('app/profile/User.svg');
    $scope.noPicture = true;
    $scope.file = null;

    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.profileId) {
            self.find($stateParams.profileId)
                .then(function (data) {
                    $scope.usuario = data;
                    if (data.pessoaFisica.pessoa.imagem != null) {
                        $scope.picture = prefixRoute + "arquivos/catchFile/" + data.pessoaFisica.pessoa.imagem.id;
                        $scope.noPicture = false;
                    }
                    $scope.isLoading = false;

                });
        }
    }

    self.activate();

    $scope.clear = function () {
        $state.go("home")
    };

    $scope.save = function () {
        $scope.isLoading = true;
        self.save($scope.usuario)
            .then(function success(data) {
                self.activate();
                $state.go("home")
                $scope.isLoading = false;
            }).catch(function (error) {
                toastr.error(error.message);
                $scope.isLoading = false;
            });
    }

    $scope.onFileSelectImagemUsuario = function ($files) {
        self.arquivoService.upload($files, "Usuario")
            .then(function success(data) {
                $scope.usuario.pessoaFisica.pessoa.imagem = data;
                toastr.success("Upload feito com sucesso!");
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.removePicture = function () {
        $scope.usuario.pessoaFisica.pessoa.imagem = null;
        $scope.picture = $filter('appImage')('app/profile/User.svg');
        $scope.noPicture = true;
    }

    $scope.uploadPicture = function () {
        var fileInput = document.getElementById('imagem');
        fileInput.click();
        $scope.noPicture = false;
    }

    $scope.getFile = function () {
        fileReader.readAsDataUrl($scope.file, $scope)
            .then(function (result) {
                $scope.picture = result;
            });
    };

    $scope.changePass = function (usuario) {
        if (usuario.senha != usuario.senhaConfirm)
            toastr.success("Senhas divergentes!");
        else
            self.service.changePass(usuario)
            .then(function success(data) {
                $state.go("seguranca.usuarios")
                toastr.success("Alteração feito com sucesso!");
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.open = function (page, size, title, usuario) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.usuario = usuario;
                    return usuario;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

});
angular.module('bentham.pages.seguranca.usuarios').controller('UsuarioCtrl', function (PessoaFisicaService, $scope, fileReader, $filter, UsuarioService, Usuario, GenericController, $state, $stateParams, $uibModal, toastr, ArquivoService, prefixRoute, AuthService, $window) {
    var self = this;
    $scope.prefixRoute = prefixRoute;
    Object.setPrototypeOf(self, GenericController);
    $scope.authService = AuthService;

    self.service = new UsuarioService();
    self.arquivoService = new ArquivoService();
    self.pessoaFisicaService = new PessoaFisicaService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.usuario = new Usuario();
        $scope.usuario.pessoaFisica = { pessoa: { imagem: {}}};
        $scope.isLoading = false;
        $scope.filtro = {}
    };

    $scope.clear = function () {
        self.clear();
    }

    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.usuarioId) {
            self.find($stateParams.usuarioId)
                .then(function (data) {
                    $scope.usuario = data;
                    if (data.pessoaFisica.pessoa.imagem != null) {
                        $scope.picture = prefixRoute + "arquivos/catchFile/" + data.pessoaFisica.pessoa.imagem.id;
                        $scope.noPicture = false;
                    } else {
                        $scope.picture = $filter('appImage')('app/profile/User.svg');
                        $scope.noPicture = true;
                    }
                    $scope.isLoading = false;

                });
        } else {
            self.clear();
            $scope.isLoading = false;

        }
    }

    self.activate();

    $scope.clear = function () {
        $state.go("seguranca.usuarios")
    };

    $scope.save = function () {
        $scope.isLoading = true;
        if ($scope.usuario.pessoaFisica.pessoa.imagem == null || $scope.usuario.pessoaFisica.pessoa.imagem.id == null || $scope.usuario.pessoaFisica.pessoa.imagem == undefined)
            $scope.usuario.pessoaFisica.pessoa.imagem = null;


        self.save($scope.usuario)
            .then(function success(data) {
                self.activate();
                $state.go("seguranca.usuarios")
                $scope.isLoading = false;
            }).catch(function (error) {
                toastr.error(error.message);
                $scope.isLoading = false;
            });
    }
    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        filtro.tipo = ($scope.filtro.tipo != null) ? $scope.filtro.tipo.name : null;
        filtro.perfil != null ? filtro.perfil = filtro.perfil.id : null;
        if ($scope.aberto == true)
            filtro.search = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, usuario) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.usuario = usuario;
                    return usuario;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.onFileSelectImagemUsuario = function ($files) {
        self.arquivoService.upload($files, "Usuario")
            .then(function success(data) {
                $scope.usuario.pessoaFisica.pessoa.imagem = data;
                toastr.success("Upload feito com sucesso!");
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.removePicture = function () {
        $scope.usuario.pessoaFisica.pessoa.imagem = null;
        $scope.picture = $filter('appImage')('app/profile/User.svg');
        $scope.noPicture = true;
    }

    $scope.uploadPicture = function () {
        var fileInput = document.getElementById('imagem');
        fileInput.click();
        $scope.noPicture = false;
    }

    $scope.getFile = function () {
        fileReader.readAsDataUrl($scope.file, $scope)
            .then(function (result) {
                $scope.picture = result;
            });
    };

    $scope.changePass = function (usuario) {
        if (usuario.senha != usuario.senhaConfirm)
            toastr.success("Senhas divergentes!");
        else
            self.service.changePass(usuario)
                .then(function success(data) {
                    $state.go("seguranca.usuarios")
                    toastr.success("Alteração feito com sucesso!");
                })
                .catch(function (error) {
                    toastr.error(error.message);
                });
    };


    $scope.onCpfBlur = function (cpf) {
        self.pessoaFisicaService.byCpf(cpf).then(function (data) {
            if (data.id != null && data.id != undefined)
                $scope.usuario.pessoaFisica = data;
        });
    };

});
angular.module('bentham').factory('Usuario', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'usuarios/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'usuarios/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            changePass: {
                method: 'POST',
                url: prefixRoute + 'usuarios/alterar-senha',
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'usuarios',
            },
            findByName: {
                method: 'GET',
                url: prefixRoute + 'usuarios/findByName',
            },
            findByPerfilDescricaoContainingAndAtivoTrue: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'usuarios/findByPerfilDescricaoContainingAndAtivoTrue',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'usuarios/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
        });
});

angular.module('bentham').factory('UsuarioService', function (GenericService, Usuario, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Usuario();
    Object.setPrototypeOf(self.resource, Usuario);

    self.changePass = function (usuario) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.changePass('' , usuario,
                function success(usuario) {
                    deferred.resolve(usuario);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () { return self; };
});
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function() {
    'use strict';

    /**
     * Includes basic panel layout inside of current element.
     */
    angular.module('bentham.theme')
        .directive('baPanel', baPanel);

    /** @ngInject */
    function baPanel(baPanel, baConfig) {
        return angular.extend({}, baPanel, {
            template: function(el, attrs) {
                var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
                res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
                res += baPanel.template(el, attrs);
                res += '</div>';
                return res;
            }
        });
    }
})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .factory('baPanel', baPanel);

    /** @ngInject */
    function baPanel() {

        /** Base baPanel directive */
        return {
            restrict: 'A',
            transclude: true,
            template: function(elem, attrs) {
                var res = '<div class="panel-body" ng-transclude></div>';
                if (attrs.baPanelTitle) {
                    var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
                    res = titleTpl + res; // title should be before
                }

                return res;
            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .directive('baPanelBlur', baPanelBlur);

    /** @ngInject */
    function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
        var bodyBgSize;

        baPanelBlurHelper.bodyBgLoad().then(function() {
            bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
        });

        $window.addEventListener('resize', function() {
            bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
        });

        return {
            restrict: 'A',
            link: function($scope, elem) {
                if (!$rootScope.$isMobile) {
                    baPanelBlurHelper.bodyBgLoad().then(function() {
                        setTimeout(recalculatePanelStyle);
                    });
                    $window.addEventListener('resize', recalculatePanelStyle);

                    $scope.$on('$destroy', function() {
                        $window.removeEventListener('resize', recalculatePanelStyle);
                    });
                }

                function recalculatePanelStyle() {
                    if (!bodyBgSize) {
                        return;
                    }
                    elem.css({
                        backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
                        backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
                    });
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .service('baPanelBlurHelper', baPanelBlurHelper);

    /** @ngInject */
    function baPanelBlurHelper($q) {
        var res = $q.defer();
        var computedStyle = getComputedStyle(document.body, ':before');
        var image = new Image();
        image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
        image.onerror = function() {
            res.reject();
        };
        image.onload = function() {
            res.resolve();
        };

        this.bodyBgLoad = function() {
            return res.promise;
        };

        this.getBodyBgImageSizes = function() {
            var elemW = document.documentElement.clientWidth;
            var elemH = document.documentElement.clientHeight;
            if (elemW <= 640) return;
            var imgRatio = (image.height / image.width); // original img ratio
            var containerRatio = (elemH / elemW); // container ratio

            var finalHeight, finalWidth;
            if (containerRatio > imgRatio) {
                finalHeight = elemH;
                finalWidth = (elemH / imgRatio);
            } else {
                finalWidth = elemW;
                finalHeight = (elemW * imgRatio);
            }
            return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth) / 2, positionY: (elemH - finalHeight) / 2 };
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function() {
    'use strict';

    /**
     * Represents current element as panel, adding all necessary classes.
     */
    angular.module('bentham.theme')
        .directive('baPanelSelf', baPanelSelf);

    /** @ngInject */
    function baPanelSelf(baPanel) {
        return angular.extend({}, baPanel, {
            link: function(scope, el, attrs) {
                el.addClass('panel panel-white');
                if (attrs.baPanelClass) {
                    el.addClass(attrs.baPanelClass);
                }
            }
        });
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme.components')
        .controller('BaSidebarCtrl', BaSidebarCtrl);

    /** @ngInject */
    function BaSidebarCtrl($scope, baSidebarService) {

        $scope.menuItems = baSidebarService.getMenuItems();
        $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

        $scope.hoverItem = function($event) {
            $scope.showHoverElem = true;
            $scope.hoverElemHeight = $event.currentTarget.clientHeight;
            var menuTopValue = 66;
            $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
        };

        $scope.$on('$stateChangeSuccess', function() {
            if (baSidebarService.canSidebarBeHidden()) {
                baSidebarService.setMenuCollapsed(true);
            }
        });
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme.components')
        .directive('baSidebar', baSidebar);

    /** @ngInject */
    function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
        var jqWindow = $(window);
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
            controller: 'BaSidebarCtrl',
            link: function(scope, el) {

                scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
                jqWindow.on('click', _onWindowClick);
                jqWindow.on('resize', _onWindowResize);

                scope.$on('$destroy', function() {
                    jqWindow.off('click', _onWindowClick);
                    jqWindow.off('resize', _onWindowResize);
                });

                function _onWindowClick($evt) {
                    if (!baUtil.isDescendant(el[0], $evt.target) &&
                        !$evt.originalEvent.$sidebarEventProcessed &&
                        !baSidebarService.isMenuCollapsed() &&
                        baSidebarService.canSidebarBeHidden()) {
                        $evt.originalEvent.$sidebarEventProcessed = true;
                        $timeout(function() {
                            baSidebarService.setMenuCollapsed(true);
                        }, 10);
                    }
                }

                // watch window resize to change menu collapsed state if needed
                function _onWindowResize() {
                    var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
                    var newMenuHeight = _calculateMenuHeight();
                    if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
                        scope.$apply(function() {
                            scope.menuHeight = newMenuHeight;
                            baSidebarService.setMenuCollapsed(newMenuCollapsed)
                        });
                    }
                }

                function _calculateMenuHeight() {
                    return el[0].childNodes[0].clientHeight - 84;
                }
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('bentham.theme.components')
        .provider('baSidebarService', baSidebarServiceProvider);

    /** @ngInject */
    function baSidebarServiceProvider($injector) {
        var staticMenuItems = [];

        this.addStaticItem = function () {
            staticMenuItems.push.apply(staticMenuItems, arguments);
        };

        /** @ngInject */
        this.$get = function ($state, layoutSizes, AuthService) {
            return new _factory();

            function _factory() {
                var isMenuCollapsed = shouldMenuBeCollapsed();

                var removeStatus = function removeStatus(children) {
                    var remove = [];
                    for (var i = 0; i < children.length; i++){if (children[i].subMenu == null && children[i].roles == undefined) remove.push(children[i]);};
                    remove.forEach(function (s) {children.splice(children.indexOf(s), 1);});
                    return children;
                }

                //Menu level 0
                this.getMenuItems = function () {
                    var states = defineMenuItemStates();
                    var children0 = states.filter(function (child0) {
                        return child0.level == 0;
                    });

                    //Menu level 1
                    children0.forEach(function (item1) {
                        var children1 = states.filter(function (child1) {
                            return child1.level == 1 && child1.name.indexOf(item1.name) === 0;
                        });

                        //Menu level 2
                        children1.forEach(function (item2) {
                            var children2 = states.filter(function (child2) {
                                return child2.level == 2 && child2.name.indexOf(item2.name) === 0;

                            });

                            //Menu level 3
                            children2.forEach(function (item3) {
                                var children3 = states.filter(function (child3) {
                                    return child3.level == 3 && child3.name.indexOf(item3.name) === 0;
                                });
                                removeStatus(children3);
                                item3.subMenu = children3.length ? children3 : null;
                            });
                            removeStatus(children2);
                            item2.subMenu = children2.length ? children2 : null;
                        });

                        removeStatus(children1);
                        item1.subMenu = children1.length ? children1 : null;

                    });
                    removeStatus(children0);
                    return children0.concat(staticMenuItems);
                };

                this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
                this.canSidebarBeHidden = canSidebarBeHidden;

                this.setMenuCollapsed = function (isCollapsed) {
                    isMenuCollapsed = isCollapsed;
                };

                this.isMenuCollapsed = function () {
                    return isMenuCollapsed;
                };

                this.toggleMenuCollapsed = function () {
                    isMenuCollapsed = !isMenuCollapsed;
                };

                this.getAllStateRefsRecursive = function (item) {
                    var result = [];
                    _iterateSubItems(item);
                    return result;

                    function _iterateSubItems(currentItem) {
                        currentItem.subMenu && currentItem.subMenu.forEach(function (subItem) {
                            subItem.stateRef && result.push(subItem.stateRef);
                            _iterateSubItems(subItem);
                        });
                    }
                };

                function defineMenuItemStates() {
                    return $state.get()
                        .filter(function (s) {
                            if (s.roles == undefined || s.roles.length == 0)
                                return s.sidebarMeta;
                            else if (s.roles != undefined && s.roles.length > 0 && AuthService.isInAnyRole(s.roles))
                                return s.sidebarMeta;
                        })
                        .map(function (s) {
                            var meta = s.sidebarMeta;
                            return {
                                name: s.name,
                                title: s.title,
                                level: (s.name.match(/\./g) || []).length,
                                order: meta.order,
                                icon: meta.icon,
                                stateRef: s.name,
                                roles: s.roles,
                            };
                        })
                        .sort(function (a, b) {
                            return (a.level - b.level) * 100 + a.order - b.order;
                        });
                }

                function shouldMenuBeCollapsed() {
                    return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
                }

                function canSidebarBeHidden() {
                    return window.innerWidth <= layoutSizes.resWidthHideSidebar;
                }
            }

        };

    }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
    'use strict';

    angular.module('bentham.theme.components')
        .directive('baSidebarToggleMenu', baSidebarToggleMenu)
        .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
        .directive('baSidebarTogglingItem', baSidebarTogglingItem)
        .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
        .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
        .directive('baUiSrefToggler', baUiSrefToggler);

    /** @ngInject */
    function baSidebarToggleMenu(baSidebarService) {
        return {
            restrict: 'A',
            link: function (scope, elem) {
                elem.on('click', function ($evt) {
                    $evt.originalEvent.$sidebarEventProcessed = true;
                    scope.$apply(function () {
                        baSidebarService.toggleMenuCollapsed();
                    });
                });
            }
        };
    }

    /** @ngInject */
    function baSidebarCollapseMenu(baSidebarService) {
        return {
            restrict: 'A',
            link: function (scope, elem) {
                elem.on('click', function ($evt) {
                    $evt.originalEvent.$sidebarEventProcessed = true;
                    if (!baSidebarService.isMenuCollapsed()) {
                        scope.$apply(function () {
                            baSidebarService.setMenuCollapsed(true);
                        });
                    }
                });
            }
        };
    }

    /** @ngInject */
    function baSidebarTogglingItem() {
        return {
            restrict: 'A',
            controller: 'BaSidebarTogglingItemCtrl'
        };
    }

    /** @ngInject */
    function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
        var vm = this;
        var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
        if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
            vm.$$expandSubmenu = function () {
                console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu')
            };
            vm.$$collapseSubmenu = function () {
                console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu')
            };

            var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

            vm.$expand = function () {
                vm.$$expandSubmenu();
                $element.addClass('ba-sidebar-item-expanded');
            };

            vm.$collapse = function () {
                vm.$$collapseSubmenu();
                $element.removeClass('ba-sidebar-item-expanded');
            };

            vm.$toggle = function () {
                $element.hasClass('ba-sidebar-item-expanded') ?
                    vm.$collapse() :
                    vm.$expand();
            };

            if (_isState($state.current)) {
                $element.addClass('ba-sidebar-item-expanded');
            }

            $scope.$on('$stateChangeStart', function (event, toState) {
                if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
                    vm.$collapse();
                    $element.removeClass('ba-sidebar-item-expanded');
                }
            });

            $scope.$on('$stateChangeSuccess', function (event, toState) {
                if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
                    vm.$expand();
                    $element.addClass('ba-sidebar-item-expanded');
                }
            });
        }

        function _isState(state) {
            return state && subItemsStateRefs.some(function (subItemState) {
                return state.name.indexOf(subItemState) == 0;
            });
        }
    }

    /** @ngInject */
    function baUiSrefTogglingSubmenu($state) {
        return {
            restrict: 'A',
            require: '^baSidebarTogglingItem',
            link: function (scope, el, attrs, baSidebarTogglingItem) {
                baSidebarTogglingItem.$$expandSubmenu = function () {
                    el.slideDown();
                };
                baSidebarTogglingItem.$$collapseSubmenu = function () {
                    el.slideUp();
                };
            }
        };
    }

    /** @ngInject */
    function baUiSrefToggler(baSidebarService) {
        return {
            restrict: 'A',
            require: '^baSidebarTogglingItem',
            link: function (scope, el, attrs, baSidebarTogglingItem) {
                el.on('click', function () {
                    if (baSidebarService.isMenuCollapsed()) {
                        // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
                        // This should not affect mobiles, because on mobiles sidebar should be hidden at all
                        scope.$apply(function () {
                            baSidebarService.setMenuCollapsed(false);
                        });
                        baSidebarTogglingItem.$expand();
                    } else {
                        baSidebarTogglingItem.$toggle();
                    }
                });
            }
        };
    }

})();
(function() {
    'use strict';

    angular.module('bentham.theme.components')
        .directive('baWizard', baWizard);

    /** @ngInject */
    function baWizard() {
        return {
            restrict: 'E',
            transclude: true,
            templateUrl: 'app/theme/components/baWizard/baWizard.html',
            controllerAs: '$baWizardController',
            controller: 'baWizardCtrl'
        }
    }
})();
(function() {
    'use strict';

    angular.module('bentham.theme.components')
        .controller('baWizardCtrl', baWizardCtrl);

    /** @ngInject */
    function baWizardCtrl($scope) {
        var vm = this;
        vm.tabs = [];

        vm.tabNum = 0;
        vm.progress = 0;

        vm.addTab = function(tab) {
            tab.setPrev(vm.tabs[vm.tabs.length - 1]);
            vm.tabs.push(tab);
            vm.selectTab(0);
        };

        $scope.$watch(angular.bind(vm, function() { return vm.tabNum; }), calcProgress);

        vm.selectTab = function(tabNum) {
            vm.tabs[vm.tabNum].submit();
            if (vm.tabs[tabNum].isAvailiable()) {
                vm.tabNum = tabNum;
                vm.tabs.forEach(function(t, tIndex) {
                    tIndex == vm.tabNum ? t.select(true) : t.select(false);
                });
            }
        };

        vm.isFirstTab = function() {
            return vm.tabNum == 0;
        };

        vm.isLastTab = function() {
            return vm.tabNum == vm.tabs.length - 1;
        };

        vm.nextTab = function() {
            vm.selectTab(vm.tabNum + 1)
        };

        vm.previousTab = function() {
            vm.selectTab(vm.tabNum - 1)
        };

        function calcProgress() {
            vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
        }
    }
})();
(function() {
    'use strict';

    angular.module('bentham.theme.components')
        .directive('baWizardStep', baWizardStep);

    /** @ngInject */
    function baWizardStep() {
        return {
            restrict: 'E',
            transclude: true,
            require: '^baWizard',
            scope: {
                form: '='
            },
            templateUrl: 'app/theme/components/baWizard/baWizardStep.html',
            link: function($scope, $element, $attrs, wizard) {
                $scope.selected = true;

                var tab = {
                    title: $attrs.title,
                    select: select,
                    submit: submit,
                    isComplete: isComplete,
                    isAvailiable: isAvailiable,
                    prevTab: undefined,
                    setPrev: setPrev
                };

                wizard.addTab(tab);

                function select(isSelected) {
                    if (isSelected) {
                        $scope.selected = true;
                    } else {
                        $scope.selected = false;
                    }
                }

                function submit() {
                    $scope.form && $scope.form.$setSubmitted(true);
                }

                function isComplete() {
                    return $scope.form ? $scope.form.$valid : true;
                }

                function isAvailiable() {
                    return tab.prevTab ? tab.prevTab.isComplete() : true;
                }

                function setPrev(pTab) {
                    tab.prevTab = pTab;
                }
            }
        };
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme.components')
        .directive('backTop', backTop);

    /** @ngInject */
    function backTop() {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/backTop/backTop.html',
            controller: function() {
                $('#backTop').backTop({
                    'position': 200,
                    'speed': 100
                });
            }
        };
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme.components')
        .directive('contentTop', contentTop);

    /** @ngInject */
    function contentTop($location, $state) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/contentTop/contentTop.html',
            link: function($scope) {
                $scope.$watch(function() {
                    $scope.activePageTitle = $state.current.title;
                });
            }
        };
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme.components')
        .controller('MsgCenterCtrl', MsgCenterCtrl);

    /** @ngInject */
    function MsgCenterCtrl($scope, $sce) {
        $scope.users = {
            0: {
                name: 'Vlad',
            },
            1: {
                name: 'Kostya',
            },
            2: {
                name: 'Andrey',
            },
            3: {
                name: 'Nasta',
            }
        };

        $scope.notifications = [{
                userId: 0,
                template: '&name posted a new article.',
                time: '1 min ago'
            },
            {
                userId: 1,
                template: '&name changed his contact information.',
                time: '2 hrs ago'
            },
            {
                image: 'assets/img/shopping-cart.svg',
                template: 'New orders received.',
                time: '5 hrs ago'
            },
            {
                userId: 2,
                template: '&name replied to your comment.',
                time: '1 day ago'
            },
            {
                userId: 3,
                template: 'Today is &name\'s birthday.',
                time: '2 days ago'
            },
            {
                image: 'assets/img/comments.svg',
                template: 'New comments on your post.',
                time: '3 days ago'
            },
            {
                userId: 1,
                template: '&name invited you to join the event.',
                time: '1 week ago'
            }
        ];

        $scope.messages = [{
                userId: 3,
                text: 'After you get up and running, you can place Font Awesome icons just about...',
                time: '1 min ago'
            },
            {
                userId: 0,
                text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
                time: '2 hrs ago'
            },
            {
                userId: 1,
                text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
                time: '10 hrs ago'
            },
            {
                userId: 2,
                text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
                time: '1 day ago'
            },
            {
                userId: 3,
                text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
                time: '1 day ago'
            },
            {
                userId: 1,
                text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
                time: '2 days ago'
            },
            {
                userId: 0,
                text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
                time: '1 week ago'
            }
        ];

        $scope.getMessage = function(msg) {
            var text = msg.template;
            if (msg.userId || msg.userId === 0) {
                text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
            }
            return $sce.trustAsHtml(text);
        };
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme.components')
        .directive('msgCenter', msgCenter);

    /** @ngInject */
    function msgCenter() {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
            controller: 'MsgCenterCtrl'
        };
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme.components')
        .directive('pageTop', pageTop);

    /** @ngInject */
    function pageTop() {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/pageTop/pageTop.html',
            controllerAs: '$pageTopController',
            controller: 'pageTopCtrl'
        };
    }

})();
angular.module('bentham').controller('pageTopCtrl', function ($rootScope, $scope, $filter, AuthService, Usuario, prefixRoute, GenericController, ContratoExterno, PessoaJuridica, PessoaJuridicaService, AuthService) {
    self = this;
    self.scopes = $scope;
    Object.setPrototypeOf(self, GenericController);
    $scope.user = new Usuario();
    $scope.authService  = AuthService;
    $scope.prefixRoute = prefixRoute;
    $scope.service = new PessoaJuridicaService();
    
    $scope.setContrato = function (contrato) {
        $scope.contrato = contrato;
        $scope.onContratoChange($scope.contrato);
    };

    $scope.setPessoaJuridica = function (pessoaJuridica) {
        $scope.pessoaJuridica = pessoaJuridica;
        $scope.onPessoaJuridicaChange($scope.pessoaJuridica);
    };

    $scope.setUser = function (user) {
        $scope.user = user;
        ContratoExterno.all().$promise.then(function (data) {
            data = $filter('orderBy')(data, 'dataAssinaturaContrato').reverse();
            $scope.setContrato(data[0]);
        });
        $scope.service.list( null, null, null, null, { predicateObject : { usuario : !! $scope.user ? $scope.user.id : null } })
            .then(function (result) { 
                $scope.setPessoaJuridica(result[0]); 
                $scope.pessoasJuridicas = result;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    AuthService.user()
        .then(function success(data) {
            Usuario.findByName({ nome: data }, 
                function (user) { $scope.setUser(user) 
            });
        });


    $scope.logout = function () {
        AuthService.logout();
    };

    $scope.onContratoChange = function (contrato) {
        $rootScope.$broadcast("sendContrato", contrato);
        $rootScope.contrato = contrato;
    };

    $scope.onPessoaJuridicaChange = function (pessoaJuridica) {
        $rootScope.$broadcast("sendPessoaJuridica", pessoaJuridica);
        $rootScope.pessoaJuridica = pessoaJuridica;
    };

});
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function() {
    'use strict';

    angular.module('bentham.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link: function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function() {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme.components')
        .directive('widgets', widgets);

    /** @ngInject */
    function widgets() {
        return {
            restrict: 'EA',
            scope: {
                ngModel: '='
            },
            templateUrl: 'app/theme/components/widgets/widgets.html',
            replace: true
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .filter('appImage', appImage);

    /** @ngInject */
    function appImage(layoutPaths) {
        return function(input) {
            return layoutPaths.images.root + input;
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .filter('kameleonImg', kameleonImg);

    /** @ngInject */
    function kameleonImg(layoutPaths) {
        return function(input) {
            return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .filter('profilePicture', profilePicture);

    /** @ngInject */
    function profilePicture(layoutPaths) {
        return function(input, ext) {
        
            ext = ext || 'svg';
        
            return layoutPaths.images.profile + input + '.' + ext;
    
        };
    }

})();
/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function() {
    'use strict';

    angular.module('bentham.theme')
        .filter('plainText', plainText);

    /** @ngInject */
    function plainText() {
        return function(text) {
            return text ? String(text).replace(/<[^>]+>/gm, '') : '';
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function() {
    'use strict';

    angular.module('bentham.theme.inputs')
        .directive('baSwitcher', baSwitcher);

    /** @ngInject */
    function baSwitcher() {
        return {
            templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
            scope: {
                switcherStyle: '@',
                switcherValue: '='
            }
        };
    }

})();
angular.module('bentham.pages.cadastrosbasicos').controller('ResponsavelCtrl', function ($scope, $state, PessoaFisicaService, GenericController, $stateParams, PessoaFisica, $uibModal, AuthService, $window, toastr) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    $scope.authService = AuthService;
    self.service = new PessoaFisicaService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.pessoaFisica = new PessoaFisica();
        $scope.pessoaFisica.pessoa = {};
        $scope.filtro = {};
    };
    self.clear();
    
    // self.activate = function () {
    //     $scope.isLoading = true;
    //     if ($stateParams.pessoaFisicaId) {
    //         self.find($stateParams.pessoaFisicaId)
    //             .then(function (data) {
    //                 $scope.pessoaFisica = data;
    //                 $scope.endereco = $scope.pessoaFisica.pessoa.endereco  != null ? $scope.pessoaFisica.pessoa.endereco : {};
    //                 $scope.isLoading = false;
    //             })
    //     } else {
    //         self.clear();
    //         $scope.isLoading = false;
    //     }
    // }

    // self.activate();


    $scope.load = function load(tableState) {
        self.initTableState(tableState, "pessoa.nome");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    }

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    if(entity.pessoa.endereco == null)
                    entity.pessoa.endereco = {};
                    $scope.pessoaFisica = entity;
                    $scope.endereco = entity.pessoa.endereco;
                    return entity;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.clear = function () {
        $window.history.back();
    }
    
    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        if ($scope.aberto == true)
            filtro.search = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };

    $scope.clear = function () {
        self.clear();
    };

});
angular.module('bentham').factory('Responsavel', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'responsavel-clientes/:id', {
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'responsavel-clientes/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'responsavel-clientes',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'responsavel-clientes/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        },
        byCpf: {
            method: 'GET',
            url: prefixRoute + 'responsavel-clientes/byCpf',
        }
    });
});

angular.module('bentham').factory('ResponsavelService', function (GenericService, Responsavel, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Responsavel();
    Object.setPrototypeOf(self.resource, Responsavel);


    self.byCpf = function (cpf) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.byCpf({
                    cpf: cpf
                },
                function (data) {
                    deferred.resolve(data);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }



    return function () {
        return self;
    };
});
angular.module('bentham').factory('Campo', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'campos/:id', {
        id: '@id',
    }, {
            delete: {   
                method: 'DELETE',
                url: prefixRoute + 'campos/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'campos/',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'campos/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            }
        });
});

angular.module('bentham').factory('CampoService', function (GenericService, Campo) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Campo();
    Object.setPrototypeOf(self.resource, Campo);
    return function () { return self; };
});
angular.module('bentham.pages.contratos.consorcios').controller('ConsorcioParceiroCtrl', function ($scope, AuthService, ConsorcioParceiro,GenericController, $stateParams, ConsorcioParceiroService, toastr, $uibModal, $window) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  self.service = new ConsorcioParceiroService();

  $scope.authService = AuthService;

  $scope.itemsByPage = 25;
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  self.clear = function clear(){
    $scope.consorcioParceiro = new ConsorcioParceiro();
    $scope.consorcioParceiro.consorcio = $scope.consorcio;
    $scope.consorcioParceiro.isLider = false;
  };

  self.clear();

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "id");
    $scope.isLoading = true;
    if ($stateParams.consorcioId)
      tableState.search.consorcioId = $stateParams.consorcioId;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  };


  $scope.open = function (page, size, title, consorcioParceiro) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          if(consorcioParceiro == null || consorcioParceiro == undefined)
            self.clear();
          $scope.consorcioParceiro = consorcioParceiro;
          return consorcioParceiro;
        },
        self: function () {
          return self;
        },
        title: function () {
          return title;
        }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

  $scope.clear = function(){
    $window.history.back();
  }

});
angular.module('bentham').factory('ConsorcioParceiro', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'consorcios-parceiros/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'consorcios-parceiros/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'consorcios-parceiros',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'consorcios-parceiros/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            }
        });
});

angular.module('bentham').factory('ConsorcioParceiroService', function (GenericService, ConsorcioParceiro, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ConsorcioParceiro();
    Object.setPrototypeOf(self.resource, ConsorcioParceiro);
    
    return function () { return self; };
});
angular.module('bentham.pages.contratos.contratosexternos').controller('ContratoExternoDocumentoCtrl', function ($scope, ContratoExternoDocumento, ContratoExternoDocumentoService, TipoDocumentoService, GenericController, toastr, DocumentoService, $uibModal) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);

    self.service = new ContratoExternoDocumentoService();
    self.tipoDocumentoService = new TipoDocumentoService();
    self.documentoService = new DocumentoService();

    self.clear = function () {
        $scope.contratoExternoDocumento = new ContratoExternoDocumento();
        $scope.contratoExternoDocumento.contratoExterno = $scope.contrato;
    };
    // Limpando anexos ja implementados //Exceções de listas de arquivos
    $scope.clear = function (result) {
        var tipos = [];
        result.forEach(function (r) {
            if (r.tipoAnexo.name != "ORDEM_DE_SERVICO" &&
                r.tipoAnexo.name != "CONTRATO_ASSINADO" &&
                r.tipoAnexo.name != "EDITAL" &&
                r.tipoAnexo.name != "ORCAMENTO_PREVISTO" &&
                r.tipoAnexo.name != "EXTRATO_DIARIO_OFICIAL")
                tipos.push(r);
        });
        return tipos;
    };

    var error = function (error) { $scope.isLoading = false; toastr.error(error.message); }

    var foreach = function (tipo) {
        self.service.findByContratoAndtipo($scope.contrato, tipo.tipoAnexo)
            .then(function success(result) { tipo.documentos = result; $scope.isLoading = false; })
            .catch(error);
    };

    var fillAtestado = function(atestado) { $scope.tipos.push(atestado); $scope.tipos.forEach(foreach); }

    var fillFicha = function (ficha) {
        $scope.tipos.push(ficha);
        self.tipoDocumentoService.getByTipoAnexo("ATESTADO")
            .then(fillAtestado)
            .catch(error);
    };

    var fillAll = function (result) {
        $scope.tipos = $scope.clear(result);
        self.tipoDocumentoService.getByTipoAnexo("FICHA")
            .then(fillFicha)
            .catch(error);
    };

    $scope.load = function () {
        $scope.isLoading = true;
        self.clear();
        self.tipoDocumentoService.getAllByTipoAnexo("CONTRATO")
            .then(fillAll)
            .catch(error);
    };

    $scope.load();

    $scope.onFileSelect = function ($files, e) {
        self.tipoDocumentoService.findOne(e.target.id).then(function success(tipo) {
            var path = "";

            if (tipo.tipoAnexo.name == "FICHA" || tipo.tipoAnexo.name == "ATESTADO")
                path = $scope.contrato.tipoServico.descricao;
            else
                path = $scope.contrato.regiao.descricao + "/" + $scope.contrato.folder;
            
            self.documentoService.upload($files, tipo.tipoAnexo.name, path).then(function success(data) {
                    $scope.contratoExternoDocumento.documento = data;
                    $scope.contratoExternoDocumento.tipo = data.tipoDocumento.tipoAnexo;
                    self.save($scope.contratoExternoDocumento).then(function (data) {
                        $scope.load();
                    });
                })
                .catch(function (error) {
                    toastr.error(error.message);
                });
        });
    };


    $scope.openDocumento = function (title, contratoExternoDocumento) {
        $uibModal.open({
            animation: true,
            templateUrl: 'app/pages/arquivos/entity-documento/modais/modalDelete.html',
            size: 'md',
            resolve: {
                entity: function () {
                    $scope.documento = contratoExternoDocumento;
                    return contratoExternoDocumento;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: "ModalController"
        });
    };

});
angular.module('bentham').factory('ContratoExternoDocumento', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'contrato-externo-documentos/:id', { id: '@id', }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'contrato-externo-documentos/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'contrato-externo-documentos/contrato-externo-documentos',
        },
        findByContratoAndtipo:{
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'contrato-externo-documentos/findBy-contrato-and-tipo',
        }
    });
});

angular.module('bentham').factory('ContratoExternoDocumentoService', function (GenericService, ContratoExternoDocumento, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ContratoExternoDocumento();
    Object.setPrototypeOf(self.resource, ContratoExternoDocumento);
     
    self.findByContratoAndtipo = function (contrato, tipoAnexo) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.findByContratoAndtipo({ contratoExternoId: contrato.id, tipoAnexo: tipoAnexo.name },
                function success(contrato) { deferred.resolve(contrato);},
                function (error) { error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.delete = function (documento) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.delete({ id: documento.id },
                function success(contrato) { deferred.resolve(contrato);},
                function (error) { error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }
   
    return function () { return self; };
});
angular.module('bentham.pages.contratos.contratosexternos').controller('DataImportanteCtrl', function ($scope, $q, DataImportanteService, DataImportante, PerspectivaService, Perspectiva, GenericController, $state, $stateParams, $uibModal, CentroDeCusto, Arquivo, toastr, ArquivoService, CentroDeCustoService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new DataImportanteService();
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.dataImportante = new DataImportante();
        $scope.dataImportante.contratoExterno = $scope.contrato;
    };


    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.dataId) {
            self.find($stateParams.dataId)
                .then(function (data) {
                    $scope.dataImportante = data;
                    $scope.dataImportante.contratoExterno = $scope.contrato;
                    $scope.isLoading = false;
                });
        } else {
            self.clear();
            $scope.isLoading = false;

        }
    };

    self.activate();

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "data");
        $scope.isLoading = true;
        if ($stateParams.contratoId)
            tableState.search.contratoExternoId = $stateParams.contratoId;        
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };


    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, dataImportante) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.dataImportante = dataImportante;
                    return dataImportante;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };


});

angular.module('bentham').factory('DataImportante', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'datas-importantes/:id', { id: '@id', }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'datas-importantes/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'datas-importantes',
        },
        deleteArquivo: {
            method: 'POST',
            url: prefixRoute + 'datas-importantes/arquivo/delete'
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'datas-importantes/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        }
    });
});

angular.module('bentham').factory('DataImportanteService', function (GenericService, DataImportante, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new DataImportante();
    Object.setPrototypeOf(self.resource, DataImportante);
   
    return function () { return self; };
});
angular.module('bentham').controller('AnaliseContratualCtrl', function ($scope, AnaliseContratual, AnaliseContratualService, GenericController, $stateParams, $uibModal, toastr) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new AnaliseContratualService();
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.analise = new AnaliseContratual();
        $scope.analise.produto = $scope.produto;
    };

    self.activate = function () {
        if ($stateParams.analiseId) {
            self.find($stateParams.analiseId)
                .then(function (data) {
                    $scope.analise = data;
                    $scope.analise.produto = $scope.produto;
                });
        } else {
            self.clear();
        }
    };

    $scope.AtualizarRealizado = function(realizado, analise){
        self.save(analise)
            .then(function success(data) { $scope.refresh(); });
    };

    self.activate();

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "descricao");
        $scope.isLoading = true;
        if ($stateParams.produtoId)
            tableState.search.id = $stateParams.produtoId;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.analise = entity;
                    return entity;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

});
angular.module('bentham').factory('AnaliseContratual', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'analise-contratual/:id', { id: '@id', }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'analise-contratual/:id',
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'analise-contratual',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'analise-contratual/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        },
    });
});

angular.module('bentham').factory('AnaliseContratualService', function (AnaliseContratual, GenericService, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new AnaliseContratual();
    Object.setPrototypeOf(self.resource, AnaliseContratual);

    return function () {
        return self;
    };
});
angular.module('bentham').controller('AnaliseOperacionalCtrl', function ($scope, AnaliseOperacional, AnaliseOperacionalService, GenericController, $stateParams, $uibModal, toastr) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new AnaliseOperacionalService();
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.analise = new AnaliseOperacional();
        $scope.analise.produto = $scope.produto;
    };
   
    self.activate = function () {
        if ($stateParams.analiseId) {
            self.find($stateParams.analiseId)
                .then(function (data) {
                    $scope.analise = data;
                    $scope.analise.produto = $scope.produto;
                });
        } else {
            self.clear();
        }
    };

    self.activate();

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "descricao");
        $scope.isLoading = true;   
        if ($stateParams.produtoId)
            tableState.search.id = $stateParams.produtoId;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.analise = entity;
                    return entity;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

});
angular.module('bentham').factory('AnaliseOperacional', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'analise-operacional/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'analise-operacional/:id',
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'analise-operacional',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'analise-operacional/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }
            },
        });
});

angular.module('bentham').factory('AnaliseOperacionalService', function (AnaliseOperacional, GenericService, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new AnaliseOperacional();
    Object.setPrototypeOf(self.resource, AnaliseOperacional);

    return function () {
        return self;
    };
});
angular.module('bentham').controller('ComentarioContaReceberCtrl', function ($scope, ComentarioContaReceber, ComentarioContaReceberService, GenericController, $stateParams, $uibModal, toastr) {


    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new ComentarioContaReceberService();
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;


    self.clear = function clear() {
        $scope.analise = new ComentarioContaReceber();
        $scope.analise.conta = $scope.contaReceber;//{ id: $stateParams.produtoId }
    };
   
    self.activate = function () {
        if ($stateParams.analiseId) {
            self.find($stateParams.analiseId)
                .then(function (data) {
                    $scope.analise = data;
                    $scope.analise.conta = $scope.contaReceber;//{ id: $stateParams.produtoId }
                });
        } else {
            self.clear();
        }
    };

    self.activate();

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "descricao");
        $scope.isLoading = true;   
        if ($stateParams.contaReceberId)
            tableState.search.contaId = $stateParams.contaReceberId;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.analise = entity;
                    return entity;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

});
angular.module('bentham').factory('ComentarioContaReceber', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'comentario-conta-receber/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'comentario-conta-receber/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'comentario-conta-receber',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'comentario-conta-receber/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            }
        });
});

angular.module('bentham').factory('ComentarioContaReceberService', function (GenericService, ComentarioContaReceber, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ComentarioContaReceber();


    Object.setPrototypeOf(self.resource, ComentarioContaReceber);
    return function () { return self; };
});
angular.module('bentham.pages.economico.planodeconta').controller('ItemPlanoDeContaCtrl', function ($scope, ItemPlanoDeContaService, PlanoDeContaService, ItemPlanoDeConta, PlanoDeConta, GenericController, $state, $stateParams, $uibModal, toastr) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new ItemPlanoDeContaService();
    self.planoDeContaService = new PlanoDeContaService();

    $scope.itemsByPage = 1000;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.disabled = true;

    self.clear = function clear() {
        $scope.filtro = {}
        $scope.item = new ItemPlanoDeConta();
        $scope.isLoading = false;
    };

    $scope.clear = function () {
      self.clear();
    };
      
    self.activate = function () {
        $scope.isLoading = true;
        var find = function (itemPlanoDeContaId) {
          self
            .find(itemPlanoDeContaId)
            .then(function (data) {
              $scope.itemPlanoDeConta = data;
              $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message);});
        };
        if ($stateParams.planoId != null) {
          self.planoDeContaService
            .find($stateParams.planoId)
            .then(function (data) {
              $scope.planoDeConta = data;
              if ($stateParams.itemPlanoDeContaId)
                find($stateParams.itemPlanoDeContaId);
              else self.clear();
            });
        }
        if ($stateParams.itemPlanoDeContaId) find($stateParams.itemPlanoDeContaId);
        else self.clear();
    }

    self.activate();

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        filtro.centroDeCusto = filtro.centroDeCusto != null ? filtro.centroDeCusto.id : null;
        filtro.contratoExterno = filtro.contratoExterno != null ? filtro.contratoExterno.id : null;
        if (filtro.inicio != null)
          filtro.inicio = moment(filtro.inicio, "YYYY-MM-DD").format("YYYY-MM-DD");
        if (filtro.fim != null)
          filtro.fim = moment(filtro.fim, "YYYY-MM-DD").format("YYYY-MM-DD");
        if ($scope.aberto == true)
          filtro.search = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
      };
    

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "codigo");
        $scope.isLoading = true;
        if($stateParams.planoId)
            tableState.search.planoDeConta=$stateParams.planoId;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    if(entity && entity.id) $scope.disabled = true;
                    else $scope.disabled = false
                    $scope.itemPlanoDeConta = entity;
                    $scope.itemPlanoDeConta.planoDeConta = $scope.planoDeConta;
                    return entity;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };
  
    $scope.onFileSelect = function ($files) {
      self.service.upload($files, $scope.planoDeConta)
        .then(function success(data) {
            $scope.load(self.tableState);
            toastr.success("Upload feito com sucesso!");
        })
        .catch(function (error) {
            toastr.error(error.message);
        });
    };

    $scope.calcular = function () {
        self.planoDeContaService.calcular($scope.planoDeConta)
            .then(function (data) {  toastr.success(data.message);  $scope.refresh(); })
            .catch(function (error) { toastr.error(error.message); });
    };
    
});

angular.module('bentham').factory('ItemPlanoDeConta', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'item-plano-de-conta/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'item-plano-de-conta/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'item-plano-de-conta-view',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'item-plano-de-conta-view/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
        });
});

angular.module('bentham').factory('ItemPlanoDeContaService', function (GenericService, ItemPlanoDeConta, $q, prefixRoute, $http) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ItemPlanoDeConta();
    Object.setPrototypeOf(self.resource, ItemPlanoDeConta);

    /*
        Upload generico para estruturar os arquivos dinamicamente
    */

    self.upload = function ($files, planoDeConta) {
        var deferred = $q.defer();
        if ($files[0].size <= 10485760) {
        var fd = new FormData();
        fd.append("file", $files[0]);
        $http.post(prefixRoute + 'plano-de-contas/importar?planoDeConta=' + (planoDeConta != undefined || planoDeConta != null ? planoDeConta.id : ""), 
            fd, {
            withCredentials: true,
            headers: {
                'Content-Type': undefined
            },
            transformRequest: angular.identity
            }).then(function (response) {
            deferred.resolve(response.data.entity);
        }).catch(function (error) {
            deferred.reject(new Error("Erro! " + error.data.message));
        });
        }
        return deferred.promise;
    }

    return function () { return self; };
});
angular.module('bentham').controller('AreaCtrl', function ($scope, $stateParams, areaService, Area, toastr, $uibModal, GenericController,AuthService) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  self.service = new areaService();
  $scope.authService = AuthService;
  $scope.itemsByPageOptions = self.itemsByPageOptions;
  $scope.aberto = false

  self.clear = function clear() {
    $scope.area = new Area();
    $scope.filtro = {};
  };

  $scope.clear = function(){
    self.clear();
  }

  self.activate = function () {
    if ($stateParams.areaId) {
      self.find($stateParams.areaId)
        .then(function (data) { $scope.area = data; })
    } else {
      self.clear();
    }
  }

  self.activate();

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "codigo");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) { toastr.error(error.message); });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          entity: function () {
            $scope.area = entity;
            return entity;
          },
          self: function () { return self; },
          title: function () { return title; }
        },
        scope: $scope,
        controller: 'ModalController'
      });
    };

    $scope.search = function () {
        var filtro = {};
        filtro = angular.copy($scope.filtro);
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };
});
angular.module('bentham').factory('Area', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'areas/:id', {
    id: '@id',
  }, {
      save: {
        method: 'POST'
      },
      all: {
        method: 'GET',
        isArray: true,
      },
      update: {
        method: 'PUT'
      },
      deletar: {
        method: 'DELETE'
      },
      pageable: {
        method: 'GET',
        url: prefixRoute + 'areas/pageable',
        params: {
          'sort': '@sort',
          'number': '@number',
          'size': '@size'
        }
      },
    });
});

angular.module('bentham').factory('areaService', function (GenericService, Area) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new Area();
  Object.setPrototypeOf(self.resource, Area);
  return function () { return self; };
});

angular.module('bentham').factory('CriterioJulgamento', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'criteriosJulgamentos/:id', {
    id: '@id',
  }, {
      save: {
        method: 'POST'
      },
      all: {
        method: 'GET',
        isArray: true,
      },
      update: {
        method: 'PUT'
      },
      deletar: {
        method: 'DELETE'
      },
      pageable: {
        method: 'GET',
        url: prefixRoute + 'criteriosJulgamentos/pageable',
        params: {
          'sort': '@sort',
          'number': '@number',
          'size': '@size'
        }
      }
    });
});

angular.module('bentham').factory('criteriosJulgamentoservice', function (GenericService, CriterioJulgamento) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new CriterioJulgamento();
  Object.setPrototypeOf(self.resource, CriterioJulgamento);
  return function () { return self; };
});

angular.module('bentham.pages.cadastrosbasicos.parceiros').controller('ParceiroCtrl', function ($q, $scope, $state, $stateParams, ParceiroService, PessoaJuridicaService, Parceiro, $uibModal, GenericController, AuthService, $window, toastr) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  self.service = new ParceiroService();
  self.pessoaJuridicaService = new PessoaJuridicaService();
  $scope.authService = AuthService;
  $scope.itemsByPage = 100;
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  self.clear = function clear() {
      $scope.parceiro = new Parceiro();
      $scope.parceiro.pessoaJuridica = {};
      $scope.filtro = {};
  };

  $scope.clear = function () {
    self.clear();
  };

  $scope.save = function () {
    $scope.isLoading = true;
    $scope.parceiro.pessoaJuridica.pessoa.endereco = $scope.endereco;    
    self.save($scope.parceiro)
      .then(function success(data) {
        self.activate();
        $state.go("cadastrosbasicos.parceiros")
        $scope.isLoading = false;
      }).catch(function (error) {
        toastr.error(error.message);
        $scope.isLoading = false;
      });
  }

  $scope.search = function () {
    var filtro = angular.copy($scope.filtro);
    filtro.area != null ? filtro.areaId = filtro.area.id : null;
    filtro.cnpj != null ? filtro.cnpj = filtro.cnpj.toString().padStart(14, '0') : null;
    filtro.area != null ? filtro.areaId = filtro.area.id : null;
    if ($scope.aberto == true)
      filtro.search = null;
    self.tableState.search = filtro;
    $scope.load(self.tableState);
  };

  $scope.clear = function () {
    $state.go("cadastrosbasicos.parceiros")
  };


  self.activate = function () {
    $scope.isLoading = true;
    if ($stateParams.parceiroId) {
      self.find($stateParams.parceiroId)
        .then(function (data) {
          $scope.parceiro = data;
          if(data.pessoaJuridica.pessoa.endereco == null)
            $scope.parceiro.pessoaJuridica.pessoa.endereco = {};
          $scope.endereco = $scope.parceiro.pessoaJuridica.pessoa.endereco;
          $scope.isLoading = false;
        })

    } else {
      self.clear();
      $scope.isLoading = false;

    }

  }

  self.activate();

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "pessoaJuridica.pessoa.nome");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) {
        toastr.error(error.message);
      });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }


  $scope.open = function (page, size, title, entity) {
    $uibModal.open({
      animation: true,
      templateUrl: page,
      size: size,
      resolve: {
        entity: function () {
          $scope.parceiro = entity;
          return entity;
        },
        self: function () {
          return self;
        },
        title: function () {
          return title;
        }
      },
      scope: $scope,
      controller: 'ModalController'
    });
  };

  $scope.onCnpjBlur = function (cnpj) {
    self.pessoaJuridicaService.byCnpj(cnpj).then(function (data) {
      if (data.id != null && data.id != undefined)
      delete data.pessoa.handler;
      delete data.pessoa.hibernateLazyInitializer;
      $scope.parceiro.pessoaJuridica = data;
    });
  };

});
angular.module('bentham').factory('Parceiro', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'parceiros/:id', {
    id: '@id',
  }, {
      save: {
        method: 'POST'
      },
      all: {
        method: 'GET',
        isArray: true,
      },
      update: {
        method: 'PUT'
      },
      deletar: {
        method: 'DELETE'
      },
      pageable: {
        method: 'GET',
        url: prefixRoute + 'parceiros/pageable',
        params: {
          'sort': '@sort',
          'number': '@number',
          'size': '@size'
        }
      },
    });
});

angular.module('bentham').factory('ParceiroService', function (GenericService, Parceiro, $q) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new Parceiro();
  Object.setPrototypeOf(self.resource, Parceiro);

  self.valida = function (entity) {
    var data = angular.copy(entity)
    var deferred = $q.defer();
    if(data.pessoaJuridica.cnpj)
      data.pessoaJuridica.cnpj.toString().padStart(14, '0');
    deferred.resolve(data);
    return deferred.promise;
};

  return function () { return self; };
});

angular.module('bentham').factory('Regiao', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'regioes/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'regioes/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'regioes',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'regioes/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }
            },
        });
});

angular.module('bentham').factory('RegiaoService', function (GenericService, Regiao, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new Regiao();
    Object.setPrototypeOf(self.resource, Regiao);
    return function () { return self; };
});
angular.module('bentham.pages.licitacoes.configuracaoperspectivas.regiaodeatuacao').controller('RegiaoCtrl', function ($scope, $state, $stateParams, RegiaoService, Regiao, $uibModal, GenericController,AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new RegiaoService();
    $scope.authService = AuthService;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.regiao = new Regiao();
    };

    $scope.clear = function () {
        $state.go("licitacoes.configuracaoperspectivas.regiaodeatuacao")
    };

    self.activate = function () {
        if ($stateParams.regiaoId) {
            self.find($stateParams.regiaoId)
                .then(function (data) { $scope.regiao = data; })
        } else {
            self.clear();
        }
    }

    self.activate();

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "codigo");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    }

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.regiao = entity;
                    return entity;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };
});

angular.module('bentham.pages.licitacoes.configuracaoperspectivas.situacaoperspectiva').controller('SituacaoPerspectivaCtrl', function ($scope, $state, $stateParams, SituacaoPerspectivaService, SituacaoPerspectiva, $uibModal, GenericController,AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new SituacaoPerspectivaService();
    $scope.authService = AuthService;

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.situacao = new SituacaoPerspectiva();
        $scope.filtro ={};
    };

    $scope.clear = function(){
        self.clear()
    }

    self.activate = function () {
        if ($stateParams.situacaoId) {
            self.find($stateParams.situacaoId)
                .then(function (data) { $scope.situacao = data; })
        } else {
            self.clear();
        }

    }

    self.activate();

    $scope.search = function () {
        var filtro = {};
        filtro = angular.copy($scope.filtro);
        filtro.tipoLicitacao = ($scope.filtro.tipoLicitacao != null) ? $scope.filtro.tipoLicitacao.id : null;
        filtro.situacaoPerspectiva = ($scope.filtro.situacaoPerspectiva != null) ? $scope.filtro.situacaoPerspectiva.id : null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };


    $scope.load = function load(tableState) {
        self.initTableState(tableState, "tipoLicitacao.descricao");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    }


    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.situacao = entity;
                    return entity;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };
});

angular.module('bentham').factory('SituacaoPerspectiva', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'situacoes-perspectiva/:id', {
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'situacoes-perspectiva/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'situacoes-perspectiva',
        },
        byAnterior: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'situacoes-perspectiva/anterior'
        },
        uniqueByCodigo: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'situacoes-perspectiva/unique-by-codigo'
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'situacoes-perspectiva/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        },
    });
});

angular.module('bentham').factory('SituacaoPerspectivaService', function (GenericService, SituacaoPerspectiva, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new SituacaoPerspectiva();
    Object.setPrototypeOf(self.resource, SituacaoPerspectiva);

    self.byAnterior = function (search) {
        var deferred = $q.defer();
        if (search.predicateObject) {
            Object.assign(search, search.predicateObject)
            delete search.predicateObject;
        }
        var fn = function () {
            self.resource.byAnterior(angular.extend(search),
                function (data) {
                    deferred.resolve(data);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () {
        return self;
    };
});
angular.module('bentham').controller('SubAreaCtrl', function ($scope, $stateParams, SubAreaService, SubArea, toastr, $uibModal, GenericController,AuthService) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  self.service = new SubAreaService();
  $scope.authService = AuthService;
  $scope.itemsByPageOptions = self.itemsByPageOptions;

  self.clear = function clear() {
    $scope.subArea = new SubArea();
  };

  self.activate = function () {
    if ($stateParams.subAreaId) {
      self.find($stateParams.subAreaId)
        .then(function (data) { $scope.subArea = data; })
    } else {
      self.clear();
    }
  }

  self.activate();

  $scope.load = function load(tableState) {
    self.initTableState(tableState, "codigo");
    $scope.isLoading = true;
    self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
      .then(function (result) {
        $scope.displayed = result.content;
        self.updateTableState(result)
        $scope.isLoading = false;
      })
      .catch(function (error) { toastr.error(error.message); });
  };

  $scope.refresh = function () {
    $scope.load(self.tableState);
  }

  $scope.open = function (page, size, title, entity) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          entity: function () {
            $scope.subArea = entity;
            return entity;
          },
          self: function () { return self; },
          title: function () { return title; }
        },
        scope: $scope,
        controller: 'ModalController'
      });
  };
});
angular.module('bentham').factory('SubArea', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'subareas/:id', {
    id: '@id',
  }, {
      save: {
        method: 'POST'
      },
      all: {
        method: 'GET',
        isArray: true,
      },
      update: {
        method: 'PUT'
      },
      deletar: {
        method: 'DELETE'
      },
      pageable: {
        method: 'GET',
        url: prefixRoute + 'subareas/pageable',
        params: {
          'sort': '@sort',
          'number': '@number',
          'size': '@size'
        }
      }
    });
});

angular.module('bentham').factory('SubAreaService', function (GenericService, SubArea) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new SubArea();
  Object.setPrototypeOf(self.resource, SubArea);
  return function () { return self; };
});

angular.module('bentham.pages.licitacoes.configuracaoperspectivas.tipodelicitacao').controller('TipoLicitacaoCtrl', function ($scope, $state, $stateParams, TipoLicitacaoService, TipoLicitacao, $uibModal, GenericController,AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new TipoLicitacaoService();
    $scope.authService = AuthService;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.tipoLicitacao = new TipoLicitacao();
    };

    $scope.clear = function () {
        $state.go("licitacoes.configuracaoperspectivas.tipodelicitacao")
    };

    self.activate = function () {
        if ($stateParams.tipoLicitacaoId) {
            self.find($stateParams.tipoLicitacaoId)
                .then(function (data) { $scope.tipoLicitacao = data; })
        } else {
            self.clear();
        }
    }

    self.activate();

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "codigo");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    }

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.tipoLicitacao = entity;
                    return entity;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    }
});

angular.module('bentham').factory('TipoLicitacao', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'tipolicitacoes/:id', {
        id: '@id',  
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'tipolicitacoes/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'tipolicitacoes',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'tipolicitacoes/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }
            },
        });
});

angular.module('bentham').factory('TipoLicitacaoService', function (GenericService, TipoLicitacao, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new TipoLicitacao();
    Object.setPrototypeOf(self.resource, TipoLicitacao);
    return function () { return self; };
});
angular.module('bentham.pages.licitacoes.configuracaoperspectivas.tipodeperspectiva').controller('TipoPerspetivaCtrl', function ($scope, $state, $stateParams, TipoPerspectivaService, TipoPerspectiva, $uibModal, GenericController,AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new TipoPerspectivaService();
    $scope.authService = AuthService;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.tipoPerspectiva = new TipoPerspectiva();
    };

    $scope.clear = function () {
        $state.go("licitacoes.configuracaoperspectivas.tipodeperspectiva")
    };

    self.activate = function () {
        if ($stateParams.tipoPerspectivaId) {
            self.find($stateParams.tipoPerspectivaId)
                .then(function (data) { $scope.tipoPerspectiva = data; })
        } else {
            self.clear();
        }
    }

    self.activate();

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "codigo");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    }

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.tipoPerspectiva = entity;
                    return entity;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };
});

angular.module('bentham').factory('TipoPerspectiva', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'tipoperspectivas/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'tipoperspectivas/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'tipoperspectivas',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'tipoperspectivas/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }
            },
        });
});

angular.module('bentham').factory('TipoPerspectivaService', function (GenericService, TipoPerspectiva, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new TipoPerspectiva();
    Object.setPrototypeOf(self.resource, TipoPerspectiva);
    return function () { return self; };
});
angular.module('bentham').factory('TipoServico', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'tipo-servicos/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'tipo-servicos/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'tipo-servicos',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'tipo-servicos/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }
            },
        });
});

angular.module('bentham').factory('TipoServicoService', function (GenericService, TipoServico, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new TipoServico();
    Object.setPrototypeOf(self.resource, TipoServico);
    return function () { return self; };
});
angular.module('bentham.pages.licitacoes.configuracaoperspectivas.tipodeservico').controller('TipoServicoCtrl', function ($scope, $state, $stateParams, TipoServicoService, TipoServico, $uibModal, GenericController,AuthService) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new TipoServicoService();
    $scope.authService = AuthService;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.tipoServico = new TipoServico();
    };

    $scope.clear = function () {
        $state.go("licitacoes.configuracaoperspectivas.tipodeservico")
    };

    self.activate = function () {
        if ($stateParams.tipoServicoId) {
            self.find($stateParams.tipoServicoId)
                .then(function (data) { $scope.tipoServico = data; })
        } else {
            self.clear();
        }
    }

    self.activate();

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "codigo");
        $scope.isLoading = true;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    }

    $scope.open = function (page, size, title, entity) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    $scope.tipoServico = entity;
                    return entity;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };
});

angular.module('bentham').factory('HistoricoPerspectiva', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'historico-perspectiva/:id', {
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'historico-perspectiva/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'historico-perspectiva',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'historico-perspectiva/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        }
    });
});

angular.module('bentham').factory('HistoricoPerspectivaService', function (GenericService, HistoricoPerspectiva, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new HistoricoPerspectiva();
    Object.setPrototypeOf(self.resource, HistoricoPerspectiva);

    self.converte = function (data) {
        if (data.data != null)
            data.data = self.converteData(data.data);
        return data;
    };

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        if (data.data != null)
            data.data = self.converteData(data.data);

        deferred.resolve(data);
        return deferred.promise
    };

    return function () {
        return self;
    };
});
angular.module('bentham.pages.licitacoes.perspectivas').controller('HistoricoPerspectivaCtrl', function ($scope, HistoricoPerspectivaService, SituacaoPerspectivaService, HistoricoPerspectiva, HistoricoPerspectiva, GenericController,$state, $stateParams, $uibModal, toastr, AuthService,  $window) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    $scope.authService = AuthService;
    self.service = new HistoricoPerspectivaService();
    self.situacaoPerspectivaService = new SituacaoPerspectivaService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
 
    self.clear = function(){
        self.tableState.sort= {predicate : "data"};
        $scope.historicoPerspectiva = new HistoricoPerspectiva();
        $scope.historicoPerspectiva.perspectiva  = $scope.perspectiva;
    };

    $scope.clear = function(){
        self.clear();
    };

    $scope.load = function load(tableState) {
        $scope.isLoading = true;
        self.initTableState(tableState, 'data');
        if ($stateParams.perspectivaId)
            tableState.search.perspectivaId = $stateParams.perspectivaId;      
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.clear();
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, historicoPerspectiva) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {                   
                    $scope.historicoPerspectiva = historicoPerspectiva;
                    $scope.historicoPerspectiva.perspectiva = $scope.perspectiva;
                    return historicoPerspectiva;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    // $scope.onTipoLicitacaoChange = function (tipoLicitacao) {
    //     self.situacaoPerspectivaService.byAnterior({
    //             tipoLicitacao: tipoLicitacao.id,
    //             situacaoPerpectiva: null
    //         })
    //         .then(function (data) {
    //             $scope.situacoes = data;
    //         })
    //         .catch(function (error) {
    //             toastr.error(error.message);
    //         });

    // }

    // $scope.onSituacaoPerspectivaChange = function (tipoLicitacao, situacao) {
    //     self.situacaoPerspectivaService.byAnterior({
    //             tipoLicitacao: tipoLicitacao.id,
    //             situacaoPerspectiva: !situacao ? null : situacao.id
    //         })
    //         .then(function (data) { $scope.situacoes = data;})
    //         .catch(function (error) { toastr.error(error.message);});
    // }

});
angular.module('bentham.pages.licitacoes.perspectivas').controller('PerspectivaConcorrenteCtrl', function ($scope, PerspectivaConcorrente, PerspectivaConcorrenteService, PessoaJuridicaService, GenericController, toastr, $uibModal, $stateParams) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);

    self.service = new PerspectivaConcorrenteService();
    self.pessoaJuridicaService = new PessoaJuridicaService();

    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
 
    $scope.clear = function(){
        self.tableState.sort= {predicate : "pessoaJuridica.nomeFantasia"};
        $scope.perspectivaConcorrente = new PerspectivaConcorrente();
        $scope.perspectivaConcorrente.perspectiva  = $scope.perspectiva;
    };

    $scope.clear();

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "pessoaJuridica.nomeFantasia");
        $scope.isLoading = true;
        if ($stateParams.perspectivaId)
            tableState.search.perspectivaId = $stateParams.perspectivaId;      
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.clear();
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.refresh = function () {
        // self.initTableState(tableState, "pessoaJuridica.nomeFantasia");
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, perspectivaConcorrente) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {                   
                    $scope.perspectivaConcorrente = perspectivaConcorrente;
                    $scope.perspectivaConcorrente.perspectiva = $scope.perspectiva;
                    return perspectivaConcorrente;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };
});
angular.module('bentham').factory('PerspectivaConcorrente', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'perspectiva-concorrente/:id', { id: '@id', }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'perspectiva-concorrente/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'perspectiva-concorrente/',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'perspectiva-concorrente/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        },
        findByPerspectiva:{
            method: 'GET',
            url: prefixRoute + 'perspectiva-concorrente/find-by-perspectiva',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        }
    });
});

angular.module('bentham').factory('PerspectivaConcorrenteService', function (GenericService, PerspectivaConcorrente, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new PerspectivaConcorrente();
    Object.setPrototypeOf(self.resource, PerspectivaConcorrente);
     
    self.findByPerspectiva = function (perspectiva) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.findByPerspectiva({ perspectivaId: perspectiva.id },
                function success(perspectiva) { deferred.resolve(perspectiva);},
                function (error) { error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.delete = function (concorrente) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.delete({ id: concorrente.id },
                function success(perspectiva) { deferred.resolve(perspectiva);},
                function (error) { error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }
   
    return function () { return self; };
});
angular.module('bentham.pages.licitacoes.perspectivas').controller('PerspectivaDocumentoCtrl', function ($scope, PerspectivaDocumento, PerspectivaDocumentoService, TipoDocumentoService, GenericController, toastr, DocumentoService, $uibModal) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);

    self.service = new PerspectivaDocumentoService();
    self.tipoDocumentoService = new TipoDocumentoService();
    self.documentoService = new DocumentoService();

    self.clear = function () {
        $scope.perspectivaDocumento = new PerspectivaDocumento();
        $scope.perspectivaDocumento.perspectiva = $scope.perspectiva;
        $scope.tipos = [];
    };

    var error = function (error) {
        $scope.isLoading = false;
        toastr.error(error.message);
    }

    var foreach = function (tipo) {
        self.service.findByPerspectivaAndtipo($scope.perspectiva, tipo.tipoAnexo)
            .then(function success(result) {
                tipo.documentos = result;
                $scope.isLoading = false;
            })
            .catch(error);
    };

    var fillAll = function (edital) {
        $scope.tipos.push(edital);
        $scope.tipos.forEach(foreach);
    }  

    $scope.load = function () {
        $scope.isLoading = true;
        self.clear();
        self.tipoDocumentoService.getByTipoAnexo("EDITAL")
            .then(fillAll)
            .catch(error);
    };

    $scope.load();


    $scope.onFileSelect = function ($files) {
        self.documentoService.upload($files, "EDITAL", $scope.perspectiva.folder)
            .then(function success(data) {
                $scope.perspectivaDocumento.documento = data;
                $scope.perspectivaDocumento.tipo = data.tipoDocumento.tipoAnexo;
                self.save($scope.perspectivaDocumento).then(function (data) {
                    $scope.load();
                });
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };


    $scope.openDocumento = function (title, perspectivaDocumento) {
        $uibModal.open({
            animation: true,
            templateUrl: 'app/pages/arquivos/entity-documento/modais/modalDelete.html',
            size: 'md',
            resolve: {
                entity: function () {
                    $scope.documento = perspectivaDocumento;
                    return perspectivaDocumento;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: "ModalController"
        });
    };

});
angular.module('bentham').factory('PerspectivaDocumento', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'perspectiva-documento/:id', { id: '@id', }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'perspectiva-documento/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'perspectiva-documento/',
        },
        findByPerspectivaAndtipo:{
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'perspectiva-documento/findBy-perspectiva-and-tipo',
        }
    });
});

angular.module('bentham').factory('PerspectivaDocumentoService', function (GenericService, PerspectivaDocumento, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new PerspectivaDocumento();
    Object.setPrototypeOf(self.resource, PerspectivaDocumento);
     
    self.findByPerspectivaAndtipo = function (perspectiva, tipoAnexo) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.findByPerspectivaAndtipo({ perspectivaId: perspectiva.id, tipoAnexo: tipoAnexo.name },
                function success(contrato) { deferred.resolve(contrato);},
                function (error) { error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }

    self.delete = function (documento) {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.delete({ id: documento.id },
                function success(perspectiva) { deferred.resolve(perspectiva);},
                function (error) { error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }
   
    return function () { return self; };
});
angular.module('bentham.pages.licitacoes.perspectivas').controller('SolicitacaoJuridicoPerspectivaCtrl', function ($scope, SolicitacaoJuridicoPerspectivaService, SolicitacaoJuridicoPerspectiva, GenericController, $state, $stateParams, $uibModal, toastr, AuthService, $window) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    $scope.authService = AuthService;
    self.service = new SolicitacaoJuridicoPerspectivaService();
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
 
    self.clear = function() {
      self.tableState.sort= {predicate : "dataApresentacao"};
      $scope.solicitacaoJuridico = new SolicitacaoJuridicoPerspectiva();
      $scope.solicitacaoJuridico.perspectiva = $scope.perspectiva;
    };

    $scope.clear = function(){
        self.clear();
    }; 

    $scope.load = function load(tableState) {
        $scope.isLoading = true;

        self.initTableState(tableState, 'dataApresentacao');
        if ($stateParams.perspectivaId)
            tableState.search.perspectivaId = $stateParams.perspectivaId;      
        self.service.pageablePerspectiva(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.clear();
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
            });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.saveEntity = function(obj, onCloseModal){
      $scope.isLoading = true;
      self.save(obj)
        .then(function(){
          onCloseModal();
          $scope.refresh();
        })
        .catch(function(error){
          $scope.isLoading = false;
        });
    };

    $scope.open = function (page, size, title, solicitacaoJuridico) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                  $scope.solicitacaoJuridico = angular.copy(solicitacaoJuridico);
                  $scope.solicitacaoJuridico.perspectiva = $scope.perspectiva;
                  return solicitacaoJuridico;
                },
                self: function () {
                    return self;
                },
                title: function () {
                    return title;
                }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };
});
angular.module('bentham').factory('SolicitacaoJuridicoPerspectiva', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'solicitacao-juridico-perspectiva/:id', { 
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'solicitacao-juridico-perspectiva/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'solicitacao-juridico-perspectiva',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'solicitacao-juridico-perspectiva/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        },
        pageablePerspectiva: {
            method: 'GET',
            url: prefixRoute + 'solicitacao-juridico-perspectiva/pageable-perspectiva',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }
        },
    });
});

angular.module('bentham').factory('SolicitacaoJuridicoPerspectivaService', function (GenericService, SolicitacaoJuridicoPerspectiva, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new SolicitacaoJuridicoPerspectiva();
    Object.setPrototypeOf(self.resource, SolicitacaoJuridicoPerspectiva);

    self.converte = function (data) {
        if (data.dataSolicitacao != null)
            data.dataSolicitacao = self.converteData(data.dataSolicitacao);
        if (data.dataApresentacao != null)
            data.dataApresentacao = self.converteData(data.dataApresentacao);
        if (data.provimentoSolicitacao && data.provimentoSolicitacao.dataDecisao)
            data.provimentoSolicitacao.dataDecisao = self.converteData(data.provimentoSolicitacao.dataDecisao);
        return data;
    };

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        if (data.dataSolicitacao != null)
            data.dataSolicitacao = self.converteData(data.dataSolicitacao);
        if (data.dataApresentacao != null)
            data.dataApresentacao = self.converteData(data.dataApresentacao);
        if (data.provimentoSolicitacao && data.provimentoSolicitacao.dataDecisao)
            data.provimentoSolicitacao.dataDecisao = self.converteData(data.provimentoSolicitacao.dataDecisao);

        deferred.resolve(data);
        return deferred.promise
    };

    self.pageablePerspectiva = function (page, size, sortField, sortOrder, search) {
      var deferred = $q.defer();
      var self = this;
      if (search.predicateObject) {
          Object.assign(search, search.predicateObject)
          delete search.predicateObject;
      }
      var fn = function () {
          self.resource.pageablePerspectiva(angular.extend(search, { page: page, size: size, sort: sortField + ',' + sortOrder }),
              function (data) {
                  for (var i = 0; i < data.content.length; i++)
                      data.content[i] = self.converte(data.content[i]);
                  deferred.resolve(data);
              },
              function (error) {
                  error = self.catchMessage(error);
                  deferred.reject(new Error("Erro! " + error.message));
              });
          return deferred.promise;
      }

      return self.process(fn);
    }

    return function () { return self; };
});
angular.module('bentham').factory('AlteracaoAuditoriaSistema', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'alteracoes-de-auditoria/:id', {
        id: '@id',
    }, {
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'alteracoes-de-auditoria',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'alteracoes-de-auditoria/pageable',
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'alteracoes-de-auditoria/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            }
        });
});

angular.module('bentham').factory('AlteracaoAuditoriaSistemaService', function (GenericService, AlteracaoAuditoriaSistema, $q, prefixRoute) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new AlteracaoAuditoriaSistema();
    Object.setPrototypeOf(self.resource, AlteracaoAuditoriaSistema);

    self.all= function () {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.all(
                function success(logs) {
                    deferred.resolve(logs);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }


    self.pageable = function () {
        var deferred = $q.defer();
        var fn = function () {
            self.resource.pageable(
                function success(alts) {
                    deferred.resolve(alts);
                },
                function (error) {
                    error = self.catchMessage(error);
                    deferred.reject(new Error("Erro! " + error.message));
                });
            return deferred.promise;
        }
        return self.process(fn);
    }
    return function () { return self; };
});
/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('bentham.pages.economico.planodeconta').controller('ValorPrevistoPlanoDeContaCtrl', function ($scope, ValorPrevistoPlanoDeContaService, ValorPrevistoPlanoDeConta, ItemPlanoDeContaService, GenericController, $state, $stateParams, $uibModal, toastr) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    self.service = new ValorPrevistoPlanoDeContaService();
    self.itemPlanoDeContaService = new ItemPlanoDeContaService();

    $scope.itemsByPage = 1000;
    $scope.itemsByPageOptions = self.itemsByPageOptions;

    self.clear = function clear() {
        $scope.valorPrevisto = new ValorPrevistoPlanoDeConta();
    };

    self.activate = function () {
        $scope.isLoading = true;
        if ($stateParams.valorPrevistoId) {
            self.find($stateParams.valorPrevistoId)
                .then(function (data) {
                    $scope.valorPrevisto = data;
                    $scope.isLoading = false;
                });
        } else {
            self.clear();
            self.itemPlanoDeContaService.find($stateParams.itemPlanoId)
                .then(function (data) { 
                    $scope.itemPlanoDeConta = data; 
                    $scope.valorPrevisto.itemPlanoDeConta = data; 
                    $scope.isLoading = false; 
                });
        }
    }
    self.activate();

    $scope.clear = function () {
        $state.go("economico.formplanodeconta")
    };

    $scope.save = function () {
        self.save($scope.valorPrevisto)
            .then(function success(data) {
                self.activate();
                $state.go("economico.formplanodeconta")
            });
    }

    $scope.load = function load(tableState) {
        self.initTableState(tableState, "data", "DESC");
        $scope.isLoading = true;
        if ($stateParams.itemPlanoId)
            tableState.search.itemPlanoDeConta = $stateParams.itemPlanoId;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) {
                $scope.displayed = result.content;
                self.updateTableState(result)
                $scope.isLoading = false;
            })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, valorPrevisto) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    valorPrevisto.itemPlanoDeConta = $scope.itemPlanoDeConta;
                    $scope.valorPrevisto = valorPrevisto;
                    return valorPrevisto;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };
  
    $scope.cancel = function () {
        $state.go("economico.formplanodeconta", { planoId: $scope.itemPlanoDeConta.planoDeConta.id }); 
    };
});

angular.module('bentham').factory('ValorPrevistoPlanoDeConta', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'valor-previsto-plano-conta/:id', {
        id: '@id',
    }, {
            delete: {
                method: 'DELETE',
                url: prefixRoute + 'valor-previsto-plano-conta/:id',
            },
            save: {
                method: 'POST'
            },
            update: {
                method: 'PUT'
            },
            all: {
                method: 'GET',
                isArray: true,
                url: prefixRoute + 'valor-previsto-plano-conta',
            },
            adicionarVarios: {
                method: 'POST',
                url: prefixRoute + 'valor-previsto-plano-conta/adicionar-varios'
            },
            pageable: {
                method: 'GET',
                url: prefixRoute + 'valor-previsto-plano-conta/pageable',
                params: {
                    'sort': '@sort',
                    'number': '@number',
                    'size': '@size'
                }

            },
        });
});

angular.module('bentham').factory('ValorPrevistoPlanoDeContaService', function (GenericService, ValorPrevistoPlanoDeConta, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new ValorPrevistoPlanoDeConta();
    Object.setPrototypeOf(self.resource, ValorPrevistoPlanoDeConta);

    self.converte = function (data) {
        if (data.data != null)
            data.data = self.converteData(data.data);
        if (data.dataOtimista != null) {
            data.dataOtimista = self.converteData(data.dataOtimista);
            data.diaOtimista = data.dataOtimista.getDate();
        }
        if (data.dataNormal != null) {
            data.dataNormal = self.converteData(data.dataNormal);
            data.diaNormal = data.dataNormal.getDate();
        }
        if (data.dataPessimista != null) {
            data.dataPessimista = self.converteData(data.dataPessimista);
            data.diaPessimista = data.dataPessimista.getDate();
        }
        return data;
    };

    self.valida = function (entity) {
        var data = angular.copy(entity)
        var deferred = $q.defer();
        if (data.data != null)
            data.data = self.converteData(data.data);
        if (data.dataOtimista != null)
            data.dataOtimista = self.converteData(data.dataOtimista);
        if (data.dataNormal != null)
            data.dataNormal = self.converteData(data.dataNormal);
        if (data.dataPessimista != null)
            data.dataPessimista = self.converteData(data.dataPessimista);
        deferred.resolve(data);
        return deferred.promise
    };

    self.adicionarVarios = function (entity) {
        var deferred = $q.defer();
        var fn = function () {
            self.valida(entity)
            .then(function (prod) {
                self.resource.adicionarVarios('', prod,
                    function success(prod) { deferred.resolve(prod); },
                    function (error) { error = self.catchMessage(error); deferred.reject(new Error("Erro! " + error.message)); });
            })
            .catch(function (error) { deferred.reject(error); });
            return deferred.promise;
        }
        return self.process(fn);
    }

    return function () { return self; };
});
angular.module('bentham.pages.economico.planodeconta').controller('ValoresPrevistoPlanoDeContaCtrl', function ($scope, $state, $stateParams, ValorPrevistoPlanoDeConta, ItemPlanoDeContaService, ValorPrevistoPlanoDeContaService, Usuario, GenericController, $uibModal, toastr, $q, AuthService) {

    var self = this;
    Object.setPrototypeOf(self, GenericController);

    $scope.authService = AuthService;
    self.service = new ValorPrevistoPlanoDeContaService();
    self.itemPlanoDeContaService = new ItemPlanoDeContaService();

    $scope.itemsByPage = 1000;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.isValores = false;
    $scope.user = undefined;
    $scope.disabledForm = false;

    self.adminProfileName = "administrador";
    self.financialProfileName = "financeiro";

    self.findUserByName = function () {
        var deferred = $q.defer();

        AuthService.user()
            .then(function success(data) {
                Usuario.findByName({ nome: data }, function (user) {
                    $scope.user = user;
                    deferred.resolve(user);
                }, function (error) {
                    deferred.reject(error);
                });
            }, function (error) {
                deferred.reject(error);
            });

        return deferred.promise;
    }

    self.extractSyntheticCode = function (accountPlanItem) {
        var accountPlanItemCode = accountPlanItem.codigo;
        var accountPlanItemCodeSplit = accountPlanItemCode.split('.');
        var accountPlanItemSyntheticCode = accountPlanItemCodeSplit[0];
        return accountPlanItemSyntheticCode;
    }

    self.userHasProfile = function (perfilName) {
        if (!$scope.user) return false;

        var userProfile = $scope.user.perfil.descricao;
        return userProfile.toLowerCase() === perfilName.toLowerCase();
    }

    $scope.hasEditPermission = function () {
        var isAdmin = self.userHasProfile(self.adminProfileName)
        var isFinancial = self.userHasProfile(self.financialProfileName)
        var accountPlanItemSyntheticCode = self.extractSyntheticCode($scope.itemPlanoDeConta);
        var revenue = accountPlanItemSyntheticCode === '1';
        if (revenue) {
            return isAdmin || isFinancial;
        }

        return true;
    }

    $scope.hasDeletePermission = function () {
        var isAdmin = self.userHasProfile(self.adminProfileName)
        return isAdmin;
    }

    $scope.canDisplayPaymentDates = function () {
        var accountPlanItemSyntheticCode = self.extractSyntheticCode($scope.itemPlanoDeConta);
        return accountPlanItemSyntheticCode !== '2';
    }

    self.processFormDisabling = function () {
        var accountPlanItem = $scope.itemPlanoDeConta;
        if (!accountPlanItem) return;

        var isAdmin = self.userHasProfile(self.adminProfileName)
        if (isAdmin) {
            $scope.disabledForm = false;
            return;
        }

        var accountPlanItemSyntheticCode = self.extractSyntheticCode(accountPlanItem);
        var revenue = accountPlanItemSyntheticCode === '1';
        if (revenue) {
            $scope.disabledForm = true;
            return;
        }

        $scope.disabledForm = false;
    }

    self.save = function (prod) {
        var deferred = $q.defer();

        var year = prod.data.getFullYear();
        var month = prod.data.getMonth();

        prod.dataOtimista = prod.diaOtimista ? new Date(year, month, prod.diaOtimista) : undefined;
        prod.dataNormal = prod.diaNormal ? new Date(year, month, prod.diaNormal) : undefined;
        prod.dataPessimista = prod.diaPessimista ? new Date(year, month, prod.diaPessimista) : undefined;

        prod.dataOtimista ? prod.dataOtimista.setMonth(prod.dataOtimista.getMonth() + 1) : undefined;
        prod.dataNormal ? prod.dataNormal.setMonth(prod.dataNormal.getMonth() + 1) : undefined;
        prod.dataPessimista ? prod.dataPessimista.setMonth(prod.dataPessimista.getMonth() + 1) : undefined;

        if ($scope.adicionarVarios) {
            // if (prod.itemPlanoDeConta != null)
            //     prod.itemPlanoDeConta = prod.itemPlanoDeConta.id;
            if (prod.dataInicial != null)
                prod.dataInicial = moment(prod.dataInicial, "YYYY-MM-DD").format("YYYY-MM-DD");
            if (prod.dataFinal != null)
                prod.dataFinal = moment(prod.dataFinal, "YYYY-MM-DD").format("YYYY-MM-DD");
            if (prod.valores != null) {
                $scope.valores = []
                angular.forEach(prod.valores, function (v) { $scope.valores.push(v.valor); });
                prod.valores = $scope.valores;
            }
            self.service.adicionarVarios(prod)
                .then(function (data) { $scope.search(); deferred.resolve(data); self.clear() })
                .catch(function (error) { deferred.reject(error); toastr.error(error.message); });
        } else
            self.service.save(prod)
                .then(function (data) { $scope.search(); deferred.resolve(data); self.clear() })
                .catch(function (error) { deferred.reject(error); toastr.error(error.message); });
        return deferred.promise;
    };

    self.clear = function clear() {
        $scope.isLoading = false;
        $scope.filtro = {};
        $scope.prod = {};
        $scope.valorPrevisto = new ValorPrevistoPlanoDeConta();
        $scope.prod.valores = [];
        self.itemPlanoDeContaService.find($stateParams.itemPlanoId)
            .then(function (data) {
                $scope.filtro = {
                    itemPlanoDeConta: data.id,
                    planoDeConta: data.planoDeConta.id,
                };
                $scope.itemPlanoDeConta = data;
                return self.findUserByName();
            })
            .then(function () {
                self.processFormDisabling();
                $scope.isLoading = false;
            })
            .catch(function (error) {
                toastr.error(error.message);
                $scope.isLoading = false;
            });
    };

    $scope.clear = function () {
        self.clear();
    }

    $scope.save = function () {
        $scope.isLoading = true;
        self.save($scope.produto)
            .then(function success(data) { self.clear(); })
            .catch(function (error) { toastr.error(error.message); $scope.isLoading = false; });
    }

    self.activate = function () {
        $scope.isLoading = true;
        self.clear();
    };

    self.activate();

    $scope.search = function () {
        var filtro = angular.copy($scope.filtro);
        if ($scope.aberto == true)
            filtro.search = null;
        self.tableState.search = filtro;
        $scope.load(self.tableState);
    };

    $scope.load = function load(tableState) {
        if (!tableState.sort.predicate && !tableState.sort.sortOrder) {
            self.initTableState(tableState, "data", 'DESC');
        } else {
            self.initTableState(tableState, tableState.sort.predicate, tableState.sort.sortOrder);
        }
        $scope.isLoading = true;
        if ($stateParams.itemPlanoId)
            tableState.search.itemPlanoDeConta = $stateParams.itemPlanoId;
        tableState.pagination.number = 1000;
        self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
            .then(function (result) { $scope.displayed = result.content; self.updateTableState(result); $scope.isLoading = false; })
            .catch(function (error) { toastr.error(error.message); });
    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.open = function (page, size, title, valorPrevisto) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
                entity: function () {
                    if (valorPrevisto.valores) $scope.adicionarVarios = true;
                    valorPrevisto.itemPlanoDeConta = $scope.itemPlanoDeConta;
                    $scope.valorPrevisto = valorPrevisto;
                    return valorPrevisto;
                },
                self: function () { return self; },
                title: function () { return title; }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.editarValores = function (dataInicial, dataFinal) {
        if (dataInicial && dataFinal) {
            $scope.isValores = true;
            $scope.prod.valor = 0;
            var i = 1;
            var d1 = moment(dataInicial);
            var d2 = moment(dataFinal);
            var qtdMes = Math.round(moment.duration(d2.diff(d1)).asMonths()) + 1;
            for (i = 1; i <= qtdMes; i++) {
                var mes = moment(dataInicial).format("MM");
                var ano = moment(dataInicial).format("YYYY");
                $scope.prod.valores.push({ data: "01/" + mes + "/" + ano });
                dataInicial = moment(dataInicial).add(1, "months");
            }
        } else {
            toastr.warning("Verifique os campos: Data Inicial, Data Final!");
        }
    };

    $scope.valorUnico = function () {
        $scope.isValores = false;
        $scope.prod.valores = []
    };

    $scope.cancel = function () {
        $state.go("economico.formplanodeconta", { planoId: $scope.itemPlanoDeConta.planoDeConta.id });
    };

    $scope.getLastDayOfCompetence = function () {
        var dateCompetence = $scope.valorPrevisto.data;
        if (!dateCompetence) return 28;

        var nextMonth = new Date(dateCompetence.getFullYear(), dateCompetence.getMonth() + 2, 0);
        var lastDayOfMonth = nextMonth.getDate();
        return lastDayOfMonth;
    };

    $scope.isDayValid = function (day) {
        if (day == undefined) return false;

        var lastDayOfMonth = $scope.getLastDayOfCompetence();
        var dayRange = day >= 1 && day <= lastDayOfMonth;

        if (dayRange) return true;

        return false;
    };

    $scope.$watch('itemPlanoDeConta', function (newValues) {
        if (!newValues) return $scope.isRecipeItem = false;
        var itemPlanoDeConta = newValues;
        $scope.isRecipeItem = itemPlanoDeConta && (itemPlanoDeConta.codigo === '1.1' || itemPlanoDeConta.codigo === '1.2');
    });

});
angular.module('bentham.pages.licitacoes.perspectivas').controller('ProvimentoSolicitacaoCtrl', function ($scope, ProvimentoSolicitacaoService, GenericController, $state, $stateParams, $uibModal, toastr, AuthService, $window) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;
  self.service = new ProvimentoSolicitacaoService();
});
angular.module('bentham').factory('ProvimentoSolicitacao', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'provimento-solicitacao/:id', { 
      id: '@id',
  }, {
    save: {
      method: 'POST'
    },
    update: {
      method: 'PUT'
    },
  });
});

angular.module('bentham').factory('ProvimentoSolicitacaoService', function (GenericService, ProvimentoSolicitacao, $q) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new ProvimentoSolicitacao();
  Object.setPrototypeOf(self.resource, ProvimentoSolicitacao);

  self.converte = function (data) {
    if (data && data.dataDecisao)
      data.dataDecisao = self.converteData(data.dataDecisao);
    return data;
  };

  self.valida = function (entity) {
    var data = angular.copy(entity)
    var deferred = $q.defer();
    if (data.dataDecisao != null)
        data.dataDecisao = self.converteData(data.dataDecisao);
    deferred.resolve(data);
    return deferred.promise
};

  return function () { return self; };
});
angular.module('bentham.pages.licitacoes.perspectivas').controller('RespostaJuridicoPerspectivaCtrl', function ($scope, RespostaJuridicoPerspectivaService, SolicitacaoJuridicoPerspectivaService, RespostaJuridicoPerspectiva, ProvimentoSolicitacao, RevisaoResposta, GenericController, $stateParams, $uibModal, toastr, AuthService, $window, $controller) {
    var self = this;
    Object.setPrototypeOf(self, GenericController);
    
    self.service = new RespostaJuridicoPerspectivaService();
    self.solicitacaoJuridicoPerspectivaService = new SolicitacaoJuridicoPerspectivaService();
    self.solicitacaoJuridicoPerspectivaCtrl = $controller('SolicitacaoJuridicoPerspectivaCtrl', {$scope: $scope});
    self.provimentoSolicitacaoCtrl = $controller('ProvimentoSolicitacaoCtrl', {$scope: $scope});
    self.revisaoRespostaCtrl = $controller('RevisaoRespostaCtrl', {$scope: $scope});
    
    $scope.authService = AuthService;
    $scope.itemsByPage = 25;
    $scope.itemsByPageOptions = self.itemsByPageOptions;
    $scope.isLoading = true;
    $scope.isSolicitacaoUpdatePerm = $scope.authService.isInRole('ROLE_SOLICITACAO_JURIDICO_[A-Z]*U[A-Z]*');

    $scope.isprovimentoFormDisabled = function() {
      return $scope.isLoading || !$scope.isSolicitacaoUpdatePerm;
    };
    $scope.isRevisaoFormDisabled = function() {
      return $scope.isLoading || !$scope.isSolicitacaoUpdatePerm;
    };
 
    self.clear = function() {
      self.tableState.sort= {predicate : "dataResposta"};
      $scope.respostaJuridicoPerspectiva = new RespostaJuridicoPerspectiva();
      $scope.respostaJuridicoPerspectiva.solicitacaoJuridicoPerspectiva = $scope.solicitacaoJuridico;
    };

    $scope.clear = function(){
        self.clear();
    };

    $scope.load = function load(tableState) {
        $scope.isLoading = true;

        self.solicitacaoJuridicoPerspectivaService.find($stateParams.solicitacaoJuridicoId)
          .then(function (result) {
              $scope.solicitacaoJuridico = result;
              $scope.provimentoSolicitacao = result.provimentoSolicitacao ? angular.copy(result.provimentoSolicitacao) : new ProvimentoSolicitacao();
              $scope.provimentoSolicitacao.solicitacaoJuridicoPerspectiva = result;
              self.initTableState(tableState, 'dataResposta');
              if ($stateParams.solicitacaoJuridicoId)
                tableState.search.solicitacaoJuridicoPerspectivaId = $scope.solicitacaoJuridico.id;
              self.service.getPage(tableState.page, tableState.pagination.number, tableState.sort.predicate, tableState.sort.sortOrder, tableState.search)
                .then(function (result) {
                    result.content.forEach(function (row) {
                      row.solicitacaoJuridicoPerspectiva = $scope.solicitacaoJuridico;
                    });
                    $scope.displayed = result.content;
                    self.updateTableState(result)
                    $scope.clear();
                    $scope.isLoading = false;
                })
                .catch(function (error) {
                    toastr.error(error.message);
                });
          })
          .catch(function (error) {
              toastr.error(error.message);
          });

    };

    $scope.refresh = function () {
        $scope.load(self.tableState);
    };

    $scope.handleBackPage = function(){
      $window.history.back();
    };
  
    $scope.saveEntity = function(obj, onCloseModal, controllerName){
      $scope.isLoading = true;
      var controller = controllerName ? self[controllerName] : self;
      controller.save(obj)
        .then(function(){
          onCloseModal();
          $scope.refresh();
        })
        .catch(function(error){
          $scope.isLoading = false;
        });
    };
  
    $scope.openModal = function (page, size, title, entity, entityName) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
              entity: function () {
                $scope[entityName] = angular.copy(entity);
                return entity;
              },
              self: function () {
                  return self;
              },
              title: function () {
                  return title;
              }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };

    $scope.openRevisao = function (page, size, title, respostaSolicitacao) {
        $uibModal.open({
            animation: true,
            templateUrl: page,
            size: size,
            resolve: {
              entity: function () {
                var revisaoRespostaJuridico = respostaSolicitacao.revisaoRespostaJuridico ? respostaSolicitacao.revisaoRespostaJuridico : new RevisaoResposta();
                $scope.revisaoResposta = angular.copy(revisaoRespostaJuridico);
                $scope.revisaoResposta.respostaSolicitacaoJuridico = respostaSolicitacao;
                return $scope.revisaoResposta;
              },
              self: function () {
                  return self;
              },
              title: function () {
                  return title;
              }
            },
            scope: $scope,
            controller: 'ModalController'
        });
    };
});
angular.module('bentham').factory('RespostaJuridicoPerspectiva', function ($resource, prefixRoute) {
    return $resource(prefixRoute + 'resposta-solicitacao-juridico/:id', { 
        id: '@id',
    }, {
        delete: {
            method: 'DELETE',
            url: prefixRoute + 'resposta-solicitacao-juridico/:id',
        },
        save: {
            method: 'POST'
        },
        update: {
            method: 'PUT'
        },
        all: {
            method: 'GET',
            isArray: true,
            url: prefixRoute + 'resposta-solicitacao-juridico',
        },
        pageable: {
            method: 'GET',
            url: prefixRoute + 'resposta-solicitacao-juridico/pageable',
            params: {
                'sort': '@sort',
                'number': '@number',
                'size': '@size'
            }

        },
    });
});

angular.module('bentham').factory('RespostaJuridicoPerspectivaService', function (GenericService, RespostaJuridicoPerspectiva, $q) {
    var self = this;
    Object.setPrototypeOf(self, GenericService);
    self.resource = new RespostaJuridicoPerspectiva();
    Object.setPrototypeOf(self.resource, RespostaJuridicoPerspectiva);

    self.converte = function (data) {
      if (data.dataResposta != null)
        data.dataResposta = self.converteData(data.dataResposta);
      return data;
    };

    return function () { return self; };
});
angular.module('bentham.pages.licitacoes.perspectivas').controller('RevisaoRespostaCtrl', function ($scope, RevisaoRespostaService, GenericController, $state, $stateParams, $uibModal, toastr, AuthService, $window) {
  var self = this;
  Object.setPrototypeOf(self, GenericController);
  $scope.authService = AuthService;
  self.service = new RevisaoRespostaService();
});
angular.module('bentham').factory('RevisaoResposta', function ($resource, prefixRoute) {
  return $resource(prefixRoute + 'revisao-resposta-juridico/:id', { 
      id: '@id',
  }, {
    save: {
      method: 'POST'
    },
    update: {
      method: 'PUT'
    },
  });
});

angular.module('bentham').factory('RevisaoRespostaService', function (GenericService, RevisaoResposta, $q) {
  var self = this;
  Object.setPrototypeOf(self, GenericService);
  self.resource = new RevisaoResposta();
  Object.setPrototypeOf(self.resource, RevisaoResposta);

  self.converte = function (data) {
    return data;
  };

  self.valida = function (entity) {
    var data = angular.copy(entity)
    var deferred = $q.defer();
    deferred.resolve(data);
    return deferred.promise
};

  return function () { return self; };
});
angular.module('bentham').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/arquivos/tree.html','<div><div class="row"><div class="col-md-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-if="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-body"><div ng-show="fonte == &quot;bentham&quot;" ng-init="collapse = true; settings = true;"><div ng-show="visao == &quot;grid&quot;"><div uib-collapse="collapse" style="margin-top:20px; margin-bottom:30px;"><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="name">Nome</label> <input name="name" id="name" type="text" ng-model="filtro.name" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="path">Diret\xF3rio</label> <input name="path" id="path" type="text" ng-model="filtro.path" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="tipoDocumento">Tipo de Documento</label><select-tipo-documento name="tipoDocumento" type="text" id="tipoDocumento" ng-model="filtro.tipoDocumento"></select-tipo-documento></div></div></div></div><div class="row"><div class="col-md-12 text-right"><button ng-click="clear()" class="btn btn-default">Limpar</button> <button ng-click="search(filtro)" class="btn btn-success">Buscar</button></div></div></div></div><div class="row"><div class="col-md-12 text-right"><div class="col-md-2"><div class="form-group"><label for="fonte">Fonte</label><select id="fonte" name="fonte" ng-model="fonte" class="form-control"><option value="">Selecione uma Vis\xE3o</option><option value="bentham">Bentham</option></select></div></div><div class="col-md-2"><div class="form-group"><label for="visao">Vis\xE3o</label><select name="visao" id="visao" ng-model="visao" class="form-control"><option value="">Selecione um Vis\xE3o</option><option value="treeView">Tree View</option><option value="grid">Grid</option></select></div></div><div class="col-md-8"><div class="form-group"><button ng-click="settings = !settings" class="btn btn-danger btn-with-icon"><i class="glyphicon glyphicon-cog"></i>Ferramentas</button> <button ng-click="collapse = !collapse" class="btn btn-info btn-with-icon"><i class="glyphicon glyphicon-search"></i>Busca Avan\xE7ada</button><div uib-collapse="settings" style="margin-top:20px; margin-bottom:30px;"><button ng-click="clean()" class="btn btn-success">Limpar</button> <button ng-click="metadata()" class="btn btn-success">Gerar Metadados</button> <button ng-click="sync()" class="btn btn-success">Sincronizar</button></div></div></div></div></div><div class="table-responsive"><table st-table="arquivos" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="name">Nome</th><th st-sort="path">Diret\xF3rio</th><th class="text-right">Tipo de Documento</th><th st-sort="dataCriacao" style="width:180px !important;" class="text-center">Data</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="arquivo in arquivos"><td><a href="" ng-click="download(arquivo)" title="Download">{{arquivo.name}}</a></td><td>{{arquivo.path}}</td><td class="text-right">{{arquivo.tipoDocumento.descricao != null ? arquivo.tipoDocumento.descricao : "Arquivo" }}</td><td class="text-center">{{arquivo.dataCriacao}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="arquivos.length==0"><tr><td colspan="4" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="3" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/components/deletemodal.html','<div class="panel panel-danger bootstrap-panel"><div class="panel-heading"><button class="btn btn-link close" type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close">&times;</button> <span style="font-size:20px; color:#fff;">{{title}}</span></div><div class="panel-body text-center"><span>Voc\xEA tem certeza que deseja excluir <b>{{content}}</b>?</span></div><div class="panel-footer text-right"><button type="submit" class="btn btn-danger" data-dismiss="modal" ng-click="remove(entity)">Excluir</button> <button autofocus="" type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()">Cancelar</button></div></div>');
$templateCache.put('app/pages/components/grid.html','<div class="table-responsive1"><table class="table table-striped table-bordered table-condensed"><thead><tr><th ng-repeat="column in columns" style="width:{{column.width}}px; min-width:{{column.width}}px; vertical-align: middle;" class="{{column.class}}" data-type="{{column.type}}" data-weight="{{column.weight}}">{{column.title}}</th></tr><tbody ng-show="entities.content && entities.content.length > 0"><tr ng-repeat="entity in entities.content"><td ng-repeat="column in columns" data-type="{{column.type}}" data-weight="{{column.weight}}" class="{{column.class}}"><div compile="render(column,entity)" entityname="entityname" style="{{column.style}}" entity="entity"></div></td></tr></tbody><tbody ng-show="!entities.content || entities.content.length <= 0"><tr class="empty-table"><td style="text-align: center" colspan="{{columns.length}}">Nenhum registro encontrado.</td></tr></tbody><tfoot><tr ng-show="totalizermethod" class="totalizer"><td ng-repeat="column in columnsFooter" style="width:{{column.width}}px; min-width:{{column.width}}px; {{column.style}}" class="{{column.class}}" data-type="{{column.type}}" data-weight="{{column.weight}}" colspan="{{column.colspan}}"><div compile="renderFooter(column, totalizador)" totalizador="totalizador"></div></td></tr><tr ng-show="paginationmethod" class="paginate"><td colspan="{{columns.length}}"><ul class="pagination" style="float: left; display: block; margin: 0px;"><li ng-class="{disabled:entities.number<=0}"><a class="first-page" ng-click="loadPage(0)" style="float: left" title="Primeira p\xE1gina."><i class="glyphicon glyphicon-step-backward"></i></a></li><li ng-class="{disabled:entities.number<=0}" ng-click="previusPage()"><a title="P\xE1gina anterior."><i class="glyphicon glyphicon-backward"></i></a></li><li ng-class="{disabled:entities.number==i}" ng-click="loadPage(i)" ng-repeat="i in rangePages"><a>{{i}}</a></li><li ng-class="{disabled:entities.number>=pageSize}" ng-click="nextPage()"><a title="Pr\xF3xima p\xE1gina."><i class="glyphicon glyphicon-forward"></i></a></li><li ng-class="{disabled:getNumberOfpages()==entities.number}"><a class="last-page" ng-click="lastPage()" title="\xDAltima p\xE1gina."><i class="glyphicon glyphicon-step-forward"></i></a></li></ul><div class="registers" style="float: right;"><label>Registros por pagina: {{entities.number}}</label><select style="width: 60px" chosen="" ng-model="recordsPerPage" data-placeholder="10" ng-change="loadPage(entities.number,true)"><option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="30">30</option><option value="40">40</option><option value="50">50</option></select></div><div style="float: right;padding: 11px 6px;"><button ng-print="ng-print" print-element-id="{{gridId}}" class="btn btn-default btn-sm"><i class="fa fa-print" style="margin: 5px 0;font-size: 1.4em;"></i></button></div></td></tr></tfoot><div style="display:none" ng-transclude=""></div></thead></table></div>');
$templateCache.put('app/pages/components/gridconsulta.html','<div style="width: 100%;"><div class="row"><legend class="column">Consultas Salvas</legend></div><div class="row"><div class="column"><grid id="tabela-consulta" entities="consultaCtrl.consultas" entityname="consulta" sticky="sticky"><gridcolumn title="" type="label" data-width="90"><input type="radio" name="itemSelecionado" ng-click="selecionarConsulta(consulta)" ng-value="consulta.id" ng-model="consultaSelecionada.id"></gridcolumn><gridcolumn title="Nome" data-type="string" data-weight="1"><string-limiter maxlength="150" text="{{consulta.nome}}" limiter="..."></string-limiter></gridcolumn><gridcolumn title="" data-type="actions-2-icon" data-weight="1" class="actions"><div class="btn-toolbar"><a ng-click="showConsulta(consulta)" class="btn btn-default btn-sm edit"><i class="glyphicon glyphicon-edit"></i></a><a ng-click="deletarConsulta(consulta)" data-confirm="Deseja deletar a consulta {{consulta.nome | limitTo: 60}}{{consulta.nome.length &gt; 60 ? &quot;...&quot; : &quot;&quot; }}?" class="btn btn-danger btn-sm delete"><i class="icon glyphicon glyphicon-trash"></i></a></div></gridcolumn></grid></div></div></div>');
$templateCache.put('app/pages/components/modal.html','<div class="modal-wrap"><div class="modal fade"><div class="modal-dialog"><div class="modal-content" style="{{style}}"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title">{{title}}</h4></div><div ng-transclude=""></div></div></div></div></div>');
$templateCache.put('app/pages/components/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/gantt/gantt.html','<div class="panel panel-primary bootstrap-panel"><div class="panel-header with-border panel-heading"></div><div class="panel-body"><div class="form-vertical"><div class="row"><div class="col-sm-4"><div class="form-group text-center"><label class="control-label"><i class="fa fa-calendar"></i><i class="fa fa-arrows-h"></i><i class="fa fa-calendar"></i> Exibir apartir de</label><br><div class="row"><div class="form-group col-sm-6"><input id="fromDate" type="date" ng-model="options.fromDate" max-date="{{options.toDate}}" start-date="{{options.currentDateValue.toString()}}" start-week="1" placeholder="Inicio" class="form-control"></div><div class="form-group col-sm-6"><input id="toDate" type="date" ng-model="options.toDate" min-date="{{options.fromDate}}" start-date="{{options.currentDateValue.toString()}}" start-week="1" placeholder="Fim" class="form-control"></div></div></div></div><div class="col-sm-8"><div class="form-group text-center"><label class="control-label"><i class="material-icons">Zoom do gr\xE1fico</i></label><br><input type="range" ng-model="options.zoom" value="0.4" min="0.01" max="2" step="0.1" class="slider"> Zoom: {{ options.zoom }}</div></div></div></div><div id="chart" class="row top-buffer"><div class="col-md-12"><div bs-collapse="" class="panel-group"><div bs-collapse-target="" class="panel-collapse"><div class="panel-body"><div gantt="" ng-if="!loading" data="data" headers-formats="headersFormats" timespans="timespans" show-side="options.labelsEnabled" daily="options.daily" filter-task="{\'name\': options.filterTask}" filter-row="{\'name\': options.filterRow}" sort-mode="options.sortMode" view-scale="options.scale" column-width="getColumnWidth(options.width, options.scale, options.zoom)" auto-expand="options.autoExpand" task-out-of-range="options.taskOutOfRange" from-date="options.fromDate" to-date="options.toDate" allow-side-resizing="options.allowSideResizing" task-content="options.taskContentEnabled ? options.taskContent : undefined" row-content="options.rowContentEnabled ? options.rowContent : undefined" current-date="options.currentDate" current-date-value="options.currentDateValue" headers="options.width &amp;&amp; options.shortHeaders || options.longHeaders" max-height="options.maxHeight &amp;&amp; 300 || 0" time-frames="options.timeFrames" date-frames="options.dateFrames" time-frames-non-working-mode="options.timeFramesNonWorkingMode" time-frames-magnet="options.timeFramesMagnet" api="options.api" column-magnet="options.columnMagnet"><gantt-tree ng-if="data.length" enabled="options.sideMode === \'Tree\' || options.sideMode === \'TreeTable\'" header-content="options.treeHeaderContent" columns="options.sideMode === \'TreeTable\' ? options.treeTableColumns : options.columns" headers="options.columnsHeaders" classes="options.columnsClasses" formatters="options.columnsFormatters" header-contents="options.columnsHeaderContents" keep-ancestor-on-filter-row="true"></gantt-tree><gantt-table ng-if="data.length" enabled="options.sideMode === \'Table\' || options.sideMode === \'TreeTable\'" columns="options.sideMode === \'TreeTable\' ? options.treeTableColumns : options.columns" headers="options.columnsHeaders" classes="options.columnsClasses" formatters="options.columnsFormatters" contents="options.columnsContents" header-contents="options.columnsHeaderContents"></gantt-table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/login/login.html','<div class="auth-main"><div id="auth-block" class="row animated zoomIn text-center"><div style="padding: 50px; border-radius: 25px;" class="panel panel-primary bootstrap-panel"><img src="assets/img/bentham-logo.png" width="145" height="42"> <label class="auth-sys">{{autenticado}}</label><form class="form-horizontal"><div class="row"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Login</label><div class="col-sm-10"><input id="inputEmail3" type="text" ng-model="data.username" placeholder="Login" class="form-control"></div></div></div><div class="row"><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Senha</label><div class="col-sm-10"><input id="inputPassword3" type="password" ng-model="data.password" placeholder="Password" class="form-control"></div></div></div><div class="row"><div class="text-center"><button id="entrar" type="submit" ng-click="login()" class="btn btn-success">Entrar</button></div></div></form></div></div><a href="https://quantaconsultoria.com/" target="_blank" class="quanta-section"><img src="assets/img/quanta-logo.jpg" width="145" height="42"></a></div>');
$templateCache.put('app/pages/arquivos/entity-documento/entity-documento.html','<h3 style="margin-top:20px;">Anexos<hr></h3><div ng-repeat="tipo in tipos"><h5>Lista de {{tipo.descricao}}</h5><div class="row"><div class="col-md-12 text-right"><label type="button" class="btn btn-danger btn-with-icon"><i class="ion-arrow-up-c"></i> Anexar <input type="file" id="{{tipo.id}}" ng-file-select="ng-file-select" onchange="angular.element(this).scope().onFileSelect(this.files, event)" ng-model="files" ng-multiple="true" class="input_file"></label></div></div><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr class="sortable"><th>Nome</th><th>Formato</th><th style="width:120px !important; padding-right: 20px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody><tr ng-repeat="doc in tipo.documentos"><td>{{doc.documento.name}}</td><td>{{doc.documento.contentType}}</td><td class="text-right"><button type="button" ng-click="download(doc.documento)" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="ion-arrow-down-c"></i></button> <button type="button" ng-disabled="!authService.isInRole(\'ROLE_CONTRATOEXTERNO_[A-Z]*D[A-Z]*\') || !authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*D[A-Z]*\')" ng-click="openDocumento(\'O Anexo \'+ tipo.descricao +\' - \'+doc.documento.name, doc)" data-toggle="modal" data-id="{{doc.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="tipo.documentos.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody></table></div><hr></div>');
$templateCache.put('app/pages/cadastrosbasicos/cargo/cargo.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_CARGO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/cadastrosbasicos/cargo/formcargo.html\', \'md\', \'Cargo\', cargo)" tooltip="" title="Novo Cargo" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="nome">Nome</th><th style="width:120px !important; padding-right: 20px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="cargo in displayed"><td class="ellipsis">{{cargo.nome}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_CARGO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/cadastrosbasicos/cargo/formcargo.html\', \'md\', \'Cargo\', cargo)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_CARGO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'lg\', \'A Cargo \'+ cargo.sigla, cargo)" data-toggle="modal" data-id="{{cargo.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="2" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="2" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="1" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/cargo/formcargo.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(cargo)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="cargo.nome" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/cadastrosbasicos/clientes/cliente.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a type="button" ng-disabled="!authService.isInRole(\'ROLE_CLIENTE_[A-Z]*C[A-Z]*\')" ui-sref="cadastrosbasicos.formcliente" class="btn btn-warning">Adicionar</a></div></div><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="well"><form class="form"><div ng-include="\'app/pages/cadastrosbasicos/clientes/clienteSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="submit" ng-click="search()" class="btn btn-success">Buscar</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="pessoaJuridica.pessoa.nome">Raz\xE3o Social</th><th st-sort="pessoaJuridica.nomeFantasia">Nome Fantasia</th><th st-sort="pessoaJuridica.cnpj" class="text-center">CNPJ</th><th st-sort="pessoaJuridica.pessoa.endereco.logradouro">Logradouro</th><th st-sort="pessoaJuridica.pessoa.endereco.codigoPostal" class="text-center">CEP</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="cliente in displayed"><td>{{cliente.pessoaJuridica.pessoa.nome}}</td><td>{{cliente.pessoaJuridica.nomeFantasia}}</td><td class="text-center">{{cliente.pessoaJuridica.cnpj | mask:"cnpj"}}</td><td>{{cliente.pessoaJuridica.pessoa.endereco.logradouro}}</td><td class="text-center">{{cliente.pessoaJuridica.pessoa.endereco.codigoPostal}}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_CLIENTE_[A-Z]*U[A-Z]*\')" ui-sref="cadastrosbasicos.formcliente({ clienteId: cliente.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_CLIENTE_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'O cliente \'+ cliente.pessoaJuridica.nomeFantasia, cliente)" data-toggle="modal" data-id="{{cliente.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/clientes/clienteSearch.html','<div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="cnpj">CNPJ</label> <input name="cnpj" id="cnpj" type="text" ng-model="filtro.cnpj" mask="cnpj" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="nomeFantasia">Nome Fantasia</label> <input name="nomeFantasia" id="nomeFantasia" type="text" ng-model="filtro.nomeFantasia" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="razaoSocial">Raz\xE3o Social</label> <input name="razaoSocial" id="razaoSocial" type="text" ng-model="filtro.nome" class="form-control"></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/clientes/clientes.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><form class="form"><div ng-include="\'app/pages/cadastrosbasicos/clientes/clienteSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a type="button" ng-disabled="!authService.isInRole(\'ROLE_CLIENTE_[A-Z]*C[A-Z]*\')" ui-sref="cadastrosbasicos.formcliente" class="btn btn-warning">Adicionar</a></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="pessoaJuridica.pessoa.nome">Raz\xE3o Social</th><th st-sort="pessoaJuridica.nomeFantasia">Nome Fantasia</th><th st-sort="pessoaJuridica.cnpj" class="text-center">CNPJ</th><th st-sort="pessoaJuridica.pessoa.endereco.logradouro">Logradouro</th><th st-sort="pessoaJuridica.pessoa.endereco.codigoPostal" class="text-center">CEP</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="cliente in displayed"><td>{{cliente.pessoaJuridica.pessoa.nome}}</td><td>{{cliente.pessoaJuridica.nomeFantasia}}</td><td class="text-center">{{cliente.pessoaJuridica.cnpj | mask:"cnpj"}}</td><td>{{cliente.pessoaJuridica.pessoa.endereco.logradouro}}</td><td class="text-center">{{cliente.pessoaJuridica.pessoa.endereco.codigoPostal}}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_CLIENTE_[A-Z]*U[A-Z]*\')" ui-sref="cadastrosbasicos.formcliente({ clienteId: cliente.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_CLIENTE_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Cliente \'+ cliente.pessoaJuridica.nomeFantasia, cliente)" data-toggle="modal" data-id="{{cliente.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/clientes/formcliente.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Informa\xE7\xF5es B\xE1sicas</h3></div><div class="panel-body"><form ng-submit="save(cliente)" name="form" method="post" class="form"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="cnpj">CNPJ<span ng-show="cliente.estrangeiroBoolean !=true">*</span></label> <input name="cnpj" id="cnpj" type="text" ng-model="cliente.pessoaJuridica.cnpj" mask="cnpj" maxlength="255" ng-maxlength="255" ng-blur="onCnpjBlur(cliente.pessoaJuridica.cnpj)" ng-required="cliente.estrangeiroBoolean!=true" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="razaoSocial">Raz\xE3o Social</label> <input name="razaoSocial" id="razaoSocial" type="text" ng-model="cliente.pessoaJuridica.pessoa.nome" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="nomeFantasia">Nome Fantasia</label> <input name="nomeFantasia" id="nomeFantasia" type="text" ng-model="cliente.pessoaJuridica.nomeFantasia" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="email">Email</label><div class="input-group ng-scope"><input name="email" id="email" type="email" aria-describedby="basic-addon2" ng-model="cliente.pessoaJuridica.pessoa.email" required="required" maxlength="255" ng-maxlength="255" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div></div></div><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'"></div><div class="form-actions text-right"><button type="button" ng-click="clear()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form><div ng-include="\'app/pages/cadastrosbasicos/responsavel/responsavel.html\'"></div><div ng-include="\'app/pages/cadastrosbasicos/contato/contato.html\'"></div></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/conta-bancaria/conta-bancaria.html','<div><form class="form"><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Dados Bancarios</h3></div><div ng-init="self.activate()" class="panel-body"><div class="text-right"><button ng-click="open(\'app/pages/cadastrosbasicos/conta-bancaria/formconta-bancaria.html\', \'lg\', \'Conta Bancaria\', conta)" tooltip="" title="Nova Conta Bancaria" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr class="sortable"><th>Ag\xEAncia</th><th>N\xFAmero Conta</th><th>Benefici\xE1rio</th><th>Tipo</th><th style="padding-right: 20px" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="conta in contas"><td class="ellipsis">{{conta.agencia}}</td><td class="ellipsis">{{conta.numeroConta}}</td><td class="ellipsis">{{conta.nomeBeneficiario}}</td><td class="ellipsis">{{conta.tipoConta.descricao}}</td><td class="text-right"><button class="btn btn-link"><span ng-click="open(\'app/pages/cadastrosbasicos\', \'lg\', \'Conta Bancaria\' conta)" class="glyphicon glyphicon-pencil"></span></button> <button ng-click="open(\'app/pages/cadastrosbasicos\', \'lg\', \'Conta Bancaria\' conta)" data-toggle="modal" data-id="{{conta.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="contas.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody></table></div></div></div></div></div></form></div>');
$templateCache.put('app/pages/cadastrosbasicos/conta-bancaria/formconta-bancaria.html','<div ng-controller="ContaCtrl"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><a type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close"><i class="ion-close-round"></i></a><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><form ng-submit="save(conta)" name="form" method="post" class="form"><div class="row"><div class="col-md"><div class="col-md-5"><div class="form-group"><label for="banco">Banco da Conta</label><select-banco name="banco" id="banco" required="required" ng-model="conta.banco" no-selection-label="Banco da Conta Banc\xE1ria"></select-banco></div></div><div class="col-md-2"><div class="form-group"><label for="agencia">Ag\xEAncia</label> <input type="text" required="required" name="agencia" id="agencia" ng-model="conta.agencia" placeholder="Ag\xEAncia" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-5"><div class="form-group"><label for="numeroConta">N\xFAmero da Conta</label> <input type="text" required="required" id="numeroConta" name="numeroConta" ng-model="conta.numeroConta" placeholder="N\xFAmero da Conta" maxlength="255" ng-maxlength="255" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="codigoSwift">BIC/Swift</label> <input type="text" name="codigoSwift" id="codigoSwift" ng-model="conta.codigoSwift" placeholder="C\xF3digo Swift" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-5"><div class="form-group"><label for="numeroABA">IBAN</label> <input type="text" name="numeroABA" id="numeroABA" ng-model="conta.numeroABA" placeholder="Numero ABA" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div></div></div><h3 style="margin-top:20px;">Inscri\xE7\xE3o do Benefici\xE1rio<hr></h3><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="nomeBeneficiario">Nome do Benefici\xE1rio</label> <input type="text" id="nomeBeneficiario" required="required" name="nomeBeneficiario" ng-model="conta.nomeBeneficiario" placeholder="Nome Benefici\xE1rio" maxlength="255" ng-maxlength="255" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="tipoConta">Tipo da Conta</label><select-tipo-conta name="tipoConta" required="required" id="tipoConta" ng-model="conta.tipoConta" no-selection-label="Tipo da Conta"></select-tipo-conta></div></div><div class="col-md-5"><div class="form-group"><label for="numeroRegistroConta">{{conta.tipoConta.registro || \'Documento\'}} do Titular</label> <input type="text" required="required" id="numeroRegistroConta" name="numeroRegistroConta" ng-model="conta.numeroRegistro" ui-mask="{{mascara}" placeholder="Selecione o Tipo da Conta" class="form-control"></div></div><div class="col-md-2"><div style="margin-top:25px" class="form-group"><input type="checkbox" name="reservaFederal" id="reservaFederal" ng-model="conta.reservaFederal"> <label for="reservaFederal">Reserva Federal</label></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-8"><div class="form-group"><label for="instrucoesEspeciais">Instru\xE7\xF5es Especiais</label> <textarea name="instrucoesEspeciais" id="instrucoesEspeciais" ng-model="conta.instrucoesEspeciais" placeholder="Instru\xE7\xF5es Especiais" maxlength="255" class="form-control"></textarea></div></div><div class="col-md-4"><div style="margin-top:25px" class="form-group"><input type="checkbox" name="bancoIntermediario" ng-model="conta.bancoIntermediario" id="bancoIntermediario"> <label for="bancoIntermediario">Conta com banco intermedi\xE1rio</label></div></div></div></div><div class="row"><div ng-show="conta.bancoIntermediario" class="col-md"><div class="col-md-3"><div class="form-group"><label for="numeroBancoIntermediario">N\xFAmero Banco Intermedi\xE1rio</label> <input type="text" name="numeroBancoIntermediario" id="numeroBancoIntermediario" ng-model="conta.numeroBancoIntermediario" maxlength="30" ng-maxlength="30" class="form-control"></div></div></div></div></form><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'"></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Adicionar Conta</button></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/conta-bancaria/viewconta-bancaria.html','<div style="margin-top:50px;"><h3>Dados Bancarios<hr></h3></div><div class="row"><div class="col-xs-12"><div class="table-responsive"><table st-table="conta" class="table table-striped table-hover"><thead><tr class="sortable"><th>Ag\xEAncia</th><th>N\xFAmero Conta</th><th>Benefici\xE1rio</th><th>Tipo</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="conta in contas"><td class="ellipsis">{{conta.agencia}}</td><td class="ellipsis">{{conta.numeroConta}}</td><td class="ellipsis">{{conta.nomeBeneficiario}}</td><td class="ellipsis">{{conta.tipoConta.descricao}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="contas.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/contato/contato.html','<div><form ng-submit="adicionarTelefone(telefone, telefones)" name="formTelefone" class="form"><h3 style="margin-top:30px;">Contato<hr></h3><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="tipoTelefone">Tipo de Contato <span ng-show="telefone.tipoTelefone == null">(Escolha o Tipo para prosseguir!)</span></label><select-enum name="tipoTelefone" id="tipoTelefone" ng-model="telefone.tipoTelefone" tipo="TipoTelefone" tipo-label="Tipo de Telefone" ng-change="atualizarMascaraTelefone(telefone.tipoTelefone)"></select-enum></div></div><div ng-show="telefone.tipoTelefone != null"><div class="col-md-3"><div class="form-group"><label for="numero">Telefone</label> <input name="numero" type="text" id="numero" ng-model="telefone.numero" ui-mask="{{mascara}}" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><button type="submit" style="margin-top:20px;" ng-disabled="telefone.tipoTelefone == null || telefone.numero == null" class="btn btn-success add">Adicionar</button></div></div></div></div></div><div ng-show="telefones.length &gt; 0" class="row"><div class="col-xs-12"><div class="table-responsive"><table st-table="telefone" class="table table-striped table-hover"><thead><tr class="sortable"></tr><th st-sort="telefone">Telefone</th><th st-sort="tipo">Tipo</th><th style="padding-right: 20px" class="text-right">A\xE7\xF5es</th></thead><tbody ng-show="!isLoading"><tr ng-repeat="telefone in telefones"><td>{{telefone.numero}}</td><td>{{telefone.tipoTelefone.descricao}}</td><td class="text-right"><button type="button" ng-click="deletarTelefone(telefone, telefones)" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody></table></div></div></div></form></div>');
$templateCache.put('app/pages/cadastrosbasicos/contato/viewcontato.html','<div style="margin-top:50px;"><h3>Contatos<hr></h3><div class="row"><div class="col-xs-12"><div class="table-responsive"><table st-table="telefones" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="telefone">Telefone</th><th st-sort="tipo">Tipo</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="telefone in telefones"><td>{{telefone.numero}}</td><td>{{telefone.tipoTelefone.descricao}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="2" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="telefones.length==0"><tr><td colspan="2" class="text-center">Sem registros!</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/endereco/endereco.html','<div><h3 style="margin-top:30px;">Endere\xE7o<hr></h3><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="codigoPostal">Cep</label> <input name="codigoPostal" id="codigoPostal" ui-mask="99.999-999" type="text" ng-model="endereco.codigoPostal" ng-blur="onCepBlur(endereco.codigoPostal)" class="form-control"></div></div><div class="col-md-10"><div class="form-group"><label for="logradouro">Logradouro</label> <input name="logradouro" id="logradouro" type="text" ng-model="endereco.logradouro" maxlength="255" ng-maxlength="255" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="numero">N\xFAmero</label> <input name="numero" id="numero" type="text" ng-model="endereco.numero" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="bairro">Bairro</label> <input name="bairro" id="bairro" type="text" ng-model="endereco.bairro" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="complemento">Complemento</label> <input name="complemento" id="complemento" type="text" ng-model="endereco.complemento" maxlength="255" ng-maxlength="255" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="paisOrigem" class="control-label">Pa\xEDs</label><select-pais name="paisOrigem" id="paisOrigem" ng-model="endereco.pais"></select-pais></div></div><div class="col-md-4"><div class="form-group"><label for="estado">Estado</label> <input name="estado" id="estado" type="text" ng-model="endereco.estado" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="cidade">Cidade</label> <input name="cidade" id="cidade" type="text" ng-model="endereco.cidade" maxlength="255" ng-maxlength="255" class="form-control"></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/endereco/viewendereco.html','<div style="margin-top:20px;"><h3>Endere\xE7o<hr></h3><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>Cep</h4><p>{{endereco.codigoPostal}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Lougradouro</h4><p>{{endereco.logradouro}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>N\xFAmero</h4><p>{{endereco.numero}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Bairro</h4><p>{{endereco.bairro}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Complemento</h4><p>{{endereco.complemento}}</p></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>Pa\xEDs</h4><p>{{endereco.pais.nome}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Estado</h4><p>{{endereco.estado}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Cidade</h4><p>{{endereco.cidade}}</p></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/fonte-recurso/fonte-recurso.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_FONTEDERECURSO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/cadastrosbasicos/fonte-recurso/formfonte-recurso.html\', \'md\', \'Fonte de Recurso\', fonte)" tooltip="" title="Nova Fonte de Recurso" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="sigla">Sigla</th><th st-sort="nome">Nome</th><th style="width:120px !important; padding-right: 20px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="fonte in displayed"><td class="ellipsis">{{fonte.sigla}}</td><td class="ellipsis">{{fonte.nome}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_FONTEDERECURSO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/cadastrosbasicos/fonte-recurso/formfonte-recurso.html\', \'md\', \'Fonte de Recurso\', fonte)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_FONTEDERECURSO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'lg\', \'A Fonte de Recurso \'+ fonte.sigla, fonte)" data-toggle="modal" data-id="{{fonte.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/fonte-recurso/formfonte-recurso.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(fonte)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="sigla" class="control-label">Sigla</label> <input name="sigla" id="sigla" ng-model="fonte.sigla" required="required" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="fonte.nome" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/cadastrosbasicos/fornecedores/formfornecedor.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-if="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Informa\xE7\xF5es B\xE1sicas</h3></div><div class="panel-body"><form ng-submit="save(fornecedor)" name="form" method="post"><div class="row"><div class="col-md"></div></div><div class="col-md-3"><div class="form-group"><label for="cnpj">CNPJ</label><span ng-show="fornecedor.estrangeiroBoolean !=true">*</span> <input name="cnpj" id="cnpj" type="text" ng-model="fornecedor.pessoaJuridica.cnpj" mask="cnpj" maxlength="255" ng-maxlength="255" ng-blur="onCnpjBlur(fornecedor.pessoaJuridica.cnpj)" ng-required="fornecedor.estrangeiroBoolean!=true" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="razaoSocial">Raz\xE3o Social</label> <input name="razaoSocial" id="razaoSocial" type="text" ng-model="fornecedor.pessoaJuridica.pessoa.nome" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="nomeFantasia">Nome Fantasia</label> <input name="nomeFantasia" id="nomeFantasia" type="text" ng-model="fornecedor.pessoaJuridica.nomeFantasia" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="email">Email</label><div class="input-group ng-scope"></div><input name="email" id="email" type="email" aria-describedby="basic-addon2" ng-model="fornecedor.pessoaJuridica.pessoa.email" required="required" maxlength="255" ng-maxlength="255" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'"></div><div class="text-right"><button type="button" ng-click="clear()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/fornecedores/fornecedor.html','<div><form class="form"><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_FORNECEDOR_[A-Z]*C[A-Z]*\')" ui-sref="cadastrosbasicos.formfornecedores" class="btn btn-warning">Adicionar</a></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="pessoaJuridica.pessoa.nome">Raz\xE3o Social</th><th st-sort="pessoaJuridica.nomeFantasia">Nome Fantasia</th><th st-sort="pessoaJuridica.cnpj" class="text-center">CNPJ</th><th st-sort="pessoaJuridica.pessoa.endereco.logradouro">Logradouro</th><th st-sort="pessoaJuridica.pessoa.endereco.codigoPostal" class="text-center">CEP</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="fornecedor in displayed"><td>{{fornecedor.pessoaJuridica.pessoa.nome}}</td><td>{{fornecedor.pessoaJuridica.nomeFantasia}}</td><td class="text-center">{{fornecedor.pessoaJuridica.cnpj | mask:"cnpj"}}</td><td>{{fornecedor.pessoaJuridica.pessoa.endereco.logradouro}}</td><td class="text-center">{{fornecedor.pessoaJuridica.pessoa.endereco.codigoPostal}}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_FORNECEDOR_[A-Z]*U[A-Z]*\')" ui-sref="cadastrosbasicos.formfornecedores({ fornecedorId: fornecedor.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_FORNECEDOR_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Fornecedor \'+ (fornecedor.pessoaFisica != null ? fornecedor.pessoaFisica.pessoa.nome : fornecedor.pessoaJuridica.nomeFantasia ), fornecedor)" data-toggle="modal" data-id="{{fornecedor.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></form></div>');
$templateCache.put('app/pages/cadastrosbasicos/fornecedores/viewFornecedor.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-if="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Informa\xE7\xF5es B\xE1sicas</h3></div><div class="panel-body"><div ng-if="fornecedor.pessoaFisica"><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"></div></div><h4>Nome</h4><p>{{fornecedor.pessoaFisica.pessoa.nome}}</p><div class="col-md-4"><div class="form-group"><h4>CPF</h4><p>{{fornecedor.pessoaFisica.cpf}}</p></div></div><div class="col-md-3"><div class="form-group"><h4>Email</h4><samp>{{fornecedor.pessoaFisica.email}}</samp></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><h4>Tipo de Fornecedor</h4></div></div><p>{{fornecedor.tipoFornecedor.descricao}}</p><div class="col-md-3"><div class="form-group"><h4>Tipo de Produto/Servi\xE7o</h4></div></div><p>{{fornecedor.pessoaFisica.tipoProdutoServico}}</p></div></div></div><div ng-if="fornecedor.pessoaJuridica"><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><h4>Raz\xE3o Social</h4><p>{{fornecedor.pessoaJuridica.pessoa.nome}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Nome Fantasia</h4><p>{{fornecedor.pessoaJuridica.nomeFantasia}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Email</h4><samp>{{fornecedor.pessoaJuridica.pessoa.email}}</samp></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><h4>CNPJ</h4><p>{{fornecedor.pessoaJuridica.cnpj}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Inscri\xE7\xE3o Municipal</h4><p>{{fornecedor.pessoaJuridica.pessoa.inscricaoMunicipal}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Inscri\xE7\xE3o Estadual</h4><p>{{fornecedor.pessoaJuridica.pessoa.inscricaoEstadual}}</p></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><h4>Tipo de Fornecedor</h4><p>{{fornecedor.tipoFornecedor.descricao}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Tipo de Produto/Servi\xE7o</h4><p>{{fornecedor.pessoaJuridica.tipoProdutoServico}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Site</h4><p>{{fornecedor.pessoaJuridica.site}}</p></div></div></div></div></div><div ng-include="\'app/pages/cadastrosbasicos/endereco/viewendereco.html\'"></div><div ng-if="fornecedor.pessoaJuridica"><div ng-include="\'app/pages/cadastrosbasicos/responsavel/viewresponsavel.html\'"></div></div><div ng-include="\'app/pages/cadastrosbasicos/contato/viewcontato.html\'"></div><div ng-include="\'app/pages/cadastrosbasicos/conta-bancaria/viewconta-bancaria.html\'"></div><div class="form-actions text-right"><button ng-click="clear()" class="btn btn-danger">Voltar</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/funcionarios/formfuncionario.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Informa\xE7\xF5es B\xE1sicas</h3></div><div class="panel-body"><form ng-submit="save(funcionario)" name="form" method="POST" class="form"><div class="row"><div class="col-md-3"><div class="form-group"><label for="cpf">CPF</label> <input name="cpf" id="cpf" type="cpf" ng-model="funcionario.pessoaFisica.cpf" ui-mask="999.999.999-99" required="required" ng-blur="onCpfBlur(funcionario.pessoaFisica.cpf)" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="funcionario.pessoaFisica.pessoa.nome" required="required" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="rg">RG</label> <input name="rg" id="rg" type="text" ng-model="funcionario.pessoaFisica.rg" ui-mask="999.999.999-9999" required="required" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="email">Email</label><div class="input-group"><input name="email" id="email" ia-describedby="basic-addon2" type="email" ng-model="funcionario.pessoaFisica.pessoa.email" required="required" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div><div class="col-md-6"><div class="form-group"><label for="tipoServicoDespesa">Tipo de Servi\xE7o/Despesa</label><select-tipo-servico-despesa name="tipoServicoDespesa" id="tipoServicoDespesa" ng-model="funcionario.tipoServicoDespesa" required="required"></select-tipo-servico-despesa></div></div><div class="col-md-6"><div class="form-group"><label for="departamento">Departamento</label><select-departamento id="departamento" name="departamento" ng-model="funcionario.departamento" required="required"></select-departamento></div></div><div class="col-md-6"><div class="form-group"><label for="cargo">Cargo</label><select-cargo id="cargo" name="cargo" ng-model="funcionario.cargo" required="required"></select-cargo></div></div><div class="col-md-6"><div class="form-group"><label for="funcao">Fun\xE7\xE3o</label> <input name="funcao" id="funcao" type="text" ng-model="funcionario.funcao" required="required" class="form-control"></div></div></div><div class="text-right"><button type="button" ng-click="close()" style="margin-top: 10px;" class="btn btn-danger">Cancelar</button> <button type="submit" value="Salvar" style="margin-top: 10px;" class="btn btn-success">Salvar</button></div></form><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'"></div><div ng-include="\'app/pages/cadastrosbasicos/contato/contato.html\'"></div></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/funcionarios/funcionario.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><form class="form"><div ng-include="\'app/pages/cadastrosbasicos/funcionarios/funcionarioSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ng-disabled="!authService.isInRole(\'ROLE_FUNCIONARIO_[A-Z]*C[A-Z]*\')" ui-sref="cadastrosbasicos.funcionario" class="btn btn-warning">Adicionar</a></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th style="padding-right:100px;" st-sort="pessoaFisica.pessoa.nome">Nome</th><th st-sort="pessoaFisica.cpf" class="text-center">CPF</th><th st-sort="pessoaFisica.rg" class="text-center">RG</th><th st-sort="departamento.abreviacao" class="text-center">Departamento</th><th st-sort="funcao">Fun\xE7\xE3o</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="funcionario in displayed"><td class="ellipsis">{{funcionario.pessoaFisica.pessoa.nome}}</td><td class="text-center">{{funcionario.pessoaFisica.cpf | mask:"cpf"}}</td><td class="text-center">{{funcionario.pessoaFisica.rg}}</td><td class="text-center">{{funcionario.departamento.abreviacao}}</td><td class="ecllipsis">{{funcionario.funcao}}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_FUNCIONARIO_[A-Z]*U[A-Z]*\')" ui-sref="cadastrosbasicos.funcionario({ funcionarioId: funcionario.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_FUNCIONARIO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Funcion\xE1rio \'+ funcionario.pessoaFisica.pessoa.nome, funcionario)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/funcionarios/funcionarioSearch.html','<div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="cpf">CPF</label> <input name="cpf" id="cpf" type="cpf" ui-mask="999.999.999-99" ng-model="filtro.cpf" class="form-control text-center"></div></div><div class="col-md-10"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="filtro.nome" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="rg">RG</label> <input name="rg" id="rg" type="text" ui-mask="9999999999-9" ng-model="filtro.rg" class="form-control text-center"></div></div><div class="col-md-5"><div class="form-group"><label for="departamento">Departamento</label><select-departamento id="departamento" name="departamento" ng-model="filtro.departamento"></select-departamento></div></div><div class="col-md-5"><div class="form-group"><label for="funcao">Fun\xE7\xE3o</label> <input name="funcao" id="funcao" type="text" ng-model="filtro.funcao" class="form-control"></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/funcionarios/viewfuncionario.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Informa\xE7\xF5es B\xE1sicas</h3></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-4"><h4>Nome</h4><p>{{funcionario.nome}}</p></div><div class="col-md-4"><h4>Nome Apresent\xE1vel</h4><p>{{funcionario.nomeApresentacao}}</p></div><div class="col-md-4"><h4>Email</h4><p>{{funcionario.email | mask:\'email\'}}</p></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><h4>CPF</h4><p>{{funcionario.cpf | mask:\'cpf\'}}</p></div><div class="col-md-4"><h4>RG</h4><p>{{funcionario.rg}}</p></div><div class="col-md-4"><h4>Matr\xEDcula</h4><p>{{funcionario.matricula}}</p></div><div class="col-md-4"><h4>Tipo de Servi\xE7o/Despesa</h4><p>{{funcionario.tipoServicoDespesa.tipoServicoDespesa}}</p></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><h4>Departamento</h4><p>{{funcionario.departamento.nome}}</p></div><div class="col-md-4"><h4>Cargo</h4><p>{{funcionario.cargo.nome}}</p></div><div class="col-md-4"><h4>Fun\xE7\xE3o</h4><p>{{funcionario.funcao}}</p></div></div></div><div ng-include="\'app/pages/cadastrosbasicos/contato/viewcontato.html\'"></div></div><div class="text-right"><button ng-click="close()" style="margin-top: 10px;" type="button" class="btn btn-danger">Voltar</button></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/naturezas/formnatureza.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(natureza)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="natureza">Pertence a Natureza</label><select-natureza-pai ng-model="natureza.pai" ng-change="naturezaPai(natureza.pai)"></select-natureza-pai></div></div><div class="col-md-6"><div class="form-group"><label for="movimentacao">Movimentacao</label><select-enum name="movimentacao" ng-model="natureza.movimentacao" required="required" tipo="TipoMovimentacao" tipo-label="Movimenta\xE7\xE3o" class="form-control"></select-enum></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="codigo">Codigo</label> <input name="codigo" ng-model="natureza.codigo" required="required" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" ng-model="natureza.descricao" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="observacao">Observacao</label> <textarea name="observacao" ng-model="natureza.observacao" required="required" class="form-control"></textarea></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success save">Salvar</button></div></form></div>');
$templateCache.put('app/pages/cadastrosbasicos/naturezas/natureza.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="text-right"><button ng-click="open(\'app/pages/cadastrosbasicos/naturezas/formnatureza.html\', \'lg\', \'Natureza\', natureza)" data-toggle="modal" tooltip="" title="Nova Natureza" data-placement="top" class="btn btn-warning right">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th style="width:150px;" st-sort="codigo">Codigo</th><th style="width:180px;" st-sort="movimentacao">Movimenta\xE7\xE3o</th><th st-sort="descricao">Descri\xE7\xE3o</th><th style="width:155px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="natureza in displayed"><td>{{natureza.codigo}}</td><td>{{natureza.movimentacao.name}}</td><td class="ellipsis">{{natureza.descricao}}</td><td class="text-right"><button ng-click="open(\'app/pages/cadastrosbasicos/naturezas/viewnatureza.html\', \'lg\', \'Natureza\', natureza)" data-toggle="modal" tooltip="" title="Visualizar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-info-sign"></span></button> <button ng-click="open(\'app/pages/cadastrosbasicos/naturezas/formnatureza.html\', \'lg\', \'Natureza\', natureza)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button id="btnExcluirNaturezas" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', natureza.descricao, natureza)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="4" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td colspan="3" class="text-center"><div st-pagination="" st-items-by-page="itemsByPage" st-displayed-pages="5"></div></td><td class="horizontal-scroll"><select title="Linhas por P\xE1gina" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" style="background-color:#fff;" class="form-control"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/naturezas/viewnatureza.html','<div><div style="padding:20px;" class="panel panel-default bootstrap-panel"><div class="panel-heading"><a type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close"><i class="ion-close-round"></i></a><h2 class="panel-title">{{title}}</h2></div><div class="panel-nody"><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><h4>Pertence a Natureza</h4><p>{{natureza.pai !== undefined? natureza.pai.codigo + \' - \' + natureza.pai.descricao: \'0 - SEM NATUREZA PAI\'}}</p></div></div><div class="col-md-6"><div class="form-group"><h4>Movimenta\xE7\xE3o</h4><p>{{natureza.movimentacao.descricao}}</p></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><h4>Codigo</h4><p>{{natureza.codigo}}</p></div></div><div class="col-md-9"><div class="form-group"><h4>Descri\xE7\xE3o</h4><p>{{natureza.descricao}}</p></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><h4>Obeser\xE7\xE3o</h4><p>{{natureza.observacao}}</p></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Fechar</button></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/pessoa-fisica/form-pessoa-fisica.html','<div class="row"><div class="col-md-3"><div class="form-group"><label for="cpf">CPF</label> <input name="cpf" id="cpf" type="cpf" ng-model="pessoaFisica.cpf" mask="cpf" required="required" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="pessoaFisica.pessoa.nome" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="rg">RG</label> <input name="rg" id="rg" type="text" ng-model="pessoaFisica.rg" ui-mask="999.999.999-9999" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="email">Email</label><div class="input-group"><input name="email" id="email" ia-describedby="basic-addon2" type="email" ng-model="pessoaFisica.pessoa.email" required="required" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div></div><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'"></div>');
$templateCache.put('app/pages/cadastrosbasicos/pessoa-fisica/formpessoa-fisica.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(pessoaFisica)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md-3"><div class="form-group"><label for="cpf">CPF</label> <input name="cpf" id="cpf" type="cpf" ng-model="pessoaFisica.cpf" mask="cpf" required="required" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="pessoaFisica.pessoa.nome" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="rg">RG</label> <input name="rg" id="rg" type="text" ng-model="pessoaFisica.rg" ui-mask="999.999.999-9999" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="email">Email</label><div class="input-group"><input name="email" id="email" ia-describedby="basic-addon2" type="email" ng-model="pessoaFisica.pessoa.email" required="required" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div></div><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'"></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/cadastrosbasicos/pessoa-fisica/pessoa-fisica.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><form class="form"><div ng-include="\'app/pages/cadastrosbasicos/pessoa-fisica/pessoa-fisicaSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button> <button ng-disabled="!authService.isInRole(\'ROLE_PESSOA_FISICA_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/cadastrosbasicos/pessoa-fisica/formpessoa-fisica.html\', \'lg\', \'Nova Pessoa F\xEDsica\', pessoaFisica)" tooltip="" title="Nova Pessoa F\xEDsica" data-placement="top" class="btn btn-warning">Adicionar</button></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="pessoa.nome">Nome</th><th st-sort="cpf" class="text-center">CPF</th><th st-sort="rg" class="text-center">RG</th><th st-sort="pessoa.endereco.codigoPostal" class="text-center">CEP</th><th st-sort="pessoa.endereco.logradouro">Logradouro</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="pessoaFisica in displayed"><td>{{pessoaFisica.pessoa.nome}}</td><td class="text-center">{{pessoaFisica.cpf | mask:"cpf"}}</td><td class="text-center">{{pessoaFisica.rg}}</td><td class="text-center">{{pessoaFisica.pessoa.endereco.codigoPostal}}</td><td>{{pessoaFisica.pessoa.endereco.logradouro}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_PESSOA_FISICA_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/cadastrosbasicos/pessoa-fisica/formpessoa-fisica.html\', \'lg\', \'Pessoa F\xEDsica\', pessoaFisica)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_PESSOA_FISICA_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Pessoa F\xEDsica: \'+ pessoaFisica.pessoa.nome, pessoaFisica)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/pessoa-fisica/pessoa-fisicaSearch.html','<div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="cpf">CPF</label> <input name="cpf" id="cpf" type="cpf" ui-mask="999.999.999-99" ng-model="filtro.cpf" class="form-control text-center"></div></div><div class="col-md-10"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="filtro.nome" maxlength="255" ng-maxlength="255" class="form-control"></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/pessoa-juridica/form-pessoa-juridica.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(pessoaJuridica)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md-4"><div class="form-group"><label for="cnpj">CNPJ</label> <input name="cnpj" id="cnpj" type="cnpj" ng-model="pessoaJuridica.cnpj" ng-blur="onCnpjBlur(pessoaJuridica.cnpj)" mask="cnpj" required="required" class="form-control text-center"> <label for="cnpj" style="color: red">{{ !isCheckCnpjExists() ? \'O CNPJ inserido n\xE3o \xE9 v\xE1lido.\' : \'\' }}</label></div></div><div class="col-md-8"><div class="form-group"><label for="razaoSocial">Nome</label> <input name="razaoSocial" id="razaoSocial" type="text" ng-model="pessoaJuridica.pessoa.nome" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="nomeFantasia">Nome Fantasia</label> <input name="nomeFantasia" id="nomeFantasia" type="text" ng-model="pessoaJuridica.nomeFantasia" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="email">Email</label><div class="input-group"><input name="email" id="email" ia-describedby="basic-addon2" type="email" ng-model="pessoaJuridica.pessoa.email" required="required" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div></div><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'"></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" ng-disabled="!isCheckCnpjExists()" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/cadastrosbasicos/pessoa-juridica/pessoa-juridica-search.html','<div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="cnpj">CNPJ</label> <input name="cnpj" id="cnpj" type="text" ng-model="filtro.cnpj" mask="cnpj" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="nomeFantasia">Nome Fantasia</label> <input name="nomeFantasia" id="nomeFantasia" type="text" ng-model="filtro.nomeFantasia" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="razaoSocial">Raz\xE3o Social</label> <input name="razaoSocial" id="razaoSocial" type="text" ng-model="filtro.nome" class="form-control"></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/pessoa-juridica/pessoa-juridica.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><form class="form"><div ng-include="\'app/pages/cadastrosbasicos/pessoa-juridica/pessoa-juridica-search.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><modal-print ng-if="authService.isInRole(\'ROLE_PESSOA_JURIDICA_CRUDP\')" title="\'Relat\xF3rio\'" reporttitle="Relatorio de Pessoas Juridicas" route="pessoaJuridica/?" filter="filtro"></modal-print><button ng-disabled="!authService.isInRole(\'ROLE_PESSOA_JURIDICA_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/cadastrosbasicos/pessoa-juridica/form-pessoa-juridica.html\', \'lg\', \'Nova Pessoa Juridica\', pessoaJuridica)" tooltip="" title="Nova Pessoa Juridica" data-placement="top" class="btn btn-warning">Adicionar</button></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="pessoa.nome">Raz\xE3o Social</th><th st-sort="nomeFantasia">Nome Fantasia</th><th st-sort="cnpj" class="text-center">CNPJ</th><th st-sort="pessoa.endereco.logradouro">Logradouro</th><th st-sort="pessoa.endereco.codigoPostal" class="text-center">CEP</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="pessoaJuridica in displayed"><td>{{pessoaJuridica.pessoa.nome}}</td><td>{{pessoaJuridica.nomeFantasia}}</td><td class="text-center">{{pessoaJuridica.cnpj}}</td><td>{{pessoaJuridica.pessoa.endereco.logradouro}}</td><td class="text-center">{{pessoaJuridica.pessoa.endereco.codigoPostal}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_PESSOA_JURIDICA_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/cadastrosbasicos/pessoa-juridica/form-pessoa-juridica.html\', \'lg\', \'Pessoa Juridica\', pessoaJuridica)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_PESSOA_JURIDICA_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Pessoa Juridica: \'+ pessoaJuridica.pessoa.nome, pessoaJuridica)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/pessoa-juridica/subform-pessoa-juridica.html','<div class="row"><div class="col-md-3"><div class="form-group"><label for="cnpj">CNPJ</label> <input name="cnpj" id="cnpj" type="cnpj" ng-model="pessoaJuridica.cnpj" ng-blur="onCnpjBlur(pessoaJuridica.cnpj)" mask="cnpj" required="required" class="form-control text-center"><p>{{pessoaJuridica}}</p></div></div><div class="col-md-9"><div class="form-group"><label for="razaoSocial">Nome</label> <input name="razaoSocial" id="razaoSocial" type="text" ng-model="pessoaJuridica.pessoa.nome" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="nomeFantasia">Nome Apresent\xE1vel</label> <input name="nomeFantasia" id="nomeFantasia" type="text" ng-model="pessoaJuridica.nomeFantasia" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="email">Email</label><div class="input-group"><input name="email" id="email" ia-describedby="basic-addon2" type="email" ng-model="pessoaJuridica.pessoa.email" required="required" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/pessoas/pessoafisica.html','<div><form name="pessoaFisicaForm" class="form"><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="pessoaFisicaNome">Nome</label> <input type="text" name="pessoaFisicaNome" id="pessoaFisicaNome" ng-model="pessoaFisica.pessoa.nome" required="required" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="pessoaFisicaNomeApresentacao">Nome de Apresenta\xE7\xE3o</label> <input type="text" name="pessoaFisicaNomeApresentacao" id="pessoaFisicaNomeApresentacao" ng-model="pessoaFisica.pessoa.nome" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="pessoaFisicaCpf">CPF</label> <input type="text" name="pessoaFisicaCpf" id="pessoaFisicaCpf" ng-model="pessoaFisica.cpf" ui-mask="99.999.999-99" required="required" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="pessoaFisicaEmail">Email</label><div class="input-group ng-scope"><input type="email" name="pessoaFisicaEmail" id="pessoaFisicaEmail" aria-describedby="basic-addon2" ng-model="pessoaFisica.email" required="required" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div><div class="col-md-3"><div class="form-group"><label for="tipoFornecedor">Tipo de Fornecedor</label><select-enum name="tipoFornecedor" ng-model="tipoFornecedor" tipo="TipoFornecedor" tipo-label="Selecione o Tipo de Fornecedor"></select-enum></div></div><div class="col-md-3"><div class="form-group"><label for="pessoaFisicaTipoProdutoServico">Tipo de Produto/Servi\xE7o</label> <input type="text" name="pessoaFisicaTipoProdutoServico" id="pessoaFisicaTipoProdutoServico" ng-model="pessoaFisica.tipoProdutoServico" class="form-control"></div></div></div></div><div style="padding: 50px; margin-right:50px;" class="text-right"><button type="button" ng-click="clear()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'"></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/pessoas/pessoajuridica.html','<div><form name="pessoaJuridicaForm" class="form"><div class="row"><div class="col-md-3"><div class="form-group"><label for="cnpj">CNPJ</label> <input name="cnpj" id="cnpj" type="cnpj" ng-model="pessoaJuridica.cnpj" ng-blur="onCnpjBlur(pessoaJuridica.cnpj)" mask="cnpj" required="required" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="razaoSocial">Nome</label> <input name="razaoSocial" id="razaoSocial" type="text" ng-model="pessoaJuridica.pessoa.nome" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="nomeFantasia">Nome Fantasia</label> <input name="nomeFantasia" id="nomeFantasia" type="text" ng-model="pessoaJuridica.nomeFantasia" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="email">Email</label><div class="input-group"><input name="email" id="email" ia-describedby="basic-addon2" type="email" ng-model="pessoaJuridica.pessoa.email" required="required" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div><div class="col-md-6"><div class="form-group"><label for="inscricaoMunicipal">Inscri\xE7\xE3o Municipal</label> <input name="inscricaoMunicipal" id="inscricaoMunicipal" type="text" ng-model="pessoaJuridica.pessoa.inscricaoMunicipal" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="inscricaoEstadual">Inscri\xE7\xE3o Estadual</label> <input name="inscricaoEstadual" id="inscricaoEstadual" type="text" ng-model="pessoaJuridica.pessoa.inscricaoEstadual" maxlength="255" ng-maxlength="255" class="form-control"></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="tipoFornecedor">Tipo de Fornecedor</label><select-enum name="tipoFornecedor" ng-model="tipoFornecedor" tipo="TipoFornecedor" tipo-label="Selecione o Tipo de Fornecedor"></select-enum></div></div><div class="col-md-3"><div class="form-group"><label for="pessoaJuridicaTipoProdutoServico">Tipo Produto/Servi\xE7o</label> <input type="text" name="pessoaJuridicaTipoProdutoServico" id="pessoaJuridicaTipoProdutoServico" ng-model="pessoaJuridica.tipoProdutoServico" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="pessoaJuridicaSite">Site</label> <input type="text" name="pessoaJuridicaSite" id="pessoaJuridicaSite" ng-model="pessoaJuridica.site" class="form-control"></div></div></div></div></form><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'"></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/responsavel/responsavel.html','<div><form ng-submit="adicionarResponsavel(responsavel)" name="formResponsavel" class="form"><h3 style="margin-top:30px;">Respons\xE1veis<hr></h3><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="cpf">CPF</label> <input name="cpf" id="cpf" type="cpf" ng-model="responsavel.cpf" ui-mask="999.999.999-99" required="required" ng-blur="onCpfBlur(responsavel.cpf)" class="form-control text-center"></div></div><div class="col-md-4"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="responsavel.pessoa.nome" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="ReponsavelEmail">Email</label><div class="input-group ng-scope"><input name="ReponsavelEmail" id="ReponsavelEmail" type="email" aria-describedby="basic-addon2" ng-model="responsavel.pessoa.email" maxlength="255" ng-maxlength="255" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div><div class="col-md-2"><div class="form-group text-right"><button type="submit" style="margin-top:20px;" ng-disabled="responsavel.pessoa.nome == null || responsavel.pessoa.email == null || resposavel.cpf" class="btn btn-success">Adicionar</button></div></div></div></div><div ng-show="responsaveis.length &gt;0" class="row"><div class="col-xs-12"><div class="table-responsive"><table st-table="responsaveis" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="cpf">CPF</th><th st-sort="nome">Nome</th><th st-sort="email">Email</th><th style="padding-right: 20px" class="text-right">A\xE7\xF5es</th></tr></thead><tbody><tr ng-repeat="responsavel in responsaveis"><td>{{responsavel.cpf}}</td><td>{{responsavel.pessoa.nome}}</td><td>{{responsavel.pessoa.email}}</td><td class="text-right"><button ng-click="deletarResponsavel(responsavel)" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody></table></div></div></div></form></div>');
$templateCache.put('app/pages/cadastrosbasicos/responsavel/viewresponsavel.html','<div style="margin-top:20px;"><h3>Reponsaveis<hr></h3><div class="row"><div class="col-xs-12"><div class="table-responsive"><table st-table="responsaveis" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="nome">Nome</th><th st-sort="email">Email</th><th st-sort="cpf">CPF</th></tr></thead><tbody><tr ng-repeat="responsavel in responsaveis"><td>{{responsavel.nome}}</td><td>{{responsavel.email}}</td><td>{{responsavel.cpf}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="responsaveis.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/components/leaflet/leaflet.html','<style>\n  .legend {\n    font: 14px/16px Arial, Helvetica, sans-serif;\n    background: rgba(255, 255, 255, 0.9);\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);\n    border-radius: 5px;\n    padding: 6px 8px;\n    width: 180px;\n    line-height: 18px;\n    color: #555;\n  }\n\n  .legend i {\n    width: 16px;\n    height: 16px;\n    float: left;\n    margin-right: 8px;\n    opacity: 0.7;\n  }\n</style><leaflet lf-center="center" controls="controls" defaults="defaults" legend="legend" layers="layers" lf-draw="drawOptions" width="100%" height="480px"></leaflet>');
$templateCache.put('app/pages/components/modal-print/modal-print.html','<div class="panel panel-default bootstrap-panel"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><p class="panel-title">{{title}}</p></div><div class="panel-body text-center"><div class="row"><div style="margin-top:15px;" class="col-md-12"><div class="col-md-4"><label class="radio-inline"><input type="radio" name="optradio" value="PDF" ng-model="formato.name">PDF</label></div><div class="col-md-4"><label class="radio-inline"><input type="radio" name="optradio" value="XLS" ng-model="formato.name">XLS</label></div><div class="col-md-4"><label class="radio-inline"><input type="radio" name="optradio" value="CSV" ng-model="formato.name">CSV</label></div></div></div><div class="row"><div style="margin-top:15px;" class="col-md-12"><button type="button" ng-click="print(formato)" class="btn btn-success">Gerar</button></div></div></div></div>');
$templateCache.put('app/pages/configuracoes/bancos/banco.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_BANCO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/configuracoes/bancos/formbanco.html\', \'lg\', \'Banco\', banco)" data-toggle="modal" title="Editar" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="pais">Pais</th><th st-sort="codigo">C\xF3digo</th><th st-sort="sigla">Sigla</th><th style="padding:20px;width:120px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="banco in displayed"><td class="ellipsis">{{banco.pais.nome}}</td><td class="sortable-space-right">{{banco.codigo}}</td><td class="text">{{banco.sigla}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_BANCO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/configuracoes/bancos/formbanco.html\', \'lg\', \'Banco\', banco)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_BANCO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Banco \'+banco.sigla, banco)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="4" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="3" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/configuracoes/bancos/formbanco.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(banco)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="pais">Pa\xEDs</label><select-pais id="pais" name="pais" ng-model="banco.pais" required="required"></select-pais></div></div><div class="col-md-3"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" type="text" id="codigo" ng-model="banco.codigo" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="sigla">Sigla</label> <input type="text" name="sigla" id="sigla" ng-model="banco.sigla" maxlength="255" ng-maxlength="255" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="nome">Nome do Banco</label> <input name="nome" type="text" id="nome" ng-model="banco.nome" maxlength="255" ng-maxlength="255" required="required" class="form-control"></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/configuracoes/consulta/consulta.html','<div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ng-disabled="!authService.isInRole(\'ROLE_CONSULTA_[A-Z]*C[A-Z]*\')" ui-sref="configuracoes.formconsultas" tooltip="" data-placement="top" class="btn btn-warning">Adicionar</a></div></div><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="well"><form class="form"><div ng-include="\'app/pages/configuracoes/consulta/consultaSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="nome">Nome</th><th st-sort="entidade">Entidade</th><th style="width:120px !important;padding-right: 20px" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="consulta in displayed"><td>{{consulta.nome}}</td><td>{{consulta.entidade.descricao}}</td><td><a ng-disabled="!authService.isInRole(\'ROLE_CONSULTA_[A-Z]*U[A-Z]*\')" ui-sref="configuracoes.formconsultas({ consultaId: consulta.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_CONSULTA_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Consulta \'+ consulta.nome, consulta)" data-toggle="modal" data-id="{{consulta.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td style="width:100 px;"><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/configuracoes/consulta/consultaSearch.html','<div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="filtro.nome" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="nomeFantasia">Entidade</label><select-enum name="alteracao" ng-model="filtro.entidade" tipo="EntityClassName" tipo-label="entidade" class="form-control"></select-enum></div></div></div></div></div>');
$templateCache.put('app/pages/configuracoes/consulta/formconsulta.html','<div class="panel panel-default bootstrap-panel"><div class="panel-body"><form ng-submit="save(consulta, filtro)" name="form" method="post" class="form"><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="usuario">Usuario</label><ui-select multiple="multiple" ng-model="consulta.usuarios" search-enabled="true" append-to-body="true" required="required" class="form-control"><ui-select-match placeholder="Selecione um Usu\xE1rio"><p style="padding-right:15px;">{{$item.pessoaFisica.pessoa.nome}}</p></ui-select-match><ui-select-choices repeat="usuario in _usuarios | filter: $select.search"><p>{{usuario.pessoaFisica.pessoa.nome}}</p></ui-select-choices></ui-select></div></div><div class="col-md-6"><div class="form-group"><label for="perfil">Perfil</label><ui-select multiple="multiple" ng-model="consulta.perfis" search-enabled="true" append-to-body="true" required="required" class="form-control"><ui-select-match placeholder="Selecione os Perfis"><p style="padding-right:15px;">{{$item.descricao}}</p></ui-select-match><ui-select-choices repeat="perfil in _perfis | filter: $select.search"><p>{{perfil.descricao}}</p></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" ng-model="consulta.nome" required="required" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="entidade">Entidade</label><select-enum name="entidade" ng-model="consulta.entidade" tipo="EntityClassName" tipo-label="entidade" ng-change="OnEntidadeChange(consulta.entidade.name)" required="required" class="form-control"></select-enum></div></div></div></div><div ng-include="entitySelected.searchForm"></div><div class="text-right"><button type="button" ng-click="clear()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div></div>');
$templateCache.put('app/pages/configuracoes/departamento/departamento.html','<div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div style="padding-right: 15px" class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_DEPARTAMENTO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/configuracoes/departamento/formdepartamento.html\', \'lg\', \'Departamento\', departamento)" tooltip="" title="Departamento" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="Codigo">C\xF3digo</th><th st-sort="nome">Nome</th><th st-sort="abreviacao">Abrevia\xE7\xE3o</th><th st-sort="descricao">Descri\xE7\xE3o</th><th style="width:120px !important;padding-right: 20px" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="departamento in displayed"><td>{{departamento.codigo}}</td><td class="ellipsis">{{departamento.nome}}</td><td>{{departamento.abreviacao}}</td><td class="ellipsis">{{departamento.descricao}}</td><td><button ng-disabled="!authService.isInRole(\'ROLE_DEPARTAMENTO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/configuracoes/departamento/formdepartamento.html\', \'lg\', \'Departamento\', departamento)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_DEPARTAMENTO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Departamento \'+ departamento.abreviacao, departamento)" data-toggle="modal" data-id="{{departamento.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="5" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="4" class="text-center"></td><td style="width:100 px;"><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/configuracoes/departamento/formdepartamento.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(departamento)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="codigo">Codigo</label> <input name="codigo" id="codigo" ng-model="departamento.codigo" required="required" class="form-control"></div></div><div class="col-md-7"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="departamento.nome" required="required" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="abreviacao">Abrevia\xE7\xE3o</label> <input name="abreviacao" id="abreviacao" ng-model="departamento.abreviacao" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" type="text" ng-model="departamento.descricao" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/configuracoes/alertadeemail/alerta-email.html','<div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div style="padding-right: 15px" class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_SERVIDORDEEMAIL_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/configuracoes/alertadeemail/formalerta-email.html\', \'lg\', \'Alerta de Email\', alerta)" tooltip="" title="Novo Alerta de Email" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="emailRemetente">Email do Remetente</th><th st-sort="servidorsmtp">Servidor SMTP</th><th st-sort="porta">Porta</th><th style="width:120px !important;padding:20px;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="alerta in displayed"><td>{{alerta.emailRemetente}}</td><td>{{alerta.enderecoServidor}}</td><td>{{alerta.porta}}</td><td><button ng-disabled="!authService.isInRole(\'ROLE_SERVIDORDEEMAIL_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/configuracoes/alertadeemail/formalerta-email.html\', \'lg\', \'Alerta de Email\', alerta)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_SERVIDORDEEMAIL_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Alerta \'+ alerta.emailRemetente, alerta)" data-toggle="modal" data-id="{{alerta.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="4" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="3" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/configuracoes/alertadeemail/formalerta-email.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(alerta)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-8"><div class="form-group"><label for="emailRemetente">Email Do Remetente</label> <input type="email" name="emailRemetente" id="emailRemetente" ng-model="alerta.emailRemetente" required="required" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="senha">Senha</label> <input name="senha" id="senha" type="password" ng-model="alerta.senha" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-8"><div class="form-group"><label for="servidorsmtp">Servidor SMTP</label> <input name="enderecoServidor" id="enderecoServidor" ng-model="alerta.enderecoServidor" required="required" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="porta">Porta</label> <input name="porta" id="porta" type="text" ng-model="alerta.porta" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/configuracoes/source-file/formsource-file.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(source)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="protocol">Protocol</label> <input name="protocol" type="text" id="protocol" ng-model="source.protocol" required="required" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="host">Host</label> <input type="text" name="host" id="host" ng-model="source.host" required="required" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="port">Port</label> <input type="text" name="port" id="port" ng-model="source.port" required="required" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="path">Path</label> <input name="path" type="text" id="path" ng-model="source.path" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/configuracoes/source-file/source-file.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_SOURCE_FILE_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/configuracoes/source-file/formsource-file.html\', \'lg\', \'Source File\', source)" data-toggle="modal" title="Adicionar" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="protocol">Protocol</th><th st-sort="host">Host</th><th st-sort="prot">Port</th><th st-sort="path">Path</th><th st-sort="dataSincronizacao">Sincroniza\xE7\xE3o</th><th></th><th style="padding-right:40px;width:250px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="source in displayed"><td>{{source.protocol}}</td><td>{{source.host}}</td><td>{{source.port}}</td><td>{{source.path}}</td><td>{{source.dataSincronizacao == null ? "N\xE3o Sincronizado" : source.dataSincronizacao | date:"dd/M/y"}}</td><td>{{source.isSynchronized == false ? "Sincronizando..." : null}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_SOURCE_FILE_[A-Z]*U[A-Z]*\')" data-toggle="modal" tooltip="" ng-click="sync(source)" title="Sincronizar" data-placement="top" class="btn btn-link"><i class="ion ion-refresh"></i></button> <button ng-disabled="!authService.isInRole(\'ROLE_SOURCE_FILE_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/configuracoes/source-file/formsource-file.html\', \'lg\', \'Source File\', source)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_SOURCE_FILE_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Banco \'+source.host, source)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="7" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="7" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-paginaton="" st-items-by-page="itemsByPage" colspan="6" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/configuracoes/tipo-documento/formtipo-documento.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(tipoDocumento)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="tipoAnexo">Tipo de Anexo</label><select-enum name="tipoAnexo" id="tipoAnexo" ng-model="tipoDocumento.tipoAnexo" tipo="TipoAnexo" tipo-label="Tipo de Anexo" required="required"></select-enum></div></div><div class="col-md-3"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" type="text" id="codigo" ng-model="tipoDocumento.codigo" required="required" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="predecessor">Predecessor</label><select-tipo-documento name="predecessor" type="text" id="predecessor" ng-model="tipoDocumento.predecessor"></select-tipo-documento></div></div><div class="col-md-3"><div class="form-group"><label for="nivel">Nivel</label> <input name="nivel" type="number" id="nivel" ng-model="tipoDocumento.nivel" required="required" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="folder">Folder</label> <input type="text" name="folder" id="folder" ng-model="tipoDocumento.folder" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" type="text" id="descricao" ng-model="tipoDocumento.descricao" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/configuracoes/tipo-documento/tipo-documento.html','<div><div class="row"><div class="col-xs-12"><div ng-init="collapse = true;" class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="text-right"><button ng-click="collapse = !collapse" class="btn btn-info btn-with-icon"><i class="glyphicon glyphicon-search"></i>Busca Avan\xE7ada</button> <button ng-disabled="!authService.isInRole(\'ROLE_TIPO_DOCUMENTO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/configuracoes/tipo-documento/formtipo-documento.html\', \'lg\', \'Tipo de Documento \', tipoDocumento)" data-toggle="modal" title="Editar" data-placement="top" class="btn btn-warning">Adicionar</button></div><div uib-collapse="collapse" style="margin-top:20px; margin-bottom:30px;" class="well"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" type="text" ng-model="filtro.codigo" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" type="text" ng-model="filtro.descricao" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="folder">Diret\xF3rio</label> <input name="folder" id="folder" type="text" ng-model="filtro.folder" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="tipoAnexo">Tipo de Anexo</label><select-enum name="tipoAnexo" id="tipoAnexo" ng-model="filtro.tipoAnexo" tipo="TipoAnexo" tipo-label="Tipo de Anexo"></select-enum></div></div><div class="col-md-3"><div class="form-group"><label for="predecessor">Predecessor</label><select-tipo-documento name="predecessor" type="text" id="predecessor" ng-model="filtro.predecessor"></select-tipo-documento></div></div></div></div><div class="row"><div class="col-md-12 text-right"><button ng-click="search(filtro)" class="btn btn-success">Buscar</button> <button ng-click="clear()" class="btn btn-default">Limpar</button></div></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="nivel">Nivel</th><th st-sort="predecessor.descricao">Predecessor</th><th st-sort="tipoAnexo.codigo">C\xF3digo</th><th st-sort="tipoAnexo.descricao">Tipo de Anexo</th><th st-sort="folder">Folder</th><th st-sort="descricao">Descri\xE7\xE3o</th><th style="padding:20px;width:120px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="tipoDocumento in displayed"><td>{{tipoDocumento.nivel}}</td><td>{{tipoDocumento.predecessor.tipoAnexo.descricao}}</td><td>{{tipoDocumento.codigo}}</td><td>{{tipoDocumento.tipoAnexo.descricao}}</td><td>{{tipoDocumento.folder}}</td><td>{{tipoDocumento.descricao}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_TIPO_DOCUMENTO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/configuracoes/tipo-documento/formtipo-documento.html\', \'lg\', \'Tipo de Documento \', tipoDocumento)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_TIPO_DOCUMENTO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Tipo de Documento \'+tipoDocumento.descricao, tipoDocumento)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="7" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="7" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="6" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/configuracoes/tipocontrato/formtipocontrato.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(tipocontrato)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="codigo">Codigo</label> <input name="codigo" id="codigo" ng-model="tipocontrato.codigo" required="required" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="tipocontrato.nome" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/configuracoes/tipocontrato/tipocontrato.html','<div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div style="padding-right: 15px" class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_TIPODECONTRATO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/configuracoes/tipocontrato/formtipocontrato.html\', \'lg\', \'Tipo de Contrato\', tipocontrato)" tooltip="" title="Novo tipocontrato" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="Codigo">Codigo</th><th st-sort="nome">Nome</th><th style="width:120px !important; padding-right: 20px" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="tipocontrato in displayed"><td>{{tipocontrato.codigo}}</td><td>{{tipocontrato.nome}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_TIPODECONTRATO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/configuracoes/tipocontrato/formtipocontrato.html\', \'lg\', \'Tipo de Contrato\', tipocontrato)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_TIPODECONTRATO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Tipo de Contrato \'+tipocontrato.nome, tipocontrato)" data-toggle="modal" data-id="{{tipocontrato.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/consorcios/consorcio-search.html','<div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="cnpj">CNPJ</label> <input name="cnpj" id="cnpj" type="text" ng-model="filtro.cnpj" mask="cnpj" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="nomeFantasia">Nome Fantasia</label> <input name="nomeFantasia" id="nomeFantasia" type="text" ng-model="filtro.nomeFantasia" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="razaoSocial">Raz\xE3o Social</label> <input name="razaoSocial" id="razaoSocial" type="text" ng-model="filtro.nome" class="form-control"></div></div></div></div>');
$templateCache.put('app/pages/contratos/consorcios/consorcio.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><form class="form"><div ng-include="\'app/pages/contratos/consorcios/consorcio-search.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ng-disabled="!authService.isInRole(\'ROLE_CONSORCIO_[A-Z]*C[A-Z]*\')" ui-sref="contratos.formconsorcio" class="btn btn-warning">Adicionar</a></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="pessoaJuridica.pessoa.nome">Raz\xE3o Social</th><th st-sort="pessoaJuridica.nomeFantasia">Nome</th><th st-sort="pessoaJuridica.cnpj">CNPJ</th><th st-sort="pessoaJuridica.pessoa.endereco.logradouro">Logradouro</th><th st-sort="pessoaJuridica.pessoa.endereco.codigoPostal" class="text-center">CEP</th><th style="width:115px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="consorcio in displayed"><td>{{consorcio.pessoaJuridica.pessoa.nome}}</td><td>{{consorcio.pessoaJuridica.nomeFantasia}}</td><td>{{consorcio.pessoaJuridica.cnpj | mask:"cnpj"}}</td><td>{{consorcio.pessoaJuridica.pessoa.endereco.logradouro}}</td><td class="text-center">{{consorcio.pessoaJuridica.pessoa.endereco.codigoPostal}}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_CONSORCIO_[A-Z]*U[A-Z]*\')" ui-sref="contratos.formconsorcio({ consorcioId: consorcio.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_CONSORCIO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Cons\xF3rcio \'+ consorcio.pessoaJuridica.nomeFantasia, consorcio)" data-toggle="modal" data-id="{{consorcio.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/consorcios/formconsorcio.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-if="isLoading"><div></div></div><div ng-if="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Informa\xE7\xF5es B\xE1sicas</h3></div><div class="panel-body"><form name="form" ng-submit="save(consorcio)" method="post" class="form"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="cnpj">CNPJ</label> <input name="cnpj" id="cnpj" type="text" ng-model="consorcio.pessoaJuridica.cnpj" ng-blur="onCnpjBlur(consorcio.pessoaJuridica.cnpj)" required="required" ui-mask="99.999.999/9999-99" placeholder="00.000.000/0000-00" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="razaoSocial">Raz\xE3o Social</label> <input name="razaoSocial" id="razaoSocial" type="text" ng-model="consorcio.pessoaJuridica.pessoa.nome" required="required" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="nomeFantasia">Nome Fantasia</label> <input name="nomeFantasia" id="nomeFantasia" type="text" ng-model="consorcio.pessoaJuridica.nomeFantasia" required="required" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="email">Email</label><div class="input-group"><input name="email" id="email" ia-describedby="basic-addon2" type="email" ng-model="consorcio.pessoaJuridica.pessoa.email" required="required" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div></div></div><div class="text-right"><button type="button" ng-click="clear()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form><div ng-include="\'app/pages/contratos/consorcios/consorcio-parceiro/consorcio-parceiro.html\'" ng-if="consorcio.id" ng-controller="ConsorcioParceiroCtrl"></div></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/consorcios/pessoa-juridica-search.html','<div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="cnpj">CNPJ</label> <input name="cnpj" id="cnpj" type="text" ng-model="filtro.cnpj" mask="cnpj" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="nomeFantasia">Nome Fantasia</label> <input name="nomeFantasia" id="nomeFantasia" type="text" ng-model="filtro.nomeFantasia" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="razaoSocial">Raz\xE3o Social</label> <input name="razaoSocial" id="razaoSocial" type="text" ng-model="filtro.nome" class="form-control"></div></div></div></div>');
$templateCache.put('app/pages/contratos/contratada/contratada.html','<div><div class="well"><h3 style="margin-bottom:20px;" class="text-center">Contratada</h3><div class="row"><div class="col-md-5"><div class="form-group"><label for="fornecedor">Fornecedor</label><select-fornecedor name="fornecedor" id="fornecedor" ng-model="fornecedor" ng-change="obterInformacoesContratada(fornecedor)" ng-required="!contrato.contratada.nome &amp;&amp; !contrato.contratada.email"></select-fornecedor></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label for="contratadaNome">Nome</label> <input name="contratadaNome" id="contratadaNome" type="text" ng-model="contratada.nome" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="contratadaEmail">Email</label><div class="input-group ng-scope"><input name="contratadaEmail" id="contratadaEmail" type="email" aria-describedby="basic-addon2" ng-model="contratada.email" required="required" maxlength="255" ng-maxlength="255" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div><div ng-if="fornecedor.pessoaFisica" class="col-md-3"><div class="form-group"><label for="contratadaCPF">CPF</label> <input name="contratadaCPF" id="contratadaCPF" type="text" ng-model="contratada.cpf" required="required" maxlength="255" ng-maxlength="255" mask="cpf" class="form-control"></div></div><div ng-if="fornecedor.pessoaJuridica" class="col-md-3"><div class="form-group"><label for="contratadaCnpj">CNPJ</label> <input name="contratadaCnpj" id="contratadaCnpj" type="text" ng-model="contratada.cnpj" required="required" maxlength="255" ng-maxlength="255" mask="cnpj" class="form-control"></div></div></div><h3>Endereco<hr></h3><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="contratadaCep">Cep</label> <input name="contratadaCep" id="contratadaCep" type="text" ui-mask="99.999.99" ng-model="contratada.endereco.codigoPostal" required="required" class="form-control"></div></div><div class="col-md-10"><div class="form-group"><label for="contratadaLogradouro">Logradouro</label> <input name="contratadaLogradouro" id="contratadaLogradouro" type="text" ng-model="contratada.endereco.logradouro" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="contratadaNumero">N\xFAmero</label> <input name="contratadaNumero" id="contratadaNumero" type="text" ng-model="contratada.endereco.numero" required="required" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="contratadaBairro">Bairro</label> <input name="contratadaBairro" id="contratadaBairro" type="text" ng-model="endereco.bairro" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="contratadaComplemento">Complemento</label> <input name="contratadaComplemento" id="contratadaComplemento" type="text" ng-model="contratada.endereco.complemento" maxlength="255" ng-maxlength="255" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="contratadaPaisOrigem" class="control-label">Pa\xEDs</label><select-pais name="contratadaPaisOrigem" required="required" id="contratadaPaisOrigem" ng-model="contratada.endereco.pais"></select-pais></div></div><div class="col-md-4"><div class="form-group"><label for="contratadaEstado">Estado</label> <input name="contratadaEstado" id="contratadaEstado" type="text" ng-model="contratada.endereco.estado" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="contratadaCidade">Cidade</label> <input name="contratadaCidade" id="contratadaCidade" type="text" ng-model="contratada.endereco.cidade" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div></div></div><h3 style="margin-top:30px;">Contato<hr></h3><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="contratadaTipoTelefone">Tipo de Contato <span ng-show="telefone.tipoTelefone == null">(Escolha o Tipo para prosseguir!)</span></label><select-enum name="contratadaTipoTelefone" id="contratadaTipoTelefone" ng-model="telefone.tipoTelefone" tipo="TipoTelefone" tipo-label="Tipo de Telefone" ng-change="atualizarMascaraTelefone(telefone.tipoTelefone)"></select-enum></div></div><div ng-show="telefone.tipoTelefone != null"><div class="col-md-3"><div class="form-group"><label for="numero">Telefone</label> <input name="numero" type="text" id="numero" ng-model="telefone.numero" ui-mask="{{mascara}}" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><button ng-click="adicionarTelefone(telefone, contratada.telefones)" style="margin-top:20px;" ng-disabled="telefone.tipoTelefone == null || telefone.numero == null" class="btn btn-success add">Adicionar</button></div></div></div></div></div><div ng-show="contratada.telefones.length &gt; 0" class="row"><div class="col-xs-12"><div class="table-responsive"><table st-table="contratada.telefones" class="table table-striped table-hover"><thead><tr class="sortable"></tr><th st-sort="telefone">Telefone</th><th st-sort="tipo">Tipo</th><th style="padding-right: 20px" class="text-right">A\xE7\xF5es</th></thead><tbody ng-show="!isLoading"><tr ng-repeat="telefone in contratada.telefones"><td>{{telefone.numero}}</td><td>{{telefone.tipoTelefone.descricao}}</td><td class="text-right"><button type="button" ng-click="deletarTelefone(telefone,contratada.telefones)" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/contratada/viewcontratada.html','<div><div class="well"><h3 style="margin-bottom:20px;" class="text-center">Contratada</h3><div class="row"><div class="col-md-3"><div class="form-group"><h4>Nome</h4>{{contratada.nome}}</div></div><div class="col-md-3"><div class="form-group"><h4>Email</h4>{{contratada.email}}</div></div><div ng-if="fornecedor.pessoaFisica" class="col-md-3"><div class="form-group"><h4>CPF</h4>{{contratada.cpf}}</div></div><div ng-if="fornecedor.pessoaJuridica" class="col-md-3"><div class="form-group"><h4>CNPJ</h4>{{contratada.cnpj}</div></div></div><h3>Endereco<hr></h3><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>Cep</h4>{{contratada.endereco.codigoPostal}}</div></div><div class="col-md-10"><div class="form-group"><h4>Logradouro</h4>{{contratada.endereco.logradouro}}</div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>N\xFAmero</h4>{{contratada.endereco.numero}}</div></div><div class="col-md-4"><div class="form-group"><h4>Bairro</h4>{{endereco.bairro}}</div></div><div class="col-md-6"><div class="form-group"><h4>Complemento</h4>{{contratada.endereco.complemento}}</div></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><h4>Pa\xEDs</h4>{{contratada.endereco.pais.nome}}</div></div><div class="col-md-4"><div class="form-group"><h4>Estado</h4>{{contratada.endereco.estado}}</div></div><div class="col-md-4"><div class="form-group"><h4>Cidade</h4>{{contratada.endereco.cidade}}</div></div></div></div><h3 style="margin-top:30px;">Contato<hr></h3><div ng-show="contratada.telefones.length &gt; 0" class="row"><div class="col-xs-12"><div class="table-responsive"><table st-table="contratada.telefones" class="table table-striped table-hover"><thead><tr class="sortable"></tr><th st-sort="telefone">Telefone</th><th st-sort="tipo">Tipo</th></thead><tbody ng-show="!isLoading"><tr ng-repeat="telefone in contratada.telefones"><td>{{telefone.numero}}</td><td>{{telefone.tipoTelefone.descricao}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/contratante/contratante.html','<div><div class="well"><h3 style="margin-bottom:20px;" class="text-center">Contratante</h3><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="contratanteNome">Nome</label> <input name="contratanteNome" id="contratanteNome" type="text" ng-model="contratante.nome" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="emailContratante">Email</label><div class="input-group ng-scope"><input name="emailContratante" id="emailContratante" type="email" aria-describedby="basic-addon2" ng-model="contratante.email" required="required" maxlength="255" ng-maxlength="255" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div><div class="col-md-2"><div class="form-group"><label for="contratanteCnpj">CNPJ</label> <input name="contratanteCnpj" id="contratanteCnpj" type="text" ng-model="contratante.cnpj" required="required" maxlength="255" ng-maxlength="255" mask="cnpj" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="contratanteInscricaoEstadual">Inscri\xE7\xE3o Estadual</label> <input name="contratanteInscricaoEstadual" id="contratanteInscricaoEstadual" type="text" ng-model="contratante.inscricaoEstadual" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div></div></div><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'" ng-init="endereco=contratante.endereco" ng-if="contratante"></div><div ng-include="\'app/pages/cadastrosbasicos/contato/contato.html\'" ng-init="telefones=contratante.telefones" ng-if="contratante"></div></div></div>');
$templateCache.put('app/pages/contratos/contratante/viewcontratante.html','<div><div class="well"><h3 style="margin-bottom:20px;" class="text-center">Contratante</h3><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><h4>Nome</h4>{{contratante.nome}}</div></div><div class="col-md-3"><div class="form-group"><h4>Email</h4>{{contratante.email}}</div></div><div class="col-md-2"><div class="form-group"><h4>CNPJ</h4>{{contratante.cnpj}}</div></div><div class="col-md-4"><div class="form-group"><h4>Inscri\xE7\xE3o Estadual</h4>{{contratante.inscricaoEstadual}}</div></div></div></div><div style="margin-top:20px;" ng-if="contratante" ng-init="endereco=contratante.endereco" ng-include="\'app/pages/cadastrosbasicos/endereco/viewendereco.html\'"></div><div style="margin-top:20px;" ng-if="contratante" ng-init="telefones=contratante.telefones" ng-include="\'app/pages/cadastrosbasicos/contato/viewcontato.html\'"></div></div></div>');
$templateCache.put('app/pages/contratos/contratosexternos/contratosexternos.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div ng-show="displayedPerspectiva.length &gt; 0"><div style="padding-bottom: 15px" class="text-left"><h3>Contratos a Gerar<hr></h3></div><div style="margin-bottom:90px;" class="table-responsive"><table st-table="displayedPerspectiva" st-safe-src="table.content" st-pipe="loadPerspectiva" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="codigo" style="width:50px !important;">Codigo</th><th st-sort="numeroEdital" style="width:150px">N\xFAmero Edital</th><th st-sort="titulo">Titulo</th><th st-sort="cliente" style="width:50px !important;">Cliente</th><th st-sort="valor" style="width:50px !important;" class="text-right">Valor (R$)</th><th style="width:150px; !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!contratosAGerarLoading"><tr ng-repeat="perspectiva in displayedPerspectiva"><td>{{perspectiva.codigo}}</td><td>{{perspectiva.numeroEdital}}</td><td>{{perspectiva.titulo}}</td><td>{{perspectiva.cliente.pessoaJuridica.nomeFantasia}}</td><td class="text-right">{{perspectiva.valor | mask:"real"}}</td><td class="text-right"><button type="button" ng-click="openPerspectiva(\'app/pages/contratos/contratosexternos/modais/modalContratoGeradoConfirm.html\', \'md\', \'Contrato Gerado\', perspectiva)" data-toggle="modal" tooltip="" title="Contrato Gerado" data-id="{{perspectiva.id}}" data-placement="top" class="btn btn-link"><i style="color:green" class="ion-checkmark-round"></i></button> <button ng-disabled="!authService.isInRole(\'ROLE_CONTRATOEXTERNO_[A-Z]*C[A-Z]*\')" ng-click="openPerspectiva(\'app/pages/contratos/contratosexternos/formcontratoexternoinicial.html\', \'lg\', \'Gerar Contrato\', perspectiva)" data-toggle="modal" tooltip="" title="Gerar Contrato" data-id="{{perspectiva.id}}" data-placement="top" class="btn btn-link"><i class="ion-clipboard"></i></button></td></tr></tbody><tbody ng-show="contratosAGerarLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPagePerspectiva" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPagePerspectiva" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div><div style="padding-bottom: 15px" ng-init="aberto=false" class="text-left"><h3>Contratos<hr></h3></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ng-disabled="!authService.isInRole(\'ROLE_CONTRATOEXTERNO_[A-Z]*C[A-Z]*\')" ui-sref="contratos.formcontratosexternos" class="btn btn-warning">Adicionar</a></div></div><div uib-collapse="!aberto" style="margin-top:20px;margin-bottom:20px;" class="div"><form class="form"><div ng-include="\'app/pages/contratos/contratosexternos/contratosexternosSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button ng-click="search()" class="btn btn-success">Buscar</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="statusContrato" class="text-center">Status</th><th st-sort="numeroContrato">N\xFAmero</th><th st-sort="centroDeCusto.nome">Centro de Custo</th><th st-sort="dataInicioExecucao">Inicio</th><th st-sort="dataFimExecucao">Fim</th><th st-sort="cliente.pessoaJuridica.nomeFantasia" class="hide-column-6">Cliente</th><th st-sort="valorEmpresaReal" class="text-right">Valor (R$)</th><th st-sort="valorPrevisto" class="text-right hide-column-5">Previsto (R$)</th><th st-sort="valorReajustePrevisto" class="text-right hide-column-6">Reajuste P. (R$)</th><th st-sort="valorMedido" class="text-right hide-column-5">Medido (R$)</th><th st-sort="valorReajusteMedido" class="text-right hide-column-6">Reajuste M. (R$)</th><th st-sort="saldo" class="text-right">Saldo (R$)</th><th style="width:180px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="contrato in displayed"><td tooltip="" title="{{contrato.statusContrato.descricao}}" class="text-center"><button ng-class="{\'btn-success\': contrato.isAtivo , \'btn-warning\': contrato.isPossivelEncerramento, \'btn-danger\': contrato.isSemSaldoAMedir, \'btn-info\': contrato.isEncerrado }" class="btn btn-xs btn-icon"><i class="{{contrato.statusContrato.icon}}"></i></button></td><td>{{contrato.numeroContrato}}</td><td>{{contrato.centroDeCusto.nome}}</td><td>{{contrato.dataInicioExecucao | date:"dd/MM/y"}}</td><td>{{contrato.dataFimExecucao | date:"dd/MM/y"}}</td><td class="hide-column-6">{{contrato.cliente.pessoaJuridica.nomeFantasia}}</td><td class="text-right">{{contrato.valorEmpresaReal | mask:"real"}}</td><td ng-class="{\'editable-empty\': contrato.valorEmpresaReal != contrato.valorPrevisto }" class="text-right hide-column-5">{{contrato.valorPrevisto | mask:"real"}}</td><td class="text-right hide-column-6">{{contrato.valorReajustePrevisto | mask:"real"}}</td><td class="text-right hide-column-5">{{contrato.valorMedido | mask:"real"}}</td><td class="text-right hide-column-6">{{contrato.valorReajusteMedido | mask:"real"}}</td><td ng-class="{\'editable-empty\': contrato.saldo &lt; 0 }" class="text-right">{{contrato.saldo | mask:"real"}}</td><td class="text-right"><div uib-dropdown="" dropdown-append-to-body="" class="btn-group"><button type="button" uib-dropdown-toggle="" class="btn btn-link">A\xE7\xF5es<ul uib-dropdown-menu=""><li><a ng-disabled="!authService.isInRole(\'ROLE_CONTRATOEXTERNO_[A-Z]*P[A-Z]*\')" ng-href="{{prefixRoute}}relatorios/ficha-de-contrato/?id={{contrato.id}}&amp;&amp;formato=PDF" tooltip="" title="Relat\xF3rio" data-placement="top" target="_blank" class="btn btn-link"><i class="ion-clipboard">- Relat\xF3rio</i></a></li><li><a ng-disabled="!authService.isInRole(\'ROLE_MEDICAO_[A-Z]*R[A-Z]*\')" ui-sref="economico.medicoes({contratoExternoId: contrato.id})" tooltip="" title="Medi\xE7\xF5es" data-placement="top" class="btn btn-link"><i style="color:green" class="ion ion-cash">- Medi\xE7\xF5es</i></a></li></ul></button><a ng-disabled="!authService.isInRole(\'ROLE_CONTRATOEXTERNO_[A-Z]*U[A-Z]*\')" ui-sref="contratos.formcontratosexternos({contratoId: contrato.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_CONTRATOEXTERNO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Contrato \'+ contrato.numeroContrato, contrato)" data-toggle="modal" data-id="{{contrato.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="13" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="13" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td><td st-pagination="" st-items-by-page="itemsByPage" class="text-center"></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/contratosexternos/contratosexternosSearch.html','<div><div class="row"><div class="col-md-3"><div class="form-group"><label for="numeroContrato">N\xFAmero do Contrato</label> <input name="numeroContrato" ng-model="filtro.numeroContrato" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" ng-model="filtro.descricao" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="numeroEdital">Centro de Custo Ativo</label><select-centro-custo name="centroDeCusto" ng-model="filtro.centroDeCusto" resource="&quot;findAllByContractStatus&quot;" filter="{statusContrato:&quot;ATIVO&quot;}"></select-centro-custo></div></div><div class="col-md-3"><div class="form-group"><label for="responsavel">Respons\xE1vel</label><select-funcionario name="reponsavel" id="responsavel" ng-model="filtro.responsavel"></select-funcionario></div></div><div class="col-md-3"><div class="form-group"><label for="pais">Pa\xEDs</label><select-pais name="pais" type="text" ng-model="filtro.pais" class="form-control"></select-pais></div></div><div class="col-md-3"><div class="form-group"><label for="regiao">Regi\xE3o</label><select-enum name="regiao" tipo="Regiao" ng-model="filtro.regiao" tipo-label="nome da Regi\xE3o" class="form-control"></select-enum></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label for="tipoServico">Tipo de Servi\xE7o</label><select-tipo-servico name="tipoServico" ng-model="filtro.tipoServico" class="form-control"></select-tipo-servico></div></div><div class="col-md-3"><div class="form-group"><label for="area">\xC1rea</label><select-area name="area" ng-model="filtro.area" class="form-control"></select-area></div></div><div class="col-md-3"><div class="form-group"><label for="subArea">Sub\xC1rea</label><select-sub-area name="subarea" ng-model="filtro.subArea" class="form-control"></select-sub-area></div></div><div class="col-md-3"><div class="form-group"><label for="numeroEdital">Status</label><select-enum name="statusContrato" ng-model="filtro.statusContrato" tipo="StatusContrato" tipo-label="Status do Contrato"></select-enum></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label for="cliente">Cliente</label><select-cliente name="cliente" ng-model="filtro.cliente" class="form-control"></select-cliente></div></div><div class="col-md-4"><div class="form-group"><label for="consorcio">Cons\xF3rcio</label><select-consorcio name="consorcio" ng-model="filtro.consorcio"></select-consorcio></div></div></div><div class="row"><div class="col-md-2"><div class="form-group"><label for="valorMinimo">Valor M\xEDnimo</label> <input name="valorMinimo" ng-model="filtro.valorMinimo" type="text" mask="real" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="valorMaximo">Valor M\xE1ximo</label> <input name="valorMaximo" ng-model="filtro.valorMaximo" type="text" mask="real" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="dataInicio">Data Inicio</label> <input type="date" name="dataInicio" ng-model="filtro.dataInicio" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="dataTermino">Data Termino</label> <input type="date" name="dataTermino" ng-model="filtro.dataTermino" class="form-control"></div></div></div></div>');
$templateCache.put('app/pages/contratos/contratosexternos/formcontratoexterno.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"></div></div><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel" ng-show="!isLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dados Gerais" ng-click="activate()"><div class="panel-body"><div style="margin-top:20px;" ng-include="\'app/pages/contratos/contratosexternos/formcontratoexternoinicial.html\'"></div><div style="margin-top:20px;" ng-include="\'app/pages/contratos/contratosexternos/data-importante/data-importante.html\'" ng-if="contrato.id!= null" ng-controller="DataImportanteCtrl"></div></div></uib-tab><uib-tab heading="Revis\xF5es de Contrato" ng-show="contrato.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/contratos/revisaocontrato/revisoescontrato.html\'" ng-if="contrato" ng-controller="RevisaoContratoCtrl"></div></uib-tab><uib-tab heading="Ordens de Servi\xE7o" ng-show="contrato.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/contratos/ordemdeservico/ordensdeservicos.html\'" ng-if="contrato" ng-controller="OrdemDeServicoCtrl"></div></uib-tab><uib-tab heading="Indice de Reajuste" ng-show="contrato.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/contratos/indice-de-reajuste/indice-de-reajuste.html\'" ng-if="contrato" ng-controller="IndiceDeReajusteCtrl"></div></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/pages/contratos/contratosexternos/formcontratoexternoinicial.html','<div class="panel-body"><form ng-submit="save(contrato)" name="form" method="post" class="form"><div class="row"><div class="col-md text-center"><div class="col-md-2"><div class="form-group"><label for="numeroContrato">N\xFAmero do Contrato</label> <input name="numeroContrato" id="numeroContrato" type="text" ng-model="contrato.numeroContrato" maxlength="255" ng-maxlength="255" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="dataAssinaturaContrato">Data da Assinatura do Contrato</label> <input type="text" name="dataAssinaturaContrato" id="dataAssinaturaContrato" ng-model="contrato.dataAssinaturaContrato" mask="brDate" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="numeroEdital">N\xFAmero do Edital</label> <input name="numeroEdital" id="numeroEdital" type="text" ng-model="contrato.numeroEdital" maxlength="255" ng-maxlength="255" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="dataPropostaFinanceira">Data da Proposta Financeira</label> <input type="text" name="dataPropostaFinanceira" id="dataPropostaFinanceira" ng-model="contrato.dataPropostaFinanceira" mask="brDate" ng-blur="onDataPropostraFinanceiraBlur(contrato.dataPropostaFinanceira)" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="dataExtratoContrato">Data do Extrato do Di\xE1rio da Uni\xE3o</label> <input type="text" name="dataExtratoContrato" id="dataExtratoContrato" ng-model="contrato.dataExtratoContrato" mask="brDate" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="numeroOrdemServico">N\xB0 da Ordem de Servi\xE7o</label> <input name="numeroOrdemServico" id="numeroOrdemServico" type="text" ng-model="contrato.numeroOrdemServico" maxlength="255" ng-maxlength="255" class="form-control text-center"></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label for="perspectiva">Perspectiva</label><select-perspectivas-contratos-assinado name="perspectiva" id="perspectiva" ng-model="contrato.perspectiva"></select-perspectivas-contratos-assinado></div></div></div><hr><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="pais" class="control-label">Pa\xEDs</label><select-pais name="pais" ng-model="contrato.pais" required="required"></select-pais></div></div><div class="col-md-3"><div class="form-group"><label for="regiao">Regi\xE3o</label><select-enum name="regiao" id="regiao" tipo="Regiao" ng-model="contrato.regiao" tipo-label="Regi\xE3o" required="required"></select-enum></div></div><div class="col-md-3"><div class="form-group"><label for="estado">Estado</label><select-estado name="estado" type="text" id="estado" ng-model="contrato.estado" noselectionlabel="Selecione um Estado" ng-disabled="!(contrato.pais.sigla === \'BRA\')"></select-estado></div></div><div class="col-md-3"><div class="form-group"><label for="cidade">Cidade</label><select-cidade name="cidade" id="cidade" type="text" ng-model="contrato.cidade" noselectionlabel="Selecione umm Cidade" watch-to="contrato.estado" ng-disabled="!(contrato.pais.sigla === \'BRA\')"></select-cidade></div></div><div class="col-md-4"><div class="form-group"><label for="statusContrato">Status do Contrato</label><select-enum required="required" name="statusContrato" id="statusContrato" ng-model="contrato.statusContrato" tipo="StatusContrato" tipo-label="Status do Contrato"></select-enum></div></div><div class="col-md-4"><div class="form-group"><label for="centroCusto">Centro de Custo</label><select-centro-custo name="centroCusto" id="centroCusto" ng-model="contrato.centroCusto" required="required"></select-centro-custo></div></div><div class="col-md-4"><div class="form-group"><label for="folder">Pasta dos Anexos</label> <input name="folder" id="folder" type="text" ng-model="contrato.folder" class="form-control"></div></div></div></div><hr><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="cliente">Cliente</label><select-cliente name="cliente" id="cliente" ng-model="contrato.cliente" required="required"></select-cliente></div></div><div class="col-md-6"><div class="form-group"><label for="consorcio">Cons\xF3rcio</label><select-consorcio name="consorcio" ng-model="contrato.consorcio"></select-consorcio></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="responsavelCliente">Respons\xE1vel do Cliente</label><select-pessoa-fisica name="responsavelCliente" id="responsavelCliente" ng-model="contrato.responsavelCliente" required="required"></select-pessoa-fisica></div></div><div class="col-md-6"><div class="form-group"><label for="responsavelEmpresa">Respons\xE1vel da Empresa</label><select-pessoa-fisica name="responsavelEmpresa" id="responsavelEmpresa" ng-model="contrato.responsavelEmpresa" required="required"></select-pessoa-fisica></div></div><div class="col-md-12"><div class="form-group"><label for="funcionarios">Funcionarios</label><select-funcionarios name="funcionarios" id="funcionarios" ng-model="contrato.funcionarios"></select-funcionarios></div></div></div></div><hr><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="tipoServicos">Tipos de Servi\xE7os</label><select-tipo-servicos name="tipoServicos" id="tipoServicos" ng-model="contrato.tipoServicos"></select-tipo-servicos></div></div><div class="col-md-4"><div class="form-group"><label for="area">\xC1rea</label><select-area name="area" id="area" ng-model="contrato.area" required="required"></select-area></div></div><div class="col-md-4"><div class="form-group"><label for="subareas">Sub\xC1reas</label><select-sub-areas name="subareas" id="subareas" ng-model="contrato.subAreas"></select-sub-areas></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="escopoContratual">Escopo Contratual</label> <textarea name="escopoContratual" id="escopoContratual" ng-model="contrato.escopoContratual" style="height: 70px;" maxlength="1000" ng-maxlength="1000" class="form-control"></textarea></div></div><div class="col-md-6"><div class="form-group"><label for="descricaoNarrativa">Descri\xE7\xE3o Narrativa</label> <textarea name="descricaoNarrativa" id="descricaoNarrativa" ng-model="contrato.descricaoNarrativa" style="height: 70px;" maxlength="1000" ng-maxlength="1000" class="form-control"></textarea></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="dataInicioExecucao">Data de Inicio da Execu\xE7\xE3o</label> <input type="text" name="dataInicioExecucao" id="dataInicioExecucao" ng-model="contrato.dataInicioExecucao" mask="brDate" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="dataInicioVigencia">Data de Inicio da Vig\xEAncia</label> <input type="text" name="dataInicioVigencia" id="dataInicioVigencia" ng-model="contrato.dataInicioVigencia" mask="brDate" required="required" class="form-control text-center"></div></div><div class="col-md-1"><div class="form-group"><label for="prazo">Prazo</label> <input name="prazo" id="prazo" type="text" ng-model="contrato.prazo" maxlength="255" ng-maxlength="255" ng-blur="onPrazoBlur()" required="required" class="form-control"></div></div><div class="col-md-1"><div class="form-group"><label for="vigencia">Vig\xEAncia</label> <input name="vigencia" id="vigencia" type="text" ng-model="contrato.vigencia" maxlength="255" ng-maxlength="255" ng-blur="onPrazoBlur()" required="required" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="tipoPrazo">Tipo do Prazo</label><select-enum name="tipoPrazo" id="tipoPrazo" ng-model="contrato.tipoPrazo" tipo="TipoPrazo" tipo-label="Tipo de Prazo" ng-change="onPrazoBlur()" required="required"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="dataFimExecucao">Data de Fim da Execu\xE7\xE3o</label> <input type="text" name="dataFimExecucao" id="dataFimExecucao" ng-model="contrato.dataFimExecucao" mask="brDate" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="dataFimVigencia">Data de Fim da Vig\xEAncia</label> <input type="text" name="dataFimVigencia" id="dataFimVigencia" ng-model="contrato.dataFimVigencia" mask="brDate" required="required" class="form-control text-center"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="valorTotalReal">Valor Total (R$)</label> <input required="required" name="valorTotalReal" id="valorTotalReal" type="text" ng-model="contrato.valorTotalReal" mask="real" ng-blur="onValorTotalBlur(contrato.valorTotalReal, contrato.percentualEmpresa, contrato.valorCotacao)" class="form-control text-right"></div></div><div class="col-md-2"><div class="form-group"><label for="percentualEmpresa">% Empresa</label> <input required="required" name="percentualEmpresa" id="percentualEmpresa" type="text" ng-model="contrato.percentualEmpresa" mask="real" ng-blur="onPercentualEmpresaBlur(contrato.valorTotalReal, contrato.percentualEmpresa)" class="form-control text-right"></div></div><div class="col-md-2"><div class="form-group"><label for="valorEmpresaReal">Valor Empresa (R$)</label> <input required="required" name="valorEmpresaReal" id="valorEmpresaReal" type="text" ng-model="contrato.valorEmpresaReal" mask="real" class="form-control text-right"></div></div><div class="col-md-2"><div class="form-group"><label for="pedidoReajuste">Data de Reajuste</label> <input type="text" name="pedidoReajuste" id="pedidoReajuste" ng-model="contrato.pedidoReajuste" mask="brDate" readonly="readonly" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="indiceDeReajuste">\xCDndice de Reajuste</label> <input name="indiceDeReajuste" id="indiceDeReajuste" readonly="readonly" value="{{contrato.indiceDeReajuste.percentual | mask:\'real\'}} - {{contrato.indiceDeReajuste.inicio | date: \'dd/MM/yy\'}}" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="reajuste">Valor de Reajuste (R$)</label> <input name="reajuste" id="reajuste" type="text" ng-model="contrato.reajuste.valor" mask="real" readonly="readonly" class="form-control text-right"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="valorTotalDolar">Valor Total (US$)</label> <input name="valorTotalDolar" id="valorTotalDolar" type="text" ng-model="contrato.valorTotalDolar" mask="real" readonly="readonly" class="form-control text-right"></div></div><div class="col-md-2"><div class="form-group"><label for="valorCotacao">% Cota\xE7\xE3o</label> <input name="valorCotacao" id="valorCotacao" ng-model="contrato.valorCotacao" mask="real" ng-blur="onValorCotacaoBlur(contrato.valorTotalReal, contrato.percentualEmpresa, contrato.valorCotacao)" class="form-control text-right"></div></div><div class="col-md-2"><div class="form-group"><label for="valorEmpresaDolar">Valor Empresa (US$)</label> <input name="valorEmpresaDolar" id="valorTotalDolar" type="text" ng-model="contrato.valorEmpresaDolar" mask="real" readonly="readonly" class="form-control text-right"></div></div><div class="col-md-2"><div class="form-group"><label for="dataCotacao">Data da Cota\xE7\xE3o</label> <input type="text" name="dataCotacao" id="dataCotacao" ng-model="contrato.dataCotacao" mask="brDate" style="text-align:center" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="observacoesGerais">Observa\xE7\xF5es Gerais</label> <textarea name="observacoesGerais" id="observacoesGerais" ng-model="contrato.observacoesGerais" style="height: 70px;" maxlength="1000" ng-maxlength="1000" class="form-control"></textarea></div></div></div></div><div class="text-right"><button type="button" ng-click="cancel()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/contratos/contratosexternos/viewcontratoexterno.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Dados Gerais</h3></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><h4>N\xFAmero do Contrato</h4><p>{{contrato.numeroContrato}}</p></div></div><div class="col-md-3"><div class="form-group"><h4>N\xFAmero do Edital</h4><p>{{contrato.numeroEdital}}</p></div></div><div class="col-md-3"><div class="form-group"><h4>N\xB0 da Ordem de Servi\xE7o</h4><p>{{contrato.numeroOrdemServico}}</p></div></div></div></div><hr><div style="margin-top:20px;" class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><h4>Data de In\xEDcio da 1\xBA O.S/Contrato</h4><p>{{contrato.dataInicioPrimeiroContrato | date:"dd/MM/y"}}</p></div></div><div class="col-md-3"><div class="form-group"><h4>Data da Assinatura do Contrato</h4><p>{{contrato.dataAssinaturaContrato | date:"dd/MM/y"}}</p></div></div><div class="col-md-3"><div class="form-group"><h4>Data do Extrato do Contrato</h4><p>{{contrato.dataExtratoContrato | date:"dd/MM/y"}}</p></div></div><div class="col-md-3"><div class="form-group"><h4>Data de T\xE9rmino da \xDAltima O.S/Contrato</h4><p>{{contrato.dataTerminoUltimoContrato | date:"dd/MM/y"}}</p></div></div></div></div><div style="margin-top:20px;" class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><h4>Data da Proposta Financeira</h4><p>{{contrato.dataPropostaFinanceira | date:"dd/MM/y"}}</p></div></div><div class="col-md-3"><div class="form-group"><h4>Status do Contrato</h4><p>{{contrato.statusContrato.descricao}}</p></div></div><div class="col-md-3"><div class="form-group"><h4>Centro de Custo</h4><p>{{contrato.centroCusto.codigo}}</p></div></div></div></div><div style="margin-top:20px;" class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>Cidade</h4><p>{{contrato.cidade}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Estado</h4><p>{{contrato.estado}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Pa\xEDs</h4><p>{{contrato.pais.nome}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>\xC1rea de Servi\xE7o</h4><p>{{contrato.area.descricao}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Tipo de Servi\xE7o</h4><p>{{contrato.tipoServico.descricao}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Cons\xF3rcio</h4><p>{{contrato.consorcio.nome}}</p></div></div></div></div><div style="margin-top:20px;" class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><h4>Escopo Contratual</h4><p>{{contrato.escopoContratual}}</p></div></div><div class="col-md-6"><div class="form-group"><h4>Descri\xE7\xE3o Narrativa</h4><p>{{contrato.descricaoNarrativa}}</p></div></div></div></div><div style="margin-top:20px;" class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>Valor Total (R$)</h4><p>{{contrato.valorTotalReal | mask:\'real\'}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Valor Empresa (R$)</h4><p>{{contrato.valorEmpresaReal | mask:\'real\'}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Data da Cota\xE7\xE3o</h4><p>{{contrato.dataCotacao | date:"dd/MM/y"}}</p></div></div><div class="col-md-3"><div class="form-group"><h4>Valor Total (US$)</h4><p>{{contrato.valorTotalDolar | mask:\'real\'}}</p></div></div><div class="col-md-3"><div class="form-group"><h4>Valor Empresa (US$)</h4><p>{{contrato.valorEmpresaDolar | mask:\'real\'}}</p></div></div></div></div><div style="margin-top:20px;" class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>Prazo de Execu\xE7\xE3o</h4><p>{{contrato.prazo}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Tipo do Prazo de Execu\xE7\xE3o</h4><p>{{contrato.tipoPrazo.descricao}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Data Final</h4><p>{{contrato.dataFimExecucao | date:"dd/MM/y"}}</p></div></div></div></div><h3 style="margin-top:20px;">Datas Importantes<hr></h3><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><h4>Pedido de Reajuste</h4><p>{{contrato.pedidoReajuste | date:"dd/MM/y"}}</p></div></div><div class="col-md-3"><div class="form-group"><h4>Pedido de Aditivo de Prazo</h4><p>{{contrato.pedidoAditivoPrazo | date:"dd/MM/y"}}</p></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><h4>Observa\xE7\xF5es Gerais</h4><p>{{contrato.observacoesGerais}}</p></div></div></div></div></div><div class="text-right"><button ng-click="clear()" class="btn btn-danger">Voltar</button></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/contratosinternos/contratosInternoSearch.html','<div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="contratrada">Nome da Contratada</label> <input name="contratrada" ng-model="filtro.contratada" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="cliente">Cliente</label><select-cliente name="cliente" ng-model="filtro.cliente" class="form-control"></select-cliente></div></div><div class="col-md-4"><div class="form-group"><label for="tipoDeContrato">Tipo de Contrato</label><select-enum name="tipoDeContrato" ng-model="filtro.tipoDeContrato" tipo="TipoDeContratoInterno" tipo-label="Tipo de Contrato"></select-enum></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/contratosinternos/contratosinternos.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto=false" class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ng-disabled="!authService.isInRole(\'ROLE_CONTRATOINTERNO_[A-Z]*C[A-Z]*\')" ui-sref="contratos.formcontratointerno" class="btn btn-warning">Adicionar</a></div></div><div uib-collapse="!aberto" style="margin-top:20px;margin-bottom:20px;" class="well"><form class="form"><div ng-include="\'app/pages/contratos/contratosinternos/contratosInternoSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="statusContrato" class="text-center">Status</th><th st-sort="numeroContrato">N\xFAmero</th><th st-sort="centroCusto.nome">Centro de Custo</th><th st-sort="dataFimExecucao">Validade</th><th st-sort="cliente.pessoaJuridica.nomeFantasia">Cliente</th><th st-sort="contratada.nome">Contratada</th><th st-sort="valorTotalReal" class="text-right">Valor (R$)</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="contrato in displayed"><td tooltip="" title="{{contrato.statusContrato.descricao}}" class="text-center"><button ng-class="{\'btn-success\': contrato.isAtivo , \'btn-warning\': contrato.isPossivelEncerramento, \'btn-danger\': contrato.isSemSaldoAMedir, \'btn-info\': contrato.isEncerrado }" class="btn btn-xs btn-icon"><i class="{{contrato.statusContrato.icon}}"></i></button></td><td>{{contrato.numeroContrato}}</td><td>{{contrato.centroCusto.nome}}</td><td>{{contrato.dataFimExecucao | date:"dd/MM/y"}}</td><td>{{contrato.cliente.pessoaJuridica.nomeFantasia}}</td><td>{{contrato.contratada.nome}}</td><td class="text-right">{{contrato.valorTotalReal | mask:"real"}}</td><td><a ng-disabled="!authService.isInRole(\'ROLE_CONTRATOINTERNO_[A-Z]*U[A-Z]*\')" ui-sref="contratos.formcontratointerno({contratoId:contrato.id})" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_CONTRATOINTERNO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \' SubContratada \' +contrato.contratada.nome, contrato)" data-toggle="modal" data-id="{{contrato.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="8" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="8" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="7" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/contratosinternos/formcontratoexterno.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div></div><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel" ng-show="!isLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dados Gerais" ng-click="activate()"><div class="panel-body"><div style="margin-top:20px;" ng-include="\'app/pages/contratos/contratosexternos/formcontratoexternoinicial.html\'"></div><div style="margin-top:20px;" ng-include="\'app/pages/contratos/contratosexternos/data-importante/data-importante.html\'" ng-if="contrato.id!= null" ng-controller="DataImportanteCtrl"></div></div></uib-tab><uib-tab heading="Revis\xF5es de Contrato" ng-show="contrato.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/contratos/revisaocontrato/revisoescontrato.html\'" ng-if="contrato" ng-controller="RevisaoContratoCtrl"></div></uib-tab><uib-tab heading="Indice de Reajuste" ng-show="contrato.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/contratos/indice-de-reajuste/indice-de-reajuste.html\'" ng-if="contrato" ng-controller="IndiceDeReajusteCtrl"></div></uib-tab><uib-tab heading="Documentos" ng-show="contrato.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/arquivos/entity-documento/entity-documento.html\'" ng-if="contrato.id &amp;&amp; contrato.folder &amp;&amp; contrato.regiao!= null" ng-controller="ContratoExternoDocumentoCtrl"></div></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/pages/contratos/contratosinternos/formcontratointerno.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div></div><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel" ng-show="!isLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dados Gerais" ng-click="activate()"><div class="panel-body"><div style="margin-top:20px;" ng-include="\'app/pages/contratos/contratosinternos/formcontratointernoinicial.html\'"></div></div></uib-tab><uib-tab heading="Revis\xF5es de Contrato" ng-show="contrato.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/contratos/revisaocontrato/revisoescontrato.html\'" ng-if="contrato" ng-controller="RevisaoContratoInternoCtrl"></div></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/pages/contratos/contratosinternos/formcontratointernoinicial.html','<div class="panel-body"><form name="form" ng-submit="save(contrato)" method="post"><div class="row"><div class="col-md required"><div class="col-md-3"><div class="form-group"><label for="numeroContrato">N\xFAmero do Contrato</label> <input name="numeroContrato" id="numeroContrato" type="text" ng-model="contrato.numeroContrato" maxlength="255" ng-maxlength="255" required="required" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="contratoExterno">Contrato</label><select-contrato-externo name="contratoExterno" id="contratoExterno" ng-model="contrato.contratoExterno" ng-change="autoFillFieldsByContract(contrato.contratoExterno)" required="required"></select-contrato-externo></div></div><div class="col-md-3"><div class="form-group"><label for="dataPropostaFinanceira">Data da Proposta Financeira</label> <input type="text" name="dataPropostaFinanceira" id="dataPropostaFinanceira" ng-model="contrato.dataPropostaFinanceira" mask="brDate" ng-blur="onDataPropostraFinanceiraBlur(contrato.dataPropostaFinanceira)" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="dataAssinaturaContrato">Data da Assinatura do Contrato</label> <input type="text" name="dataAssinaturaContrato" id="dataAssinaturaContrato" ng-model="contrato.dataAssinaturaContrato" mask="brDate" required="required" class="form-control text-center"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="pais" class="control-label">Pa\xEDs</label><select-pais name="pais" ng-model="contrato.pais" required="required"></select-pais></div></div><div class="col-md-3"><div class="form-group"><label for="regiao">Regi\xE3o</label><select-enum name="regiao" id="regiao" tipo="Regiao" ng-model="contrato.regiao" tipo-label="Regi\xE3o" required="required"></select-enum></div></div><div class="col-md-3"><div class="form-group"><label for="estado">Estado</label><select-estado name="estado" type="text" id="estado" ng-model="contrato.estado" noselectionlabel="Selecione um Estado" ng-disabled="!(contrato.pais.sigla === \'BRA\')"></select-estado></div></div><div class="col-md-3"><div class="form-group"><label for="cidade">Cidade</label><select-cidade name="cidade" id="cidade" type="text" ng-model="contrato.cidade" noselectionlabel="Selecione umm Cidade" watch-to="contrato.estado" ng-disabled="!(contrato.pais.sigla === \'BRA\')"></select-cidade></div></div><div class="col-md-4"><div class="form-group"><label for="statusContrato">Status do Contrato</label><select-enum required="required" name="statusContrato" id="statusContrato" ng-model="contrato.statusContrato" tipo="StatusContrato" tipo-label="Status do Contrato"></select-enum></div></div><div class="col-md-4"><div class="form-group"><label for="centroCusto">Centro de Custo</label><select-centro-custo name="centroCusto" id="centroCusto" ng-model="contrato.centroCusto" required="required"></select-centro-custo></div></div><div class="col-md-4"><div class="form-group"><label for="folder">Pasta dos Anexos</label> <input name="folder" id="folder" type="text" ng-model="contrato.folder" class="form-control"></div></div></div></div><hr><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="cliente">Cliente</label><select-cliente name="cliente" id="cliente" ng-model="contrato.cliente" required="required"></select-cliente></div></div><div class="col-md-6"><div class="form-group"><label for="contratada">Contratada</label><select-pessoa id="contratada" name="contratada" ng-model="contrato.contratada"></select-pessoa></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="responsavelCliente">Respons\xE1vel Cliente</label><select-pessoa-fisica name="responsavelCliente" id="responsavelCliente" ng-model="contrato.responsavelCliente"></select-pessoa-fisica></div></div><div class="col-md-6"><div class="form-group"><label for="responsavelEmpresa">Respons\xE1vel Contratada</label><select-pessoa-fisica name="responsavelEmpresa" id="responsavelEmpresa" ng-model="contrato.responsavelEmpresa"></select-pessoa-fisica></div></div><div class="col-md-12"><div class="form-group"><label for="funcionarios">Funcionarios</label><select-funcionarios name="funcionarios" id="funcionarios" ng-model="contrato.funcionarios"></select-funcionarios></div></div></div></div><hr><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="tipoServicos">Tipos de Servi\xE7os</label><select-tipo-servicos name="tipoServicos" id="tipoServicos" ng-model="contrato.tipoServicos"></select-tipo-servicos></div></div><div class="col-md-4"><div class="form-group"><label for="area">\xC1rea</label><select-area name="area" id="area" ng-model="contrato.area"></select-area></div></div><div class="col-md-4"><div class="form-group"><label for="subareas">Sub\xC1reas</label><select-sub-areas name="subareas" id="subareas" ng-model="contrato.subAreas"></select-sub-areas></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="tipoPagamentoContrato">Tipo de Pagamento</label><select-enum name="tipoPagamentoContrato" id="tipoPagamentoContrato" ng-model="contrato.tipoPagamentoContrato" tipo="TipoPagamentoContrato" tipo-label="Tipo de Pagamento"></select-enum></div></div><div class="col-md-6"><div class="form-group"><label for="riscoContrato">Risco do Contrato</label><select-enum name="riscoContrato" id="riscoContrato" ng-model="contrato.riscoContrato" tipo="RiscoContrato" tipo-label="Risco do Contrato"></select-enum></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="contrato.objeto">Objeto do Contrato</label> <textarea name="objeto" ng-model="contrato.objeto" style="height: 70px;" maxlength="1000" ng-maxlength="1000" placeholder="Subcontrata\xE7\xE3o referente ao contrato (n\xFAmero do contrato), servi\xE7o da OS (n\xFAmero do contrato) do cons\xF3rcio (nome do cons\xF3rcio). O objeto consiste em ..." class="form-control"></textarea></div></div><div class="col-md-6"><div class="form-group"><label for="escopoContratual">Escopo Contratual</label> <textarea name="escopoContratual" id="escopoContratual" ng-model="contrato.escopoContratual" style="height: 70px;" maxlength="1000" ng-maxlength="1000" class="form-control"></textarea></div></div><div class="col-md-6"><div class="form-group"><label for="descricaoNarrativa">Descri\xE7\xE3o Narrativa</label> <textarea name="descricaoNarrativa" id="descricaoNarrativa" ng-model="contrato.descricaoNarrativa" style="height: 70px;" maxlength="1000" ng-maxlength="1000" class="form-control"></textarea></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="dataInicioExecucao">Data de Inicio da Execu\xE7\xE3o</label> <input type="text" name="dataInicioExecucao" id="dataInicioExecucao" ng-model="contrato.dataInicioExecucao" mask="brDate" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="dataInicioVigencia">Data de Inicio da Vig\xEAncia</label> <input type="text" name="dataInicioVigencia" id="dataInicioVigencia" ng-model="contrato.dataInicioVigencia" mask="brDate" required="required" class="form-control text-center"></div></div><div class="col-md-1"><div class="form-group"><label for="prazo">Prazo</label> <input name="prazo" id="prazo" type="text" ng-model="contrato.prazo" maxlength="255" ng-maxlength="255" ng-blur="onPrazoBlur()" required="required" class="form-control"></div></div><div class="col-md-1"><div class="form-group"><label for="vigencia">Vig\xEAncia</label> <input name="vigencia" id="vigencia" type="text" ng-model="contrato.vigencia" maxlength="255" ng-maxlength="255" ng-blur="onPrazoBlur()" required="required" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="tipoPrazo">Tipo do Prazo</label><select-enum name="tipoPrazo" id="tipoPrazo" ng-model="contrato.tipoPrazo" tipo="TipoPrazo" tipo-label="Tipo de Prazo" ng-change="onPrazoBlur()" required="required"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="dataFimExecucao">Data de Fim da Execu\xE7\xE3o</label> <input type="text" name="dataFimExecucao" id="dataFimExecucao" ng-model="contrato.dataFimExecucao" mask="brDate" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="dataFimVigencia">Data de Fim da Vig\xEAncia</label> <input type="text" name="dataFimVigencia" id="dataFimVigencia" ng-model="contrato.dataFimVigencia" mask="brDate" required="required" class="form-control text-center"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="valorTotalReal">Valor Total (R$)</label> <input required="required" name="valorTotalReal" id="valorTotalReal" type="text" ng-model="contrato.valorTotalReal" mask="real" ng-blur="onValorTotalBlur(contrato.valorTotalReal, contrato.percentualEmpresa, contrato.valorCotacao)" class="form-control text-right"></div></div><div class="col-md-2"><div class="form-group"><label for="percentualEmpresa">% Empresa</label> <input required="required" name="percentualEmpresa" id="percentualEmpresa" type="text" ng-model="contrato.percentualEmpresa" mask="real" ng-blur="onPercentualEmpresaBlur(contrato.valorTotalReal, contrato.percentualEmpresa)" class="form-control text-right"></div></div><div class="col-md-2"><div class="form-group"><label for="valorEmpresaReal">Valor Empresa (R$)</label> <input required="required" name="valorEmpresaReal" id="valorEmpresaReal" type="text" ng-model="contrato.valorEmpresaReal" mask="real" class="form-control text-right"></div></div><div class="col-md-2"><div class="form-group"><label for="pedidoReajuste">Data de Reajuste</label> <input type="text" name="pedidoReajuste" id="pedidoReajuste" ng-model="contrato.pedidoReajuste" mask="brDate" readonly="readonly" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="indiceDeReajuste">\xCDndice de Reajuste</label> <input name="indiceDeReajuste" id="indiceDeReajuste" readonly="readonly" value="{{contrato.indiceDeReajuste.percentual | mask:\'real\'}} - {{contrato.indiceDeReajuste.inicio | date: \'dd/MM/yy\'}}" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="reajuste">Reajuste (R$)</label> <input name="reajuste" id="reajuste" type="text" ng-model="contrato.reajuste.valor" mask="real" readonly="readonly" class="form-control text-right"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="observacoesGerais">Observa\xE7\xF5es Gerais</label> <textarea name="observacoesGerais" id="observacoesGerais" ng-model="contrato.observacoesGerais" style="height: 70px;" maxlength="1000" ng-maxlength="1000" class="form-control"></textarea></div></div></div></div><div class="text-right"><button type="button" ng-click="clear()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/contratos/contratosinternos/formcontratosinternos.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Dados Gerais</h3></div><div class="panel-body"><form name="form" ng-submit="save(contrato)" method="post"><hr><div class="row"><div class="col-md required"><div class="col-md-3"><div class="form-group"><label for="numeroContrato">N\xFAmero do Contrato</label> <input name="numeroContrato" id="numeroContrato" type="text" ng-model="contrato.numeroContrato" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="contratoExterno">Contrato</label><select-contrato-externo name="contratoExterno" id="contratoExterno" ng-model="contrato.contratoExterno"></select-contrato-externo></div></div><div class="col-md-3"><div class="form-group"><label for="dataPropostaFinanceira">Data da Proposta Financeira</label> <input type="text" name="dataPropostaFinanceira" id="dataPropostaFinanceira" ng-model="contrato.dataPropostaFinanceira" mask="brDate" ng-blur="onDataPropostraFinanceiraBlur(contrato.dataPropostaFinanceira)" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="dataAssinaturaContrato">Data da Assinatura do Contrato</label> <input type="text" name="dataAssinaturaContrato" id="dataAssinaturaContrato" ng-model="contrato.dataAssinaturaContrato" mask="brDate" required="required" class="form-control text-center"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="pais" class="control-label">Pa\xEDs</label><select-pais name="pais" ng-model="contrato.pais" required="required"></select-pais></div></div><div class="col-md-3"><div class="form-group"><label for="regiao">Regi\xE3o</label><select-enum name="regiao" id="regiao" tipo="Regiao" ng-model="contrato.regiao" tipo-label="Regi\xE3o" required="required"></select-enum></div></div><div class="col-md-3"><div class="form-group"><label for="estado">Estado</label><select-estado name="estado" type="text" id="estado" ng-model="contrato.estado" noselectionlabel="Selecione um Estado" ng-disabled="!(contrato.pais.sigla === \'BRA\')"></select-estado></div></div><div class="col-md-3"><div class="form-group"><label for="cidade">Cidade</label><select-cidade name="cidade" id="cidade" type="text" ng-model="contrato.cidade" noselectionlabel="Selecione umm Cidade" watch-to="contrato.estado" ng-disabled="!(contrato.pais.sigla === \'BRA\')"></select-cidade></div></div><div class="col-md-4"><div class="form-group"><label for="statusContrato">Status do Contrato</label><select-enum required="required" name="statusContrato" id="statusContrato" ng-model="contrato.statusContrato" tipo="StatusContrato" tipo-label="Status do Contrato"></select-enum></div></div><div class="col-md-4"><div class="form-group"><label for="centroCusto">Centro de Custo</label><select-centro-custo name="centroCusto" id="centroCusto" ng-model="contrato.centroCusto" required="required"></select-centro-custo></div></div><div class="col-md-4"><div class="form-group"><label for="folder">Pasta dos Anexos</label> <input name="folder" id="folder" type="text" ng-model="contrato.folder" class="form-control"></div></div></div></div><hr><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="cliente">Cliente</label><select-cliente name="cliente" id="cliente" ng-model="contrato.cliente" required="required"></select-cliente></div></div><div class="col-md-6"><div class="form-group"><label for="contratada">Contratada</label><select-pessoa id="contratada" name="contratada" ng-model="contrato.contratada"></select-pessoa></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="responsavelCliente">Respons\xE1vel Cliente</label><select-pessoa-fisica name="responsavelCliente" id="responsavelCliente" ng-model="contrato.responsavelCliente" required="required"></select-pessoa-fisica></div></div><div class="col-md-6"><div class="form-group"><label for="responsavelEmpresa">Respons\xE1vel Contratada</label><select-pessoa-fisica name="responsavelEmpresa" id="responsavelEmpresa" ng-model="contrato.responsavelEmpresa" required="required"></select-pessoa-fisica></div></div><div class="col-md-12"><div class="form-group"><label for="funcionarios">Funcionarios</label><select-funcionarios name="funcionarios" id="funcionarios" ng-model="contrato.funcionarios"></select-funcionarios></div></div></div></div><hr><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="tipoServicos">Tipos de Servi\xE7os</label><select-tipo-servicos name="tipoServicos" id="tipoServicos" ng-model="contrato.tipoServicos"></select-tipo-servicos></div></div><div class="col-md-4"><div class="form-group"><label for="area">\xC1rea</label><select-area name="area" id="area" ng-model="contrato.area" required="required"></select-area></div></div><div class="col-md-4"><div class="form-group"><label for="subareas">Sub\xC1reas</label><select-sub-areas name="subareas" id="subareas" ng-model="contrato.subAreas"></select-sub-areas></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="contrato.objeto">Objeto do Contrato</label> <textarea name="objeto" ng-model="contrato.objeto" style="height: 70px;" maxlength="1000" ng-maxlength="1000" placeholder="Subcontrata\xE7\xE3o referente ao contrato (n\xFAmero do contrato), servi\xE7o da OS (n\xFAmero do contrato) do cons\xF3rcio (nome do cons\xF3rcio). O objeto consiste em ..." class="form-control"></textarea></div></div><div class="col-md-6"><div class="form-group"><label for="escopoContratual">Escopo Contratual</label> <textarea name="escopoContratual" id="escopoContratual" ng-model="contrato.escopoContratual" style="height: 70px;" maxlength="1000" ng-maxlength="1000" class="form-control"></textarea></div></div><div class="col-md-6"><div class="form-group"><label for="descricaoNarrativa">Descri\xE7\xE3o Narrativa</label> <textarea name="descricaoNarrativa" id="descricaoNarrativa" ng-model="contrato.descricaoNarrativa" style="height: 70px;" maxlength="1000" ng-maxlength="1000" class="form-control"></textarea></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="prazo">Prazo</label> <input name="prazo" id="prazo" type="text" ng-model="contrato.prazo" maxlength="255" ng-maxlength="255" ng-blur="onPrazoBlur()" required="required" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="tipoPrazo">Tipo do Prazo</label><select-enum name="tipoPrazo" id="tipoPrazo" ng-model="contrato.tipoPrazo" tipo="TipoPrazo" tipo-label="Tipo de Prazo" ng-change="onPrazoBlur()" required="required"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="dataFinal">Data Final</label> <input type="text" id="tipoPrazo" name="dataFinal" ng-model="contrato.dataFinal" mask="brDate" readonly="readonly" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="pedidoAditivoPrazo">Pedido de Aditivo de Prazo</label> <input type="text" name="pedidoAditivoPrazo" id="pedidoReajuste" ng-model="contrato.pedidoAditivoPrazo" mask="brDate" readonly="readonly" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="pedidoReajuste">Pedido de Reajuste</label> <input type="text" name="pedidoReajuste" id="pedidoReajuste" ng-model="contrato.pedidoReajuste" mask="brDate" readonly="readonly" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="valorTotalReal">Valor Total (R$)</label> <input required="required" name="valorTotalReal" id="valorTotalReal" type="text" ng-model="contrato.valorTotalReal" mask="real" ng-blur="onValorTotalBlur(contrato.valorTotalReal, contrato.percentualEmpresa, contrato.valorCotacao)" class="form-control text-right"></div></div><div class="col-md-3"><div class="form-group"><label for="percentualEmpresa">% Empresa</label> <input required="required" name="percentualEmpresa" id="percentualEmpresa" type="text" ng-model="contrato.percentualEmpresa" mask="real" ng-blur="onPercentualQuantaBlur(contrato.valorTotalReal, contrato.percentualEmpresa)" class="form-control text-right"></div></div><div class="col-md-3"><div class="form-group"><label for="valorEmpresaReal">Valor Empresa (R$)</label> <input required="required" name="valorEmpresaReal" id="valorEmpresaReal" type="text" ng-model="contrato.valorEmpresaReal" mask="real" class="form-control text-right"></div></div><div class="col-md-3"><div class="form-group"><label for="indiceDeReajuste">\xCDndice de Reajuste</label> <input name="indiceDeReajuste" id="indiceDeReajuste" readonly="readonly" value="{{contrato.indiceDeReajuste.percentual | mask:\'real\'}} - {{contrato.indiceDeReajuste.inicio | date: \'dd/MM/yy\'}}" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="reajuste">Reajuste (R$)</label> <input name="reajuste" id="reajuste" type="text" ng-model="contrato.reajuste.valor" mask="real" readonly="readonly" class="form-control text-right"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="observacoesGerais">Observa\xE7\xF5es Gerais</label> <textarea name="observacoesGerais" id="observacoesGerais" ng-model="contrato.observacoesGerais" style="height: 70px;" maxlength="1000" ng-maxlength="1000" class="form-control"></textarea></div></div></div></div><div class="text-right"><button type="button" ng-click="clear()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/contratosinternos/viewcontratointerno.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Dados Gerais</h3></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><h4>N\xFAmero Subcontrato</h4>{{contrato.numeroSubContrato}}</div></div></div></div><h3 style="margin-top:20px;">Contrato de Cliente<hr></h3><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><h4>Contrato</h4>{{contrato.contratoExterno.numeroContrato}}</div></div><div class="col-md-3"><div class="form-group"><h4>Data de In\xEDcio</h4>{{contrato.dataInicio | date:"dd/MM/y"}}</div></div><div class="col-md-3"><div class="form-group"><h4>Data da O.S</h4>{{contrato.dataOS | date:"dd/MM/y"}}</div></div><div class="col-md-3"><div class="form-group"><h4>Data de T\xE9rmino do Contrato</h4>{{contrato.dataTerminoContrato | date:"dd/MM/y"}}</div></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><h4>Prazo de Execu\xE7\xE3o</h4>{{contrato.prazoDeExecucao.valor}}</div></div><div class="col-md-3"><div class="form-group"><h4>Tipo do Prazo de Execu\xE7\xE3o</h4>{{contrato.prazoDeExecucao.tipoPrazo.descricao}}</div></div><div class="col-md-3"><div class="form-group"><h4>Prazo de Vig\xEAncia</h4>{{contrato.prazoDeVigencia.valor}}</div></div><div class="col-md-3"><div class="form-group"><h4>Tipo do Prazo de Vig\xEAncia</h4>{{contrato.prazoDeVigencia.tipoPrazo.descricao}}</div></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><h4>Valor do Contrato (R$)</h4>{{contrato.valorContrato}}</div></div><div class="col-md-3"><div class="form-group"><h4>Servi\xE7os Vinculados ao Centro de Custo</h4>{{contrato.centroDeCusto.codigo}}</div></div><div class="col-md-3"><div class="form-group"><h4>Cliente</h4>{{contrato.cliente.nome}}</div></div><div class="col-md-3"><div class="form-group"><h4>Faturamento Conta Cliente</h4>{{(contrato.faturamentoContaCliente.sim == true) ? "Sim" : "N\xE3o" }}</div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><h4>Objeto do Contrato</h4>{{contrato.objeto}}</div></div></div></div><div style="margin-top:20px;" ng-include="\'app/pages/contratos/contratante/viewcontratante.html\'" ng-if="contrato" ng-init="contratante=contrato.contratante"></div><div style="margin-top:20px;" ng-include="\'app/pages/contratos/contratada/viewcontratada.html\'" ng-if="contrato" ng-init="contratada=contrato.contratada"></div><div class="text-right"><button ng-click="clear()" class="btn btn-danger">Voltar</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/documento-cat/documento-cat.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto = false" class="panel panel-primary bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ng-disabled="!authService.isInRole(\'ROLE_DOCUMENTO_CAT_[A-Z]*C[A-Z]*\')" ui-sref="contratos.formdocumento-cat" class="btn btn-warning">Adicionar</a></div></div><div uib-collapse="!aberto" style="margin-top:20px;margin-bottom:20px;" class="well"><form class="form"><div ng-include="\'app/pages/contratos/documento-cat/documento-catSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button ng-click="search()" class="btn btn-success">Buscar</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="documento.tipoDocumento.codigo">Tipo</th><th st-sort="numero">N\xFAmero</th><th st-sort="profissional.pessoa.nome">Profissional</th><th st-sort="nomeContrato">Contrato</th><th st-sort="contratada.nomeFantasia">Contratada</th><th st-sort="cliente.nomeFantasia">Cliente</th><th>Tipo de Servi\xE7o</th><th>Area</th><th>Sub Area</th><th st-sort="inicio" class="text-center">Inicio</th><th st-sort="fim" class="text-center">Fim</th><th st-sort="valor" class="text-right">Valor</th><th style="width:120px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="documento in displayed"><td>{{documento.documento.tipoDocumento.codigo}}</td><td>{{documento.numero}}</td><td>{{documento.profissional.pessoa.nome}}</td><td>{{documento.nomeContrato}}</td><td>{{documento.contratada.nomeFantasia}}</td><td>{{documento.cliente.nomeFantasia}}</td><td><span ng-repeat="tipoServico in documento.tipoServicos">{{tipoServico.descricao+", "}}</span></td><td><span ng-repeat="area in documento.areas">{{area.descricao+", "}}</span></td><td><span ng-repeat="subArea in documento.subAreas">{{subArea.descricao+", "}}</span></td><td class="text-center">{{documento.inicio | date:\'dd/MM/y\'}}</td><td class="text-center">{{documento.fim | date:\'dd/MM/y\'}}</td><td class="text-right">{{documento.valor | mask:"real"}}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_DOCUMENTO_CAT_[A-Z]*U[A-Z]*\')" ui-sref="contratos.formdocumento-cat({documentoId: documento.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_DOCUMENTO_CAT_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Documento do Contrato \'+ documento.contratoExterno.numeroContrato, documento)" data-toggle="modal" data-id="{{documento.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="12" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="12" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="11" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/documento-cat/documento-catSearch.html','<div><div class="row"><div class="col-md-4"><div class="form-group"><label for="contratoExterno" class="control-label">Contrato de Cliente</label><select-contrato-externo name="contratoExterno" id="contratoExterno" ng-model="filtro.contratoExterno"></select-contrato-externo></div></div><div class="col-md-4"><div class="form-group"><label for="profissional" class="control-label">Profissional</label><select-pessoa-fisica name="profissional" id="profissional" ng-model="filtro.profissional"></select-pessoa-fisica></div></div><div class="col-md-2"><div class="form-group"><label for="numero" class="control-label">N\xFAmero</label> <input name="numero" id="numero" ng-model="filtro.numero" class="form-control text-center"></div></div><div class="col-md-4"><div class="form-group"><label for="funcao" class="control-label">Fun\xE7\xE3o</label> <input name="funcao" id="funcao" ng-model="filtro.funcao" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="cliente" class="control-label">Cliente</label><select-pessoa-juridica name="cliente" id="cliente" ng-model="filtro.cliente"></select-pessoa-juridica></div></div><div class="col-md-4"><div class="form-group"><label for="contratada" class="control-label">Contratada</label><select-pessoa-juridica name="contratada" id="contratada" ng-model="filtro.contratada"></select-pessoa-juridica></div></div><div class="col-md-4"><div class="form-group"><label for="pais" class="control-label">Pais</label><select-pais name="pais" id="pais" ng-model="filtro.pais"></select-pais></div></div><div class="col-md-4"><div class="form-group"><label for="estado">Estado</label><select-estado name="estado" type="text" id="estado" ng-model="filtro.estado" noselectionlabel="Selecione um Estado" ng-disabled="!(filtro.pais.sigla === \'BRA\')"></select-estado></div></div><div class="col-md-4"><div class="form-group"><label for="fonteDeRecurso">Fonte de Recurso</label><select-fonte-recurso name="fonteDeRecurso" id="fonteDeRecurso" ng-model="filtro.fonteDeRecurso"></select-fonte-recurso></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="tipoServicos">Tipos de Servi\xE7os</label><select-tipo-servico name="tipoServico" id="tipoServico" ng-model="filtro.tipoServico"></select-tipo-servico></div></div><div class="col-md-4"><div class="form-group"><label for="area">\xC1rea</label><select-area name="area" id="area" ng-model="filtro.area"></select-area></div></div><div class="col-md-4"><div class="form-group"><label for="subareas">Sub\xC1reas</label><select-sub-area name="subarea" id="subarea" ng-model="filtro.subArea"></select-sub-area></div></div><div class="col-md-2"><div class="form-group"><label for="inicio" class="control-label">Data Inicial</label> <input name="inicio" type="date" id="inicio" ng-model="filtro.inicio" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="fim" class="control-label">Data Final</label> <input name="fim" type="date" id="fim" ng-model="filtro.fim" ng-blur="onFimBlur(filtro.fim)" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="valor" class="control-label">Valor (R$)</label> <input name="valor" id="valor" ng-model="filtro.valor" mask="real:true" class="form-control text-right"></div></div><div class="col-md-3"><div class="form-group"><label for="tipoDocumento">Tipo de Documento</label><select-tipo-documento name="tipoDocumento" type="text" id="tipoDocumento" ng-model="filtro.tipoDocumento"></select-tipo-documento></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/documento-cat/formdocumento-cat.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Dados Gerais</h3></div><div class="panel-body"><form ng-submit="save(cat)" name="form" method="post" class="form"><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="numero" class="control-label">N\xFAmero</label> <input name="numero" id="numero" ng-model="cat.numero" required="required" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="profissional" class="control-label">Profissional</label><select-pessoa-fisica name="profissional" id="profissional" ng-model="cat.profissional" required="required"></select-pessoa-fisica></div></div><div class="col-md-3"><div class="form-group"><label for="funcao" class="control-label">Fun\xE7\xE3o</label> <input name="funcao" id="funcao" ng-model="cat.funcao" required="required" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="numeroContrato" class="control-label">Numero do Contrato</label> <input name="numeroContrato" id="numeroContrato" ng-model="cat.numeroContrato" required="required" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="nomeContrato" class="control-label">Nome do Contrato</label> <input name="nomeContrato" id="nomeContrato" ng-model="cat.nomeContrato" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label for="contratoExterno" class="control-label">Contrato de Cliente</label><select-contrato-externo name="contratoExterno" id="contratoExterno" ng-model="cat.contratoExterno"></select-contrato-externo></div></div><div class="col-md-4"><div class="form-group"><label for="cliente" class="control-label">Cliente</label><select-pessoa-juridica name="cliente" id="cliente" ng-model="cat.cliente" required="required"></select-pessoa-juridica></div></div><div class="col-md-4"><div class="form-group"><label for="contratada" class="control-label">Contratada</label><select-pessoa-juridica name="contratada" id="contratada" ng-model="cat.contratada" required="required"></select-pessoa-juridica></div></div><div class="col-md-4"><div class="form-group"><label for="pais" class="control-label">Pais</label><select-pais name="pais" id="pais" ng-model="cat.pais" required="required"></select-pais></div></div><div class="col-md-4"><div class="form-group"><label for="estado">Estado</label><select-estado name="estado" type="text" id="estado" ng-model="cat.estado" noselectionlabel="Selecione um Estado" ng-disabled="!(cat.pais.sigla === \'BRA\')"></select-estado></div></div><div class="col-md-4"><div class="form-group"><label for="fonteDeRecurso">Fonte de Recurso</label><select-fonte-recurso name="fonteDeRecurso" id="fonteDeRecurso" ng-model="cat.fonteRecurso"></select-fonte-recurso></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="tipoServicos">Tipos de Servi\xE7os</label><select-tipo-servicos name="tipoServicos" id="tipoServicos" ng-model="cat.tipoServicos"></select-tipo-servicos></div></div><div class="col-md-4"><div class="form-group"><label for="areas">\xC1rea</label><select-areas name="areas" id="areas" ng-model="cat.areas"></select-areas></div></div><div class="col-md-4"><div class="form-group"><label for="subareas">Sub\xC1reas</label><select-sub-areas name="subareas" id="subareas" ng-model="cat.subAreas"></select-sub-areas></div></div><div class="col-md-12"><div class="form-group"><label for="pessoasFisicas" class="control-label">Equipe</label><select-pessoas-fisicas name="pessoasFisicas" id="pessoasFisicas" ng-model="cat.pessoasFisicas"></select-pessoas-fisicas></div></div><div class="col-md-2"><div class="form-group"><label for="inicio" class="control-label">Data Inicial</label> <input name="inicio" type="date" id="inicio" ng-model="cat.inicio" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="fim" class="control-label">Data Final</label> <input name="fim" type="date" id="fim" ng-model="cat.fim" ng-blur="onFimBlur(cat.fim)" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="valor" class="control-label">Valor (R$)</label> <input name="valor" id="valor" ng-model="cat.valor" mask="real:true" required="required" class="form-control text-right"></div></div><div class="col-md-3"><div class="form-group"><label for="tipoDocumento">Tipo de Documento</label><select-tipo-documento name="tipoDocumento" type="text" id="tipoDocumento" ng-model="cat.documento.tipoDocumento"></select-tipo-documento></div></div></div></div><h3 style="margin-top:20px">Anexo<hr></h3><div class="row"><div class="col-md-12 text-right"><div class="form-group"><label type="button" style="color:#fff" class="btn btn-danger btn-with-icon"><i class="ion-arrow-up-c"></i> Anexar <input type="file" onchange="angular.element(this).scope().onFileSelect(this.files)" ng-show="false" ng-model="files" ng-file-select="ng-file-select" class="input_file"></label> <button ng-show="cat.documento != null" type="button" ng-click="download(cat.documento)" style="margin-bottom:5px" class="btn btn-success btn-with-icon"><i class="ion-arrow-down-c"></i> Download</button></div></div></div><div class="row"><div class="col-md-12"><object ng-if="picture != null &amp;&amp; cat.documento.contentType == \'application/pdf\'" data="{{trustSrc(picture)}}" width="100%" height="400"></object><img ng-if="picture != null &amp;&amp; cat.documento.contentType != \'application/pdf\'" ng-src="{{picture}}" width="100%" height="400"></div></div><div class="text-right"><button type="button" ng-click="clear()" class="btn btn-danger">Voltar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/indice-de-reajuste/formindice-de-reajuste.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(indice)" name="formIndice" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="codigo" class="control-label">C\xF3digo</label> <input name="codigo" id="codigo" ng-model="indice.codigo" class="form-control text-center"></div></div><div class="col-md-4"><div class="form-group"><label for="inicio" class="control-label">Inicio</label> <input name="inicio" id="inicio" ng-model="indice.inicio" ng-disabled="isLoading" required="required" mask="brDate" class="form-control text-center"></div></div><div class="col-md-4"><div class="form-group"><label for="fim" class="control-label">Fim</label> <input name="fim" id="fim" ng-model="indice.fim" ng-disabled="isLoading" required="required" mask="brDate" class="form-control text-center"></div></div><div class="col-md-4"><div class="form-group"><label for="percentual">Percentual</label> <input name="percentual" id="percentual" type="text" ng-model="indice.percentual" mask="real:false:2:0:100" ng-disabled="isLoading" required="required" class="form-control text-right"></div></div><div class="col-md-4"><div class="form-group"><label for="valorApostilamento">Valor Apostilamento (R$)</label> <input name="valorApostilamento" id="valorApostilamento" ng-model="indice.valorApostilamento" mask="real" ng-disabled="isLoading" class="form-control text-right"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" ng-if="!isLoading" class="btn btn-danger">Cancelar</button> <button type="submit" ng-disabled="isLoading" class="btn btn-success">{{ isLoading ? "Processando Informa\xE7\xF5es..." : "Salvar" }}</button></div></form></div>');
$templateCache.put('app/pages/contratos/indice-de-reajuste/indice-de-reajuste.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto=true"><div class="text-right"><button ng-click="open(\'app/pages/contratos/indice-de-reajuste/formindice-de-reajuste.html\', \'md\', \'\xCDndice de Reajuste\', indice)" tooltip="" title="Nova \xCDndice de Reajuste" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="codigo">codigo</th><th st-sort="inicio">Inicio</th><th st-sort="fim">Fim</th><th st-sort="valorApostilamento" class="text-right">Valor Apostilamento</th><th st-sort="valorAtualizado" class="text-right">Valor Atualizado</th><th st-sort="percentual" class="text-right">Percentual(%)</th><th style="width:120px !important; padding-right: 20px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="indice in displayed"><td>{{indice.codigo }}</td><td>{{indice.inicio | date: "dd/MM/y"}}</td><td>{{indice.fim | date: "dd/MM/y"}}</td><td class="text-right">R$ {{indice.valorApostilamento | mask:"real"}}</td><td class="text-right">R$ {{indice.valorAtualizado | mask:"real"}}</td><td class="text-right">{{indice.percentual| mask:"real"}}</td><td class="text-right"><button ng-click="open(\'app/pages/contratos/indice-de-reajuste/formindice-de-reajuste.html\', \'md\', \'\xCDndice de Reajuste\', indice)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'lg\', \'O indice \'+indice.percentual , indice)" data-toggle="modal" data-id="{{indice.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="6" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/medicao/formmedicao.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Dados Gerais</h3></div><div class="panel-body"><form ng-submit="save(medicao)" name="form" method="post" class="form"><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="contratoExterno" class="control-label">Contrato de Cliente</label><select-contrato-externo name="contratoExterno" id="contratoExterno" ng-model="medicao.contratoExterno" required="required"></select-contrato-externo></div></div><div class="col-md-4"><div class="form-group"><label for="funcionario" class="control-label">Respons\xE1vel</label><select-funcionario name="funcionario" id="funcionario" ng-model="medicao.funcionario" required="required" class="form-control"></select-funcionario></div></div><div class="col-md-2"><div class="form-group"><label for="tipoMedicao" class="control-label">Tipo</label><select-enum name="tipoMedicao" id="tipoMedicao" ng-model="medicao.tipoMedicao" tipo="TipoMedicao" tipo-label="Tipo" required="required"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="statusMedicao" class="control-label">Status</label><select-enum name="statusMedicao" id="statusMedicao" ng-model="medicao.statusMedicao" tipo="StatusMedicao" tipo-label="Status" required="required"></select-enum></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="codigo" class="control-label">C\xF3digo</label> <input name="codigo" id="codigo" ng-model="medicao.codigo" required="required" class="form-control text-center"></div></div><div class="col-md-10"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="medicao.descricao" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2 form-group"><label for="dataCompetencia" class="control-label">Compet\xEAncia</label> <input type="month" name="dataCompetencia" id="dataCompetencia" ng-model="medicao.dataCompetencia" ng-change="onCompetenciaChange(medicao.dataCompetencia)" required="required" class="form-control text-center"></div><div class="col-md-2"><div class="form-group"><label for="inicio" class="control-label">Data Inicial</label> <input name="inicio" type="date" id="inicio" ng-model="medicao.inicio" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="fim" class="control-label">Data Final</label> <input name="fim" type="date" id="fim" ng-model="medicao.fim" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="data" class="control-label">Data do Protocolo</label> <input name="data" type="date" id="data" ng-model="medicao.data" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="valor" class="control-label">Valor (R$)</label> <input name="valor" id="valor" ng-model="medicao.valor" mask="real:true" ng-blur="onValorMedicaoBlur(medicao.valor)" ng-disabled="true" class="form-control text-right"></div></div><div class="col-md-2"><div class="form-group"><label for="valorEmpresa" class="control-label">Valor da Empresa (R$)</label> <input name="valorEmpresa" id="valorEmpresa" ng-model="medicao.valorEmpresa" mask="real:true" ng-disabled="true" class="form-control text-right"></div></div><div ng-if="indicesReajuste.length &amp;&amp; !isLoadingReadjustmentIndices &amp;&amp; medicao.reajuste.indiceDeReajuste"><div class="col-md-2"><div class="form-group"><label for="percentual" class="control-label">% Reajuste</label><select-indice-reajuste name="percentual" id="percentual" ng-model="medicao.reajuste.indiceDeReajuste" indices-reajuste="indicesReajuste" ng-change="onCalculateReadjustmentValue(medicao.valorEmpresa, medicao.reajuste.indiceDeReajuste)" disabled="disabled"></select-indice-reajuste></div></div><div class="col-md-2"><div class="form-group"><label for="reajusteValor" class="control-label">Reajuste (R$)</label> <input name="reajusteValor" id="reajusteValor" ng-model="medicao.reajuste.valor" mask="real:true" class="form-control text-right"></div></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="observacao" class="control-label">Observa\xE7\xF5es</label> <textarea name="observacao" id="observacao" ng-model="medicao.observacao" class="form-control"></textarea></div></div></div></div><div class="row"><div ng-if="!isLoadingProducts" class="col-md"><div class="col-md-12"><div class="form-group"><label for="medicao">Produtos</label><select name="produto" id="produto" multiple="" selectpicker="" ng-model="medicao.produtos" ng-change="onCalculateTotalValueProducts()" ng-options="produto as produto.descricao for produto in produtos track by produto.id" class="form-control"><option value="">Selecione o Produto</option></select></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><p>\u2022 Observa\xE7\xE3o: O valor total da medi\xE7\xE3o \xE9 calculado automaticamente com base nos valores dos produtos selecionados.</p></div></div></div></div><div class="text-right"><button type="button" ng-click="clear()" class="btn btn-danger">{{ medicao.id ? "Voltar" : "Cancelar" }}</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/medicao/medicoes.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto=false" class="panel panel-primary bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div ng-show="centroDeCusto.id != null" class="text-left"><h3>Centro de Custo: {{(centroDeCusto.nome != null) ? centroDeCusto.nome : centroDeCusto.codigo}}</h3></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><modal-print ng-if="authService.isInRole(\'ROLE_MEDICAO_CRUDP\')" title="\'Relat\xF3rio\'" reporttitle="Relatorio de Medi\xE7\xF5es" route="medicao/?" filter="filtro"></modal-print><a ng-disabled="!authService.isInRole(\'ROLE_MEDICAO_[A-Z]*C[A-Z]*\')" ui-sref="economico.formMedicao" tooltip="" title="Editar" data-placement="top" class="btn btn-warning">Adicionar</a> <button ng-disabled="!authService.isInRole(\'ROLE_MEDICAO_[A-Z]*C[A-Z]*\')" ng-click="openAddVarios(\'app/pages/contratos/medicao/modais/form-addVariosMedicao.html\', \'lg\', \'Medi\xE7\xF5es\', med)" tooltip="" title="Novas Medi\xE7oes" ng-controller="addVariosMedicaoCtrl" class="btn btn-warning">Adicionar Varios</button></div></div><div uib-collapse="!aberto" style="margin-top:20px;margin-bottom:20px;" class="row"><form class="form"><div ng-include="\'app/pages/contratos/medicao/medicoesSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="status" style="width:100px !important;" class="text-center">Status</th><th st-sort="codigo" style="width:50px !important;">C\xF3digo</th><th st-sort="descricao">Descri\xE7\xE3o</th><th st-sort="contratoExterno.centroCusto" ng-if="centroDeCusto.id == null" style="width:50px !important;" class="text-center hide-column-5">Centro de Custo</th><th st-sort="dataCompetencia" style="width:50px !important;" class="text-center">Compet\xEAncia</th><th st-sort="data" style="width:50px !important;" class="text-center">Data do Protocolo</th><th st-sort="acumulado" style="width:140px !important;" class="text-right hide-column-6">Anterior</th><th st-sort="valorEmpresa" style="width:140px !important;" class="text-right">Valor</th><th st-sort="reajuste" style="width:140px !important;" class="text-right">Reajuste</th><th st-sort="total" style="width:140px !important;" class="text-right hide-column-6">Total</th><th st-sort="saldo" style="width:140px !important;" class="text-right hide-column-6">Saldo</th><th st-sort="fisicoRealizado" style="width:50px !important;" class="text-right hide-column-5">%</th><th st-sort="fisicoRealizadoAcumulado" style="width:50px !important;" class="text-right hide-column-5">%%</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="medicao in displayed"><td class="text-center"><button class="btn btn-xs {{medicao.color}}">{{medicao.status.descricao}}</button></td><td>{{medicao.codigo}}</td><td>{{medicao.descricao}}</td><td ng-if="centroDeCusto.id == null" class="hide-column-5">{{medicao.contratoExterno.centroCusto.nome}}</td><td class="text-center">{{medicao.dataCompetencia | date: "MM/y"}}</td><td class="text-center">{{medicao.data | date: "dd/MM/y"}}</td><td class="text-right hide-column-6">R$ {{medicao.acumulado | mask:"real"}}</td><td class="text-right">R$ {{medicao.valorEmpresa | mask:"real"}}</td><td class="text-right">R$ {{medicao.reajuste.valor | mask:"real"}}</td><td class="text-right hide-column-6">R$ {{medicao.total | mask:"real"}}</td><td class="text-right hide-column-6">R$ {{medicao.saldo | mask:"real"}}</td><td class="text-right hide-column-5">{{medicao.fisicoRealizado | number: 2}}</td><td class="text-right hide-column-5">{{medicao.fisicoRealizadoAcumulado | number : 2}}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_MEDICAO_[A-Z]*U[A-Z]*\')" ui-sref="economico.formMedicao({medicaoId: medicao.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_MEDICAO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'lg\', \'A Medi\xE7\xE3o \'+ medicao.descricao, medicao)" data-toggle="modal" data-id="{{medicao.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="100" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="100" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td><td st-pagination="" st-items-by-page="itemsByPage" colspan="8" class="text-center"></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/medicao/medicoesSearch.html','<div><div class="col-md-3"><div class="form-group"><label for="codigo" class="control-label">C\xF3digo</label> <input name="codigo" id="codigo" ng-model="filtro.codigo" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="filtro.descricao" class="form-control"></div></div><div ng-show="contratoExterno.id == null" class="col-md-4"><div class="form-group"><label for="contratoExterno">Contrato de Cliente Ativo</label><select-contrato-externo name="filtro.contratoExterno" ng-model="filtro.contratoExterno" filtro="{ statusContrato: &quot;ATIVO&quot; }"></select-contrato-externo></div></div><div class="col-md-2"><div class="form-group"><label for="inicio" class="control-label">\xCDnicio</label> <input name="inicio" type="date" id="inicio" ng-model="filtro.inicio" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="fim" class="control-label">Fim</label> <input name="fim" type="date" id="fim" ng-model="filtro.fim" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="valor" class="control-label">Valor (R$)</label> <input name="valor" id="valor" ng-model="filtro.valor" mask="real:true" class="form-control text-right"></div></div><div class="col-md-2"><div class="form-group"><label for="valorEmpresa" class="control-label">Valor da Empresa (R$)</label> <input name="valorEmpresa" id="valorEmpresa" ng-model="filtro.valorEmpresa" mask="real:true" class="form-control text-right"></div></div></div>');
$templateCache.put('app/pages/contratos/ordemdeservico/ordemdeservico.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(ordemDeServico)" name="form" method="post" class="form"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div id="preloader" ng-show="isLoading"><div></div></div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="numero" class="control-label">N\xFAmero</label> <input name="numero" id="numero" ng-model="ordemDeServico.numero" required="required" class="form-control text-center"></div></div><div class="col-md-6"><div class="form-group"><label for="data" class="control-label">Data</label> <input type="date" name="data" id="data" ng-model="ordemDeServico.data" required="required" class="form-control text-center"></div></div><div class="col-md-6"><div class="form-group"><label for="diasParalisado" class="control-label">Dias de Paralisa\xE7\xE3o</label> <input ng-disabled="ordemDeServico.statusOrdemServico.descricao != &quot;REIN\xCDCIO&quot;" type="number" name="diasParalisado" id="diasParalisado" ng-model="ordemDeServico.diasParalisado" required="required" class="form-control text-center"></div></div><div class="col-md-6"><div class="form-group"><label for="statusOrdemServico" class="control-label">Status</label><select-enum name="statusOrdemServico" id="statusOrdemServico" ng-model="ordemDeServico.statusOrdemServico" tipo="StatusOrdemServico" required="required"></select-enum></div></div><div class="col-md-12"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <textarea name="descricao" id="descricao" ng-model="ordemDeServico.descricao" style="height: 70px;" maxlength="1000" ng-maxlength="1000" class="form-control"></textarea></div></div></div></div></div><div class="panel-footer text-right"><button type="button" ng-click="clear()" class="btn btn-danger">Voltar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/contratos/ordemdeservico/ordensdeservicos.html','<div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div class="panel-body"><div ng-show="contrato.id != null" class="text-left"><h3>Contrato : {{contrato.numeroContrato}}</h3></div><div class="text-right"><button ng-click="open(\'app/pages/contratos/ordemdeservico/ordemdeservico.html\', \'md\', \'Ordem de Servi\xE7o\', ordemDeServico)" data-placement="top" tooltip="" title="Nova Ordem de Servi\xE7o" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="numero">Numero</th><th st-sort="data" class="text-center">Data</th><th style="width:115px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="ordemdeservico in displayed"><td>{{ordemdeservico.numero}}</td><td class="text-center">{{ordemdeservico.data | date:\'dd/MM/yyyy\'}}</td><td class="text-right"><button ng-click="open(\'app/pages/contratos/ordemdeservico/ordemdeservico.html\', \'md\', \'Ordem de Servi\xE7o\', ordemdeservico)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Ordem de Servi\xE7o\', ordemdeservico)" data-toggle="modal" data-id="{{ordemdeservico.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/contratos/produtos/ProdutoSearch.html','<div><div class="row"><div class="col-md"><div ng-show="centroDeCusto.id == null" class="col-md-3"><div class="form-group"><label for="numeroEdital">Centro de Custo</label><select-centro-custo name="centroDeCusto" ng-model="filtro.centroDeCusto"></select-centro-custo></div></div><div ng-show="contratoExterno.id == null" class="col-md-3"><div class="form-group"><label for="contratoExterno">Contrato de Cliente</label><select-contrato-externo name="filtro.contratoExterno" ng-model="filtro.contratoExterno"></select-contrato-externo></div></div><div class="col-md-6"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" ng-model="filtro.descricao" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="tipo">Tipo</label><select-enum name="tipo" ng-model="filtro.tipo" tipo="TipoProduto" tipo-label="Tipo"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="dataContrato">Data Contrato</label> <input mask="brDate" name="dataContrato" ng-model="filtro.dataContrato" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="dataPrevisto">Data Previsto</label> <input mask="brDate" name="dataPrevisto" ng-model="filtro.dataPrevisto" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="dataRealizado">Data Realizado</label> <input mask="brDate" name="dataRealizado" ng-model="filtro.dataRealizado" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="valor">Valor</label> <input name="valor" ng-model="filtro.valor" mask="real:true" class="form-control text-right"></div></div><div class="col-md-2"><div class="form-group"><label for="status">Status</label><select-enum name="status" ng-model="filtro.status" tipo="StatusProduto" tipo-label="Status"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="inicio">Inicio</label> <input mask="brDate" name="inicio" ng-model="filtro.inicio" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="fim">Fim</label> <input mask="brDate" name="fim" ng-model="filtro.fim" class="form-control text-center"></div></div></div></div><div class="row"><div class="form-group"><div class="col-md-2"><button ng-click="search()" class="btn btn-success">Buscar</button> <button ng-click="clear()" class="btn btn-default">Limpar</button></div></div></div></div>');
$templateCache.put('app/pages/contratos/produtos/formproduto.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Dados Gerais</h3></div><div class="panel-body"><form ng-submit="save(produto)" name="form" method="post" class="form"><div class="row"><div class="col-md"><div class="col-md-9 form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="produto.descricao" required="required" class="form-control"></div><div class="col-md-3 form-group"><label for="status" class="control-label">Status</label><select-enum name="status" id="status" ng-model="produto.status" tipo="StatusProduto" tipo-label="Status" required="required"></select-enum></div><div class="col-md-2 form-group"><label for="tipo" class="control-label">Tipo</label><select-enum name="tipo" id="tipo" ng-model="produto.tipo" tipo="TipoProduto" tipo-label="tipo" required="required"></select-enum></div><div class="col-md-4 form-group"><label for="contrato" class="control-label">Contrato de Cliente</label><select-contrato-externo name="contrato" id="contrato" ng-model="produto.contratoExterno" ng-change="onContratoChange(produto.contratoExterno)"></select-contrato-externo></div><div class="col-md-3 form-group"><label for="numeroEdital">Centro de Custo</label><select-centro-custo name="centroDeCusto" ng-model="produto.centroDeCusto" required="required"></select-centro-custo></div><div class="col-md-3 form-group"><label for="ordemDeServico">Ordem de Servi\xE7o</label><select ng-disabled="produto.contratoExterno.id == null" name="ordemDeServico" id="ordemDeServico" ng-model="produto.ordemDeServico" ng-options="ordemDeServico as ordemDeServico.numero for ordemDeServico in ordensDeServicos track by ordemDeServico.id" class="form-control"><option value="">Selecione a Ordem de Servi\xE7o</option></select></div><div class="col-md-2 form-group"><label for="dataContrato" class="control-label">Data Oficial do Contrato</label> <input type="date" name="dataContrato" id="dataContrato" ng-model="produto.dataContrato" required="required" class="form-control text-center"></div><div class="col-md-2 form-group"><label for="isPagamentoParcelado" class="control-label">Pagamento Parcelado</label><select ng-disabled="!produto.tipo || isProductTypeHH()" name="isPagamentoParcelado" id="isPagamentoParcelado" ng-model="produto.isPagamentoParcelado" required="required" class="form-control"><option value="" disabled="disabled">Selecione a Op\xE7\xE3o</option><option ng-value="true">Sim</option><option ng-value="false">N\xE3o</option></select></div></div></div><h3 style="margin-top:30px;">Previs\xE3o do Servi\xE7o</h3><h5>Informe os valores e datas previstas para a execu\xE7\xE3o do servi\xE7o. Essas informa\xE7\xF5es ajudar\xE3o a planejar e acompanhar o andamento do produto com mais precis\xE3o.<hr></h5><div class="row"><div class="col-md"><div class="col-md-2 form-group"><label for="dataPrevisto" class="control-label">Data Prevista do Gestor</label> <input type="date" name="dataPrevisto" id="dataPrevisto" ng-model="produto.dataPrevisto" required="required" class="form-control text-center"></div><div ng-if="!isProductInInstallments()" class="col-md-3 form-group"><label for="dataCompetencia" class="control-label">Compet\xEAncia Prevista da Entrega/Aprova\xE7\xE3o</label> <input type="month" name="dataCompetencia" id="dataCompetencia" ng-model="produto.dataCompetencia" ng-change="onCompetenciaChange(produto.dataCompetencia)" required="required" class="form-control text-center"></div><div ng-if="isProductInInstallments()"><div class="col-md-2 form-group"><label for="dataCompetencia" class="control-label">Compet\xEAncia Prevista da Entrega</label> <input type="month" name="dataCompetencia" id="dataCompetencia" ng-model="produto.dataCompetencia" ng-change="onCompetenciaChange(produto.dataCompetencia)" required="required" class="form-control text-center"></div><div class="col-md-2 form-group"><label for="competenciaPrevistaAprovacao" class="control-label">Compet\xEAncia Prevista da Aprova\xE7\xE3o</label> <input type="month" name="competenciaPrevistaAprovacao" id="competenciaPrevistaAprovacao" ng-model="produto.competenciaPrevistaAprovacao" required="required" class="form-control text-center"></div></div><div ng-if="produto.tipo.name == \'PRODUTO\'" class="col-md-3 form-group"><label for="inicio" class="control-label">Inicio da Entrega</label> <input type="date" name="inicio" id="inicio" ng-model="produto.inicio" required="required" class="form-control text-center"></div><div ng-if="produto.tipo.name == \'PRODUTO\'" class="col-md-3 form-group"><label for="fim" class="control-label">Fim da Entrega</label> <input type="date" name="fim" id="fim" ng-model="produto.fim" required="required" class="form-control text-center"></div></div></div><div class="row"><div class="col-md"><div class="col-md-3 form-group"><label for="valor" class="control-label">Valor Previsto Total (R$)</label> <input name="valor" id="valor" ng-model="produto.valor" mask="real" required="required" class="form-control text-right"></div><div class="col-md-3 form-group"><label for="valorEmpresa" class="control-label">Valor Previsto da Empresa (R$)</label> <input name="valorEmpresa" id="valorEmpresa" ng-model="produto.valorEmpresa" mask="real" ng-disabled="true" required="required" class="form-control text-right"></div><div ng-if="indicesReajuste.length &amp;&amp; !isLoadingReadjustmentIndices &amp;&amp; produto.reajuste.indiceDeReajuste"><div class="col-md-3 form-group"><label for="percentual" class="control-label">% Reajuste</label><select-indice-reajuste name="percentual" id="percentual" ng-model="produto.reajuste.indiceDeReajuste" indices-reajuste="indicesReajuste" ng-change="onCalculateReadjustmentValue(produto.valorEmpresa, produto.reajuste.indiceDeReajuste)" disabled="disabled"></select-indice-reajuste></div><div class="col-md-3 form-group"><label for="reajusteValor" class="control-label">Reajuste Empresa (R$)</label> <input name="reajusteValor" id="reajusteValor" ng-model="produto.reajuste.valor" mask="real" class="form-control text-right"></div></div><div ng-if="!isProductInInstallments()" class="col-md-3 form-group"><label for="porcentagemPrevistaEntrega">Porcentagem Prevista da Entrega/Aprovado</label> <input name="porcentagemPrevistaEntrega" id="porcentagemPrevistaEntrega" type="text" ng-model="produto.porcentagemPrevistaEntrega" mask="real:false:2:0:100" ng-disabled="true" required="required" class="form-control text-right"></div><div ng-if="isProductInInstallments()"><div class="col-md-2 form-group"><label for="porcentagemPrevistaEntrega">Porcentagem Prevista da Entrega</label> <input name="porcentagemPrevistaEntrega" id="porcentagemPrevistaEntrega" type="text" ng-model="produto.porcentagemPrevistaEntrega" mask="real:false:2:0:100" required="required" class="form-control text-right"></div><div class="col-md-2 form-group"><label for="porcentagemPrevistaAprovacao">Porcentagem Prevista da Aprova\xE7\xE3o</label> <input name="porcentagemPrevistaAprovacao" id="porcentagemPrevistaAprovacao" type="text" ng-model="produto.porcentagemPrevistaAprovacao" mask="real:false:2:0:100" required="required" class="form-control text-right"></div></div></div></div><h3 style="margin-top:30px;">Realizado</h3><h5>Registre informa\xE7\xF5es relacionadas ao status do produto. Os campos marcados como "Aprovado" podem ser preenchidos apenas quando o status do produto estiver definido como "Aprovado". Da mesma forma, os campos marcados como "Entregue" devem ser preenchidos apenas quando o status do produto for "Entregue".<hr></h5><div class="row"><div class="col-md"><div class="col-md-3 form-group"><label for="valorRealizadoTotal" class="control-label">Valor Realizado Total (R$)</label> <input name="valorRealizadoTotal" id="valorRealizadoTotal" ng-model="produto.valorRealizadoTotal" mask="real" ng-disabled="!isProductEntregue() &amp;&amp; !isProductAprovado()" required="required" class="form-control text-right"></div><div class="col-md-3 form-group"><label for="valorRealizado" class="control-label">Valor Realizado da Empresa (R$)</label> <input name="valorRealizado" id="valorRealizado" ng-model="produto.valorRealizado" mask="real" ng-disabled="true" required="required" class="form-control text-right"></div><div class="col-md-3 form-group"><label for="dataRealizado" class="control-label">Data Realizada da Entrega</label> <input type="date" name="dataRealizado" id="dataRealizado" ng-model="produto.dataRealizado" ng-disabled="!isProductEntregue() &amp;&amp; !isProductAprovado()" required="required" class="form-control text-center"></div><div ng-if="!isProductInInstallments()"><div class="col-md-3 form-group"><label for="competenciaRealizadaEntrega" class="control-label">Compet\xEAncia Realizada da Entrega/Aprova\xE7\xE3o</label> <input type="month" name="competenciaRealizadaEntrega" id="competenciaRealizadaEntrega" ng-model="produto.competenciaRealizadaEntrega" ng-disabled="!isProductEntregue() &amp;&amp; !isProductAprovado()" required="required" class="form-control text-center"></div><div class="col-md-3 form-group"><label for="porcentagemRealizadaEntrega">Porcentagem Realizada da Entrega/Aprova\xE7\xE3o</label> <input name="porcentagemRealizadaEntrega" id="porcentagemRealizadaEntrega" type="text" ng-model="produto.porcentagemRealizadaEntrega" mask="real:false:2:0:100" ng-disabled="true" required="required" class="form-control text-right"></div></div></div></div><div ng-if="isProductInInstallments()"><h5 style="margin-top:10px;">ENTREGUE</h5><div class="row"><div class="col-md"><div class="col-md-2 form-group"><label for="competenciaRealizadaEntrega" class="control-label">Compet\xEAncia Realizada da Entrega</label> <input type="month" name="competenciaRealizadaEntrega" id="competenciaRealizadaEntrega" ng-model="produto.competenciaRealizadaEntrega" ng-disabled="!isProductEntregue()" required="required" class="form-control text-center"></div><div class="col-md-2 form-group"><label for="porcentagemRealizadaEntrega">Porcentagem Realizada da Entrega</label> <input name="porcentagemRealizadaEntrega" id="porcentagemRealizadaEntrega" type="text" ng-model="produto.porcentagemRealizadaEntrega" mask="real:false:2:0:100" ng-disabled="!isProductEntregue()" required="required" class="form-control text-right"></div></div></div><h5 style="margin-top:10px;">APROVADO</h5><div class="row"><div class="col-md"><div class="col-md-2 form-group"><label for="competenciaRealizadaAprovacao" class="control-label">Compet\xEAncia Realizada da Aprova\xE7\xE3o</label> <input type="month" name="competenciaRealizadaAprovacao" id="competenciaRealizadaAprovacao" ng-model="produto.competenciaRealizadaAprovacao" ng-disabled="!isProductAprovado()" required="required" class="form-control text-center"></div><div class="col-md-2 form-group"><label for="porcentagemRealizadaAprovacao">Porcentagem Realizada da Aprova\xE7\xE3o</label> <input name="porcentagemRealizadaAprovacao" id="porcentagemRealizadaAprovacao" type="text" ng-model="produto.porcentagemRealizadaAprovacao" mask="real:false:2:0:100" ng-disabled="!isProductAprovado()" required="required" class="form-control text-right"></div></div></div></div><div class="row col-md"><div class="col-md-12 form-group"><label for="observacao" class="control-label">An\xE1lise Critica</label> <textarea style="height:300px;" name="observacao" id="observacao" ng-model="produto.observacao" class="form-control col-xs-12"></textarea></div></div><hr><div class="text-right form-group"><button type="button" ng-click="back()" class="btn btn-danger">{{ produto.id ? "Voltar" : "Cancelar" }}</button> <button type="submit" class="btn btn-success">Salvar</button></div></form><div ng-if="produto.id" ng-include="\'app/pages/contratos/produtos/analise-contratual/analiseContratual.html\'" ng-controller="AnaliseContratualCtrl"></div><div ng-if="produto.id" ng-include="\'app/pages/contratos/produtos/analise-operacional/analiseOperacional.html\'" ng-controller="AnaliseOperacionalCtrl"></div></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/produtos/produtos.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div ng-show="centroDeCusto.id != null" class="text-left"><h3>Centro de Custo: {{(centroDeCusto.nome != null) ? centroDeCusto.nome : centroDeCusto.codigo}}</h3></div><div ng-show="contratoExterno.id != null" class="text-left"><h3>Contrato de Cliente: {{contratoExterno.numeroContrato}}</h3></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="filtro.openAdvancedSearch" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="filtro.openAdvancedSearch = !filtro.openAdvancedSearch" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><modal-print ng-if="authService.isInRole(\'ROLE_PRODUTO_CRUDP\') &amp;&amp; !!filtro.contratoExterno" title="\'Relat\xF3rio\'" reporttitle="Relatorio de Produtos" route="produto/?" filter="filtro" style="margin-right: 3px"></modal-print><a ng-disabled="!authService.isInRole(\'ROLE_PRODUTO_[A-Z]*C[A-Z]*\')" ui-sref="economico.produto({centroDeCustoId : centroDeCusto.id, contratoExternoId:contratoExterno.id})" tooltip="" title="Novo Produto" class="btn btn-warning">Adicionar</a> <button ng-disabled="!authService.isInRole(\'ROLE_PRODUTO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/contratos/produtos/modais/form-produtos.html\', \'lg\', \'Produtos\', prod)" tooltip="" title="Novos Produtos" class="btn btn-warning">Adicionar Varios</button></div></div><div uib-collapse="!filtro.openAdvancedSearch" style="margin-top:20px;margin-bottom:20px;" class="row"><form class="form"><div ng-include="\'app/pages/contratos/produtos/produtosSearch.html\'"></div><div class="col-md-12 text-right"><button type="submit" ng-click="search()" class="btn btn-success">Buscar</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="status" style="width:100px !important;" class="text-center">Status</th><th st-sort="tipo" style="width:50px !important;" class="text-center">Tipo</th><th st-sort="descricao">Descri\xE7\xE3o</th><th ng-if="centroDeCusto.id == null" st-sort="centroDeCusto" style="width:50px !important;" class="text-center hide-column-5">Centro de Custo</th><th st-sort="dataCompetencia" style="width:50px !important;" class="text-center">Comp. Prev. da Entrega</th><th st-sort="competenciaPrevistaAprovacao" style="width:50px !important;" class="text-center">Comp. Prev. da Aprova\xE7\xE3o</th><th st-sort="dataContrato" style="width:50px !important;" class="text-center hide-column-5">Data Oficial</th><th st-sort="dataPrevisto" style="width:50px !important;" class="text-center hide-column-6">Data Prevista</th><th st-sort="dataRealizado" style="width:50px !important;" class="text-center hide-column-6">Data Realizada</th><th st-sort="acumulado" style="width:140px !important;" class="text-right hide-column-6">Anterior (R$)</th><th st-sort="valor" style="width:140px !important;" class="text-right">Valor Previsto (R$)</th><th st-sort="valorRealizado" style="width:140px !important;" class="text-right">Valor Realizado (R$)</th><th st-sort="reajuste.valor" style="width:140px !important;" class="text-right">Reajuste (R$)</th><th st-sort="total" style="width:140px !important;" class="text-right hide-column-6">Total (R$)</th><th st-sort="saldo" style="width:140px !important;" class="text-right hide-column-6">Saldo (R$)</th><th st-sort="fisicoPrevisto" style="width:50px !important;" class="text-right hide-column-5">%</th><th st-sort="fisicoPrevistoAcumulado" style="width:50px !important;" class="text-right hide-column-5">%%</th><th style="width:150px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="produto in displayed"><td class="text-center"><button class="btn btn-xs {{produto.color}}">{{produto.status.descricao}}</button></td><td class="text-center">{{produto.tipo.descricao}}</td><td tooltip="" title="{{produto.descricao}}">{{produto.descricao}}</td><td ng-if="centroDeCusto.id == null" class="hide-column-5">{{produto.centroDeCusto.nome}}</td><td class="text-center">{{produto.dataCompetencia | date:\'MM/y\'}}</td><td class="text-center">{{produto.competenciaPrevistaAprovacao | date:\'MM/y\'}}</td><td class="text-center hide-column-5">{{produto.dataContrato | date:\'dd/MM/y\'}}</td><td class="text-center hide-column-6">{{produto.dataPrevisto | date:\'dd/MM/y\'}}</td><td class="text-center hide-column-6">{{produto.dataRealizado | date:\'dd/MM/y\'}}</td><td class="text-right hide-column-6">R$ {{produto.acumulado | mask:"real"}}</td><td class="text-right">R$ {{produto.valorEmpresa | mask:"real"}}</td><td class="text-right">R$ {{produto.valorRealizado | mask:"real"}}</td><td class="text-right">R$ {{produto.reajuste.valor | mask:"real"}}</td><td class="text-right hide-column-6">R$ {{produto.total | mask:"real"}}</td><td class="text-right hide-column-6">R$ {{produto.saldo | mask:"real"}}</td><td class="text-right hide-column-5">{{produto.fisicoPrevisto | number: 2}}</td><td class="text-right hide-column-5">{{produto.fisicoPrevistoAcumulado | number : 2}}</td><td class="text-center"><div uib-dropdown="" dropdown-append-to-body="" class="btn-group"><a ng-disabled="!authService.isInRole(\'ROLE_PRODUTO_[A-Z]*U[A-Z]*\')" ng-click="copiarProduto(produto)" tooltip="" title="Duplicar" class="btn btn-link"><span class="glyphicon glyphicon-duplicate"></span></a><a ng-disabled="!authService.isInRole(\'ROLE_PRODUTO_[A-Z]*U[A-Z]*\')" ui-sref="economico.produto({contratoExternoId: produto.contratoExterno.id, centroDeCustoId : produto.centroDeCusto.id, produtoId : produto.id})" tooltip="" title="Editar" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_PRODUTO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'lg\', \'O produto \'+produto.descricao, produto)" data-toggle="modal" data-id="{{fonte.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></div></td></tr></tbody><tbody ng-if="isLoading"><tr><td colspan="100" class="text-center">Loading ...</td></tr></tbody><tbody ng-if="displayed.length==0"><tr><td colspan="100" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td><td></td><td st-pagination="" st-items-by-page="itemsByPage" class="text-center"></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/produtos/produtosSearch.html','<div><div class="col-md-12"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" ng-model="filtro.descricao" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="contratoExterno" class="control-label">Contrato de Cliente</label><select-contrato-externo name="contratoExterno" id="contratoExterno" ng-model="filtro.contratoExterno" ng-change="onContratoChange(filtro.contratoExterno)"></select-contrato-externo></div></div><div class="col-md-4"><div class="form-group"><label for="ordemDeServico">Ordem de Servi\xE7o</label><select ng-disabled="filtro.contratoExterno.id == null" name="ordemDeServico" id="ordemDeServico" ng-model="filtro.ordemDeServico" ng-options="ordemDeServico as ordemDeServico.numero for ordemDeServico in ordensDeServicos track by ordemDeServico.id" class="form-control"><option value="">Selecione a Ordem de Servi\xE7o</option></select></div></div><div class="col-md-3"><div class="form-group"><label for="tipo">Tipo</label><select-enum name="tipo" ng-model="filtro.tipo" tipo="TipoProduto" tipo-label="Tipo"></select-enum></div></div><div class="col-md-3"><div class="form-group"><label for="status">Status</label><select-enum name="status" ng-model="filtro.status" tipo="StatusProduto" tipo-label="Status"></select-enum></div></div><div class="col-md-3 form-group"><label for="dataCompetencia" class="control-label">Compet\xEAncia</label> <input type="month" name="dataCompetencia" id="dataCompetencia" ng-model="filtro.dataCompetencia" class="form-control text-center"></div><div class="col-md-3 form-group"><label for="dataCompetenciaInicial" class="control-label">Compet\xEAncia Prevista (In\xEDcio)</label> <input type="month" name="dataCompetencia" id="dataCompetenciaInicial" ng-model="filtro.dataCompetenciaInicial" class="form-control text-center"></div><div class="col-md-3 form-group"><label for="dataCompetenciaFinal" class="control-label">Compet\xEAncia Prevista (Fim)</label> <input type="month" name="dataCompetencia" id="dataCompetenciaFinal" ng-model="filtro.dataCompetenciaFinal" class="form-control text-center"></div><div class="col-md-3 form-group"><label for="dataInicioRealizado" class="control-label">Data de In\xEDcio Realizado</label> <input name="dataInicioRealizado" type="date" id="dataInicioRealizado" ng-model="filtro.dataInicioRealizado" class="form-control text-center"></div><div class="col-md-3 form-group"><label for="dataFimRealizado" class="control-label">Data de Fim Realizado</label> <input name="dataFimRealizado" type="date" id="dataFimRealizado" ng-model="filtro.dataFimRealizado" class="form-control text-center"></div></div>');
$templateCache.put('app/pages/contratos/revisaocontrato/produtos.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto=false" class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div ng-show="centroDeCusto.id != null" class="text-left"><h3>Centro de Custo: {{(centroDeCusto.nome != null) ? centroDeCusto.nome : centroDeCusto.codigo}}</h3></div><div ng-show="contratoExterno.id != null" class="text-left"><h3>Contrato de Cliente: {{contratoExterno.numeroContrato}}</h3></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><modal-print ng-if="authService.isInRole(\'ROLE_PRODUTO_CRUDP\')" title="\'Relat\xF3rio\'" reporttitle="Relatorio de Produtos" route="produto/?" filter="filtro"></modal-print><a ng-disabled="!authService.isInRole(\'ROLE_PRODUTO_[A-Z]*C[A-Z]*\')" ui-sref="economico.produto({centroDeCustoId : centroDeCusto.id, contratoExternoId:contratoExterno.id})" tooltip="" title="Novo Produto" class="btn btn-warning">Adicionar</a> <button ng-disabled="!authService.isInRole(\'ROLE_PRODUTO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/contratos/produtos/modais/form-produtos.html\', \'lg\', \'Produtos\', prod)" tooltip="" title="Novos Produtos" class="btn btn-warning">Adicionar Varios</button></div></div><div uib-collapse="!aberto" style="margin-top:20px;margin-bottom:20px;" class="row"><form class="form"><div ng-include="\'app/pages/contratos/produtos/produtosSearch.html\'"></div><div class="col-md-12 text-right"><button type="submit" ng-click="search()" class="btn btn-success">Buscar</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="status" style="width:100px !important;" class="text-center">Status</th><th st-sort="tipo" style="width:50px !important;" class="text-center">Tipo</th><th st-sort="descricao">Descri\xE7\xE3o</th><th ng-if="centroDeCusto.id == null" st-sort="centroDeCusto" style="width:50px !important;" class="text-center hide-column-5">Centro de Custo</th><th st-sort="dataCompetencia" style="width:50px !important;" class="text-center">Data da Competencia</th><th st-sort="dataContrato" style="width:50px !important;" class="text-center hide-column-5">Data do Contrato</th><th st-sort="dataPrevisto" style="width:50px !important;" class="text-center hide-column-6">Data Prevista</th><th st-sort="dataRealizado" style="width:50px !important;" class="text-center hide-column-6">Data Realizada</th><th st-sort="acumulado" style="width:140px !important;" class="text-right hide-column-6">Anterior</th><th st-sort="valor" style="width:140px !important;" class="text-right">Valor (R$)</th><th st-sort="reajuste.valor" style="width:140px !important;" class="text-right">Reajuste (R$)</th><th st-sort="total" style="width:140px !important;" class="text-right hide-column-6">Total</th><th st-sort="saldo" style="width:140px !important;" class="text-right hide-column-6">Saldo</th><th st-sort="fisicoPrevisto" style="width:50px !important;" class="text-right hide-column-5">%</th><th st-sort="fisicoPrevistoAcumulado" style="width:50px !important;" class="text-right hide-column-5">%%</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="produto in displayed"><td class="text-center"><button class="btn btn-xs {{produto.color}}">{{produto.status.descricao}}</button></td><td class="text-center">{{produto.tipo.descricao}}</td><td tooltip="" title="{{produto.descricao}}">{{produto.descricao}}</td><td ng-if="centroDeCusto.id == null" class="hide-column-5">{{produto.centroDeCusto.nome}}</td><td class="text-center">{{produto.dataCompetencia | date:\'dd/MM/y\'}}</td><td class="text-center hide-column-5">{{produto.dataContrato | date:\'dd/MM/y\'}}</td><td class="text-center hide-column-6">{{produto.dataPrevisto | date:\'dd/MM/y\'}}</td><td class="text-center hide-column-6">{{produto.dataRealizado | date:\'dd/MM/y\'}}</td><td class="text-right hide-column-6">R$ {{produto.acumulado | mask:"real"}}</td><td class="text-right">R$ {{produto.valorEmpresa | mask:"real"}}</td><td class="text-right">R$ {{produto.reajuste.valor | mask:"real"}}</td><td class="text-right hide-column-6">R$ {{produto.total | mask:"real"}}</td><td class="text-right hide-column-6">R$ {{produto.saldo | mask:"real"}}</td><td class="text-right hide-column-5">{{produto.fisicoPrevisto | number: 2}}</td><td class="text-right hide-column-5">{{produto.fisicoPrevistoAcumulado | number : 2}}</td><td class="text-center"><div uib-dropdown="" dropdown-append-to-body="" class="btn-group"><a ng-disabled="!authService.isInRole(\'ROLE_PRODUTO_[A-Z]*U[A-Z]*\')" ui-sref="economico.produto({contratoExternoId: produto.contratoExterno.id, centroDeCustoId : produto.centroDeCusto.id, produtoId : produto.id})" tooltip="" title="Editar" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_PRODUTO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'lg\', \'O produto \'+produto.descricao, produto)" data-toggle="modal" data-id="{{fonte.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></div></td></tr></tbody><tbody ng-if="isLoading"><tr><td colspan="100" class="text-center">Loading ...</td></tr></tbody><tbody ng-if="displayed.length==0"><tr><td colspan="100" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td><td></td><td st-pagination="" st-items-by-page="itemsByPage" class="text-center"></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/revisaocontrato/produtosSearch.html','<div><div class="col-md-12"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" ng-model="filtro.descricao" class="form-control"></div></div><div ng-show="centroDeCusto.id == null" class="col-md-6"><div class="form-group"><label for="centroDeCusto">Centro de Custo</label><select-centro-custo name="centroDeCusto" ng-model="filtro.centroDeCusto"></select-centro-custo></div></div><div ng-show="contratoExterno.id == null" class="col-md-6"><div class="form-group"><label for="contratoExterno">Contrato de Cliente</label><select-contrato-externo id="contrato" name="contrato" ng-model="filtro.contratoExterno"></select-contrato-externo></div></div><div class="col-md-3"><div class="form-group"><label for="tipo">Tipo</label><select-enum name="tipo" ng-model="filtro.tipo" tipo="TipoProduto" tipo-label="Tipo"></select-enum></div></div><div class="col-md-3"><div class="form-group"><label for="status">Status</label><select-enum name="status" ng-model="filtro.status" tipo="StatusProduto" tipo-label="Status"></select-enum></div></div><div class="col-md-3 form-group"><label for="inicio" class="control-label">\xCDnicio</label> <input name="inicio" type="date" id="inicio" ng-model="filtro.inicio" class="form-control text-center"></div><div class="col-md-3 form-group"><label for="fim" class="control-label">Fim</label> <input name="fim" type="date" id="fim" ng-model="filtro.fim" class="form-control text-center"></div></div>');
$templateCache.put('app/pages/contratos/revisaocontrato/revisaoContratoSearch.html','<div><div ng-show="centroDeCusto.id == null" class="col-md-6"><div class="form-group"><label for="centroDeCusto">Centro de Custo Ativo</label><select-centro-custo name="centroDeCusto" ng-model="filtro.centroDeCusto" resource="&quot;findAllByContractStatus&quot;" filter="{statusContrato:&quot;ATIVO&quot;}"></select-centro-custo></div></div><div ng-show="contratoExterno.id == null" class="col-md-6"><div class="form-group"><label for="contratoExterno">Contrato de Cliente</label><select-contrato-externo id="contrato" name="contrato" ng-model="filtro.contratoExterno"></select-contrato-externo></div></div><div class="col-md-3 form-group"><label for="inicio" class="control-label">\xCDnicio</label> <input name="inicio" type="date" id="inicio" ng-model="filtro.inicio" class="form-control text-center"></div><div class="col-md-3 form-group"><label for="fim" class="control-label">Fim</label> <input name="fim" type="date" id="fim" ng-model="filtro.fim" class="form-control text-center"></div></div>');
$templateCache.put('app/pages/contratos/revisaocontrato/revisaocontrato.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(revisaoContrato)" name="form" method="post" class="form"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div id="preloader" ng-show="isLoading"><div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="codigo" class="control-label">C\xF3digo</label> <input name="codigo" id="codigo" ng-model="revisaoContrato.codigo" required="required" class="form-control text-center"></div></div><div class="col-md-8"><div class="form-group"><label for="numero" class="control-label">N\xFAmero</label> <input name="numero" id="numero" ng-model="revisaoContrato.numero" required="required" class="form-control text-center"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="data" class="control-label">Data</label> <input type="date" name="data" id="data" ng-model="revisaoContrato.data" required="required" class="form-control text-center"></div></div><div class="col-md-8"><div class="form-group"><label for="tipoRevisao" class="control-label">Tipo de Revis\xE3o</label><select-enum name="tipoRevisao" id="tipoRevisao" ng-model="revisaoContrato.tipoRevisao" tipo="TipoRevisao" tipo-label="Tipo De Revis\xE3o" required="required" ng-click="clearTipoRevisao()"></select-enum></div></div></div></div><div class="row"><div class="col-md"><div ng-if="revisaoContrato.tipoRevisao.name == \'PRAZO\' || revisaoContrato.tipoRevisao.name == \'PRAZO_VALOR\'" class="col-md-3"><div class="form-group"><label for="prazo" class="control-label">Prazo</label> <input name="prazo" id="prazo" ng-model="revisaoContrato.prazo" class="form-control text-center"></div></div><div ng-if="revisaoContrato.tipoRevisao.name == \'PRAZO\' || revisaoContrato.tipoRevisao.name == \'PRAZO_VALOR\'" class="col-md-3"><div class="form-group"><label for="vigencia" class="control-label">Vig\xEAncia</label> <input name="vigencia" id="vigencia" ng-model="revisaoContrato.vigencia" class="form-control text-center"></div></div><div ng-if="revisaoContrato.tipoRevisao.name == \'PRAZO\' || revisaoContrato.tipoRevisao.name == \'PRAZO_VALOR\'" class="col-md-6"><div class="form-group"><label for="tipoPrazo" class="control-label">Tipo de Prazo</label><select-enum name="tipoPrazo" id="tipoPrazo" ng-model="revisaoContrato.tipoPrazo" tipo="TipoPrazo" tipo-label="Tipo De Prazo" required="required"></select-enum></div></div></div></div><div ng-if="revisaoContrato.tipoRevisao.name == \'VALOR\' || revisaoContrato.tipoRevisao.name == \'PRAZO_VALOR\' || revisaoContrato.tipoRevisao.name == \'APOSTILAMENTO\'" class="row"><div class="col-md-4 offset-md-6"><div class="form-group"><label for="valorTotal" class="control-label">Valor Total (R$)</label> <input name="valor" id="valor" ng-model="revisaoContrato.valorTotal" mask="real" class="form-control text-right"></div></div><div class="col-md-4 offset-md-6"><div class="form-group"><label for="valor" class="control-label">Valor Empresa (R$)</label> <input name="valor" id="valor" ng-model="revisaoContrato.valor" mask="real" class="form-control text-right"></div></div></div></div><div class="panel-footer text-right"><button type="button" ng-click="clear()" class="btn btn-danger">Voltar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/contratos/revisaocontrato/revisoescontrato.html','<div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div class="panel-body"><div ng-show="contrato.id != null" class="text-left"><h3>Contrato : {{contrato.numeroContrato}}</h3></div><div class="text-right"><button ng-click="open(\'app/pages/contratos/revisaocontrato/revisaocontrato.html\', \'md\', \'Revis\xE3o de Contrato\', revisaoContrato)" data-placement="top" tooltip="" title="Nova Revis\xE3o de Contrato" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="codigo">C\xF3digo</th><th st-sort="tipoRevisao">Tipo de Revis\xE3o</th><th st-sort="data" class="text-center">Data</th><th st-sort="prazo" class="text-center">Prazo</th><th st-sort="tipoPrazo" class="text-center">Tipo</th><th st-sort="valorTotal" class="text-right">Valor Empresa (R$)</th><th class="text-right">Valor Total (R$)</th><th style="width:115px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="revisaocontrato in displayed"><td>{{revisaocontrato.codigo}}</td><td>{{revisaocontrato.tipoRevisao.descricao}}</td><td class="text-center">{{revisaocontrato.data | date:\'dd/MM/y\'}}</td><td class="text-center">{{revisaocontrato.prazo}}</td><td class="text-center">{{revisaocontrato.tipoPrazo.descricao}}</td><td class="text-right">{{revisaocontrato.valor | mask:"real"}}</td><td class="text-right">{{revisaocontrato.valorTotal | mask:"real"}}</td><td class="text-right"><button ng-click="open(\'app/pages/contratos/revisaocontrato/revisaocontrato.html\', \'md\', \'Revis\xE3o de Contrato\', revisaocontrato)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Revis\xE3o de contrato \', revisaocontrato)" data-toggle="modal" data-id="{{revisaocontrato.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="8" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="8" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="7" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/contratos/revisaocontrato/revisoescontratos.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto=false" class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div ng-show="centroCusto.id != null" class="text-left"><h3>Centro de Custo: {{(centroCusto.nome != null) ? centroCusto.nome : centroCusto.codigo}}</h3></div><div ng-show="contratoExterno.id != null" class="text-left"><h3>Contrato de Cliente: {{contratoExterno.numeroContrato}}</h3></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar.." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><modal-print title="\'Relat\xF3rio\'" reporttitle="Relatorio de Revis\xE3o de Contrato" route="revisao-contrato-externo/?" filter="filtro"></modal-print></div></div><div uib-collapse="!aberto" style="margin-top:20px;margin-bottom:20px;" class="row"><form class="form"><div ng-include="\'app/pages/contratos/revisaocontrato/revisaoContratoSearch.html\'"></div><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="contratoExterno.statusContrato" class="text-center">Status</th><th st-sort="contratoExterno.numeroContrato">N\xFAmero</th><th st-sort="contratoExterno.centroCusto.nome">Centro de Custo</th><th st-sort="codigo">C\xF3digo</th><th st-sort="tipoRevisao">Tipo de Revis\xE3o</th><th st-sort="data" class="text-center">Data</th><th st-sort="prazo" class="text-center">Prazo</th><th st-sort="tipoPrazo" class="text-center">Tipo</th><th st-sort="valorTotal" class="text-right">Valor (R$)</th><th class="text-right">Valor Total (R$)</th><th style="width:115px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="revisaocontrato in displayed"><td tooltip="" title="{{revisaocontrato.contratoExterno.statusContrato.descricao}}" class="text-center"><button ng-class="{\'btn-success\': revisaocontrato.contratoExterno.isAtivo , \'btn-warning\': revisaocontrato.contratoExterno.isPossivelEncerramento, \'btn-danger\': revisaocontrato.contratoExterno.isSemSaldoAMedir, \'btn-info\': revisaocontrato.contratoExterno.isEncerrado }" class="btn btn-xs btn-icon"><i class="{{revisaocontrato.contratoExterno.statusContrato.icon}}"></i></button></td><td>{{revisaocontrato.contratoExterno.numeroContrato}}</td><td>{{revisaocontrato.contratoExterno.centroCusto.nome}}</td><td>{{revisaocontrato.codigo}}</td><td>{{revisaocontrato.tipoRevisao.descricao}}</td><td class="text-center">{{revisaocontrato.data | date:\'dd/MM/y\'}}</td><td class="text-center">{{revisaocontrato.prazo}}</td><td class="text-center">{{revisaocontrato.tipoPrazo.descricao}}</td><td class="text-right">{{revisaocontrato.valor | mask:"real"}}</td><td class="text-right">{{revisaocontrato.valorTotal | mask:"real"}}</td><td class="text-right"><button ng-click="open(\'app/pages/contratos/revisaocontrato/revisaocontrato.html\', \'md\', \'Revis\xE3o de Contrato\', revisaocontrato)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Revis\xE3o de Contrato \', revisaocontrato)" data-toggle="modal" data-id="{{revisaocontrato.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="11" class="text-center">Loading ..</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="11" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="10" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/revisaocontratointerno/revisaocontrato.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(revisaoContrato)" name="form" method="post" class="form"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div id="preloader" ng-show="isLoading"><div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="codigo" class="control-label">C\xF3digo</label> <input name="codigo" id="codigo" ng-model="revisaoContrato.codigo" required="required" class="form-control text-center"></div></div><div class="col-md-8"><div class="form-group"><label for="numero" class="control-label">N\xFAmero</label> <input name="numero" id="numero" ng-model="revisaoContrato.numero" required="required" class="form-control text-center"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="data" class="control-label">Data</label> <input type="date" name="data" id="data" ng-model="revisaoContrato.data" required="required" class="form-control text-center"></div></div><div class="col-md-8"><div class="form-group"><label for="tipoRevisao" class="control-label">Tipo de Revis\xE3o</label><select-enum name="tipoRevisao" id="tipoRevisao" ng-model="revisaoContrato.tipoRevisao" tipo="TipoRevisao" tipo-label="Tipo De Revis\xE3o" required="required" ng-click="clear()"></select-enum></div></div></div></div><div class="row"><div class="col-md"><div ng-if="revisaoContrato.tipoRevisao.name == \'PRAZO\' || revisaoContrato.tipoRevisao.name == \'PRAZO_VALOR\'" class="col-md-3"><div class="form-group"><label for="prazo" class="control-label">Prazo</label> <input name="prazo" id="prazo" ng-model="revisaoContrato.prazo" class="form-control text-center"></div></div><div ng-if="revisaoContrato.tipoRevisao.name == \'PRAZO\' || revisaoContrato.tipoRevisao.name == \'PRAZO_VALOR\'" class="col-md-3"><div class="form-group"><label for="vigencia" class="control-label">Vig\xEAncia</label> <input name="vigencia" id="vigencia" ng-model="revisaoContrato.vigencia" class="form-control text-center"></div></div><div ng-if="revisaoContrato.tipoRevisao.name == \'PRAZO\' || revisaoContrato.tipoRevisao.name == \'PRAZO_VALOR\'" class="col-md-6"><div class="form-group"><label for="tipoPrazo" class="control-label">Tipo de Prazo</label><select-enum name="tipoPrazo" id="tipoPrazo" ng-model="revisaoContrato.tipoPrazo" tipo="TipoPrazo" tipo-label="Tipo De Prazo" required="required"></select-enum></div></div></div></div><div ng-if="revisaoContrato.tipoRevisao.name == \'VALOR\' || revisaoContrato.tipoRevisao.name == \'PRAZO_VALOR\' || revisaoContrato.tipoRevisao.name == \'APOSTILAMENTO\'" class="row"><div class="col-md-4 offset-md-6"><div class="form-group"><label for="valorTotal" class="control-label">Valor Total (R$)</label> <input name="valor" id="valor" ng-model="revisaoContrato.valorTotal" mask="real" class="form-control text-right"></div></div><div class="col-md-4 offset-md-6"><div class="form-group"><label for="valor" class="control-label">Valor (R$)</label> <input name="valor" id="valor" ng-model="revisaoContrato.valor" mask="real" class="form-control text-right"></div></div></div></div><div class="panel-footer text-right"><button type="button" ng-click="clear()" class="btn btn-danger">Voltar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/contratos/revisaocontratointerno/revisoescontrato.html','<div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div class="panel-body"><div ng-show="contrato.id != null" class="text-left"><h3>Contrato : {{contrato.numeroContrato}}</h3></div><div class="text-right"><button ng-click="open(\'app/pages/contratos/revisaocontratointerno/revisaocontrato.html\', \'md\', \'Revis\xE3o de Contrato\', revisaoContrato)" data-placement="top" tooltip="" title="Nova Revis\xE3o de Contrato" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="codigo">C\xF3digo</th><th st-sort="tipoRevisao">Tipo de Revis\xE3o</th><th st-sort="data" class="text-center">Data</th><th st-sort="prazo" class="text-center">Prazo</th><th st-sort="tipoPrazo" class="text-center">Tipo</th><th st-sort="valorTotal" class="text-right">Valor (R$)</th><th class="text-right">Valor Total (R$)</th><th style="width:115px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="revisaocontrato in displayed"><td>{{revisaocontrato.codigo}}</td><td>{{revisaocontrato.tipoRevisao.descricao}}</td><td class="text-center">{{revisaocontrato.data | date:\'dd/MM/y\'}}</td><td class="text-center">{{revisaocontrato.prazo}}</td><td class="text-center">{{revisaocontrato.tipoPrazo.descricao}}</td><td class="text-right">{{revisaocontrato.valor | mask:"real"}}</td><td class="text-right">{{revisaocontrato.valorTotal | mask:"real"}}</td><td class="text-right"><button ng-click="open(\'app/pages/contratos/revisaocontratointerno/revisaocontrato.html\', \'md\', \'Revis\xE3o de Contrato\', revisaocontrato)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Revis\xE3o de Contrato \', revisaocontrato)" data-toggle="modal" data-id="{{revisaocontrato.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="8" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="8" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="7" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/dashboard/apresentadas/apresentadas-dashboard.html','<div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div class="panel panel-primary bootstrap-panel"><div class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="row"><div class="col-md-12"><div ng-include="\'app/pages/licitacoes/apresentadas/apresentadasSearch.html\'"></div></div><div class="col-md-4 form-group text-left"><label for="agrupador">Agrupador</label><select-enum name="agrupador" id="agrupador" ng-model="filtro.agrupador" tipo="AgrupadorPerspectiva" tipo-label="agrupador"></select-enum></div><div class="col-md-2 form-group text-left"><label for="tempo">Tempo</label><select-enum name="tempo" id="tempo" ng-model="filtro.tempo" tipo="AgrupadorTemporal" tipo-label="tempo"></select-enum></div><div class="col-md-2"><div class="form-group"><label for="visao">Vis\xE3o</label><select name="visao" id="visao" ng-model="filtro.visao" class="form-control"><option value="">Selecione uma Vis\xE3o</option><option value="quantidade">QUANTIDADE</option><option value="valor">VALOR</option></select></div></div></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca Avan\xE7ada</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button ng-click="search()" class="btn btn-success">Buscar</button></div></div></div></div><div class="row"><div ba-panel="" ba-panel-title="{{perspectivaChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" ng-if="!isLoading" chart-data="perspectivaChart.data" chart-labels="perspectivaChart.labels" chart-colors="perspectivaChart.colors" chart-dataset-override="perspectivaChart.datasetOverride" chart-options="perspectivaChart.options" height="75" class="chart chart-bar"></canvas></div></div><div ng-repeat="pesc in perspectivas" ng-if="!isLoading" class="panel panel-primary bootstrap-panel"><div ng-show="pesc.data.length &gt; 0" class="panel-body"><div class="text-left"><h3 class="lead">{{pesc.data.length}} {{pesc.sigla}}</h3></div><div class="table-responsive"><table st-table="pesc.data" class="table table-striped table-hover table-hover"><thead><tr class="sortable"><th style="width:50px !important;">C\xF3digo</th><th style="width:150px !important;">N\xFAmero Edital</th><th>Titulo</th><th>\xDAltima atualiza\xE7\xE3o</th><th style="width:150px !important;">Parceiros</th><th style="width:50px !important;">Cliente</th><th style="width:50px !important;" class="text-center">Apresenta\xE7\xE3o</th><th style="width:150px !important;" class="text-right">Valor</th></tr></thead><tbody ng-show="!isLoading"><tr ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})" ng-repeat="perspectiva in pesc.data"><td>{{perspectiva.codigo}}</td><td>{{perspectiva.numeroEdital}}</td><td tooltip="" title="{{perspectiva.titulo}}"><div class="ellipsis-4-lines">{{perspectiva.titulo}}</div></td><td tooltip="" title="{{perspectiva.ultimoHistorico}}"><div class="ellipsis-4-lines">{{perspectiva.ultimoHistorico}}</div></td><td tooltip="" title="{{perspectiva.todosParceiros}}">{{perspectiva.todosParceiros}}</td><td tooltip="" title="{{perspectiva.cliente.pessoaJuridica.nomeFantasia}}">{{perspectiva.cliente.pessoaJuridica.nomeFantasia}}</td><td class="text-center">{{perspectiva.dataApresentacao | date:"dd/MM/y"}}</td><td class="text-right">{{"R$ " + (perspectiva.valor | mask: "real")}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="pesc.data.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody></table></div></div></div><div ng-show="perspectivasUl.length &gt; 0" class="panel panel-primary bootstrap-panel"><div class="panel-body"><div class="text-left"><h3 class="lead">Perspectivas</h3></div><div class="table-responsive"><table st-table="perspectivasUl" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th style="width:50px !important;" st-sort="codigo">Codigo</th><th style="width:120px !important;" st-sort="situacaoPerspectiva.descricao">Situa\xE7\xE3o Atual</th><th style="width:150px !important;" st-sort="numeroEdital">N\xFAmero Edital</th><th st-sort="titulo">Titulo</th><th st-sort="ultimoHistorico">\xDAltima atualiza\xE7\xE3o</th><th style="width:120px !important;" st-sort="cliente.pessoaJuridica.nomeFantasia">Cliente</th><th style="width:120px !important;" st-sort="tipoLicitacao">Tipo de Licita\xE7\xE3o</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="perspectiva in perspectivasUl"><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.codigo}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.situacaoPerspectiva.descricao}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.numeroEdital}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})"><div class="ellipsis-4-lines">{{perspectiva.titulo}}</div></td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})"><div class="ellipsis-4-lines">{{perspectiva.ultimoHistorico}}</div></td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.cliente.pessoaJuridica.nomeFantasia}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.tipoLicitacao.descricao}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/atuacao-juridica-perspectiva/atuacao-juridica-perspectiva-dashboard.html','<div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div class="panel panel-primary bootstrap-panel"><div class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="row"><div class="col-md"><div class="col-md-3 form-group"><label for="numeroEdital">N\xFAmero do Edital da Perspectiva</label> <input type="text" name="numeroEdital" id="numeroEdital" ng-model="filter.numeroEdital" class="form-control"></div><div class="col-md-3 form-group"><label for="titulo">T\xEDtulo da Perspectiva</label> <input name="titulo" id="titulo" type="text" ng-model="filter.titulo" maxlength="255" ng-maxlength="255" class="form-control"></div><div class="col-md-3 form-group"><label for="tipoAcaoJuridico">Tipo de A\xE7\xE3o Solicitado</label><select-enum name="tipoAcaoJuridico" id="tipoAcaoJuridico" ng-model="filter.tipoAcaoJuridico" tipo="TipoAcaoJuridico" tipo-label="Tipo de A\xE7\xE3o do Jur\xEDdico" ng-disabled="isLoading"></select-enum></div><div class="col-md-3 form-group"><label for="statusRespostaJuridico">Status da Entrega da Resposta</label><select-enum name="statusRespostaJuridico" id="statusRespostaJuridico" ng-model="filter.statusRespostaJuridico" tipo="StatusRespostaJuridico" tipo-label="Selecione o Status da Resposta" ng-disabled="isLoading"></select-enum></div><div class="col-md-3 form-group"><label for="responsavel">Respons\xE1vel pela Resposta</label><select-usuario name="responsavel" id="responsavel" ng-model="filter.responsavel" watch-to="{ descricao: \'JUR\xCDDICO\' }" ng-disabled="isLoading"></select-usuario></div><div class="col-md-3 form-group"><label for="dataSolicitacaoInicio" class="control-label">Data da Solicita\xE7\xE3o In\xEDcio</label> <input name="dataSolicitacaoInicio" type="date" id="dataSolicitacaoInicio" ng-model="filter.dataSolicitacaoInicio" class="form-control text-center"></div><div class="col-md-3 form-group"><label for="dataSolicitacaoFim" class="control-label">Data da Solicita\xE7\xE3o Fim</label> <input name="dataSolicitacaoFim" type="date" id="dataSolicitacaoFim" ng-model="filter.dataSolicitacaoFim" class="form-control text-center"></div></div></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca Avan\xE7ada</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button ng-click="search()" class="btn btn-success">Buscar</button></div></div></div></div><div class="panel panel-primary bootstrap-panel"><div class="panel-body"><div class="text-left"><h3 class="lead">Solicita\xE7\xF5es ao Departamento Jur\xEDdico</h3></div><div class="table-responsive"><table st-table="solicitacoesJuridico" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr><th colspan="1" class="th-group-highlight-standard text-center">Perspectiva</th><th colspan="4" class="text-center th-group-highlight-standard">Solicita\xE7\xE3o de A\xE7\xE3o Jur\xEDdica</th><th colspan="3" class="text-center th-group-highlight-standard">Resposta Mais Recente da Solicita\xE7\xE3o</th><th colspan="2" class="text-center th-group-highlight-standard">Provimento</th></tr><tr class="sortable"><th class="table-division-separator">Edital</th><th st-sort="tipoAcaoJuridico">Tipo de A\xE7\xE3o</th><th st-sort="dataSolicitacao">Data da Solicita\xE7\xE3o</th><th st-sort="dataApresentacao">Data de Apresenta\xE7\xE3o</th><th class="table-division-separator">Observa\xE7\xE3o</th><th st-sort="respostasSolicitacaoJuridico.statusRespostaJuridico">Status da Entrega</th><th st-sort="respostasSolicitacaoJuridico.dataResposta">Data da Resposta</th><th st-sort="respostasSolicitacaoJuridico.responsavel" class="table-division-separator">Respons\xE1vel</th><th st-sort="provimentoSolicitacao.decisaoCliente">Decis\xE3o do Provimento</th><th st-sort="provimentoSolicitacao.dataDecisao">Data do Provimento</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="solicitacao in solicitacoesJuridico" ng-disabled="!authService.isInRole(\'ROLE_SOLICITACAO_JURIDICO_[A-Z]*R[A-Z]*\')" ui-sref="licitacoes.respostaJuridicoPerspectiva({solicitacaoJuridicoId: solicitacao.id})"><td style="font-size: 14px; width: 500px !important; max-width: 500px" class="table-division-separator">{{ "[" + solicitacao.perspectiva.numeroEdital + "] - " }} {{ solicitacao.perspectiva.titulo.length > 120 ? solicitacao.perspectiva.titulo.substring(0, 120) + \'...\' : solicitacao.perspectiva.titulo }}</td><td style="font-size: 14px;">{{ solicitacao.tipoAcaoJuridico.descricao }}</td><td class="text-center">{{ solicitacao.dataSolicitacao | date:"dd/MM/y" }}</td><td class="text-center">{{ solicitacao.dataApresentacao | date:"dd/MM/y" }}</td><td style="font-size: 14px; width: 500px !important; max-width: 500px" class="table-division-separator">{{ solicitacao.observacao.length > 130 ? solicitacao.observacao.substring(0, 130) + \'...\' : solicitacao.observacao }}</td><td class="text-center">{{ solicitacao.lastRespostaSolicitacaoJuridico.statusRespostaJuridico.descricao }}</td><td class="text-center">{{ solicitacao.lastRespostaSolicitacaoJuridico.dataResposta | date:"dd/MM/y" }}</td><td class="table-division-separator">{{ solicitacao.lastRespostaSolicitacaoJuridico.responsavel.pessoaFisica.pessoa.nome }}</td><td class="text-center">{{ solicitacao.provimentoSolicitacao.decisaoCliente.descricao }}</td><td class="text-center">{{ solicitacao.provimentoSolicitacao.dataDecisao | date: \'dd/MM/y\' }}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="10" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="solicitacoesJuridico.length==0"><tr><td colspan="10" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td><td st-pagination="" st-items-by-page="itemsByPage" colspan="10" class="text-center"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/contrato/contrato-dashboard.html','<div ng-init="init()"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-if="contrato &amp;&amp; !isLoading"><div ng-if="!isLoading" ng-init="aberto=false" class="panel panel-primary bootstrap-panel"><div class="panel-body"><div class="row"><div class="col"><div class="text-center"><h2>{{contrato.numeroContrato}} - {{contrato.centroDeCusto.nome}}</h2></div></div></div></div></div><div class="row"><div ba-panel="" ba-panel-title="{{barOrcamentaria.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="bar" chart-data="barOrcamentaria.data" chart-labels="barOrcamentaria.labels" chart-series="barOrcamentaria.series" chart-colors="barOrcamentaria.colors" chart-options="barOrcamentaria.options" height="75" class="chart chart-bar"></canvas></div><div ba-panel="" ba-panel-title="{{pieFinanciero.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-6 col-md-12 col-sm-12"><canvas id="pie" chart-data="pieFinanciero.data" chart-labels="pieFinanciero.labels" chart-colors="pieFinanciero.colors" chart-options="pieFinanciero.options" class="chart chart-pie"></canvas></div><div ba-panel="" ba-panel-title="{{pieTemporal.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-6 col-md-12 col-sm-12"><canvas id="pie" chart-data="pieTemporal.data" chart-labels="pieTemporal.labels" chart-colors="pieTemporal.colors" chart-options="pieTemporal.options" class="chart chart-pie"></canvas></div></div><div class="row"><div ba-panel="" ba-panel-title="{{Schart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="Schart.data" chart-labels="Schart.labels" chart-colors="Schart.colors" chart-dataset-override="Schart.datasetOverride" chart-options="Schart.options" height="75" class="chart chart-bar"></canvas></div></div><div class="row"><div ba-panel="" ba-panel-title="{{produtoChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="produtoChart.data" chart-labels="produtoChart.labels" chart-colors="produtoChart.colors" chart-dataset-override="produtoChart.datasetOverride" chart-options="produtoChart.options" height="75" class="chart chart-bar"></canvas></div></div><div class="row"><div ba-panel="" ba-panel-title="{{resultadoEconomicoChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="resultadoEconomicoChart.data" chart-labels="resultadoEconomicoChart.labels" chart-colors="resultadoEconomicoChart.colors" chart-dataset-override="resultadoEconomicoChart.datasetOverride" chart-options="resultadoEconomicoChart.options" height="75" class="chart chart-bar"></canvas></div></div><div class="row"><div ba-panel="" ba-panel-title="{{contaReceberChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="contaReceberChart.data" chart-labels="contaReceberChart.labels" chart-colors="contaReceberChart.colors" chart-dataset-override="contaReceberChart.datasetOverride" chart-options="contaReceberChart.options" height="75" class="chart chart-bar"></canvas></div></div><div class="row"><div ba-panel="" ba-panel-title="{{faturamentoChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="faturamentoChart.data" chart-labels="faturamentoChart.labels" chart-colors="faturamentoChart.colors" chart-dataset-override="faturamentoChart.datasetOverride" chart-options="faturamentoChart.options" height="75" class="chart chart-bar"></canvas></div></div></div></div>');
$templateCache.put('app/pages/dashboard/financeiro/financeiro-dashboard.html','<div ng-init="init()"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-if="!isLoading"><div class="panel panel-primary bootstrap-panel"><div class="panel-body"><form class="form form-group"><div class="row"><div class="col-md-12 text-right"><button ng-click="aberto=!aberto" class="btn btn-md btn-info">Busca Avan\xE7ada</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button ng-click="search()" class="btn btn-success">Buscar</button></div></div><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="row"><div class="col-md-4 form-group"><label for="funcionario">Respons\xE1vel</label><select-funcionario type="text" name="funcionario" id="funcionario" ng-model="filtro.responsavel" watch-to="70853"></select-funcionario></div><div class="col-md-4 form-group"><label for="regiao">Regi\xE3o</label><select-enum name="regiao" id="regiao" ng-model="filtro.regiao" tipo="Regiao" tipo-label="Regi\xE3o"></select-enum></div><div class="col-md-4 form-group"><label for="numeroEdital">Centro de Custo</label><select-centro-custo name="centroDeCusto" ng-model="filtro.centroDeCusto"></select-centro-custo></div><div class="col-md-2 form-group"><label for="inicio" class="control-label">\xCDnicio</label> <input name="inicio" type="date" id="inicio" ng-model="filtro.inicio" class="form-control text-center"></div><div class="col-md-2 form-group"><label for="fim" class="control-label">Fim</label> <input name="fim" type="date" id="fim" ng-model="filtro.fim" class="form-control text-center"></div><div class="col-md-2"><div class="form-group"><label for="tipo">Tipo</label><select-enum name="tipo" ng-model="filtro.tipoContaReceber" tipo="TipoContaReceber" tipo-label="Tipo"></select-enum></div></div><div class="col-md-2 form-group"><label for="tempo">Tempo</label><select-enum name="tempo" id="tempo" ng-model="filtro.tempo" tipo="AgrupadorTemporal" tipo-label="tempo"></select-enum></div><div class="col-md-2 form-group"><label for="tipo">Fase</label><select name="tipo" ng-model="filtro.tipo" class="form-control"><option value="">Selecione uma Vis\xE3o</option><option value="contrato">VENDAS</option><option value="produto">PRODUTOS</option><option value="economico">ECON\xD4MICO</option><option value="medicao">RECEITAS</option><option value="contaReceber">RECEBIMENTOS</option></select></div><div class="col-md-2"><div class="form-group"><label for="visao">Vis\xE3o</label><select name="visao" id="visao" ng-model="filtro.visao" class="form-control"><option value="">Selecione uma Vis\xE3o</option><option value="quantidade">QUANTIDADE</option><option value="valor">VALOR</option></select></div></div></div></form></div></div><div ng-if="contratoChart.data" class="row"><div ba-panel="" ba-panel-title="{{contratoChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="contratoChart.data" chart-labels="contratoChart.labels" chart-colors="contratoChart.colors" chart-dataset-override="contratoChart.datasetOverride" chart-options="contratoChart.options" height="75" class="chart chart-bar"></canvas></div></div><div ng-if="produtoChart.data" class="row"><div ba-panel="" ba-panel-title="{{produtoChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="produtoChart.data" chart-labels="produtoChart.labels" chart-colors="produtoChart.colors" chart-dataset-override="produtoChart.datasetOverride" chart-options="produtoChart.options" height="75" class="chart chart-bar"></canvas></div></div><div ng-if="resultadoEconomicoChart.data" class="row"><div ba-panel="" ba-panel-title="{{resultadoEconomicoChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="resultadoEconomicoChart.data" chart-labels="resultadoEconomicoChart.labels" chart-colors="resultadoEconomicoChart.colors" chart-dataset-override="resultadoEconomicoChart.datasetOverride" chart-options="resultadoEconomicoChart.options" height="75" class="chart chart-bar"></canvas></div></div><div ng-if="faturamentoChart.data" class="row"><div ba-panel="" ba-panel-title="{{faturamentoChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="faturamentoChart.data" chart-labels="faturamentoChart.labels" chart-colors="faturamentoChart.colors" chart-dataset-override="faturamentoChart.datasetOverride" chart-options="faturamentoChart.options" height="75" class="chart chart-bar"></canvas></div></div><div ng-if="despesasChart.data" class="row"><div ba-panel="" ba-panel-title="{{despesasChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="despesasChart.data" chart-labels="despesasChart.labels" chart-colors="despesasChart.colors" chart-dataset-override="despesasChart.datasetOverride" chart-options="despesasChart.options" height="75" class="chart chart-bar"></canvas></div></div><div ng-if="contaReceberChart.data" class="row"><div ba-panel="" ba-panel-title="{{contaReceberChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="contaReceberChart.data" chart-labels="contaReceberChart.labels" chart-colors="contaReceberChart.colors" chart-dataset-override="contaReceberChart.datasetOverride" chart-options="contaReceberChart.options" height="75" class="chart chart-bar"></canvas></div></div><div ng-include="\'app/pages/gantt/gantt.html\'" ng-if="!loading" ng-controller="GanttCtrl" ng-init="activate(columns)"></div></div></div>');
$templateCache.put('app/pages/dashboard/indicador/dashboard.html','<div ng-init="init()"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-if="!isLoading"><div ng-repeat="chart in charts" class="row"><div ng-if="chart.data" ba-panel="" ba-panel-title="{{chart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="chart.data" chart-labels="chart.labels" chart-colors="chart.colors" chart-dataset-override="chart.datasetOverride" chart-options="chart.options" height="75" class="chart chart-bar"></canvas></div></div></div></div>');
$templateCache.put('app/pages/dashboard/perspectiva/perspectiva-dashboard.html','<div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div class="panel panel-primary bootstrap-panel"><div class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="row"><div class="col-md-12"><div ng-include="\'app/pages/licitacoes/perspectivas/perspectivasSearch.html\'"></div></div><div class="col-md-4 form-group text-left"><label for="agrupador">Agrupador</label><select-enum name="agrupador" id="agrupador" ng-model="filtro.agrupador" tipo="AgrupadorPerspectiva" tipo-label="agrupador"></select-enum></div><div class="col-md-2 form-group text-left"><label for="tempo">Tempo</label><select-enum name="tempo" id="tempo" ng-model="filtro.tempo" tipo="AgrupadorTemporal" tipo-label="tempo"></select-enum></div><div class="col-md-2"><div class="form-group"><label for="visao">Vis\xE3o</label><select name="visao" id="visao" ng-model="filtro.visao" class="form-control"><option value="">Selecione uma Vis\xE3o</option><option value="quantidade">QUANTIDADE</option><option value="valor">VALOR</option></select></div></div></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca Avan\xE7ada</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button ng-click="search()" class="btn btn-success">Buscar</button></div></div></div></div><div class="row"><div ba-panel="" ba-panel-title="{{perspectivaChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" ng-if="!isLoading" chart-data="perspectivaChart.data" chart-labels="perspectivaChart.labels" chart-colors="perspectivaChart.colors" chart-dataset-override="perspectivaChart.datasetOverride" chart-options="perspectivaChart.options" height="75" class="chart chart-bar"></canvas></div></div><div ng-repeat="pesc in perspectivas" ng-if="!isLoading" class="panel panel-primary bootstrap-panel"><div ng-show="pesc.data.length &gt; 0" class="panel-body"><div class="text-left"><h3 class="lead">{{pesc.data.length}} {{pesc.sigla}}</h3></div><div class="table-responsive"><table st-table="pesc.data" class="table table-striped table-hover table-hover"><thead><tr class="sortable"><th style="width:50px !important;">C\xF3digo</th><th style="width:150px !important;">N\xFAmero Edital</th><th>Titulo</th><th>Parceiros</th><th style="width:50px !important;">Cliente</th><th style="width:50px !important;" class="text-center">Apresenta\xE7\xE3o</th><th style="width:50px !important;" class="text-right">Valor</th></tr></thead><tbody ng-show="!isLoading"><tr ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})" ng-repeat="perspectiva in pesc.data | orderBy:&quot;dataApresentacao&quot;"><td>{{perspectiva.codigo}}</td><td>{{perspectiva.numeroEdital}}</td><td tooltip="" title="{{perspectiva.titulo}}">{{perspectiva.titulo}}</td><td tooltip="" title="{{perspectiva.todosParceiros}}">{{perspectiva.todosParceiros}}</td><td tooltip="" title="{{perspectiva.cliente.pessoaJuridica.nomeFantasia}}">{{perspectiva.cliente.pessoaJuridica.nomeFantasia}}</td><td class="text-center">{{perspectiva.dataApresentacao | date:"dd/MM/y"}}</td><td class="text-right">{{"R$ " + (perspectiva.valor | mask: "real")}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="pesc.data.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody></table></div></div></div><div ng-show="perspectivasUl.length &gt; 0" class="panel panel-primary bootstrap-panel"><div class="panel-body"><div class="text-left"><h3 class="lead">Perspectivas</h3></div><div class="table-responsive"><table st-table="perspectivasUl" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th style="width:50px !important;" st-sort="codigo">Codigo</th><th style="width:120px !important;" st-sort="situacaoPerspectiva.descricao">Situa\xE7\xE3o Atual</th><th style="width:150px !important;" st-sort="numeroEdital">N\xFAmero Edital</th><th st-sort="titulo">Titulo</th><th style="width:120px !important;" st-sort="cliente.pessoaJuridica.nomeFantasia">Cliente</th><th style="width:120px !important;" st-sort="tipoLicitacao">Tipo de Licita\xE7\xE3o</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="perspectiva in perspectivasUl"><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.codigo}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.situacaoPerspectiva.descricao}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.numeroEdital}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.titulo}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.cliente.pessoaJuridica.nomeFantasia}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.tipoLicitacao.descricao}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/qualidade/qualidade-dashboard.html','<div ng-init="init()"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-if="!isLoading"><div class="panel panel-primary bootstrap-panel"><div class="panel-body"><form class="form form-group"><div class="row"><div class="col-md-12 text-right"><div class="col-md-12"><div class="form-group text-right"><br><button ng-click="aberto=!aberto" class="btn btn-md btn-info">Busca Avan\xE7ada</button> <button ng-click="search()" class="btn btn-success">Buscar</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button></div></div></div></div><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><div ng-include="\'app/pages/qualidade/nao-conformidade/naoConformidadeSearch.html\'"></div></div></form></div></div><div ng-if="acaoChart.data" class="row"><div ba-panel="" ba-panel-title="{{acaoChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="acaoChart.data" chart-labels="acaoChart.labels" chart-colors="acaoChart.colors" chart-dataset-override="acaoChart.datasetOverride" chart-options="acaoChart.options" height="75" class="chart chart-bar"></canvas></div></div><div ng-if="naoConformidadeChart.data" class="row"><div ba-panel="" ba-panel-title="{{naoConformidadeChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="naoConformidadeChart.data" chart-labels="naoConformidadeChart.labels" chart-colors="naoConformidadeChart.colors" chart-dataset-override="naoConformidadeChart.datasetOverride" chart-options="naoConformidadeChart.options" height="75" class="chart chart-bar"></canvas></div></div></div></div>');
$templateCache.put('app/pages/financeiro/centro-custo/centrocusto.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto=false" class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px;margin-bottom:20px;" class="well"><form class="form"><div ng-include="\'app/pages/financeiro/centro-custo/centrocustoSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button> <button ng-disabled="!authService.isInRole(\'ROLE_CENTRODECUSTO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/financeiro/centro-custo/formcentrocusto.html\', \'lg\', \'Centro de Custo\', centro)" tooltip="" title="Novo Centro de Custo" data-placement="top" class="btn btn-warning">Adicionar</button></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="nome">Nome</th><th st-sort="responsavel">Respons\xE1vel</th><th st-sort="anoDeCriacao">Ano</th><th st-sort="naoRecebidoSemNf" style="width:50px !important;" class="text-right">N\xE3o Faturado (R$)</th><th st-sort="faturado" style="width:50px !important;" class="text-right">Faturado (R$)</th><th st-sort="naoRecebidoComNf" style="width:50px !important;" class="text-right">N\xE3o Recebido (R$)</th><th st-sort="recebido" style="width:50px !important;" class="text-right">Recebido (R$)</th><th style="width:180px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="centro in displayed"><td>{{centro.nome}}</td><td>{{centro.responsavel.pessoaFisica.pessoa.nome}}</td><td>{{centro.anoDeCriacao}}</td><td ng-class="{\'editable-empty\': centro.naoRecebidoSemNf &gt; 0 }" class="text-right">{{centro.naoRecebidoSemNf | mask:"real"}}</td><td class="text-right">{{centro.faturado | mask:"real"}}</td><td ng-class="{\'editable-empty\': centro.naoRecebidoComNf &gt; 0 }" class="text-right">{{centro.naoRecebidoComNf | mask:"real"}}</td><td class="text-right">{{centro.recebido | mask:"real"}}</td><td class="text-right"><div uib-dropdown="" dropdown-append-to-body="" class="btn-group"><a ng-disabled="!authService.isInRole(\'ROLE_CENTRODECUSTO_[A-Z]*R[A-Z]*\')" ui-sref="financeiro.contasreceber({centroDeCustoId: centro.id})" tooltip="" title="Contas a Receber" data-placement="top" class="btn btn-link"><i style="color:green" class="ion ion-cash"></i></a> <button ng-disabled="!authService.isInRole(\'ROLE_CENTRODECUSTO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/financeiro/centro-custo/formcentrocusto.html\', \'lg\', \'Centro de Custo\', centro)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_CENTRODECUSTO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Centro de Custo \'+ centro.nome, centro)" data-toggle="modal" data-id="{{centro.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="8" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="8" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="7" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/financeiro/centro-custo/centrocustoSearch.html','<div><div class="col-md-7"><div class="form-group"><label for="nome">Nome</label> <input type="text" name="nome" id="nome" ng-model="filtro.nome" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="anoDeCriacao">Ano</label> <input type="text" ui-mask="9999" name="anoDeCriacao" id="anoDeCriacao" ng-model="filtro.anoDeCriacao" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="funcionario">Respons\xE1vel</label><select-funcionario type="text" name="funcionario" id="funcionario" ng-model="filtro.responsavel" watch-to="70853"></select-funcionario></div></div><div class="col-md-4"><div class="form-group"><label for="regiao">Regi\xE3o</label><select-enum name="regiao" id="regiao" ng-model="filtro.regiao" tipo="Regiao" tipo-label="Regi\xE3o"></select-enum></div></div><div class="col-md-4"><div class="form-group"><label for="tipoCentroCusto">Tipo</label><select-enum name="tipoCentroCusto" id="tipoCentroCusto" ng-model="filtro.tipoCentroCusto" tipo="TipoDeCentroDeCusto" tipo-label="Tipo Centro de Custo"></select-enum></div></div><div class="col-md-4"><div class="form-group"><label for="statusContrato">Status do Contrato</label><select-enum name="statusContrato" ng-model="filtro.statusContrato" tipo="StatusContrato" tipo-label="Status do Contrato"></select-enum></div></div></div>');
$templateCache.put('app/pages/financeiro/centro-custo/formcentrocusto.html','<div class="panel panel-default bootstrap-panel"><form name="form" ng-submit="save(centro)" class="form"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="nome">Nome</label> <input type="text" name="nome" id="nome" ng-model="centro.nome" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="funcionario">Respons\xE1vel</label><select-funcionario type="text" name="funcionario" id="funcionario" ng-model="centro.responsavel" watch-to="70853" required="required"></select-funcionario></div></div><div class="col-md-3"><div class="form-group"><label for="regiao">Regi\xE3o</label><select-enum name="regiao" id="regiao" tipo="Regiao" ng-model="centro.regiao" tipo-label="Regi\xE3o" required="required"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="anoDeCriacao">Ano</label> <input type="text" ui-mask="9999" name="anoDeCriacao" id="anoDeCriacao" ng-model="centro.anoDeCriacao" required="required" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="tipoCentroCusto">Tipo</label><select-enum name="tipoCentroCusto" id="tipoCentroCusto" ng-model="centro.tipoCentroCusto" tipo="TipoDeCentroDeCusto" tipo-label="Tipo"></select-enum></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="diaOtimista" class="control-label">Dia Otimista</label> <input type="number" name="diaOtimista" id="diaOtimista" ng-model="centro.diaOtimista" min="1" max="31" step="1" class="form-control"><h6 ng-if="!isDayValid(centro.diaOtimista)" class="help-block">O dia deve ser entre 1 e 31.</h6></div></div><div class="col-md-4"><div class="form-group"><label for="diaNormal" class="control-label">Dia Normal</label> <input type="number" name="diaNormal" id="diaNormal" ng-model="centro.diaNormal" min="1" max="31" step="1" class="form-control"><h6 ng-if="!isDayValid(centro.diaNormal)" class="help-block">O dia deve ser entre 1 e 31.</h6></div></div><div class="col-md-4"><div class="form-group"><label for="diaPessimista" class="control-label">Dia Pessimista</label> <input type="number" name="diaPessimista" id="diaPessimista" ng-model="centro.diaPessimista" min="1" max="31" step="1" class="form-control"><h6 ng-if="!isDayValid(centro.diaPessimista)" class="help-block">O dia deve ser entre 1 e 31.</h6></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <textarea name="descricao" id="descricao" ng-model="centro.descricao" class="form-control"></textarea></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/financeiro/conta-receber/conta-receber.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto=false" class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div class="text-left"><h3>{{centroDeCusto.nome}}</h3></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ng-disabled="!authService.isInRole(\'ROLE_CONTARECEBER_[A-Z]*C[A-Z]*\')" ui-sref="financeiro.contareceber({ centroDeCustoId: centroDeCusto.id })" class="btn btn-warning">Adicionar</a></div></div><div uib-collapse="!aberto" style="margin-top:20px;margin-bottom:20px;" class="well"><form class="form"><div ng-include="\'app/pages/financeiro/conta-receber/contareceberSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="situacao" style="width:50px !important;" class="text-center">Situa\xE7\xE3o</th><th st-sort="medicao.codigo" style="width:50px !important;" class="text-center">Medi\xE7\xE3o</th><th st-sort="tipo" style="width:50px !important;" class="text-center">Tipo</th><th st-sort="descricao">Descri\xE7\xE3o</th><th ng-show="centroDeCustoId == null" st-sort="centroDeCusto" style="width:50px !important;" class="hide-column-5">Centro de Custo</th><th st-sort="numeroNotaFiscal" style="width:50px !important;" class="text-center">Nota Fiscal</th><th st-sort="dataCompetencia" style="width:50px !important;" class="text-center hide-column-6">Compet\xEAncia</th><th st-sort="dataEmissao" style="width:50px !important;" class="text-center">Data de Emiss\xE3o</th><th st-sort="dataPrevista" style="width:50px !important;" class="text-center hide-column-5">Data Prevista</th><th st-sort="dataRecebimento" style="width:50px !important;" class="text-center hide-column-5">Data de Recebimento</th><th st-sort="valor" style="width:100px !important;" class="text-right">Valor Faturado</th><th st-sort="valorRecebido" style="width:100px !important;" class="text-right">Valor Recebido</th><th style="width:120px !important;" class="text-right hide-column-6">Saldo</th><th style="width:120px;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!tableIsLoading"><tr ng-repeat="contaReceber in displayed"><td class="text-center"><button class="btn btn-xs {{contaReceber.color}}">{{contaReceber.situacao.descricao}}</button></td><td class="text-center">{{contaReceber.medicao.codigo}}</td><td class="text-center">{{contaReceber.tipo.descricao}}</td><td>{{contaReceber.descricao}}</td><td ng-show="centroDeCustoId == null" class="hide-column-5">{{contaReceber.centroDeCusto.nome}}</td><td class="text-center">{{contaReceber.numeroNotaFiscal}}</td><td class="text-center hide-column-6">{{contaReceber.dataCompetencia | date:\'MM/y\'}}</td><td class="text-center">{{contaReceber.dataEmissao | date: "dd/MM/y"}}</td><td class="text-center hide-column-5">{{contaReceber.dataPrevista | date: "dd/MM/y"}}</td><td class="text-center hide-column-5">{{contaReceber.dataRecebimento | date: "dd/MM/y"}}</td><td class="text-right">{{"R$ " + (contaReceber.valor | mask: "real")}}</td><td class="text-right">{{"R$ " + (contaReceber.valorRecebido | mask: "real")}}</td><td class="text-right hide-column-6">{{"R$ " + ((contaReceber.valor - contaReceber.valorRecebido) | mask: "real")}}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_CONTARECEBER_[A-Z]*U[A-Z]*\')" ui-sref="financeiro.contareceber({ contaReceberId: contaReceber.id , centroDeCustoId: contaReceber.centroDeCusto.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_CONTARECEBER_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Conta \xE0 Receber \'+contaReceber.numeroNotaFiscal, contaReceber)" data-toggle="modal" data-id="{{contaReceber.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="tableIsLoading"><tr><td colspan="100" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="100" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td><td></td><td></td><td st-pagination="" st-items-by-page="itemsByPage" class="text-center"></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/financeiro/conta-receber/contareceberSearch.html','<div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input type="text" name="descricao" ng-model="filtro.descricao" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="numNotaFiscal">Nota Fiscal</label> <input name="numNotaFiscal" ng-model="filtro.numNotaFiscal" class="form-control text-center"></div></div><div ng-show="centroDeCusto.id == null" class="col-md-2"><div class="form-group"><label for="numeroEdital">Centro de Custo Ativo</label><select-centro-custo name="centroDeCusto" ng-model="filtro.centroDeCusto" resource="&quot;findAllByContractStatus&quot;" filter="{statusContrato:&quot;ATIVO&quot;}"></select-centro-custo></div></div><div class="col-md-2"><div class="form-group"><label for="situacao">Situa\xE7\xE3o</label><select-enum name="situacao" ng-model="filtro.situacao" tipo="SituacaoContaReceber" tipo-label="Situa\xE7\xE3o"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="tipoContaReceber">Tipo</label><select-enum name="tipoContaReceber" ng-model="filtro.tipoContaReceber" tipo="TipoContaReceber" tipo-label="Tipo"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="inicio" class="control-label">\xCDnicio</label> <input name="inicio" type="date" id="inicio" ng-model="filtro.inicio" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="fim" class="control-label">Fim</label> <input name="fim" type="date" id="fim" ng-model="filtro.fim" class="form-control text-center"></div></div><div class="col-md-2 form-group"><label for="dataCompetencia" class="control-label">Compet\xEAncia</label> <input type="month" name="dataCompetencia" id="dataCompetencia" ng-model="filtro.dataCompetencia" class="form-control text-center"></div></div></div></div>');
$templateCache.put('app/pages/financeiro/conta-receber/form-conta-receber.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Informa\xE7\xF5es B\xE1sicas</h3></div><div class="panel-body"><form ng-submit="save(contaReceber)" name="form" method="post" class="form"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="centroDeCusto">Centro de Custo</label><select-centro-custo name="centroDeCusto" id="centroDeCusto" ng-model="contaReceber.centroDeCusto" required="required" ng-change="onCentroDeCustoChange(contaReceber.centroDeCusto.id)"></select-centro-custo></div></div><div class="col-md-5"><div class="form-group"><label for="medicao">Medi\xE7\xE3o</label><select ng-disabled="contaReceber.centroDeCusto.id == null" name="medicao" id="medicao" ng-model="contaReceber.medicao" required="required" ng-change="onMedicaoChange(contaReceber.medicao)" ng-options="medicao as medicao.descricao+\' / \'+medicao.tipoMedicao.descricao+\' / \'+medicao.statusMedicao.descricao for medicao in medicoes track by medicao.id" class="form-control"><option value="">Selecione a Medi\xE7\xE3o</option></select></div></div><div class="col-md-2"><div class="form-group"><label for="tipo" class="control-label">Tipo</label><select-enum name="tipo" id="tipo" ng-model="contaReceber.tipo" tipo="TipoContaReceber" tipo-label="tipo" required="required"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="numeroNotaFiscal">N\xFAmero da Nota Fiscal</label> <input name="numeroNotaFiscal" id="numeroNotaFiscal" ng-model="contaReceber.numeroNotaFiscal" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-8"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" type="text" ng-model="contaReceber.descricao" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-2 form-group"><label for="dataCompetencia" class="control-label">Compet\xEAncia</label> <input type="month" name="dataCompetencia" id="dataCompetencia" ng-model="contaReceber.dataCompetencia" required="required" class="form-control text-center"></div><div class="col-md-2"><div class="form-group"><label for="dataEmissao">Data de Emiss\xE3o</label> <input type="date" name="dataEmissao" ng-model="contaReceber.dataEmissao" required="required" class="form-control text-center"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="situacao">Situa\xE7\xE3o</label><select-enum name="situacao" id="situacao" ng-model="contaReceber.situacao" tipo="SituacaoContaReceber" tipo-label="Situa\xE7\xE3o" required="required"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="valor" class="control-label">Valor (R$)</label> <input name="valor" type="text" ng-model="contaReceber.valor" mask="real" required="required" class="form-control text-right"></div></div><div class="col-md-2"><div class="form-group"><label for="dataPrevista">Data Prevista</label> <input type="date" name="dataPrevista" ng-model="contaReceber.dataPrevista" required="required" class="form-control text-center"></div></div><div ng-if="contaReceber.situacao.name === &quot;RECEBIDO&quot;"><div class="col-md-2"><div class="form-group"><label for="dataRecebimento">Data de Recebimento</label> <input type="date" name="dataRecebimento" ng-model="contaReceber.dataRecebimento" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="valorRecebido">Valor Recebido</label> <input type="text" name="valorRecebido" ng-model="contaReceber.valorRecebido" mask="real" required="required" class="form-control text-right"></div></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="contaReceber.observacoes">Observa\xE7\xF5es</label> <textarea name="observacoes" ng-model="contaReceber.observacoes" style="height: 70px;" maxlength="255" ng-maxlength="255" class="form-control"></textarea></div></div></div></div><div class="form-actions text-right"><button type="button" ng-click="clear()" class="btn btn-warning">Nova Conta</button> <button type="button" ng-click="back()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form><div style="padding-top:20px;" ng-if="contaReceber.id" ng-include="\'app/pages/contratos/medicaos/analise-operacional/analiseOperacional.html\'" ng-controller="ComentarioContaReceberCtrl"></div></div></div></div></div></div>');
$templateCache.put('app/pages/financeiro/conta-receber/relatorioConfirm.html','<div class="panel panel-default bootstrap-panel"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h6 class="panel-title">{{title}}</h6></div><div class="panel-body"><div class="row text-center"><div class="col-md-4"><div class="form-group"><input type="radio" name="formato" id="formatoPdf" value="PDF" ng-model="formato"> <label for="formatoPdf">PDF</label></div></div><div class="col-md-4"><div class="form-group"><input type="radio" name="formato" id="formatoXls" value="XLS" ng-model="formato"> <label for="formatoPdf">XLS</label></div></div><div class="col-md-4"><button ng-show="centroDeCusto.nome != null" ng-click="gerarRelatorio(formato)" data-dismiss="modal" aria-label="close" class="btn btn-success">Gerar</button> <button ng-show="centroDeCusto.nome == null" ng-click="gerarRelatorioTodosCentroCusto(formato)" data-dismiss="modal" aria-label="close" class="btn btn-success">Gerar</button></div></div></div></div>');
$templateCache.put('app/pages/financeiro/plano-de-conta/formplano-de-conta.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Informa\xE7\xF5es B\xE1sicas</h3></div><div class="panel-body"><form ng-submit="save(plano)" name="form" method="post" class="form"><div class="row"><div class="col-md-3"><div class="form-group"><label for="centroDeCusto">Centro de Custo</label><select-centro-custo name="centroDeCusto" id="centroDeCusto" ng-model="plano.centroDeCusto"></select-centro-custo></div></div><div class="col-md-6"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input type="text" name="descricao" id="descricao" ng-model="plano.descricao" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="valor">Resultado (R$)</label> <input type="text" name="valor" id="valor" ng-model="plano.valor" mask="real" disabled="disabled" class="form-control text-right"></div></div></div><div class="text-right"><button type="button" ng-click="cancel()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form><div ng-show="plano.id != null" ng-include="\'app/pages/financeiro/plano-de-conta/item-plano-de-conta/item-plano-de-conta.html\'" ng-controller="ItemPlanoDeContaCtrl"></div></div></div></div></div></div>');
$templateCache.put('app/pages/financeiro/plano-de-conta/plano-de-conta-search.html','<div ng-show="centroDeCusto.id == null" class="col-md-4"><div class="form-group"><label for="numeroEdital">Centro de Custo Ativo</label><select-centro-custo name="centroDeCusto" ng-model="filtro.centroDeCusto" ng-change="onCentroDeCustoChange()" resource="&quot;findAllByContractStatus&quot;" filter="{statusContrato:&quot;ATIVO&quot;}"></select-centro-custo></div></div><div class="col-md-4"><div class="form-group"><label for="funcionario">Respons\xE1vel</label><select-funcionario name="responsavel" id="responsavel" ng-model="filtro.responsavel" watch-to="70853"></select-funcionario></div></div><div class="col-md-4"><div class="form-group"><label for="regiao">Regi\xE3o</label><select-enum name="regiao" id="regiao" ng-model="filtro.regiao" tipo="Regiao" tipo-label="Regi\xE3o"></select-enum></div></div><div class="col-md-8"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input type="text" name="descricao" ng-model="filtro.descricao" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="inicio" class="control-label">\xCDnicio</label> <input name="inicio" type="date" id="inicio" ng-model="filtro.inicio" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="fim" class="control-label">Fim</label> <input name="fim" type="date" id="fim" ng-model="filtro.fim" class="form-control text-center"></div></div>');
$templateCache.put('app/pages/financeiro/plano-de-conta/plano-de-conta.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px;margin-bottom:20px;" class="row"><div ng-include="\'app/pages/financeiro/plano-de-conta/plano-de-conta-search.html\'"></div><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button ng-click="search()" class="btn btn-success">Buscar</button></div></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ui-sref="economico.formplanodeconta" tooltip="" title="Adicionar" data-placement="top" class="btn btn-warning">Adicionar</a></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="descricao">Descri\xE7\xE3o</th><th st-sort="centroDeCusto.nome">Centro de Custo</th><th st-sort="centroDeCusto.responsavel">Respons\xE1vel</th><th st-sort="centroDeCusto.anoDeCriacao">Ano</th><th st-sort="valor">Valor / Resultado</th><th style="width:120px !important; padding-right: 20px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="plano in displayed"><td>{{plano.descricao}}</td><td>{{plano.centroDeCusto.nome}}</td><td>{{plano.centroDeCusto.responsavel.pessoaFisica.pessoa.nome}}</td><td>{{plano.centroDeCusto.anoDeCriacao}}</td><td>{{plano.valor | mask:"real"}}</td><td class="text-right"><a ui-sref="economico.formplanodeconta({ planoId: plano.id })" tooltip="" title="Visualizar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-eye-open"></span></a> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'lg\', \'O Plano \'+ plano.descricao, plano)" data-toggle="modal" data-id="{{plano.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/gerencial/controle-entrega/controle-entrega.html','<div class="no-js"><div ng-init="init()" ng-cloak="true"><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="row"><div ng-include="\'app/pages/contratos/produtos/produtosSearch.html\'"></div></div><div class="row"><div class="col-md-2 form-group"><label for="tipoRelatorio">Tipo de Relatorio</label><select name="tipoRelatorio" ng-model="tipoRelatorio" ng-change="onTipoRelatorioChange(tipoRelatorio)" class="form-control"><option value="controleDeEntrega">Relat\xF3rio Controle de Entregas</option></select></div><div class="col-md-2"><div class="form-group"><label for="visao">Vis\xE3o</label><select name="visao" id="visao" ng-model="filtro.visao" class="form-control"><option value="">Selecione um Tipo</option><option value="quantidade">Quantidade</option><option value="valor">Valor</option></select></div></div><div class="col-md-2"><label for="periodo">Periodo</label><select name="periodo" id="periodo" ng-model="filtro.periodo" class="form-control"><option value="">Selecione o Tipo</option><option value="produto">Servi\xE7o</option><option value="entrega">Entrega</option></select></div><div class="col-md-6"><div class="form-group text-right"><br><modal-print ng-if="tipoRelatorio == \'geral\'" title="\'Relat\xF3rio\'" reporttitle="Relatorio de Entregas" route="produto/?" filter="filtro"></modal-print><modal-print ng-if="tipoRelatorio == \'controleDeEntrega\'" ng-disabled="filtro.contratoExterno==null &amp;&amp; filtro.inicio==null &amp;&amp; filtro.fim==null" title="\'Relat\xF3rio\'" reporttitle="Relatorio Controle de Entregas" route="controle-de-entregas/?" filter="filtro"></modal-print><button ng-click="aberto=!aberto" class="btn btn-md btn-info">Busca Avan\xE7ada</button> <button ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></div></div></div><div ng-if="!isLoading &amp;&amp; produtoChart.data" class="row"><div ba-panel="" ba-panel-title="{{produtoChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="produtoChart.data" chart-labels="produtoChart.labels" chart-colors="produtoChart.colors" chart-dataset-override="produtoChart.datasetOverride" chart-options="produtoChart.options" height="75" class="chart chart-bar"></canvas></div></div><div ng-include="\'app/pages/gantt/gantt.html\'" ng-if="!loading" ng-controller="GanttCtrl" ng-init="activate(columns)"></div></div></div></div></div>');
$templateCache.put('app/pages/gerencial/gerencial-centro-custo/gerencialcentrodecusto.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div class="well"><form class="form"><div class="row"><div class="col-md"><div class="col-md-5"><div class="form-group"><label for="nome">Nome</label> <input type="text" name="nome" id="nome" ng-model="filtro.nome" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="anoDeCriacao">Ano</label> <input type="text" ui-mask="9999" name="anoDeCriacao" id="anoDeCriacao" ng-model="filtro.anoDeCriacao" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="tipoCentroCusto">Tipo de Centro de custo</label><select-enum name="tipoCentroCusto" id="tipoCentroCusto" ng-model="filtro.tipoCentroCusto" tipo="TipoDeCentroDeCusto" tipo-label="Tipo"></select-enum></div></div><div class="col-md-4"><div class="form-group"><label for="funcionario">Funcion\xE1rio</label><select-funcionario type="text" name="funcionario" id="funcionario" ng-model="filtro.responsavel" watch-to="70853"></select-funcionario></div></div><div class="col-md-3"><div class="form-group"><label for="agrupador">Agrupador</label><select-enum name="agrupador" id="agrupador" ng-model="filtro.agrupador" tipo="AgrupadorCentroDeCusto" tipo-label="agrupador"></select-enum></div></div></div></div><div class="row"><div class="form-group"><div class="col-md-4 text-left"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div><div class="col-md-8 text-right"><modal-print type="button" ng-disabled="!authService.isInRole(\'ROLE_GERENCIAL_CENTRODECUSTO_[A-Z]*P[A-Z]*\')" title="\'Rel\xE1torio\'" reporttitle="Relatorio de Contratos" route="centro-custo/?" filter="filtro"></modal-print></div></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="nome">Nome</th><th st-sort="responsavel">Responsavel</th><th st-sort="tipoCentroCusto">Tipo</th><th st-sort="anoDeCriacao">Ano</th><th st-sort="dataModificacao">Data Modifica\xE7\xE3o</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="centro in displayed"><td>{{centro.nome}}</td><td>{{centro.responsavel.nome}}</td><td>{{centro.tipoCentroCusto.descricao}}</td><td>{{centro.anoDeCriacao}}</td><td>{{centro.dataModificacao}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="5" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="4" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/gerencial/gerencial-conta-a-receber/gerencialconta-a-receber.html','<div><div class="row"><div class="col-xs-12"><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><div ng-include="\'app/pages/financeiro/conta-receber/contareceberSearch.html\'"></div></div><div class="row"><div class="col-md-2 form-group"><label for="agrupador">Tipo de Relat\xF3rio</label><select name="tipoRelatorio" ng-model="tipoRelatorio" ng-change="onTipoDeRelatorioChange(filtro.tipoRelatorio)" class="form-control"><option value="">Selecione um tipo</option><option value="geral">Relat\xF3rio Geral de Contas a Receber</option></select></div><div class="col-md-10 form-group text-right"><br><button ng-click="copyLinkApi()" class="btn btn-success"><i style="margin: 0 5px 0 0;font-size: 1.4em;" class="fa fa-print"></i><span>Copiar link de exporta\xE7\xE3o CSV</span></button><modal-print ng-show="tipoRelatorio == \'geral\'" ng-disabled="!authService.isInRole(\'ROLE_CONTARECEBER_[A-Z]*P[A-Z]*\')" title="\'Relat\xF3rio\'" reporttitle="Relatorio de Contas \xE9 Receber" route="contas-receber/?" filter="filtro"></modal-print><button ng-click="aberto=!aberto" class="btn btn-md btn-info">Busca Avan\xE7ada</button> <button ng-click="clear()" class="btn btn-default">Limpar</button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/gerencial/gerencial-contratos-externos/gerencialcontratosexternos.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="div"><form class="form"><div ng-include="\'app/pages/contratos/contratosexternos/contratosexternosSearch.html\'"></div></form></div><div class="row"><div class="col-md-2 form-group"><label for="agrupador">Tipo de Relat\xF3rio</label><select name="tipoRelatorio" ng-model="tipoRelatorio" ng-change="onTipoDeRelatorioChange(filtro.tipoRelatorio)" class="form-control"><option value="">Selecione um tipo</option><option value="geral">Relat\xF3rio Geral de Contratos</option></select></div><div class="col-md-10 form-group text-right"><br><button ng-click="aberto=!aberto" class="btn btn-md btn-info">Busca Avan\xE7ada</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button><modal-print ng-show="tipoRelatorio == \'geral\'" ng-disabled="!authService.isInRole(\'ROLE_CONTRATOEXTERNO_[A-Z]*P[A-Z]*\')" title="\'Gerar Rel\xE1torio\'" reporttitle="Relatorio Geral de Contratos" route="geral-contratos/?" filter="filtro"></modal-print><modal-print ng-show="tipoRelatorio == \'gerencial\'" ng-disabled="!authService.isInRole(\'ROLE_CONTRATOEXTERNO_[A-Z]*P[A-Z]*\')" title="\'Gerar Rel\xE1torio\'" reporttitle="Relatorio Gerencial de Contratos" route="contratoGeral/?" filter="filtro"></modal-print><modal-print ng-show="tipoRelatorio == \'resumo\'" ng-disabled="!authService.isInRole(\'ROLE_CONTRATOEXTERNO_[A-Z]*P[A-Z]*\')" title="\'Gerar Rel\xE1torio\'" reporttitle="Relatorio Resumo de Contratos" route="contratoResumo/?" filter="filtro"></modal-print></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/gerencial/gerencial-perspectivas/gerencialperspectivas.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto=false" class="panel panel-default bootstrap-panel"><div ng-init="relatorio=true" class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="div"><div ng-include="\'app/pages/licitacoes/perspectivas/perspectivasSearch.html\'"></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label for="consulta">Consulta</label><select-consulta-by-usuario-and-perfil name="consulta" id="consulta" ng-model="consulta" ng-change="loadConsulta(consulta)" entidade="Perspectiva"></select-consulta-by-usuario-and-perfil></div></div><div class="col-md-2"><div class="form-group"><label for="visao">Tipo</label><select name="visao" id="visao" ng-model="filtro.visao" class="form-control"><option value="">Selecione um Tipo</option><option value="empresa">Relat\xF3rio Gerencial</option><option value="geral">Relat\xF3rio Geral</option></select></div></div><div ng-show="filtro.visao != \'geral\' &amp;&amp; filtro.visao != null" class="col-md-4"><div class="form-group text-left"><label for="agrupador">Agrupador</label><select-enum name="agrupador" id="agrupador" ng-model="filtro.agrupador" tipo="AgrupadorPerspectiva" tipo-label="agrupador" required="required"></select-enum></div></div><div ng-show="filtro.visao == \'geral\' &amp;&amp; filtro.visao != null" class="col-md-2"><div class="form-group text-left"><label for="ordenacao">Ordena\xE7\xE3o</label><select-enum name="ordenacao" id="ordenacao" ng-model="filtro.ordenacao" tipo="OrdenacaoPerspectiva" tipo-label="ordena\xE7\xE3o"></select-enum></div></div><div ng-show="filtro.visao == \'geral\' &amp;&amp; filtro.visao != null" class="col-md-2"><div class="form-group text-left"><label for="order">Ordem</label><select-order name="order" id="order" ng-model="filtro.order"></select-order></div></div><div class="col-md-3"><div class="form-group text-right"><br><button ng-click="aberto=!aberto" class="btn btn-md btn-info">Busca Avan\xE7ada</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button><modal-print ng-show="filtro.visao == \'geral\'" ng-disabled="!authService.isInRole(\'ROLE_GERENCIAL_PERSPECTIVA_[A-Z]*P[A-Z]*\')" title="\'Relat\xF3rio\'" reporttitle="Relatorio de Perspectivas" route="geral-perspectiva/?" filter="filtro" search="search"></modal-print><modal-print ng-show="filtro.agrupador!=null &amp;&amp; (filtro.visao == \'empresa\' || filtro.visao == \'consorcio\')" ng-disabled="!authService.isInRole(\'ROLE_GERENCIAL_PERSPECTIVA_[A-Z]*P[A-Z]*\')" title="\'Relat\xF3rio\'" reporttitle="Relatorio de Perspectivas" route="gerencial-perspectiva/?" filter="filtro" search="search"></modal-print></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/gerencial/orcamento-economico/orcamento-economico.html','<div class="no-js"><div ng-init="init()" ng-cloak="true"><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><div ng-show="centroDeCusto.id == null" class="col-md-4"><div class="form-group"><label for="numeroEdital">Centro de Custo</label><select-centro-custo name="centroDeCusto" ng-model="filtro.centroDeCusto" ng-change="onCentroDeCustoChange()"></select-centro-custo></div></div><div class="col-md-4"><div class="form-group"><label for="contratoExterno" class="control-label">Contrato de Cliente</label><select-contrato-externo name="contratoExterno" id="contratoExterno" ng-model="filtro.contratoExterno" ng-change="onContratoChange(filtro.contratoExterno)"></select-contrato-externo></div></div><div class="col-md-2"><div class="form-group"><label for="inicio" class="control-label">\xCDnicio</label> <input name="inicio" type="date" id="inicio" ng-model="filtro.inicio" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="fim" class="control-label">Fim</label> <input name="fim" type="date" id="fim" ng-model="filtro.fim" class="form-control text-center"></div></div></div><div class="row"><div class="col-md-2 form-group"></div><div class="col-md-10"><div class="form-group text-right"><br><button ng-click="aberto=!aberto" class="btn btn-md btn-info">Busca Avan\xE7ada</button> <button ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></div></div></div></div></div><div ng-if="resultadoEconomicoChart.data" class="row"><div ba-panel="" ba-panel-title="{{resultadoEconomicoChart.name}}" ba-panel-class="meddium-panel traffic-panel" class="col-lg-12 col-md-12 col-sm-12"><canvas id="base" chart-data="resultadoEconomicoChart.data" chart-labels="resultadoEconomicoChart.labels" chart-colors="resultadoEconomicoChart.colors" chart-dataset-override="resultadoEconomicoChart.datasetOverride" chart-options="resultadoEconomicoChart.options" height="75" class="chart chart-bar"></canvas></div></div><div ng-include="\'app/pages/gantt/gantt.html\'" ng-if="!loading" ng-controller="GanttCtrl" ng-init="activate(columns, filter.inicio, filter.inicio)"></div></div></div>');
$templateCache.put('app/pages/gerencial/planejamento-estrategico/planejamento-estrategico.html','<div class="no-js"><section class="content animated fadeIn"><div ng-cloak="true"><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div class="panel-body"><div class="form-group"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><div ng-if="tipo != \'contrato\'"><div class="row"><div class="col-md"><div class="col-md-2 form-group"><label for="inicio" class="control-label">\xCDnicio</label> <input name="inicio" type="date" id="inicio" ng-model="filtro.inicio" class="form-control text-center"></div><div class="col-md-2 form-group"><label for="fim" class="control-label">Fim</label> <input name="fim" type="date" id="fim" ng-model="filtro.fim" class="form-control text-center"></div><div class="col-md-4 form-group"><label for="numeroEdital">Centro de Custo</label><select-centro-custo name="centroDeCusto" ng-model="filtro.centroDeCusto"></select-centro-custo></div><div class="col-md-2"><div class="form-group"><label for="tipo">Tipo</label><select-enum name="tipo" ng-model="filtro.tipo" tipo="TipoContaReceber" tipo-label="Tipo"></select-enum></div></div><div class="col-md-4 form-group"><label for="funcionario">Funcion\xE1rio</label><select-funcionario type="text" name="funcionario" id="funcionario" ng-model="filtro.responsavel" watch-to="70853"></select-funcionario></div><div class="col-md-4 form-group"><label for="regiao">Regi\xE3o</label><select-enum name="regiao" id="regiao" ng-model="filtro.regiao" tipo="Regiao" tipo-label="Regi\xE3o"></select-enum></div></div></div></div><div ng-if="tipo == \'contrato\'" ng-include="\'app/pages/licitacoes/perspectivas/perspectivasSearch.html\'"></div></div><div class="row"><div class="col-md-2 form-group"><label for="tipo">Tipo</label><select id="tipo" name="tipo" ng-model="tipo" ng-click="clear()" class="form-control"><option value="">Selecione um Tipo</option><option value="contrato">Vendas</option><option value="produto">Produtos</option><option value="medicao">Receitas</option><option value="contaReceber">Recebimentos</option></select></div><div class="form-group"><div class="col-md-10"><div class="form-group text-right"><br><button ng-click="aberto=!aberto" class="btn btn-md btn-info">Busca Avan\xE7ada</button> <button ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></div></div></div></div></div><div ng-include="\'app/pages/gantt/gantt.html\'" ng-if="!loading" ng-controller="GanttCtrl" ng-init="activate(columns)"></div><div id="preloader" ng-show="loading"></div></div></div></div></section></div><net></net>');
$templateCache.put('app/pages/licitacoes/apresentadas/apresentadasSearch.html','<div><div class="row"><div class="col-md-1"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="nome" ng-model="filtro.codigo" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="numeroEdial">N\xFAmero do Edital</label> <input name="numeroEdital" ng-model="filtro.numeroEdital" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="titulo">Titulo</label> <input name="titulo" ng-model="filtro.titulo" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" ng-model="filtro.descricao" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="observacao">Observa\xE7\xE3o</label> <input name="observacao" ng-model="filtro.observacao" class="form-control"></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label for="folder">Pasta de Anexos</label> <input name="folder" ng-model="filtro.folder" type="text" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="fonteDeRecurso">Fonte de Recurso</label><select-fonte-recurso name="fonteDeRecurso" id="fonteDeRecurso" ng-model="filtro.fonteDeRecurso"></select-fonte-recurso></div></div><div class="col-md-3"><div class="form-group"><label for="cliente">Cliente</label><select-cliente name="cliente" ng-model="filtro.cliente" class="form-control"></select-cliente></div></div><div class="col-md-3"><div class="form-group"><label for="parceiro">Parceiro</label><select-parceiro name="parceiro" ng-model="filtro.parceiro" id="parceiro"></select-parceiro></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label for="pais">Pa\xEDs</label><select-pais name="pais" type="text" ng-model="filtro.pais" class="form-control"></select-pais></div></div><div class="col-md-3"><div class="form-group"><label for="estado">Estado</label><select-estado name="estado" type="text" ng-model="filtro.estado" noselectionlabel="Selecione um Estado" ng-disabled="(filtro.pais.sigla !== \'BRA\')" class="form-control"></select-estado></div></div><div class="col-md-3"><div class="form-group"><label for="regiaoAtuacao">Ger\xEAncia</label><select-regiao name="regiaoAtuacao" ng-model="filtro.regiaoAtuacao" class="form-control"></select-regiao></div></div><div class="col-md-3"><div class="form-group"><label for="regiao">Regi\xE3o</label><select-enum name="regiao" tipo="Regiao" ng-model="filtro.regiao" tipo-label="nome da Regi\xE3o" class="form-control"></select-enum></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label for="tipoServico">Tipo de Servi\xE7o</label><select-tipo-servico name="tipoServico" ng-model="filtro.tipoServico" class="form-control"></select-tipo-servico></div></div><div class="col-md-3"><div class="form-group"><label for="area">\xC1rea</label><select-area name="area" ng-model="filtro.area" class="form-control"></select-area></div></div><div class="col-md-3"><div class="form-group"><label for="subArea">Sub\xC1rea</label><select-sub-areas name="subarea" ng-model="filtro.subAreas" class="form-control"></select-sub-areas></div></div><div class="col-md-3"><div class="form-group"><label for="tipoLicitacao">Tipo de Licita\xE7\xE3o</label><select-tipo-licitacao name="tipoLicitacao" id="tipoLicitacao" ng-model="filtro.tipoLicitacao" ng-change="onTipoLicitacaoChange(perspectiva.tipoLicitacao)"></select-tipo-licitacao></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label for="responsavel">Respons\xE1vel</label><select-usuario name="reponsavel" id="responsavel" ng-model="filtro.autor"></select-usuario></div></div><div class="col-md-3"><div class="form-group"><label for="situacaoPerspectivaCodigoAnterior">Hist\xF3rico da Situa\xE7\xE3o</label><select-situacao_perspectiva-by-codigo name="situacaoPerspectivaCodigoAnterior" type="text" ng-model="filtro.situacaoPerspectivaCodigoAnterior"></select-situacao_perspectiva-by-codigo></div></div><div class="col-md-3"><div class="form-group"><label for="situacaoPerspectivaCodigo">Situa\xE7\xE3o Atual</label><select-situacao_perspectiva-by-codigo-apresentadas name="situacaoPerspectivaCodigo" type="text" ng-model="filtro.situacaoPerspectivaCodigo"></select-situacao_perspectiva-by-codigo-apresentadas></div></div><div class="col-md-3"><div class="form-group"><label for="criterioJulgamento">Motivo da Desclassifica\xE7\xE3o</label><select-criterios-julgamentos name="criterioJulgamento" ng-model="filtro.criteriosJulgamentos" class="form-control"></select-criterios-julgamentos></div></div></div><div class="row"><div class="col-md-2"><div class="form-group"><label for="valorMinimo">Valor M\xEDnimo</label> <input name="valorMinimo" ng-model="filtro.valorMinimo" type="text" mask="real" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="valorMaximo">Valor M\xE1ximo</label> <input name="valorMaximo" ng-model="filtro.valorMaximo" type="text" mask="real" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="dataInicioApresentacao">In\xEDcio da Apresenta\xE7\xE3o</label> <input type="date" name="dataInicioApresentacao" ng-model="filtro.dataInicioApresentacao" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="dataFimApresentacao">Fim da Apresenta\xE7\xE3o</label> <input type="date" name="dataFimApresentacao" ng-model="filtro.dataFimApresentacao" class="form-control"></div></div></div><div ng-show="filtro.visao == \'geral\'" class="row"><div class="col-md-1"><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showAll" ng-change="onChangueCheckbox()">Todos</label></div></div><div class="col-md-11"><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showNone" ng-change="onChangueCheckbox()">Nenhum</label></div></div><div class="col-md-4"><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showItem">Item</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showTipo">Tipo</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showDescricao">Descri\xE7\xE3o</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showArea">\xC1rea</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showGerencia">Ger\xEAncia</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showEstadoPais">Estado/Pa\xEDs</label></div></div><div class="col-md-4"><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showCliente">Cliente</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showTipoServico">Tipo de Servi\xE7o</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showParceria">Parceria</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showTipoLicitacao">Tipo de Licita\xE7\xE3o</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showDataApresentacao">Data de Apresenta\xE7\xE3o dos Documentos</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showSituacao">Situa\xE7\xE3o</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showCriteriosJulgamentos">Motivo da Desclassifica\xE7\xE3o</label></div></div><div class="col-md-4"><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showPrazoContrato">Prazo do Contrato</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showValorTotalMil">Valor Total (Mil R$)</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showPorcentagemEmpresa">% Empresa</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showValorEmpresaMil">Valor Empresa (Mil R$)</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showPorcentagemCSD">% csd</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showValorCSD">Valor csd (R$)</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showObservacoes">Observa\xE7\xF5es</label></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/parceiro/parceiro.html','<div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="parceiro">Parceiro</label><select-parceiro name="parceiro" ng-model="parceiro" id="parceiro"></select-parceiro></div></div><div class="col-md-3"><div class="form-group"><button type="button" style="margin-top:20px" ng-click="adicionarParceiro(parceiro)" ng-disabled="parceiro== null" class="btn btn-warning">Adicionar Parceiro</button></div></div></div></div><div ng-show="parceiros.length &gt; 0" class="row"><div class="col-xs-12"><div class="table-responsive"><table st-table="parceiros" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="pessoaJuridica.nomeFantasia">Parceiro</th><th st-sort="area.descricao">\xC1rea</th><th class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="parceiro in parceiros"><td>{{parceiro.pessoaJuridica.nomeFantasia}}</td><td>{{parceiro.area.descricao}}</td><td class="text-right"><button type="button" ng-click="deletarParceiro(parceiro)" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="parceiros.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/parceiro/viewparceiro.html','<h3 style="margin-top:20px;">Parceiros<hr></h3><div ng-show="parceiros.length &gt; 0" class="row"><div class="col-xs-12"><div class="table-responsive"><table st-table="parceiros" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="descricao">Parceiro</th><th st-sort="areaDescricao">\xC1rea</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="parceiro in parceiros"><td>{{parceiro.descricao}}</td><td>{{parceiro.area.descricao}}</td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="2" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="telefones.length==0"><tr><td colspan="2" class="text-center">Sem registros!</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/formperspectiva.html','<div class="panel-body"><form ng-submit="save(perspectiva)" name="form" method="post" class="form"><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" type="text" style="display: block; text-align: center;" ng-model="perspectiva.codigo" readonly="readonly" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="numeroEdital">N\xFAmero do Edital</label> <input type="text" name="numeroEdital" id="numeroEdital" ng-model="perspectiva.numeroEdital" required="required" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="folder">Pasta dos Documentos</label> <input name="folder" id="folder" type="text" ng-model="perspectiva.folder" required="required" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="tipoPerspectiva">Tipo de Perspectiva</label><select-tipo-perspectiva name="tipoPerspectiva" id="tipoPerspectiva" ng-model="perspectiva.tipoPerspectiva" required="required"></select-tipo-perspectiva></div></div><div class="col-md-12"><div class="form-group"><label for="titulo">T\xEDtulo</label> <input name="titulo" id="titulo" type="text" ng-model="perspectiva.titulo" maxlength="255" ng-maxlength="255" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="fonteDeRecurso">Fonte de Recurso</label><select-fonte-recurso name="fonteDeRecurso" id="fonteDeRecurso" ng-model="perspectiva.fonteDeRecurso" required="required"></select-fonte-recurso></div></div><div class="col-md-4"><div class="form-group"><label for="responsavel">Respons\xE1vel</label><select-usuario name="responsavel" id="responsavel" ng-model="perspectiva.autor" required="required"></select-usuario></div></div><div class="col-md-4"><div class="form-group"><label for="cliente">Cliente</label><select-cliente name="cliente" id="cliente" ng-model="perspectiva.cliente" required="required"></select-cliente></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label for="pais">Pa\xEDs</label><select-pais name="pais" id="pais" type="text" ng-model="perspectiva.pais" ng-change="zerarCidadeEstado()" required="required"></select-pais></div></div><div class="col-md-4"><div class="form-group"><label for="estado">Estado</label><select-estado name="estado" type="text" id="estado" ng-model="perspectiva.estado" noselectionlabel="Selecione um Estado" ng-disabled="!(perspectiva.pais.sigla === \'BRA\')"></select-estado></div></div><div class="col-md-4"><div class="form-group"><label for="cidade">Cidade</label><select-cidade name="cidade" id="cidade" type="text" ng-model="perspectiva.cidade" noselectionlabel="Selecione umm Cidade" watch-to="perspectiva.estado" ng-disabled="!(perspectiva.pais.sigla === \'BRA\')"></select-cidade></div></div></div><div ng-include="\'app/pages/licitacoes/parceiro/parceiro.html\'"></div><h3 style="margin-top:20px;">Descri\xE7\xE3o/Observa\xE7\xF5es<hr></h3><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label> <textarea name="descricao" id="descricao" ng-model="perspectiva.descricao" ng-maxlength="1000" maxlength="1000" required="required" class="resizable_textarea form-control"></textarea></div></div><div class="col-md-6"><div class="form-group"><label for="observacao" class="control-label">Observa\xE7\xF5es</label> <textarea name="observacao" id="observacao" ng-model="perspectiva.observacao" ng-maxlength="1000" maxlength="1000" class="resizable_textarea form-control"></textarea></div></div></div></div><h3 style="margin-top:20px">Tipo de Servi\xE7o/\xC1rea/Ger\xEAncia<hr></h3><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="tipoServicos">Tipos de Servi\xE7os</label><select-tipo-servicos name="tipoServicos" id="tipoServicos" ng-model="perspectiva.tipoServicos" required="required"></select-tipo-servicos></div></div><div class="col-md-4"><div class="form-group"><label for="area">\xC1rea</label><select-area name="area" id="area" ng-model="perspectiva.area" required="required"></select-area></div></div><div class="col-md-4"><div class="form-group"><label for="subareas">Sub\xC1reas</label><select-sub-areas name="subareas" id="subareas" ng-model="perspectiva.subAreas" required="required"></select-sub-areas></div></div><div class="col-md-4"><div class="form-group"><label for="regiaoAtuacao">Ger\xEAncia</label><select-regiao name="regiaoAtuacao" id="regiaoAtuacao" ng-model="perspectiva.regiaoAtuacao" required="required"></select-regiao></div></div><div class="col-md-4"><div class="form-group"><label for="regiao">Regi\xE3o</label><select-enum name="regiao" id="regiao" tipo="Regiao" ng-model="perspectiva.regiao" tipo-label="Regi\xE3o" required="required"></select-enum></div></div><div class="col-md-4"><div class="form-group"><label for="previsaoContratacao">Previs\xE3o de Contrata\xE7\xE3o</label> <input type="text" id="previsaoContratacao" name="previsaoContratacao" ng-model="perspectiva.previsaoContratacao" mask="mesAno" class="form-control"></div></div></div></div><h3 style="margin-top:20px">Valores/Percentuais<hr></h3><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="valorEdital" class="control-label">Valor do Edital (R$)</label> <input name="valorEdital" id="valorEdital" type="text" ng-change="onValorTotalChange()" ng-model="perspectiva.valorEdital" mask="real" required="required" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="valorTotal" class="control-label">Valor Apresentado (R$)</label> <input name="valorTotal" id="valorTotal" type="text" ng-change="onValorTotalChange()" ng-model="perspectiva.valorTotal" mask="real" required="required" class="form-control"></div></div><div class="col-md-1"><div class="form-group"><label for="percentualDesconto" class="control-label">% Desconto</label> <input name="percentualDesconto" id="percentualDesconto" ng-model="perspectiva.percentualDesconto" type="text" mask="real:false:2:0:100" value="0.00" placeholder="0.00" class="form-control"></div></div><div class="col-md-1"><div class="form-group"><label for="percentualEmpresa" class="control-label">% Empresa</label> <input name="percentualEmpresa" id="percentualEmpresa" ng-change="onCalculateValorEmpresa()" ng-model="perspectiva.percentualEmpresa" type="text" mask="real:false:2:0:100" required="required" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="valor" class="control-label">Valor da Empresa (R$)</label> <input name="valor" id="valor" type="text" ng-model="perspectiva.valor" mask="real" required="required" class="form-control"></div></div><div class="col-md-1"><div class="form-group"><label for="percentualSucesso" class="control-label">% de Sucesso</label> <input name="percentualSucesso" id="percentualSucesso" type="text" ng-change="onPercentualSucessoChange()" ng-model="perspectiva.percentualSucesso" mask="real:false:2:0:100" required="required" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="valorSucesso" class="control-label">Valor de Sucesso (R$)</label> <input name="valorSucesso" id="valorSucesso" type="text" ng-model="perspectiva.valorSucesso" mask="real" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-1"><div class="form-group"><label for="prazo">Prazo</label> <input name="prazo" id="prazo" type="text" ng-model="perspectiva.prazo" maxlength="255" ng-maxlength="255" required="required" class="form-control"></div></div><div class="col-md-1"><div class="form-group"><label for="vigencia">Vig\xEAncia</label> <input name="vigencia" id="vigencia" type="text" ng-model="perspectiva.vigencia" maxlength="255" ng-maxlength="255" required="required" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="tipoPrazo">Tipo do Prazo</label><select-enum name="tipoPrazo" id="tipoPrazo" ng-model="perspectiva.tipoPrazo" tipo="TipoPrazo" tipo-label="Tipo de Prazo" ng-change="onPrazoBlur()" required="required"></select-enum></div></div></div></div><h3 style="margin-top:20px">Tipo de Licita\xE7\xE3o/Situa\xE7\xF5es/Resultados<hr></h3><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="dataApresentacao">Data da Apresenta\xE7\xE3o</label> <input type="date" name="dataApresentacao" id="dataApresentacao" ng-model="perspectiva.dataApresentacao" required="required" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="tipoLicitacao">Tipo de Licita\xE7\xE3o</label><select-tipo-licitacao name="tipoLicitacao" id="tipoLicitacao" ng-model="perspectiva.tipoLicitacao" ng-change="onTipoLicitacaoChange(perspectiva.tipoLicitacao)" required="required"></select-tipo-licitacao></div></div><div class="col-md-3"><div class="form-group"><label for="situacaoPerspectiva">Situa\xE7\xE3o Atual</label><select name="situacaoPerspectiva" id="situacaoPerspectiva" ng-model="perspectiva.situacaoPerspectiva" ng-change="onSituacaoPerspectivaChange(perspectiva.tipoLicitacao, perspectiva.situacaoPerspectiva)" ng-disabled="perspectiva.tipoLicitacao.id == null" ng-options="situacao as situacao.senquencia+\' \'+situacao.descricao for situacao in situacoes |orderBy:\'codigo\' track by situacao.id" required="required" class="form-control"><option value="">Selecione uma Situa\xE7\xE3o</option></select></div></div><div class="col-md-2"><div class="form-group"><label for="dataHistorico">Data do Marco da Situa\xE7\xE3o</label> <input type="date" id="dataHistorico" name="dataHistorico" ng-model="perspectiva.dataHistorico" style="text-align:center" required="required" class="form-control"></div></div><div class="col-md-2"><div ng-show="perspectiva.situacaoPerspectiva.descricao === \'Contrato Assinado\'" style="margin-top:25px" class="form-group"><input type="checkbox" name="contratoGerado" id="contratoGerado" ng-model="perspectiva.contratoGerado"> <label for="contratoGerado">Contrato Gerado</label></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div ng-show="situacao.descricao != perspectiva.situacaoPerspectiva.descricao" class="form-group"><label for="observacaoHistorico" class="control-label">Observa\xE7\xF5es</label> <textarea style="height:300px;" name="observacaoHistorico" id="observacaoHistorico" ng-model="perspectiva.observacaoHistorico" class="form-control col-xs-12"></textarea></div></div><div class="row"><div class="col-md"></div></div></div></div><div ng-if="perspectiva.situacaoPerspectiva.codigo === \'PERDEMOS\'"><h3 style="margin-top:20px">Avalia\xE7\xE3o do Resultado Perdemos<hr></h3><div class="col-md-4"><div class="form-group"><label for="criteriosJulgamentos">Crit\xE9rio de Julgamento</label><select-criterios-julgamentos name="criteriosJulgamentos" id="criteriosJulgamentos" ng-model="perspectiva.criteriosJulgamentos" required="required"></select-criterios-julgamentos></div></div></div><div ng-if="perspectiva.situacaoPerspectiva.codigo === \'CONTRATO_ASSINADO\'"><h3 style="margin-top:20px">Anexos<hr></h3><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="propostaTecnica">N\xFAmero proposta t\xE9cnica</label> <input name="propostaTecnica" id="propostaTecnica" type="text" ng-model="perspectiva.propostaTecnica" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="propostaFinanceira">N\xFAmero proposta financeira</label> <input name="propostaFinanceira" id="propostaFinanceira" type="text" ng-model="perspectiva.propostaFinanceira" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="extratoDiarioOficial">N\xFAmero extrato di\xE1rio oficial</label> <input name="extratoDiarioOficial" id="extratoDiarioOficial" type="text" ng-model="perspectiva.extratoDiarioOficial" class="form-control"></div></div></div></div></div><hr><div class="text-right"><button type="button" ng-click="clear()" class="btn btn-danger mb-3">Cancelar</button> <button type="submit" ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*C[A-Z]*\')" class="btn btn-success mb-3">Salvar</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/formperspectivatabs.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"></div></div><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel" ng-show="!isLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dados Gerais" ng-click="activate()"><div class="panel-body"><div style="margin-top:20px;"><div ng-if="authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')"><div ng-include="\'app/pages/licitacoes/perspectivas/formperspectiva.html\'"></div></div><div ng-if="authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*R[A-Z]*\') &amp;&amp; !authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')"><div ng-include="\'app/pages/licitacoes/perspectivas/viewperspectivas.html\'"></div></div></div></div></uib-tab><uib-tab heading="Solicita\xE7\xF5es ao Departamento Jur\xEDdico" ng-show="perspectiva.id != null &amp;&amp; authService.isInRole(\'ROLE_SOLICITACAO_JURIDICO_[A-Z]*R[A-Z]*\')"><div style="margin-top:20px;" ng-include="\'app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/solicitacao-juridico-perspectiva.html\'" ng-if="perspectiva.id!= null" ng-controller="SolicitacaoJuridicoPerspectivaCtrl"></div></uib-tab><uib-tab heading="Concorrentes" ng-show="perspectiva.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/licitacoes/perspectivas/perspectiva-concorrente/perspectiva-concorrente.html\'" ng-if="perspectiva.id!= null" ng-controller="PerspectivaConcorrenteCtrl"></div></uib-tab><uib-tab heading="Hist\xF3rico dos Status da Licita\xE7\xE3o" ng-show="perspectiva.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/licitacoes/perspectivas/historico-perspectiva/historico-perspectiva.html\'" ng-if="perspectiva.id!= null" ng-controller="HistoricoPerspectivaCtrl"></div></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/perspectivas.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto=false" class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-if="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a type="button" ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*C[A-Z]*\')" ui-sref="licitacoes.formperspectivas" class="btn btn-warning">Adicionar</a></div></div><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="div"><form class="form"><div class="row"><div class="col-md-12"><div class="form-group"><label for="consulta">Consulta</label><select-consulta-by-usuario-and-perfil name="consulta" id="consulta" ng-model="consulta" ng-change="fillFiltro(consulta)" entidade="Perspectiva"></select-consulta-by-usuario-and-perfil></div></div></div><div ng-include="\'app/pages/licitacoes/perspectivas/perspectivasSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button ng-click="search()" class="btn btn-success">Buscar</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th style="width:50px !important;" st-sort="codigo">Codigo</th><th style="width:120px !important;" st-sort="situacaoPerspectiva.descricao">Situa\xE7\xE3o Atual</th><th style="width:150px !important;" st-sort="numeroEdital">N\xFAmero Edital</th><th st-sort="titulo">Titulo</th><th style="width:120px !important;" st-sort="cliente.pessoaJuridica.nomeFantasia">Cliente</th><th style="width:120px !important;" st-sort="tipoLicitacao">Tipo de Licita\xE7\xE3o</th><th style="width:120px !important;" st-sort="valorEdital" class="text-right">Valor do Edital</th><th style="width:155px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="perspectiva in displayed"><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.codigo}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.situacaoPerspectiva.descricao}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.numeroEdital}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.titulo}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.cliente.pessoaJuridica.nomeFantasia}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})">{{perspectiva.tipoLicitacao.descricao}}</td><td ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})" class="text-right">{{perspectiva.valorEdital | mask:"real"}}</td><td class="text-right"><div uib-dropdown="" dropdown-append-to-body="" class="btn-group"><button ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/perspectivas/modais/modalClonePerspectiva.html\', \'md\', \'Deseja fazer uma copia da Perpestiva \'+ perspectiva.numeroEdital +\' ?\', perspectiva)" data-toggle="modal" data-id="{{perspectiva.id}}" tooltip="" title="Copiar Perspectiva" data-placement="top" class="btn btn-link"><i class="ion-forward"></i></button><a ng-if="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.viewperspectivas({perspectivaId:perspectiva.id})" tooltip="" title="Visualizar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-eye-open"></span></a><a ng-if="authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ui-sref="licitacoes.formperspectivas({perspectivaId:perspectiva.id})" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Perpestiva \'+ perspectiva.numeroEdital, perspectiva)" data-toggle="modal" data-id="{{perspectiva.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="8" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="8" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="7" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/perspectivasSearch.html','<div><div class="row"><div class="col-md-1"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="nome" ng-model="filtro.codigo" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="numeroEdial">N\xFAmero do Edital</label> <input name="numeroEdital" ng-model="filtro.numeroEdital" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="titulo">Titulo</label> <input name="titulo" ng-model="filtro.titulo" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" ng-model="filtro.descricao" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="observacao">Observa\xE7\xE3o</label> <input name="observacao" ng-model="filtro.observacao" class="form-control"></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label for="folder">Pasta de Anexos</label> <input name="folder" ng-model="filtro.folder" type="text" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="fonteDeRecurso">Fonte de Recurso</label><select-fonte-recurso name="fonteDeRecurso" id="fonteDeRecurso" ng-model="filtro.fonteDeRecurso"></select-fonte-recurso></div></div><div class="col-md-3"><div class="form-group"><label for="cliente">Cliente</label><select-cliente name="cliente" ng-model="filtro.cliente" class="form-control"></select-cliente></div></div><div class="col-md-3"><div class="form-group"><label for="parceiro">Parceiro</label><select-parceiro name="parceiro" ng-model="filtro.parceiro" id="parceiro"></select-parceiro></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label for="pais">Pa\xEDs</label><select-pais name="pais" type="text" ng-model="filtro.pais" class="form-control"></select-pais></div></div><div class="col-md-3"><div class="form-group"><label for="estado">Estado</label><select-estado name="estado" type="text" ng-model="filtro.estado" noselectionlabel="Selecione um Estado" ng-disabled="(filtro.pais.sigla !== \'BRA\')" class="form-control"></select-estado></div></div><div class="col-md-3"><div class="form-group"><label for="regiaoAtuacao">Ger\xEAncia</label><select-regiao name="regiaoAtuacao" ng-model="filtro.regiaoAtuacao" class="form-control"></select-regiao></div></div><div class="col-md-3"><div class="form-group"><label for="regiao">Regi\xE3o</label><select-enum name="regiao" tipo="Regiao" ng-model="filtro.regiao" tipo-label="nome da Regi\xE3o" class="form-control"></select-enum></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label for="tipoServico">Tipo de Servi\xE7o</label><select-tipo-servico name="tipoServico" ng-model="filtro.tipoServico" class="form-control"></select-tipo-servico></div></div><div class="col-md-3"><div class="form-group"><label for="area">\xC1rea</label><select-area name="area" ng-model="filtro.area" class="form-control"></select-area></div></div><div class="col-md-3"><div class="form-group"><label for="subArea">Sub\xC1rea</label><select-sub-areas name="subarea" ng-model="filtro.subAreas" class="form-control"></select-sub-areas></div></div><div class="col-md-3"><div class="form-group"><label for="tipoLicitacao">Tipo de Licita\xE7\xE3o</label><select-tipo-licitacao name="tipoLicitacao" id="tipoLicitacao" ng-model="filtro.tipoLicitacao" ng-change="onTipoLicitacaoChange(perspectiva.tipoLicitacao)"></select-tipo-licitacao></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label for="responsavel">Respons\xE1vel</label><select-usuario name="reponsavel" id="responsavel" ng-model="filtro.autor"></select-usuario></div></div><div class="col-md-3"><div class="form-group"><label for="situacaoPerspectivaCodigoAnterior">Hist\xF3rico da Situa\xE7\xE3o</label><select-situacao_perspectiva-by-codigo name="situacaoPerspectivaCodigoAnterior" type="text" ng-model="filtro.situacaoPerspectivaCodigoAnterior"></select-situacao_perspectiva-by-codigo></div></div><div class="col-md-3"><div class="form-group"><label for="situacaoPerspectivaCodigo">Situa\xE7\xE3o Atual</label><select-situacao_perspectiva-by-codigo name="situacaoPerspectivaCodigo" type="text" ng-model="filtro.situacaoPerspectivaCodigo"></select-situacao_perspectiva-by-codigo></div></div><div class="col-md-3"><div class="form-group"><label for="criterioJulgamento">Motivo da Desclassifica\xE7\xE3o</label><select-criterios-julgamentos name="criterioJulgamento" ng-model="filtro.criteriosJulgamentos" class="form-control"></select-criterios-julgamentos></div></div></div><div class="row"><div class="col-md-2"><div class="form-group"><label for="valorMinimo">Valor M\xEDnimo</label> <input name="valorMinimo" ng-model="filtro.valorMinimo" type="text" mask="real" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="valorMaximo">Valor M\xE1ximo</label> <input name="valorMaximo" ng-model="filtro.valorMaximo" type="text" mask="real" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="dataInicioApresentacao">In\xEDcio da Apresenta\xE7\xE3o</label> <input type="date" name="dataInicioApresentacao" ng-model="filtro.dataInicioApresentacao" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="dataFimApresentacao">Fim da Apresenta\xE7\xE3o</label> <input type="date" name="dataFimApresentacao" ng-model="filtro.dataFimApresentacao" class="form-control"></div></div></div><div ng-show="filtro.visao == \'geral\'" class="row"><div class="col-md-1"><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showAll" ng-change="onChangueCheckbox()">Todos</label></div></div><div class="col-md-11"><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showNone" ng-change="onChangueCheckbox()">Nenhum</label></div></div><div class="col-md-4"><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showItem">Item</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showTipo">Tipo</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showDescricao">Descri\xE7\xE3o</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showArea">\xC1rea</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showGerencia">Ger\xEAncia</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showEstadoPais">Estado/Pa\xEDs</label></div></div><div class="col-md-4"><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showCliente">Cliente</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showTipoServico">Tipo de Servi\xE7o</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showParceria">Parceria</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showTipoLicitacao">Tipo de Licita\xE7\xE3o</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showDataApresentacao">Data de Apresenta\xE7\xE3o dos Documentos</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showSituacao">Situa\xE7\xE3o</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showCriteriosJulgamentos">Motivo da Desclassifica\xE7\xE3o</label></div></div><div class="col-md-4"><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showPrazoContrato">Prazo do Contrato</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showValorTotalMil">Valor Total (Mil R$)</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showPorcentagemEmpresa">% Empresa</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showValorEmpresaMil">Valor Empresa (Mil R$)</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showPorcentagemCSD">% csd</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showValorCSD">Valor csd (R$)</label></div><div class="checkbox"><label><input type="checkbox" ng-model="filtro.showObservacoes">Observa\xE7\xF5es</label></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/viewperspectivas.html','<div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>C\xF3digo</h4><p>{{perspectiva.codigo}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>N\xFAmero Edital</h4><p>{{perspectiva.numeroEdital}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Pasta dos Documentos</h4><p>{{perspectiva.folder}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Tipo de Perspectiva</h4><p>{{perspectiva.tipoPerspectiva.descricao}}</p></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><h4>T\xEDtulo</h4><p>{{perspectiva.titulo}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Fonte de Recurso</h4><p>{{perspectiva.fonteDeRecurso.nome}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Respons\xE1vel</h4><p>{{perspectiva.autor.pessoaFisica.pessoa.nome}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Cliente</h4><p>{{perspectiva.cliente.pessoaJuridica.pessoa.nome}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Pa\xEDs</h4><p>{{perspectiva.pais.nome}}</p></div></div><div ng-show="perspectiva.estado != null" class="col-md-4"><div class="form-group"><h4>Estado</h4><p>{{perspectiva.estado}}</p></div></div><div ng-show="perspectiva.cidades != null" class="col-md-4"><div class="form-group"><h4>Cidade</h4><p>{{perspectiva.cidade}}</p></div></div></div></div><div ng-include="\'app/pages/licitacoes/parceiro/viewparceiro.html\'"></div><h3 style="margin-top:20px;">Descri\xE7\xE3o/Observa\xE7\xF5es<hr></h3><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><h4>Descri\xE7\xE3o</h4><p>{{perspectiva.descricao}}</p></div></div><div class="col-md-6"><div class="form-group"><h4>Observa\xE7\xF5es</h4><p>{{perspectiva.observacao}}</p></div></div></div></div><h3 style="margin-top:20px;">Tipo de Servi\xE7o/\xC1rea/Ger\xEAncia<hr></h3><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><h4>\xC1rea</h4><p>{{perspectiva.area.descricao}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Ger\xEAncia</h4><p>{{perspectiva.regiaoAtuacao.descricao}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Regi\xE3o</h4><p>{{perspectiva.regiao.descricao}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Previs\xE3o de Contrata\xE7\xE3o</h4><p>{{perspectiva.previsaoContratacao}}</p></div></div></div></div><h3 style="margin-top:20px">Valores/Percentuais<hr></h3><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>Valor Edital (R$)</h4><p>{{perspectiva.valorEdital}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Valor Total (R$)</h4><p>{{perspectiva.valorTotal}}</p></div></div><div class="col-md-1"><div class="form-group"><h4>Desconto (%)</h4><p>{{perspectiva.desconto}}</p></div></div><div class="col-md-1"><div class="form-group"><h4>% Empresa</h4><p>{{perspectiva.percentualEmpresa}}\'</p></div></div><div class="col-md-2"><div class="form-group"><h4>Valor da Empresa (R$)</h4><p>{{perspectiva.valor}}</p></div></div><div class="col-md-1"><div class="form-group"><h4>% de Sucesso</h4><p>{{perspectiva.percentualSucesso}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Valor de Sucesso (R$)</h4><p>{{perspectiva.valorSucesso}}</p></div></div></div></div><h3 style="margin-top:20px">Tipo de Licita\xE7\xE3o/Situa\xE7\xF5es/Resultados<hr></h3><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>Data da Apresenta\xE7\xE3o</h4><p>{{perspectiva.dataApresentacao | date:"dd/MM/y"}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Tipo de Licita\xE7\xE3o</h4><p>{{perspectiva.tipoLicitacao.descricao}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Situa\xE7\xE3o Atual</h4><p>{{perspectiva.situacaoPerspectiva.descricao}}</p></div></div></div></div><div class="text-right"><buttom type="button" ng-click="clear()" class="btn btn-danger">Voltar</buttom></div></div>');
$templateCache.put('app/pages/qualidade/acoes/acao.html','<div class="panel-body"><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button> <button ng-click="open(\'app/pages/qualidade/acoes/formacao.html\', \'lg\', \'Nova A\xE7\xE3o\', acao)" tooltip="" title="Nova A\xE7\xE3o" data-placement="top" class="btn btn-warning">Adicionar</button></div></div><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><form class="form"><div ng-include="\'app/pages/qualidade/acoes/acaoSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="status" class="text-center">Status</th><th st-sort="codigo" class="text-center">C\xF3digo</th><th style="padding-right:100px;" st-sort="descricao">Descri\xE7\xE3o</th><th st-sort="inicio" class="text-center">Inicio</th><th st-sort="prazo" class="text-center">Prazo</th><th st-sort="fim" class="text-center">Fim</th><th st-sort="responsavel.pessoaFisica.pessoa.nome">Respons\xE1vel</th><th style="width:155px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="acao in displayed"><td class="text-center"><button class="btn btn-xs {{acao.status.color}}">{{acao.status.descricao}}</button></td><td class="text-center">{{acao.codigo}}</td><td>{{acao.descricao}}</td><td class="text-center">{{acao.inicio | date:\'dd/MM/yyyy\'}}</td><td class="text-center">{{acao.prazo | date:\'dd/MM/yyyy\'}}</td><td class="text-center">{{acao.fim | date:\'dd/MM/yyyy\'}}</td><td>{{acao.responsavel.pessoaFisica.pessoa.nome}}</td><td class="text-right"><button ng-click="open(\'app/pages/qualidade/acoes/formacao.html\', \'lg\', \'A\xE7\xE3o\', acao)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Risco \'+ acao.descricao, acao)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="8" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="8" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="7" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/qualidade/acoes/acaoSearch.html','<div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" type="text" ng-model="filtro.descricao" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="responsavel">Respons\xE1vel</label><select-funcionario id="responsavel" name="responsavel" ng-model="filtro.responsavel"></select-funcionario></div></div></div></div></div>');
$templateCache.put('app/pages/qualidade/acoes/formacao.html','<div class="panel panel-default bootstrap-panel"><div class="panel-body"><form ng-submit="save(acao)" name="form" method="POST" class="form"><div class="row"><div class="col-md-2"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" type="codigo" ng-model="acao.codigo" required="required" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="inicio" class="control-label">Inicio</label> <input name="inicio" type="date" id="inicio" ng-model="acao.inicio" required="required" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="prazo" class="control-label">Prazo</label> <input name="prazo" type="date" id="prazo" ng-model="acao.prazo" required="required" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="fim" class="control-label">Fim</label> <input name="fim" type="date" id="fim" ng-model="acao.fim" class="form-control text-center"></div></div><div class="col-md-1"><label for="eficaz">Eficaz</label> <input type="checkbox" name="eficaz" id="eficaz" value="Eficaz" ng-model="acao.eficaz"></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="responsavel">Respons\xE1vel</label><select-funcionario id="responsavel" name="responsavel" ng-model="acao.responsavel" required="required"></select-funcionario></div></div><div class="col-md-6"><div class="form-group"><label for="statusAcao">Status</label><select-enum id="statusAcao" name="statusAcao" ng-model="acao.status" tipo="StatusAcao" tipo-label="Status" required="required"></select-enum></div></div><div class="col-md-12"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <textarea name="descricao" id="descricao" type="text" ng-model="acao.descricao" required="required" class="form-control"></textarea></div></div><div class="col-md-12"><div class="form-group"><label for="observacao">Observa\xE7\xE3o</label> <textarea name="observacao" id="observacao" type="text" ng-model="acao.observacao" class="form-control"></textarea></div></div><div class="col-md-12"><div class="form-group"><label for="eficacia">Descri\xE7\xE3o da Efic\xE1cia</label> <textarea name="eficacia" id="eficacia" type="text" ng-model="acao.eficacia" class="form-control"></textarea></div></div></div><div class="text-right"><button type="button" ng-click="clear()" style="margin-top: 10px;" class="btn btn-danger">Cancelar</button> <button type="submit" value="Salvar" style="margin-top: 10px;" class="btn btn-success">Salvar</button></div></form></div></div>');
$templateCache.put('app/pages/qualidade/avancos/avanco.html','<div class="panel-body"><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button ng-click="open(\'app/pages/qualidade/avancos/formavanco.html\', \'lg\', \'Nova Avan\xE7o\', avanco)" tooltip="" title="Nova Avan\xE7o" data-placement="top" class="btn btn-warning">Adicionar</button></div></div><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="well"><form class="form"><div ng-include="\'app/pages/qualidade/avancos/avancoSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="submit" ng-click="search()" class="btn btn-success">Buscar</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="data">Data</th><th st-sort="valor" class="text-right">Valor</th><th style="width:155px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="avanco in displayed"><td>{{avanco.data | date:\'dd/MM/yyyy\'}}</td><td class="text-right">{{avanco.valor}}</td><td class="text-right"><button ng-click="open(\'app/pages/qualidade/avancos/formavanco.html\', \'lg\', \'Avan\xE7o\', avanco)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Avan\xE7o \'+ avanco.descricao, avanco)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/qualidade/avancos/avancoSearch.html','<div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" type="text" ng-model="filtro.descricao" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="codigo">Codigos</label> <input name="codigo" id="codigo" type="codigo" ng-model="filtro.codigo" class="form-control text-center"></div></div><div class="col-md-4"><div class="form-group"><label for="responsavel">Respons\xE1vel</label><select-funcionario id="responsavel" name="responsavel" ng-model="filtro.responsavel"></select-funcionario></div></div></div></div></div>');
$templateCache.put('app/pages/qualidade/avancos/formavanco.html','<div class="panel panel-default bootstrap-panel"><div class="panel-body"><form ng-submit="save(avanco)" name="form" method="POST" class="form"><div class="row"><div class="col-md-6"><div class="form-group"><label for="data" class="control-label">Data</label> <input name="data" type="date" id="data" ng-model="avanco.data" required="required" class="form-control text-center"></div></div><div class="col-md-6"><div class="form-group"><label for="valor">Valor</label> <input name="valor" id="valor" type="text" ng-model="avanco.valor" required="required" class="form-control"></div></div></div><div class="text-right"><button type="button" ng-click="clear()" style="margin-top: 10px;" class="btn btn-danger">Cancelar</button> <button type="submit" value="Salvar" style="margin-top: 10px;" class="btn btn-success">Salvar</button></div></form></div></div>');
$templateCache.put('app/pages/qualidade/dashboardIndicadores/dashboardIndicador.html','<div class="panel-body"><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button ng-click="open(\'app/pages/qualidade/dashboardIndicadores/formdashboardIndicador.html\', \'lg\', \'Nova Dashboard\', dashboardIndicador)" tooltip="" title="Nova Dashboard" data-placement="top" class="btn btn-warning">Adicionar</button></div></div><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="well"><form class="form"><div ng-include="\'app/pages/cadastrosbasicos/dashboardIndicadors/dashboardIndicadorSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="ordem">Ordem</th><th st-sort="tipoGrafico">Tipo de Gr\xE1fico</th><th st-sort="indicador">Indicador</th><th style="width:155px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="dashboardIndicador in displayed"><td>{{dashboardIndicador.ordem}}</td><td>{{dashboardIndicador.tipoGrafico}}</td><td>{{dashboardIndicador.indicador.descricao}}</td><td class="text-right"><button ng-click="open(\'app/pages/qualidade/dashboardIndicadores/formdashboardIndicador.html\', \'lg\', \'Dashboard\', dashboardIndicador)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Dashboard \'+ dashboardIndicador.descricao, dashboardIndicador)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="4" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="3" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/qualidade/dashboardIndicadores/dashboardIndicadorSearch.html','<div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" type="text" ng-model="filtro.descricao" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="codigo">Codigos</label> <input name="codigo" id="codigo" type="codigo" ng-model="filtro.codigo" class="form-control text-center"></div></div><div class="col-md-4"><div class="form-group"><label for="responsavel">Respons\xE1vel</label><select-funcionario id="responsavel" name="responsavel" ng-model="filtro.responsavel" watch-to="70853"></select-funcionario></div></div></div></div></div>');
$templateCache.put('app/pages/qualidade/dashboardIndicadores/formdashboardIndicador.html','<div class="panel panel-default bootstrap-panel"><div class="panel-body"><form ng-submit="save(dashboardIndicador)" name="form" method="POST" class="form"><div class="row"><div class="col-md-2"><div class="form-group"><label for="ordem">Ordem</label> <input name="ordem" id="ordem" type="number" ng-model="dashboardIndicador.ordem" required="required" class="form-control text-center"></div></div><div class="col-md-4"><div class="form-group"><label for="tipoGrafico">Tipo Gr\xE1fico</label> <input name="tipoGrafico" id="tipoGrafico" type="text" ng-model="dashboardIndicador.tipoGrafico" required="required" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="indicador">Indicador</label><select-indicador id="indicador" name="indicador" ng-model="dashboardIndicador.indicador"></select-indicador></div></div></div><div class="text-right"><button type="button" ng-click="clear()" style="margin-top: 10px;" class="btn btn-danger">Cancelar</button> <button type="submit" value="Salvar" style="margin-top: 10px;" class="btn btn-success">Salvar</button></div></form></div></div>');
$templateCache.put('app/pages/qualidade/dashboards/dashboard.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><form class="form"><div ng-include="\'app/pages/qualidade/dashboards/dashboardSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="submit" ng-click="search()" class="btn btn-success">Buscar</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button></div></div></form></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ng-disabled="!authService.isInRole(\'ROLE_DASHBOARD_[A-Z]*C[A-Z]*\')" ui-sref="cadastrosbasicos.dashboard" class="btn btn-warning">Adicionar</a></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="ordem">Ordem</th><th style="padding-right:100px;" st-sort="nome">Nome</th><th st-sort="tipo" class="text-center">Tipo</th><th st-sort="perfil" class="text-center">Pefil</th><th style="width:155px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="dashboard in displayed"><td>{{dashboard.ordem}}</td><td class="ellipsis">{{dashboard.nome}}</td><td class="text-center">{{dashboard.tipo }}</td><td class="text-center">{{dashboard.perfil.descricao }}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_DASHBOARD_[A-Z]*U[A-Z]*\')" ui-sref="cadastrosbasicos.dashboard({ dashboardId: dashboard.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_DASHBOARD_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Dashboard \'+ dashboard.nome, dashboard)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="5" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="4" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/qualidade/dashboards/dashboardSearch.html','<div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" type="codigo" ng-model="filtro.codigo" class="form-control text-center"></div></div><div class="col-md-6"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" type="text" ng-model="filtro.descricao" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="departamento">Departamento</label><select-departamento id="departamento" name="departamento" ng-model="filtro.departamento"></select-departamento></div></div></div></div></div>');
$templateCache.put('app/pages/qualidade/dashboards/formdashboard.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div></div><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel" ng-show="!isLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dados Gerais" ng-click="activate()"><div class="panel-body"><div style="margin-top:20px;" ng-include="\'app/pages/qualidade/dashboards/formdashboardinicial.html\'"></div></div></uib-tab><uib-tab heading="Indicadores" ng-show="dashboard.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/qualidade/dashboardIndicadores/dashboardIndicador.html\'" ng-if="dashboard" ng-controller="DashboardIndicadorCtrl"></div></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/pages/qualidade/dashboards/formdashboardinicial.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel-body"><form ng-submit="save(dashboard)" name="form" method="POST" class="form"><div class="row"><div class="col-md-2"><div class="form-group"><label for="ordem">Ordem</label> <input name="ordem" id="ordem" type="number" ng-model="dashboard.ordem" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="tipo">Tipo</label> <input name="tipo" id="tipo" type="tipo" ng-model="dashboard.tipo" class="form-control text-center"></div></div><div class="col-md-8"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="dashboard.nome" required="required" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="perfil">Perfil</label><select-perfil id="perfil" name="perfil" ng-model="dashboard.perfil"></select-perfil></div></div></div><div class="text-right"><button type="button" ng-click="close()" style="margin-top: 10px;" class="btn btn-danger">Cancelar</button> <button type="submit" value="Salvar" style="margin-top: 10px;" class="btn btn-success">Salvar</button></div></form></div></div></div></div>');
$templateCache.put('app/pages/qualidade/indicadores/formindicador.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div></div><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel" ng-show="!isLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dados Gerais" ng-click="activate()"><div class="panel-body"><div style="margin-top:20px;" ng-include="\'app/pages/qualidade/indicadores/formindicadorinicial.html\'"></div></div></uib-tab><uib-tab heading="Avan\xE7os" ng-show="indicador.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/qualidade/avancos/avanco.html\'" ng-if="indicador" ng-controller="AvancoCtrl"></div></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/pages/qualidade/indicadores/formindicadorinicial.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel-body"><form ng-submit="save(indicador)" name="form" method="POST" class="form"><div class="row"><div class="col-md-2"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" type="codigo" ng-model="indicador.codigo" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="peso">Peso</label> <input name="pedo" id="peso" type="number" ng-model="indicador.peso" required="required" class="form-control text-center"></div></div><div class="col-md-8"><div class="form-group"><label for="descricao">Descricao</label> <input name="descricao" id="descricao" type="text" ng-model="indicador.descricao" required="required" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="departamento">Departamento</label><select-departamento id="departamento" name="departamento" ng-model="indicador.departamento" required="required"></select-departamento></div></div><div class="col-md-6"><div class="form-group"><label for="contratoExterno">Contrato de Cliente</label><select-contrato-externo id="contratoExterno" name="contratoExterno" ng-model="indicador.contratoExterno"></select-contrato-externo></div></div><div class="col-md-6"><div class="form-group"><label for="categoria">Periodicidade</label><select-enum name="categoria" id="categoria" ng-model="indicador.categoria" tipo="CategoriaIndicador" tipo-label="Categoria do Indicador" required="required"></select-enum></div></div><div class="col-md-6"><div class="form-group"><label for="kpi">Kpi</label><select-kpi id="kpi" name="kpi" ng-model="indicador.kpi"></select-kpi></div></div><div class="col-md-3"><div class="form-group"><label for="inicio" class="control-label">Inicio</label> <input name="inicio" type="date" id="inicio" ng-model="indicador.inicio" required="required" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="fim" class="control-label">Fim</label> <input name="fim" type="date" id="fim" ng-model="indicador.fim" required="required" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="linhaBase">Linha base</label> <input name="linhaBase" id="linhaBase" type="number" ng-model="indicador.linhaBase" required="required" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="meta">Meta</label> <input name="meta" id="meta" type="number" ng-model="indicador.meta" required="required" class="form-control text-center"></div></div><div class="col-md-12"><div class="form-group"><label for="objetivo">Objetivo</label> <textarea name="objetivo" id="objetivo" type="text" ng-model="indicador.objetivo" required="required" class="form-control"></textarea></div></div><div class="col-md-12"><div class="form-group"><label for="observacao">Observa\xE7\xF5es</label> <textarea name="observacao" id="observacao" type="text" ng-model="indicador.observacao" class="form-control"></textarea></div></div></div><div class="text-right"><button type="button" ng-click="close()" style="margin-top: 10px;" class="btn btn-danger">Cancelar</button> <button type="submit" value="Salvar" style="margin-top: 10px;" class="btn btn-success">Salvar</button></div></form></div></div></div></div>');
$templateCache.put('app/pages/qualidade/indicadores/indicador.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><form class="form"><div ng-include="\'app/pages/qualidade/indicadores/indicadorSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ng-disabled="!authService.isInRole(\'ROLE_INDICADOR_[A-Z]*C[A-Z]*\')" ui-sref="cadastrosbasicos.indicador" class="btn btn-warning">Adicionar</a></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="codigo" class="text-center">C\xF3digo</th><th style="padding-right:100px;" st-sort="descricao">Descri\xE7\xE3o</th><th st-sort="linhaBase" class="text-center">Linha Base</th><th st-sort="meta" class="text-center">Meta</th><th st-sort="inicio" class="text-center">Inicio</th><th st-sort="fim" class="text-center">Fim</th><th st-sort="peso" class="text-center">Peso</th><th st-sort="kpi" class="text-center">Kpi</th><th style="width:155px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="indicador in displayed"><td class="text-center">{{indicador.codigo}}</td><td class="ellipsis">{{indicador.descricao}}</td><td class="text-center">{{indicador.linhaBase }}</td><td class="text-center">{{indicador.meta }}</td><td class="text-center">{{indicador.inicio | date:\'dd/MM/yyyy\'}}</td><td class="text-center">{{indicador.fim | date:\'dd/MM/yyyy\'}}</td><td class="text-center ellipsis">{{indicador.peso}}</td><td class="text-center ellipsis">{{indicador.kpi.descricao}}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_INDICADOR_[A-Z]*U[A-Z]*\')" ui-sref="cadastrosbasicos.indicador({ indicadorId: indicador.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_INDICADOR_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Indicador \'+ indicador.causa, indicador)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="9" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="9" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="8" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/qualidade/indicadores/indicadorSearch.html','<div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" type="codigo" ng-model="filtro.codigo" class="form-control text-center"></div></div><div class="col-md-6"><div class="form-group"><label for="descricao">Causa</label> <input name="descricao" id="descricao" type="text" ng-model="filtro.descricao" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="departamento">Departamento</label><select-departamento id="departamento" name="departamento" ng-model="filtro.departamento"></select-departamento></div></div></div></div></div>');
$templateCache.put('app/pages/qualidade/kpi/form-kpi.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(kpi)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="kpi.descricao" required="required" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="unidadeMedida">Unidade de Medida</label><select-unidade-medida id="unidadeMedida" name="unidadeMedida" ng-model="kpi.unidadeMedida" required="required"></select-unidade-medida></div></div><div class="col-md-6"><div class="form-group"><label for="frequencia">Frequ\xEAncia</label><select-enum name="frequencia" id="frequencia" ng-model="kpi.frequencia" tipo="FrequenciaKpi" tipo-label="Frequ\xEAncia" required="required"></select-enum></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/qualidade/kpi/kpi.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_KPI_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/qualidade/kpi/form-kpi.html\', \'md\', \'KPI\', kpi)" tooltip="" title="Nova KPI" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="frequencia">Frequ\xEAncia</th><th st-sort="descricao">Descricao</th><th st-sort="unidadeMedida">Unidade de Medida</th><th style="width:120px !important; padding-right: 20px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="kpi in displayed"><td class="ellipsis">{{kpi.frequencia.descricao}}</td><td class="ellipsis">{{kpi.descricao}}</td><td class="ellipsis">{{kpi.unidadeMedida.descricao}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_KPI_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/qualidade/kpi/form-kpi.html\', \'md\', \'KPI\', kpi)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_KPI_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'lg\', \'KPI \'+ kpi.descricao, kpi)" data-toggle="modal" data-id="{{kpi.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="4" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="3" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/qualidade/nao-conformidade/formnaoconformidade.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div></div><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel" ng-show="!isLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dados Gerais" ng-click="activate()"><div class="panel-body"><div style="margin-top:20px;" ng-include="\'app/pages/qualidade/nao-conformidade/formnaoconformidadeinicial.html\'"></div></div></uib-tab><uib-tab heading="A\xE7\xF5es" ng-show="naoConformidade.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/qualidade/acoes/acao.html\'" ng-if="naoConformidade" ng-controller="AcaoCtrl"></div></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/pages/qualidade/nao-conformidade/formnaoconformidadeinicial.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel-body"><form ng-submit="save(naoConformidade)" name="form" method="POST" class="form"><div class="row"><div class="col-md-3"><div class="form-group"><label for="numero">N\xFAmero</label> <input name="numero" id="numero" type="numero" ng-model="naoConformidade.numero" required="required" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="departamento">\xC1rea</label><select-departamento id="departamento" name="departamento" ng-model="naoConformidade.departamento" required="required"></select-departamento></div></div><div class="col-md-3"><div class="form-group"><label for="contratoExterno">Contrato de Cliente</label><select-contrato-externo id="contratoExterno" name="contratoExterno" ng-model="naoConformidade.contratoExterno"></select-contrato-externo></div></div><div class="col-md-3"><div class="form-group"><label for="tipoNaoConformidade">Tipo</label><select-enum name="tipoNaoConformidade" id="tipoNaoConformidade" ng-model="naoConformidade.tipoNaoConformidade" tipo="TipoNaoConformidade" tipo-label="Tipo" required="required"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="categoriaNaoConformidade">Origem</label><select-enum name="categoriaNaoConformidade" id="categoriaNaoConformidade" ng-model="naoConformidade.categoriaNaoConformidade" tipo="CategoriaNaoConformidade" tipo-label="Categoria" required="required"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="statusNaoConformidade">Status</label><select-enum name="statusNaoConformidade" id="statusNaoConformidade" ng-model="naoConformidade.statusNaoConformidade" tipo="StatusNaoConformidade" tipo-label="Status" required="required"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="solicitacao" class="control-label">Data de Abertura</label> <input name="solicitacao" type="date" id="solicitacao" ng-model="naoConformidade.solicitacao" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="prazo" class="control-label">Prazo</label> <input name="prazo" type="date" id="prazo" ng-model="naoConformidade.prazo" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="atendimento" class="control-label">Atendimento</label> <input name="atendimento" type="date" id="atendimento" ng-model="naoConformidade.atendimento" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="fechamento" class="control-label">Fechamento</label> <input name="fechamento" type="date" id="fechamento" ng-model="naoConformidade.fechamento" class="form-control text-center"></div></div><div class="col-md-12"><div class="form-group"><label for="descricao">Descricao</label> <textarea name="descricao" id="descricao" type="text" ng-model="naoConformidade.descricao" required="required" class="form-control"></textarea></div></div><div class="col-md-12"><div class="form-group"><label for="causaRaiz">Causa Raiz</label> <textarea name="causaRaiz" id="causaRaiz" type="text" ng-model="naoConformidade.causaRaiz" required="required" class="form-control"></textarea></div></div><div class="col-md-12"><div class="form-group"><label for="impacto">Impacto</label> <textarea name="impacto" id="impacto" type="text" ng-model="naoConformidade.impacto" class="form-control"></textarea></div></div><div class="col-md-12"><div class="form-group"><label for="diretrizes">Diretrizes</label> <textarea name="diretrizes" id="diretrizes" type="text" ng-model="naoConformidade.diretrizes" class="form-control"></textarea></div></div><div class="col-md-6"><div class="form-group"><label for="responsavel">Respons\xE1vel</label><select-funcionario id="responsavel" name="responsavel" ng-model="naoConformidade.responsavel" required="required"></select-funcionario></div></div><div class="col-md-6"><div class="form-group"><label for="revisor">Emissor</label><select-funcionario id="revisor" name="revisor" ng-model="naoConformidade.revisor" required="required"></select-funcionario></div></div></div><div class="text-right"><button type="button" ng-click="close()" style="margin-top: 10px;" class="btn btn-danger">Cancelar</button> <button type="submit" value="Salvar" style="margin-top: 10px;" class="btn btn-success">Salvar</button></div></form></div></div></div></div>');
$templateCache.put('app/pages/qualidade/nao-conformidade/naoConformidadeSearch.html','<div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="numero">Numero</label> <input name="numero" id="numero" type="numero" ng-model="filtro.numero" class="form-control text-center"></div></div><div class="col-md-6"><div class="form-group"><label for="descricao">Causa</label> <input name="descricao" id="descricao" type="text" ng-model="filtro.descricao" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="departamento">Departamento</label><select-departamento id="departamento" name="departamento" ng-model="filtro.departamento"></select-departamento></div></div></div></div></div>');
$templateCache.put('app/pages/qualidade/nao-conformidade/naoconformidade.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ui-sref="cadastrosbasicos.naoconformidade" class="btn btn-warning">Adicionar</a></div></div><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="div"><form class="form"><div ng-include="\'app/pages/qualidade/nao-conformidade/naoConformidadeSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="submit" ng-click="search()" class="btn btn-success">Buscar</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="statusNaoConformidade" style="width:100px !important;" class="text-center">Status</th><th st-sort="numero" style="width:50px !important;" class="text-center">Numero</th><th st-sort="solicitacao" style="width:50px !important;" class="text-center">Abertura</th><th st-sort="prazo" style="width:50px !important;" class="text-center">Prazo</th><th st-sort="atendimento" style="width:50px !important;" class="text-center">Atendimento</th><th st-sort="fechamento" style="width:50px !important;" class="text-center">Fechamento</th><th st-sort="tipoNaoConformidade" class="text-center hide-column-5">Tipo</th><th st-sort="categoriaNaoConformidade" class="text-center hide-column-5">Origem</th><th st-sort="responsavel.pessoaFisica.pessoa.nome" class="text-center hide-column-5">Respons\xE1vel</th><th st-sort="departamento.nome" style="width:50px !important;" class="text-center">\xC1rea</th><th style="width:155px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="naoConformidade in displayed"><td class="text-center"><button class="btn btn-xs {{naoConformidade.statusNaoConformidade.color}}">{{naoConformidade.statusNaoConformidade.descricao}}</button></td><td class="text-center">{{naoConformidade.numero}}</td><td class="text-center">{{naoConformidade.solicitacao | date:\'dd/MM/yyyy\'}}</td><td class="text-center">{{naoConformidade.prazo | date:\'dd/MM/yyyy\'}}</td><td class="text-center">{{naoConformidade.atendimento | date:\'dd/MM/yyyy\'}}</td><td class="text-center">{{naoConformidade.fechamento | date:\'dd/MM/yyyy\'}}</td><td class="text-center hide-column-5">{{naoConformidade.tipoNaoConformidade.descricao}}</td><td class="text-center hide-column-5">{{naoConformidade.categoriaNaoConformidade.descricao}}</td><td class="text-center hide-column-5">{{naoConformidade.responsavel.pessoaFisica.pessoa.nome}}</td><td class="text-center">{{naoConformidade.departamento.nome}}</td><td class="text-right"><a ui-sref="cadastrosbasicos.naoconformidade({ naoConformidadeId: naoConformidade.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'N\xE3o Conformidade \'+ naoConformidade.causa, naoConformidade)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="11" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="11" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td><td st-pagination="" st-items-by-page="itemsByPage" class="text-center"></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/qualidade/unidade-medida/form-unidade-medida.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(unidadeMedida)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="sigla">Sigla</label> <input name="nome" id="nome" type="text" ng-model="unidadeMedida.sigla" required="required" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="nome" id="nome" type="text" ng-model="unidadeMedida.descricao" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/qualidade/unidade-medida/unidade-medida.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_CARGO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/qualidade/unidade-medida/form-unidade-medida.html\', \'md\', \'Unidade de Medida\', unidadeMedida)" tooltip="" title="Novo Unidade de Medida" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="sigla">Sigla</th><th st-sort="descricao">Descri\xE7\xE3o</th><th style="width:120px !important; padding-right: 20px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="unidadeMedida in displayed"><td class="ellipsis">{{unidadeMedida.sigla}}</td><td class="ellipsis">{{unidadeMedida.descricao}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_CARGO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/qualidade/unidade-medida/form-unidade-medida.html\', \'md\', \'Unidade de Medida\', unidadeMedida)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_CARGO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'lg\', \'A Unidade de Medida \'+ unidadeMedida.sigla, unidadeMedida)" data-toggle="modal" data-id="{{unidadeMedida.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/qualidade/riscos/formrisco.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div></div><div class="col-md-12"><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel" ng-show="!isLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Dados Gerais" ng-click="activate()"><div class="panel-body"><div style="margin-top:20px;" ng-include="\'app/pages/qualidade/riscos/formriscoinicial.html\'"></div></div></uib-tab><uib-tab heading="A\xE7\xF5es" ng-show="risco.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/qualidade/acoes/acao.html\'" ng-if="risco" ng-controller="AcaoCtrl"></div></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/pages/qualidade/riscos/formriscoinicial.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel-body"><form ng-submit="save(risco)" name="form" method="POST" class="form"><div class="row"><div class="col-md-1"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" type="codigo" ng-model="risco.codigo" required="required" class="form-control text-center"></div></div><div class="col-md-1"><div class="form-group"><label for="probabilidade">Probabilidade</label> <input name="probabilidade" id="probabilidade" type="number" ng-model="risco.probabilidade" required="required" class="form-control text-center"></div></div><div class="col-md-1"><div class="form-group"><label for="impacto">Impacto</label> <input name="impacto" id="impacto" type="number" ng-model="risco.impacto" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="gravidade">Grau</label><select-enum name="gravidade" id="gravidade" ng-model="risco.gravidade" tipo="Gravidade" tipo-label="Gravidade" required="required"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="tipoNaoConformidade">Tipo</label><select-enum name="tipoNaoConformidade" id="tipoNaoConformidade" ng-model="risco.tipoNaoConformidade" tipo="TipoNaoConformidade" tipo-label="Tipo" required="required"></select-enum></div></div><div class="col-md-2"><div class="form-group"><label for="tipoRisco">Evento</label><select-enum name="tipoRisco" id="tipoRisco" ng-model="risco.tipoRisco" tipo="TipoRisco" tipo-label="Tipo de Risco" required="required"></select-enum></div></div><div class="col-md-1"><label for="continuo">Continuo</label> <input type="checkbox" name="continuo" id="continuo" value="Continuo" ng-model="risco.continuo"></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label for="departamento">Departamento</label><select-departamento id="departamento" name="departamento" ng-model="risco.departamento" required="required"></select-departamento></div></div><div class="col-md-3"><div class="form-group"><label for="contratoExterno">Contrato de Clientente</label><select-contrato-externo id="contratoExterno" name="contratoExterno" ng-model="risco.contratoExterno"></select-contrato-externo></div></div><div class="col-md-2"><div class="form-group"><label for="inicioObservacao" class="control-label">Inicio da Observa\xE7\xE3o</label> <input name="inicioObservacao" type="date" id="inicioObservacao" ng-model="risco.inicioObservacao" required="required" class="form-control text-center"></div></div><div class="col-md-1"><div ng-if="risco.continuo" class="form-group"><label for="prazo">Prazo</label> <input name="prazo" id="prazo" type="text" ng-model="risco.prazo" maxlength="255" ng-maxlength="255" ng-blur="onPrazoBlur()" required="required" class="form-control"></div></div><div class="col-md-2"><div ng-if="risco.continuo" class="form-group"><label for="tipoPrazo">Tipo do Prazo</label><select-enum name="tipoPrazo" id="tipoPrazo" ng-model="risco.tipoPrazo" tipo="TipoPrazo" tipo-label="Tipo de Prazo" ng-change="onPrazoBlur()" required="required"></select-enum></div></div><div class="col-md-2"><div ng-if="!risco.continuo" class="form-group"><label for="dataPrazo" class="control-label">Data Prazo</label> <input name="dataPrazo" type="date" id="dataPrazo" ng-model="risco.dataPrazo" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div ng-if="!risco.continuo" class="form-group"><label for="mitigacao" class="control-label">Conclus\xE3o</label> <input name="mitigacao" type="date" id="mitigacao" ng-model="risco.mitigacao" class="form-control text-center"></div></div><div class="col-md-12"><div class="form-group"><label for="descricao">Descricao</label> <input name="descricao" id="descricao" type="text" ng-model="risco.descricao" required="required" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="causa">Causa</label> <textarea name="causa" id="causa" type="text" ng-model="risco.causa" required="required" class="form-control"></textarea></div></div><div class="col-md-12"><div class="form-group"><label for="consequencia">Consequ\xEAncia</label> <textarea name="consequencia" id="consequencia" type="text" ng-model="risco.consequencia" required="required" class="form-control"></textarea></div></div><div class="col-md-12"><div class="form-group"><label for="acao">Plano de A\xE7\xE3o</label> <textarea name="acao" id="acao" type="text" ng-model="risco.acao" required="required" class="form-control"></textarea></div></div></div><div class="text-right"><button type="button" ng-click="close()" style="margin-top: 10px;" class="btn btn-danger">Cancelar</button> <button type="submit" value="Salvar" style="margin-top: 10px;" class="btn btn-success">Salvar</button></div></form></div></div></div></div>');
$templateCache.put('app/pages/qualidade/riscos/risco.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ng-disabled="!authService.isInRole(\'ROLE_RISCO_[A-Z]*C[A-Z]*\')" ui-sref="cadastrosbasicos.risco" class="btn btn-warning">Adicionar</a></div></div><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="div"><form class="form"><div ng-include="\'app/pages/qualidade/riscos/riscoSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th style="width:30px !important;" st-sort="codigo" class="text-center">C\xF3digo</th><th style="width:250px;" st-sort="descricao">Descri\xE7\xE3o</th><th st-sort="causa">Causa</th><th style="width:30px !important;" st-sort="inicioObservacao" class="text-center">Inicio</th><th style="width:30px !important;" st-sort="inicioObservacao" class="text-center">Prazo</th><th style="width:30px !important;" st-sort="mitigacao" class="text-center">Mitiga\xE7\xE3o</th><th style="width:30px !important;" st-sort="impacto" class="text-center">Impacto/Probabilidade/Grau</th><th style="width:30px !important;" st-sort="tipoRisco" class="text-center">Evento</th><th style="width:30px !important;" st-sort="departamento.nome" class="text-center">Departamento</th><th style="width:120px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="risco in displayed"><td class="text-center">{{risco.codigo}}</td><td>{{risco.descricao}}</td><td>{{risco.causa}}</td><td class="text-center">{{risco.inicioObservacao | date:\'dd/MM/yyyy\'}}</td><td class="text-center">{{risco.continuo ? risco.prazo + " " + risco.tipoPrazo.descricao : risco.dataPrazo | date:\'dd/MM/yyyy\' }}</td><td class="text-center">{{risco.mitigacao | date:\'dd/MM/yyyy\'}}</td><td class="text-center">{{risco.impacto}} / {{risco.probabilidade}} / {{risco.gravidade.descricao}}</td><td class="text-center">{{risco.tipoRisco.descricao}}</td><td class="text-center">{{risco.departamento.nome}}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_RISCO_[A-Z]*U[A-Z]*\')" ui-sref="cadastrosbasicos.risco({ riscoId: risco.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_RISCO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Risco \'+ risco.causa, risco)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="10" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="10" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="9" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/qualidade/riscos/riscoSearch.html','<div><div class="row"><div class="col-md"><div class="col-md-8"><div class="form-group"><label for="descricao">Causa</label> <input name="descricao" id="descricao" type="text" ng-model="filtro.descricao" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="departamento">Departamento</label><select-departamento id="departamento" name="departamento" ng-model="filtro.departamento"></select-departamento></div></div></div></div></div>');
$templateCache.put('app/pages/seguranca/area-sistema/area-sistema.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div style="padding-right: 15px" class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_AREASISTEMA_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/seguranca/area-sistema/formarea-sistema.html\', \'sm\', \'\xC1rea Sistema\', area)" data-toggle="modal" data-id="{{area.id}}" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="descricao">Descri\xE7\xE3o</th><th st-sort="grupoAreaSistema">Grupo \xC1rea Sistema</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="area in displayed"><td>{{area.descricao}}</td><td>{{area.grupoAreaSistema.descricao}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_AREASISTEMA_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/seguranca/area-sistema/formarea-sistema.html\', \'sm\', \'\xC1rea Sistema\', area)" data-toggle="modal" data-id="{{area.id}}" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_AREASISTEMA_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'\xC1rea Sistema \'+ area.descricao, area)" data-toggle="modal" data-id="{{area.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/seguranca/area-sistema/formarea-sistema.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(area)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="area.descricao" required="required" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="name" class="control-label">Entidade</label> <input name="name" id="name" ng-model="area.name" required="required" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="grupoAreaSistema" class="control-label">Grupo</label><select-grupo-area-sistema name="grupoAreaSistema" id="grupoAreaSistema" ng-model="area.grupoAreaSistema" required="required"></select-grupo-area-sistema></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/seguranca/auditoria-registro/auditoria-registro.html','<div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="entidade">Entidade</label><select-enum name="alteracao" ng-model="filtro.entidade" tipo="EntityClassName" tipo-label="entidade" ng-change="OnEntidadeChange(filtro.entidade.name)" class="form-control"></select-enum></div></div></div></div><div ng-if="!isLoading &amp;&amp; entitySelected != null"><div ng-if="!isLoading" id="{{entitySelected.controller}}" ng-include="\'app/pages/seguranca/auditoria-registro/listauditoria-registro.html\'" dynamic-ctrl="entitySelected.controller"></div></div></div></div>');
$templateCache.put('app/pages/seguranca/auditoria-registro/listauditoria-registro.html','<div class="well"><form class="form"><div ng-include="entitySelected.searchForm"></div><div class="row"><div class="col-md-12 text-right"><button type="submit" ng-click="search()" class="btn btn-success">Buscar</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th class="text-left">Status</th><th>Identificador</th><th>Data Cria\xE7\xE3o</th><th>Data Modifica\xE7\xE3o</th><th>Campos Preenchidos</th><th>Percentual</th><th class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-if="!isLoading &amp;&amp; entitySelected != null" ng-init="formatarStatus(displayed)"><tr ng-repeat="data in displayedFormated"><td class="text-left"><button class="btn btn-xs {{data.btnColor}}">{{data.status}}</button></td><td>{{data.id}}</td><td>{{data.dataCriacao}}</td><td>{{data.dataModificacao}}</td><td>{{data.qtdCamposPreenchidos}}</td><td>{{data.percentualPreenchido | number : 2 }} %</td><td class="text-center"><button ng-disabled="!authService.isInRole(\'ROLE_AUDITORIAREGISTRO_[A-Z]*R[A-Z]*\')" ui-sref="seguranca.viewauditoriaregistro({entityName:entitySelected.entityName, entityId: data.id})" tooltip="" title="Visualizar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-info-sign"></span></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="7" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="7" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="6" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/seguranca/auditoria-registro/table-auditoria-registro.html','<div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="table-responsive"><table ng-if="results" class="table table-striped table-hover"><thead><tr class="sortable"><th>Campo</th><th>Valor</th><th>Situa\xE7\xE3o</th></tr></thead><tbody ng-if="!isLoading"><tr ng-repeat="data in results"><td>{{data.key}}</td><td>{{data.value.id != null ? data.value.id : data.value.descricao != null ? data.value.descricao : data.value}}</td><td class="text-left"><button class="btn btn-xs {{data.btnColor}}">{{data.status}}</button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/seguranca/auditoria-registro/view-auditoria-registro.html','<div><div ng-include="\'app/pages/seguranca/auditoria-registro/table-auditoria-registro.html\'" dynamic-ctrl="entitySelected.controller"></div></div>');
$templateCache.put('app/pages/seguranca/auditoria-sistema/auditoria-sistema.html','<div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" ng-init="aberto=true" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Linha do Tempo</h3></div><div class="panel-body"><div uib-collapse="aberto" style="margin-top:20px; margin-bottom:30px;"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="perfil">Perfil</label><select-perfil name="perfil" id="perfil" ng-model="filtro.perfil"></select-perfil></div></div><div class="col-md-3"><div class="form-group"><label for="usuario">Usu\xE1rio</label><select-usuario name="usuario" id="usuario" ng-model="filtro.usuario" watch-to="filtro.perfil"></select-usuario></div></div><div class="col-md-3"><div class="form-group"><label for="alteracao">Altera\xE7\xE3o</label><select-enum name="alteracao" ng-model="filtro.alteracao" tipo="TipoDeAcao" tipo-label="Altera\xE7\xE3o" class="form-control"></select-enum></div></div><div class="col-md-3"><div class="form-group"><label for="entidade">Entidade</label><select-enum name="alteracao" ng-model="filtro.entidade" tipo="EntityClassName" tipo-label="entidade" class="form-control"></select-enum></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="inicio">Inicio</label> <input name="inicio" id="inicio" type="date" ng-model="filtro.inicio" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="fim">Fim</label> <input name="fim" id="fim" type="date" ng-model="filtro.fim" class="form-control"></div></div></div></div><div class="row"><div class="col-md-12 text-right"><button ng-click="clear()" class="btn btn-default">Limpar</button> <button ng-click="search(itemsByPage , displayed.page.currentPage)" class="btn btn-success">Buscar</button></div></div></div><div style="margin-top:20px;" class="row"><div class="col-md-12 text-right"><button ng-click="aberto = !aberto" class="btn btn-info btn-with-icon"><i class="glyphicon glyphicon-search"></i> Busca Avan\xE7ada</button></div></div><div style="margin-top:20px;" class="row"><div class="col-md-11 text-center form-group"><ul ng-if="displayed.content.length" class="pagination"><li ng-class="{disabled:displayed.pages.currentPage == 0}"><a ng-click="search(itemsByPage, 0)">Primeiro</a></li><li ng-class="{disabled:displayed.page.currentPage == 0}"><a ng-click="search(itemsByPage, displayed.page.currentPage - 1 )">Anterior</a></li><li ng-repeat="page in displayed.page.pages" ng-class="{active:displayed.page.currentPage == page}"><a ng-click="search(itemsByPage, page)">{{page}}</a></li><li ng-class="{disabled:displayed.page.currentPage == displayed.page.totalPages}"><a ng-click="search(itemsByPage, displayed.page.currentPage + 1)">Proximo</a></li><li ng-class="{disabled:displayed.page.currentPage == displayed.page.totalPages}"><a ng-click="search(itemsByPage,displayed.page.totalPages -1)">Ultimo</a></li></ul></div><div style="margin-top:20px;" ng-if="displayed.content.length" class="col-md-1 text-right form-group"><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-click="load(itemsByPage, displayed.page.currentPage)" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></div></div><div class="row"><div ng-if="displayed.totalPages == 0" class="alert bg-info text-center"><strong>Sem Registros !!!.</strong></div></div><hr><section id="cd-timeline" class="cd-container cssanimations"><div ng-repeat="alt in displayed.content" class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg"><img ng-src="{{alt.pathImagem}}"></div></div><div class="cd-timeline-content {{alt.typeColor}}"><h5>O usu\xE1rio "{{alt.revision.usuario.pessoaFisica.pessoa.nome}}" realizou uma {{alt.tipoDeOperacao}} na se\xE7\xE3o {{alt.entityClassName.descricao}}</h5><span class="cd-date">{{alt.revision.timestamp | date: "dd/MM/y HH:mm"}}</span></div></div></section></div></div>');
$templateCache.put('app/pages/seguranca/grupo-area-sistema/formgrupo-area-sistema.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(grupo)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="grupo.descricao" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/seguranca/grupo-area-sistema/grupo-area-sistema.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div style="padding-right: 15px" class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_GRUPOAREASISTEMA_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/seguranca/grupo-area-sistema/formgrupo-area-sistema.html\', \'sm\', \'Grupo \xC1rea Sistema\', grupo)" data-toggle="modal" data-id="{{grupo.id}}" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="descricao">Descri\xE7\xE3o</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="grupo in displayed"><td>{{grupo.descricao}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_GRUPOAREASISTEMA_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/seguranca/grupo-area-sistema/formgrupo-area-sistema.html\', \'sm\', \'Grupo \xC1rea Sistema\', grupo)" data-toggle="modal" data-id="{{grupo.id}}" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_GRUPOAREASISTEMA_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Grupo \xC1rea Sistema \'+ grupo.descricao, grupo)" data-toggle="modal" data-id="{{grupo.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="2" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="5" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="1" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/seguranca/perfil/formperfil.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Informa\xE7\xF5es B\xE1sicas</h3></div><div class="panel-body"><form name="form" ng-submit="save(usuario)" method="post" class="form"><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" type="text" ng-model="perfil.descricao" required="required" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="telaInicial">Tela Inicial</label> <input name="telaInicial" id="telaInicial" type="text" ng-model="perfil.telaInicial" required="required" class="form-control"></div></div><div class="col-md-2"><div class="form-group text-center"><label class="control-label">Status</label><br><button type="button" ng-class="{\'btn-success\': perfil.isActive }" ng-click="perfil.isActive=true" title="Ativo" class="btn btn-md btn-icon"><i class="fa fas fa-unlock"></i></button> <button type="button" ng-class="{\'btn-danger\': !perfil.isActive }" ng-click="perfil.isActive=false" title="Bloqueado" class="btn btn-md btn-icon"><i class="fa fas fa-lock"></i></button></div></div></div></div><div ng-repeat="grupo in grupos" class="col-sm-12"><h4>{{grupo.descricao}}</h4><div class="row"><div ng-repeat="area in grupo.areasSistema" class="col-sm-12"><div class="input-group mb-3"><div class="input-group-prepend"><div class="btn-group btn-group-sm"><button ng-class="style(area.all)" data-toggle="tooltip" title="Selecionar Todos" type="button" ng-click="setAll(!area.all, area)" class="btn icon ion-checkmark-round"></button> <button ng-class="style(area.create)" data-toggle="tooltip" title="Adicionar" type="button" ng-click="area.create = ! area.create" class="btn icon fa fa-plus"></button> <button ng-class="style(area.read)" data-toggle="tooltip" title="Visualizar" type="button" ng-click="area.read = ! area.read" class="btn icon fa fa-eye"></button> <button ng-class="style(area.update)" data-toggle="tooltip" title="Editar" type="button" ng-click="area.update = ! area.update" class="btn icon fa fa-pencil"></button> <button ng-class="style(area.delete)" data-toggle="tooltip" title="Remover" type="button" ng-click="area.delete = ! area.delete" class="btn icon fa fa-trash"></button> <button ng-class="style(area.print)" data-toggle="tooltip" title="Imprimir" type="button" ng-click="area.print = ! area.print" class="btn icon fa fa-print"></button></div><label class="control-label">{{area.descricao}}</label></div></div></div></div></div><div class="text-right"><button type="button" ng-click="clear()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/seguranca/perfil/perfil.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div style="padding-right: 15px" class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_PERFIL_[A-Z]*C[A-Z]*\')" ui-sref="seguranca.formperfil" class="btn btn-warning">Adicionar</a></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="status" style="width:50px !important;" class="text-center">Status</th><th st-sort="descricao">Descri\xE7\xE3o</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="perfil in displayed"><td class="text-left"><button type="button" ng-class="{\'btn-success\': perfil.isActive }" ng-if="perfil.isActive == true" class="btn btn-xs btn-icon"><i class="fa fas fa-unlock"></i></button> <button type="button" ng-class="{\'btn-danger\': !perfil.isActive }" ng-if="perfil.isActive == false" class="btn btn-xs btn-icon"><i class="fa fas fa-lock"></i></button></td><td>{{perfil.descricao}}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_PERFIL_[A-Z]*U[A-Z]*\')" ui-sref="seguranca.formperfil({ perfilId: perfil.id })" tooltip="Editar" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_PERFIL_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Perfil \'+ perfil.descricao, perfil)" data-toggle="modal" data-id="{{perfil.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/seguranca/profile/changePass.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="changePass(usuario)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="senha">Senha Nova</label> <input name="senha" id="senha" type="password" ng-model="usuario.senha" required="required" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="senhaConfirm">Confirme a Senha</label> <input name="senhaConfirm" id="senhaConfirm" type="password" ng-model="usuario.senhaConfirm" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/seguranca/profile/profile.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-body"><form name="form" ng-submit="save(usuario)" method="post" class="form"><div class="row"><div class="col-md-12"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Picture</label></div><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i ng-click="removePicture()" ng-if="!noPicture" class="ion-ios-close-outline"></i><a href="" ng-click="uploadPicture()" class="change-userpic"></a> <input id="imagem" type="file" ng-show="false" ng-model="files" onchange="angular.element(this).scope().onFileSelectImagemUsuario(this.files)" ng-file-select="ng-file-select"></div></div></div></div></div><div style="margin-top:20px;" class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="nome">Nome Completo</label> <input name="nome" id="nome" type="text" ng-model="usuario.pessoaFisica.pessoa.nome" required="required" class="form-control"></div></div><div class="col-md-2"><div class="form-group"><label for="cpf">CPF</label> <input name="cpf" id="cpf" type="text" ng-model="usuario.pessoaFisica.cpf" ui-mask="999.999.999-99" placeholder="000.000.000-00" class="form-control text-center"></div></div><div class="col-md-4"><div class="form-group"><label for="email">Email</label><div class="input-group ng-scope"><input name="email" id="email" type="email" aria-describedby="basic-addon2" ng-model="usuario.pessoaFisica.pessoa.email" required="required" maxlength="255" ng-maxlength="255" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div></div></div><div class="text-right"><button type="button" ng-click="open(\'app/pages/seguranca/profile/changePass.html\', \'sm\', \'Mudar Senha\', usuario)" data-toggle="modal" data-id="{{usuario.id}}" class="btn btn-info">Mudar Senha</button> <button type="button" ng-click="clear()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div></div></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul ng-if="!$baSidebarService.isMenuCollapsed()" class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><div><li ng-repeat="children0 in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': children0.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="children0"><a ng-mouseenter="hoverItem($event, item)" ui-state="children0.stateRef || \'\'" ng-href="{{::(children0.fixedHref ? children0.fixedHref: \'\')}}" ng-if="::!children0.subMenu" class="al-sidebar-list-link"><i class="{{ ::children0.icon }}"></i> <span>{{ ::children0.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::children0.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::children0.icon }}"></i> <span>{{ ::children0.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::children0.subMenu"></b></a><ul ng-if="::children0.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': children0.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="children1 in ::children0.subMenu" ng-class="::{\'with-sub-menu\': children1.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="children1" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::children1.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link children1-submenu-link"><span>{{ ::children1.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': children1.expanded, \'fa-angle-down\': !children1.expanded}" ng-if="::children1.subMenu"></b></a><ul ng-if="::children1.subMenu" class="al-sidebar-sublist children2-submenu-list" ng-class="{\'slide-right\': children1.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="children2 in ::children1.subMenu" ng-class="::{\'with-sub-menu\': children2.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="children2" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::children2.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link children2-submenu-link"><span>{{ ::children2.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': children2.expanded, \'fa-angle-down\': !children2.expanded}" ng-if="::children2.subMenu"></b></a><ul ng-if="::children2.subMenu" class="al-sidebar-sublist children3-submenu-list" ng-class="{expanded: children2.expanded, \'slide-right\': children2.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="children3 in ::children2.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::children3.disabled" class="al-sidebar-list-link">{{ ::children3.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="children3.stateRef || \'\'" ng-if="::!children3.disabled" ng-href="{{::(children3.fixedHref ? children3.fixedHref: \'\')}}">{{::children3.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!children2.subMenu && children2.disabled)" class="al-sidebar-list-link">{{ ::children2.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(children2.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!children2.subMenu && !children2.disabled)" ui-state="children2.stateRef || \'\'" ng-href="{{::(children2.fixedHref ? children2.fixedHref: \'\')}}">{{ ::children2.title}}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!children1.subMenu && children1.disabled)" class="al-sidebar-list-link">{{ ::children1.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(children1.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!children1.subMenu && !children1.disabled)" ui-state="children1.stateRef || \'\'" ng-href="{{::(children1.fixedHref ? children1.fixedHref: \'\')}}">{{ ::children1.title}}</a></li></ul></li></div><div class="quanta-logo"><img class="extended-logo" src="assets/img/quanta-logo.jpg" alt="Quanta Consultoria LTDA" width="135" height="42"></div></ul><div ng-if="$baSidebarService.isMenuCollapsed()" class="space_up"><a><i class="ion-arrow-up-b"></i></a></div><ul ng-if="$baSidebarService.isMenuCollapsed()" class="children0" role="presentation"><div class="scrollbar"><li num="{{$index}}" ng-repeat="children0 in ::menuItems" class="button" ng-class="::{\'with-sub-menu\': children0.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="children0"><a class="title_sem_submenu" ng-mouseenter="hoverItem($event, item)" ui-state="children0.stateRef || \'\'" ng-href="{{::(children0.fixedHref ? children0.fixedHref: \'\')}}" ng-if="::!children0.subMenu"><i class="{{ ::children0.icon }}"></i></a><ul ng-if="::!children0.subMenu"><li class="title_hover"><span>{{ ::children0.title }}</span></li></ul><a ng-mouseenter="hoverItem($event, item)" ng-if="::children0.subMenu" ba-ui-sref-toggler=""><i class="{{ ::children0.icon }}"></i> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::children0.subMenu"></b></a><ul ng-if="::children0.subMenu" class="children1" ng-class="{\'slide-right\': children0.slideRight}" ba-ui-sref-toggling-submenu=""><li class="title_hover"><span>{{ ::children0.title }}</span></li><li num="{{$index}}" ng-repeat="children1 in ::children0.subMenu" ng-class="::{\'with-sub-menu\': children1.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="children1"><a ng-mouseenter="hoverItem($event, item)" ng-if="::children1.subMenu" ba-ui-sref-toggler=""><span>{{ ::children1.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': children1.expanded, \'fa-angle-down\': !children1.expanded}" ng-if="::children1.subMenu"></b></a><ul ng-if="::children1.subMenu" class="children2" ng-class="{\'slide-right\': children1.slideRight}" ba-ui-sref-toggling-submenu=""><li num="{{$index}}" ng-repeat="children2 in ::children1.subMenu" ng-class="::{\'with-sub-menu\': children2.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="children2"><a ng-mouseenter="hoverItem($event, item)" ng-if="::children2.subMenu" ba-ui-sref-toggler=""><span>{{ ::children2.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': children2.expanded, \'fa-angle-down\': !children2.expanded}" ng-if="::children2.subMenu"></b></a><ul num="{{$index}}" ng-if="::children2.subMenu" class="children3" ng-class="{expanded: children2.expanded, \'slide-right\': children2.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="children3 in ::children2.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::children3.disabled">{{ ::children3.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="children3.stateRef || \'\'" ng-if="::!children3.disabled" ng-href="{{::(children3.fixedHref ? children3.fixedHref: \'\')}}">{{::children3.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!children2.subMenu && children2.disabled)">{{ ::children2.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(children2.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!children2.subMenu && !children2.disabled)" ui-state="children2.stateRef || \'\'" ng-href="{{::(children2.fixedHref ? children2.fixedHref: \'\')}}">{{ ::children2.title}}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!children1.subMenu && children1.disabled)">{{ ::children1.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(children1.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!children1.subMenu && !children1.disabled)" ui-state="children1.stateRef || \'\'" ng-href="{{::(children1.fixedHref ? children1.fixedHref: \'\')}}">{{ ::children1.title}}</a></li></ul></li></div></ul><div ng-if="$baSidebarService.isMenuCollapsed()" class="space_down"><a><i class="ion-arrow-down-b"></i></a></div><div class="quanta-logo" ng-if="$baSidebarService.isMenuCollapsed()"><img class="short-logo" src="assets/img/quanta-logo-short.png" alt="Quanta Consultoria LTDA" width="20" height="20"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/pages/seguranca/usuario/formusuario.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-body"><form name="form" ng-submit="save(usuario)" method="post" class="form"><div class="row"><div class="col-md-12"><div class="col-md-11"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Picture</label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i ng-click="removePicture()" ng-if="!noPicture" class="ion-ios-close-outline"></i><a href="" ng-click="uploadPicture()" class="change-userpic"></a> <input id="imagem" type="file" ng-show="false" ng-model="files" onchange="angular.element(this).scope().onFileSelectImagemUsuario(this.files)" ng-file-select="onFileSelectImagemUsuario($files)"></div></div></div></div><div class="col-md-1"><div style="margin-top:25px" class="form-group"></div></div><label for="ativo">Ativo</label> <input type="checkbox" name="ativo" ng-model="usuario.ativo" id="ativo"></div></div><div style="margin-top:20px;" class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="cpf">CPF</label> <input name="cpf" id="cpf" type="cpf" ng-model="usuario.pessoaFisica.cpf" ui-mask="999.999.999-99" required="required" ng-blur="onCpfBlur(usuario.pessoaFisica.cpf)" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="email">Email</label><div class="input-group ng-scope"><input name="email" id="email" type="email" aria-describedby="basic-addon2" ng-model="usuario.pessoaFisica.pessoa.email" required="required" maxlength="255" ng-maxlength="255" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div><div class="col-lg-12"><div class="form-group"><label for="nome">Nome Completo</label> <input name="nome" id="nome" type="text" ng-model="usuario.pessoaFisica.pessoa.nome" required="required" class="form-control"></div></div><div ng-if="usuario.id != null" class="col-md-3"><div class="form-group"><label for="login">Nome de Usu\xE1rio</label> <input name="login" id="login" type="text" ng-model="usuario.login" required="required" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="perfil">Perfil</label><select-perfil name="perfil" id="perfl" ng-model="usuario.perfil" required="required"></select-perfil></div></div></div></div><div class="text-right"><button ng-if="usuario.id" type="button" ng-click="open(\'app/pages/seguranca/profile/changePass.html\', \'sm\', \'Mudar Senha\', usuario)" data-toggle="modal" data-id="{{usuario.id}}" class="btn btn-info">Mudar Senha</button> <button type="button" ng-click="clear()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div><div ng-if="usuario.id == null"><h3 style="margin-top:20px">Login<hr></h3><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="login">Nome de Usu\xE1rio</label> <input name="login" id="login" type="text" ng-model="usuario.login" required="required" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="senha">Senha</label> <input name="senha" id="senha" type="password" ng-model="usuario.senha" required="required" class="form-control"></div></div><div class="col-md-4"><div class="form-group"><label for="resenha">Confirmar Senha</label> <input name="resenha" id="resenha" type="password" ng-model="usuario.resenha" required="required" class="form-control"></div></div></div></div></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/seguranca/usuario/usuario.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto=false" class="panel panel-default bootstrap-panel"><div ng-init="self.activate()" class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px;margin-bottom:20px;"><form class="form"><div ng-include="\'app/pages/seguranca/usuario/usuarioSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ng-disabled="!authService.isInRole(\'ROLE_USUARIO_[A-Z]*C[A-Z]*\')" ui-sref="seguranca.formusuario" class="btn btn-warning">Adicionar</a></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="ativo">Status</th><th st-sort="login">Usu\xE1rio</th><th st-sort="pessoaFisica.pessoa.nome">Nome</th><th st-sort="pessoaFisica.cpf" class="text-center">CPF</th><th st-sort="perfil.descricao">Perfil</th><th style="width:155px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="usuario in displayed"><td><button ng-class="{\'btn-success\': usuario.ativo , \'btn-danger\': !usuario.ativo }" class="btn btn-xs btn-icon"><i class="ion-checkmark-round"></i></button></td><td>{{usuario.login}}</td><td>{{usuario.pessoaFisica.pessoa.nome}}</td><td class="text-center">{{usuario.pessoaFisica.cpf | mask:"cpf"}}</td><td>{{usuario.perfil.descricao}}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_USUARIO_[A-Z]*R[A-Z]*\')" ui-sref="seguranca.viewusuario({ usuarioId: usuario.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-info-sign"></span></a><a ng-disabled="!authService.isInRole(\'ROLE_USUARIO_[A-Z]*U[A-Z]*\')" ui-sref="seguranca.formusuario({ usuarioId: usuario.id })" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_USUARIO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Usuario \'+ usuario.pessoaFisica.pessoa.nome, usuario)" data-toggle="modal" data-id="{{usuario.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/seguranca/usuario/usuarioSearch.html','<div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="perfil">Perfil</label><select-perfil name="perfil" id="perfl" ng-model="filtro.perfil"></select-perfil></div></div><div class="col-md-8"><div class="form-group"><label for="login">Usu\xE1rio</label> <input name="login" id="login" type="text" ng-model="filtro.login" class="form-control"></div></div><div class="col-md-1"><div style="margin-top:25px" class="form-group"></div></div><label for="ativo">Ativo</label> <input type="checkbox" name="ativo" ng-model="usuario.ativo" id="ativo"><div class="col-md-3"><div class="form-group"><label for="cpf">CPF</label> <input name="cpf" id="cpf" type="text" ng-model="filtro.cpf" ui-mask="999.999.999-99" placeholder="000.000.000-00" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="filtro.nome" class="form-control"></div></div></div></div>');
$templateCache.put('app/pages/seguranca/usuario/viewusuario.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Informa\xE7\xF5es B\xE1sicas</h3></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><h4>Nome completo</h4><p>{{usuario.pessoaFisica.pessoa.nome}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Nome apresent\xE1vel</h4><p>{{usuario.pessoaFisica.pessoa.nome}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>CPF</h4><p>{{usuario.cpf}}</p></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>Data Nascimento</h4><p>{{usuario.dataNascimento | date: "dd/MM/y"}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Email</h4><p>{{usuario.email}}</p></div></div></div></div><h3 style="margin-top:20px">Conta de Acesso<hr></h3><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><h4>Usu\xE1rio</h4><p>{{usuario.login}}</p></div></div></div></div></div><div class="text-right"><button ng-click="clear()" class="btn btn-danger">Voltar</button></div></div></div></div></div>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#!/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><div class="logo"></div><a ng-if="user.id" ui-sref="{{user.perfil.telaInicial}}" class="al-logo"><img class="hideBySize" src="assets/img/benthamicon.png" ng-if="$baSidebarService.isMenuCollapsed()" width="35" height="40"> <img class="hideBySize" src="assets/img/bentham-logo.png" ng-if="!$baSidebarService.isMenuCollapsed()" width="139" height="40"><div class="espacamento" ng-if="!$baSidebarService.isMenuCollapsed()"></div></a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile"><div class="al-user-profile dropdown" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link dropdown-toggle"><img ng-if="user.imagem == null" ng-src="{{::( \'User\' | profilePicture )}}"> <img ng-if="user.imagem != null" class="profilePicture" ng-src="{{prefixRoute}}arquivos/catchFile/{{user.imagem.id}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a ui-sref="profile({profileId: user.id})"><i class="fa fa-user"></i>Profile</a></li><li><a href="" class="signout" ng-click="logout()"><i class="fa fa-power-off"></i>Sair</a></li></ul></div><div class="select"><select-contrato-externo ng-if="authService.isInRole(\'ROLE_DASHBOARDCONTRATO_[A-Z]*C[A-Z]*\')" id="contrato" name="contrato" ng-model="contrato" ng-change="onContratoChange(contrato)"></select-contrato-externo></div><div ng-if="user.id" class="user-profile text-right hideBySize" style="font-size:16px; margin-top:15px; margin-right: 10px;">{{user.pessoaFisica.pessoa.nome}}</div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/pages/arquivos/entity-documento/modais/modalDelete.html','<div class="panel panel-default bootstrap-panel"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><h4>Voc\xEA tem certeza que deseja remover o anexo ?</h4></div><div class="panel-footer text-right"><button ng-click="remove(documento)" class="btn btn-success">Comfirmar</button></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/clientes/responsavel/form-responsave.html','<div class="row"><div class="col-md-3"><div class="form-group"><label for="cpf">CPF</label> <input name="cpf" id="cpf" type="cpf" ng-model="pessoaFisica.cpf" mask="cpf" required="required" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="pessoaFisica.pessoa.nome" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="rg">RG</label> <input name="rg" id="rg" type="text" ng-model="pessoaFisica.rg" ui-mask="999.999.999-9999" required="required" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="email">Email</label><div class="input-group"><input name="email" id="email" ia-describedby="basic-addon2" type="email" ng-model="pessoaFisica.pessoa.email" required="required" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div></div><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'"></div>');
$templateCache.put('app/pages/cadastrosbasicos/clientes/responsavel/form-responsavel.html','<div class="row"><div class="col-md-3"><div class="form-group"><label for="cpf">CPF</label> <input name="cpf" id="cpf" type="cpf" ng-model="pessoaFisica.cpf" mask="cpf" required="required" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="pessoaFisica.pessoa.nome" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="rg">RG</label> <input name="rg" id="rg" type="text" ng-model="pessoaFisica.rg" ui-mask="999.999.999-9999" required="required" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="email">Email</label><div class="input-group"><input name="email" id="email" ia-describedby="basic-addon2" type="email" ng-model="pessoaFisica.pessoa.email" required="required" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div></div><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'"></div>');
$templateCache.put('app/pages/cadastrosbasicos/clientes/responsavel/formpessoa-fisica.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(pessoaFisica)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md-3"><div class="form-group"><label for="cpf">CPF</label> <input name="cpf" id="cpf" type="cpf" ng-model="pessoaFisica.cpf" mask="cpf" required="required" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="pessoaFisica.pessoa.nome" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="rg">RG</label> <input name="rg" id="rg" type="text" ng-model="pessoaFisica.rg" ui-mask="999.999.999-9999" required="required" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="email">Email</label><div class="input-group"><input name="email" id="email" ia-describedby="basic-addon2" type="email" ng-model="pessoaFisica.pessoa.email" required="required" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div></div><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'"></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/cadastrosbasicos/clientes/responsavel/pessoa-fisica.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button> <button ng-disabled="!authService.isInRole(\'ROLE_PESSOA_FISICA_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/cadastrosbasicos/pessoa-fisica/formpessoa-fisica.html\', \'lg\', \'Nova Pessoa F\xEDsica\', pessoaFisica)" tooltip="" title="Nova Pessoa F\xEDsica" data-placement="top" class="btn btn-warning">Adicionar</button></div></div><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><form class="form"><div ng-include="\'app/pages/cadastrosbasicos/pessoa-fisica/pessoa-fisicaSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="submit" ng-click="search()" class="btn btn-success">Buscar</button> <button type="button" ng-click="clear()" class="btn btn-default">Limpar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="pessoa.nome">Nome</th><th st-sort="cpf" class="text-center">CPF</th><th st-sort="rg" class="text-center">RG</th><th st-sort="pessoa.endereco.codigoPostal" class="text-center">CEP</th><th st-sort="pessoa.endereco.logradouro">Logradouro</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="pessoaFisica in displayed"><td>{{pessoaFisica.pessoa.nome}}</td><td class="text-center">{{pessoaFisica.cpf | mask:"cpf"}}</td><td class="text-center">{{pessoaFisica.rg}}</td><td class="text-center">{{pessoaFisica.pessoa.endereco.codigoPostal}}</td><td>{{pessoaFisica.pessoa.endereco.logradouro}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_PESSOA_FISICA_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/cadastrosbasicos/pessoa-fisica/formpessoa-fisica.html\', \'lg\', \'Pessoa F\xEDsica\', pessoaFisica)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_PESSOA_FISICA_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Pessoa F\xEDsica: \'+ pessoaFisica.pessoa.nome, pessoaFisica)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/clientes/responsavel/pessoa-fisicaSearch.html','<div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="nome">Nome</label> <input name="nome" id="nome" type="text" ng-model="filtro.nome" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="cpf">CPF</label> <input name="cpf" id="cpf" type="cpf" ui-mask="999.999.999-99" ng-model="filtro.cpf" class="form-control text-center"></div></div></div></div></div>');
$templateCache.put('app/pages/cadastrosbasicos/clientes/responsavel/reponsavel.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button> <button ng-disabled="!authService.isInRole(\'ROLE_PESSOA_FISICA_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/cadastrosbasicos/pessoa-fisica/formpessoa-fisica.html\', \'lg\', \'Nova Pessoa F\xEDsica\', pessoaFisica)" tooltip="" title="Nova Pessoa F\xEDsica" data-placement="top" class="btn btn-warning">Adicionar</button></div></div><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;"><form class="form"><div ng-include="\'app/pages/cadastrosbasicos/pessoa-fisica/pessoa-fisicaSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="pessoa.nome">Nome</th><th st-sort="cpf" class="text-center">CPF</th><th st-sort="rg" class="text-center">RG</th><th st-sort="pessoa.endereco.codigoPostal" class="text-center">CEP</th><th st-sort="pessoa.endereco.logradouro">Logradouro</th><th style="width:110px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="pessoaFisica in displayed"><td>{{pessoaFisica.pessoa.nome}}</td><td class="text-center">{{pessoaFisica.cpf | mask:"cpf"}}</td><td class="text-center">{{pessoaFisica.rg}}</td><td class="text-center">{{pessoaFisica.pessoa.endereco.codigoPostal}}</td><td>{{pessoaFisica.pessoa.endereco.logradouro}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_PESSOA_FISICA_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/cadastrosbasicos/pessoa-fisica/formpessoa-fisica.html\', \'lg\', \'Respons\xE1vel\', pessoaFisica)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_PESSOA_FISICA_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Respons\xE1vel: \'+ pessoaFisica.pessoa.nome, pessoaFisica)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/configuracoes/source-file/modais/modalconfirm.html','<div class="panel panel-default bootstrap-panel"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div ng-show="!syncLoading" class="row"><div class="col-md-12 text-left"><p>Tem certeza que deseja sincronizar o arquivos do host: {{source.host}} ?</p></div></div><div ng-show="syncLoading" class="row"><div class="col-md-12 text-left"></div></div></div><div class="panel-footer text-right"><button ng-disabled="syncLoading" type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button ng-disabled="syncLoading" type="submit" ng-click="sync(source)" class="btn btn-success">Confirmar</button></div></div>');
$templateCache.put('app/pages/contratos/consorcios/consorcio-parceiro/consorcio-parceiro.html','<div style="margin-top:20px"><div class="row"><div class="col-xs-12"><div class="row"><div class="col-md-12 text-left"><h3>Parceiros<hr></h3></div><div class="col-md-12 text-right"><button ng-disabled="!authService.isInRole(\'ROLE_CONSORCIO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/contratos/consorcios/consorcio-parceiro/formconsorcio-parceiro.html\', \'lg\', \'Consorcio Parceiro\', consorcioParceiro)" class="btn btn-warning">Adicionar</button></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="parceiro.pessoaJuridica.nomeFantasia">Nome Fantasia</th><th st-sort="parceiro.pessoaJuridica.cnpj">CNPJ</th><th st-sort="porcentagem">Percentual (%)</th><th st-sort="isLider">Lider</th><th style="width:115px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="consorcioParceiro in displayed"><td>{{consorcioParceiro.parceiro.pessoaJuridica.nomeFantasia}}</td><td>{{consorcioParceiro.parceiro.pessoaJuridica.cnpj | mask:"cnpj"}}</td><td>{{consorcioParceiro.porcentagem}}</td><td><button ng-class="{\'btn-success\': consorcioParceiro.isLider,\'btn-danger\': !consorcioParceiro.isLider}" class="btn btn xs">{{consorcioParceiro.isLider == true ? \'Sim\': \'N\xE3o\' }}</button></td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_CONSORCIO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/contratos/consorcios/consorcio-parceiro/formconsorcio-parceiro.html\', \'lg\', \'Consorcio Parceiro\', consorcioParceiro)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_CONSORCIO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Cons\xF3rcio \'+ consorcioParceiro.parceiro.pessoaJuridica.nome, consorcioParceiro)" data-toggle="modal" data-id="{{consorcioParceiro.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="5" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="4" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/contratos/consorcios/consorcio-parceiro/formconsorcio-parceiro.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(consorcioParceiro)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-7"><div class="form-group"><label for="parceiro" class="control-label">Parceiro</label><select-parceiro name="parceiro" id="parceiro" ng-model="consorcioParceiro.parceiro" required="required"></select-parceiro></div></div><div class="col-md-3"><div class="form-group"><label for="nome">Percentual</label> <input name="nome" id="nome" type="text" ng-model="consorcioParceiro.porcentagem" mask="real:false:2:0:100" class="form-control text-right"></div></div><div ng-if="consorcioParceiro.id == null" class="col-md-2"><div class="form-group"><input type="checkbox" name="lider" style="margin-top:30px;" ng-model="consorcioParceiro.isLider"> <label for="lider">Lider</label></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/contratos/contratosexternos/data-importante/data-importante.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading"><div class="text-left"><h3 style="margin-top:20px;">Datas Importantes<hr></h3></div><div class="text-right"><button ng-click="open(\'app/pages/contratos/contratosexternos/data-importante/formdata-importante.html\', \'md\', \'Data Importante\' , dataImportante)" data-toggle="modal" tooltip="" title="Adicionar" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="data">Data</th><th st-sort="descricao">Descri\xE7\xE3o</th><th style="width:120px !important; padding-right: 20px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="dataImportante in displayed"><td>{{dataImportante.data | date: "dd/MM/y"}}</td><td>{{dataImportante.descricao}}</td><td class="text-right"><button ng-click="open(\'app/pages/contratos/contratosexternos/data-importante/formdata-importante.html\', \'md\', \'Data Importante\' , dataImportante)" data-toggle="modal" data-id="{{dataImportante.id}}" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'lg\', \'A Data \'+dataImportante.descricao , dataImportante)" data-toggle="modal" data-id="{{dataImportante.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/contratos/contratosexternos/data-importante/formdata-importante.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(dataImportante)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="data" class="control-label">Data</label> <input name="data" id="data" ng-model="dataImportante.data" required="required" mask="brDate" class="form-control text-center"></div></div><div class="col-md-9"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" type="text" ng-model="dataImportante.descricao" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/contratos/contratosexternos/modais/modalConfirm.html','<div class="panel panel-default bootstrap-panel"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><h4>Voc\xEA tem certeza que deseja gerar este contrato {{perspectiva.numeroEdital}} ?</h4></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button ng-click="gerarContrato(perspectiva)" class="btn btn-success">Comfirmar</button></div></div>');
$templateCache.put('app/pages/contratos/contratosexternos/modais/modalContratoGeradoConfirm.html','<div role="dialog" class="panel panel-default bootstrap-panel"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><h4>Voc\xEA tem certeza que esta perspectiva {{perspectiva.numeroEdital}} j\xE1 foi gerada ?</h4></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button ng-click="confirm(perspectiva)" data-dismiss="modal" aria-label="close" class="btn btn-success">Comfirmar</button></div></div>');
$templateCache.put('app/pages/contratos/medicao/modais/form-addVariosMedicao.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(med)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="contrato" class="control-label">Contrato de Cliente</label><select-contrato-externo name="contrato" id="contrato" ng-model="med.contratoExterno" required="required"></select-contrato-externo></div></div><div class="col-md-3"><div class="form-group"><label for="diaDoInicio" class="control-label">Dia do Inicio</label> <input type="text" name="diaDoInicio" id="diaDoInicio" ng-model="med.diaDoInicio" ui-mask="99" required="required" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="diaDoFim" class="control-label">Dia do Fim</label> <input type="text" name="diaDoFim" id="diaDoFim" ng-model="med.diaDoFim" ui-mask="99" required="required" class="form-control text-center"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="med.descricao" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="dataIncial" class="control-label">Data Inicial</label> <input type="date" name="dataIncial" id="dataIncial" ng-model="med.start" required="required" ng-disabled="isValores==true" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="dataFinal" class="control-label">Data Final</label> <input type="date" name="dataFinal" id="dataFinal" ng-model="med.end" required="required" ng-disabled="isValores==true" class="form-control text-center"></div></div><div ng-hide="isValores==true" class="col-md-3"><div class="form-group"><label for="valor" class="control-label">Valor</label> <input type="text" name="valor" id="valor" ng-model="med.valor" mask="real" ng-blur="med.valorEmpresa=onValorBlur(med.valor)" required="required" class="form-control text-right"></div></div><div ng-hide="isValores==true" class="col-md-3"><div class="form-group"><label for="valorEmpresa" class="control-label">Valor da Empresa</label> <input type="text" name="valorEmpresa" id="valorEmpresa" ng-model="med.valorEmpresa" mask="real" required="required" class="form-control text-right"></div></div></div></div><div ng-show="isValores==true"><div class="table-responsive"><table st-table="med.valores" class="table table-striped table-hover"><thead><tr class="sortable"><th>Data</th><th class="text-right">Valor</th><th class="text-right">Valor da Empresa</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="v in med.valores"><td>{{v.data | date: "dd/MM/yyyy"}}</td><td><input type="text" name="valor" id="valor" ng-model="v.valor" mask="real" ng-blur="v.valorEmpresa=onValorBlur(v.valor)" required="required" style="height:25px;margin-top:5px;" class="form-control text-right"></td><td><input type="text" name="valorEmpresa" id="valorEmpresa" ng-model="v.valorEmpresa" mask="real" required="required" style="height:25px;margin-top:5px;" class="form-control text-right"></td></tr></tbody></table></div></div></div><div class="panel-footer text-right"><button type="button" ng-click="editarValores(med.start, med.end, med.diaDoInicio)" ng-hide="isValores==true" class="btn btn-warning">Editar Valores</button> <button type="button" ng-click="valorUnico();" ng-show="isValores==true" class="btn btn-warning">Valor Unico</button> <button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/contratos/produtos/analise-contratual/analiseContratual.html','<div style="margin-top:20px;"><div class="text-left"><h3>An\xE1lise Cr\xEDtica Contratual</h3></div><div style="padding-right: 15px" class="text-right"><button ng-click="open(\'app/pages/contratos/produtos/analise-contratual/formanaliseContratual.html\', \'lg\', \'An\xE1lise Cr\xEDtica Contratual\', analise)" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="descricao">Descri\xE7\xE3o</th><th style="width:100px" class="text-center">Realizado</th><th style="width:150px;padding-right:20px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="analise in displayed"><td class="ellipsis">{{analise.descricao}}</td><td style="padding-right:20px;" class="text-center"><label for="realizado" class="checkbox-inline custom-checkbox"></label> <input type="checkbox" name="realizado" ng-model="analise.realizado" style="padding:20px;" ng-change="AtualizarRealizado(analise.realizado, analise)"></td><td class="text-right"><button ng-click="open(\'app/pages/contratos/produtos/analise-contratual/formanaliseContratual.html\', \'lg\', \'An\xE1lise Cr\xEDtica Contratual\', analise)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Analise Contratual\', analise)" data-toggle="modal" data-id="{{analise.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/contratos/produtos/analise-contratual/formanaliseContratual.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(analise)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="observacao" class="control-label">An\xE1lise Critica Contatual</label> <textarea style="height:300px;" name="observacao" id="observacao" ng-model="analise.descricao" class="form-control col-xs-12"></textarea></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/contratos/produtos/analise-operacional/analiseOperacional.html','<div style="margin-top:20px;"><div class="text-left"><h3>An\xE1lise Cr\xEDtica Operacional</h3></div><div style="padding-right: 15px" class="text-right"><button ng-click="open(\'app/pages/contratos/produtos/analise-operacional/formanaliseOperacional.html\', \'lg\', \'An\xE1lise Cr\xEDtica Operacional\', analise)" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="descricao">Descri\xE7\xE3o</th><th style="width:150px;" class="text-center">Data</th><th style="width:150px;padding-right:20px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="analise in displayed"><td class="ellipsis">{{analise.descricao}}</td><td class="text-right">{{analise.dataCriacao | date: "dd/MM/y"}}</td><td class="text-right"><button ng-click="open(\'app/pages/contratos/produtos/analise-operacional/formanaliseOperacional.html\', \'lg\', \'An\xE1lise Cr\xEDtica Operacional\', analise)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'An\xE1lise Operacional\', analise)" data-toggle="modal" data-id="{{analise.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div>');
$templateCache.put('app/pages/contratos/produtos/analise-operacional/formanaliseOperacional.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(analise)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="observacao" class="control-label">An\xE1lise Critica Contatual</label> <textarea style="height:300px;" name="observacao" id="observacao" ng-model="analise.descricao" class="form-control col-xs-12"></textarea></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/contratos/produtos/modais/contaConfirm.html','<div class="panel panel-default bootstrap-panel"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">X</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><h4>Voc\xEA tem certeza que deseja gerar a conta a receber {{produto.descricao}} ?</h4></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button ng-click="gerarConta(produto)" class="btn btn-success">Comfirmar</button></div></div>');
$templateCache.put('app/pages/contratos/produtos/modais/form-produtos.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(prod)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="contrato" class="control-label">Contrato de Cliente</label><select-contrato-externo name="contrato" id="contrato" ng-model="prod.contratoExterno" required="required" ng-change="onContratoChange(prod.contratoExterno)"></select-contrato-externo></div></div><div class="col-md-3"><div class="form-group"><label for="dataContrato" class="control-label">Dia do Contrato</label> <input type="text" name="dataContrato" id="dataContrato" ng-model="prod.diaDoContrato" ui-mask="99" required="required" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="dataPrevisto" class="control-label">Dia Previsto</label> <input type="text" name="dataPrevisto" id="dataPrevisto" ng-model="prod.diaPrevisto" ui-mask="99" required="required" class="form-control text-center"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="prod.descricao" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="dataInicial" class="control-label">Data Inicial</label> <input type="date" name="dataInicial" id="dataInicial" ng-model="prod.dataInicial" required="required" ng-disabled="isValores==true" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="dataFinal" class="control-label">Data Final</label> <input type="date" name="dataFinal" id="dataFinal" ng-model="prod.dataFinal" required="required" ng-disabled="isValores==true" class="form-control text-center"></div></div><div ng-hide="isValores==true" class="col-md-3"><div class="form-group"><label for="valor" class="control-label">Valor</label> <input type="text" name="valor" id="valor" ng-model="prod.valor" ng-blur="prod.valorEmpresa=onValorBlur(.valor)" mask="real" required="required" class="form-control text-right"></div></div><div ng-hide="isValores==true" class="col-md-3"><div class="form-group"><label for="valorEmpresa" class="control-label">Valor da Empresa</label> <input type="text" name="valorEmpresa" id="valorEmpresa" ng-model="prod.valorEmpresa" mask="real" required="required" class="form-control text-right"></div></div></div></div><div ng-show="isValores==true"><div class="table-responsive"><table st-table="prod.valores" class="table table-striped table-hover"><thead><tr class="sortable"><th>Data</th><th class="text-right">Valor</th><th class="text-right">Valor Empresa</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="v in prod.valores"><td>{{v.data | date: "dd/MM/yyyy"}}</td><td><input type="text" name="valor" id="valor" ng-model="v.valor" mask="real" ng-blur="v.valorEmpresa=onValorBlur(v.valor)" required="required" style="height:25px;margin-top:5px;" class="form-control text-right"></td><td><input type="text" name="valorEmpresa" id="valorEmpresa" ng-model="v.valorEmpresa" mask="real" required="required" style="height:25px;margin-top:5px;" class="form-control text-right"></td></tr></tbody></table></div></div></div><div class="panel-footer text-right"><button type="button" ng-click="editarValores(prod.dataInicial, prod.dataFinal)" ng-hide="isValores==true" class="btn btn-warning">Editar Valores</button> <button type="button" ng-click="valorUnico();" ng-show="isValores==true" class="btn btn-warning">Valor Unico</button> <button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/financeiro/plano-de-conta/item-plano-de-conta/formitem-plano-de-conta.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(itemPlanoDeConta)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="codigo" class="control-label">C\xF3digo</label> <input type="text" name="codigo" id="codigo" ng-model="itemPlanoDeConta.codigo" ng-disabled="disabled" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="tipoItemPlanoDeConta" class="control-label">Tipo de Item</label><select-enum name="valorRealizado" id="valorRealizado" ng-model="itemPlanoDeConta.tipoItemPlanoDeConta" tipo="TipoItemPlanoDeConta" tipo-label="tipo" ng-disabled="disabled"></select-enum></div></div><div class="col-md-12"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" type="text" ng-model="itemPlanoDeConta.descricao" ng-disabled="disabled" class="form-control"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="valorPrevisto" class="control-label">Valor Previsto (R$)</label> <input type="text" name="valorPrevisto" id="valorPrevisto" ng-model="itemPlanoDeConta.valorPrevisto" mask="real" ng-disabled="disabled" class="form-control text-right"></div></div><div class="col-md-6"><div class="form-group"><label for="valorMedido" class="control-label">Valor Medido (R$)</label> <input type="text" name="valorMedido" id="valorMedido" ng-model="itemPlanoDeConta.valorMedido" mask="real" ng-disabled="disabled" class="form-control text-right"></div></div></div></div><div ng-if="!disabled" class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/financeiro/plano-de-conta/item-plano-de-conta/item-plano-de-conta.html','<div style="margin-top:20px;"><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><div class="text-right"><a ng-if="!authService.isInRole(\'ROLE_USUARIO_[A-Z]+\')" ui-sref="gerencial.orcamento-economico({planoDeContaId: plano.id})" tooltip="" title="Contas a Receber" data-placement="top" class="btn btn-info">Gr\xE1fico</a></div></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="codigo">C\xF3digo</th><th st-sort="descricao">Descri\xE7\xE3o</th><th st-sort="tipoItemPlanoDeConta">Tipo</th><th st-sort="valorPrevisto" class="text-right">Valor Previsto (R$)</th><th st-sort="valorMedido" class="text-right">Valor Medido (R$)</th><th style="width:180px !important; padding-right: 20px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="item in displayed"><td>{{item.codigo}}</td><td>{{item.descricao}}</td><td>{{item.tipoItemPlanoDeConta.descricao}}</td><td class="text-right">{{item.valorPrevisto | mask:"real"}}</td><td class="text-right">{{item.valorMedido | mask:"real"}}</td><td class="text-right"><button ng-if="item.tipoItemPlanoDeConta.name==\'ANALITICO\'" ui-sref="economico.valor-previsto-plano-conta({ itemPlanoId: item.id })" tooltip="" title="Valor Previsto" data-placement="top" class="btn btn-link"><span class="i ion ion-cash"></span></button> <button ng-click="open(\'app/pages/financeiro/plano-de-conta/item-plano-de-conta/formitem-plano-de-conta.html\', \'lg\', \'Item\', item)" data-toggle="modal" data-id="{{item.id}}" tooltip="" title="Visualizar Informa\xE7\xF5es do Item" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-eye-open"></span></button> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'lg\', \'O Item \'+ item.codigo, item)" data-toggle="modal" data-id="{{item.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="4" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/area/area.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto=true" class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="!aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button> <button ng-disabled="!authService.isInRole(\'ROLE_AREA_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/area/formarea.html\', \'lg\', \'Area\', area)" data-toggle="modal" title="Editar" data-placement="top" class="btn btn-warning">Adicionar</button></div></div><div uib-collapse="aberto" style="margin-top:20px;margin-bottom:20px;"><div ng-include="\'app/pages/licitacoes/configuracaoperspectivas/area/areaSearch.html\'"></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="codigo">C\xF3digo</th><th st-sort="descricao">Descri\xE7\xE3o</th><th style="padding:20px;width:120px;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="area in displayed"><td class="ellipsis">{{area.codigo}}</td><td class="sortable-space-right">{{area.descricao}}</td><td class="text-center"><button ng-disabled="!authService.isInRole(\'ROLE_AREA_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/area/formarea.html\', \'lg\', \'Area\', area)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_AREA_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'\xC1rea \'+area.descricao, area)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="5" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/area/areaSearch.html','<form class="form"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" ng-model="filtro.codigo" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="filtro.descricao" class="form-control"></div></div></div></div><div class="row"><div class="form-group"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></div></form>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/area/formarea.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(area)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="codigo">C\xF3digo</label> <input id="codigo" name="codigo" ng-model="area.codigo" required="required" style="text-align: center;" class="form-control"></div></div><div class="col-md-10"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" type="text" id="descricao" ng-model="area.descricao" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/parceiros/formparceiros.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-body"><form ng-submit="save(parceiro)" name="form" method="post" class="form"><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="cnpj">CNPJ</label> <input name="cnpj" id="cnpj" type="text" ng-model="parceiro.pessoaJuridica.cnpj" ng-blur="onCnpjBlur(parceiro.pessoaJuridica.cnpj)" required="required" ui-mask="99.999.999/9999-99" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="nome">Raz\xE3o Social</label> <input name="nome" id="nome" type="text" ng-model="parceiro.pessoaJuridica.pessoa.nome" required="required" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="nomeFantasia">Noma Fantasia</label> <input name="nomeFantasia" id="nomeFantasia" type="text" ng-model="parceiro.pessoaJuridica.nomeFantasia" required="required" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="email">Email</label><div class="input-group"><input name="email" id="email" ia-describedby="basic-addon2" type="email" ng-model="parceiro.pessoaJuridica.pessoa.email" required="required" class="form-control with-warning-addon"><span id="basic-addon2" class="input-group-addon input-group-addon-warning addon-right">@example.com</span></div></div></div><div class="col-md-6"><div class="form-group"><label for="inscricaoMunicipal">Inscri\xE7\xE3o Municipal</label> <input name="inscricaoMunicipal" id="inscricaoMunicipal" type="text" ng-model="parceiro.pessoaJuridica.pessoa.inscricaoMunicipal" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="inscricaoEstadual">Inscri\xE7\xE3o Estadual</label> <input name="inscricaoEstadual" id="inscricaoEstadual" type="text" ng-model="parceiro.pessoaJuridica.pessoa.inscricaoEstadual" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="site">Site</label> <input name="site" id="site" type="text" ng-model="parceiro.pessoaJuridica.site" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="area">\xC1rea</label><select-area name="area" id="area" ng-model="parceiro.area"></select-area></div></div></div></div><div ng-include="\'app/pages/cadastrosbasicos/endereco/endereco.html\'"></div><div class="text-right"><button type="button" ng-click="clear()" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/parceiros/parceiros.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto=false" class="panel panel-default bootstrap-panel"><div class="panel-body"><div uib-collapse="!aberto" style="margin-top:20px; margin-bottom:30px;" class="div"><form class="form"><div ng-include="\'app/pages/licitacoes/configuracaoperspectivas/parceiros/parceirosSearch.html\'"></div><div class="row"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button ng-click="search()" class="btn btn-success">Buscar</button></div></div></form></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button><a ng-disabled="!authService.isInRole(\'ROLE_PARCEIRO_[A-Z]*C[A-Z]*\')" ui-sref="cadastrosbasicos.formparceiros" class="btn btn-warning">Adicionar</a></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="pessoaJuridica.pessoa.nome">Raz\xE3o Social</th><th st-sort="pessoaJuridica.nomeFantasia">Nome Fantasia</th><th st-sort="pessoaJuridica.cnpj">CNPJ</th><th st-sort="area.descricao">\xC1rea</th><th st-sort="pessoaJuridica.pessoa.endereco.logradouro">Logradouro</th><th st-sort="pessoaJuridica.pessoa.endereco.codigoPostal" class="text-center">CEP</th><th style="width:120px !important;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="parceiro in displayed"><td>{{parceiro.pessoaJuridica.pessoa.nome}}</td><td>{{parceiro.pessoaJuridica.nomeFantasia}}</td><td>{{parceiro.pessoaJuridica.cnpj}}</td><td>{{parceiro.area.descricao}}</td><td>{{parceiro.pessoaJuridica.pessoa.endereco.logradouro}}</td><td class="text-center">{{parceiro.pessoaJuridica.pessoa.endereco.codigoPostal}}</td><td class="text-right"><a ng-disabled="!authService.isInRole(\'ROLE_PARCEIRO_[A-Z]*U[A-Z]*\')" ui-sref="cadastrosbasicos.formparceiros({parceiroId:parceiro.id})" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></a> <button ng-disabled="!authService.isInRole(\'ROLE_PARCEIRO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Parceiro \'+parceiro.descricao, parceiro)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="7" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="7" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="6" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/parceiros/parceirosSearch.html','<div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="cnpj">CNPJ</label> <input name="cnpj" id="cnpj" type="text" ng-model="filtro.cnpj" mask="cnpj" class="form-control"></div></div><div class="col-md-9"><div class="form-group"><label for="nomeFantasia">Nome Fantasia</label> <input name="nomeFantasia" id="nomeFantasia" type="text" ng-model="filtro.nomeFantasia" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="area">\xC1rea</label><select-area name="area" ng-model="filtro.area" class="form-control"></select-area></div></div><div class="col-md-9"><div class="form-group"><label for="razaoSocial">Raz\xE3o Social</label> <input name="razaoSocial" id="razaoSocial" type="text" ng-model="filtro.nome" class="form-control"></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/regiaodeatuacao/formregiaodeatuacao.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(regiao)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" ng-model="regiao.codigo" required="required" class="form-control text-center"></div></div><div class="col-md-10"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="regiao.descricao" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/regiaodeatuacao/regiaodeatuacao.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_REGIAOATUACAO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/regiaodeatuacao/formregiaodeatuacao.html\', \'lg\', \'Regi\xE3o de Atua\xE7\xE3o\', regiao)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="codigo">C\xF3digo</th><th st-sort="descricao">Descri\xE7\xE3o</th><th style="padding:20px; width:120px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="regiao in displayed"><td class="ellipsis">{{regiao.codigo}}</td><td class="sortable-space-right">{{regiao.descricao}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_REGIAOATUACAO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/regiaodeatuacao/formregiaodeatuacao.html\', \'lg\', \'Regi\xE3o de Atua\xE7\xE3o\', regiao)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_REGIAOATUACAO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Regi\xE3o de Atua\xE7\xE3o \'+regiao.descricao, regiao)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/situacao-perspectiva/formsituacaoperspectiva.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(situacao)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="sequencia">Sequ\xEAncia</label> <input name="sequencia" id="sequencia" ng-model="situacao.sequencia" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" ng-model="situacao.codigo" required="required" class="form-control text-center"></div></div><div class="col-md-8"><div class="form-group"><label for="tipoLicitacao">Tipo de Licita\xE7\xE3o</label><select-tipo-licitacao name="tipoLicitacao" id="tipoLicitacao" ng-model="situacao.tipoLicitacao" required="required"></select-tipo-licitacao></div></div><div class="col-md-12"><div class="form-group"><label for="situacaoPerspectiva">Predecessor</label><select-situacao-perspectiva name="situacaoPerspectiva" id="situacaoPerspectiva" ng-model="situacao.situacaoPerspectiva" ng-disabled="situacao.tipoLicitacao.id == null" watch-to="situacao.tipoLicitacao"></select-situacao-perspectiva></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="situacao.descricao" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="observacao">Observa\xE7\xE3o</label> <textarea name="observacao" id="observacao" ng-model="situacao.observacao" class="form-control"></textarea></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/situacao-perspectiva/situacaoperspectiva.html','<div><div class="row"><div class="col-xs-12"><div ng-init="aberto=true" class="panel panel-default bootstrap-panel"><div class="panel-body"><div uib-collapse="aberto" style="margin-top:20px;margin-bottom:20px;" class="div"><div ng-include="\'app/pages/licitacoes/configuracaoperspectivas/situacao-perspectiva/situacaoperspectivaSearch.html\'"></div></div><div class="row"><div class="col-md-4 text-left"><input ng-change="search()" ng-model="filtro.search" type="text" placeholder="Pesquisar..." ng-disabled="!aberto" class="typeahead form-control"></div><div style="padding-right: 15px" class="col-md-8 text-right"><button type="button" ng-click="aberto = !aberto" class="btn btn-info"><i class="glyphicon glyphicon-search"></i> Busca avan\xE7ada</button> <button ng-disabled="!authService.isInRole(\'ROLE_SITUACAO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/situacao-perspectiva/formsituacaoperspectiva.html\', \'lg\', \'Situa\xE7\xE3o de Perspectiva\', situacao)" data-toggle="modal" tooltip="" title="Editar" data-placement="center" class="btn btn-warning">Adicionar</button></div></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="tipoLicitacao">Tipo de Licitacao</th><th st-sort="sequencia">Sequ\xEAncia</th><th st-sort="codigo">C\xF3digo</th><th st-sort="situacaoPerspectiva.descricao">Predecessor</th><th st-sort="descricao">Descri\xE7\xE3o</th><th style="padding:20px; width:120px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="situacao in displayed"><td>{{situacao.tipoLicitacao.descricao}}</td><td>{{situacao.sequencia}}</td><td>{{situacao.codigo}}</td><td>{{situacao.situacaoPerspectiva.descricao}}</td><td>{{situacao.descricao}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_SITUACAO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/situacao-perspectiva/formsituacaoperspectiva.html\', \'lg\', \'Situa\xE7\xE3o da Perspectiva\', situacao)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_SITUACAO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Situa\xE7\xE3o da Perspectiva \'+situacao.codigo, situacao)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/situacao-perspectiva/situacaoperspectivaSearch.html','<form class="form"><div class="row"><div class="col-md"><div class="col-md-1"><div class="form-group"><label for="sequencia">Sequ\xEAncia</label> <input name="sequencia" id="sequencia" ng-model="filtro.sequencia" class="form-control text-center"></div></div><div class="col-md-4"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" ng-model="filtro.codigo" class="form-control"></div></div><div class="col-md-3"><div class="form-group"><label for="tipoLicitacao">Tipo de Licita\xE7\xE3o</label><select-tipo-licitacao name="tipoLicitacao" id="tipoLicitacao" ng-model="filtro.tipoLicitacao"></select-tipo-licitacao></div></div><div class="col-md-4"><div class="form-group"><label for="situacaoPerspectiva">Predecessor</label><select-situacao-perspectiva name="situacaoPerspectiva" id="situacaoPerspectiva" ng-model="filtro.situacaoPerspectiva" ng-disabled="filtro.tipoLicitacao.id == null" watch-to="filtro.tipoLicitacao"></select-situacao-perspectiva></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="filtro.descricao" class="form-control"></div></div></div></div><div class="row"><div class="form-group"><div class="col-md-12 text-right"><button type="button" ng-click="clear()" class="btn btn-default">Limpar</button> <button type="submit" ng-click="search()" class="btn btn-success">Buscar</button></div></div></div></form>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/subarea/formsubarea.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(subArea)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="codigo">C\xF3digo</label> <input id="codigo" name="codigo" ng-model="subArea.codigo" required="required" style="text-align: center;" class="form-control"></div></div><div class="col-md-10"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" type="text" id="descricao" ng-model="subArea.descricao" required="required" maxlength="255" ng-maxlength="255" class="form-control"></div></div><div class="col-md-12"><div class="form-group"><label for="area">\xC1rea</label><select-area name="area" id="area" ng-model="subArea.area" required="required"></select-area></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/subarea/subarea.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_SUBAREA_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/subarea/formsubarea.html\', \'lg\', \'SubArea\', subArea)" data-toggle="modal" title="Editar" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="codigo">C\xF3digo</th><th st-sort="descricao">Descri\xE7\xE3o</th><th st-sort="area.descricao">Descri\xE7\xE3o</th><th style="padding:20px;width:120px;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="subarea in displayed"><td class="ellipsis">{{subarea.codigo}}</td><td class="sortable-space-right">{{subarea.descricao}}</td><td class="sortable-space-right">{{subarea.area.descricao}}</td><td class="text-center"><button ng-disabled="!authService.isInRole(\'ROLE_SUBAREA_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/subarea/formsubarea.html\', \'lg\', \'SubArea\', subarea)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_SUBAREA_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Sub\xC1rea \'+subarea.descricao, subarea)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="4" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="3" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/tipodelicitacao/formtipodelicitacao.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(tipoLicitacao)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" ng-model="tipoLicitacao.codigo" required="required" class="form-control text-center"></div></div><div class="col-md-2"><div class="form-group"><label for="sigla">Sigla</label> <input name="sigla" id="sigla" ng-model="tipoLicitacao.sigla" required="required" class="form-control text-center"></div></div><div class="col-md-8"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="tipoLicitacao.descricao" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/tipodelicitacao/tipodelicitacao.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_TIPOLICITACAO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/tipodelicitacao/formtipodelicitacao.html\', \'lg\', \'Tipo de Licita\xE7\xE3o\', tipoLicitacao)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="codigo">C\xF3digo</th><th st-sort="sigla">Sigla</th><th st-sort="descricao">Descri\xE7\xE3o</th><th style="padding:20px; width:120px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="tipoLicitacao in displayed"><td class="ellipsis">{{tipoLicitacao.codigo}}</td><td>{{tipoLicitacao.sigla}}</td><td class="sortable-space-right">{{tipoLicitacao.descricao}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_TIPOLICITACAO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/tipodelicitacao/formtipodelicitacao.html\', \'lg\', \'Tipo de Licita\xE7\xE3o\', tipoLicitacao)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_TIPOLICITACAO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Tipo de Licita\xE7\xE3o \'+tipoLicitacao.sigla, tipoLicitacao)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="4" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="4" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="3" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/tipodeperspectiva/formtipoperspectiva.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(tipoPerspectiva)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" ng-model="tipoPerspectiva.codigo" required="required" class="form-control text-center"></div></div><div class="col-md-10"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="tipoPerspectiva.descricao" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/tipodeperspectiva/tipoperspectiva.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_TIPOPERSPECTIVA_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/tipodeperspectiva/formtipoperspectiva.html\', \'lg\', \'Tipo de Perspectiva\', tipoPerspectiva)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="codigo">C\xF3digo</th><th st-sort="descricao">Descri\xE7\xE3o</th><th style="padding:20px; width:120px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="tipoPerspectiva in displayed"><td class="ellipsis">{{tipoPerspectiva.codigo}}</td><td class="sortable-space-right">{{tipoPerspectiva.descricao}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_TIPOPERSPECTIVA_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/tipodeperspectiva/formtipoperspectiva.html\', \'lg\', \'Tipo de Perspectiva\', tipoPerspectiva)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_TIPOPERSPECTIVA_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Tipo de Perspectiva \'+tipoPerspectiva.descricao, tipoPerspectiva)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/tipodeservico/formtipodeservico.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(tipoServico)" name="form" method="post" class="form-vertical"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><label for="codigo">C\xF3digo</label> <input name="codigo" id="codigo" ng-model="tipoServico.codigo" required="required" class="form-control text-center"></div></div><div class="col-md-10"><div class="form-group"><label for="descricao">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="tipoServico.descricao" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/configuracaoperspectivas/tipodeservico/tipodeservico.html','<div><div class="row"><div class="col-xs-12"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_TIPOSERVICO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/tipodeservico/formtipodeservico.html\', \'lg\', \'Tipo de Servi\xE7o\', tipoServico)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="codigo">C\xF3digo</th><th st-sort="descricao">Descri\xE7\xE3o</th><th style="padding:20px; width:120px;" class="text-right">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="tipoServico in displayed"><td class="ellipsis">{{tipoServico.codigo}}</td><td class="sortable-space-right">{{tipoServico.descricao}}</td><td class="text-right"><button ng-disabled="!authService.isInRole(\'ROLE_TIPOSERVICO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/configuracaoperspectivas/tipodeservico/formtipodeservico.html\', \'lg\', \'Tipo de Servi\xE7o\', tipoServico)" data-toggle="modal" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-disabled="!authService.isInRole(\'ROLE_TIPOSERVICO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Tipo de Servi\xE7o \'+tipoServico.descricao, tipoServico)" data-toggle="modal" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/historico-perspectiva/formhistorico-perspectiva.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(historicoPerspectiva)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-8"><div class="form-group"><label for="situacaoPerspectiva">Situa\xE7\xE3o Atual</label><select name="situacaoPerspectiva" id="situacaoPerspectiva" ng-model="historicoPerspectiva.situacaoPerspectiva" ng-options="situacao as situacao.senquencia+\' \'+situacao.descricao for situacao in situacoes |orderBy:\'codigo\' track by situacao.id" required="required" class="form-control"><option value="">Selecione uma Situa\xE7\xE3o</option></select></div></div><div class="col-md-4"><div class="form-group"><label for="dataHistorico">Data do Marco da Situa\xE7\xE3o</label> <input type="date" id="dataHistorico" name="dataHistorico" ng-model="historicoPerspectiva.data" style="text-align:center" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="observacao" class="control-label">Observa\xE7\xF5es</label> <textarea style="height:300px;" name="observacao" id="observacao" ng-model="historicoPerspectiva.observacao" class="form-control col-xs-12"></textarea></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/historico-perspectiva/historico-perspectiva.html','<h3 style="margin-top:20px">Hist\xF3rico<hr></h3><div class="text-right"><button type="button" ng-hide="!authService.isInRole(\'ROLE_HISTORICOPERSPECTIVA_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/perspectivas/historico-perspectiva/formhistorico-perspectiva.html\', \'lg\', \'Historico de Perspectiva\', historicoPerspectiva)" tooltip="" title="Novo Historico" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th>Situa\xE7\xE3o</th><th>Observa\xE7\xF5es</th><th>Autor</th><th class="text-center">Data</th><th style="width:150px !important" ng-hide="!authService.isInRole(\'ROLE_HISTORICOPERSPECTIVA_[A-Z]*D[A-Z]*\')" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="historico in displayed | orderBy:\'-data\'"><td>{{historico.situacaoPerspectiva.descricao}}</td><td>{{historico.observacao}}</td><td>{{historico.usuario.pessoaFisica.pessoa.nome}}</td><td class="text-center">{{historico.data | date:"dd/MM/y"}}</td><td class="text-center"><button type="button" ng-hide="!authService.isInRole(\'ROLE_HISTORICOPERSPECTIVA_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/perspectivas/historico-perspectiva/formhistorico-perspectiva.html\', \'lg\', \'Historico de Perspectiva\', historico)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-hide="!authService.isInRole(\'ROLE_HISTORICOPERSPECTIVA_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Historico de Perspectiva \'+ perspectiva.numeroEdital, historico)" data-toggle="modal" data-id="{{historico.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="5" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="5" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="4" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/historico-perspectiva/viewhistoricoperspectivas.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-heading"><h3>Informa\xE7\xF5es B\xE1sicas</h3></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>C\xF3digo</h4><p>{{perspectiva.codigo}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>N\xFAmero Edital</h4><p>{{perspectiva.numeroEdital}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Pasta dos Documentos</h4><p>{{perspectiva.folder}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Tipo de Perspectiva</h4><p>{{perspectiva.tipoPerspectiva.descricao}}</p></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><h4>T\xEDtulo</h4><p>{{perspectiva.titulo}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Fonte de Recurso</h4><p>{{perspectiva.fonteDeRecurso.nome}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Respons\xE1vel</h4><p>{{perspectiva.autor.pessoaFisica.pessoa.nome}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Cliente</h4><p>{{perspectiva.cliente.pessoaJuridica.pessoa.nome}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Pa\xEDs</h4><p>{{perspectiva.pais.nome}}</p></div></div><div ng-show="perspectiva.estado != null" class="col-md-4"><div class="form-group"><h4>Estado</h4><p>{{perspectiva.estado}}</p></div></div><div ng-show="perspectiva.cidades != null" class="col-md-4"><div class="form-group"><h4>Cidade</h4><p>{{perspectiva.cidade}}</p></div></div></div></div><div ng-include="\'app/pages/licitacoes/parceiro/viewparceiro.html\'"></div><h3 style="margin-top:20px;">Descri\xE7\xE3o/Observa\xE7\xF5es<hr><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><h4>Descri\xE7\xE3o</h4><p>{{perspectiva.descricao}}</p></div></div><div class="col-md-6"><div class="form-group"><h4>Observa\xE7\xF5es</h4><p>{{perspectiva.observacao}}</p></div></div></div></div></h3><h3 style="margin-top:20px;">Tipo de Servi\xE7o/\xC1rea/Ger\xEAncia<hr><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><h4>\xC1rea</h4><p>{{perspectiva.area.descricao}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Ger\xEAncia</h4><p>{{perspectiva.regiaoAtuacao.descricao}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Regi\xE3o</h4><p>{{perspectiva.regiao.descricao}}</p></div></div><div class="col-md-4"><div class="form-group"><h4>Previs\xE3o de Contrata\xE7\xE3o</h4><p>{{perspectiva.previsaoContratacao}}</p></div></div></div></div></h3><h3 style="margin-top:20px">Valores/Percentuais<hr><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>Valor Edital (R$)</h4><p>{{perspectiva.valorEdital}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Valor Total (R$)</h4><p>{{perspectiva.valorTotal}}</p></div></div><div class="col-md-1"><div class="form-group"><h4>Desconto (%)</h4><p>{{perspectiva.desconto}}</p></div></div><div class="col-md-1"><div class="form-group"><h4>% Empresa</h4><p>{{perspectiva.percentualEmpresa}}\'</p></div></div><div class="col-md-2"><div class="form-group"><h4>Valor da Empresa (R$)</h4><p>{{perspectiva.valor}}</p></div></div><div class="col-md-1"><div class="form-group"><h4>% de Sucesso</h4><p>{{perspectiva.percentualSucesso}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Valor de Sucesso (R$)</h4><p>{{perspectiva.valorSucesso}}</p></div></div></div></div></h3><h3 style="margin-top:20px">Tipo de Licita\xE7\xE3o/Situa\xE7\xF5es/Resultados<hr><div class="row"><div class="col-md"><div class="col-md-2"><div class="form-group"><h4>Data da Apresenta\xE7\xE3o</h4><p>{{perspectiva.dataApresentacao | date:"dd/MM/y"}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Tipo de Licita\xE7\xE3o</h4><p>{{perspectiva.tipoLicitacao.descricao}}</p></div></div><div class="col-md-2"><div class="form-group"><h4>Situa\xE7\xE3o Atual</h4><p>{{perspectiva.situacao.descricao}}</p></div></div></div></div></h3><div class="text-right"><buttom type="button" ng-click="clear()" class="btn btn-danger">Voltar</buttom></div><div ng-show="perspectiva.id != null"><div style="margin-top:20px;" ng-include="\'app/pages/licitacoes/perspectivas/historico-perspectiva/historico-perspectiva.html\'" ng-if="perspectiva.id!= null" ng-controller="HistoricoPerspectivaCtrl"></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/modais/modalClonePerspectiva.html','<div class="panel panel-default bootstrap-panel"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="tipoLicitacao">Tipo de Licita\xE7\xE3o</label><select-tipo-licitacao name="tipoLicitacao" id="tipoLicitacao" ng-model="clone.tipoLicitacao" ng-change="onTipoLicitacaoChange(clone.tipoLicitacao)"></select-tipo-licitacao></div></div><div class="col-md-6"><div class="form-group"><label for="situacaoPerspectiva">Situa\xE7\xE3o Atual</label><select name="situacaoPerspectiva" id="situacaoPerspectiva" ng-model="clone.situacaoPerspectiva" ng-change="onSituacaoPerspectivaChange(clone.tipoLicitacao, clone.situacaoPerspectiva)" ng-disabled="clone.tipoLicitacao.id == null" ng-options="situacao as situacao.senquencia+\' \'+situacao.descricao for situacao in situacoes |orderBy:\'codigo\' track by situacao.id" class="form-control"><option value="">Selecione uma Situa\xE7\xE3o</option></select></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" ng-click="clonePerspectiva(perspectiva, clone)" class="btn btn-success">Confirmar</button></div></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/modais/modalHistoricoPerspectiva.html','<div class="panel panel-default bootstrap-panel"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr class="sortable"><th>Situa\xE7\xE3o</th><th>Data</th></tr></thead><tbody><tr ng-repeat="historico in perspectiva.historicoPerspectiva"><td>{{historico.situacaoPerspectiva.descricao}}</td><td>{{historico.dataCriacao}}</td></tr></tbody><tbody ng-show="perspectica.historicoPerspectiva.length==0"><tr><td colspan="2" class="text-center">Sem registros!</td></tr></tbody></table></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button></div></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/perspectiva-concorrente/form-perspectiva-concorrente.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(perspectivaConcorrente)" name="concorrenteform" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-8"><div class="form-group"><label for="pessoa-juridica">Pessoa Juridica</label><select-pessoa-juridica name="pessoa-juridica" id="pessoa-juridica" ng-model="perspectivaConcorrente.pessoaJuridica"></select-pessoa-juridica></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/perspectiva-concorrente/formhistorico-perspectiva.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(historicoPerspectiva)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-8"><div class="form-group"><label for="situacaoPerspectiva">Situa\xE7\xE3o Atual</label><select name="situacaoPerspectiva" id="situacaoPerspectiva" ng-model="historicoPerspectiva.situacaoPerspectiva" ng-change="onSituacaoPerspectivaChange(perspectiva.tipoLicitacao, historicoPerspectiva.situacaoPerspectiva)" ng-disabled="perspectiva.tipoLicitacao.id == null" ng-options="situacao as situacao.senquencia+\' \'+situacao.descricao for situacao in situacoes |orderBy:\'codigo\' track by situacao.id" required="required" class="form-control"><option value="">Selecione uma Situa\xE7\xE3o</option></select></div></div><div class="col-md-4"><div class="form-group"><label for="dataHistorico">Data da Transi\xE7\xE3o</label> <input type="date" id="dataHistorico" name="dataHistorico" ng-model="historicoPerspectiva.data" style="text-align:center" required="required" class="form-control"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/perspectiva-concorrente/perspectiva-concorrente.html','<h3 style="margin-top:20px">Concorrentes<hr></h3><div class="text-right"><button type="button" ng-hide="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/perspectivas/perspectiva-concorrente/form-perspectiva-concorrente.html\', \'lg\', \'Concorrente de Perspectiva\', perspectivaConcorrente)" tooltip="" title="Novo Concorrente" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th>Nome</th><th>Cnpj</th><th style="width:150px !important" ng-hide="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*D[A-Z]*\')" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="perspectivaConcorrente in displayed | orderBy:\'pessoaJuridica.nomeFantasia\'"><td>{{perspectivaConcorrente.pessoaJuridica.nomeFantasia}}</td><td>{{perspectivaConcorrente.pessoaJuridica.cnpj}}</td><td class="text-center"><button type="button" ng-hide="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/perspectivas/perspectiva-concorrente/form-perspectiva-concorrente.html\', \'lg\', \'Concorente\', perspectivaConcorrente)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-hide="!authService.isInRole(\'ROLE_PERSPECTIVA_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Concorrente \'+ perspectiva.numeroEdital, perspectivaConcorrente)" data-toggle="modal" data-id="{{perspectivaConcorrente.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="3" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="3" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="2" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/form-solicitacao-juridico-perspectiva.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="saveEntity(solicitacaoJuridico, clear, &quot;solicitacaoJuridicoPerspectivaCtrl&quot;)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><h5>Ao salvar as informa\xE7\xF5es, um e-mail ser\xE1 automaticamente enviado para os setores envolvidos. Certifique-se de revisar todas as informa\xE7\xF5es antes de prosseguir, pois as partes interessadas ser\xE3o notificadas.</h5></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="tipoAcaoJuridico">Tipo de A\xE7\xE3o Solicitado</label><select-enum name="tipoAcaoJuridico" id="tipoAcaoJuridico" ng-model="solicitacaoJuridico.tipoAcaoJuridico" tipo="TipoAcaoJuridico" tipo-label="Tipo de A\xE7\xE3o do Jur\xEDdico" ng-disabled="isLoading" required="required"></select-enum></div></div><div class="col-md-6"><div class="form-group"><label for="dataSolicitacao">Data da Solicita\xE7\xE3o</label> <input type="date" id="dataSolicitacao" name="dataSolicitacao" ng-model="solicitacaoJuridico.dataSolicitacao" style="text-align:center" ng-disabled="isLoading" required="required" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="dataApresentacao">Data de Apresenta\xE7\xE3o</label> <input type="date" id="dataApresentacao" name="dataApresentacao" ng-model="solicitacaoJuridico.dataApresentacao" style="text-align:center" ng-disabled="isLoading" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="observacao" class="control-label">Observa\xE7\xF5es</label> <textarea style="height:300px;" name="observacao" id="observacao" ng-model="solicitacaoJuridico.observacao" ng-disabled="isLoading" class="form-control col-xs-12"></textarea></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" ng-if="!isLoading" class="btn btn-danger">Cancelar</button> <button type="submit" ng-disabled="isLoading" class="btn btn-success">{{ isLoading ? "Processando Informa\xE7\xF5es..." : "Salvar" }}</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/solicitacao-juridico-perspectiva.html','<h3 style="margin-top:20px">Solicita\xE7\xF5es ao Departamento Jur\xEDdico<hr></h3><div class="text-right"><button type="button" ng-hide="!authService.isInRole(\'ROLE_SOLICITACAO_JURIDICO_[A-Z]*C[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/form-solicitacao-juridico-perspectiva.html\', \'lg\', \'Solicita\xE7\xE3o para o Departamento Jur\xEDdico\', solicitacaoJuridico)" tooltip="" title="Solicita\xE7\xE3o para o Departamento Jur\xEDdico" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th>Data da Solicita\xE7\xE3o</th><th>Data da Apresenta\xE7\xE3o</th><th>Tipo de A\xE7\xE3o</th><th>Observa\xE7\xE3o</th><th>Decis\xE3o do Provimento</th><th style="width:150px !important" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="solicitacao in displayed | orderBy:\'-data\'"><td>{{ solicitacao.dataSolicitacao | date:"dd/MM/y" }}</td><td>{{ solicitacao.dataApresentacao | date:"dd/MM/y" }}</td><td>{{ solicitacao.tipoAcaoJuridico.descricao }}</td><td><p style="white-space: pre-wrap;" ng-if="solicitacao.observacao">{{ solicitacao.observacao.length > 50 ? solicitacao.observacao.substring(0, 50) + \'...\' : solicitacao.observacao }}</p></td><td>{{ solicitacao.provimentoSolicitacao ? solicitacao.provimentoSolicitacao.decisaoCliente.descricao : \'-\' }}</td><td class="text-center"><div uib-dropdown="" dropdown-append-to-body="" class="btn-group"><a ui-sref="licitacoes.respostaJuridicoPerspectiva({solicitacaoJuridicoId: solicitacao.id})" tooltip="Respostas da Solicita\xE7\xE3o" title="Respostas da Solicita\xE7\xE3o" data-placement="top" ng-hide="!authService.isInRole(\'ROLE_RESPOSTA_JURIDICO_[A-Z]*R[A-Z]*\')" class="btn btn-link"><span class="glyphicon glyphicon-briefcase"></span></a> <button type="button" ng-hide="!authService.isInRole(\'ROLE_SOLICITACAO_JURIDICO_[A-Z]*U[A-Z]*\')" ng-click="open(\'app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/form-solicitacao-juridico-perspectiva.html\', \'lg\', \'Solicita\xE7\xE3o para o Departamento Jur\xEDdico\', solicitacao)" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-hide="!authService.isInRole(\'ROLE_SOLICITACAO_JURIDICO_[A-Z]*D[A-Z]*\')" ng-click="open(\'app/pages/components/deletemodal.html\', \'md\', \'Solicita\xE7\xE3o ao Setor Jur\xEDdico\', solicitacao)" data-toggle="modal" data-id="{{solicitacao.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="6" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="6" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="4" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/financeiro/plano-de-conta/item-plano-de-conta/valor-previsto-plano-de-conta/form-produtos.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(prod)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="contrato" class="control-label">Contrato de Cliente</label><select-contrato-externo name="contrato" id="contrato" ng-model="prod.contratoExterno" required="required" ng-change="onContratoChange(prod.contratoExterno)"></select-contrato-externo></div></div><div class="col-md-3"><div class="form-group"><label for="dataContrato" class="control-label">Dia do Contrato</label> <input type="text" name="dataContrato" id="dataContrato" ng-model="prod.diaDoContrato" ui-mask="99" required="required" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="dataPrevisto" class="control-label">Dia Previsto</label> <input type="text" name="dataPrevisto" id="dataPrevisto" ng-model="prod.diaPrevisto" ui-mask="99" required="required" class="form-control text-center"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="descricao" class="control-label">Descri\xE7\xE3o</label> <input name="descricao" id="descricao" ng-model="prod.descricao" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-3"><div class="form-group"><label for="dataInicial" class="control-label">Data Inicial</label> <input type="date" name="dataInicial" id="dataInicial" ng-model="prod.dataInicial" required="required" ng-disabled="isValores==true" class="form-control text-center"></div></div><div class="col-md-3"><div class="form-group"><label for="dataFinal" class="control-label">Data Final</label> <input type="date" name="dataFinal" id="dataFinal" ng-model="prod.dataFinal" required="required" ng-disabled="isValores==true" class="form-control text-center"></div></div><div ng-hide="isValores==true" class="col-md-3"><div class="form-group"><label for="valor" class="control-label">Valor</label> <input type="text" name="valor" id="valor" ng-model="prod.valor" mask="real" class="form-control text-right"></div></div><div ng-hide="isValores==true" class="col-md-3"><div class="form-group"><label for="valorEmpresa" class="control-label">Valor da Empresa</label> <input type="text" name="valorEmpresa" id="valorEmpresa" ng-model="pro.valorEmpresa" mask="real" class="form-control text-right"></div></div></div></div><div ng-show="isValores==true"><div class="table-responsive"><table st-table="prod.valores" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="data">Data</th><th st-sort="valor" class="text-right">Valor</th><th st-sort="valor" class="text-right">Valor Empresa</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="v in prod.valores"><td>{{v.data | date: "dd/MM/yyyy"}}</td><td><input type="text" name="valor" id="valor" ng-model="v.valor" mask="real" style="width:190px;height:25px;margin-top:5px;" class="form-control text-right"></td><td class="pull-right"><input type="text" name="valorEmpresa" id="valorEmpresa" ng-model="v.valorEmpresa" mask="real" style="width:190px;height:25px;margin-top:5px;" class="form-control text-right"></td></tr></tbody></table></div></div></div><div class="panel-footer text-right"><button type="button" ng-click="editarValores(prod.dataInicial, prod.dataFinal)" ng-hide="isValores==true" class="btn btn-warning">Editar Valores</button> <button type="button" ng-click="valorUnico();" ng-show="isValores==true" class="btn btn-warning">Valor Unico</button> <button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/financeiro/plano-de-conta/item-plano-de-conta/valor-previsto-plano-de-conta/form-valor-plano-de-conta.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(valorPrevisto)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="data" class="control-label">M\xEAs de Compet\xEAncia</label> <input type="month" name="data" id="data" ng-model="valorPrevisto.data" ng-disabled="disabledForm" required="required" class="form-control"></div></div></div></div><div class="row"><div ng-if="canDisplayPaymentDates()" class="col-md"><div class="col-md-4"><div class="form-group"><label for="diaOtimista" class="control-label">Dia Otimista</label> <input type="number" name="diaOtimista" id="diaOtimista" ng-model="valorPrevisto.diaOtimista" min="1" max="31" step="1" class="form-control"><h6 ng-if="!isDayValid(valorPrevisto.diaOtimista)" class="help-block">O dia deve ser entre 1 e {{ getLastDayOfCompetence() }}.</h6></div></div><div class="col-md-4"><div class="form-group"><label for="diaNormal" class="control-label">Dia Normal</label> <input type="number" name="diaNormal" id="diaNormal" ng-model="valorPrevisto.diaNormal" min="1" max="31" step="1" class="form-control"><h6 ng-if="!isDayValid(valorPrevisto.diaNormal)" class="help-block">O dia deve ser entre 1 e {{ getLastDayOfCompetence() }}.</h6></div></div><div class="col-md-4"><div class="form-group"><label for="diaPessimista" class="control-label">Dia Pessimista</label> <input type="number" name="diaPessimista" id="diaPessimista" ng-model="valorPrevisto.diaPessimista" min="1" max="31" step="1" class="form-control"><h6 ng-if="!isDayValid(valorPrevisto.diaPessimista)" class="help-block">O dia deve ser entre 1 e {{ getLastDayOfCompetence() }}.</h6></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="valor" class="control-label">Valor Previsto (R$)</label> <input name="valor" id="valor" ng-model="valorPrevisto.valor" mask="real" ng-disabled="disabledForm" required="required" class="form-control text-right"></div></div><div class="col-md-6"><div class="form-group"><label for="valorMedido" class="control-label">Valor Medido (R$)</label> <input name="valorMedido" id="valorMedido" ng-model="valorPrevisto.valorMedido" mask="real" ng-disabled="disabledForm" required="required" class="form-control text-right"></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/financeiro/plano-de-conta/item-plano-de-conta/valor-previsto-plano-de-conta/form-valores-plano-de-conta.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="save(prod)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-4"><div class="form-group"><label for="dataInicial" class="control-label">Data Inicial</label> <input type="date" name="dataInicial" id="dataInicial" ng-model="prod.dataInicial" required="required" ng-disabled="isValores==true" class="form-control text-center"></div></div><div class="col-md-4"><div class="form-group"><label for="dataFinal" class="control-label">Data Final</label> <input type="date" name="dataFinal" id="dataFinal" ng-model="prod.dataFinal" required="required" ng-disabled="isValores==true" class="form-control text-center"></div></div><div ng-hide="isValores==true" class="col-md-4"><div class="form-group"><label for="valor" class="control-label">Valor</label> <input type="text" name="valor" id="valor" ng-model="prod.valor" mask="real" class="form-control text-right"></div></div></div></div><div ng-show="isValores==true"><div class="table-responsive"><table st-table="prod.valores" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="data">Data</th><th st-sort="valor" class="text-right">Valor</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="v in prod.valores"><td>{{v.data | date: "MM/yyyy"}}</td><td class="pull-right"><input type="text" name="valor=" id="valor" ng-model="v.valor" mask="real" style="width:190px;height:25px;margin-top:5px;" class="form-control text-right"></td></tr></tbody></table></div></div></div><div class="panel-footer text-right"><button type="button" ng-click="editarValores(prod.dataInicial, prod.dataFinal)" ng-hide="isValores==true" class="btn btn-warning">Editar Valores</button> <button type="button" ng-click="valorUnico();" ng-show="isValores==true" class="btn btn-warning">Valor Unico</button> <button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-danger">Cancelar</button> <button type="submit" class="btn btn-success">Salvar</button></div></form></div>');
$templateCache.put('app/pages/financeiro/plano-de-conta/item-plano-de-conta/valor-previsto-plano-de-conta/valor-plano-de-conta.html','<div><div class="row"><div class="col-xs-12"><div id="preloader" ng-show="isLoading"><div></div></div><div ng-show="!isLoading" class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="text-right"><button type="button" ng-click="cancel()" class="btn btn-danger">Voltar</button><modal-print title="\'Relat\xF3rio\'" reporttitle="Relatorio de Valores Previstos" route="valor-previsto/?" filter="filtro"></modal-print><button ng-if="!isRecipeItem" ng-click="open(\'app/pages/financeiro/plano-de-conta/item-plano-de-conta/valor-previsto-plano-de-conta/form-valor-plano-de-conta.html\', \'lg\', \'Valor Previsto\', valorPrevisto)" data-toggle="modal" data-id="{{valorPrevisto.id}}" tooltip="" title="Adicionar" data-placement="top" class="btn btn-warning">Adicionar</button> <button ng-if="!isRecipeItem" ng-click="open(\'app/pages/financeiro/plano-de-conta/item-plano-de-conta/valor-previsto-plano-de-conta/form-valores-plano-de-conta.html\', \'lg\', \'Valores Prevsitos\', prod)" tooltip="" title="Novas Previs\xF5es" class="btn btn-warning">Adicionar Varios</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"><th st-sort="itemPlanoDeConta.codigo">C\xF3digo</th><th st-sort="itemPlanoDeConta.descricao">Descri\xE7\xE3o</th><th st-sort="data" class="text-center">M\xEAs de Compet\xEAncia</th><th st-sort="dataOtimista" ng-if="canDisplayPaymentDates()" class="text-center">Data Otimista</th><th st-sort="dataNormal" ng-if="canDisplayPaymentDates()" class="text-center">Data Normal</th><th st-sort="dataPessimista" ng-if="canDisplayPaymentDates()" class="text-center">Data Pessimista</th><th st-sort="valor" class="text-right">Valor Previsto (R$)</th><th st-sort="valorMedido" class="text-right">Valor Medido (R$)</th><th ng-if="hasEditPermission()" style="width:120px !important; padding-right: 20px;" class="text-center">A\xE7\xF5es</th></tr></thead><tbody ng-show="!isLoading"><tr ng-repeat="valor in displayed"><td>{{valor.itemPlanoDeConta.codigo}}</td><td style="max-width: 400px">{{valor.itemPlanoDeConta.descricao}}</td><td class="text-center">{{valor.data | date:\'MM/y\' }}</td><td ng-if="canDisplayPaymentDates()" class="text-center">{{valor.dataOtimista | date:\'dd/MM/y\' }}</td><td ng-if="canDisplayPaymentDates()" class="text-center">{{valor.dataNormal | date:\'dd/MM/y\' }}</td><td ng-if="canDisplayPaymentDates()" class="text-center">{{valor.dataPessimista | date:\'dd/MM/y\' }}</td><td class="text-right">{{valor.valor | mask: "real"}}</td><td class="text-right">{{valor.valorMedido | mask: "real"}}</td><td class="text-center"><button ng-if="(valor.itemPlanoDeConta.tipoItemPlanoDeConta.name == \'ANALITICO\') &amp;&amp; hasEditPermission()" ng-click="open(\'app/pages/financeiro/plano-de-conta/item-plano-de-conta/valor-previsto-plano-de-conta/form-valor-plano-de-conta.html\', \'lg\', \'Valor Previsto\', valor)" data-toggle="modal" data-id="{{valor.id}}" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-click="open(\'app/pages/components/deletemodal.html\', \'lg\', \'O valor \'+ valor.itemPlanoDeConta.codigo, valor)" data-toggle="modal" data-id="{{valor.id}}" tooltip="" title="Excluir" data-placement="top" ng-if="hasDeletePermission()" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="9" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="9" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-valors-by-page="itemsByPage" colspan="4" class="text-center"></td><td><select title="N\xFAmero de Linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/provimento/form-provimento.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="saveEntity(provimentoSolicitacao, clear, &quot;provimentoSolicitacaoCtrl&quot;)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><h5>Ao salvar as informa\xE7\xF5es, um e-mail ser\xE1 automaticamente enviado para os setores envolvidos. Certifique-se de revisar todas as informa\xE7\xF5es antes de prosseguir, pois as partes interessadas ser\xE3o notificadas.</h5></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="decisaoCliente">Decis\xE3o</label><select-enum name="decisaoCliente" ng-model="provimentoSolicitacao.decisaoCliente" tipo="DecisaoCliente" tipo-label="Selecione a decis\xE3o do cliente" ng-disabled="isprovimentoFormDisabled()" required="required"></select-enum></div></div><div class="col-md-6"><div class="form-group"><label for="dataDecisao">Data da Decis\xE3o</label> <input type="date" id="dataDecisao" name="dataDecisao" ng-model="provimentoSolicitacao.dataDecisao" style="text-align:center" ng-disabled="isprovimentoFormDisabled()" required="required" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="observacao" class="control-label">Observa\xE7\xF5es</label> <textarea style="height:300px;" name="observacao" id="observacao" ng-model="provimentoSolicitacao.observacao" ng-disabled="isprovimentoFormDisabled()" class="form-control col-xs-6"></textarea></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" ng-if="!isLoading" class="btn btn-danger">{{ isSolicitacaoUpdatePerm ? "Cancelar" : "Voltar" }}</button> <button type="submit" ng-disabled="isprovimentoFormDisabled()" ng-if="isSolicitacaoUpdatePerm" class="btn btn-success">{{ isLoading ? "Processando Informa\xE7\xF5es..." : "Salvar" }}</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/resposta-juridico-perspectiva/form-resposta-juridico-perspectiva.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="saveEntity(respostaJuridicoPerspectiva, clear)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><h5>Ao salvar as informa\xE7\xF5es, um e-mail ser\xE1 automaticamente enviado para os setores envolvidos. Certifique-se de revisar todas as informa\xE7\xF5es antes de prosseguir, pois as partes interessadas ser\xE3o notificadas.</h5></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-6"><div class="form-group"><label for="statusRespostaJuridico">Status</label><select-enum name="statusRespostaJuridico" ng-model="respostaJuridicoPerspectiva.statusRespostaJuridico" tipo="StatusRespostaJuridico" tipo-label="Selecione o Status da Resposta" ng-disabled="isLoading" required="required"></select-enum></div></div><div class="col-md-6"><div class="form-group"><label for="responsavelResposta">Respons\xE1vel</label><select-usuario name="responsavelResposta" id="responsavelResposta" ng-model="respostaJuridicoPerspectiva.responsavel" watch-to="{ descricao: \'JUR\xCDDICO\' }" ng-disabled="isLoading" required="required"></select-usuario></div></div><div class="col-md-6"><div class="form-group"><label for="dataResposta">Data da Resposta</label> <input type="date" id="dataResposta" name="dataResposta" ng-model="respostaJuridicoPerspectiva.dataResposta" style="text-align:center" ng-disabled="isLoading" required="required" class="form-control"></div></div><div class="col-md-6"><div class="form-group"><label for="folder">Pasta do Documento</label> <input name="folder" id="folder" type="text" ng-model="respostaJuridicoPerspectiva.folder" ng-disabled="isLoading" class="form-control"></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="observacao" class="control-label">Observa\xE7\xF5es</label> <textarea style="height:300px;" name="observacao" id="observacao" ng-model="respostaJuridicoPerspectiva.observacao" ng-disabled="isLoading" class="form-control col-xs-6"></textarea></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" ng-if="!isLoading" class="btn btn-danger">Cancelar</button> <button type="submit" ng-disabled="isLoading" class="btn btn-success">{{ isLoading ? "Processando Informa\xE7\xF5es..." : "Salvar" }}</button></div></form></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/resposta-juridico-perspectiva/resposta-juridico-perspectiva.html','<div><div><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div class="panel-body"><h3 style="margin-top:20px">Detalhes da Solicita\xE7\xE3o<hr></h3><div style="display: flex; flex-direction: column; gap: 12px;"><div class="row"><div class="col-md-8"><h5 style="font-weight: bold;">T\xEDtulo da Perspectiva</h5><p style="font-size: 18px;">{{ solicitacaoJuridico.perspectiva.titulo }}</p></div><div class="col-md-4"><h5 style="font-weight: bold;">Situa\xE7\xE3o da perspectiva quando a solicita\xE7\xE3o foi cadastra</h5><p style="font-size: 18px;">{{ solicitacaoJuridico.situacaoPerspectiva.descricao }}</p></div></div><div class="row"><div class="col-md-4"><h5 style="font-weight: bold;">Tipo de A\xE7\xE3o Solicitada</h5><p style="font-size: 18px;">{{ solicitacaoJuridico.tipoAcaoJuridico.descricao }}</p></div><div class="col-md-4"><h5 style="font-weight: bold;">Data de Solicita\xE7\xE3o</h5><p style="font-size: 18px;">{{ solicitacaoJuridico.dataSolicitacao | date:"dd/MM/y" }}</p></div><div class="col-md-4"><h5 style="font-weight: bold;">Data de Apresenta\xE7\xE3o</h5><p style="font-size: 18px;">{{ solicitacaoJuridico.dataApresentacao | date:"dd/MM/y" }}</p></div></div><div class="row"><div class="col-md-12"><h5 style="font-weight: bold;">Observa\xE7\xF5es da Solicita\xE7\xE3o</h5><p style="font-size: 18px; white-space: pre-wrap;">{{ solicitacaoJuridico.observacao }}</p></div></div><div class="row"><div class="col-md-12"><div class="text-right"><button type="button" ng-if="isSolicitacaoUpdatePerm" ng-click="openModal(\'app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/form-solicitacao-juridico-perspectiva.html\', \'lg\', \'Editar Solicita\xE7\xE3o\', solicitacaoJuridico, \'solicitacaoJuridico\')" tooltip="" title="Solicita\xE7\xE3o ao Jur\xEDdico" data-placement="top" class="btn btn-info">Editar Solicita\xE7\xE3o</button> <button type="button" ng-if="isSolicitacaoUpdatePerm" ng-click="openModal(\'app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/provimento/form-provimento.html\', \'lg\', \'Provimento da Solicita\xE7\xE3o\', provimento, \'provimento\')" tooltip="" title="Provimento da Solicita\xE7\xE3o" data-placement="top" class="btn btn-success">{{ solicitacaoJuridico.provimentoSolicitacao.id ? \'Editar\' : \'Registrar\' }} Provimento</button> <button type="button" ng-if="!isSolicitacaoUpdatePerm &amp;&amp; solicitacaoJuridico.provimentoSolicitacao.id" ng-click="openModal(\'app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/provimento/form-provimento.html\', \'lg\', \'Provimento da Solicita\xE7\xE3o\', provimento, \'provimento\')" tooltip="" title="Visualizar Provimento" data-placement="top" class="btn btn-success">Visualizar Provimento</button> <button type="button" ng-click="handleBackPage()" tooltip="" title="Voltar" data-placement="top" class="btn btn-warning">Voltar para a p\xE1gina anterior</button></div></div></div></div></div></div></div></div></div><div><div class="row"><div class="col-xs-12"><div class="panel panel-primary bootstrap-panel"><div class="panel-body"><h3 style="margin-top:20px">Hist\xF3rico de Resposta de A\xE7\xE3o ao Jur\xEDdico<hr></h3><div class="text-right"><button type="button" ng-hide="!authService.isInRole(\'ROLE_RESPOSTA_JURIDICO_[A-Z]*C[A-Z]*\')" ng-click="openModal(\'app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/resposta-juridico-perspectiva/form-resposta-juridico-perspectiva.html\', \'lg\', \'Resposta da solicita\xE7\xE3o\', respostaJuridicoPerspectiva, \'respostaJuridicoPerspectiva\')" tooltip="" title="Resposta da A\xE7\xE3o do Jur\xEDdico" data-placement="top" class="btn btn-warning">Adicionar</button></div><div class="table-responsive"><table st-table="displayed" st-safe-src="table.content" st-pipe="load" class="table table-striped table-hover"><thead><tr class="sortable"></tr><th class="text-center">Data da Resposta</th><th>Respons\xE1vel</th><th>Status da Resposta</th><th>Pasta do Documento</th><th>observa\xE7\xE3o</th><th style="width:150px !important" class="text-center">A\xE7\xF5es</th></thead><tbody ng-show="!isLoading"><tr ng-repeat="resposta in displayed | orderBy:\'-data\'"><td>{{ resposta.dataResposta | date:"dd/MM/y" }}</td><td>{{ resposta.responsavel.pessoaFisica.pessoa.nome }}</td><td>{{ resposta.statusRespostaJuridico.descricao }}</td><td>{{ resposta.folder }}</td><td>{{ resposta.observacao }}</td><td ng-class="{\'text-center\': isSolicitacaoUpdatePerm, \'text-right\': !isSolicitacaoUpdatePerm}"><div uib-dropdown="" dropdown-append-to-body="" class="btn-group"><button type="button" ng-hide="!isSolicitacaoUpdatePerm &amp;&amp; !resposta.revisaoRespostaJuridico" ng-click="openRevisao(\'app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/revisao-resposta/form-revisao-resposta.html\', \'lg\', \'Revis\xE3o da Resposta\', resposta)" tooltip="" title="Revis\xE3o da Resposta" data-placement="top" class="btn btn-link"><i class="glyphicon glyphicon-copy"></i></button> <button type="button" ng-hide="!authService.isInRole(\'ROLE_RESPOSTA_JURIDICO_[A-Z]*U[A-Z]*\')" ng-click="openModal(\'app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/resposta-juridico-perspectiva/form-resposta-juridico-perspectiva.html\', \'lg\', \'Resposta da A\xE7\xE3o do Jur\xEDdico\', resposta, \'respostaJuridicoPerspectiva\')" tooltip="" title="Editar" data-placement="top" class="btn btn-link"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-hide="!authService.isInRole(\'ROLE_RESPOSTA_JURIDICO_[A-Z]*D[A-Z]*\')" ng-click="openModal(\'app/pages/components/deletemodal.html\', \'md\', \'Resposta da Solicita\xE7\xE3o do Jur\xEDdico\'+ perspectiva.numeroEdital, resposta, \'respostaJuridicoPerspectiva\')" data-toggle="modal" data-id="{{resposta.id}}" tooltip="" title="Excluir" data-placement="top" class="btn icon-red btn-link"><i class="glyphicon glyphicon-remove"></i></button></div></td></tr></tbody><tbody ng-show="isLoading"><tr><td colspan="7" class="text-center">Loading ...</td></tr></tbody><tbody ng-show="displayed.length==0"><tr><td colspan="7" class="text-center">Sem registros!</td></tr></tbody><tfoot><tr><td st-pagination="" st-items-by-page="itemsByPage" colspan="5" class="text-center"></td><td><select title="N\xFAmero de linhas" tooltip="N\xFAmero de Linhas" ng-model="itemsByPage" ng-options="i for i in itemsByPageOptions" class="form-control show-tick"></select></td></tr></tfoot></table></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/licitacoes/perspectivas/solicitacao-juridico-perspectiva/revisao-resposta/form-revisao-resposta.html','<div class="panel panel-primary bootstrap-panel"><form ng-submit="saveEntity(revisaoResposta, clear, &quot;revisaoRespostaCtrl&quot;)" name="form" method="post"><div class="panel-heading"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" class="btn btn-link close">&times;</button><h2 class="panel-title">{{title}}</h2></div><div class="panel-body"><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><h5>Ao salvar as informa\xE7\xF5es, um e-mail ser\xE1 automaticamente enviado para os setores envolvidos. Certifique-se de revisar todas as informa\xE7\xF5es antes de prosseguir, pois as partes interessadas ser\xE3o notificadas.</h5></div></div></div></div><div class="row"><div class="col-md"><div class="col-md-12"><div class="form-group"><label for="responsavelResposta">Respons\xE1vel</label><select-usuario name="responsavelResposta" id="responsavelResposta" ng-model="revisaoResposta.responsavel" watch-to="{ descricao: \'COMERCIAL\' }" ng-disabled="isRevisaoFormDisabled()" required="required"></select-usuario></div></div><div class="col-md-12"><div class="form-group"><label for="observacao" class="control-label">Observa\xE7\xF5es</label> <textarea style="height:300px;" name="observacao" id="observacao" ng-model="revisaoResposta.observacao" ng-disabled="isRevisaoFormDisabled()" required="required" class="form-control col-xs-6"></textarea></div></div></div></div></div><div class="panel-footer text-right"><button type="reset" ng-click="clear()" data-dismiss="modal" aria-label="close" ng-if="!isLoading" class="btn btn-danger">{{ isSolicitacaoUpdatePerm ? "Cancelar" : "Voltar" }}</button> <button type="submit" ng-disabled="isprovimentoFormDisabled()" ng-if="isSolicitacaoUpdatePerm" class="btn btn-success">{{ isLoading ? "Processando Informa\xE7\xF5es..." : "Salvar" }}</button></div></form></div>');}]);